//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


/**
 * @fileOverview This file triggers various Coremetrics events upon user actions. The following five events are supported:
 * 1. pageview: This event is triggered when a new page is loaded, part of a page is refreshed, or the mini shopping cart is accessed
 * 2. productview: This event is triggered when a catalog entry is viewed using Quick Info button
 * 3. cartview: This event is triggered when a user's cart is updated in any way, such as item being added, item being
 *    deleted, quantity being updated, shipping being updated, and payment being updated.
 * 4. element: This event is triggered when filtering criteria or sorting criteria in a fast finder is updated.
 * 5. registration: This event is triggered when the user updates his account information
 *
 * @version 1.0
 *
 **/

/**
* @class analyticsJS This class defines all the variables and functions used by the Analytics.js
* One and only one global analyticsJS should be created. Therefore, we create this object only when it is not present in
* in the global namespace.
*
**/

if(typeof(analyticsJS) === "undefined" || !analyticsJS || !analyticsJS.topicNamespace){
    analyticsJS = {
        /** The storeId this object is used for.**/
        storeId: 0,

        /** The catalogId the user uses **/
        catalogId: 0,

        /** The URL prefix used for invoking JSON views **/
        urlPath: null,

        /** The Mini Shopping cart title will be used in publishStoreAccordionPageView **/
        miniShopCartTitle: "MiniShoppingCart",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics page view **/
        jsonPageView: "AnalyticsPageView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics product view **/
        jsonProductView: "AnalyticsProductView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics element view **/
        jsonElementView: "AnalyticsElementView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics cart view **/
        jsonShopcartView: "AnalyticsShopcartView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics add cart **/
        jsonAddCart: "AnalyticsShopcartView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics registration view **/
        jsonRegistrationView: "AnalyticsRegistrationView",

        /** The name of the view that will be used to retrieve JSON data for Coremetrics conversion event **/
        jsonConversionEventView: "AnalyticsConversionEventView",

        /** The namespace of any Commerce implementation of Coremetrics event. For example, if an element event
         *  will be of form "/wc/analytics/element". To generalize, each Coremetric topic/event follows this
         *   grammar: <topicNamespace><event name>
         */
        topicNamespace: "/wc/analytics/",

        /** The name of the page view event **/
        pageView: "pageview",

        /** The name of the product view event **/
        productView: "productview",

        /** The name of the cart view event **/
        cartView: "cartview",

        /** The name of the add cart event **/
        addCart: "addcart",

        /** The name of the element view **/
        element: "element",

        /** The name of the registration view **/
        registration: "registration",

        /** The name of the conversion event view **/
        conversionEvent: "conversionevent",

        /** A boolean flag to control the page views triggered through minishop cart views **/
        pageViewControl: false,

        incTaxInUnitPriceForCart: "F",

        /**
         * The list of service requests that should result in a cart view event. Each item in the list
         * is an legitimate action ID used in a service. Refer to the wcService.* for details.
         * Assumption: Each service topic will be of form "modelChanged/<actionID>".
         */
        cartViewActionIdList: [
            "AjaxDeleteOrderItem",
            "AjaxUpdateOrderItem"
        ],

        /**
         * The list of service requests that should result in a add cart event. Each item in the list
         * is an legitimate action ID used in a service. Refer to the wcService.* for details.
         * Assumption: Each service topic will be of form "modelChanged/<actionID>".
         */
        addCartActionIdList: [
            "AddOrderItem",
            "AjaxAddOrderItemWithShipingInfo",
        ],

        /** The list of service requests that should result in ajax wishlist update page view event.**/
        wishlistPageIdList: [
            "AjaxInterestItemAdd",
            "InterestItemDelete",
            "AjaxRestWishListAddItem",
            "AjaxRestWishListRemoveItem",
            "ShoppingListServiceAddItem"

        ],
        /** The list of service requests that should result in ajax multiple wishlist add conversionevent.**/
        conversionEventList : [
            "AjaxInterestItemAdd",
            "AjaxRestWishListAddItem",
            "AjaxInterestItemAddAndDeleteFromCart",
            "ShoppingListServiceAddItem",
            "AnalyticsConversionEvent"

        ],

        /**
        * This function retrieves all the required data for cart view event, and then publishes a  view event with the retrieved data
        *
        * @param {String} jsonViewName name of the view that will be called to get Coremetrics event data
        * @param {String} urlParams  The URL parameters passed to the jsonViewName when it is be called.For example: {storeId: 0, shopperStoreId: 10001}
        * @param {object} publisher  A function that takes a single parameter. The parameter will be the
        *                            retrieved data. It is up to this function to decide if a Coremetrics view
        *                            will be published. This function will be invoked under the context of this object. For example: function(data){this.publishTopic("/wc/analytics/cartview", data);}
        **/
        publishAnalyticsView: function(jsonViewName, urlParams, publisher){
            var scope = this;
            var kw = {
                url:        getAbsoluteURL() + jsonViewName,
                method:     'GET',
                dataType:   'json',
                data:       $.extend({storeId:scope.storeId, catalogId:scope.catalogId}, urlParams),
                error:      function(type, textStatus){
                                // Hidden tags should not interrupt user interactions. Therefore, no error will be reported to user.
                                wcTopic.publish("ajaxRequestCompleted");
                            },
                success:    function(data, textStatus){
                                publisher.call(scope, data);
                                wcTopic.publish("ajaxRequestCompleted");
                            }
            };
            wcTopic.publish("ajaxRequestInitiated");
            $.ajax(kw);
        },

       /**
        * This function publishes a topic with the given topic data
        * @param {String} topicName Topic name
        * @param {Object} topicData Topic data
        *
        */
        publishTopic: function(/*String*/topicName, /*Object*/topicData){
            var topic = this.makeTopic(topicName);
            wcTopic.publish(topic, topicData);
        },
        /**
         * This function publishes a page view event with page view data
         * @param {Object} pageViewData name-value pairs that contain all the page view event data
         *
         */
        publishPageView: function(/*Object*/pageViewData){
            var scope = this;
            this.publishAnalyticsView(
                scope.jsonPageView,
                pageViewData,
                function(data){
                    scope.publishTopic(scope.pageView, data);
                }
            );
        },

        /**
         * Publishes a non eCommerce conversion event with the event data.
         * @param {Object} conEventData name-value pairs that contain the conversion event data
         */
        publishConversionEventView: function(/*Object*/conEventData){
            var scope = this;
            this.publishAnalyticsView(
                scope.jsonConversionEventView,
                conEventData,
                function(data){
                    scope.publishTopic(scope.conversionEvent, data);
                }
            );
        },

        /**
         * This function publishes a cart view event with cart view data
         *
         */
        publishCartView: function(){
            var scope = this;
            this.publishAnalyticsView(
                scope.jsonShopcartView,
                {storeId:scope.storeId, incTaxInPrice: scope.incTaxInUnitPriceForCart },
                function(data){
                    scope.publishTopic(scope.cartView, data);
                }
            );
        },

        /**
         * This function publishes an add cart event with add cart data
         *
         */
        publishAddCart: function(){
            var scope = this;
            this.publishAnalyticsView(
                scope.jsonAddCart,
                {storeId:scope.storeId, incTaxInPrice: scope.incTaxInUnitPriceForCart },
                function(data){
                    scope.publishTopic(scope.addCart, data);
                }
            );
        },

        /**
         * This function publishes a registration view event with registration view data
         *
         */
        publishRegistrationView: function() {
            var scope = this;
            this.publishAnalyticsView(
                scope.jsonRegistrationView,
                {storeId:scope.storeId},
                function(data){
                    scope.publishTopic(scope.registration, data);
                }
            );
        },
        /**
         * This function assembles full topic  with the given topic name.
         * @param {String} topicName Topic name      *
         * @return {String} topicName A string of the form <topicNamespace><topicName>
         */
        makeTopic: function(/*String*/topicName){

            return [this.topicNamespace, topicName].join("")
        },
        /**
         * This function  is used to get the category of  mini shopping cart page view
         * @return {String} MiniShoppingCart  the page category of mini shopping cart page view
         */

        getMiniShopCartPageCategory: function(){
            return "MiniShoppingCart"
        },

        /**
         * This function is used to get the mini shopping cart page name.
         * @returns {String} MiniShoppingCart the mini shopping cart page name
         *
         */
        getMiniShopCartPageName: function(){
            return ["MiniShoppingCart: ", document.title].join("");
        },

        /**
         * This function is called to get the mini shopping cart view data
         * @param {String} miniShopCartTitle MiniShopCart Title
         * @returns {String} pagename: pageName, category: pageCategory the mini shopping cart page view data
         */
        getMiniShopCartPageViewData: function(miniShopCartTitle){
            var pageName = this.getMiniShopCartPageName();
            var pageCategory = this.getMiniShopCartPageCategory();

            return {pagename: pageName, category: pageCategory};
        },
        /**
         * This function publishes the mini shop cart page view
         * @param {String} miniShopCartTitle  MiniShopCart Title
         */
        publishMiniShopCartPageView: function(miniShopCartTitle) {
            var scope = this;
            if (!scope.pageViewControl) {
                scope.lockPageView();
                var pageViewData = this.getMiniShopCartPageViewData(miniShopCartTitle);
                this.publishPageView(pageViewData);
            }

        },

        /**
         * This function sets the pageview control flag in locked state for 3 seconds so that no extra page views are thrown
         * at the same time
         */
        lockPageView: function() {
            this.pageViewControl = true;
            setTimeout('analyticsJS.pageViewControl = false;', 3000);
        },




       /**
        * This function registers the mini shopping cart cart view whenever the user adds a item to the mini shopping cart
        */
        registerMiniShopCartCartView: function(){
            var scope = this;
            $(this.cartViewActionIdList).each( function(i, actionId){
                wcTopic.subscribe("modelChanged/"+actionId, function(){
                    scope.publishCartView();
                });
            });

           $(this.addCartActionIdList).each( function(i, actionId){
        	   wcTopic.subscribe("modelChanged/"+actionId, function(){
                    scope.publishAddCart();
                });
            });
        },

        /**
         * This function registers the shopping cart page view and cart view events
         * @param{boolean} incTaxInUP The boolean flag to indicate whether to include the sales tax in the unit price amount
         */
        loadShopCartHandler: function(/* boolean */ incTaxInUP){
            var scope = this;
            if (incTaxInUP === true) {
                scope.incTaxInUnitPriceForCart = "T";
            }
            scope.registerMiniShopCartCartView();

            scope.registerShopCartPaginationPageView();
            scope.registerShippingBillingAddressEditPageView();
        },


        /**
         * This function registers the shop cart page's pagination handler
         */
        loadShopCartPaginationHandler: function() {
            var scope = this;
            scope.registerShopCartPaginationPageView();
        },

        /**
         * Registers the shopping cart pagination event to trigger a page view tag
         */
        registerShopCartPaginationPageView: function() {
            var scope = this;
            wcTopic.subscribe("ShopCartPaginationDisplay_Context/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title};
                scope.publishPageView(pageViewData);
            });
            wcTopic.subscribe("OrderItemPaginationDisplay_Context/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title};
                scope.publishPageView(pageViewData);
            });
            wcTopic.subscribe("traditionalShipmentDetailsContext/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title};
                scope.publishPageView(pageViewData);
            });
            wcTopic.subscribe("MSOrderItemPaginationDisplay_Context/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title};
                scope.publishPageView(pageViewData);
            });
        },

        /**
         * Registers the shipping and billing address add/update event to trigger a page view tag
         */
        registerShippingBillingAddressEditPageView: function() {
            var scope = this;
            wcTopic.subscribe("editShippingAddressContext/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title, category:"Shipping and biling address"};
                scope.publishPageView(pageViewData);
            });
        },


        /**
         * Registers the store locator event page views
         */
        registerStoreLocatorPageViews: function() {
            var scope = this;
            wcTopic.subscribe("selectedStoreListContext/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title, category:"Store locator"};
                scope.publishPageView(pageViewData);
            });
            wcTopic.subscribe("storeLocatorResultsContext/RenderContextChanged", function(){
                var pageViewData = {pagename: document.title, category:"Store locator"};
                scope.publishPageView(pageViewData);
            });
        },

        /**
         * Loads the event handlers to generate coremetrics page view tags when the user interact with the
         * store locator page
         */
        loadStoreLocatorPageViews: function(){
            var scope = this;
            $(document).ready(function(){
                scope.registerStoreLocatorPageViews();
            });
        },

        /**
         * This function registers page view events when the shopper adds/removes items
         * from his personal wishlist
         */
        registerWishlistHandler: function() {
            var scope = this;
            var pageCategory = "MyAccountPage";
            var pageName = "Personal Wishlist:" + document.title;
            var pageViewData = {pagename: pageName, category: pageCategory};
            var cevData = {eventId: 'AddToWishlist'};


            $(this.conversionEventList).each( function(i, actionId){
                wcTopic.subscribe("modelChanged/"+actionId, function(){
                scope.publishConversionEventView(cevData);
               });
           });




        },

        /**
         * This function loads the event handlers for the Wishlist based events.
         *
         */
        loadWishlistHandler: function() {
            var scope = this;
            $(document).ready(function(){
                scope.registerWishlistHandler();
            });
        },

        /**
         * This function publishes the registration and cart tag when a guest shopper
         * tries to login from the checkout page
         */
        publishShopCartLoginTags: function() {
            var scope = this;
            $(document).ready(function(){
                scope.publishRegistrationView();
                scope.publishCartView();
            });
        },

        /**
         * This function registers the product view when the user clicks on the Quick info button
         */
        registerProductQuickInfoView: function() {

            var scope = this;
            if(typeof(QuickInfoJS) !== "undefined") {
            	Utils.aop_after(QuickInfoJS, "showDetails", function(args){
                    //console.debug("productId ", productId)
                    var catEntryId = args[0];
                    scope.publishAnalyticsView(
                        scope.jsonProductView,
                        {
                            productId: catEntryId,
                            storeId: scope.storeId
                        },
                        function(data){
                            scope.publishTopic(scope.productView, data);
                        }
                    );
                });
            }
        },
        /**
         * This function loads the Quick info event handlers
         */
        loadProductQuickInfoHandler: function () {

            var scope = this;
            $(document).ready(function(){
                scope.registerProductQuickInfoView();
            });
        },
        /**
         * This function loads the paging handler
         *
         */
        loadPagingHandler: function(){

            var scope = this;

            $(document).ready(function(){
                var movement = {forward: "page forward", backward: "page backward"};
                var monitoredEvents = [
                    ["Common", "goBack", movement.backward],
                    ["Common", "goForard", movement.forward],
                    ["Common.HistoryTracker.prototype", "back", movement.backward],
                    ["Common.HistoryTracker.prototype", "forward", movement.forward]
                ];

                $(monitoredEvents).each( function(i, target){
                    var srcObj = Utils.getObject(target[0]);
                    var srcFunc = target[1];
                    var movement = target[2];
                    $(srcObj).on( srcFunc, function(){
                        scope.publishPageView(
                            {pagename: document.title,
                             category: movement
                            }
                        );
                    });
                });
            });

        },
        /**
         * This function assumes that the related page view data is inside a DIV with ID = resultInfoDivId
         *  @param{String} resultInfoDivId  The ID of the DIV that contains information about search result.
         *  @param{Boolean} registerPageViewNow  A boolean flag to indicate whether to throw a page view when the handler is being loaded.
         *  @param{String} advSearchFormDivId  A DIV Id of the advanced search form display.
         *
         */

        registerSearchResultPageView: function(resultInfoDivId, registerPageViewNow, advSearchFormDivId){

            var realSearch = true;
            var scope = this;

            if (registerPageViewNow) {
                if ($("#" + resultInfoDivId).length) {
                    var resultInfo = eval('('+$("#" + resultInfoDivId).html()+')').searchResult;
                    var pageViewData = {pagename: document.title};

                    if (resultInfo.searchTerms !== "") {
                        if (resultInfo.totalResultCount !== '0') {
                            pageViewData = {pagename: "Search Successful:" + resultInfo.currentPageNumber};
                        } else {
                            pageViewData = {pagename: "Search Unsuccessful"};
                        }
                        if (resultInfo.searchTerms.length > 0) {
                            pageViewData.searchTerms = resultInfo.searchTerms;
                            pageViewData.searchCount = resultInfo.totalResultCount;
                        }
                        pageViewData.category = "Search Results";
                    }

                    pageViewData.attributes = resultInfo.attributes;
                    scope.publishPageView(pageViewData);
                }
            }
        },

        /**
         *  This function handles the Coremetrics event for searching.
         *  @param{String} resultInfoDivId  The ID of the DIV that contains information about search result.
         *  @param{Boolean} registerPageViewNow  A boolean flag to indicate whether to throw a page view when the handler is being loaded.
         *  @param{String} advSearchFormDivId  A DIV Id of the advanced search form display.
         */
        loadSearchResultHandler: function(/*String*/resultInfoDivId, registerPageViewNow, /*String*/ advSearchFormDivId){
            var scope = this;
            wcTopic.subscribe("CMPageRefreshEvent", function(){
                scope.registerSearchResultPageView(resultInfoDivId,registerPageViewNow, advSearchFormDivId);
            });
        },

        /**
         * This function will publish page view events when number of payment methods  changes. The category of page view event will be "payment method".
         * @param paymentController The paymentController object
         */
        registerPaymentPageView: function(/*Object*/paymentController){
            var scope = this;
            Utils.aop_after(paymentController, "setNumberOfPaymentMethods", function(args){
            	var selection = args[1];
            	scope.publishPageView({pagename:selection.value, category:"payment method"});
            	selection = null;
            });
        },

        /**
         * Loads the function that handles all the Coremetrics events for changing payments.
         * @param paymentController The paymentController object
         */
        loadPaymentPageView: function(/*Object*/paymentController){
            var scope = this;
            $(document).ready(function(){
                scope.registerPaymentPageView(paymentController);
            });
        }
    }
}
;

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

//
//

/**
* @fileOverview This file holds methods to perform client side operations in relation to catalog browsing, usually at the category level.<b>
* 			For example, this file holds methods to add items to the shopping cart, wish list and compare zone and to resolve SKUs.<b>
*			This file is referenced in a collection of JSPs including all of the catalog entry display JSPs such as
*			CachedBundleDisplay.jsp, CachedItemDisplay.jsp , CachedPackageDisplay.jsp, CachedProductOnlyDisplay.jsp.
*			As well this file is included in CategoryOnlyResultsDisplay.jsp and in none catalog browsing pages such as
*			CatalogSearchDisplay.jsp and MyAccountDisplay.jsp.
*
* @version 1.0
**/

/**
* @class categoryDisplayJS This class defines all the variables and functions used by the CategoryDisplay.js. Any page that will use a function in this file
*		can access that function thru this class. Pages that use categoryDisplayJS include CachedProductOnlyDisplay.jsp which is responsible for
*		displaying product details. As well CategoryOnlyResultsDisplay.jsp uses this page to facilitate the category browsing functionality such as add to cart,
*		wish list and compare zone.
*
**/
categoryDisplayJS={

	/** An array of entitled items which is used in various methods throughout CategoryDisplay.js **/
	entitledItems:[],

	/** An map which holds the attributes of a set of products **/
	selectedProducts:{},

	/** A map of attribute name value pairs for the currently selected attribute values **/
	selectedAttributes:{},

	/** Can be used to hold a map of error messages **/
	errorMessages: {},

	/** The language ID currently in use **/
	langId: "-1",

	/** The store ID currently in use **/
	storeId: "",

	/** The catalog ID currently in use **/
	catalogId: "",

	/** The order ID currently in use if being called from the pending order details page.**/
	orderId: "",

	/** Can be used to indicate whether or not there has been a context change event **/
	contextChanged:false,

	/** Set to true in the goBack and goForward methods **/
	isHistory:false,

	/** Holds an array of  JSON objects representing properties of merchandising associations **/
	merchandisingAssociationItems:[],

	/** Holds an array of JSON objects holding information about the parent catalog entries of merchandising associations **/
	baseCatalogEntryDetails:[],

	/** Used to determine the index of the next association to display and is used as a global storage variable to share data between methods. **/
	associationThumbnailIndex:1,

	/** A count of the number of merchandising associations available. **/
	totalAssociationCount:0,

	/** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
	baseItemAddedToCart:false,

	/** A boolean used to determine whether or not to add merchandising associations to the cart **/
	merchandisingProductAssociationAddToCart:false,

	/** The form which holds information about merchandising associations to be added to the cart **/
	merchandisingProductAssociationForm:"",

	/** A boolean used to determine whether or not the parent catalog entry is a bundle bean. **/
	isParentBundleBean:false,

	/** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
	userType:"",

	/** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
	moreInfoUrl :"",
	/** The text to display as an alt to the image used on the MerchandisingAssociationDisplay.jsp to show the previous assoication **/
	displayPrevAssociation:"",

	/** The text to display as an alt to the image used on the MerchandisingAssociationDisplay.jsp to show the next assoication **/
	displayNextAssociation:"",

	/** A map holding a mapping between product IDs as its key and the first entitled item ID of that product as its value **/
	defaultItemArray:[],

	/** The type of the catalog page that the user is currently viewing **/
	currentPageType:"",

	/** The identifier of the catalog entry that the current page is displaying **/
	currentCatalogEntryId:"",

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

	/**
	* A boolean used to to determine is it from a Qick info popup or not.
	**/
	isPopup : false,

	/**
	* A boolean used to to determine whether or not to diplay the price range when the catEntry is selected.
	**/
	displayPriceRange : true,

	/**
	* This array holds the json object retured from the service, holding the price information of the catEntry.
	**/
	itemPriceJsonOject : [],

	/**
	* stores all name and value of all swatches
	* this is a 2 dimension array and each record i contains the following information:
	* allSwatchesArray[i][0] - attribute name of the swatch
	* allSwatchesArray[i][1] - attribute value of the swatch
	* allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
	* allSwatchesArray[i][4] - onclick action of the swatch when enabled
	**/
	allSwatchesArray : [],

	/**
	* setCommonParameters This function initializes storeId, catalogId, and langId.
	*
	* @param {String} langId The language id to use.
	* @param {String} storeId The store id to use.
	* @param {String} catalogId The catalog id to use.
	* @param {String} userType The type of user. G for Guest user.
	*
	**/
	setCommonParameters:function(langId,storeId,catalogId,userType){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
		this.userType = userType;
	},

	/**
	* setEntitledItems Sets an array of entitled items for a product. The array that is generated is used later in {@link this.resolveSKU}.
	*
	* @param {Object} entitledItemArray An object which holds both the catalog entry ID as well as an array of attributes for the entitled items of a product.
	*
	**/
	setEntitledItems : function(entitledItemArray){
		this.entitledItems = entitledItemArray;
	},

	/**
	* setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
	*					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
	*					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
	*
	* @param {String} selectedAttributeName The name of the attribute.
	* @param {String} selectedAttributeValue The value of the selected attribute.
	*
	**/
	setSelectedAttribute : function(selectedAttributeName , selectedAttributeValue){
		console.debug(selectedAttributeName +" : "+ selectedAttributeValue);
		this.selectedAttributes[selectedAttributeName] = selectedAttributeValue;
		this.moreInfoUrl=this.moreInfoUrl+'&'+selectedAttributeName+'='+selectedAttributeValue;
	},

	/**
	* setSelectedAttributeJS Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
	*					   One place this function is used is on the quick info pop up where there is a drop down box of attributes.
	*					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
	*
	* @param {String} selectedAttributeName The name of the attribute.
	* @param {String} selectedAttributeValue The value of the selected attribute.
	*
	**/
	setSelectedAttributeJS : function(selectedAttributeName , selectedAttributeValue){
		console.debug(selectedAttributeName.replace(/'/g,"&#039;") +" : "+ selectedAttributeValue.replace(/'/g,"&#039;"));
		this.selectedAttributes[selectedAttributeName.replace(/'/g,"&#039;")] = selectedAttributeValue.replace(/'/g,"&#039;");
		this.moreInfoUrl=this.moreInfoUrl+'&'+selectedAttributeName.replace(/'/g,"&#039;") +'='+selectedAttributeValue.replace(/'/g,"&#039;");
	},

	/**
	 * Displays price of the catEntry selected with the JSON objrct returned from the server.
	 *
	 * @param {object} serviceRepsonse The JSON response from the service.
	 * @param {object} ioArgs The arguments from the service call.
	 */
	 displayPriceServiceResponse : function(serviceResponse, ioArgs){

		//stores the json object, so that the service is not called when same catEntry is selected.
		categoryDisplayJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

		categoryDisplayJS.displayPrice(serviceResponse.catalogEntry);
	 },

	/**
	 * Displays price of the attribute selected with the JSON oject.
	 *
	 * @param {object} catEntry The JSON object with catalog entry details.
	 */
	 displayPrice : function(catEntry){

		var tempString;
		var popup = categoryDisplayJS.isPopup;

		if(popup == true){
			$("#productPrice").html(catEntry.offerPrice);
			$("#productName").html(catEntry.description[0].name);
			$("#productSKUValue").html(catEntry.catalogEntryIdentifier.externalIdentifier.partNumber);
		}

		if(popup == false){
			var innerHTML = "";
			if(!catEntry.listPriced ||  catEntry.listPrice <= catEntry.offerPrice){
				innerHTML = "<span class='price bold'>"+MessageHelper.messages['PRICE']+" </span>" +
							"<span class='price bold'>" + catEntry.offerPrice + "</span>";
			}
			else{
				innerHTML = "<span class='price bold'>"+MessageHelper.messages['PRICE']+" </span>" +
							"<span class='price listPrice bold'>" + catEntry.listPrice + "</span>"+
							"<div class='price offerprice bold'>" + catEntry.offerPrice + "</div>";
			}

			innerHTML = innerHTML +	"<br />";

			if(categoryDisplayJS.displayPriceRange == true){
				for(var i in catEntry.priceRange){
					if(catEntry.priceRange[i].endingNumberOfUnits != 'null'){
						tempString = MessageHelper.messages['TieredPricingDisp'];
						tempString = tempString.replace('{0}',catEntry.priceRange[i].startingNumberOfUnits);
						tempString = tempString.replace('{1}',catEntry.priceRange[i].endingNumberOfUnits);
						tempString = tempString.replace('{2}',catEntry.priceRange[i].localizedPrice);
						innerHTML = innerHTML + "<span class='price bold'>" + tempString + "</span>";;
					}
					else{
						tempString = MessageHelper.messages['TieredPricingDispLast'];
						tempString = tempString.replace('{0}',catEntry.priceRange[i].startingNumberOfUnits);
						tempString = tempString.replace('{1}',catEntry.priceRange[i].localizedPrice);
						innerHTML = innerHTML + "<span class='price bold'>" + tempString + "</span>";;
					}
					innerHTML = innerHTML + "<br />";
				}
			}
			$("#WC_CachedProductOnlyDisplay_div_4").html(innerHTML);
			$("#catalog_link").html(catEntry.description[0].name);
		}
	 },

	/**
	* setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
	*								This function is used to set the assigned value of defining attributes to specific
	*								products which will be stored in the selectedProducts map.
	*
	* @param {String} productId The catalog entry ID of the catalog entry to use.
	* @param {String} selectedAttributeName The name of the attribute.
	* @param {String} selectedAttributeValue The value of the selected attribute.
	*
	**/
	setSelectedAttributeOfProduct : function(productId,selectedAttributeName,selectedAttributeValue){

		selectedAttributesForProduct = {};

		if(this.selectedProducts[productId]) selectedAttributesForProduct = this.selectedProducts[productId];

		selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
		this.selectedProducts[productId] = selectedAttributesForProduct;

	},

	/**
	* getCatalogEntryId Returns the catalog entry ID of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
	*					This method uses {@link this.resolveSKU} to find the SKU with the selected attributes values.
	*
	* @see this.resolveSKU
	*
	* @return {String} catalog entry ID.
	*
	**/
	getCatalogEntryId : function(){
		var attributeArray = [];
		for(attribute in this.selectedAttributes){
			attributeArray.push(attribute + "_|_" + this.selectedAttributes[attribute]);
		}
		return this.resolveSKU(attributeArray);
	},

	/**
	* getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
	*					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
	*
	* @return {String} path to the SKU image.
	*
	**/
	getImageForSKU : function(){
		var attributeArray = [];
		for(attribute in this.selectedAttributes){
			attributeArray.push(attribute + "_|_" + this.selectedAttributes[attribute]);
		}
		return this.resolveImageForSKU(attributeArray);
	},

	/**
	* getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
	*
	* @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
	*
	* @return {String} catalog entry ID of the SKU.
	*
	**/
	getCatalogEntryIdforProduct : function(selectedAttributes){
		var attributeArray = [];
		for(attribute in selectedAttributes){
			attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
		}
		return this.resolveSKU(attributeArray);
	},


	/**
	* resolveSKU Resolves a SKU using an array of defining attributes.
	*
	* @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
	*
	* @return {String} catentry_id The catalog entry ID of the SKU.
	*
	**/
	resolveSKU : function(attributeArray){

		console.debug("Resolving SKU >> " + attributeArray +">>"+ this.entitledItems);
		var catentry_id = "";
		var attributeArrayCount = attributeArray.length;

		for(x in this.entitledItems){
			var catentry_id = this.entitledItems[x].catentry_id;
			var Attributes = this.entitledItems[x].Attributes;
			var attributeCount = 0;
			for(index in Attributes){
				attributeCount ++;
			}

			// Handle special case where a catalog entry has one sku with no attributes
			if (attributeArrayCount == 0 && attributeCount == 0){
				return catentry_id;
			}
			if(attributeCount != 0 && attributeArrayCount >= attributeCount){
				var matchedAttributeCount = 0;

				for(attributeName in attributeArray){
					var attributeValue = attributeArray[attributeName];
					if(attributeValue in Attributes){
						matchedAttributeCount ++;
					}
				}

				if(attributeCount == matchedAttributeCount){
					console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
					return catentry_id;
				}
			}
		}
		return null;
	},

	/**
	* resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
	*
	* @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
	*
	* @return {String} imagePath The location of SKU image.
	*
	**/
	resolveImageForSKU : function(attributeArray){

		console.debug("Resolving SKU >> " + attributeArray +">>"+ this.entitledItems);
		var imagePath = "";
		var attributeArrayCount = attributeArray.length;

		for(x in this.entitledItems){
			var imagePath = this.entitledItems[x].ItemImage;
			var Attributes = this.entitledItems[x].Attributes;
			var attributeCount = 0;
			for(index in Attributes){
				attributeCount ++;
			}

			// Handle special case where a catalog entry has one sku with no attributes
			if (attributeArrayCount == 0 && attributeCount == 0){
				return imagePath;
			}
			if(attributeCount != 0 && attributeArrayCount >= attributeCount){
				var matchedAttributeCount = 0;

				for(attributeName in attributeArray){
					var attributeValue = attributeArray[attributeName];
					if(attributeValue in Attributes){
						matchedAttributeCount ++;
					}
				}

				if(attributeCount == matchedAttributeCount){
					console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
					return imagePath;
				}
			}
		}
		return null;
	},

	/**
	* updates the product image from the PDP page to use the selected SKU image
	* @param String entitledItemId the ID of the SKU
	**/
    /*
	changeProdImage: function(entitledItemId){
		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}
		this.setEntitledItems(entitledItemJSON);
		var skuImage = categoryDisplayJS.getImageForSKU();
		if(skuImage != null){
			document.getElementById('productMainImage').src = skuImage;
		}
	}, */

	/**
	* Handles the case when a swatch is selected. Set the border of the selected swatch.
	* @param {String} selectedAttributeName The name of the selected swatch attribute.
	* @param {String} selectedAttributeValue The value of the selected swatch attribute.
	* @param {String} entitledItemId The ID of the SKU
	* @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
	* @return boolean Whether the swatch is available for selection
	**/
    /*
	selectSwatch: function(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable) {
		for (attribute in this.selectedAttributes) {
			if (attribute == selectedAttributeName) {
				// case when the selected swatch is already selected with a value, if the value is different than
				// what's being selected, reset other swatches and deselect the previous value and update selection
				if (this.selectedAttributes[attribute] != selectedAttributeValue) {
					// deselect previous value and update swatch selection
					document.getElementById("swatch_" + this.selectedAttributes[attribute]).className = "swatch_normal";
				}
			}
		}
		this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable);
	}, */

	/**
	* Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
	* @param {String} swatchAttrName The name of the selected swatch attribute.
	* @param {String} swatchAttrValue The value of the selected swatch attribute.
	* @param {String} entitledItemId The ID of the SKU.
	* @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
	**/
    /*
	makeSwatchSelection: function(swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable) {
		this.setSelectedAttribute(swatchAttrName, swatchAttrValue);
		document.getElementById("swatch_" + swatchAttrValue).className = "swatch_selected";
		this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable);
		this.changeProdImage(entitledItemId);
	},*/

	/**
	* Constructs record and add to this.allSwatchesArray.
	* @param {String} swatchName The name of the swatch attribute.
	* @param {String} swatchValue The value of the swatch attribute.
	* @param {String} swatchImg1 The path to the swatch image.
	**/
	addToAllSwatchsArray: function(swatchName, swatchValue, swatchImg1) {
		if (!this.existInAllSwatchsArray(swatchName, swatchValue)) {
			var swatchRecord = [];
			swatchRecord[0] = swatchName;
			swatchRecord[1] = swatchValue;
			swatchRecord[2] = swatchImg1;
			swatchRecord[4] = document.getElementById("swatch_" + swatchValue).onclick;
			this.allSwatchesArray.push(swatchRecord);
		}
	},

	/**
	* Checks if a swatch is already exist in this.allSwatchesArray.
	* @param {String} swatchName The name of the swatch attribute.
	* @param {String} swatchValue The value of the swatch attribute.
	* @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
	*/
	existInAllSwatchsArray: function(swatchName, swatchValue) {
		for(var i=0; i<this.allSwatchesArray.length; i++) {
			var attrName = this.allSwatchesArray[i][0];
			var attrValue = this.allSwatchesArray[i][1];
			if (attrName == swatchName && attrValue == swatchValue) {
				return true;
			}
		}
		return false;
	},

	/**
	* Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
	* @param {String} entitledItemId The ID of the SKU.
	* @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
	**/
    /*
	makeDefaultSwatchSelection: function(entitledItemId, doNotDisable) {
		if (this.entitledItems.length == 0) {
			if ($("#" + entitledItemId).length) {
				 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
			}
			this.setEntitledItems(entitledItemJSON);
		}

		// need to make selection for every single swatch
		for(x in this.entitledItems){
			var Attributes = this.entitledItems[x].Attributes;
			for(y in Attributes){
				var index = y.indexOf("_|_");
				var swatchName = y.substring(0, index);
				var swatchValue = y.substring(index+3);
				this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable);
			}
			break;
		}
	}, */

	/**
	* Update swatch images - this is called after selection of a swatch is made, and this function checks for
	* entitlement and disable swatches that are not available
	* @param selectedAttrName The attribute that is selected
	* @param {String} entitledItemId The ID of the SKU.
	* @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
	**/
    /*
	updateSwatchImages: function(selectedAttrName, entitledItemId, doNotDisable) {
		var swatchToUpdate = [];
		var selectedAttrValue = this.selectedAttributes[selectedAttrName];

		// finds out which swatch needs to be updated, add to swatchToUpdate array
		for(var i=0; i<this.allSwatchesArray.length; i++) {
			var attrName = this.allSwatchesArray[i][0];
			var attrValue = this.allSwatchesArray[i][1];
			var attrImg1 = this.allSwatchesArray[i][2];
			var attrImg2 = this.allSwatchesArray[i][3];
			var attrOnclick = this.allSwatchesArray[i][4];

			if (attrName != doNotDisable && attrName != selectedAttrName) {
				var swatchRecord = [];
				swatchRecord[0] = attrName;
				swatchRecord[1] = attrValue;
				swatchRecord[2] = attrImg1;
				swatchRecord[4] = attrOnclick;
				swatchRecord[5] = false;
				swatchToUpdate.push(swatchRecord);
			}
		}

		// finds out which swatch is entitled, if it is, image should be set to enabled
		// go through entitledItems array and find out swatches that are entitled
		for (x in this.entitledItems) {
			var Attributes = this.entitledItems[x].Attributes;

			for(y in Attributes){
				var index = y.indexOf("_|_");
				var entitledSwatchName = y.substring(0, index);
				var entitledSwatchValue = y.substring(index+3);

				//the current entitled item has the selected attribute value
				if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
					//go through the other attributes that are available to the selected attribute
					//exclude the one that is selected
					for (z in Attributes) {
						var index2 = z.indexOf("_|_");
						var entitledSwatchName2 = z.substring(0, index2);
						var entitledSwatchValue2 = z.substring(index2+3);

						if(y != z){ //only check the attributes that are not the one selected
							for (i in swatchToUpdate) {
								var swatchToUpdateName = swatchToUpdate[i][0];
								var swatchToUpdateValue = swatchToUpdate[i][1];

								if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
									swatchToUpdate[i][5] = true;
								}
							}
						}
					}
				}
			}
		}

		// Now go through swatchToUpdate array, and update swatch images
		var disabledAttributes = [];
		for (i in swatchToUpdate) {
			var swatchToUpdateName = swatchToUpdate[i][0];
			var swatchToUpdateValue = swatchToUpdate[i][1];
			var swatchToUpdateImg1 = swatchToUpdate[i][2];
			var swatchToUpdateImg2 = swatchToUpdate[i][3];
			var swatchToUpdateOnclick = swatchToUpdate[i][4];
			var swatchToUpdateEnabled = swatchToUpdate[i][5];

			if (swatchToUpdateEnabled) {
				document.getElementById("swatch_" + swatchToUpdateValue).style.opacity = 1;
				document.getElementById("swatch_" + swatchToUpdateValue).style.filter = "";
				document.getElementById("swatch_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
			} else {
				if(swatchToUpdateName != doNotDisable){
					document.getElementById("swatch_" + swatchToUpdateValue).style.opacity = 0.3;
					document.getElementById("swatch_" + swatchToUpdateValue).style.filter = 'alpha(opacity=30)';
					document.getElementById("swatch_" + swatchToUpdateValue).onclick = null;

					//The previously selected attribute is now unavailable for the new selection
					//Need to switch the selection to an available value
					if(this.selectedAttributes[swatchToUpdateName] == swatchToUpdateValue){
						disabledAttributes.push(swatchToUpdate[i]);
					}
				}
			}
		}

		//If there were any previously selected attributes that are now unavailable
		//Find another available value for that attribute and update other attributes according to the new selection
		for(i in disabledAttributes){
			var disabledAttributeName = disabledAttributes[i][0];
			var disabledAttributeValue = disabledAttributes[i][1];

			for (i in swatchToUpdate) {
				var swatchToUpdateName = swatchToUpdate[i][0];
				var swatchToUpdateValue = swatchToUpdate[i][1];
				var swatchToUpdateEnabled = swatchToUpdate[i][5];

				if(swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled){
						document.getElementById("swatch_" + disabledAttributeValue).className = "swatch_normal";
						this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable);
					break;
				}
			}
		}
	},*/

	/**
	* updateParamObject This function updates the given params object with a key to value pair mapping.
	*				    If the toArray value is true, It creates an Array for duplicate entries otherwise it overwrites the old value.
	*			        This is useful while making a service call which accepts a few parameters of type array.
	*					This function is used to prepare a a map of parameters which can be passed to XMLHttpRequests.
	* 					The keys in this parameter map will be the name of the parameter to send and the value is the corresponding value for each parameter key.
	* @param {Object} params The parameters object to add name value pairs to.
	* @param {String} key The new key to add.
	* @param {String} value The new value to add to the specified key.
	* @param {Boolean} toArray Set to true to turn duplicate keys into an array, or false to override previous values for a specified key.
	* @param {int} index The index in an array of values for a specified key in which to place a new value.
	*
	* @return {Object} params A parameters object holding name value pairs.
	*
	**/
	updateParamObject:function(params, key, value, toArray, index){

	   if(params == null){
		   params = [];
	   }

	   if(params[key] != null && toArray)
	   {
			if($.isArray(params[key]))
			{
				//3rd time onwards
			    if(index != null && index !== "")
				{
					//overwrite the old value at specified index
				     params[key][index] = value;
				}
				else
				{
				    params[key].push(value);
			     }
		    }
			else
			{
			     //2nd time
			     var tmpValue = params[key];
			     params[key] = [];
			     params[key].push(tmpValue);
			     params[key].push(value);
		    }
	   }
	   else
	   {
			//1st time
		   if(index != null && index !== "" && index != -1)
		   {
		      //overwrite the old value at specified index
		      params[key+"_"+index] = value;
		   }
		   else if(index == -1)
		   {
		      var i = 1;
		      while(params[key + "_" + i] != null)
			  {
			       i++;
		      }
		      params[key + "_" + i] = value;
		   }
		   else
		   {
		      params[key] = value;
		    }
	   }
	   return params;
	 },

	 /**
	  *  This function associates the product id with its first entitledItemId.
	  *  @param {String} productId The id of the product.
	  *  @param {String} entitledItemId The id of the first entitledItem of the product.
	  */
	 setDefaultItem : function(productId,entitledItemId){
		this.defaultItemArray[productId] = entitledItemId;

},
	/*
     *	This function retrieves the first entitledItemId of the product.
	 *  @param {String} productId The id of the product.
	 *
	 *  @return {String} The id of the first entitledItem of the product.
	 */
getDefaultItem : function(productId){
		return this.defaultItemArray[productId];
},


	/**
	* AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart. This is for the ajax flow which will take a form as input and retrieves all the items catentry IDs and adds them to the form.
	*
	* @param {form} form The form which contains all the inputs for the bundle.
	*					 The form is expected to have the following values:
	*						numberOfProducts The number of products in the bundle.
	*						catEntryId_<index> where index is between 1 and numberOfProduct.
	*						quantity_<index> where index is between 1 and numberOfProduct.
	**/
	AddBundle2ShopCartAjax : function(form){

		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		var params = [];

		params.storeId		= this.storeId;
		params.catalogId	= this.catalogId;
		params.langId		= this.langId;
		params.orderId		= ".";
		// Remove calculations for performance
		// params.calculationUsage = "-1,-2,-5,-6,-7";
		params.calculateOrder="0";
		params.inventoryValidation = "true";

		var productCount = form["numberOfProduct"].value;
		for(var i = 1; i <= productCount; i++){
			var catEntryId = form["catEntryId_" + i].value;
			if(this.selectedProducts[catEntryId])
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryId]);
			var qty = form["quantity_" + i].value;
			if(qty == null || qty === "" || qty<=0){ MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']); return;}
			if(qty!=null && qty !== '' && catEntryId!=null){
				this.updateParamObject(params,"catEntryId",catEntryId,false,-1);
				this.updateParamObject(params,"quantity",qty,false,-1);
				this.baseItemAddedToCart=true;
			}
			else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
				return;
			}
			var contractIdElements = document.getElementsByName('contractSelectForm_contractId_' + catEntryId);
			if (contractIdElements != null && contractIdElements != "undefined") {
				for (j=0; j<contractIdElements.length; j++) {
					if (contractIdElements[j].checked) {
						form["contractId_" + i].value = contractIdElements[j].value;
						break;
					}
				}
			}
			var contractId = form["contractId_" + i].value;
			if (contractId != null && contractId !== '') {
				this.updateParamObject(params,"contractId",contractId,false,-1);
			}
		}
		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxAddOrderItem", params);

	},


	/**
	* AddBundle2ShopCart This function is used to add a bundle to the shopping cart. This is for the non ajax flow which  will take a form as input and submits the form.
	*
	* @param {form} form The form which contains all the inputs for the bundle.
	*					 The form is expected to have the following values:
	*						numberOfProducts The number of products in the bundle.
	*						catEntryId_<index> where index is between 1 and numberOfProduct.
	*						quantity_<index> where index is between 1 and numberOfProduct.
	*
	**/
	AddBundle2ShopCart : function(form){

		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		form.URL.value = "AjaxOrderItemDisplayView";
		var productCount = form["numberOfProduct"].value;
		for(var i = 1; i <= productCount; i++){
			var catEntryId = form["catEntryId_" + i].value;
			if(this.selectedProducts[catEntryId]){
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryId]);
				if(catEntryId != null)
				form["catEntryId_" + i].value = catEntryId;
				else{
					MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
					return;
				}
			}
			var qty = form["quantity_" + i].value;
			if(qty == null || qty === "" || qty<=0){ MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']); return;}
			var contractIdElements = document.getElementsByName('contractSelectForm_contractId_' + catEntryId);
			if (contractIdElements != null && contractIdElements != "undefined") {
				for (j=0; j<contractIdElements.length; j++) {
					if (contractIdElements[j].checked) {
						form["contractId_" + i].value = contractIdElements[j].value;
						break;
					}
				}
			}
		}

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}

		processAndSubmitForm(form);
	},


	/**
	* Add2ShopCart This function is used to add to a catalog entry to the shopping cart. This will resolve the catentryId using entitledItemId and adds the item to the cart.
	*			   This function will call AddItem2ShopCart after resolving the entitledItemId to a SKU.
	*
	* @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	* @param {form} form The form which contains all the inputs for the item. The catEntryId and productId values of the form you pass in
	*					 will be set to the catalog entry Id of the SKU resolved from the list of skus whos defining attributes match those in the {@link this.selectedAttributes} array.
	* @param {int} quantity quantity of the item.
	* @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
	*
	**/
	Add2ShopCart : function(entitledItemId,form,quantity,isPopup){

		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}

		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		if(catalogEntryId!=null){
			if(this.merchandisingProductAssociationAddToCart){
				this.AddAssociation2ShopCart(catalogEntryId,quantity);
				return;
			}
			form.catEntryId.value = catalogEntryId;
			form.productId.value = catalogEntryId;
			this.AddItem2ShopCart(form,quantity);
			hidePopup('second_level_category_popup');
		} else if (isPopup == true){
			$('#second_level_category_popup').css('zIndex', '1');
			MessageHelper.formErrorHandleClient('addToCartLink', MessageHelper.messages['ERR_RESOLVING_SKU']);
		} else{
			MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
		}

	},



	/**
	* AddItem2ShopCart This function is used to add a SKU to the shopping cart.
	*
	* @param {form} form The form which contains all the inputs for the item.
    * 					The form must have the following values:
    *						quantity The quantity of the item that you want to add to the cart.
	* @param {int} quantity The quantity of the item to add to the shopping cart.
	*
	**/
	AddItem2ShopCart : function(form,quantity){
		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		if(!isPositiveInteger(quantity)){
			MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
			return;
		}

		form.quantity.value = quantity;

		var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
		if (contractIdElements != null && contractIdElements != "undefined") {
			for (i=0; i<contractIdElements.length; i++) {
				if (contractIdElements[i].checked) {
					form.contractId.value = contractIdElements[i].value;
					break;
				}
			}
		}
		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		processAndSubmitForm(form);
	},


	/**
	* Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
	*				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
	* @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	* @param {int} quantity The quantity of the item to add to the cart.
	* @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
	* @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
	*
	**/
	Add2ShopCartAjax : function(entitledItemId,quantity,isPopup,customParams){
		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}

		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		if(catalogEntryId!=null){
			this.AddItem2ShopCartAjax(catalogEntryId , quantity,customParams);
			this.baseItemAddedToCart=true;
			hidePopup('second_level_category_popup');
		}
		else if (isPopup == true){
			$('#second_level_category_popup').css('zIndex', '1');
			MessageHelper.formErrorHandleClient('addToCartLinkAjax', MessageHelper.messages['ERR_RESOLVING_SKU']);
		} else{
			MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
			this.baseItemAddedToCart=false;
		}
	},

	/**
	 * sets the entitledItemJsonObject
	 * @param (object) jsonObject the entitled item JSON objects
	 */
    setEntitledItemJsonObject: function(jsonObject) {
        this.entitledItemJsonObject = jsonObject;
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
    	return this.entitledItemJsonObject;
    },

	/**
	* ReplaceItemAjax This function is used to replace an item in the shopping cart when the AJAX Checkout flow is enabled. This will be called from the shopping cart and checkout pages.
	*
	* @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	* @param {int} quantity The quantity of the item to add to the shopping cart.
	*
	**/
	ReplaceItemAjax : function(entitledItemId,quantity){

		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}
		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		var removeOrderItemId = "";
		//if(entitledItemJSON[0] != null){
		//	removeOrderItemId = entitledItemJSON[0].orderItemId_remove;
		//}
		var removeOrderItemId = replaceOrderItemId;
		var typeId = document.getElementById("shipmentTypeId");
		var addressId = "";
		var shipModeId = "";
		if(typeId != null && typeId !== ""){
			if(typeId.value == "2"){
				//Multiple shipment..each orderItem will have its own addressId and shipModeId..
				addressId = document.getElementById("MS_ShipmentAddress_"+removeOrderItemId).value;
				shipModeId = document.getElementById("MS_ShippingMode_"+removeOrderItemId).value;
			}
			else {
				//Single Shipment..get the common addressId and shipModeId..
				addressId = $("#addressId_all").val();;
				shipModeId = $("#shipModeId_all").val();
			}
		}
		if(catalogEntryId!=null){
			if(removeOrderItemId !== ""){
				//Remove existing catEntryId and then add new one...
				this.ReplaceItemAjaxHelper(catalogEntryId,quantity,removeOrderItemId,addressId,shipModeId);
			}
		}else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
		}
	},

	/**
	* ReplaceItemNonAjax This function is used to replace an item in the shopping cart when the Non Ajax checkout flow is enabled. This will be called from shopcart and checkout pages.
	*
	* @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	* @param {int} quantity The quantity of the item to replace in the shopping cart.
	* @param {form} form The form which contains all the inputs for the item.
	*
	**/
	ReplaceItemNonAjax : function(entitledItemId,quantity,form){

		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}
		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		var removeOrderItemId = "";
		//if(entitledItemJSON[0] != null){
		//	removeOrderItemId = entitledItemJSON[0].orderItemId_remove;
		//}
		var removeOrderItemId = replaceOrderItemId;
		if(catalogEntryId!=null){
			if(removeOrderItemId === ""){
				//Prepare form to just add this item.. This code will never be executed...
				//Needed only when we plan to show add to cart link also in the quick info..
				//form.action = "orderChangeServiceItemAdd";
				//form.submit();
			}
			else{
				//Else remove existing catEntryId and then add new one...
				form.orderItemId.value = removeOrderItemId;
				var addressId, shipModeId;
				if(quantity == 0){
					console.debug("An invalid quantity was selected");

				}
				if(form.shipmentTypeId != null && form.shipmenTypeId !== ""){
					if(form.shipmentTypeId.value == "2"){
						//Multiple shipment..each orderItem will have its own addressId and shipModeId..
						addressId = document.getElementById("MS_ShipmentAddress_"+removeOrderItemId).value;;
						shipModeId = document.getElementById("MS_ShippingMode_"+removeOrderItemId).value;;
					}
					else {
						//Single Shipment..get the common addressId and shipModeId..
						addressId = $("#addressId_all").val();;
						shipModeId = $("#shipModeId_all").val();
					}
					form.URL.value = "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId="+catalogEntryId+"&quantity="+quantity+"&addressId="+addressId+"&shipModeId="+shipModeId+"&URL=RESTOrderShipInfoUpdate?URL="+form.URL.value;
			    }
				else{
					form.URL.value = "RESTOrderItemAdd?calculationUsage=-1,-2,-3,-4,-5,-6,-7&catEntryId="+catalogEntryId+"&quantity="+quantity+"&URL="+form.URL.value;
				}

				//For Handling multiple clicks
				if(!submitRequest()){
					return;
				}
				processAndSubmitForm(form);
			}
		}
		else{
			MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
		}
	},

	/**
	* AddItem2ShopCartAjax This function is used to add a single or multiple items to the shopping cart using an ajax call.
							If an array is passed for catEntryIdentifier and quantity parramters, then multiple items can be added.	In this case, catEntryIdentifier[i] corresponds to quantity[i]
							Else, catEntryIdentifier  and quantity parramters represent a single catalog entry.
	*
	* @param {Array|String} catEntryIdentifier An array of catalog entry identifiers or a single catalog entry ID of the item to add to the cart.
	* @param {Array|int} quantity An array of quantities corresponding to the catEntryIdentifier array or a single quantity of the item to add to the cart.
	* @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
	*
	**/
	AddItem2ShopCartAjax : function(catEntryIdentifier, quantity, customParams) {
		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		var params = {
			storeId: this.storeId,
			catalogId: this.catalogId,
			langId: this.langId,
			orderId: "."
		};
		// Remove calculations for performance
		// params.calculationUsage = "-1,-2,-5,-6,-7";
		params.calculateOrder="0";
		params.inventoryValidation = "true";
		var ajaxShopCartService = "AjaxAddOrderItem";
		var nonAjaxShopCartService = "AjaxAddOrderItem_shopCart";

		if($.isArray(catEntryIdentifier) && $.isArray(quantity)){
			for(var i=0; i<catEntryIdentifier.length; i++){
				if(!isPositiveInteger(quantity[i])){
					MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
					return;
				}
				params["catEntryId_" + (i+1)] = catEntryIdentifier[i];
				params["quantity_" + (i+1)]	= quantity[i];
			}
		}
		else{
			if(!isPositiveInteger(quantity)){
				MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
				return;
			}
			params.catEntryId	= catEntryIdentifier;
			params.quantity		= quantity;
		}

		//Pass any other customParams set by other add on features
		if(customParams != null && customParams != 'undefined'){
			for(i in customParams){
				params[i] = customParams[i];
			}
			if(customParams['catalogEntryType'] == 'dynamicKit' ){
				ajaxShopCartService = "AjaxAddPreConfigurationToCart";
				nonAjaxShopCartService = "AjaxAddPreConfigurationToCart_shopCart";
			}
		}

		var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
		if (contractIdElements != null && contractIdElements != "undefined") {
			for (i=0; i<contractIdElements.length; i++) {
				if (contractIdElements[i].checked) {
					params.contractId = contractIdElements[i].value;
					break;
				}
			}
		}

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke(ajaxShopCartService, params);
		this.baseItemAddedToCart=true;

		if(document.getElementById("headerShopCartLink")&&document.getElementById("headerShopCartLink").style.display != "none")
		{
			$("#headerShopCart").focus();
		}
		else
		{
			$("#headerShopCart1").focus();
		}
	},

	/**
	* ConfigureDynamicKit This function is used to call the configurator page for a dynamic kit.
	* @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
	* @param {int} quantity A quantity of the item to add to the cart.
	* @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
	*
	**/
	ConfigureDynamicKit : function(catEntryIdentifier, quantity, customParams)
	{
		var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
catEntryId: catEntryIdentifier,
quantity: quantity};

		if(!isPositiveInteger(quantity)){
			MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
			return;
		}

		var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
		if (contractIdElements != null && contractIdElements != "undefined") {
			for (i=0; i<contractIdElements.length; i++) {
				if (contractIdElements[i].checked) {
					params.contractId = contractIdElements[i].value;
					break;
				}
			}
		}

		//Pass any other customParams set by other add on features
		if(customParams != null && customParams != 'undefined'){
			for(i in customParams){
				params[i] = customParams[i];
			}
		}

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();

		var configureURL = "ConfigureView";
		var i =0;
		for(param in params){
			configureURL += ((i++ == 0)? "?" : "&") + param + "=" + params[param];
		}
		document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
	},

	/**
	* ReplaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
	*
	* @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
	* @param {int} qty The quantity of the item to add.
	* @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
	* @param {String} addressId The address ID of the order item.
	* @param {String} shipModeId The shipModeId of the order item.
	*
	**/
	ReplaceItemAjaxHelper : function(catalogEntryId,qty,removeOrderItemId,addressId,shipModeId){

		var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderItemId: removeOrderItemId,
            orderId: (this.orderId != null && this.orderId != 'undefined' && this.orderId !== '') ?this.orderId:"."
        };
		if(CheckoutHelperJS.shoppingCartPage){
			params.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}

		var params2 = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: (this.orderId != null && this.orderId != 'undefined' && this.orderId !== '')?this.orderId:"."
        };
		if(CheckoutHelperJS.shoppingCartPage){
			params2.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}

		var params3 = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: (this.orderId != null && this.orderId != 'undefined' && this.orderId !== '')?this.orderId:"."
        };
		if(CheckoutHelperJS.shoppingCartPage){
			params3.calculationUsage = "-1,-2,-5,-6,-7";
		}else{
			params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		}
		params3.allocate="***";
		params3.backorder="***";
		params3.remerge="***";
		params3.check="*n";

		var shipInfoUpdateNeeded = false;
		if(addressId != null && addressId !== "" && shipModeId != null && shipModeId !== ""){
			params3.addressId = addressId;
			params3.shipModeId = shipModeId;
			shipInfoUpdateNeeded = true;
		}

		//Delcare service for deleting item...
		wcService.declare({
			id: "AjaxReplaceItem",
			actionId: "AjaxReplaceItem",
			url: "AjaxRESTOrderItemDelete",
			formId: ""

			,successHandler: function(serviceResponse) {
				//Now add the new item to cart..
				if(!shipInfoUpdateNeeded){
					//We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
					wcService.invoke("AjaxAddOrderItem", params2);
				}
				else{
					//We need to update the adderessId and shipModeId..so call our temp service to add..
					wcService.invoke("AjaxAddOrderItemTemp", params2);
				}
			}

			,failureHandler: function(serviceResponse) {
				if (serviceResponse.errorMessage) {
							 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
					  } else {
							 if (serviceResponse.errorMessageKey) {
									MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
							 }
					  }
					  cursor_clear();
			}

		});

		//Delcare service for adding item..
		wcService.declare({
			id: "AjaxAddOrderItemTemp",
			actionId: "AjaxAddOrderItemTemp",
			url: "AjaxRESTOrderItemAdd",
			formId: ""

			,successHandler: function(serviceResponse) {
				//Now item is added.. call update to set addressId and shipModeId...
				wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
			}

			,failureHandler: function(serviceResponse) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		});

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxReplaceItem",params);
	},

	/**
	* AddBundle2WishList This function is used to add a bundle to the wish list and it can be called by the product/bundle/package details pages.
	*
	* @param {form} form The form which contains all the inputs for the bundle.
	*
	**/
	AddBundle2WishList : function(form){
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		var productCount = form["numberOfProduct"].value;
		for(var i = 1; i <= productCount; i++){
			var catEntryId = form["catEntryId_" + i].value;
			if(this.selectedProducts[catEntryId]){
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryId]);
				if(catEntryId != null)
				form["catEntryId_" + i].value = catEntryId;
				else{
					MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
					return;
				}
			}
		}
		form.action="InterestItemAdd";
		form.page.value="customerlinkwishlist";

		if(this.userType=='G'){
			form.URL.value='InterestItemDisplay';
		}else {
			form.URL.value='AjaxLogonForm';
		}

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}

		processAndSubmitForm(form);
	},

	/**
	* AddBundle2WishListAjax This fuction is used to add a bundle to the wish list using the ajax flow and it is called by the product/bundle/package details pages.
	*
	* @param {form} form The form which contains all the inputs for the bundle.
	*
	**/
	AddBundle2WishListAjax : function(form){
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		var params = [];

		params.storeId		= this.storeId;
		params.catalogId	= this.catalogId;
		params.langId		= this.langId;
		params.updateable	= 0;
		params.orderId		= ".";

		var catEntryArray = [];
		catEntryArray = form.catEntryIDS.value.toString().split(",");

		for(var i = 0; i < catEntryArray.length; i++){
			var qty = document.getElementById("quantity_" + catEntryArray[i]).value;
			var catEntryId = catEntryArray[i];
			if(this.selectedProducts[catEntryArray[i]])
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryArray[i]]);
			if(qty==0 || qty == null) qty = 1;
			if(qty!=null && qty !== '' && catEntryId!=null){
				this.updateParamObject(params,"catEntryId",catEntryId,false,-1);
				this.updateParamObject(params,"quantity",qty,false,-1);
			}
			else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
				return;
			}
		}
		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxInterestItemAdd", params);

	},

	/**
	* Add2WishListAjaxByID. This function is used to add a catalog entry to the wish list using ajax by passing in a catalog entry ID.
	*
	* @param {int} catalogEntryId The catalog entry ID of the catalog entry.
	*
	**/
	Add2WishListAjaxByID:function(catalogEntryId)
	{
		if(catalogEntryId!=null){
			if (!isAuthenticated) {
				setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
			}
			var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                catEntryId: catalogEntryId,
                updateable: 0,
                URL: "SuccessfulAJAXRequest"
            };
			if($("#controllerURLWishlist").length)
                $("#WishlistDisplay_Widget").refreshWidget("updateUrl", $("#controllerURLWishlist").val());

			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke("AjaxInterestItemAdd", params);
		}
		else MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
	},

	/**
	* Add2WishListAjax This function is used to add an item to the wishlist using ajax by passing in the id of an HTML element containing a JSON object representing a catalog entry.
	*				   This fuction is called by product/bundle/package detail pages.
	*
	* @param {HTMLDivElement} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	*
	**/
	Add2WishListAjax:function(entitledItemId)
	{
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}
		this.setEntitledItems(entitledItemJSON);



		var catalogEntryId = this.getCatalogEntryId();

		this.Add2WishListAjaxByID(catalogEntryId);

	},

	/**
	* AddItem2WishListAjax. This function is used to add an item to the wishlist using AJAX by passing in its catentryId.
	* 						This function can be called by item detail page.
	*
	* @param {String} itemId The catalog entry ID of the catalog entry to add to the wish list.
	*
	**/
	AddItem2WishListAjax:function(itemId)
	{
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: itemId,
            updateable: 0,
            URL: "SuccessfulAJAXRequest"
        };
		if ($("#controllerURLWishlist").length)
            $("#WishlistDisplay_Widget").refreshWidget("updateUrl", $("#controllerURLWishlist").val());

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxInterestItemAdd", params);
	},

	/**
	* Add2WishList This function is used to add a catalog entry to the wish list using the non ajax flow by passing in the ID of an HTML element containing a JSON which represents a catalog entry
	*			   This fuction is called by the product/bundle/package detail pages.
	*
	* @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
	* @param {form} form form to submit the request.
	*
	**/
	Add2WishList:function(entitledItemId,form)
	{
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}
		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		this.Add2WishListByID(catalogEntryId,form);
	},


	/**
	* Add2WishListByID Add a catalog entry to the wish list using the non-AJAX flow. This fuction is called by the product/bundle/package detail pages.
	*
	* @param {String} catalogEntryId The catalog entry ID of the catalog entry to be added.
	* @param {form} form  form to submit the request.
	*
	**/
	Add2WishListByID:function(catalogEntryId,form)
	{
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		if(catalogEntryId!=null){
			form.productId.value = catalogEntryId;
			form.catEntryId.value = catalogEntryId;
			form.action="InterestItemAdd";
			form.page.value="customerlinkwishlist";

			if(this.userType=='G'){
				form.URL.value='InterestItemDisplay';
			}else {
				form.URL.value='AjaxLogonForm';
			}

			form.quantity.value = "1";

			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}

			processAndSubmitForm(form);
		}
		else MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
	},


	/**
	* AddItem2WishList Add a SKU to the wish list using the non-AJAX flow. This function is called by the item detail page.
	*
	* @param {form} form The form to submit the request.
	*
	**/
	AddItem2WishList:function(form)
	{
		if (!isAuthenticated) {
			setWarningMessageCookie('WISHLIST_GUEST_ADDITEM');
		}
		form.action="InterestItemAdd";
		form.quantity.value = "1";
		form.page.value="customerlinkwishlist";

		if(this.userType=='G'){
			form.URL.value='InterestItemDisplay';
		}else {
			form.URL.value='AjaxLogonForm';
		}

		//For Handling multiple clicks
		if(!submitRequest()){
			return;
		}

		processAndSubmitForm(form);
	},

	/**
	* initializeMerchandisingAssociation Since the merchandising associations are only displayed one at a time with a scrolling widget this method
	*									 will initialize that widget with a specified starting index represented by thumbnailIndex so that the correct
	*									 merchandising association is displayed first.
	*									 This function is called on MerchandisingAssociationsDisplay.jsp.s
	*
	* @param {String} thumbnailIndex The index of the association that needs to be displayed.
	*
	**/
	initializeMerchandisingAssociation:function(thumbnailIndex){

	var associationDisplay = document.getElementById("marchandisingAssociationDisplay");
	var totalPriceMsg = $("#totalPriceMsg").val();
	var baseCatEntryJSON = eval('('+ $("#baseCatEntryDetails").html() +')');
	this.baseCatalogEntryDetails = baseCatEntryJSON;
	var basePrice=this.baseCatalogEntryDetails[0].baseCatEntry_Price;
	this.totalAssociationCount= this.baseCatalogEntryDetails[0].totalAssociations;
	var identifierJSON = "associatedCatEntries_"+thumbnailIndex;
	var associationEntryJSON = eval('('+ $("#" + identifierJSON).html() +')');
	this.merchandisingAssociationItems = associationEntryJSON;
	var totalPrice = parseFloat(basePrice)+ parseFloat(this.merchandisingAssociationItems[0].catEntry_Price);
	var dragType = "";

	if(this.merchandisingAssociationItems[0].catEntry_Type =='ProductBean'){
		dragType = "product";
	}else if (this.merchandisingAssociationItems[0].catEntry_Type =='ItemBean'){
		dragType = "item";
	}else if (this.merchandisingAssociationItems[0].catEntry_Type =='PackageBean'){
		dragType = "package";
	}else if (this.merchandisingAssociationItems[0].catEntry_Type =='BundleBean'){
		dragType = "bundle";
	}
//Creates the inner HTML of the associated item determined by the thumbnailIndex which needs to be displayed in the page.
var widgetHTML = "";
if ($("#addToCartLink").length){
var url = "AjaxOrderItemDisplayView?storeId="+this.storeId+"&catalogId="+this.catalogId+"&langId="+this.langId;
						widgetHTML = widgetHTML
						+"<form name='OrderItemAddForm_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' action='RESTOrderItemAdd' method='post' id='OrderItemAddForm_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'>\n"
						+"<input type='hidden' name='storeId' value='"+this.storeId+"' id='OrderItemAddForm_storeId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='orderId' value='.' id='OrderItemAddForm_orderId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='catalogId' value='"+this.catalogId+"' id='OrderItemAddForm_orderId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='URL' value='"+ url + "' id='OrderItemAddForm_url_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='errorViewName' value='InvalidInputErrorView' id='OrderItemAddForm_errorViewName_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='catEntryId' value='"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' id='OrderItemAddForm_catEntryId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' name='productId' value='"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' id='OrderItemAddForm_productId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' value='1' name='quantity' id='OrderItemAddForm_quantity_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' value='' name='page' id='OrderItemAddForm_page_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' value='-1,-2,-3,-4,-5,-6,-7' name='calculationUsage' id='OrderItemAddForm_calcUsage_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' value='0' name='updateable' id='OrderItemAddForm_updateable_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"<input type='hidden' value='' name='giftListId' id='OrderItemAddForm_giftListId_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'/>\n"
						+"</form>\n";
						}
widgetHTML = widgetHTML
			+"<div class='scroller' id='WC_CategoryDisplayJS_div_1'>";
			if(this.totalAssociationCount > 1){
				if(this.associationThumbnailIndex < this.totalAssociationCount){
					widgetHTML = widgetHTML
					+"		<a href='Javascript:categoryDisplayJS.showNextAssociation()'  id='WC_ProductAssociation_UpArrow_Link_1'>";
				}
				widgetHTML = widgetHTML
				+"		<img src='"+this.baseCatalogEntryDetails[0].storeImage_Path+"i_up_arrow.png' alt='"+this.displayNextAssociation+"'/></a>";
			}
			widgetHTML = widgetHTML +" <br />"
			+"<div id='baseContent_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"'";
			if(this.merchandisingAssociationItems[0].showProductQuickView == 'true'){
				widgetHTML = widgetHTML
				+" onmouseover='showPopupButton("+this.merchandisingAssociationItems[0].catEntry_Identifier+");' onmouseout='hidePopupButton("+this.merchandisingAssociationItems[0].catEntry_Identifier+");'>";
			}else{
				widgetHTML = widgetHTML
				+" >";
			}
			widgetHTML = widgetHTML
			+"	<a href='"+this.merchandisingAssociationItems[0].catEntry_ProductLink+"'  id='img"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' onfocus='showPopupButton("+this.merchandisingAssociationItems[0].catEntry_Identifier+");'>";
			widgetHTML = widgetHTML
			+"		<img src='"+this.merchandisingAssociationItems[0].catEntry_Thumbnail+"' alt='"+this.merchandisingAssociationItems[0].catEntry_ShortDescription+"' class='img' width='70' height='70'/>"
			+"	</a><br />";
			if(this.merchandisingAssociationItems[0].showProductQuickView == 'true'){
				widgetHTML = widgetHTML
				+" <div id='popupButton_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' class='main_quickinfo_button'>"
					+"<span class='secondary_button' >\n"
						+"<span class='button_container' >\n"
							+"<span class='button_bg' >\n"
								+"<span class='button_top'>\n"
									+"<span class='button_bottom'>\n"
										+"<a id='QuickInfoButton_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' href='#' onclick='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList="+this.merchandisingAssociationItems[0].associationProductBuyable+"; actionListImageAcct.showAddToCart="+this.merchandisingAssociationItems[0].associationProductBuyable+"; showPopup("+this.merchandisingAssociationItems[0].catEntry_Identifier+",event,null,null,actionListImageAcct);' onkeypress='javaScript:var actionListImageAcct = new popupActionProperties(); actionListImageAcct.showWishList="+this.merchandisingAssociationItems[0].associationProductBuyable+"; actionListImageAcct.showAddToCart="+this.merchandisingAssociationItems[0].associationProductBuyable+"; showPopup("+this.merchandisingAssociationItems[0].catEntry_Identifier+",event,null,null,actionListImageAcct);' onblur='hidePopupButton("+this.merchandisingAssociationItems[0].catEntry_Identifier+");' role='wairole:button' waistate:haspopup='true'>"+this.merchandisingAssociationItems[0].showProductQuickViewLable+"</a></span>\n"
								+"</span>\n"
							+"</span>\n"
						+"</span>\n"
					+"</span>\n"
				+"</div>\n";
			}
			widgetHTML = widgetHTML
			+"</div>";

			if(this.totalAssociationCount > 1){
				if(this.associationThumbnailIndex > 1 ){
					widgetHTML = widgetHTML
					+"		<a href='Javascript:categoryDisplayJS.showPreviousAssociation()'  id='WC_ProductAssociation_DownArrow_Link_1'>";
				}
				widgetHTML = widgetHTML
				+"		<img src='"+this.baseCatalogEntryDetails[0].storeImage_Path+"i_down_arrow.png' alt='"+this.displayPrevAssociation+"'/></a>";
			}

			var comboText = this.baseCatalogEntryDetails[0].associatedProductsName.replace(/%0/, this.baseCatalogEntryDetails[0].baseCatEntry_Name);
			comboText = comboText.replace(/%1/, this.merchandisingAssociationItems[0].catEntry_Name);

			widgetHTML = widgetHTML
			+"</div>"
			+"<div class='combo_text' id='WC_CategoryDisplayJS_div_2'>\n"
			+"	<h1 id='maHeader' class='status_msg'>"+ comboText +"</h1>\n"
			+"	<span id='maPrice' class='grey'>"+totalPriceMsg+Utils.formatCurrency(totalPrice.toFixed(2), {currency: this.baseCatalogEntryDetails[0].currency})+"</span>\n"+"</div>\n";
			widgetHTML = widgetHTML
			+"<input type='hidden' id='compareImgPath_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' value='"+this.merchandisingAssociationItems[0].catEntry_Thumbnail_compare+"'/>"
			+"<input type='hidden' id='compareProductDetailsPath_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' value='"+this.merchandisingAssociationItems[0].catEntry_ProductLink+"'/>"
			+"<input type='hidden' id='compareImgDescription_"+this.merchandisingAssociationItems[0].catEntry_Identifier+"' value='"+this.merchandisingAssociationItems[0].catEntry_ShortDescription+"'/>";
			associationDisplay.innerHTML=null;
			associationDisplay.innerHTML=widgetHTML;
            WCWidgetParser.parse(associationDisplay);
            WCWidgetParser.parseRefreshArea(associationDisplay);
},


	/**
	* showNextAssociation Displays the next association in the association array. No action is performed if it is already at the last item.
	*				      This function is used with the merchandising association widget on the MerchandisingAssociationDisplay.jsp to display the next
	*					  association available.
	**/
	showNextAssociation : function(){

		if(this.associationThumbnailIndex < this.totalAssociationCount){
			this.associationThumbnailIndex = this.associationThumbnailIndex+1;
			this.initializeMerchandisingAssociation(this.associationThumbnailIndex);
		}
	},

	/**
	* showPreviousAssociation Displays the previous association in the association array. No action is performed if it is already the first item.
	*				      This function is used with the merchandising association widget on the MerchandisingAssociationDisplay.jsp to display the previous
	*					  association available.
	**/
	showPreviousAssociation : function(){

	if(this.associationThumbnailIndex > 1 ){
			this.associationThumbnailIndex = this.associationThumbnailIndex-1;
			this.initializeMerchandisingAssociation(this.associationThumbnailIndex);
		}
	},

	/**
	* AddAssociation2ShopCartAjax Adds the associated product to the shopping cart.
	*
	* @param {String} baseProductId The catalog entry ID of the parent product.
	* @param {int} baseProductQuantity The quantity of the parent product to add.
	*
	**/
	AddAssociation2ShopCartAjax:function(baseProductId,baseProductQuantity){

		if (browseOnly){
			MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
			return;
		}
		var identifierJSON = "associatedCatEntries_"+this.associationThumbnailIndex;
		//Get the associated item from the JSON object.
		var associationEntryJSON = eval('('+ $("#" + identifierJSON).html() +')');
		this.merchandisingAssociationItems = associationEntryJSON;
		this.baseItemAddedToCart = false;
		//Add the parent product to the cart.
		if(this.merchandisingAssociationItems[0].catEntry_Type=='ProductBean'){
			this.Add2ShopCartAjax(baseProductId,baseProductQuantity);
			if(this.baseItemAddedToCart){
				//Show the pop-up to select the attributes of the associated product.
				showPopup(this.merchandisingAssociationItems[0].catEntry_Identifier,function(e){return e;},'marchandisingAssociationDisplay');
			}
		}else if (["ItemBean", "PackageBean", "BundleBean"].indexOf(this.merchandisingAssociationItems[0].catEntry_Type) > -1){
			//Get the associated item from the JSON object.
			var entitledItemJSON = eval('('+ $("#" + baseProductId).html() +')');
			this.setEntitledItems(entitledItemJSON);
			var catalogEntryId = this.getCatalogEntryId();
			var params = {
                storeId: this.storeId,
                catalogId: this.catalogId,
                langId: this.langId,
                orderId: "."
            };
				// Remove calculations for performance
				// params.calculationUsage = "-1,-2,-5,-6,-7";
				params.calculateOrder="0";
			if(catalogEntryId!=null){
				this.updateParamObject(params,"catEntryId",catalogEntryId,false,-1);
				this.updateParamObject(params,"quantity",baseProductQuantity,false,-1);
				if(this.merchandisingAssociationItems[0].catEntry_Type=='BundleBean'){
					var form = document.getElementById(this.merchandisingAssociationItems[0].catEntry_BundleFormId);
					var catEntryArray = [];
					// add the individual bundle items to the request.
					catEntryArray = form.catEntryIDS.value.toString().split(",");
					for(var i = 0; i < catEntryArray.length; i++){
						var qty = document.getElementById("quantity_" + catEntryArray[i]).value;
						var catEntryId = catEntryArray[i];
						if(this.getDefaultItem(catEntryArray[i]))
							catEntryId = this.getDefaultItem(catEntryArray[i]);
						if(qty==0 || qty == null) qty = 1;
						if(qty!=null && qty !== '' && catEntryId!=null){
							this.updateParamObject(params,"catEntryId",catEntryId,false,-1);
							this.updateParamObject(params,"quantity",qty,false,-1);
						}else{
							MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
							return;
						}
					}
				}else{
					this.updateParamObject(params,"catEntryId",this.merchandisingAssociationItems[0].catEntry_Identifier,false,-1);
					this.updateParamObject(params,"quantity",1,false,-1);
				}
			}else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
				return;
			}
			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			//Invoke service to add to the cart.
			wcService.invoke("AjaxAddOrderItem", params);
		}
	},

	/**
	* AddAssociation2ShopCart Adds an associated product to the shopping cart. This function is called by other functions in the FastFinderDisplay.js such as Add2ShopCart().
	*
	* @param {String} associatedItemId The catalog entry ID of the associated item.
	* @param {int} quantity The quantity of the associated item to add.
	*
	**/
	AddAssociation2ShopCart:function(associatedItemId,quantity){

	if (browseOnly){
		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ADD2CART_BROWSE_ONLY_ERROR'));
		return;
	}
	var form = this.merchandisingProductAssociationForm;
	this.merchandisingProductAssociationAddToCart = false;
	if(this.isParentBundleBean){
		// add the individual bundle items to the request.
		var catEntryArray = [];
		catEntryArray = form.catEntryIDS.value.toString().split(",");
		var bundleItemsCount = 1;
		for(var i = 0; i < catEntryArray.length; i++){
			var qty = document.getElementById("quantity_" + catEntryArray[i]).value;
			var catEntryId = catEntryArray[i];
			if(this.selectedProducts[catEntryArray[i]])
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryArray[i]]);
			if(qty==0 || qty == null) qty = 1;
			if(qty!=null && qty !== '' && catEntryId!=null){
				var input1 = document.createElement("input");
				$(input1).attr("id", "OrderItemAddForm_catEntryId_"+catEntryId);
				$(input1).attr("type", "hidden");
				$(input1).attr("name", "catEntryId_"+bundleItemsCount);
				$(input1).attr("value", catEntryId);
				bundleItemsCount = bundleItemsCount + 1;
				form.appendChild(input1);
			}else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU']);
				return;
			}
		}
		var input2 = document.createElement("input");
		$(input2).attr("id", "OrderItemAddForm_catEntryId_"+associatedItemId);
		$(input2).attr("type", "hidden");
		$(input2).attr("name", "catEntryId_"+bundleItemsCount);
		$(input2).attr("value", associatedItemId);
		form.appendChild(input2);
		var quantity1 = document.createElement("input");
		$(quantity1).attr("id", "OrderItemAddForm_quantity_"+associatedItemId);
		$(quantity1).attr("type", "hidden");
		$(quantity1).attr("name", "quantity_"+bundleItemsCount);
		$(quantity1).attr("value", quantity);
		form.appendChild(quantity1);
		form.URL.value = "AjaxOrderItemDisplayView";
		this.isParentBundleBean = false;
	}else{
		form.catEntryId_2.value = associatedItemId;
		form.productId_2.value = associatedItemId;
		form.quantity_2.value = quantity;
	}

	//For Handling multiple clicks
	if(!submitRequest()){
		return;
	}

	// submit the form to add the items to the shop cart.
	processAndSubmitForm(form);
	this.merchandisingProductAssociationForm = "";
	},

	/**
	* Sets the orderID if it is not already set on the Current Order page.
	* The order ID is used to determine which order to act upon such as in the case of replacing an order item in an order.
	*
	* @param {String} orderId The orderID to use.
	*/
	setOrderId : function(orderId) {
		this.orderId = orderId;
	},

	/**
	 * Resolves the SKU and adds the item to a new requisition list.
	 *
	 * @param {String} entitledItemId The catalog entry ID of the item to add to the requisition list.
	 * @param {String} quantityElemId The ID of the Quantity field.
	 * @param {String} currentPage The URL of the current page. When a customer clicks Cancel on the requisition list creation page, they are redirected to the current page.
	 */
	addToNewListFromProductDetail:function (entitledItemId,quantityElemId,currentPage) {
		MessageHelper.hideAndClearMessage();
		var entitledItemJSON;

		if ($("#" + entitledItemId).length) {
			//the json object for entitled items are already in the HTML.
			 entitledItemJSON = eval('('+ $("#" + entitledItemId).html() +')');
		}else{
			//if $("#" + entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
			//in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
			entitledItemJSON = this.getEntitledItemJsonObject();
		}
		this.setEntitledItems(entitledItemJSON);
		var catalogEntryId = this.getCatalogEntryId();
		if(catalogEntryId!=null){
			this.addItemToNewListFromProductDetail(catalogEntryId, quantityElemId, currentPage);
		}
		else{
			MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU_REQ_LIST']);
			//Close the quick info pop-up if it exists
			if($('#second_level_category_popup').length){
				hidePopup('second_level_category_popup');
			}
			return;
		}
	},

	/**
	 * Adds the item to a new requisition list.
	 *
	 * @param {String} catalogEntryId The resolved catalog entry ID of the item to add to the requisition list.
	 * @param {String} quantityElemId The ID of the Quantity field.
	 * @param {String} currentPage The URL of the current page. When a customer clicks Cancel on the requisition list creation page, they are redirected to the current page.
	 */
	addItemToNewListFromProductDetail:function (catalogEntryId,quantityElemId,currentPage) {
		MessageHelper.hideAndClearMessage();
		if(catalogEntryId!=null){
			var quantity = $("#" + quantityElemId).val()
			if (quantity == null || quantity === "" || quantity<=0 || !RequisitionList.isNumber(quantity)) {
				MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
				//Close the quick info pop-up if it exists
				if($('#second_level_category_popup').length){
					hidePopup('second_level_category_popup');
				}
				return;
			}

			var URL = "AjaxLogonForm?page=createrequisitionlist";

			//using the form because the previousPage url can be very long
			var formObj = document.createElement("form");
			$(formObj).attr("method", "POST");

			var input = document.createElement("input");
			$(input).attr("type", "hidden");
			$(input).attr("value", currentPage);
			$(input).attr("name", "previousPage");
			formObj.appendChild(input);

			formObj.action = URL + "&catEntryId="+catalogEntryId +"&quantity="+quantity+ "&storeId=" + this.storeId +"&catalogId=" + this.catalogId + "&langId=" + this.langId;

			document.body.appendChild(formObj); // have to add this form to the body node before submitting.
			processAndSubmitForm(formObj);
		}
		else{
			MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU_REQ_LIST']);
		}
	},

	/**
	 * Adds the bundle to a new requisition list.
	 *
	 * @param {form} form The form that contains all of the inputs for the bundle.
	 * @param {String} currentPage The URL of the current page. When a customer clicks Cancel on the requisition list creation page, they are redirected to the current page.
	 */
	addBundleToNewListFromProductDetail:function (form,currentPage) {
		var productCount = form["numberOfProduct"].value;
		var URL = "AjaxLogonForm?page=createrequisitionlist";

		for(var i = 1; i <= productCount; i++){
			var catEntryId = form["catEntryId_" + i].value;
			if(this.selectedProducts[catEntryId]) {
				catEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[catEntryId]);
			}

			var qty = form["quantity_" + i].value;
			if(qty == null || qty === "" || qty<=0 || !RequisitionList.isNumber(qty)){
				MessageHelper.displayErrorMessage(MessageHelper.messages['QUANTITY_INPUT_ERROR']);
				return;
			} else if(catEntryId!=null){
				URL = URL + "&catEntryId=" + catEntryId + "&quantity=" + qty;
			} else{
				MessageHelper.displayErrorMessage(MessageHelper.messages['ERR_RESOLVING_SKU_REQ_LIST']);
				return;
			}
		}

		var input = document.createElement("input");
		$(input).attr("type", "hidden");
		$(input).attr("value", currentPage);
		$(input).attr("name", "previousPage");
		form.appendChild(input);

		URL = URL +"&numberOfProduct="+form.numberOfProduct.value+ "&storeId=" + this.storeId +"&catalogId=" + this.catalogId + "&langId=" + this.langId;
		form.action=URL;
		processAndSubmitForm(form);
	},

	/**
	* Sets the currentPageType variable.
	* This variable determines the type of catalog pages that are being viewed, such as product or item pages.
	*
	* @param {Boolean} pageType Indicates the type of catalog page viewed by the customer.
	*
	**/
	setCurrentPageType:function(pageType){
		this.currentPageType = pageType;
	},

	/**
	* Sets the currentCatalogEntryId variable.
	* This variable stores the catalogEntryId of the catalog item being viewed.
	*
	* @param {Boolean} catalogEntryId The ID of the new catalog item viewed by the customer.
	*
	**/
	setCurrentCatalogEntryId:function(catalogEntryId){
		this.currentCatalogEntryId = catalogEntryId;
	},

	/**
	 * Submits a category subscription request by invoking the AjaxCategorySubscribe service.
	 *
	 * @param {String} formId The form Id.
	 */
	handleCategorySubscription:function(formId){
		var form = document.forms[formId];
		var params = {
			DM_ReqCmd: form.DM_ReqCmd.value,
			storeId: form.storeId.value,
			catalogId: form.catalogId.value,
			langId: form.langId.value,
			categoryId: form.categoryId.value
		};
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxCategorySubscribe", params);
	}
}
;


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

	/**
	 * @fileOverview This file contains all the global variables and JavaScript functions needed by the compare product page and the compare zone.
	 */

	/**
	 * @class The functions defined in the class are used for comparing products.
	 *
	 * This compareProductJS class defines all the variables and functions for the page that uses the comparison functionality in the store.
	 * The compare zone in the right side bar is a place holder that accepts a maximum of 4 products to compare.
	 * The compare product display page compares various products' attributes side-by-side.
	 *
	 */
	compareProductJS={

		/**
		 * The langId is a string to store the current language identifier of the store.
		 */
		langId: "-1",

		/**
		 * The storeId is a string to store the current store identifier of the store.
		 */
		storeId: "",

		/**
		 * The catalogId is a string to store the current catalog identifier of the store.
		 */
		catalogId: "",

		/**
		* The compareReturnName is a string to store the current name of the category from where the compare link was clicked
		*/
		compareReturnName: "",

		/**
		* The returnUrl is a string to store the url of the category from where the compare link was clicked
		*/
		returnUrl: "",

		/**
		 * The prefix of the cookie key that is used to store item Ids.
		 */
		cookieKeyPrefix: "CompareItems_",

		/**
		 * The delimiter used to separate item Ids in the cookie.
		 */
		cookieDelimiter: ";",

		/**
		 * The maximum number of items allowed in the compare zone.
		 */
		maxNumberProductsAllowedToCompare: 4,


		/**
		 * Sets the common parameters used in all service calls like langId, storeId and catalogId.
		 * @param {String} langId The language Id.
		 * @param {String} storeId The store Id.
		 * @param {String} catalogId The catalog Id.
		 * @param {String} compareReturnName The return page name
		 * @param {String} returnUrl The url of the return page to go back
		 */
		setCommonParameters:function(langId,storeId,catalogId, compareReturnName, returnUrl){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
			this.compareReturnName = compareReturnName;
			this.returnUrl = decodeURIComponent(returnUrl);
		},


		/**
		 * This function clears items in the compare zone.
		 */
		clear: function(){
			MessageHelper.hideAndClearMessage();
			var cookieKey = this.cookieKeyPrefix + this.storeId;
			setCookie(cookieKey, '', {path:'/', domain:cookieDomain});

			$.remove('#compareDropZoneImgDiv');
			if($("#compareDropZoneImg").length){
				$('#compareDropZoneImg').css('display', 'block');
			}

			if($("#compareProductPage").length){
				if($("#compareProductPage").val()){
					var url = "CompareProductsDisplay?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId
						+ "&compareReturnName=" + this.compareReturnName + "&returnUrl=" + encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl));
					document.location.href=appendWcCommonRequestParameters(url);
				}
			}
			MessageHelper.displayStatusMessage(MessageHelper.messages["COMPARE_ITEMS_CLEAR"]);
		},

		/**
		 * Removes an item from the products compare page.
		 * @param {String} key The Id of the item to remove.
		 */
		remove: function(key){
			var cookieKey = this.cookieKeyPrefix + this.storeId;
			var cookieValue = getCookie(cookieKey);
			if(cookieValue != null){
				if($.trim(cookieValue) == ""){
					setCookie(cookieKey, null, {expires: -1});
				}else{
					var cookieArray = cookieValue.split(this.cookieDelimiter);
					var newCookieValue = "";
					for(index in cookieArray){
				if(cookieArray[index] != key){
					if(newCookieValue === ""){
						newCookieValue = cookieArray[index];
					}else{
						newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index]
					}
				}
					}
					setCookie(cookieKey, newCookieValue, {path:'/', domain:cookieDomain});
				}
				this.compareProducts();
			}
		},


		/**
		 * Adds an item to the compare zone.
		 * @param {string} catEntryIdentifier The Id of the catalog entry to add.
		 */
		Add2CompareAjax:function(catEntryIdentifier , dragImagePath , url , dragImageDescription){
			MessageHelper.hideAndClearMessage();
			if($("#compareProductParentId_" + catEntryIdentifier).length && document.getElementById("compareProductParentId_"+catEntryIdentifier)!=undefined){
				catEntryIdentifier = document.getElementById("compareProductParentId_"+catEntryIdentifier).value;
			}
			var cookieKey = this.cookieKeyPrefix + this.storeId;
			var cookieValue = getCookie(cookieKey);

			if(cookieValue != null){
				if(cookieValue.indexOf(catEntryIdentifier) !== -1 || catEntryIdentifier == null){
					MessageHelper.displayErrorMessage(MessageHelper.messages["COMPARE_ITEM_EXISTS"]);
					return;
				}
			}

			var currentNumberOfItemsInCompare = 0;
			if(cookieValue != null && cookieValue !== ""){
				currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
			}

			if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
				var newCookieValue = "";
				if(cookieValue == null || cookieValue === ""){
					newCookieValue = catEntryIdentifier;
				}else{
					newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
				}
				setCookie(cookieKey, newCookieValue, {path:'/', domain:cookieDomain});

				if (0==currentNumberOfItemsInCompare) {
					$('#compareDropZoneImg').css('display', 'none');
					/* Initialize DOM of compare zone */
					$("#compareZone").after("<div id='compareDropZoneImgDiv' style='width:100%'><table><tbody id='compareItemsTable'><tr id='compareRow'></tr></tbody></table></div>");
				}

				if ($("#compareDropZoneImgDiv").length){
					/* Build the inner HTML to display the items in the compare zone. */
					var itemHTML = 	('<td id="compareCatentry'+catEntryIdentifier+'"><div id="compareCatentryContainer'+catEntryIdentifier+'">'+
									'<div id="compare_img_'+catEntryIdentifier+'" class="compare_img">'+
										'<a id="imgcatBrowseCompare_Item_'+catEntryIdentifier+'" href="'+url+'">'+
											'<img height="40" width="40" border="0" alt="'+dragImageDescription+'" title="'+dragImageDescription+'" src="'+dragImagePath+'"></img>\n'+
										"</a></div>"+
									'<div id="compare_info_'+catEntryIdentifier+'" class="compare_info">'+
										'<div id="compare_product_desc_'+catEntryIdentifier+'" class="compare_product_desc">'+
											dragImageDescription+
										"</div></div></div></td>").replace(/\"/g,"'").replace(/\r|\n|\r\n|\n\r/g, "");

					$("#compareRow").after(itemHTML);
				}

				if($("#compareProductPage").length && document.getElementById("compareProductPage") != 'undefined'){
					if($("#compareProductPage").val()){
						this.compareProducts();
					}
				}
				MessageHelper.displayStatusMessage(MessageHelper.messages["COMPAREZONE_ADDED"]);
			} else {
				MessageHelper.displayErrorMessage(MessageHelper.messages["COMPATE_MAX_ITEMS"]);
			}
		},

		/**
		 * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
		 */
		compareProducts:function(){
			var url = "CompareProductsDisplay?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + this.compareReturnName;

			var cookieKey = this.cookieKeyPrefix + this.storeId;
			var cookieValue = getCookie(cookieKey);
			if(Utils.notNullOrWhiteSpace(cookieValue)){
				var cookieArray = cookieValue.split(this.cookieDelimiter);
				for(index in cookieArray){
					url = url + "&catentryId=" + cookieArray[index];
				}
			}
			url = appendWcCommonRequestParameters(url) + "&returnUrl=" + encodeURIComponent(appendWcCommonRequestParameters(this.returnUrl));
			document.location.href = getAbsoluteURL() + url;
		},



		/**
		 * Initializes the compare zone as a drop target and loads the product images for all the products in the compare zone.
		 */
		init:function(){

			 wcTopic.subscribe("/dnd/drop", function(source, nodes, copy, target){
				if (source != target) {
					target.deleteSelectedNodes();
				}
				var productDisplayPath="";
				var imgPath="";
				var imgDescription="";
				var sourceId = source.parent.id;

				if(target.parent.id=='compareZone'){
					if(getCookie('coShoppingDisableDnd')!=undefined && getCookie('coShoppingDisableDnd') == 'true') {
						wcTopic.publish("/wc/collaboration/dndDisabled",[]);

						return;
					}

	  			    var indexOfIdentifier = sourceId.indexOf("_",0);
	                if ( indexOfIdentifier >= 0) {
				        /* remove the prefix including the "underscore". */
					   sourceId = sourceId.substring(indexOfIdentifier+1);
	                }
					if($("#compareImgPath_" + sourceId).length && document.getElementById("compareImgPath_"+sourceId)!=undefined){
						imgPath = document.getElementById("compareImgPath_"+sourceId).value;
					}
	                if($("#compareProductDetailsPath_" + sourceId).length && document.getElementById("compareProductDetailsPath_"+sourceId)!=undefined){
						productDisplayPath=document.getElementById("compareProductDetailsPath_"+sourceId).value;
					}
	                if($("#compareImgDescription_" + sourceId).length && document.getElementById("compareImgDescription_"+sourceId)!=undefined){
						imgDescription = document.getElementById("compareImgDescription_"+sourceId).value;
	                }
					if($("#compareProductParentId_" + sourceId).length && document.getElementById("compareProductParentId_"+sourceId)!=undefined){
							sourceId = document.getElementById("compareProductParentId_"+sourceId).value;
					}
	                compareProductJS.Add2CompareAjax(sourceId,imgPath,productDisplayPath,imgDescription);
				}
			});
			var cookieKey = this.cookieKeyPrefix + this.storeId;
			var cookieValue = getCookie(cookieKey);
		}
	}

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides utility functions for the order check-out pages.
 */

/**
 * The functions defined in this class are used for managing order information update during check-out.
 *
 * @class This CheckoutHelperJS class defines all the variables and functions for the page(s) used in the check-out process to udpate order related information, such as address, shipping method, shipping instruction, etc.
 *
 */

CheckoutHelperJS = {

    /* Global variable declarations */

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */

    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of the order, in case the current shopping cart is not being used. Its default value is empty.
     */
    orderId: "",

    /**
     * This variable stores the shipment type, either 1 for single shipment or 2 for multiple shipment. Its default value is set to empty.
     * @private
     */
    shipmentTypeId: "",


    /**
     * This array stores the item IDs in an order. It is used to save the item IDs before an address is edited or created during the order check-out.
     * @private
     */
    orderItemIds: [],

    /**
     * This constant stores the amount of time in milliseconds that the <code>updateCartWait</code> function needs to wait before updating the shopping cart.
     * @private
     * @constant
     * @see CheckoutHelperJS.updateCartWait
     */
    updateWaitTimeOut: 1500,

    /**
     * This array stores the number of key press events after a shopper has modified the quantity of an item in the shopping cart.
     * @private
     * @see CheckoutHelperJS.updateCartWait
     */
    keyPressCount: {},

    /**
     * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
     * be a two step process where shipping is captured in first step and billing in second step.
     * It is set to true by default.
     *
     * @private
     */
    singlePageCheckout: true,

    /**
     * This array stores the address ID before it is updated by the user during the order check-out.
     * @private
     */
    selectedAddressesArray: {},

    /**
     * This array stores the values that indicate if the payment method input in a payment area has been changed by the user.
     *
     * @private
     */
    dataDirty: {},

    /**
     * This variable stores a value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     * Its default value is set to false.
     *
     * @private
     */
    fieldDirtyFlag: false,

    /**
     * This constant stores the String value representing a date that the service understands to reset a requested shipping date.
     * @private
     * @constant
     */
    resetRequestedShipDateValue: "1970-01-01T00:00:00.000Z",

    /**
     * This variable stores the value that indicates if the current page is the Shopping Cart page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    shoppingCartPage: false,

    /**
     * This variable stores the value that indicates if the current page is the pending order details page. It is used to determine what page to redirect to after a service call has been successfully performed.
     *
     * @private
     */
    pendingOrderDetailsPage: false,

    /**
     * This variable stores the value that indicates if the requested shipping date has recently been updated. It is used to determine if certain area of the page needs to be refreshed.
     */
    RequestShippingDateAction: false,

    /**
     * Indicates whether the ShippingChargeType flexflow is enabled.
     */
    shipChargeEnabled: false,

    /**
     * The order ID.
     */
    tempOrderId: "",
    /**
     * The type of the current user.
     */
    tempUserType: "",
    /**
     * The list of emails spearated by space. Order confirmation will be sent to these emails.
     */
    tempEmailAddresses: "",
    /**
     * Indicates whether it is a Quote that is being checked out.
     */
    tempIsQuote: false,

    /**
     * The current order total.
     */
    tempOrderTotal: "0",

    /**
     * The payment instructions allocated in the order.
     */
    tempPaymentInstructions: {},
    lastAddressLinkIdToFocus: "",
    lastFocusId: "",
    setLastFocus: function (id) {
        this.lastFocusId = id;
    },
    getLastFocus: function () {
        return this.lastFocusId;
    },
    tabPressed: function (event) {
        if (event.keyCode == 9) {
            tabPressed = true;
        }
    },
    setLastAddressLinkIdToFocus: function (lastLinkId) {
        this.lastAddressLinkIdToFocus = lastLinkId;
    },
    getLastAddressLinkIdToFocus: function () {
        return this.lastAddressLinkIdToFocus;
    },

    /**
     * Indicates whether the order is prepared already or not.
     */
    orderPrepared: "false",

    /**
     * Sets the orderPrepared variable to indicate whether the order has been through the OrderPrepare command or not. An order must be prepared before it can be submitted.
     *
     * @param {Boolean} inPrepareIndicator Whether or not the order has been prepared.
     */
    setOrderPrepared: function (inPrepareIndicator) {
        this.orderPrepared = inPrepareIndicator;
    },

    /**
     * Returns whether or not the order is prepared.
     */
    isOrderPrepared: function () {
        return this.orderPrepared;
    },

    /**
     * Save some variables needed for re-calling checkoutOrder method after a service call.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails spearated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    saveCheckoutOrderParameters: function (orderId, userType, addressListForMailNotification, isQuote) {
        this.tempOrderId = orderId;
        this.tempUserType = userType;
        this.tempEmailAddresses = addressListForMailNotification;
        this.tempIsQuote = isQuote;
    },

    /**
     * Sets some internal variables needed for verifying order totals.
     *
     * @param {Object} orderTotal The current order total.
     * @param {Object} paymentInstructions The currently allocated payment instructions for the order.
     */
    setOrderPayments: function (orderTotal, paymentInstructions) {
        this.tempOrderTotal = orderTotal + 0;
        this.tempPaymentInstructions = paymentInstructions;
    },

    /**
     * Returns whether or not the order total amount has been fully allocated with payment instructions.
     */
    isOrderPaymentFullyAllocated: function () {
        var allocatedAmount = 0;
        if (this.tempPaymentInstructions.paymentInstruction != null && this.tempPaymentInstructions.paymentInstruction.length >= 1) {
            for (var i = 0; i < this.tempPaymentInstructions.paymentInstruction.length; i++) {
                allocatedAmount = allocatedAmount + parseFloat(this.tempPaymentInstructions.paymentInstruction[i].piAmount);
            }
        }

        if (allocatedAmount == this.tempOrderTotal) {
            return true;
        } else {
            var roundedAllocatedAmount = allocatedAmount.toFixed(2);
            var roundedTempOrderTotal = this.tempOrderTotal.toFixed(2);
            if (roundedAllocatedAmount == roundedTempOrderTotal) {
                return true;
            } else {
                if (allocatedAmount < this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_CANNOT_RECONCILE_PAYMENT_AMT"]);
                    return false;
                } else if (allocatedAmount > this.tempOrderTotal) {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_LARGER_THAN_ORDER_AMOUNT"]);
                    return false;
                } else {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["EDPPaymentMethods_PAYMENT_AMOUNT_PROBLEM"]);
                    return false;
                }
            }
        }
    },

    /**
     * Returns the value of the internal variable with that name.
     *
     * @param {Object} paramName The value of the internal parameter.
     */
    getSavedParameter: function (paramName) {
        return this[paramName];
    },

    /**
     * Sets the ShipChargeEnabled variable to indicate whether the ShippingChargeType feature is enabled.
     *
     * @param {Boolean} enabled This parameter is set to true if the ShippingChargeType feature is enabled.
     */
    setShipChargeEnabled: function (enabled) {
        this.shipChargeEnabled = enabled;
    },

    /**
     * This function updates the input associative array params with the input key-value pair.
     * If the toArray value is true, this function creates an associative array for duplicate entries; otherwise it overwrites the existing array.
     * The function is used for updating input parameters before passing them to a service call.
     *
     * @param {Array} params The associative array to update.
     * @param {String} key The key to search for in the array.
     * @param {String} value The new value to update with when the key has been found in the array.
     * @param {Boolean} toArray If the value is true, then the function creates a new array for duplicate entries. If the value is false, no new array will be created, the existing array will be overwritten.
     * @param {Integer} index The index in the array in which the value should be updated.
     *
     * @returns {Array} params The updated associative array.
     */
    updateParamObject: function (params, key, value, toArray, index) {
        if (params == null) {
            params = [];
        }

        if (params[key] != null && toArray) {
            if ($.isArrayLike(params[key])) {
                //3rd time onwards
                if (index != null && index != "") {
                    //overwrite the old value at specified index
                    params[key][index] = value;
                } else {
                    params[key].push(value);
                }
            } else {
                //2nd time
                var tmpValue = params[key];
                params[key] = [];
                params[key].push(tmpValue);
                params[key].push(value);
            }
        } else {
            //1st time
            if (index != null && index != "" && index != -1) {
                //overwrite the old value at specified index
                params[key + "_" + index] = value;
            } else if (index == -1) {
                var i = 1;
                while (params[key + "_" + i] != null) {
                    i++;
                }
                params[key + "_" + i] = value;
            } else {
                params[key] = value;
            }
        }
        return params;
    },


    /**
     * This function shows or hides the request shipping date input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderItemAddressShipMethodUpdate</code> service will be called to update the shipping information.
     *
     * @param {String} checkBoxName The ID of the request shipping date checkbox.
     * @param {String} divName The name of the div element that contains the request shipping date input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkRequestShippingDateBox: function (checkBoxName, divName, suffix) {
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            checkBoxName = checkBoxName + "_" + suffix;
            divName = divName + "_" + suffix;
        }

        var checkBox = $("#" + checkBoxName)[0];

        if (checkBox.checked) {
            $("#" + divName).css("visibility", "visible");
            $("#" + divName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + divName).css("visibility", "hidden");
            $("#" + divName).css("display", "none");
            if (this.shipmentTypeId == "1") {
                $("#requestedShippingDate").blur();
            } else if (this.shipmentTypeId == "2") {
                $("#MS_requestedShippingDate_" + suffix).blur();
            }
        }

        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete the requestedShippingDate if the checkBox is unchecked
        if (!checkBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            this.updateParamObject(params, "addressId", addressId, false, -1);
            this.updateParamObject(params, "shipModeId", shipModeId, false, -1);

           if($("#requestedShippingDate") != null || $("#MS_requestedShippingDate_" + suffix) != null){
				if(this.shipmentTypeId == "1") {
					params["requestedShipDate"] = this.resetRequestedShipDateValue;
				} else {
					this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false, -1);
				}
			}

            var orderItemId = null;
            var qty = -1;
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null) {
                    qty = document.getElementById("qty_" + (i + 1)).value;
                }
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                // we need atleast one orderItemId..this is the limitation of order service..
                if (qty != -1) {
                    if (this.shipmentTypeId == "1") {
                        // Single Shipment
                        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                        break;
                    } else if (this.shipmentTypeId == "2") {
                        // Multiple Shipment
                        if (suffix != null && suffix != "" && orderItemId == suffix) {
                            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                            break;
                        }
                    } else {
                        console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
                    }
                }
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            CheckoutHelperJS.RequestShippingDateAction = true;
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        }
    },


    /**
     * This function shows or hides the shipping instruction input field depending on the state of the corresponding checkbox.
     * If the checkbox is unchecked, the <code>OrderShippingInfoUpdate</code> service will be called to update the shipping information.
     * Note that order items that have the same ship-to address and shipping method will share the same shipping instruction.
     *
     * @param {String} checkBoxName The ID of the shipping instruction checkbox.
     * @param {String} divName The name of the div element that contains the shipping instruction input field.
     * @param {String} suffix The suffix that is appended after the divName. It is usually the order item ID.
     */
    checkShippingInstructionsBox: function (checkBoxName, divName, suffix) {
        //var divName = "shippingInstructionsDiv";
        var thisCheckBoxName;
        var thisDivName;

        if (suffix != null && suffix != "") {
            thisCheckBoxName = checkBoxName + "_" + suffix;
            thisDivName = divName + "_" + suffix;
        } else {
            thisCheckBoxName = checkBoxName;
            thisDivName = divName;
        }

        var thisCheckBox = $("#" + thisCheckBoxName)[0];

        if (thisCheckBox.checked) {
            $("#" + thisDivName).css("visibility", "visible");
            $("#" + thisDivName).css("display", "block");
        } else {
            // If the checkbox is unchecked, hide the input field
            $("#" + thisDivName).css("visibility", "hidden");
            $("#" + thisDivName).css("display", "none");
        }

        // Update other shipping instructions div with same addressId and shipModeId..
        var addressId, shipModeId = "";
        if (this.shipmentTypeId == "1") {
            addressId = document.getElementById("singleShipmentAddress").value;
            shipModeId = document.getElementById("singleShipmentShippingMode").value;
        } else if (this.shipmentTypeId == "2") {
            var orderItemId, tempAddressId, tempShipModeId = "";

            //get current div's shipModeId and addressId..
            addressId = document.getElementById("MS_ShipmentAddress_" + suffix).value;
            shipModeId = document.getElementById("MS_ShippingMode_" + suffix).value;

            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 0; i < totalItems; i++) {
                if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                    orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                    tempAddressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    tempShipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                    if (tempShipModeId == shipModeId && tempAddressId == addressId) {
                        var tempDivName = divName + "_" + orderItemId;
                        var tempCheckBoxName = checkBoxName + "_" + orderItemId;
                        if (thisCheckBox.checked) {
                            $(tempDivName).css("visibility", "visible");
                            $(tempDivName).css("display", "block");
                            $(tempCheckBoxName).attr("checked", "checked");
			    }
                        else {
                            //User doesnt want to specify shipping instructions and requested ship date..hide this div..
                            $("#" + tempDivName).css("visibility", "hidden");
                            $("#" + tempDivName).css("display", "none");
                            $("#" + tempCheckBoxName).attr("checked", "");
                        }
                    }
                }
            }
        } else {
            console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
        }

        // Delete shippingInstructions if the checkBox is unchecked
        if (!thisCheckBox.checked) {
            var params = [];
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params.orderId = ".";

            var orderItemId = null;
            if (this.shipmentTypeId == "1") {
                if (document.getElementById("shipInstructions") != null) {
                    this.updateParamObject(params, "shipInstructions", "", false);
                    document.getElementById("shipInstructions").value = "";
                }
                orderItemId = document.getElementById("orderItem_1").value;
                this.updateParamObject(params, "addressId", addressId, false);
                this.updateParamObject(params, "orderItemId", orderItemId, false);

            } else if (this.shipmentTypeId == "2") {
                if (suffix != null && suffix != "") {
                    if (document.getElementById("MS_shipInstructions_" + suffix) != null) {
                        this.updateParamObject(params, "shipInstructions", "", false);
                        document.getElementById("MS_shipInstructions_" + suffix).value = "";
                    }
                    this.updateParamObject(params, "addressId", addressId, false, -1);
                    this.updateParamObject(params, "orderItemId", suffix, false);
                    this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, "");
                }
            } else {
                console.debug("shipmentTypeId is undefined. Single shipment has Id 1; multiple shipment has Id 2.");
            }

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();
            wcService.invoke("OrderShippingInfoUpdate", params);
        }
    },


    /**
     * This function sets the shipment type for the current page.
     *
     * @param {Integer} shipmentTypeId The shipment type ID, 1 for single shipment or 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.getShipmentTypeId
     */
    initializeShipmentPage: function (shipmentTypeId) {
        this.shipmentTypeId = shipmentTypeId;
    },


    /**
     * This function sets the common parameters for the current page, i.e. language ID, store ID and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    },


    /**
     * This function deletes an order item from the shopping cart.
     * If forWishlist is true, then the item is added to the wish list subsequently by calling the <code>AjaxDeleteOrderItemFromCart</code> service.
     *
     * @param {Integer} orderItemId The ID of the order item to delete.
     * @param {Boolean} forWishlist If the value is true, then the item is added to the wish list.
     */
    deleteFromCart: function (orderItemId, forWishlist) {
        var params = [];
        params.storeId = this.storeId;
        params.catalogId = this.catalogId;
        params.langId = this.langId;
        params.orderId = (this.orderId != null && this.orderId != 'undefined' && this.orderId != "") ? this.orderId : ".";
        params.orderItemId = orderItemId;
        if (this.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }
        params.check = "*n";
        params.calculateOrder = "1";

        var x = document.getElementById("totalNumberOfItems").value;
        var y = x;
        //Now remove free items from this total number of items count..
        //x = total items and y = totalItems - totalFreeItems
        for (var i = 0; i < x; i++) {
            var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
            if (qtyObj != null || qtyObj != undefined) {
                qty = qtyObj.value;
                if (qty != null && qty != undefined && qty == -1) {
                    y = y - 1;
                }
            }

        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if (y == 1) {
            wcService.invoke("AjaxDeleteOrderItem1", params);
        } else {
            if (forWishlist) {
                wcService.invoke("AjaxDeleteOrderItemFromCart", params);
            } else {
                if (this.shoppingCartPage || this.pendingOrderDetailsPage) {
                    wcService.invoke("AjaxDeleteOrderItem", params);
                } else {
                    wcService.invoke("AjaxDeleteOrderItemForShippingBillingPage", params);
                }
            }
        }
    },


    /**
     * This function is used to update the ship-to address ID of all items in the current order when the user chooses to add a new address during order check-out.
     * This function calls the <code>AjaxUpdateOrderItemsAddressId</code> service.
     *
     * @param {Integer} addressId The ID of the newly created address.
     */
    updateAddressIdOFItemsOnCreateEditAddress: function (addressId) {
        if (this.shipmentTypeId == "2" && this.orderItemIds.length == 0) {
            // If this is multiple shipment and none of the orderItems addressId is same as modified addressId, then no need make a service call.
            return;
        }
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        if (this.shipmentTypeId == "1") {
            params.addressId = addressId;
        } else {
            var orderItemId = null;
            for (var i = 0; i < this.orderItemIds.length; i++) {
                orderItemId = this.orderItemIds[i];
                this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
                this.updateParamObject(params, "addressId", addressId, false, -1);
            }
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxUpdateOrderItemsAddressId", params);
    },


    /**
     * This function is used to save the current order items list when the user edits an existing address or creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressId The ID of the address.
     *
     * @private
     */
    saveOrderItemsList: function (orderItemId, addressId) {
        if (orderItemId == '-1') {
            //Creating or editing shipping address for single shipment, get all the orderItemIds in the order..

            var totalItems = document.getElementById("totalNumberOfItems").value;
            // if order item section is collapsed, we only have data for the first order item. And this is the case for single shipment so it
            // is ok just to update orderItem_1
            this.orderItemIds[0] = document.getElementById("orderItem_1").value;

        } else if (orderItemId == 0 && this.shipmentTypeId == "1") {
            // Editing or creating billing address.. If it's single shipment type, then we need to save all orderItem Id's.
            // If the shipping address is same as this billing address which is edited, then after editing this addressId will change, so we need to update the orderItemIds.

            if (document.getElementById("singleShipmentAddress")) {
                if (addressId == document.getElementById("singleShipmentAddress").value) {
                    var totalItems = document.getElementById("totalNumberOfItems").value;
                    for (var i = 0; i < totalItems; i++) {
                        this.orderItemIds[i] = document.getElementById("orderItem_" + (i + 1)).value;
                    }
                } else {
                    this.orderItemIds = [];
                }
            } else {
                this.orderItemIds = [];
            }
            return;
        } else {
            // OrderItemId is passed..so it's multiple shipment, get all the orderItemIds with the same address...
            // This section is for multiple shipment and create/edit both shipping/billing address...
            var totalItems = document.getElementById("totalNumberOfItems").value;
            var temp = null;
            var orderItemId = null;
            var j = 0;

            //saving orderItemIds (used by this.updateAddressIdOFItemsOnCreateEditAddress) for  the'edit address' link
            for (var i = 0; i < totalItems; i++) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                if (document.getElementById("MS_ShipmentAddress_" + orderItemId)) {
                    temp = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                    //addressId is -1 if 'create address' is clicked. The following if will always return false in that case.
                    if (temp == addressId) {
                        //Add this to our list..
                        this.orderItemIds[j++] = orderItemId;
                    }
                }
            }
        }
    },


    /**
     * By convention, all items in an order that have the same shipping address and shipping mode share the same shipping instruction.
     * This function is used to update the shipping instruction of all items that have the same shipping address and shipping mode.
     *
     * @param {Integer} addressId The shipping address ID.
     * @param {Integer} shipModeId The shipping mode ID.
     * @param {String} shipInstructions The shipping instruction.
     */
    setShippingInstuctionsForAllOtherItems: function (addressId, shipModeId, shipInstructions) {

        var orderItemId, addressId1, shipModeId1 = "";
        var totalItems = document.getElementById("totalNumberOfItems").value;
        for (var i = 0; i < totalItems; i++) {
            if (document.getElementById("qty_" + (i + 1)) != null && document.getElementById("qty_" + (i + 1)).value != -1) {
                orderItemId = document.getElementById("orderItem_" + (i + 1)).value;
                addressId1 = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
                shipModeId1 = document.getElementById("MS_ShippingMode_" + orderItemId).value;
                if (shipModeId1 == shipModeId && addressId1 == addressId) {
                    document.getElementById("MS_shipInstructions_" + orderItemId).value = shipInstructions;
                }
            }
        }
    },


    /**
     * When a user toggles the 'ship as complete' checkbox, the same will be updated at the server side by invoking the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} checkBox The 'ship as complete' checkbox object.
     */
    shipAsComplete: function (checkBox) {
        var params = [];
        params.orderId = ".";
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        if (checkBox.checked) {
            this.updateParamObject(params, "ShipAsComplete", "true", true);
        } else {
            this.updateParamObject(params, "ShipAsComplete", "false", true);
        }
        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * When there is an invalid address ID in an order, this function updates all items to use the valid address ID by invoking the <code>AjaxSetAddressIdOfOrderItems</code> service.
     *
     * @param {Integer} addressId A valid address ID.
     */
    updateAddressIdForOrderItem: function (addressId) {
        if (addressId == null || addressId.length == 0) {
            return true;
        }

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false);
        wcService.invoke("AjaxSetAddressIdOfOrderItems", params);
    },


    /**
     * When there is an invalid shipping mode ID in an order, this function updates all items to use the valid shipping mode ID by invoking the <code>AjaxSetShipModeIdForOrder</code> service.
     *
     * @param {Integer} shipModeId A valid shipping mode ID.
     */
    updateShipModeIdForOrder: function (shipModeId) {
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["shipModeId"] = shipModeId;
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        wcService.invoke("AjaxSetShipModeIdForOrder", params);
    },

    /**
     * When there is an inconsistent requested ship date in an order when multiple shipment is disabled,
     * this function updates all items to use the the same date by invoking the <code>AjaxSetRequestedShipDateForOrder</code> service.
     *
     * @param {String} date The String representation of the requested ship date
     */
    updateRequestedShipDateForOrder: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        if (date != "") {
            this.updateParamObject(params, "requestedShipDate", date, false);
        } else {
            this.updateParamObject(params, "requestedShipDate", this.resetRequestedShipDateValue, false);
        }

        wcService.invoke("AjaxSetRequestedShipDateForOrder", params);
    },



    /**
     * This function is used to apply a promotion code to the order.
     *
     * @param {String} formName	The name of the promotion code entry form.
     * @param {String} returnView	The name of the view that the server should redirect the browser to after a promotion code is applied.
     */
    applyPromotionCode: function (formName, orderId) {
        var form = document.forms[formName];

        if (trim(form.promoCode.value) == "") {
            MessageHelper.formErrorHandleClient(form.promoCode.id, MessageHelper.messages["PROMOTION_CODE_EMPTY"]);
            return;
        }

		service = wcService.getServiceById('AjaxPromotionCodeManage');

		var params = [];
		params["taskType"] = "A";
		params["promoCode"] = trim(form.promoCode.value);
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;
		params["orderId"] = orderId;

		//For handling multiple clicks
		if (!submitRequest()) {
			return;
		}
		cursor_wait();
		wcService.invoke('AjaxPromotionCodeManage', params);

    },


    /**
     * This function is used to remove a promotion code from the order.
     *
     * @param {String} promoCode	The promotion code to remove.
     */
    removePromotionCode: function (promoCode, orderId) {

		var params = [];
		params["taskType"] = "R";
		params["promoCode"] = promoCode;
		params["storeId"] = WCParamJS.storeId;
		params["catalogId"] = WCParamJS.catalogId;
		params["langId"] = WCParamJS.langId;
		params["orderId"] = orderId;

	   //For handling multiple clicks
		if (!submitRequest()) {
			return;
		}
		cursor_wait();
		wcService.invoke('AjaxPromotionCodeDelete',params);

    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has not been applied to an order then this function can be used to apply that coupon to the current order.
     *
     * @param {String} formName The name of the form that performs the action to apply the coupon, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    applyCoupon: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "A";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsAdd');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsAdd');
    },


    /**
     * If a customer has a coupon in his/her coupon wallet that has been applied to an order then this function can be used to remove that coupon from the current order.
     *
     * @param {String} formName The name of the form that performs the action to remove the coupon from the order, and holds the parameters to pass to the service.
     * @param {String} returnView The view to return to after the request has been processed.
     * @param {Integer} couponId The unique ID of the coupon. This is set into the form to be sent to the service.
     */
    removeCouponFromOrder: function (formName, returnView, couponId) {
        var form = document.forms[formName];
        form.setAttribute('action', 'CouponsAddRemove');
        form.couponId.value = couponId;
        form.taskType.value = "R";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        service = wcService.getServiceById('AjaxCouponsRemove');
        service.setFormId(formName);
        cursor_wait();
        wcService.invoke('AjaxCouponsRemove');
    },


    /**
     * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
     *
     * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
     *
     * @see CheckoutHelperJS.isSinglePageCheckout
     */
    setSinglePageCheckout: function (singlePageCheckout) {
        this.singlePageCheckout = singlePageCheckout;
    },


    /**
     * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
     *
     * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
     * enabled/disabled.
     *
     * @see CheckoutHelperJS.setSinglePageCheckout
     */
    isSinglePageCheckout: function () {
        return this.singlePageCheckout;
    },


    /**
     * This function is used to submit the order by invoking the <code>AjaxSubmitOrder</code> service.
     *
     * @param {Integer} orderId The order ID.
     * @param {String} userType The type of the current user.
     * @param {String} addressListForMailNotification The list of emails separated by space. Order confirmation will be sent to these emails.
     * @param {boolean} isQuote Optional parameter which indicates whether it is a Quote that is being checked out. If this parameter is not passed then it defaults to false.
     */
    checkoutOrder: function (orderId, userType, addressListForMailNotification, isQuote) {
        if (isQuote == undefined || isQuote == null) {
            isQuote = false;
        }

        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }

        if (this.isOrderPrepared() == "false") {
            this.saveCheckoutOrderParameters(orderId, userType, addressListForMailNotification, isQuote);
            wcService.invoke("AjaxPrepareOrderForSubmit");
            return;
        }

        params = [];
        params["orderId"] = orderId;
        params["notifyMerchant"] = 1;
        params["notifyShopper"] = 1;
        params["notifyOrderSubmitted"] = 1;
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

	var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
		}
            else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
        }
        params["purchaseorder_id"] = purchaseOrderNumber;
        if (userType == 'G') {
            //addressListForMailNotification contains list of emailId's spearated by space.. remove leading or trailing spaces..
            addressListForMailNotification = trim(addressListForMailNotification);

            //Get the space separated email list in an array...
            var emailList = [];
            emailList = addressListForMailNotification.split(" ");

            //Now from this array, remove repeated email Id's.. keep only unique email Id's
            var uniqueList = [];
            for (var j = 0; j < emailList.length; j++) {
                uniqueList[emailList[j]] = emailList[j];
            }

            //Get the total length of unique email id's list..
            var totalLength = 0;
            for (i in uniqueList) {
                totalLength = totalLength + 1;
            }

            //Convert the unique List array into comma separated values...
            var temp = "";
            var k = 0;
            for (i in uniqueList) {
                k = k + 1;
                temp = temp + uniqueList[i];
                if (k < totalLength) {
                    //If not last value, add , before next value..
                    temp = temp + ",";
                }
            }
            //For guest user send the email list..
            params["notify_EMailSender_recipient"] = temp;

            //setup sms phone for service
            var smsOrderNotificationCheckbox = document.getElementById("sendMeSMSNotification");
            if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
                if (smsOrderNotificationCheckbox.checked) {
                    var mobileCountryCode = document.getElementById("mobileCountryCode");
                    var mobilePhone1 = document.getElementById("mobilePhone1");
                    if (mobileCountryCode != null && mobileCountryCode != "undefined" && mobilePhone1 != null && mobilePhone1 != "undefined") {
                        params["SMS"] = mobileCountryCode.value + mobilePhone1.value;
                    }
                }
            }
        }


        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        if (!isQuote) {
            wcService.invoke("AjaxSubmitOrder", params);
        } else {
            params["URL"] = "";
            this.setOrderId(orderId);
            wcService.invoke("AjaxSubmitQuote", params);
        }
    },


    /**
     * Validates the scheduled start date and sets the cookies that are used to retrieve the start date and interval of a scheduled order.
     */
    prepareOrderSchedule: function () {
        if (document.getElementById("scheduleOrderInputSection") != null) {
            var scheduleOrderStartDateObj = $("#ScheduleOrderStartDate")[0];
            if (!this.validateDate(scheduleOrderStartDateObj, 'ScheduleOrderStartDate')) {
                return;
            }

            var interval = $("#ScheduleOrderFrequency").val();

            var key1 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_strStartDate";
            var key2 = "WC_ScheduleOrder_" + document.getElementById("orderIdToSchedule").value + "_interval";

            if ((interval == "undefined") && (scheduleOrderStartDateObj.value == null)) {
                // if the order interval is '' and the specified start date is empty, remove the cookies
               	setCookie(key1, null, {expires: -1});
               	setCookie(key2, null, {expires: -1});
            } else {
                var t = $(scheduleOrderStartDateObj).datepicker("getDate");
                var now = new Date();

                t.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

                // set start date in zulu time
                t = t.toISOString();
                setCookie(key1, t, {
                    path: "/",
                    domain: cookieDomain
                });
                setCookie(key2, interval, {
                    path: "/",
                    domain: cookieDomain
                });
            }
        }
    },


    /**
     * Schedules an order.
     *
     * @param {Integer} orderId The order ID of the scheduled order.
     * @param {String} isRecurring The flag to identify a recurring order.
     * @param {String} userType The type of the user.
     */
    scheduleOrder: function (orderId, isRecurring, userType) {
        if (!this.isOrderPaymentFullyAllocated()) {
            return;
        }
        if (userType === "G" && isRecurring) {
            MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
            return;
        }
        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["orderId"] = orderId;

	var authToken = $("#PaymentsAndBill_authToken").val();
        params["authToken"] = authToken;
        if (isRecurring != undefined && isRecurring == true) {
            params["startDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '1') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
                params["timePeriod"] = '1';
                params["timePeriodUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '2') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'DAY';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '3') {
                params["fulfillmentInterval"] = '1';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '4') {
                params["fulfillmentInterval"] = '2';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '5') {
                params["fulfillmentInterval"] = '3';
                params["fulfillmentIntervalUOM"] = 'WEE';
            } else if (getCookie("WC_ScheduleOrder_" + orderId + "_interval") == '6') {
                params["fulfillmentInterval"] = '4';
                params["fulfillmentIntervalUOM"] = 'WEE';
            }
		}
         else {
            params["strStartDate"] = getCookie("WC_ScheduleOrder_" + orderId + "_strStartDate");
            params["interval"] = getCookie("WC_ScheduleOrder_" + orderId + "_interval");
        }


        var purchaseOrderForm = document.forms["purchaseOrderNumberInfo"];
        if (purchaseOrderForm) {
            var purchaseOrderNumber = purchaseOrderForm.purchase_order_number.value;
            if (purchaseOrderForm.purchaseOrderNumberRequired.value == 'true' && purchaseOrderForm.purchase_order_number.value == "") {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberEmpty"]);
                return;
            } else if (!MessageHelper.isValidUTF8length(purchaseOrderForm.purchase_order_number.value, 128)) {
                MessageHelper.formErrorHandleClient(purchaseOrderForm.purchase_order_number, MessageHelper.messages["ERROR_PONumberTooLong"]);
                return;
            }
            params["purchaseorder_id"] = purchaseOrderNumber;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if (isRecurring != undefined && isRecurring == true) {
            wcService.invoke("SubmitRecurringOrder", params);
        } else {
            wcService.invoke("ScheduleOrder", params);
        }
    },


    /**
     * Checks if a date occurred in the past.
     *
     * @param {Object} dateObj The date object to be validated.
     * @param {String} elementId The ID of the element that an error message would be attached to.
     */
    validateDate: function (dateObj, elementId) {
        var now = new Date();
        if ($(dateObj).datepicker("getDate") != null && ($(dateObj).datepicker("getDate") - now < 0)) {
            //if the date is the current date, then it is valid
            if (now.toDateString() === $(dateObj).datepicker("getDate").toDateString()) {
                return true;
            }

            if ((elementId != null) && (document.getElementById(elementId) != null)) {
                MessageHelper.formErrorHandleClient(document.getElementById(elementId).id, MessageHelper.messages["PAST_DATE_ERROR"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["PAST_DATE_ERROR"]);
            }
            return false;
        } else {
            return true;
        }
    },

    /**
     * Creates a new address during order check-out.
     *
     * @param {Integer} orderItemId The order item ID for a multiple shipment scenario, or 0 to indicate a shipping address needs to be created, or 1 to indicate a billing address needs to be created.
     * @param {String} addressType The type of the address to be created.
     */
    createAddress: function (orderItemId, addressType) {
        this.saveOrderItemsList(orderItemId, "-1");

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        var checkForOpera = true; //require a check of whether the browser is opera or not
        cursor_wait(checkForOpera);
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used to show an area and hide an area on the current page.
     *
     * @param {String} showArea The ID of the area to show.
     * @param {String} hideArea The ID of the area to hide.
     *
     * @private
     */
    showHideDivs: function (showArea, hideArea) {
        document.getElementById(hideArea).style.display = "none";
        document.getElementById(showArea).style.display = "block";
    },


    /**
     * Restores the previous address details when a user cancels editing an existing address or cancels creating a new address.
     *
     * @see CheckoutHelperJS.cancelEditAddress
     */
    restorePreviousAddressDetails: function () {

        //For Ajax flow when the previous shipping address is not available in the array
        //Save the addresses present on server side only.. on change of address the server will be updated in ajax checkout..so can use
        //the address from server side only..
        if (this.shipmentTypeId == "2") {
            for (var i = 0; i < this.orderItemIds.length; i++) {
                //Get the orderItemId
                var orderItemId = this.orderItemIds[i];
                var element = document.getElementById("MS_ShipmentAddress_" + orderItemId);

                if (element != null && element.value == -1) {
                    //IF createAddress is selected in this box, then restore it to previously selected value..
                    element.value = document.getElementById("addressId_" + orderItemId).value;
                }
            }
        } else if (this.shipmentTypeId == "1") {
            var element = document.getElementById("singleShipmentAddress");
            if (element != null && document.getElementById("addressId_all")) {
                element.value = document.getElementById("addressId_all").value;
            }
        }

        //Restore the original billing address(es) that was updated on the server
        for (var i = 1; i < 4; i++) {
            //Find the payment forms that are present on the page
            if (document.getElementById("PaymentForm" + i) != null) {
                var paymentForm = document.getElementById("PaymentForm" + i);
                //Restore the selected billing address if it "create address" was selected
                if (paymentForm.billing_address_id.value == -1) {
                    paymentForm.billing_address_id.value = document.getElementById("selectedAddressId_" + i).value;
                }
                if (wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] == -1) {
                	wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext")["billingAddress" + i] = paymentForm.billing_address_id.value;
                }
            }
        }
    },


    /**
     * This function is used when a user edits an existing shipping address during check-out.
     *
     * @param {String} addressSelectBoxName The ID of the address drop-down object.
     * @param {Integer} orderItemId The item ID. It is required in the a multiple shipment scenario.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editAddress: function (addressSelectBoxName, orderItemId, profileshipping, profilebilling) {
        var addressBox = document.getElementById(addressSelectBoxName);

        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id.
        this.saveOrderItemsList(orderItemId, addressBox.value);

        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressSelectBoxName != null) {
                MessageHelper.formErrorHandleClient(addressSelectBoxName, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': 'Shipping'
        });

        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * This function is used when a user edits an existing billing address during check-out.
     *
     * @param {Integer} orderItemId The item ID.
     * @param {Integer} paymentArea The payment area number that this billing address belongs to.
     * @param {String} profileshipping The name of the quick checkout profile shipping address.
     * @param {String} profilebilling The name of the quick checkout profile billing address.
     */
    editBillingAddress: function (orderItemId, paymentArea, profileshipping, profilebilling) {
        var form = document.forms["PaymentForm" + paymentArea];
        var addressBox = form.billing_address_id;

        //We need to save order Items having this addressId..bcs if user edits this address then the id of this address changes..
        //so all order items needs to be updated with new id..
        this.saveOrderItemsList(orderItemId, addressBox.value);

        // the quick checkout address nick name is hardcoded here..it should be same as that used in quick checkout profile page..
        if (addressBox.options[addressBox.selectedIndex].text == profileshipping || addressBox.options[addressBox.selectedIndex].text == profilebilling) {
            if (addressBox != null) {
                MessageHelper.formErrorHandleClient(addressBox, MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_QUICKCHECKOUT_ADDRESS_CHANGE"]);
            }
            return;
        }
        var billingAddressId = addressBox.value;
        var shippingAddressId = (document.getElementById("singleShipmentAddress")) ? document.getElementById("singleShipmentAddress").value : "noAddress";
        var addressType = (billingAddressId == shippingAddressId) ? "ShippingAndBilling" : "Billing";
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        //Update the display area context..
        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': addressBox.value,
            'addressType': addressType
        });

        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * When a user cancels editing an address, this function is called to hide the address entry form and show the original main content of the page, then calls restorePreviousAddressDetails to restore the previous address.
     *
     * @see CheckoutHelperJS.restorePreviousAddressDetails
     */
    cancelEditAddress: function () {
        this.showHideDivs('mainContents', 'editAddressContents');
        this.restorePreviousAddressDetails();
        if (this.getLastAddressLinkIdToFocus() != null && this.getLastAddressLinkIdToFocus() != 'undefined' && this.getLastAddressLinkIdToFocus() != '') {
            document.getElementById(this.getLastAddressLinkIdToFocus()).focus();
            this.setLastAddressLinkIdToFocus('');
        }

    },


    /**
     * This function gets the shipment type Id for the order. Shipment type Id 1 is for single shipment, 2 for multiple shipment.
     *
     * @see CheckoutHelperJS.initializeShipmentPage
     */
    getShipmentTypeId: function () {
        return this.shipmentTypeId;
    },


    /**
     * Sets the dataDiry flag to indicate if payment information in the specified payment form area has been changed by the user.
     * This method should be used for payment methods involving credit card.
     * @param {Integer} paymentAreaNumber The unique payment area number.
     * @param {Boolean} flag A true/false value to indicate if the payment method input has been changed.
     *
     * @see CheckoutHelperJS.isPaymentDataDirty
     */
    paymentDataDirty: function (paymentAreaNumber, flag) {
        this.dataDirty[paymentAreaNumber] = flag;
        console.debug("Information in payment area " + paymentAreaNumber + " has been modified.");
    },

    /**
     * Returns the dataDiry flag that indicates if payment information in the specified payment form area has been changed by the user.
     *
     * @param {Integer} paymentAreaNumber The unique payment area number.
     *
     * @see CheckoutHelperJS.paymentDataDirty
     */
    isPaymentDataDirty: function (paymentAreaNumber) {
        return this.dataDirty[paymentAreaNumber];
    },


    /**
     * Sets fieldDirtyFlag to indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @param {Boolean} value A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.getFieldDirtyFlag
     */
    setFieldDirtyFlag: function (value) {
        this.fieldDirtyFlag = value;
    },


    /**
     * Returns fieldDirtyFlag that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @returns {Boolean} fieldDirtyFlag A true/false value that indicates if the value of a shipping information related input field or the quantity of an item has been changed by the user.
     *
     * @see CheckoutHelperJS.setFieldDirtyFlag
     */
    getFieldDirtyFlag: function () {
        return this.fieldDirtyFlag;
    },


    /**
     * Verifies if the dirty flag is set to true, such as when a customer changes shipping information. If the dirty
     * flag is set to true, a message displays prompting the customer to update their current order before they continue
     * to checkout. This function is used in a non-AJAX checkout flow.
     *
     * @return {Boolean} Return true if the dirty flag is set to true.
     */
    checkForDirtyFlag: function () {
        if (this.getFieldDirtyFlag()) {
            if (document.getElementById("ShoppingCart_NonAjaxUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("ShoppingCart_NonAjaxUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
                return true;
            } else if (document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("MultipleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else if (document.getElementById("SingleShipment_NonAjaxShipInfoUpdate") != null) {
                MessageHelper.formErrorHandleClient(document.getElementById("SingleShipment_NonAjaxShipInfoUpdate"), MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST"]);
                return true;
            }
        }
        return false;
    },


    /**
     * This function is used to show or hide the SMS phone number field section for guest shoppers in the
     * order summary page.
     * @param {DOM Element Id} checkboxElementId The id of the checkbox for getting SMS order notifications.
     * @param {DOM Element Id} smsElementId The id of the element that contains the SMS phone number field.
     */
    showHideCheckoutSMS: function (checkboxElementId, smsElementId) {
        var smsOrderNotificationCheckbox = document.getElementById(checkboxElementId);
        if (smsOrderNotificationCheckbox != null && smsOrderNotificationCheckbox != "undefined") {
            if (smsOrderNotificationCheckbox.checked) {
                showElementById(smsElementId);
            } else {
                hideElementById(smsElementId);
            }
        }

    },

    /**
     * This function return an array of countries from a global variable called countries.
     * If that variable does not already exist then it will be created and populated from a JSON of country objects which should
     * have been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     **/
    getCountryArray: function () {
        //If the countries array does not already exist then create it.
        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined') return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;
    },

    /**
     *  This function populates the country code to mobile phone based on the selected country.
     *  @param {string} countryDropDownId The id of the mobile country drop down list
     *  @param {string} countryCallingCodeId The id of the mobile country calling code text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = document.getElementById(countryDropDownId).value;
        document.getElementById(countryCallingCodeId).value = countries[countryCode].countryCallingCode;
    },


    /**
     * Invokes the OrderShippingInfoUpdate service to expedite shipping for the selected order item.
     *
     * @param {DOM Element} checkBox The Expedite Shipping check-box object.
     * @param {String} inputOrderItemId The ID of the order item for which you want to expedite shipping.
     */
    expediteShipping: function (checkBox, inputOrderItemId) {

        var params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;

        if (checkBox.checked) {
            this.updateParamObject(params, "isExpedited", "true", true);
        } else {
            this.updateParamObject(params, "isExpedited", "false", true);
        }
        if (inputOrderItemId != null) {
            this.updateParamObject(params, "orderItemId", inputOrderItemId, false);
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /************************************************************
     * The following methods are used on the Shopping Cart page
     ************************************************************/

    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the total by calling <code>updateCart</code> after <code>updateWaitTimeOut</code> milliseconds have passed.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Object} event A keyboard event object.
     *
     * @see CheckoutHelperJS.updateCart
     */
    updateCartWait: function (quantityBox, orderItemId, event) {
        //Arrows are escaped for keyboard accesibility of table
        if (event.keyCode == KeyCodes.TAB ||
            event.keyCode == KeyCodes.DOWN_ARROW ||
            event.keyCode == KeyCodes.UP_ARROW ||
            event.keyCode == KeyCodes.LEFT_ARROW ||
            event.keyCode == KeyCodes.RIGHT_ARROW
        ) return;

        //Key pressed.. update the flag
        if (this.keyPressCount[orderItemId] == null && isNaN(this.keyPressCount[orderItemId])) {
            this.keyPressCount[orderItemId] = 0;
        }
        this.keyPressCount[orderItemId] = parseInt(this.keyPressCount[orderItemId]) + 1;
        setTimeout($.proxy(this, "updateCart", quantityBox, orderItemId, this.keyPressCount[orderItemId]), this.updateWaitTimeOut);
    },


    /**
     * This function updates the total on the shopping cart page when the quantity of an item has been changed.
     * It updates the shopping cart by calling the <code>AjaxUpdateOrderItem</code> service.
     *
     * @param {DOM Element} quantityBox The quantity input text field.
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {Integer} keyPressCountValue The count of keyPress events. If there are more keyPress events after this event was fired, then this function just returns without doing anything.
     */
    updateCart: function (quantityBox, orderItemId, keyPressCountValue) {
        if (keyPressCountValue < this.keyPressCount[orderItemId]) {
            //User has pressed one more key..that key press call will update the server..no work for me..
            return;
        }

        var quantity = (quantityBox.value);
        if (!isNonNegativeInteger(quantity)) {
            TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            MessageHelper.formErrorHandleClient(quantityBox, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
        } else {
            //Its a positive valid number > 0...Update the qty at server side..
            if (!isChrome()) {
                TealeafWCJS.createExplicitChangeEvent(quantityBox.id);
            }
            var params = [];
            params.orderId = ".";
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            if (this.shoppingCartPage) {
                params.calculationUsage = "-1,-2,-5,-6,-7";
                params.inventoryValidation = "true";
            } else {
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";
            this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
            this.updateParamObject(params, "quantity", quantity, false, -1);

            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            cursor_wait();

            if (quantity == 0) {
                var x = document.getElementById("totalNumberOfItems").value;
                var y = x;
                //Now remove free items from this total number of items count..
                //x = total items and y = totalItems - totalFreeItems
                for (var i = 0; i < x; i++) {
                    var qtyObj = document.getElementById("freeGift_qty_" + (i + 1));
                    if (qtyObj != null || qtyObj != undefined) {
                        qty = qtyObj.value;
                        if (qty != null && qty != undefined && qty == -1) {
                            y = y - 1;
                        }
                    }

                }

                if (y == 1) {
                    wcService.invoke("AjaxUpdateOrderItem1", params);
                } else {
                    wcService.invoke("AjaxUpdateOrderItem", params);
                }
            } else {
                wcService.invoke("AjaxUpdateOrderItem", params);
            }
        }
    },


    /**
     * Validates the quantity of all items on the 'Shopping Cart' page.
     * @param {DOM Element} form The form object that contains the table of order items.
     */
    updateShoppingCart: function (form) {

        MessageHelper.hideAndClearMessage();
        var totalItems = document.getElementById("totalNumberOfItems").value;
        if (totalItems != null) {
            for (var i = 0; i < totalItems; i++) {
                var quantity = null;
                if (form != undefined) {
                    quantity = form["quantity_" + (i + 1)];
                } else if (document.getElementById("qty_" + (i + 1)) != null) {
                    quantity = document.getElementById("qty_" + (i + 1));
                }
                //Update qty for all items
                if (quantity != null || quantity != undefined) {
                    var v = quantity.value;
                    if (!isNonNegativeInteger(v)) {
                        MessageHelper.formErrorHandleClient(quantity.id, MessageHelper.messages["QUANTITY_INPUT_ERROR"]);
                        return;
                    }
                }

            }
            return true;
        } else {
            console.debug("error: element 'totalNumberOfItems' was expected but undefined.");
            return;
        }
    },

    /**
     * If the shopper has selected to perform a recurring order in the shopping cart page, this function is used to
     * validate that all conditions for creating a recurring order are met:
     * - make sure it is a registered shopper
     * - make sure that the order does not have order items that are non-recurring (i.e disallowRecurringOrder flag set to 1)
     *
     * @param {String} userType The user type of the current user, either G (guest shopper) or R (registered shopper).
     */
    canCheckoutContinue: function (userType) {
		if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked) && ((document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) || document.getElementById("shipTypeOnline") == null)) {
			if (document.getElementById("nonRecurringOrderItems") && document.getElementById("nonRecurringOrderItems").value != "") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["RECURRINGORDER_ERROR"]);
                return false;
            } else if (userType != undefined && userType === "G") {
                MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_GUEST_USER_SUBMIT_RECURRING_ORDER"]);
                return false;
            }
        }
        return true;
    },

    /**
     * Updates the shopping cart in a 'quick check-out' scenario by invoking the <code>QuickCheckOutOrderCopy</code> service.
     *
     * @param {Integer} quickOrderId The ID of the quick check-out order.
     */
    updateCartWithQuickCheckoutProfile: function (quickOrderId) {
		var postRefreshHandlerParameters = [];
		var initialURL = "AjaxRESTOrderCopy";
		var urlRequestParams = [];
		urlRequestParams["storeId"] = this.storeId;
		urlRequestParams["catalogId"] = this.catalogId;
		urlRequestParams["langId"] = this.langId;
		urlRequestParams.toOrderId = ".";
		urlRequestParams["shippingAddressFromOrderProfile"] = "1";
		urlRequestParams["shippingModeFromOrderProfile"] = "1";
		urlRequestParams["URL"] = "dummy";
		urlRequestParams["payInfoFrom"] = quickOrderId;

		postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPrepare", "requestParams":{"orderId":"."}});
		postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{"quickCheckoutProfileForPayment":"true"}});
		var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);

		//For handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();

		wcService.invoke(service.getParam("id"), urlRequestParams);
    },


    /************************************************************
     * End Shopping Cart page specific functions
     ************************************************************/



    /**************************************************************
     * The following methods are used on the Single Shipment page
     **************************************************************/

    /**
     * Helper function used for adding a new shipping address in a single shipment scenario.
     *
     * @param {String} addressType The type of the selected address.
     */
    addNewShippingAddress: function (addressType) {
        this.displayAddressDetails(-1, addressType);
    },


    /**
     * This function is used to update the address of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     */
    updateAddressForAllItems: function (addressSelectBox) {
        //Save it in local array..
        if (addressSelectBox.value != -1) {
            this.selectedAddressesArray[addressSelectBox.name] = addressSelectBox.value;
        }

        var addressId = addressSelectBox.value;
        if (addressId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        var addressId = document.getElementById("singleShipmentAddress").value;
        this.updateParamObject(params, "addressId", addressId, false);
        if (typeof updateGiftRegistrantAddressForItemsExt != "undefined" && typeof updateGiftRegistrantAddressForItemsExt != null) {
            params = updateGiftRegistrantAddressForItemsExt(params, addressId);
        }

        var enabledShipInstructions = false;
        var shipInstructions;

        //Check if Shipping Instructions is enabled
        if (document.getElementById("shipInstructions") != null) {
            shipInstructions = document.getElementById("shipInstructions").value;

            reWhiteSpace = new RegExp(/^\s+$/);
            if (reWhiteSpace.test(shipInstructions)) {
                shipInstructions = "";
            }
            enabledShipInstructions = true;
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        //If Shipping Instructions is enabled & there are some shipping instructions entered
        //Update both the shipping address and shipping instructions
        //Else only update shipping address
        if (!enabledShipInstructions || shipInstructions == undefined || shipInstructions == "") {
            wcService.invoke("OrderItemAddressShipMethodUpdate", params);
        } else {
            wcService.invoke("OrderItemAddressShipInstructionsUpdate", params);
        }
    },


    /**
     * This function is used to update the shipping mode of all order items in a single shipment checkout-out scenario.
     *
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available shipping modes.
     */
    updateShipModeForAllItems: function (shipmentSelectBox) {

        var shipModeId = shipmentSelectBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "shipModeId", shipModeId, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * This function updates the shipping instruction for items in the order. It is used in a single shipment check-out scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     */
    updateShippingInstructionsForAllItems: function () {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";

        var orderItemId = null;
        var shipInstructions = document.getElementById("shipInstructions").value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(document.getElementById("shipInstructions").id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        orderItemId = document.getElementById("orderItem_1").value;
        this.updateParamObject(params, "orderItemId", orderItemId, false);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },

    /**
     * Updates the shipping charge type and account number for items in the order. This method calls the
     * <code>OrderShippingInfoUpdate</code> service and is used in both single and multiple shipment checkout scenarios.
     *
     * @param {Integer} curOrderId The order ID of the current order.
     * @param {Integer} shipModeId The ID of the shipping mode to which shipping charge applies.
     * @param {String} shipChargeType Shipping charge type selected for the shipmode.
     * @param {Integer} shipAcctNum The account number that is used when the selected shipping charge type is Charge by Carrier.
     */
    updateShippingChargeForShipModeAjax: function (curOrderId, shipModeId, shipChargeType, shipAcctNum) {

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = curOrderId;
        params.URL = "";
        params["shipModeId"] = shipModeId;
        params["shipChargTypeId"] = shipChargeType;

        // ship account number is optional field for shipping charge, if it is not specified, pass in empty
        if (shipAcctNum != null && shipAcctNum != undefined) {
            params["shipCarrAccntNum"] = shipAcctNum;
        } else {
            params["shipCarrAccntNum"] = "";
        }

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxOrderShipChargeUpdate", params);
    },


    /**
     * Hides the account number field for the selected in shipping charge. If the charge by seller charge
     * type is selected, account field should not be shown.
     * @param {object} selectValue The HTML element of the shipping charge type selection
     * @param {object} acctFieldId The HTML element of the account number field
     */
    hideShipChargeAccountField: function (selectValue, acctFieldId) {

        if (document.getElementById(selectValue).value.indexOf("ByCarrier") > -1) {
            document.getElementById(acctFieldId).style.display = 'block';
        } else {
            document.getElementById(acctFieldId).style.display = 'none';
        }
    },

    /**
     * This function validates the specified requested shipping date then calls {@link CheckoutHelperJS.updateShippingDateForAllItems}
     * to update the date for all items in the current order in a single shipment scenario.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     *
     * @see CheckoutHelperJS.updateRequestedShipDateForThisItem
     */

    updateRequestedShipDate: function (jsDate) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else {
            t = this.resetRequestedShipDateValue;
        }

        this.updateShippingDateForAllItems(t);
    },


    /**
     * This function updates the requested shipping date for all items in the order. It is called by {@link CheckoutHelperJS.updateRequestedShipDate}.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {String} date The String representation of the date object, see {@link CheckoutHelperJS.updateRequestedShipDate}.
     */
    updateShippingDateForAllItems: function (date) {
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        this.updateParamObject(params, "requestedShipDate", date, false);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Displays the details of an address in a single shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetails: function (addressSelectBoxValue, addressType) {
        //Display selected address details..
        if (addressSelectBoxValue != -1) {
            //For handling multiple clicks
            if (!submitRequest()) {
                return;
            }
            var checkForOpera = true; //require a check of whether the browser is opera or not
            cursor_wait(checkForOpera);
            wcRenderContext.updateRenderContext('shippingAddressContext', {
                'shippingAddress': addressSelectBoxValue
            });
        } else {
            this.createAddress(-1, addressType);
        }
    },


    /************************************************************
     * End Single Shipment page specific functions
     ************************************************************/


    /****************************************************************
     * The following methods are used on the Multiple Shipment page
     ****************************************************************/

    /**
     * This function is used to move all order items into a single shipment when a shopper changes the order from multiple shipment check-out to single shipment.
     * The shipping information of the first item in the order will be used for all items after this update.
     * It calls the <code>OrderItemAddressShipMethodUpdate1</code> service to update the order.
     */
    moveAllItemsToSingleShipment: function () {
        //Get the first orderItem id..
        var orderItemId = document.getElementById("orderItem_1").value;
        //Now get the addressId and shipModeId of this orderItemId...
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        //Update the shipModeId and addressId of all the items present in currentOrder...

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

	  // FIX LATER TODO
        var requestedShipDate = $("#MS_requestedShippingDate_" + orderItemId);
        if (requestedShipDate == undefined) {
            requestedShipDate = document.getElementById("MS_requestedShippingDate_" + orderItemId);
            if (requestedShipDate != null && requestedShipDate != 'undefined') {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = requestedShipDate.value;
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            }
        }

        var requestedShipDateCheckbox = document.getElementById("MS_requestShippingDateCheckbox_" + orderItemId);
        if (requestedShipDateCheckbox != null && requestedShipDateCheckbox != 'undefined') {
            if (requestedShipDateCheckbox.checked) {
                if (requestedShipDate.value != "") {
                    params.requestedShipDate = this.formatRequestedShipDate(requestedShipDate);
                } else {
                    params.requestedShipDate = this.resetRequestedShipDateValue;
                }
            } else {
                params.requestedShipDate = this.resetRequestedShipDateValue;
            }
        }

        //addressId -3 is reserved for gift registry "Registrant" address.
        if (addressId == -3) {
            var totalItems = document.getElementById("totalNumberOfItems").value;
            for (var i = 2; i <= totalItems; i++) {
                if (document.getElementById("orderItem_" + i) != null && document.getElementById("orderItem_" + i) != 'undefined') {
                    var giftOrderItemId = document.getElementById("orderItem_" + i).value;
                    var validAddressId = document.getElementById("MS_ShipmentAddress_" + giftOrderItemId).value;
                    if (validAddressId != -3) {
                        this.updateParamObject(params, "addressId", validAddressId, false);
                        break;
                    }
                } else {
                    break;
                }
            }
        } else {
            this.updateParamObject(params, "addressId", addressId, false);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate1", params);
    },


    /**
     * Helper function for adding an address on the multiple shipment 'Shipping & Billing' page.
     * @param (Integer) orderItemId The ID of the order item.
     */
    addNewShippingAddressForMS: function (orderItemId) {
        this.updateAddressIdForThisItem(-1, orderItemId);

        this.orderItemIds = []; //Reset this.orderItemIds. So that previous edit/create address doesn't have effect on the new create/edit address
        //now save the orderItemId, so we can update that orderItem with the newly created addressId

        //now save the orderItemId, so we can update that orderItem with the newly created addressId
        this.orderItemIds.push(orderItemId);
    },


    /**
     * Updates the address ID for an order item in a multiple shipment check-out scenario.
     * It is used when a different address is selected from the drop down.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service to update.
     *
     * @param {String} addressBoxValue The value, i.e. address ID, of the input select drop-down object that contains all available addresses.
     * @param {Integer} orderItemId The order item ID.
     */
    updateAddressIdForThisItem: function (addressBoxValue, orderItemId) {
        //Save it in local array..
        if (addressBoxValue != -1) {
            var addressBox = document.getElementById("MS_ShipmentAddress_" + orderItemId);
            this.selectedAddressesArray[addressBox.name] = addressBoxValue;
        }
        if (addressBoxValue == -1) return;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";
        var addressId = addressBoxValue;
        this.updateParamObject(params, "shipToRegistrant", "0", false, -1)
        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        if (typeof updateGiftRegistrantAddressForThisItemExt != "undefined" && typeof updateGiftRegistrantAddressForThisItemExt != null) {
            params = updateGiftRegistrantAddressForThisItemExt(params, addressId);
        }
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping mode for an item in the order. It is used in a multiple shipment scenario.
     * It calls the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {DOM Element} shipModeBox The select drop-down object that contains all available shipping modes.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShipModeForThisItem: function (shipModeBox, orderItemId) {
        var shipModeId = shipModeBox.value;
        if (shipModeId == -1) {
            return;
        }
        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },


    /**
     * Updates the shipping instruction for an item. It is used in a multiple shipment scenario.
     * It calls the <code>OrderShippingInfoUpdate</code> service.
     *
     * @param {DOM Element} textArea The input text area for shipping instruction.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateShippingInstructionsForThisItem: function (textArea, orderItemId) {
        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;
        var shipInstructions = textArea.value;

        reWhiteSpace = new RegExp(/^\s+$/);
        if (reWhiteSpace.test(shipInstructions)) {
            shipInstructions = "";
        }

        //Validate the length of the shipping instructions
        if (!MessageHelper.isValidUTF8length(shipInstructions, 4000)) {
            MessageHelper.formErrorHandleClient(textArea.id, MessageHelper.messages["ERROR_ShippingInstructions_TooLong"]);
            return;
        }

        this.setShippingInstuctionsForAllOtherItems(addressId, shipModeId, shipInstructions);

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";

        this.updateParamObject(params, "addressId", addressId, false, -1);
        this.updateParamObject(params, "shipModeId", shipModeId, false, -1);
        this.updateParamObject(params, "shipInstructions", shipInstructions, false, -1);
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("OrderShippingInfoUpdate", params);
    },


    /**
     * This function updates the requested shipping date for the current item in a multiple shipment check-out scenario.
     * It invokes the <code>OrderItemAddressShipMethodUpdate</code> service.
     *
     * @param {datepicker} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @param {Integer} orderItemId The ID of the order item to update.
     */
    updateRequestedShipDateForThisItem: function (jsDate, orderItemId) {
        if (jsDate == null || jsDate.value == "")
            return;

        var t = "";
        if (jsDate.value != "") {
            t = this.formatRequestedShipDate(jsDate);
        } else if (jsDate.value == "") {
            t = this.resetRequestedShipDateValue;
        }

        var addressId = document.getElementById("MS_ShipmentAddress_" + orderItemId).value;
        var shipModeId = document.getElementById("MS_ShippingMode_" + orderItemId).value;

        params = [];
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params.orderId = ".";
        this.updateParamObject(params, "orderItemId", orderItemId, false, -1);
        this.updateParamObject(params, "requestedShipDate", t, false, -1);
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.allocate = "***";
        params.backorder = "***";
        params.remerge = "***";
        params.check = "*n";
        params.calculateOrder = "1";

        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        CheckoutHelperJS.RequestShippingDateAction = true;
        wcService.invoke("OrderItemAddressShipMethodUpdate", params);
    },

    /**
     * This function formats the requested shipping date from the jQuery datepicker object into a GMT date string.
     *
     * @param {datepicker object} jsDate The jQuery datepicker object containing the requested shipping date specified by the user.
     * @return {string} String representation of the requested ship date in GMT.
     */
    formatRequestedShipDate: function (jsDate) {
        var date = $(jsDate).datepicker("getDate");
        //Set the time to 12pm to handle cases where daylight savings cause a date shift
        date.setHours(12);
        return date.toISOString();
    },


    /**
     * This function is used to bring up the address entry form when a user wants to create a new address for an item in a multiple shipment scenario.
     *
     * @param {Integer} orderItemId The ID of the order item to update.
     * @param {String} addressType The type of address to create.
     *
     * @private
     */
    createAddressForMS: function (orderItemId, addressType) {
        //For handling multiple clicks
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        wcRenderContext.updateRenderContext('editShippingAddressContext', {
            'shippingAddress': '-1',
            'addressType': addressType
        });
        //Hide the mainContents (contains shipping/billing details, shop cart details, promotion details, orderDetails)
        this.showHideDivs('editAddressContents', 'mainContents');
    },


    /**
     * Helper function for adding a new address in a multiple shipment scenario.
     *
     * @param (Integer) orderItemId The ID of the item.
     * @param (String) addressType The type of the selected address.
     */
    displayAddressDetailsForMSHelper: function (orderItemId, addressType) {
        this.displayAddressDetailsForMS(-1, orderItemId, addressType);
    },


    /**
     * Displays the details of an address in a multiple shipment check-out scenario.
     *
     * @param {String} addressSelectBoxValue The value, i.e. address ID, of the input address select drop-down object.
     * @param {Integer} orderItemId The order item ID.
     * @param {String} addressType The type of the selected address.
     */
    displayAddressDetailsForMS: function (addressSelectBoxValue, orderItemId, addressType) {
        if (addressSelectBoxValue == -1) {
            this.createAddressForMS(orderItemId, addressType);
        }
    },


    /**
     * This function is used to show or hide the edit address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} orderItemId The id of the orderItem for which the edit address link is displayed/hidden.
     */

    showHideEditAddressLink: function (addressSelectBox, orderItemId) {
        if (addressSelectBox.value == '-3') {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "none");
            }
            return;
        }
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");
            for (var i = 0; i < orgAddressArray.length; i++) {
                if ($("#editAddressLink_" + orderItemId).length) {

                    if (addressSelectBox.value == orgAddressArray[i]) {
                        $("#editAddressLink_" + orderItemId).css("display", "none");
                        break;
                    } else {
                        $("#editAddressLink_" + orderItemId).css("display", "block");
                    }
                }
            }
        } else {
            if ($("#editAddressLink_" + orderItemId).length) {
                $("#editAddressLink_" + orderItemId).css("display", "block");
            }
        }
    },

    /**
     * This function is used to show or hide the edit billing address link in multiple and single shipment page.
     * @param {DOM Element} addressSelectBox The select drop-down object that contains all available addresses.
     * @param {String} paymentAreaNumber The area number of the payment section.
     */

    showHideEditBillingAddressLink: function (addressSelectBox, paymentAreaNumber) {

        // If the value is "Please Select Billing Method first", then don't display the edit link on load.
        if (addressSelectBox.value == '-2') {
            $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
            return;
        }

        // Gets the address Ids of all the organization addresses
        var orgAddressList = document.getElementById("shippingOrganizationAddressList");

        //if there exists organization addresses
        if (orgAddressList) {
            var orgAddressArray = [];
            orgAddressArray = orgAddressList.value.toString().split(",");

            //loops through all the organization address Ids
            for (var i = 0; i < orgAddressArray.length; i++) {

                //checks to see if the edit link divs exists
                if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {

                    //compares the selected value address Id in the drop down to the organization address id
                    if (addressSelectBox.value == orgAddressArray[i]) {

                        //hides the link if a match is found and then exits the loop (exit is for the case where there might be a different org address id)
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "none");
                        break;
                    } else {
                        //displays it in all other cases
                        $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
                    }
                }
            }

        } else {

            // if no organization addresses exists, show the valid edit divs.
            if ($("#editBillingAddressLink_" + paymentAreaNumber).length) {
                $("#editBillingAddressLink_" + paymentAreaNumber).css("display", "block");
            }
        }
    },

    /**
     * Sets the order ID when it is not called form the current order.
     * The order ID is used to determine which order to act upon such as in the case of deleting an order item from an order.
     * @param {String} orderId The orderID to use.
     */
    setOrderId: function (orderId) {
        this.orderId = orderId;
    },

    /**
     * Returns the orderId.
     */
    getOrderId: function () {
        return this.orderId;
    },

    /************************************************************
     * End Multiple Shipment page specific functions
     ************************************************************/

    _toggleOrderItemDetails: function (div) {
        if (div.css("display") == "none") {
        	div.css("display", "block");
            $("#orderExpandAreaBottom").css("display", "none");
            $("#OrderItemDetailsPlus").css("display", "none");
            $("#OrderItemDetailsShowPrompt").css("display", "none");
            $("#OrderItemDetailsMinus").css("display", "inline");
            $("#OrderItemDetailsHidePrompt").css("display", "inline");
            $("#OrderItemDetails_plusImage_link").css("display", "none");
            $("#OrderItemDetails_minusImage_link").css("display", "");
        } else {
        	div.css("display", "none");
            $("#orderExpandAreaBottom").css("display", "block");
            $("#OrderItemDetailsPlus").css("display", "inline");
            $("#OrderItemDetailsShowPrompt").css("display", "inline");
            $("#OrderItemDetailsMinus").css("display", "none");
            $("#OrderItemDetailsHidePrompt").css("display", "none");
            $("#OrderItemDetails_plusImage_link").css("display", "");
            $("#OrderItemDetails_minusImage_link").css("display", "none");
        }
    },
    toggleOrderItemDetailsShipping: function (orderItemDetailsDiv, contextId, initializeJS) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': 0,
                    'storeId': this.storeId,
                    'catalogId': this.catalogId,
                    'langId': this.langId,
                    'initializeJS': initializeJS
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    },

    toggleOrderItemDetailsSummary: function (orderItemDetailsDiv, contextId, beginIndex, pageSize, exOrderId, exQuoteId, fromOrderDetails, analytics) {
        var div = $("#" + orderItemDetailsDiv);
        if (div.css("display") == "none") {
            if (!div.hasClass('orderRetrieved')) {
                cursor_wait();
                wcRenderContext.updateRenderContext(contextId, {
                    'beginIndex': '',
                    'pageSize': pageSize,
                    'externalOrderId': exOrderId,
                    'externalQuoteId': exQuoteId,
                    'isFromOrderDetailsPage': 'false',
                    'analytics': analytics
                });
                div.addClass('orderRetrieved');
            }
        }
        this._toggleOrderItemDetails(div);
    }
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript provides the variables and methods used on the PromotionChoiceOfFreeGiftsPopup.jspf
 * to allow the user to select a free gift of their choice when this promotion applies to the order.
 * @version 1.5
 */

PromotionChoiceOfFreeGiftsJS={

	/* Global variable declarations */

	/**
	 * This variable is used to keep track of the enable or disable status of the Apply button in the pop-up.
	 * @private
	 */
	disableApplyButton:false,

	/**
	 * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
	 * @private
	 */
	langId: "-1",

	/**
	 * This variable stores the ID of the current store. Its default value is empty.
	 * @private
	 */
	storeId: "",

	/**
	 * This variable stores the ID of the catalog. Its default value is empty.
	 * @private
	 */
	catalogId: "",

	/**
	 * Sets the common parameters for the current page.
	 * For example, the language ID, store ID, and catalog ID.
	 *
	 * @param {Integer} langId The ID of the language that the store currently uses.
	 * @param {Integer} storeId The ID of the current store.
	 * @param {Integer} catalogId The ID of the catalog.
	 */
	setCommonParameters: function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
	},

  /**
   * This function is used to update the free gift choices for a promotion, made by the user, during order check-out.
   * The <code>AjaxUpdateRewardOption</code> service is invoked.
   *
   * @param {String} formName: The name of the reward choices form.
   * @param {Integer} maximumNumberOfItems: The maximum number of gift selections that the user can make.
   * @param {Integer} rewardOptionId: The ID of the RewardOption object used to add the reward choices data to.
   */
   updateRewardChoices:function(formName, maximumNumberOfItems, rewardOptionId, orderId){

		if(this.disableApplyButton){
			return false;
		}

		var params = [];
		var catEntryId = [];
		var quantity = [];
		var j = 0;

		params.storeId = this.storeId;
		params.orderId = orderId;
		params["rewardOptionId"] = rewardOptionId;
		if(CheckoutHelperJS.shoppingCartPage){
			params["calculationUsage"] = "-1,-2,-5,-6,-7";
		}else{
			params["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
		}
		//params["allocate"] = "***";
		//params["backorder"] = "***";

		//add the catalog entry ID and quantity of each gift item selection.
		for(var i = 0; i < maximumNumberOfItems; i++){
			if(!document.getElementById("no_gifts").checked){
				if(document.getElementById("SelectFreeGift_" + (i+1)).checked){
					catEntryId[j] = document.getElementById("CatalogEntryID_" + (i+1)).value;
					quantity[j] = document.getElementById("GiftItemQuantity_" + (i+1)).value;
					j++;
				}
			}
		}
		params["catEntryId"] = catEntryId;
		params["quantity"] = quantity;

		//For handling multiple clicks
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		wcService.invoke("AjaxUpdateRewardOption", params);
		//hide the pop-up after the service has been invoked after some delay.
		setTimeout($.proxy(this,"hidePopup",'free_gifts_popup'),200);
        $('#free_gifts_popup').data("wc-WCDialog").close();
	},

	/**
	 * This function is used to display a message of the total number of gift
	 * item selections made by the shopper. It also displays an error message
	 * when the user selects more gift items than the maximum number of gift
	 * items that are allowed for the promotion.
	 *
	 * @param {Integer}
	 *            maximumNumberOfItems The maximum number of gift items that are
	 *            allowed as part of the promotion.
	 */
	checkNumberOfAllowedItems:function(maximumNumberOfItems){
		var i = 1;
		var numberOfSelectionsMade = 0;
		this.disableApplyButton = false;

		while(document.getElementById("SelectFreeGift_" + i)){
			if(document.getElementById("SelectFreeGift_" + i).checked){
				numberOfSelectionsMade++;
			}
			i++;
		}
		if(numberOfSelectionsMade > maximumNumberOfItems){
			//display an error message warning the shopper about exceeding the maximum number of gift item selections
			if(document.getElementById('message')!= null){
				document.getElementById('message').className = "error";
				document.getElementById('message').innerHTML = MessageHelper.messages["PROMOTION_FREE_GIFTS_POPUP_ERROR_EXCEED_GIFT_QUANTITY"];
			}
			this.disableApplyButton = true;
		} else if(numberOfSelectionsMade > 0){
			//display a message indicating the number of gift item selections made by the shopper
			if(numberOfSelectionsMade == 1){
				var selectionsMadeMsg = MessageHelper.messages["PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS_ONE"];
			} else {
				var selectionsMadeMsg = MessageHelper.messages["PROMOTION_FREE_GIFTS_POPUP_NUMBER_OF_SELECTIONS"];
				selectionsMadeMsg = selectionsMadeMsg.replace(/%0/, numberOfSelectionsMade);
			}
			if(document.getElementById('message')!= null){
				document.getElementById('message').className = "status_message";
				document.getElementById('message').innerHTML = selectionsMadeMsg;
			}
		} else if(numberOfSelectionsMade == 0){
			//checking that the element exists because when the promotion is inactive,
			//this element does not exist in the jsp.
			if(document.getElementById('message')!= null){
				document.getElementById('message').innerHTML = "&nbsp;"
			}
			this.disableApplyButton = true;
		}
	},

	/**
	 * If the user has selected the option to not receive any free gifts as part
	 * of the promotion, then the gift item choices are cleared and disabled for
	 * selection.
	 */
	rewardChoicesEnabledStatus:function(){
		var i = 1;

		if(document.getElementById("no_gifts").checked){
			this.disableApplyButton = false;
			if(document.getElementById('message')!= null){
				document.getElementById('message').innerHTML = "&nbsp;";
			}
			while(document.getElementById("SelectFreeGift_" + i)){
				document.getElementById("SelectFreeGift_" + i).checked = false;
				document.getElementById("SelectFreeGift_" + i).disabled = true;
				i++;
			}
		} else {
			while(document.getElementById("SelectFreeGift_" + i)){
				document.getElementById("SelectFreeGift_" + i).disabled = false;
				i++;
			}
			this.checkNumberOfAllowedItems();
			this.checkFreeGiftsAvailability();
		}
	},

	/**
	 * This function is used to make the free gift choices pop-up visible to the user.
	 */
	showFreeGiftsDialog: function(){
		this.checkNumberOfAllowedItems();
        $('#free_gifts_popup').data("wc-WCDialog").open();

		this.checkFreeGiftsAvailability();
	},

	/**
	 * This function is used to disable any free gifts that are not available.
	 */
	checkFreeGiftsAvailability: function(){
		var i = 1;
		var numberOfAvailableGifts = 0;

		while(document.getElementById("OnlineAvailability_" + i)){
			if(document.getElementById("OnlineAvailability_" + i).value != "Available" && document.getElementById("OnlineAvailability_" + i).value != "Backorderable"){
				document.getElementById("SelectFreeGift_" + i).checked = false;
				document.getElementById("SelectFreeGift_" + i).disabled = true;
			} else {
				numberOfAvailableGifts++;
			}
			i++;
		}

		if(numberOfAvailableGifts == 0){
			this.disableApplyButton = true;
		}

	},

	/**
	 * Hide the pop-up identified by the passed id parameter.
	 *
	 * @param {String} id: The id of the pop-up to hide.
	 * @param {Object} event: The event object.
	 */
	hideFreeGiftsPopup:function(id,event){
		if(event!=null && event.type=="keypress" && event.keyCode!=KeyCodes.ESCAPE){
			return;
		} else {
			var popUp =  $("#" + id).data("wc-WCDialog");
			if(popUp){
                popUp.close();
			}
		}
	}

};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file is used by PunchoutPaymentRedirect.jsp, MyAccountDisplay.jsp and OrderDetailDisplay.jsp.
 */

if(typeof(PunchoutJS) === "undefined" || !PunchoutJS || !PunchoutJS.topicNamespace){

	/**
	 * @class The PunchoutJS class defines helper functions that are used to process punchout payments.
	 */
	PunchoutJS = {
		/**
		 * The Id of a section on the page that will be replaced by the punchout payment page.
		 */
		divId:"",

		/**
		 * A boolean value that indicates if the punchout payment page should be opened in the same browser window as the current page.
		 * The default value is true.
		 */
		sameWindow:true,

		/**
		 * Displays a message pop-up on the checkout page to remind the user that the punchout payment needs to be paid while blocking the background page with a semi-transparent image.
		 */
		displayPopup:function(){
			if(!$("#punchout_popup_container").length){
				console.debug("PunchoutJS.displayPopup: element with Id punchout_popup_container was not found on the page.");
				return;
			}
			$("#punchout_popup_container").show();

			var pageMask = $("<div id='pageMask'/>").appendTo($("body"));
			$(pageMask).css({
				"position":"absolute",
				"z-index":949,
				"top":"0px",
				"left":"0px",
				"width":$("body").innerWidth() + "px",
				"height":$("body").innerHeight() + "px",
				"background":"#000",
				"opacity":"0.40"
			});
			setTimeout("$('#punchout_popup_close_icon').focus()", 1000);
		},

		/**
		 * This function renders the actual punchout payment section on the page after a successful service call invocation to AjaxPunchoutPay.
		 * @param {String} orderId The Id of the order that is being processed.
		 */
		handleResponse:function(orderId) {
			var divId = this.divId;
			var sameWindow = this.sameWindow;

			var div = document.getElementById(divId);
			var url = div.innerHTML.replace(/(^\s*)|(\s*$)/g, "");
			var lowerUrl = url.toLowerCase();
			if (lowerUrl.indexOf('<form') !== 0 && lowerUrl.indexOf('&lt;form') !== 0) {
				if (lowerUrl.indexOf('<a') !== 0 && lowerUrl.indexOf('&lt;a') !== 0) {
					div.innerHTML = '<a name="punchout_anchor" href="' + url + '" />';
				} else {
					div.innerHTML = url;
				}
				var a = div.childNodes[0];
				if (!sameWindow) {
					a.target = '_blank';
					window.open(a.href);
				} else {
					window.location = a.href;
				}
			} else {
				div.innerHTML = url;
				var form = div.childNodes[0];
				form.name = 'punchout_form';
				if (!sameWindow) {
					form.target = '_blank';
					form.submit();
				} else {
					form.submit();
				}
			}
		},

		/**
		 * Invokes the service AjaxPunchoutPay to handle the payment for the current order.
 		 * @param {String} storeId The Id of the store.
		 * @param {String} orderId The Id of the order that is being processed.
		 * @param {String} piId The payment instruction Id.
		 * @param {String} divId The Id of the div element that the punchout payment page should be displayed in.
		 * @param {boolean} sameWindow Whether the punchout payment page should be displayed in the same browser window.
		 */
		pay:function(storeId, orderId, piId, divId, sameWindow) {
			this.divId = divId;
			this.sameWindow = sameWindow;
			params = [];
			params["storeId"] = storeId;
			params["orderId"] = orderId;
			params["piId"] = piId;
			var punchoutPaymentRedirectForm = document.forms["punchoutPaymentRedirectForm_AuthTokenInfo"];
			var authToken = punchoutPaymentRedirectForm.punchoutPaymentRedirect_authToken.value;
			params["authToken"] = authToken;
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke("AjaxPunchoutPay",params);
		},

		/**
		 * Handles key press event that occurs in the punchout payment message pop-up dialog.
		 * If the key press event is not tab and shift, then refresh the page.
		 * @param {Object} event An HTML event object.
		 */
		handleKeyPress:function(event){
			if(event.keyCode !== KeyCodes.TAB && event.keyCode !== KeyCodes.SHIFT){
				location.reload();
			}
		},

		/**
		 * Put the cursor focus on the element with the given Id.
		 * @param {String} elementId The element Id.
		 */
		focusElement:function(elementId){
			if(!$("#" + elementId).length){
				console.debug("PunchoutJS.focusElement: element with Id " + elementId + " was not found on the page.");
			}
			$("#" + elementId).focus();
		}
	}
};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript handles different actions to perform after shopper selects to proceed with checkout.
 * In summary, user can have different logon status and user can select different shopping option (buy online or
 * pick up at store).
 * A user can have the following logon status:
 * 1. Shopper is a guest user
 * 2. Shopper has a commerce account but is not yet logged on (and would like to log on before user proceeds with
 *    shopping flow)
 * 3. Shopper is already logged on
 * In addition, user can select different shipping options:
 * 1. Shop online
 * 2. Pick up at store
 * Every logon status/shipping selection combination as mentioned above will be handled in this javascript
 */

ShipmodeSelectionExtJS = {
	/** language id used by the store, default to -1 (English) */
	langId: "-1",
	/** store id of the store */
	storeId: "",
	/** catalog id of the store */
	catalogId: "",
	/** indicates if BOPIS feauture is enabled or not */
	BOPISEnabled: false,
	/** Order item ID of an order item in the current order. This is needed for RESTOrderItemUpdate to call DoInventoryActionCmd to get fulfillment center ID **/
	orderItemId : "",

	/**
	* Indicates if "Pick up in store" shipping option is selected by shopper
	*/
	isPickUpInStore: function() {
		var shipType = this.getShipTypeValue();
		if (shipType == "pickUp") {
			return true;
		} else {
			return false;
		}
	},

	/**
	* Gets the shipType value from the document.BOPIS_FORM form.
	*/
	getShipTypeValue: function() {
		if (document.BOPIS_FORM != undefined){
			for (var i=0; i < document.BOPIS_FORM.shipType.length; i++) {
			   if (document.BOPIS_FORM.shipType[i].checked) {
				  return document.BOPIS_FORM.shipType[i].value;
				  }
			   }
		}
	},

	/**
	 * This function retrieves the shipment type value for the current order from the cookie.  If no shipment type value for the
	 * current order is found in the cookie, empty string is returned.
	 *
	 * @param {String} orderId The order ID.
	 *
	 * @returns {String} The shipment type value.
	 *
	 */
	getShipTypeValueFromCookieForOrder:function(orderId) {
		var shipTypeValueOrderId = getCookie("WC_shipTypeValueOrderId");
		if (shipTypeValueOrderId == orderId) {
			var shipTypeValue = getCookie("WC_shipTypeValue");
			return shipTypeValue;
		} else {
			return "";
		}
	},

	/**
	 * This function adds or updates the shipment type value for the current order to the cookie.
	 *
	 * @param {String} value The new pick up store ID.
	 * @param {String} orderId The order ID.
	 *
	 */
	setShipTypeValueToCookieForOrder:function(value, orderId) {
		var newShipTypeValue = value;
		if (newShipTypeValue != null && newShipTypeValue != "undefined" && newShipTypeValue != "") {
			var shipTypeValueOrderId = getCookie("WC_shipTypeValueOrderId");
			if (shipTypeValueOrderId != orderId) {
				setCookie("WC_shipTypeValueOrderId", null, {expires: -1});
				setCookie("WC_shipTypeValueOrderId", orderId, {path: "/", domain: cookieDomain});
			}
			var currentShipTypeValue = this.getShipTypeValueFromCookieForOrder(orderId);
			if (newShipTypeValue != currentShipTypeValue) {
				setCookie("WC_shipTypeValue", null, {expires: -1});
				setCookie("WC_shipTypeValue", newShipTypeValue, {path: "/", domain: cookieDomain});
			}
		}
		//select the proper options that are saved in context
		if (newShipTypeValue == "pickUp") {
			if (document.getElementById("scheduling_options")) {
				document.getElementById("scheduling_options").style.display="none";
				setCookie("WC_recurringOrder_"+orderId, "false", {path: "/", domain: cookieDomain});
				if (document.getElementById("recurringOrder")) {
					document.getElementById("recurringOrder").checked = false;
				}
				this.hideShowNonRecurringOrderMsg(orderId);
			}
		} else if (newShipTypeValue == "shopOnline") {
			if (document.getElementById("scheduling_options")) {
				document.getElementById("scheduling_options").style.display="block";
				this.hideShowNonRecurringOrderMsg(orderId);
			}
		}
	},

	/**
	 * This function select the proper shipmode in the shopping cart page that is saved in the cookie.
	 *
	 * @param {String} orderId The order identifier of the current shopping cart.
	 *
	 */
	displaySavedShipmentTypeForOrder:function(orderId) {
		var shipTypeValueOrderId = getCookie("WC_shipTypeValueOrderId");
		if (shipTypeValueOrderId != orderId) {
			setCookie("WC_shipTypeValueOrderId", null, {expires: -1});
			setCookie("WC_shipTypeValue", null, {expires: -1});
		} else {
			var currentShipTypeValue = this.getShipTypeValueFromCookieForOrder(orderId);

			//select the proper shipmode that is saved in context
			if (currentShipTypeValue == "pickUp") {
				if(document.getElementById("shipTypePickUp").disabled == false){
						document.getElementById("shipTypePickUp").checked = true;
						if (document.getElementById("scheduling_options")) {
							document.getElementById("scheduling_options").style.display="none";
							setCookie("WC_recurringOrder_"+orderId, "false", {path: "/", domain: cookieDomain});
							if (document.getElementById("recurringOrder")) {
								document.getElementById("recurringOrder").checked = false;
							}
						}
				}else{
						document.getElementById("shipTypeOnline").checked = true;
						if (document.getElementById("scheduling_options")) {
							document.getElementById("scheduling_options").style.display="block";
						}
						this.setShipTypeValueToCookieForOrder("shopOnline", orderId);
				}
			} else if (currentShipTypeValue == "shopOnline") {
				document.getElementById("shipTypeOnline").checked = true;
				if (document.getElementById("scheduling_options")) {
					document.getElementById("scheduling_options").style.display="block";
				}
			}
		}
		this.hideShowNonRecurringOrderMsg(orderId,true);
	},

	/**
	 * This function is used to show all the cues to the shopper when in the shopping cart page. It shows messages for the following:
	 * - guest shopper attempting to checkout a recurring order
	 * - it flags non recurring items when attempting to checkout as a recurring order
	 *
	 * @param {String} orderId 			The order identifier of the current shopping cart.
	 * @param {String} fromPageLoad Tells if this function is called on a page load, which does not need the error message to show.
	 */
	hideShowNonRecurringOrderMsg:function(orderId,fromPageLoad) {
		if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) ||
					(document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") == null)) {
			setCookie("WC_recurringOrder_"+orderId, "true", {path: "/", domain: cookieDomain});
		} else {
			setCookie("WC_recurringOrder_"+orderId, "false", {path: "/", domain: cookieDomain});
		}

		if (document.getElementById("nonRecurringOrderItems") && document.getElementById("nonRecurringOrderItems").value != "") {
			if (document.getElementById("nonRecurringOrderItemsCount") && document.getElementById("numOrderItemsInOrder")) {
				var totalItems = document.getElementById("numOrderItemsInOrder").value;
				var totalNonRecurringItems = document.getElementById("nonRecurringOrderItemsCount").value;
				if (totalItems == totalNonRecurringItems) {
					if (document.getElementById("scheduling_options")) {
						document.getElementById("scheduling_options").style.display = "none";
						setCookie("WC_recurringOrder_"+orderId, "false", {path: "/", domain: cookieDomain});
						if (document.getElementById("recurringOrder")) {
							document.getElementById("recurringOrder").checked = false;
						}
						return;
					}// else if (document.getElementById("scheduling_options") && document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) {
					//	document.getElementById("scheduling_options").style.display = "block";
					//}
				}
			}
			var orderItemIds = document.getElementById("nonRecurringOrderItems").value;
			var orderItemIdArray = orderItemIds.split(",");
			for(var i=0; i<orderItemIdArray.length; i++){
				if (document.getElementById("nonRecurringItem_"+orderItemIdArray[i])) {
					if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked) ||
								(document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") == null)) {
						document.getElementById("nonRecurringItem_"+orderItemIdArray[i]).style.display = "block";
					} else {
						document.getElementById("nonRecurringItem_"+orderItemIdArray[i]).style.display = "none";
					}
				}
			}
			if ( (document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") && document.getElementById("shipTypeOnline").checked && !fromPageLoad) ||
						(document.getElementById("recurringOrder") && document.getElementById("recurringOrder").checked && document.getElementById("shipTypeOnline") == null && !fromPageLoad)) {
				MessageHelper.displayErrorMessage(MessageHelper.messages["RECURRINGORDER_ERROR"]);
			}
		}
	},

	/**
	* Constructs the next URL to call when user is already signed on
	* 3 scenarios to handle:
	* 	1. Registered user selects to shop online -> goes to the shipping and billing page
	* 	2. Registered user selects to pick up in store - 2 variations:
	*		2a. User has not yet selected a physical store (WC_physicalStores cookie is empty) ->
	*				Goes to store selection page
	*		2b. User has selected at least one store (WC_physicalStore cookie is not empty) ->
	*				Updates shipmode then goes to shipping and billing page
	* @param {String} billingShippingPageURLForOnline The URL to the billing and shipping page of the online checkout path
	* @param (String) physicalStoreSelectionURL The URL to the physical store selection page of the pick up in store checkout path
	*/
	registeredUserContinue: function(billingShippingPageURLForOnline, physicalStoreSelectionURL) {

		if(CheckoutHelperJS.getFieldDirtyFlag()){
			MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
			return;
		}

		//For handling multiple clicks
		if(!submitRequest()){
			return;
		}

		/*
		// deletePaymentInstructionsURL is never used anywhere in this function. Comment it out for now.
		var deletePaymentInstructionsURL = "";
		var paymentInstructionIds = document.getElementById("existingPaymentInstructionId").value;
		if(paymentInstructionIds != "") {
			var paymentInstructionsArray = paymentInstructionIds.split(",");
			deletePaymentInstructionsURL = "RESTOrderPIDelete?";
			for (var i=0; i<paymentInstructionsArray.length; i++) {
				if (i!=0) {
					deletePaymentInstructionsURL = deletePaymentInstructionsURL + "&";
				}
				deletePaymentInstructionsURL = deletePaymentInstructionsURL + "piId=" + paymentInstructionsArray[i];
			}
			deletePaymentInstructionsURL = deletePaymentInstructionsURL + "&URL=";
		} */

		if (this.isBOPISEnabled() && this.isPickUpInStore()) {
			document.location.href = appendWcCommonRequestParameters(physicalStoreSelectionURL);
		} else {
			//need to pass in orderItemId here for RESTOrderItemUpdate so it will call DoInventoryActionCmd to get fulfillment center ID
			var nextLink = 'RESTOrderItemUpdate?remerge=***&check=*n&allocate=***&backorder=***&calculationUsage=-1,-2,-3,-4,-5,-6,-7&calculateOrder=1&orderItemId='+this.orderItemId +'&errorViewName=AjaxOrderItemDisplayView'+'&orderId=.&URL=';
			//document.location.href = appendWcCommonRequestParameters(nextLink + billingShippingPageURLForOnline);

			var postRefreshHandlerParameters = [];
			var initialURL = "AjaxRESTOrderItemUpdate";
			var urlRequestParams = [];
			urlRequestParams["remerge"] = "***";
			urlRequestParams["check"] = "*n";
			urlRequestParams["allocate"] = "***";
			urlRequestParams["backorder"] = "***";
			urlRequestParams["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
			urlRequestParams["calculateOrder"] = "1";
			urlRequestParams["orderItemId"] = this.orderItemId;
			urlRequestParams["orderId"] = ".";
			urlRequestParams["storeId"] = this.storeId;
			postRefreshHandlerParameters.push({"URL":billingShippingPageURLForOnline,"requestType":"GET", "requestParams":{}});
			var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
			service.invoke(urlRequestParams);
		}

	},

	/**
	* Constructs the next URL to call when user is not signed on and selected to continue checkout with
	* guest user mode
	* 3 scenarios to handle:
	* 	1. Guest user selects to shop online -> goes to the shipping and billing page
	* 	2. Guest user selects to pick up in store - 2 variations:
	*		2a. User has not yet selected a physical store (WC_physicalStores cookie is empty) ->
	*				Goes to store selection page
	*		2b. User has selected at least one store (WC_physicalStore cookie is not empty) ->
	*				Updates shipmode then goes to shipping and billing page
	* @param {String} billingShippingPageURLForOnline The URL to the billing and shipping page of the online checkout path
	* @param (String) physicalStoreSelectionURL The URL to the physical store selection page of the pick up in store checkout path
	*/
	guestShopperContinue: function(billingShippingPageURLForOnline, physicalStoreSelectionURL) {

		if(CheckoutHelperJS.getFieldDirtyFlag()){
			MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
			return;
		}

		/* HB-528
		//For handling multiple clicks
		if(!submitRequest()){
			return;
		}
		*/

		var postRefreshHandlerParameters = [];
		if (this.isBOPISEnabled() && this.isPickUpInStore()) {
			var paymentInstructionIds = $("#existingPaymentInstructionId").val();
			if (paymentInstructionIds != "") {
				var paymentInstructionsArray = paymentInstructionIds.split(",");
				for (var i = 1; i < paymentInstructionsArray.length; i++) {
					// Chain subsequent PI Delete calls. REST API can delete only one piId at a time. Hence these requests needs to be chained.
					postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPIDelete", "requestParams":{"piId":paymentInstructionsArray[i]}});
				}
				postRefreshHandlerParameters.push({"URL":physicalStoreSelectionURL,"requestType":"GET"});

				// Initial request to PIDelete
				var params = [];
				params["piId"] = paymentInstructionsArray[0];
				var service = getCustomServiceForURLChaining("AjaxRESTOrderPIDelete",postRefreshHandlerParameters,null);
					service.invoke(params);
			} else {
				// No piId to delete. Just redirect to physicalStoreSelectionURL
				document.location.href = physicalStoreSelectionURL;
			}
		} else {
			//need to pass in orderItemId here for RESTOrderItemUpdate so it will call DoInventoryActionCmd to get fulfillment center ID
			var params = [];
			params["remerge"] = "***";
			params["check"] = "*n";
			params["allocate"] = "***";
			params["backorder"] = "***";
			params["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
			params["calculateOrder"] = "1";
			params["orderItemId"] = this.orderItemId;
			params["orderId"] = ".";
			params["storeId"] = this.storeId;

			var postRefreshHandlerParameters = [];
			postRefreshHandlerParameters.push({"URL":billingShippingPageURLForOnline, "requestType":"GET", "requestParams":{"guestChkout":"1"}});
			var service = getCustomServiceForURLChaining("AjaxRESTOrderItemUpdate",postRefreshHandlerParameters,null);
			service.invoke(params);
		}
	},

	/**
	* Constructs the next URL to call when user is not signed on and selected to sign in before checkout
	* 3 scenarios to handle:
	* 	1. User selects to shop online -> invokes logon URL
	* 	2. User selects to pick up in store - 2 variations:
	*		2a. User has not yet selected a physical store (WC_physicalStores cookie is empty) ->
	*				After logon URL, go to the store selection page
	* 	2b. User has selected at least one store (WC_physicalStore cookie is not empty) ->
	*				Updates shipmode then invokes logon URL
	* @param {String} logonURL URL to perform user logon
	* @param {String} orderMoveURL URL to call order move after user has logged on
	* @param {String} billingShippingPageURLForOnline The URL to the billing and shipping page of the online checkout path
	* @param (String) physicalStoreSelectionURL The URL to the physical store selection page of the pick up in store checkout path
	*/
	guestShopperLogon: function(logonURL, billingShippingPageURLForOnline, physicalStoreSelectionURL) {
		if(CheckoutHelperJS.getFieldDirtyFlag()){
			MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
			return;
		}

		//var completeOrderMoveURL = orderMoveURL;
		var afterLogonURL = "";

		if (this.isBOPISEnabled() && this.isPickUpInStore()) {
			afterLogonURL = physicalStoreSelectionURL;
		} else {
			afterLogonURL = billingShippingPageURLForOnline;
		}

		// change URL of logon link
		// when mergeCart = true is passed to LogonURL command, logonCmd will merge the cart + does order calculate using MigrateUserEntriesCmdImpl.
		// So no need to explicitly call OrderItemMove and OrderCacluate commands again.
		// completeOrderMoveURL = completeOrderMoveURL + "&URL=RESTOrderCalculate%3FURL=" + afterLogonURL + "&calculationUsageId=-1&calculationUsageId=-2&calculationUsageId=-7";
		document.AjaxLogon.URL.value = afterLogonURL; // Got to next view directly.
		document.location.href = logonURL;
	},

	/**
	* Function to call when Quick Checkout button is pressed
	* 2 scenarios to handle:
	*   1. User selects to shop online -> proceed to call CheckoutHelperJS.updateCartWithCheckoutProfile
	*   2. User selects to pick up in store -> display error message to indicate quick checkout option is only
	*      available with online shopping option
	* @param {String} quickOrderId order id of this order
	*/
	updateCartWithQuickCheckoutProfile: function(quickOrderId) {
		if (this.isBOPISEnabled() && this.isPickUpInStore()) {
			MessageHelper.displayErrorMessage(MessageHelper.messages["message_QUICK_CHKOUT_ERR"]);
		} else {
			if(CheckoutHelperJS.getFieldDirtyFlag()){
				MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_UPDATE_FIRST_SHOPPING_CART"]);
				return;
			}
			CheckoutHelperJS.setCommonParameters(this.langId, this.storeId, this.catalogId);
			CheckoutHelperJS.updateCartWithQuickCheckoutProfile(quickOrderId);
		}
	},

	/**
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use
	* @param {String} catalog Catalog ID to use
	*/
	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
	},

	/**
	* Sets orderItemId used by this javascript object
	* @param {String} orderItemId OrderItemId to use
	*/
	setOrderItemId:function(orderItemId){
		this.orderItemId = orderItemId;
	},

	/**
	* sets to tell if BOPIS feature is enabled
	* @param {boolean} flag Contains value of true or false
	*/
	setBOPISEnabled:function(flag){
		this.BOPISEnabled = flag;
	},

	/**
	* indicates if BOPIS feature is enabled
	*/
	isBOPISEnabled:function(){
		return this.BOPISEnabled;
	},

	/**
	* This function is called by the CheckoutStoreSelection.jsp "Next" button. It's job is to decide if it should go to
	* the next page. If there are no missing information it submits the call to the server to save the pick up location
	* for all the order items and then goes to the next page.
	* @param {Object} form The form that contains the order items and that need to be submitted
	*/
	submitStoreSelectionForm:function(form) {
		var phyStoreId = PhysicalStoreCookieJSStore.getPickUpStoreIdFromCookie();

		if (phyStoreId != null && phyStoreId != "") {
			form["physicalStoreId"].value = phyStoreId;
			processAndSubmitForm(form);
		} else {
			if(document.getElementById("storeSelection_NextButton") != null){
				MessageHelper.formErrorHandleClient(document.getElementById("storeSelection_NextButton"), MessageHelper.messages["message_NO_STORE"]);
			}else{
				MessageHelper.displayErrorMessage(MessageHelper.messages["message_NO_STORE"]);
			}
		}
	},

	/**
	* This function is called by the CheckoutPayInStore.jsp "Next" button. It's job is to decide if it should go to
	* the next page. If the action is to use "PayInStore" then it directly goes to next page, otherwise it does
	* validation on the address form and if there are no missing information it submits the call to the server to
	* create the address and then goes to the next page.
	*
	* @param {String} formName Name of the form that contains the address and need to be submitted
	* @param {String} stateDivName Name of the div that has the "state" field
	* @param {String} hasValidAddresses boolean indicating if the user has at least one valid address for checkout purposes
	*/
	submitAddressForm:function(formName, stateDivName, hasValidAddresses) {
		var form = document.forms[formName];
		if (stateDivName != "") {
			AddressHelper.setStateDivName(stateDivName);
		}

		var payInStore = false;
		if ($("#payInStorePaymentOption").is(':checked')) {
			payInStore = true;
		}

		var postRefreshHandlerParameters = [];
		var urlRequestParams = [];


		/* Chain of URLs that can be invoked are:
		*  AjaxPersonChangeServiceAddressAdd - ($(form).attr("action") )
		*  AjaxRESTOrderPIDelete - (If more than one piId is present, then this action is repeated as many times as piIds present
		*  AjaxRESTOrderItemUpdate
		*  DOMOrderShippingBillingView
		*  In worst case scenario, chained URLs will be: (Assuming maximum 3 piIds are present)
		*	AjaxPersonChangeServiceAddressAdd,AjaxRESTOrderPIDelete,AjaxRESTOrderPIDelete,AjaxRESTOrderPIDelete,AjaxRESTOrderItemUpdate,DOMOrderShippingBillingView
		*  In best case scenario, chained URLs will be: (Assuming shopper has valid address and no piIDs)
		*   AjaxRESTOrderItemUpdate,DOMOrderShippingBillingView
		*/
		if (hasValidAddresses) {
			var initialURL = null;
			var formId = null;
		}
		else if (AddressHelper.validateAddressForm(form)) {
			var initialURL = $(form).attr("action");
			var formId = form.id;
		}

		var paymentInstructionIds = $("#existingPaymentInstructionId").val();
		if (paymentInstructionIds != "") {
			var paymentInstructionsArray = paymentInstructionIds.split(",");
			if(initialURL == null){
				var initialURL = "AjaxRESTOrderPIDelete";
				urlRequestParams["piId"] = paymentInstructionsArray[0];
			} else {
				postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPIDelete", "requestParams":{"piId":paymentInstructionsArray[0]}});
			}

			for (var i = 1; i < paymentInstructionsArray.length; i++) {
				// Chain subsequent PI Delete calls. REST API can delete only one piId at a time. Hence these requests needs to be chained.
				postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPIDelete", "requestParams":{"piId":paymentInstructionsArray[i]}});
			}
		}

		var orderItemUpdateParams = [];
		orderItemUpdateParams["remerge"] = "***";
		orderItemUpdateParams["check"] = "*n";
		orderItemUpdateParams["allocate"] = "***";
		orderItemUpdateParams["backorder"] = "***";
		orderItemUpdateParams["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
		orderItemUpdateParams["calculateOrder"] = "1";
		orderItemUpdateParams["orderItemId"] = this.orderItemId;
		orderItemUpdateParams["orderId"] = ".";
		orderItemUpdateParams["storeId"] = this.storeId;

		if(initialURL == null ){
			initialURL = "AjaxRESTOrderItemUpdate"; // Best case scenario defined above.
			urlRequestParams = orderItemUpdateParams;
		} else {
			postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderItemUpdate", "requestParams":orderItemUpdateParams});
		}
		postRefreshHandlerParameters.push({"URL":"DOMOrderShippingBillingView","requestType":"GET", "requestParams":{"payInStore":payInStore}});
		var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,formId);
		service.invoke(urlRequestParams);
	}
}	;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file contains declarations of refresh controllers used by WebSphere Commerce AJAX services for the shipping and billing pages.
 */

/**
 * @class This class stores the common parameters and functions for the controllers.
 */
SBControllersDeclarationJS = {

	/**
	 * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
	 * be a two step process where shipping is captured in first step and billing in second step.
	 * It is set to true by default.
	 *
	 * @private
	 */
	singlePageCheckout: true,

	/**
		* This variable is used to indicate if ShippingChargeType flexflow option is enabled or not.
		*/
	shipChargeEnabled: false,

	 /**
	  * This function sets the URL parameter for a given refresh area.
	  *
	  * @param {String} refreshAreaId The ID of the refresh area of which the URL parameter will be set.
	  * @param {String} url The new URL parameter for the controller.
	  */
	setRefreshURL:function(refreshAreaId, url){
		$("#" + refreshAreaId).attr("refreshurl", url);
	},


	/**
	 * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
	 *
	 * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
	 *
	 * @see CheckoutHelperJS.isSinglePageCheckout
	 */
	setSinglePageCheckout:function(singlePageCheckout){
		this.singlePageCheckout = singlePageCheckout;
	},


	/**
	 * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 *
	 * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
	 * enabled/disabled.
	 *
	 * @see CheckoutHelperJS.setSinglePageCheckout
	 */
	isSinglePageCheckout:function(){
		return this.singlePageCheckout;
	},

	/**
	 * Sets the shipChargeEnabled variable to indicate if the 'ShippingChargeType' feature is enabled.
	 *
	 * @param {Boolean} enabled A true/false value that indicates if the 'ShippingChargeType' feature is enabled.
	 */
	setShipChargeEnabled:function(enabled){
		this.shipChargeEnabled = enabled;
	}
};


/**
 * Refresh controller declaration for the main page area on the 'Shipping & Billing' page.
 * @constructor
 */
function declareControllerForMainAndAddressDiv() {
	/* this a local context..no need to define URL for this */
	var myWidgetObj = $("#content_wrapper");
	wcRenderContext.addRefreshAreaId("contextForMainAndAddressDiv", "content_wrapper");
	var myRCProperties = wcRenderContext.getRenderContextProperties("contextForMainAndAddressDiv");

	myWidgetObj.refreshWidget({
		/**
		 * Calls {@link CheckoutHelperJS.showHideDivs} to display and hide the areas defined in renderContext.
		 */
		renderContextChangedHandler: function() {
			CheckoutHelperJS.showHideDivs(myRCProperties["showArea"],myRCProperties["hideArea"]);
		}
	});

};


/**
 * Refresh controller declaration for the order items area on the single shipment 'Shipping & Billing' page.
 * @constructor
 */
function declareTraditionalShipmentDetailsController() {
	var myWidgetObj = $("#WC_ShipmentDisplay_div_17");
	wcRenderContext.addRefreshAreaId("traditionalShipmentDetailsContext", "WC_ShipmentDisplay_div_17");
	var myRCProperties = wcRenderContext.getRenderContextProperties("traditionalShipmentDetailsContext");

	var events = $.extend({}, order_updated,
			{"OrderShippingInfoUpdate": "OrderShippingInfoUpdate"},
			{"AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage"},
			//{"AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage"},
			{"AjaxPrepareOrderForShipChargeUpdate": "AjaxPrepareOrderForShipChargeUpdate"},
			{"OrderItemAddressShipInstructionsUpdate": "OrderItemAddressShipInstructionsUpdate"},
			{"OrderItemAddressShipInstructionsUpdate1": "OrderItemAddressShipInstructionsUpdate1"},
			{"AjaxAddUnboundPaymentInstructionToThisOrder": "AjaxAddUnboundPaymentInstructionToThisOrder"},
			{"AjaxDeleteUnboundPaymentInstructionFromThisOrder": "AjaxDeleteUnboundPaymentInstructionFromThisOrder"},
			{"OrderItemAddressShipMethodUpdate": "OrderItemAddressShipMethodUpdate"});

	/**
	 * Refreshes the item details area with the properties defined in renderContext if the actionId of the input message parameter is from an order update service or if it is 'OrderShippingInfoUpdate'.
	 */
	wcTopic.subscribe(events, function(returnData) {
		myWidgetObj.refreshWidget("refresh", myRCProperties);
		if(returnData.actionId != 'OrderItemAddressShipMethodUpdate') {
			submitRequest(); //Till shop cart is refreshed, do not allow any other requests..
			cursor_wait();
		}

	});

	myWidgetObj.refreshWidget({
		/**
		 * Refreshes the order item details area with the properties defined in renderContext.
		 */
		renderContextChangedHandler: function() {
			if(wcRenderContext.testForChangedRC("traditionalShipmentDetailsContext", ["beginIndex"])){
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			}
		},

		/**
		 * Clears the progress bar after a successful refresh.
		 */
		postRefreshHandler: function() {
			resetRequest(); //Shop cart is refreshed, give the control to shopper...
			cursor_clear();

			if (myRCProperties["initializeJS"] == 'true') {
				$('input[id^="orderItem_"]').each(function(i, orderItem) {
					var initJS = 'addReqListsJS' + orderItem.value + ' = new AddToRequisitionListsJS(' +
							myRCProperties["storeId"] + ',' +
							myRCProperties["catalogId"] + ',' +
							myRCProperties["langId"] + ',' +
							'"' + orderItem.value + 'requisitionListContent",' +
							'"' + orderItem.value + 'requisitionListSelect",' +
							'"' + orderItem.value + 'createNewListMenu",' +
							'"' + orderItem.value + 'listTypeMenu",' +
							'"' + orderItem.value + 'newListNameInput",' +
							'"' + orderItem.value + 'listType",' +
							'"' + orderItem.value + 'productAdded",' +
							'"",' +
							'"AddToRequisitionListsJS' + orderItem.value + '"' +
							');' +
							'addReqListsJS' + orderItem.value + '.setCatEntryId("' + $('#catalogId_' + (orderItem.id.substring(orderItem.id.indexOf('_') + 1))).val() + '");';
					eval(initJS);
				});
				$('div[id^="shoppingListScript_"]').each(function(i, node){
					$.globalEval(node.innerHTML);
				});
			}
		}
	});
};


/**
 * Refresh controller declaration for the shipping address area on the single shipment 'Shipping & Billing' page.
 * @constructor
 */
function declareShippingAddressSelectBoxAreaController() {
	var myWidgetObj = $("#shippingAddressSelectBoxArea");
	wcRenderContext.addRefreshAreaId("shippingAddressDropDownBoxContext", "shippingAddressSelectBoxArea");
	var myRCProperties = wcRenderContext.getRenderContextProperties("shippingAddressDropDownBoxContext");

	var events = $.extend({}, address_updated,
			{"AjaxUpdateOrderItemsAddressId": "AjaxUpdateOrderItemsAddressId"},
			{"AddBillingAddressInCheckOut": "AddBillingAddressInCheckOut"});

	/**
	 * Refreshes the shipping address area with the properties defined in renderContext.
	 */
	wcTopic.subscribe(events, function(returnData) {
			if (returnData.actionId in address_updated){
				//This means, invokeService for Address Add/Edit has been called..so update our select box area
				wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
				selectedAddressId = returnData.data.addressId;
				myRCProperties.addressId=selectedAddressId;
				if (CheckoutHelperJS.orderItemIds.length != 0) {
					CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(selectedAddressId[0]);
				}
				cursor_clear();
			} else if (returnData.actionId == "AjaxUpdateOrderItemsAddressId"){
				//This means, new shipping address is created / edited and all the items are updated with this new address id
				// and ajax prepare order is called.. we need to update our shipping address drop down...
				myWidgetObj.refreshWidget("refresh", myRCProperties);
				cursor_clear();
			} else if (returnData.actionId == "AddBillingAddressInCheckOut" &&
					returnData.data.addBillingAddressInCheckOutAddressType == 'ShippingAndBilling' &&
					document.getElementById("singleShipmentAddress")){
				myRCProperties.addressId = document.getElementById("singleShipmentAddress").value;
				myWidgetObj.refreshWidget("refresh", myRCProperties);
				cursor_clear();
			}
	});

	myWidgetObj.refreshWidget({
		/**
		 * Sets focus after shipping address is altered.
		 */
		postRefreshHandler: function() {
			if (CheckoutHelperJS.getLastAddressLinkIdToFocus() != null && CheckoutHelperJS.getLastAddressLinkIdToFocus() != 'undefined' && CheckoutHelperJS.getLastAddressLinkIdToFocus() != '') {
				document.getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus()).focus();
			}
			// Initialize shippingAddressDisplayArea refresh widget
			declareShippingAddressDisplayAreaController();
		}
	});

};


/**
 * Refresh controller declaration for the order totals summary area.
 * @constructor
 */
function declareCurrentOrderTotalsAreaController() {
	var myWidgetObj = $("#WC_ShipmentDisplay_div_18");
	wcRenderContext.addRefreshAreaId("currentOrder_Context", "WC_ShipmentDisplay_div_18");
	var myRCProperties = wcRenderContext.getRenderContextProperties("currentOrder_Context");

	/**
	 * Payment type promotion: add message.actionId == 'AjaxPrepareOrderForPaymentSubmit' to cause the order total
	 * to refresh when order prepare is called.
	 */
	var events = $.extend({}, order_updated,
			{"AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage"},
			{"OrderItemAddressShipMethodUpdate": "OrderItemAddressShipMethodUpdate"},
			{"AjaxPrepareOrderForShipChargeUpdate": "AjaxPrepareOrderForShipChargeUpdate"},
			{"OrderItemAddressShipInstructionsUpdate": "OrderItemAddressShipInstructionsUpdate"},
			{"OrderItemAddressShipInstructionsUpdate1": "OrderItemAddressShipInstructionsUpdate1"},
			{"AjaxUpdateOrderAfterAddressUpdate": "AjaxUpdateOrderAfterAddressUpdate"},
			{"AjaxAddShippingAndBillingAddressForPersonDuringCheckout": "AjaxAddShippingAndBillingAddressForPersonDuringCheckout"},
			{"AjaxPrepareOrderForPaymentSubmit": "AjaxPrepareOrderForPaymentSubmit"});

	/**
	 * Refreshes the area with the properties defined in renderContext if the actionId of the input message is from an order update service.
	 */
	wcTopic.subscribe(events, function(returnData) {
		myWidgetObj.refreshWidget("refresh", myRCProperties);
	});

	myWidgetObj.refreshWidget({
		/**
		 * Updates the display style of relevant sections on the page after a successful refresh.
		 */
		postRefreshHandler: function() {
			// Order level discount tooltip section - if the tooltip is defined, show the section after area is refreshed
			if($("#discountDetailsSection").length )  {
				$("#discountDetailsSection").css("display", "block");
			}

			// Promotion code tooltip section - if the tooltip is defined, show the section after area is refreshed
			if($("#appliedPromotionCodes").length ) {
				$("#appliedPromotionCodes").css("display", "block");
			}
		}
	});
};

/**
 * Refresh controller declaration for the shipping charge area in a single shipment check-out scenario.
 * @constructor
 */
function declareSingleShipmentShipChargeController() {
	var myWidgetObj = $("#WC_SingleShipmentDisplay_ShipCharge_Area");
	wcRenderContext.addRefreshAreaId("singleShipmentShipChargeContext", "WC_SingleShipmentDisplay_ShipCharge_Area");
	var myRCProperties = wcRenderContext.getRenderContextProperties("singleShipmentShipChargeContext");

	/**
	 * Only refresh this area when shipping method is updated
	 */
	wcTopic.subscribe(["OrderItemAddressShipMethodUpdate"], function() {
		if (SBControllersDeclarationJS.shipChargeEnabled) {
			myWidgetObj.refreshWidget("refresh", myRCProperties);
		}
	});

	myWidgetObj.refreshWidget({
		/**
		 * Clears the progress bar after a successful refresh.
		 */
		postRefreshHandler: function() {
			cursor_clear();
		}
	});
};

/**
 * Refresh controller declaration for the billing address area.
 * @constructor
 */
function declareBillingAddressSelectBoxAreaController(widgetId) {
	if(typeof widgetId == "object" || typeof widgetId == "array") {
		widgetId = widgetId[0];
	}

	var myWidgetObj = $("#" + widgetId);
	wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", widgetId);
	var myRCProperties = wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext");

	/**
	 * This function refreshes the billing address area with the properties defined in renderContext if the actionId of the input message parameter is AddBillingAddressInCheckOut or AjaxUpdateAddressForPerson.
	 */
	wcTopic.subscribe(["AddBillingAddressInCheckOut","UpdateBillingAddressInCheckout","AjaxUpdateAddressForPerson",
	                   "AjaxAddShippingAndBillingAddressForPersonDuringCheckout","AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout"], function(returnData) {
		//If we are creating a new billing address or editing the existing address, then we should update our billing address drop down box area...
		//Make sure that even after we refresh the billing address drop down box, we pre-select the previously selected address for user...
		var objectId = myWidgetObj.attr("objectId");
		var addressId = myRCProperties["billingAddress"+objectId];
		if (myRCProperties["paymentTCId"+objectId] == "") {
			myWidgetObj.refreshWidget("updateUrl", myRCProperties["billingURL"+objectId]);
		} else {
			myWidgetObj.refreshWidget("updateUrl", myRCProperties["billingURL"+objectId]+"&paymentTCId="+myRCProperties["paymentTCId"+objectId]);
		}
		if(myRCProperties["billingAddress"+objectId] == -1){
			//Create address was selected from this billing drop down..so this drop down box should have new address selected by default...
			addressId = returnData.data.addressId;
			myWidgetObj.refreshWidget("refresh", {"paymentAreaNumber":objectId,"selectedAddressId":addressId,"paymentMethodSelected":myRCProperties["payment"+objectId]});
			myRCProperties["billingAddress"+objectId] = addressId;
			// Mark this address for update
			if(objectId <= CheckoutPayments.numberOfPaymentMethods){
				CheckoutPayments.updatePaymentObject(objectId, 'billing_address_id');
			}
		}
		else if(myRCProperties["billingAddress"+objectId] == 0){
			//Means user has not yet touched this select box..don't try to select anything...
			myWidgetObj.refreshWidget("refresh", {"paymentAreaNumber":objectId,"paymentMethodSelected":myRCProperties["payment"+objectId]});
		}
		else{
			// User changed the select box selection
			if (document.getElementById("singleShipmentAddress")) {
				// Applies to single shipment only
				shippingAddressId = document.getElementById("singleShipmentAddress").value;
				billingAddressId = document.getElementById("billing_address_id_" + objectId).value;
				if (shippingAddressId == billingAddressId && objectId <= CheckoutPayments.numberOfPaymentMethods) {
					//If shipping and billing addresses are the same and we are updating the address(updated address will have new id),
					//widget refresh should be based on the new addressId, not the old one.
					//However, we should ignore the case that adding address from shipping address section
					if (returnData.data.originalServiceId != "AjaxAddAddressForPerson"){
						addressId = returnData.data.addressId;
					}
				}
			}
			myWidgetObj.refreshWidget("refresh", {"paymentAreaNumber":objectId,"selectedAddressId":addressId,"paymentMethodSelected":myRCProperties["payment"+objectId]});
			// Mark this address for update
			if(objectId <= CheckoutPayments.numberOfPaymentMethods){
				CheckoutPayments.updatePaymentObject(objectId, 'billing_address_id');
			}
		}
	});

	myWidgetObj.refreshWidget({
		/**
		 * Refreshes the Billing Address dropdown box with addresses corresponding to the newly selected payment method.
		 *
		 * @param {Object} message The render context changed event message.
		 */
		renderContextChangedHandler: function() {
			var objectId = myWidgetObj.attr("objectId");
			if(wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext",["payment"+objectId]) || wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext",["paymentTCId"+objectId])){
				if (myRCProperties["paymentTCId"+objectId] == "") {
					myWidgetObj.refreshWidget("updateUrl", myRCProperties["billingURL"+objectId]);
				} else {
					myWidgetObj.refreshWidget("updateUrl", myRCProperties["billingURL"+objectId]+"&paymentTCId="+myRCProperties["paymentTCId"+objectId]);
				}
				var selectedAddressId = $("#billing_address_id_" + objectId).val();
				myWidgetObj.refreshWidget("refresh", {"paymentAreaNumber":objectId,"selectedAddressId":selectedAddressId,"paymentMethodSelected":myRCProperties["payment"+objectId]});
			}
		},

		postRefreshHandler: function() {
			var objectId = myWidgetObj.attr("objectId");
			// After the section refreshes, shows or hides the edit and create links.
			CheckoutHelperJS.showHideEditBillingAddressLink((document.getElementsByName('billing_address_id'))[objectId-1], objectId);

			//Removes the Progress Bar if its still running.
			cursor_clear();
			var lastAddress = CheckoutHelperJS.getLastAddressLinkIdToFocus();
			if ((numAjaxRequests >= 0) && lastAddress != null && lastAddress != 'undefined' && lastAddress != '') {
				if (document.getElementById(lastAddress) != null){
					document.getElementById(lastAddress).focus();
				}else{
					var lastAddressArray = lastAddress.split("_");
					var lastAddressOrderId = (parseInt(lastAddressArray[lastAddressArray.length - 1]) + 1) + '';
					if (lastAddress.indexOf('WC_ShippingAddressSelectMultiple_link_2_') > -1){
						var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_2_' + lastAddressOrderId;
						if (document.getElementById(lastAddressForFreeGift) != null ){
							document.getElementById(lastAddressForFreeGift).focus();
						}
					}else{
						var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_3_' + lastAddressOrderId;
						if (document.getElementById(lastAddressForFreeGift) != null ){
							document.getElementById(lastAddressForFreeGift).focus();
						}
					}
				}
			}
			declareBillingAddressDisplayAreaController("billingAddressDisplayArea_" + objectId);
		}
	});

};

/**
 * Refresh controller declaration for the billing address display area.
 * @constructor
 */
function declareBillingAddressDisplayAreaController(widgetId) {
	if(typeof widgetId == "object" || typeof widgetId == "array") {
		widgetId = widgetId[0];
	}
	var myWidgetObj = $("#" + widgetId);

	wcRenderContext.addRefreshAreaId("billingAddressDropDownBoxContext", widgetId);
	var myRCProperties = wcRenderContext.getRenderContextProperties("billingAddressDropDownBoxContext");

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			var areaNumber = myRCProperties["areaNumber"];
			var objectId = widgetId;
			if (wcRenderContext.testForChangedRC("billingAddressDropDownBoxContext", ["billingAddress"+areaNumber]) && objectId.charAt(objectId.length-1) == areaNumber) {
				var addressId = myRCProperties["billingAddress"+areaNumber];
				myWidgetObj.refreshWidget("refresh", {"addressId": addressId});
			}
		},

		postRefreshHandler: function() {
			var areaNumber = myRCProperties["areaNumber"];
			CheckoutHelperJS.showHideEditBillingAddressLink((document.getElementsByName('billing_address_id'))[areaNumber-1],areaNumber);
			//clears the progress bar set from billingdropdowndisplay.jsp
			cursor_clear();
		}
	});

};

/**
 * Refresh controller declaration for the order total area.
 * @constructor
 */
function declareOrderTotalController() {
	var myWidgetObj = $("#orderTotalAmountArea");
	wcRenderContext.addRefreshAreaId("paymentContext", "orderTotalAmountArea");
	var myRCProperties = wcRenderContext.getRenderContextProperties("paymentContext");

	var events = $.extend({}, order_updated,
			{"OrderItemAddressShipMethodUpdate": "OrderItemAddressShipMethodUpdate"},
			{"AjaxPrepareOrderForShipChargeUpdate": "AjaxPrepareOrderForShipChargeUpdate"},
			{"OrderItemAddressShipInstructionsUpdate": "OrderItemAddressShipInstructionsUpdate"},
			{"OrderItemAddressShipInstructionsUpdate1": "OrderItemAddressShipInstructionsUpdate1"},
			{"AjaxUpdateOrderAfterAddressUpdate": "AjaxUpdateOrderAfterAddressUpdate"},
			{"AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage"},
			{"AjaxUpdateOrderItemsAddressId": "AjaxUpdateOrderItemsAddressId"});

	wcTopic.subscribe(events, function() {
		cursor_wait();
		//updating the total
		CheckoutPayments.getTotalInJSON();
	});

	// initialize widget
	myWidgetObj.refreshWidget({
		postRefreshHandler: function(widget) {
			cursor_clear();
		}
	});
};

/**
 * Refresh controller declaration for the payment area.
 * @constructor
 * There will be three controllers by default..
 * When paymentAreaController for paymentArea1 changes, the payment1 property of the context will be updated... So in that case for paymentAreaController for paymentArea1,
 * wcRenderContext.testForChangedRC(["payment1"])) will return true..and then we check for payment1 type ..if its VISA, then we load Visa.jsp.. similarly it works for other controllers
 */
function declarePaymentAreaController(divId) {
	if(typeof divId == "object") {
		divId = divId[0];
	}

	var myWidgetObj = $("#"+divId);
	wcRenderContext.addRefreshAreaId("paymentContext", divId);
	var myRCProperties = wcRenderContext.getRenderContextProperties("paymentContext");
	var paymentAreaNumber = divId[divId.length-1];

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
				if (myRCProperties.currentPaymentArea == paymentAreaNumber) {
					if ((wcRenderContext.testForChangedRC("paymentContext", ["payment" + paymentAreaNumber])  || wcRenderContext.testForChangedRC("paymentContext", ["paymentTCId" + paymentAreaNumber])
						|| (wcRenderContext.testForChangedRC("paymentContext", ["piAmount"])) && supportPaymentTypePromotions )
					) {
						if (myRCProperties["payment" + paymentAreaNumber] == "empty") {
							viewName = "EmptySnippetView";
						} else {
							viewName = paymentSnippetsURLMap[myRCProperties["payment" + paymentAreaNumber]];
						}
						myWidgetObj.refreshWidget("updateUrl", viewName + paymentAreaUrlParam);

						if (supportPaymentTypePromotions) {
							if (CheckoutPayments.numberOfPaymentMethods != 1) {
								myWidgetObj.refreshWidget("refresh", myRCProperties);
							} else if (CheckoutPayments.numberOfPaymentMethods == 1 && paymentAreaNumber < 2) {
								myWidgetObj.refreshWidget("refresh", myRCProperties);
							}
						} else {
							myWidgetObj.refreshWidget("refresh", myRCProperties);
						}
					}
				}
		},

		postRefreshHandler: function() {
			/**
				if supportPaymentTypePromotions is true, CheckoutPayments.loadPaymentSnippet should have been called to
				reload the entire payment refresh area. This will also refresh the amount field. Hence, we don't need to
				call update amount field again	(which will trigger a call to CheckoutPayments.loadPaymentSnippet ).
			**/
			if (!supportPaymentTypePromotions) {
				var orderTotal = $("#OrderTotalAmount").val();
				CheckoutPayments.updateAmountFields(orderTotal);
			}

			var widgetId = "paymentArea" + paymentAreaNumber;
			TealeafWCJS.rebind(widgetId);

			var addressKey = "billingAddress" + paymentAreaNumber;
			//reset the billing address id in the billing address context to be the default selected address after payment method refresh
			wcRenderContext.updateRenderContext('billingAddressDropDownBoxContext', {addressKey:(document.getElementsByName('billing_address_id'))[paymentAreaNumber-1].value, 'areaNumber':paymentAreaNumber});

			cursor_clear();
		}
	});

};

/**
 * Refresh controller declaration for shipping address display area.
 * @constructor
 */
function declareShippingAddressDisplayAreaController() {
	var myWidgetObj = $("#shippingAddressDisplayArea");

	wcRenderContext.addRefreshAreaId("shippingAddressContext", "shippingAddressDisplayArea");
	var myRCProperties = wcRenderContext.getRenderContextProperties("shippingAddressContext");

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			if (wcRenderContext.testForChangedRC("shippingAddressContext", ["shippingAddress"])) {
				var addressId = myRCProperties["shippingAddress"];
				myWidgetObj.refreshWidget("refresh", {"addressId": addressId});
			}
			cursor_clear();
		}
	});

};

/**
 * Refresh controller declaration for shipping address edit area.
 * @constructor
 */
function declareEditShippingAdddressAreaController() {
	var myWidgetObj = $("#editShippingAddressArea1");

	wcRenderContext.addRefreshAreaId("editShippingAddressContext", "editShippingAddressArea1");
	var myRCProperties = wcRenderContext.getRenderContextProperties("editShippingAddressContext");

	var events = $.extend({}, address_updated, {"UpdateBillingAddressInCheckout": "UpdateBillingAddressInCheckout"});

	wcTopic.subscribe(events, function(returnData) {
		if(shipmentTypeId == 2){
			//This means, invokeService for Address Add/Edit has been called..so update our select box area
			wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
			selectedAddressId = returnData.data.addressId;
			CheckoutHelperJS.updateAddressIdOFItemsOnCreateEditAddress(selectedAddressId[0]);
			cursor_clear();
		}
	});

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			if (wcRenderContext.testForChangedRC("editShippingAddressContext", ["shippingAddress"])) {
				var addressId = myRCProperties["shippingAddress"];
				//reset the addressID..so that when user selects create address next time it works properly..
				myRCProperties["shippingAddress"] = 0;
				var addressType = myRCProperties["addressType"];
				myWidgetObj.refreshWidget("refresh", {"addressId": addressId,"addressType":addressType});
			}
		},
		postRefreshHandler: function() {
			cursor_clear();
			AddressHelper.loadStatesUI('shopcartAddressForm','','stateDiv','state', true);
			TealeafWCJS.rebind("centered_single_column_form");
		}
	});
};


function declareMultipleShipmentOrderDetailsRefreshArea() {
	var widgetName = "WC_MultipleShipmentDisplay_div_18";
	var contextName = "multipleShipmentDetailsContext";

	if (!wcRenderContext.checkIdDefined(contextName)) {
		wcRenderContext.declare(contextName, [], {shipmentDetailsArea: "update"});
	}
	var myRCProperties = wcRenderContext.getRenderContextProperties(contextName);
	var myWidgetObj = $("#"+widgetName);

	wcRenderContext.addRefreshAreaId(contextName, widgetName);

	var actionIds = $.extend({}, order_updated,{'AjaxUpdateOrderItemsAddressId':'AjaxUpdateOrderItemsAddressId','AjaxDeleteOrderItemForShippingBillingPage':'AjaxDeleteOrderItemForShippingBillingPage','OrderItemAddressShipMethodUpdate':'OrderItemAddressShipMethodUpdate',
	'AjaxPrepareOrderForShipChargeUpdate':'AjaxPrepareOrderForShipChargeUpdate',
	'OrderItemAddressShipInstructionsUpdate':'OrderItemAddressShipInstructionsUpdate',
	'OrderItemAddressShipInstructionsUpdate1':'OrderItemAddressShipInstructionsUpdate1',
	'AjaxAddUnboundPaymentInstructionToThisOrder':'AjaxAddUnboundPaymentInstructionToThisOrder',
	'AjaxDeleteUnboundPaymentInstructionFromThisOrder':'AjaxDeleteUnboundPaymentInstructionFromThisOrder',
	'AddBillingAddressInCheckOut':'AddBillingAddressInCheckOut'});

	wcTopic.subscribe(actionIds, function(data){
		if(!CheckoutHelperJS.RequestShippingDateAction && (data.actionId != 'AddBillingAddressInCheckOut' || data.addBillingAddressInCheckOutAddressType != 'Billing')){
			myWidgetObj.refreshWidget("refresh", myRCProperties);
			submitRequest(); //Till shop cart is refreshed, do not allow any other requests..
			cursor_wait();
		} else {
			CheckoutHelperJS.RequestShippingDateAction = false;
		}
	});

	var renderContextChangedHandler = function() {
		if(wcRenderContext.testForChangedRC(contextName,["beginIndex"])){
			myWidgetObj.refreshWidget("refresh", myRCProperties);
		}
	};

	// post refresh handler
	var postRefreshHandler = function() {
		resetRequest(); //Shop cart is refreshed, give the control to shopper...
		cursor_clear();

		if (myRCProperties["initializeJS"] == 'true') {
			$('input[id^="orderItem_"]').each(function(i, orderItem) {
				$.globalEval($('#addToRequisitionListScript_' + orderItem.value).html());
				var addReqObj = 'addReqListsJS' + orderItem.value;
				$.globalEval('if(typeof '+ addReqObj + ' !== "undefined") {' + addReqObj + '.setCatEntryId("' + document.getElementById('catalogId_' + (orderItem.id.substring(orderItem.id.indexOf('_') + 1))).value + '");}');
			});
			$('div[id^="shoppingListScript_"]').each(function(i, node){
				$.globalEval($(node).html());
			});
		}
		if ((numAjaxRequests >= 0) && CheckoutHelperJS.getLastAddressLinkIdToFocus() != null && CheckoutHelperJS.getLastAddressLinkIdToFocus() != 'undefined' && CheckoutHelperJS.getLastAddressLinkIdToFocus() != '') {
			if (document.getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus()) != null){
				document.getElementById(CheckoutHelperJS.getLastAddressLinkIdToFocus()).focus();
			}else{
				var lastAddress = CheckoutHelperJS.getLastAddressLinkIdToFocus();
				var lastAddressArray = lastAddress.split("_");
				var lastAddressOrderId = (parseInt(lastAddressArray[lastAddressArray.length - 1]) + 1) + '';
				if (lastAddress.indexOf('WC_ShippingAddressSelectMultiple_link_2_') > -1){
					var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_2_' + lastAddressOrderId;
					if (document.getElementById(lastAddressForFreeGift) != null ){
						document.getElementById(lastAddressForFreeGift).focus();
					}
				}else{
					var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_3_' + lastAddressOrderId;
					if (document.getElementById(lastAddressForFreeGift) != null ){
						document.getElementById(lastAddressForFreeGift).focus();
					}
				}
			}
		} else if (CheckoutHelperJS.getLastFocus() != '' && tabPressed) {
			tabPressed = false;
			if (document.getElementById(CheckoutHelperJS.getLastFocus()) != null){
				document.getElementById(CheckoutHelperJS.getLastFocus()).focus();
			}else{
				var lastAddress = CheckoutHelperJS.getLastFocus();
				var lastAddressArray = lastAddress.split("_");
				var lastAddressOrderId = (parseInt(lastAddressArray[lastAddressArray.length - 1]) + 1) + '';
				if (lastAddress.indexOf('WC_ShippingAddressSelectMultiple_link_2_') > -1){
					var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_2_' + lastAddressOrderId;
					if (document.getElementById(lastAddressForFreeGift) != null ){
						document.getElementById(lastAddressForFreeGift).focus();
					}
				}else{
					var lastAddressForFreeGift = 'WC_ShippingAddressSelectMultiple_link_3_' + lastAddressOrderId;
					if (document.getElementById(lastAddressForFreeGift) != null ){
						document.getElementById(lastAddressForFreeGift).focus();
					}
				}
			}
			CheckoutHelperJS.setLastFocus('');
		}
	};

	// initialize widget
	myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
};

function declareMultipleShipmentShipChargeRefreshArea() {

	var contextName = "multipleShipmentShipChargeContext";
	var widgetName = "WC_MultipleShipmentDisplay_ShipCharge_Area";
	var myWidgetObj = $("#"+widgetName);

	if (!wcRenderContext.checkIdDefined(contextName)) {
		wcRenderContext.declare(contextName, [],null);
	}
	var myRCProperties = wcRenderContext.getRenderContextProperties(contextName);
	wcRenderContext.addRefreshAreaId(contextName, widgetName);

	// model change
	wcTopic.subscribe(["OrderItemAddressShipMethodUpdate","AjaxDeleteOrderItemForShippingBillingPage"], function(data) {
		if (SBControllersDeclarationJS.shipChargeEnabled) {
			if (data.actionId=="OrderItemAddressShipMethodUpdate") {
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			}
			if (data.actionId=="AjaxDeleteOrderItemForShippingBillingPage") {
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			}
		}
	});

	var postRefreshHandler = function() {
		cursor_clear();
	};

	// initialize widget
	myWidgetObj.refreshWidget({postRefreshHandler: postRefreshHandler});
};

/**
 * Refresh controller declaration for shipping address edit area for DOMOrderShippingBillingDetails.jsp.
 * @constructor
 */
function declareDOMEditShippingAdddressAreaController() {
	var contextName = "editShippingAddressContext";
	var widgetName = "editShippingAddressArea1";

	var myWidgetObj = $("#" + widgetName);
	var myRCProperties = wcRenderContext.getRenderContextProperties(contextName);
	wcRenderContext.addRefreshAreaId(contextName, widgetName);

	wcTopic.subscribe(address_updated, function() {
		//This means, invokeService for Address Add/Edit has been called..so upadate our select box area
		wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
		cursor_clear();
	});

	myWidgetObj.refreshWidget({
		renderContextChangedHandler: function() {
			if (wcRenderContext.testForChangedRC(contextName, ["shippingAddress"])) {
				var addressId = myRCProperties["shippingAddress"];
				//reset the addressID..so that when user selects create address next time it works properly..
				myRCProperties["shippingAddress"] = 0;
				var addressType = myRCProperties["addressType"];
				myWidgetObj.refreshWidget("refresh", {"addressId": addressId,"addressType":addressType});
			}
		},

		postRefreshHandler: function() {
			cursor_clear();
		}
	});

};

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

//
//

/**
 * @fileOverview This file declares services that are used in the store check-out pages.
 */


/**
 * This file declares services that are used in the store check-out pages.
 *
 * @class This SBServicesDeclarationJS class defines all the variables and functions for the page(s) that use shipping and billing functionality in the store.
 *
 */
SBServicesDeclarationJS = {
	/**
	 * This variable stores the ID of the language that the store is currently using.
	 *
	 * @private
	 */
	langId: "-1",

	/**
	 * This variable stores the ID of the current store.
	 *
	 * @private
	 */
	storeId: "",

	/**
	 * This variable stores the ID of the catalog that is used in the store.
	 *
	 * @private
	 */
	catalogId: "",

	/**
	 * This variable stores the true/false value that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 * When it is true, both shipping and billing information are captured in a single page. If it is false, checkout will
	 * be a two step process where shipping is captured in first step and billing in second step.
	 * It is set to true by default.
	 *
	 * @private
	 */
	singlePageCheckout:true,

	/**
	 * This variable stores the value that indicates if an <code>OrderProcessServiceOrderPrepare</code> service call is required.
	 *
	 * @private
	 */
	orderPrepare: false,


	/**
 	 * Sets the common parameters for this instance.
 	 *
 	 * @param {int} langId The ID of the language used in the store.
 	 * @param {int} storeId The ID of the store.
 	 * @param {catalogId} catalogId The ID of the catalog used in the store.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	},


	/**
	 * Sets the SinglePageCheckout variable to indicate if the 'SinglePageCheckout' feature is enabled or disabled.
	 *
	 * @param {Boolean} singlePageCheckout. A true/false value that indicates if the 'SinglePageCheckout' feature is enabled.
	 *
	 * @see CheckoutHelperJS.isSinglePageCheckout
	 */
	setSinglePageCheckout:function(singlePageCheckout){
		this.singlePageCheckout = singlePageCheckout;
	},


	/**
	 * Returns the singlePageCheckout variable that indicates if the 'SinglePageCheckout' feature is enabled/disabled.
	 *
	 * @returns {Boolean} singlePageCheckout A true/false value that indicates if the 'SinglePageCheckout' feature is
	 * enabled/disabled.
	 *
	 * @see CheckoutHelperJS.setSinglePageCheckout
	 */
	isSinglePageCheckout:function(){
		return this.singlePageCheckout;
	}

}

/**
 * Declares an AJAX service that adds an item to the wish list and delete an item from the shopping cart.
 * @constructor
 */
wcService.declare({
	id: "AjaxInterestItemAddAndDeleteFromCart",
	actionId: "AjaxInterestItemAddAndDeleteFromCart",
	url: "AjaxInterestItemAdd",
	formId: ""

	/**
	 * Hides the progress bar and deletes the order item from the shopping cart.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping address and shipping method for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipMethodUpdate",
	actionId: "OrderItemAddressShipMethodUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates the shipping charge type for items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxOrderShipChargeUpdate",
	actionId: "AjaxOrderShipChargeUpdate",
	url: "AjaxShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		/*
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		*/
		var params = [];
		params.orderId = ".";
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		wcService.invoke("AjaxPrepareOrderForShipChargeUpdate", params);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 *This service calculates charges, performs inventory actions, and locks the
 *price of the order to indicate that the order can be submitted.
 *A message is displayed after the service call.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderForShipChargeUpdate",
	actionId: "AjaxPrepareOrderForShipChargeUpdate",
	url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
	formId: ""
    /**
   * hides all the messages and the progress bar
   * @param (object) serviceResponse The service response object, which is the
   * JSON object returned by the service invocation
   */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
			cursor_clear();
	}

    /**
   * hides all the messages and the progress bar
   * @param (object) serviceResponse The service response object, which is the
   * JSON object returned by the service invocation
   */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping address and shipping instruction for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipInstructionsUpdate",
	actionId: "OrderItemAddressShipInstructionsUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Invokes the <code>OrderItemAddressShipInstructionsUpdate1</code> service if shipping instructions were specified, otherwise hides all the messages and the progress bar
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var params = [];
		params.orderId = ".";
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		params.calculateOrder = "1";

		//Check if Shipping Instructions is enabled
		if(document.getElementById("shipInstructions") != null){
			var shipInstructions = document.getElementById("shipInstructions").value;
			var orderItemId = document.getElementById("orderItem_1").value;

			params["shipInstructions"] = shipInstructions;
			params["orderItemId"] = orderItemId;

			wcService.invoke("OrderItemAddressShipInstructionsUpdate1", params);
		} else {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that updates the shipping instruction for items in the order.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipInstructionsUpdate1",
	actionId: "OrderItemAddressShipInstructionsUpdate1",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates the shipping method for items in the order. This service is used to move all order items to single addressId and shipModeId when a user clicks on the single shipment button.
 * @constructor
 */
wcService.declare({
	id: "OrderItemAddressShipMethodUpdate1",
	actionId: "OrderItemAddressShipMethodUpdate1",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Invokes the <code>OrderChangeServiceShipInfoUpdate</code> service, then redirects the browser to OrderShippingBillingView.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		//Store the ids
		var storeId = CheckoutHelperJS.storeId;
		var catalogId = CheckoutHelperJS.catalogId;
		var langId = CheckoutHelperJS.langId;
		var orderId = serviceResponse.orderId;

		//Obtain the shipmode id for the first order item
		var orderItemId = document.getElementById("orderItem_1").value;
		var commonShipModeId = document.getElementById("commonShipModeId").value;
		if(commonShipModeId !=null && commonShipModeId!='undefined'){
			var shipModeId = commonShipModeId;
		}else{
			var shipModeId = document.getElementById("MS_ShippingMode_"+orderItemId).value;
		}

		var postRefreshHandlerParameters = [];
		var initialURL = "AjaxRESTOrderShipInfoUpdate";
		var urlRequestParams = [];
		urlRequestParams["remerge"] = "***";
		urlRequestParams["check"] = "*n";
		urlRequestParams["allocate"] = "***";
		urlRequestParams["backorder"] = "***";
		urlRequestParams["storeId"] = storeId;
		urlRequestParams["catalogId"] = catalogId;
		urlRequestParams["langId"] = langId;
		urlRequestParams["orderId"] = orderId;
		urlRequestParams["shipModeId"] = shipModeId;
		urlRequestParams["calculationUsage"] = "-1,-2,-3,-4,-5,-6,-7";
		urlRequestParams["calculateOrder"] = "1";

		//do not want to pass an empty purchaseorder_id to OrderChangeServiceShipInfoUpdate because it'll cause an failure in OrderFacadeClient.java
		var purchaseorderRef = document.getElementById("purchase_order_number");
		if(purchaseorderRef){
			var purchaseorder_id = purchaseorderRef.value;
			if(purchaseorder_id !=null && purchaseorder_id !='undefined' && purchaseorder_id !=''){
				urlRequestParams["purchaseorder_id"] = purchaseorder_id;
			}
		}
		//checks to see if quick checkout is enabled to display the credit card masked info  by checking the valueFromProfileOrder parameter
		if (valueFromProfileOrderElement = document.getElementsByName("valueFromProfileOrder")[0]&&valueFromProfileOrderElement.value == 'Y') {
			urlRequestParams["quickCheckoutProfileForPayment"] = "true";
		}
		postRefreshHandlerParameters.push({"URL":"OrderShippingBillingView","requestType":"GET", "requestParams":{}});
		var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
		service.invoke(urlRequestParams);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if(serviceResponse.errorMessageKey == '_ERR_INVALID_ADDR'){
			MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_SWITCH_SINGLE_SHIPMENT"]);
		} else {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
		}
		cursor_clear();
	}
}),

/**
 * Declares an AJAX service that updates the shipping address for items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxUpdateOrderItemsAddressId",
	actionId: "AjaxUpdateOrderItemsAddressId",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * After service was successfully performed, hides all messages and the progress bar.
	 * Otherwise, routes to shipping and billing page.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		CheckoutHelperJS.orderItemIds = [];
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),


/**
 * Declares an AJAX service that adds a billing address during order check-out.
 * @constructor
 */
wcService.declare({
	id: "AddBillingAddressInCheckOut",
	actionId: "AddBillingAddressInCheckOut",
	url: "AjaxPersonChangeServiceAddressAdd",
	formId: ""

	/**
	 * This function renders the area having the context ID contextForMainAndAddressDiv with the specified properties.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
		if (this.formId != '' && document.getElementById(this.formId)){
			serviceResponse.addBillingAddressInCheckOutAddressType = document.getElementById(this.formId).addressType.value;
		}
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
 * This service edits an billing address for the person during checkout. An error message is displayed
 * if the service failed.
 * @constructor
 */
wcService.declare({
	id: "UpdateBillingAddressInCheckout",
	actionId: "UpdateBillingAddressInCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
	formId: ""

/**
 * hides all the messages and the progress bar
 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
 *
 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		wcRenderContext.updateRenderContext('contextForMainAndAddressDiv', {'showArea':'mainContents','hideArea':'editAddressContents'});
	}
 /**
 * display an error message
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that updates shipping information for order items during check-out.
 * @constructor
 */
wcService.declare({
	id: "OrderShippingInfoUpdate",
	actionId: "OrderShippingInfoUpdate",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Clears the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),


/**
 * Declares an AJAX service that prepares order information before submitting the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderBeforeSubmit",
	actionId: "AjaxPrepareOrderBeforeSubmit",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * Submits the order with the name of the payment form.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		CheckoutPayments.getTotalInJSON("OrderPrepare", 'PaymentForm', false);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that prepares order information before submitting the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxPrepareOrderBeforePaymentCapture",
	actionId: "AjaxPrepareOrderBeforePaymentCapture",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * Submits the order with the name of the payment form.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
		CheckoutPayments.showBillingPage();
		cursor_clear();
	}


	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that sets the address ID for all items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetAddressIdOfOrderItems",
	actionId: "AjaxSetAddressIdOfOrderItems",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var url="OrderShippingBillingView?orderId="+(serviceResponse.orderId?serviceResponse.orderId:".")+"&langId="+serviceResponse.langId+"&storeId="+serviceResponse.storeId+"&catalogId="+serviceResponse.catalogId+"&showRegTag=T";
		document.location.href=appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),


/**
 * Declares an AJAX service that sets the shipping mode ID for the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetShipModeIdForOrder",
	actionId: "AjaxSetShipModeIdForOrder",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var url="OrderShippingBillingView?langId="+SBServicesDeclarationJS.langId+"&storeId="+SBServicesDeclarationJS.storeId+"&catalogId="+SBServicesDeclarationJS.catalogId;
		document.location.href=appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),

/**
 * Declares an AJAX service that sets the requested ship date for all items in the order.
 * @constructor
 */
wcService.declare({
	id: "AjaxSetRequestedShipDateForOrder",
	actionId: "AjaxSetRequestedShipDateForOrder",
	url: "AjaxRESTOrderShipInfoUpdate",
	formId: ""

	/**
	 * Redirects the browser to OrderShippingBillingView
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var url = "OrderShippingBillingView?orderId="+(serviceResponse.orderId?serviceResponse.orderId:".")+"&langId="+SBServicesDeclarationJS.langId+"&storeId="+SBServicesDeclarationJS.storeId+"&catalogId="+SBServicesDeclarationJS.catalogId+"&showRegTag=T";
		document.location.href=appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 *
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		document.getElementById("OrderShippingBillingErrorArea").style.display = "block";
		cursor_clear();
	}

}),


/**
* This service adds a shipping and billing address during order check out. An error message is displayed if the service failed.
* @constructor
*/
wcService.declare({
	id: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
	actionId: "AjaxAddShippingAndBillingAddressForPersonDuringCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
	formId: ""

/**
* Hides all the messages and the progress bar
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,successHandler: function(serviceResponse) {
		if (this.formId != ""){
			serviceResponse.originalServiceId = document.getElementById(this.formId).originalServiceId.value;
		}
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

/**
* Displays an error message in case of failure.
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),
/**
* This service updates a shipping and billing address during order check out. An error message is displayed if the service failed.
* @constructor
*/
wcService.declare({
	id: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
	actionId: "AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout",
	url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
	formId: ""

/**
* Hides all the messages and the progress bar
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,successHandler: function(serviceResponse) {
		if (this.formId != ""){
			serviceResponse.originalServiceId = document.getElementById(this.formId).originalServiceId.value;
		}
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

/**
* Displays an error message in case of failure.
* @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
*/
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),
/**
* Declares an AJAX service that deletes payment instructions from the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxDeletePaymentInstructionFromThisOrder",
	actionId: "AjaxDeletePaymentInstructionFromThisOrder",
	url: "AjaxRESTOrderPIDelete",
	formId: ""

	/**
	 * Removes piId from payment objects and payment forms on the page, clears the progress bar.
	 * Invokes the AjaxPrepareOrderBeforeProceedingToSummary service to prepare order information.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		var paymentObj = CheckoutPayments.retrievePaymentObject(serviceResponse["paymentAreaNumber"]);
		if (typeof(paymentObj) != "undefined") {
			paymentObj['piId'] = "";
		}
		cursor_clear();
		if (CheckoutPayments.getPaymentsToDelete().length < 1) {
			cursor_clear();
			if(CheckoutPayments.getPaymentsToAdd().length > 0){
				CheckoutPayments.addPaymentInstructions();
			}else if(CheckoutPayments.getPaymentsToUpdate().length > 0){
				CheckoutPayments.updatePaymentInstructions();
			}else{
				if(!submitRequest()){
					return;
				}
				cursor_wait();
				CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
				CheckoutPayments.showSummaryPage();
				cursor_clear();
			}
		} else {
			CheckoutPayments.deletePaymentInstructions();
		}
	}

	/**
	 * Resets the array object that contains existing payment objects to delete.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		CheckoutPayments.paymentsToDelete = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}

}),


/**
* Declares an AJAX service that adds a payment instruction to the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxAddPaymentInstructionToThisOrder",
	actionId: "AjaxAddPaymentInstructionToThisOrder",
	url: "AjaxRESTOrderPIAdd",
	formId: ""

	/**
	 * Resets the array object that contains payment objects to add. Verifies if there is any payment instruction that needs to be updated.
	 * If there is no payment instruction that needs to be updated, direct the browser to the order summary page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		if (CheckoutPayments.getPaymentsToAdd().length < 1) {
			if(CheckoutPayments.getPaymentsToUpdate().length > 0){
				CheckoutPayments.updatePaymentInstructions();
			}else{
				if(!submitRequest()){
					return;
				}
				resetRequest();
				CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));

			}
		} else {
			CheckoutPayments.addPaymentInstructions();
		}
	}

	/**
	 * Resets the array object that contains existing payment objects to add.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		CheckoutPayments.paymentsToAdd = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		//Payment type promotion: If add payment object failed, then if the number of payment methods is 1, call the service to associate an unbounded payment method with the order.
		if(supportPaymentTypePromotions && CheckoutPayments.numberOfPaymentMethods == 1){
			CheckoutPayments.addNewUnboundPaymentInstruction();
        }
	}

}),

/**
* Declares an AJAX service that updates payment instructions in the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxUpdatePaymentInstructionInThisOrder",
	actionId: "AjaxUpdatePaymentInstructionInThisOrder",
	url: "AjaxRESTOrderPIUpdate",
	formId: ""

	/**
	 * Clears the progress bar, verifies if there is any more payment instruction that needs to be updated.
	 * If there is no more payment instruction that needs to be updated, direct the browser to the order summary page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		if(CheckoutPayments.getPaymentsToUpdate().length < 1){
			if(!submitRequest()){
				return;
			}
			cursor_wait();

			CheckoutPayments.setCommonParameters(SBServicesDeclarationJS.langId,SBServicesDeclarationJS.storeId,SBServicesDeclarationJS.catalogId);
			CheckoutPayments.showSummaryPage();
			cursor_clear();
		}else{
			CheckoutPayments.updatePaymentInstructions();
		}
	}

	/**
	 * Resets the array object that contains existing payment objects to update.
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		CheckoutPayments.paymentsToUpdate = new Array();
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
 * Payment type promotion - START
 */

/**
* Declares an AJAX service that adds an unbounded payment instruction to the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxAddUnboundPaymentInstructionToThisOrder",
	actionId: "AjaxAddUnboundPaymentInstructionToThisOrder",
	url: "AjaxRESTOrderPIAdd",
	formId: ""

	/**
	 * Sets the piId of payment object 1 to the returned piId from the service
	 * call and updates its action to re-add, so that its correctly handled by
	 * the client logic of associating actions to payment objects. Invokes the
	 * AjaxPrepareOrderForPaymentSubmit service to prepare order information.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	 ,successHandler: function(serviceResponse) {
		cursor_clear();

		CheckoutPayments.setPaymentFormPiId(1, serviceResponse.paymentInstruction[0].piId);
		CheckoutPayments.paymentObjects[1]['piId'] = serviceResponse.paymentInstruction[0].piId;
		CheckoutPayments.paymentObjects[1]['action'] = 're-add';

		var params = [];
		params.orderId = serviceResponse.orderId;
		params["storeId"] = CheckoutHelperJS.storeId;
		params["catalogId"] = CheckoutHelperJS.catalogId;
		params["langId"] = CheckoutHelperJS.langId;
		cursor_wait();
		wcService.invoke("AjaxPrepareOrderForPaymentSubmit", params);
 	 }
	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
* Declares an AJAX service that deletes an unbounded payment instruction from the current order.
* @constructor
*/
wcService.declare({
	id: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
	actionId: "AjaxDeleteUnboundPaymentInstructionFromThisOrder",
	url: "AjaxRESTOrderPIDelete",
	formId: ""

	/**
	 * The piId of all payment objects is set to empty string, the
	 * action is set to 'add' or empty string depends on whether the
	 * payment object is in the scope of <code>numberOfPaymentMethods</code>,
	 * so that they are correctly handled by the client logic of associating
	 * actions to payment objects. Invokes addNewUnboundPaymentInstruction
	 * if isSinglePaymentType return true. Else, it
	 * calls the AjaxPrepareOrderForPaymentSubmit service to prepare order
	 * information.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();
		for(var i = 1; i < CheckoutPayments.paymentObjects.length; i++){
			// In order for adding new dummy instruction to calculate payment type promotion,
			// all payment instructions (dummy or non-dummy) were deleted at this point.
			//
			// We also need to clear the card number (the number are shown in: ******1111),
			// since the corresponding non-dummy instruction for paymentObjects[i]['piId'] is deleted.
			if($("#account1_" + i).length ){
				CheckoutPayments.removeCreditCardNumberAndCVV(i, true, true);
				CheckoutHelperJS.paymentDataDirty(i, true);
			}
			CheckoutPayments.setPaymentFormPiId(i,'');
			CheckoutPayments.paymentObjects[i]['piId'] = '';
			if (i > CheckoutPayments.numberOfPaymentMethods){
				CheckoutPayments.paymentObjects[i]['action'] = '';
			} else {
				CheckoutPayments.paymentObjects[i]['action'] = 'add';
			}
		}
		if(CheckoutPayments.isSinglePaymentType()){
			//Add new unbound instruction if is single payment type
			CheckoutPayments.addNewUnboundPaymentInstruction();
		} else {
			 var params = [];
			 params.orderId = serviceResponse.orderId;
			 params["storeId"] = CheckoutHelperJS.storeId;
			 params["catalogId"] = CheckoutHelperJS.catalogId;
			 params["langId"] = CheckoutHelperJS.langId;
			 cursor_wait();
			 wcService.invoke("AjaxPrepareOrderForPaymentSubmit", params);
		}
	}
	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
}),

/**
* Declares an AJAX service that prepares order information before submitting the order.
* @constructor
*/
wcService.declare({
	id: "AjaxPrepareOrderForPaymentSubmit",
	actionId: "AjaxPrepareOrderForPaymentSubmit",
	url: "AjaxRESTOrderPrepare",
	formId: ""

	/**
	 * If required, sets payment objects 2 and above to null. Triggers the
	 * calculation of order total and payment amounts.
	 *
	 * @param (object)
	 *            serviceResponse The service response object, which is the JSON
	 *            object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		cursor_clear();

		/**
		 * We want to update the total and load the payment snippets
		 */
		CheckoutPayments.getTotalInJSON("loadPaymentSnippet", "PaymentForm", true);
	}

	/**
	 * Displays the error message returned with the service response and hides the progress bar.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
	}
})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

if (flowEnabled.SideBySideIntegration) {

	CallCenterIntegrationJS = function() {
		this.lookUpMode = 'lookup';
		this.normalMode = 'normal';

		this.setUpCookies = function(cookieValue){
			var cookieName = "WCC_Mode_"+WCParamJS.storeId;
			// Add new cookie.
			if(cookieValue != undefined && cookieValue != null) {
				if(cookieValue.length > 0){
					setCookie("WCC_Mode_"+WCParamJS.storeId, escapeXml(cookieValue, true), {path:'/', domain:cookieDomain});
				} else {
					//Empty value passed for wccModeCookie. Delete it.
					removeCookie(cookieName);
				}
			}
		};

		this.updateWCParamJS = function(key, value){
			WCParamJS[key] = value;
		};

		this.consumeAddToCartEvent = function(params, customParams){
			var wccModeCookie = getCookie("WCC_Mode_"+WCParamJS.storeId);
			if(wccModeCookie == this.lookUpMode) {
				params.action = "Sending_Product";
				$.extend( params, customParams );
				params = JSON.stringify(params);
				console.debug(params);
				window.parent.postMessage(params, WCParamJS.wcc_integration_origin);
				return true;
			} else {
				return false;
			}
		};

		this.postActionMessage = function(params,actionName){
			var wccModeCookie = getCookie("WCC_Mode_"+WCParamJS.storeId);
			if(wccModeCookie == this.lookUpMode || wccModeCookie == this.normalMode) {
				params.action = actionName;
				params = JSON.stringify(params);
				window.parent.postMessage(params, WCParamJS.wcc_integration_origin);
				return true;
			}
		};

		window.addEventListener("message", function(event) {
			if (event.origin != WCParamJS.wcc_integration_origin) {
				console.warn("Unexpected WCC Integration server - " + event.origin);
				return;
			}
			try {
				console.debug(event.data);
				var data = JSON.parse(event.data);
				if (data.action && data.action === "Requesting_Cart_Details") {
					var orderIdCookie = getCookie("WC_CartOrderId_"+WCParamJS.storeId);
					var params = {};
					params.storeId = WCParamJS.storeId;
					params.action = 'Sending_Cart';
					params.custId = WCParamJS.logonId;
					params.orderId = orderIdCookie;
					event.source.postMessage(JSON.stringify(params), event.origin);
				} else if (data.action && data.action === "ADD_TO_EXTERNAL_CART_SUCCESS") {
						cursor_clear();
				} else if(data.action && data.action === "TERMINATE_ON_BEHALF_SESSION"){
					if(typeof GlobalLoginShopOnBehalfJS != 'undefined' && GlobalLoginShopOnBehalfJS != undefined && GlobalLoginShopOnBehalfJS != null){
						GlobalLoginShopOnBehalfJS.restoreCSRSessionAndRedirect(data.redirectURL);
					}
				} else if(data.action && data.action === "SET_USER_IN_SESSION"){
					if(typeof registeredCustomersJS != 'undefined' && registeredCustomersJS != undefined && registeredCustomersJS != null){
						registeredCustomersJS.setUserInSession(data.userId, data.userName, data.redirectURL);
					}
				}

			} catch (e) {
				// Likely invalid message.  Ignore or handle other messages here.
				console.warn("Unexpected message: " + event.data);
			}
		});
	};

	$(document).ready(function(){
		callCenterIntegrationJS = new CallCenterIntegrationJS();
	});

}

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not.
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected.
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /**
     * stores all name and value of all swatches
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids.
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone.
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone.
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry.
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML.
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";

        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     *
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call.
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object.
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /**
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     *
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /**
     * Displays price of the attribute selected with the JSON oject.
     *
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     *
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     *
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     *
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     *
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link

			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);



                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML.
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
shoppingActionsServicesDeclarationJS = {
	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
			cursor_clear();
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}
			wcTopic.publish('ProductAddedToCart');
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
 		            MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG)
 		        } else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else if ("_API_CANT_RESOLVE_FFMCENTER" == e.errorMessageKey) {
 		            MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG)
 		        } else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides the common render context variables and functions,
 * and defines all the render contexts needed throughout the store.
 */

/**
 * @class The CommonContextsJS class defines all the common variables and functions
 * for the render contexts across all store pages.
 */
CommonContextsJS = {
	/**
	 * This variable stores the ID of the language that the store is currently using.
	 * @private
	 */
	langId: "-1",

	/**
	 * This variable stores the ID of the current store.
	 * @private
	 */
	storeId: "",

	/**
	 * This variable stores the ID of the catalog that is used in the store.
	 * @private
	 */
	catalogId: "",

	/**
	 * Sets the common ids used in the store - language id, store id, and catalog id.
	 *
	 * @param {string} langId The id of the store language.
	 * @param {string} storeId The id of the store.
	 * @param {string} langId The id of the catalog used in the store.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	},

	/**
	 * Updates the specified context's property and assign it the desired value.
	 *
	 * @param {string} contextId The id of the render context
	 * @param {string} property The name of the context's property to update
	 * @param {string} value The value to update the specified property to
	 */
	setContextProperty:function(contextId,property,value){
        wcRenderContext.getRenderContextProperties(contextId)[property] = value;
	}

}

/**
 * Declares a new render context for Multiple Shipment Shipping & Billing display.
 */
wcRenderContext.declare("multipleShipmentDetailsContext", [], {shipmentDetailsArea: "update"}),

/**
 * Declares a new render context for Single Shipment Shipping Charge display.
 */
wcRenderContext.declare("singleShipmentShipChargeContext", [], null),

/**
 * Declares a new render context for Multiple Shipment Shipping Charge display.
 */
wcRenderContext.declare("multipleShipmentShipChargeContext", [], null),

/**
 * Declares a new render context for Single Shipment Shipping & Billing display.
 */
wcRenderContext.declare("traditionalShipmentDetailsContext", [], {shipmentDetailsArea: "update"}),

/**
 * Declares a new render context for the Current Order Totals display.
 */
wcRenderContext.declare("currentOrder_Context", [], null),

/**
 * Declares a new render context for creating/editing the shipping address
 * and initializes it with the shipping address id and address type to the default placeholder values.
 */
wcRenderContext.declare("editShippingAddressContext", [], {shippingAddress: "0",addressType: "ShippingAndBilling"}),

/**
 * Declares a new render context for dealing with states for the shipping addresses in all shipments
 * and initializes it with the shipping address id to the default placeholder values.
 */
wcRenderContext.declare("shippingAddressContext",[],{shippingAddress: "0"});

/**
 * Declares a new render context for the select Billing Address dropdowns,
 * and initializes each Billing Address dropdown with address id and billing url placeholders.
 * Even though BillingURL1, 2, 3 point to same BillingAddressDropDisplay.jsp we cannot use only one URL to submit 3 requests.
 * There are 3 billing dropdown boxes in the Checkout page and all needs to be refreshed on address add/change.
 * But using the same URL and submitting 3 requests separately to refresh 3 dropdown boxes doesn't work,
 * and invariably one of the request doesn't come back with response. Solution is to use 3 different URLs as a workaround.
 * BillingURL1,2,3 are set to correct <c:url values in .JSP page using setContextPRoperty method..
 */
wcRenderContext.declare("billingAddressDropDownBoxContext", [], {billingAddress1: "0", billingAddress2: "0", billingAddress3: "0", billingURL1: "",billingURL2:"",billingURL3:"",areaNumber:'0',payment1: "", payment2: "", payment3: "", paymentTCId1: "", paymentTCId2: "", paymentTCId3: ""}),

/**
 * Declares a new render context for 3 payment areas
 * and initializes it with the payment method names, current area number, billing modes and current total price to the default placeholder values.
 * When the context changes the corresponding controller will be used and the paymentArea div will be populated with the required JSP file, based on the
 * selection made...ex: if Visa brand is selected in payment1, then paymentArea1 will get populated with contents of Visa.jsp
 */
wcRenderContext.declare("paymentContext", [], {payment1: "empty", payment2: "empty", payment3: "empty", currentAreaNumber: "1", billingMode1: "none", billingMode2: "none", billingMode3: "none",currentTotal:"0"}),

/**
 * Declares a new render context for showing/hiding the address form on the Checkout pages,
 * and initializes the show and hide area to a placeholder value.
 */
wcRenderContext.declare("contextForMainAndAddressDiv", [], {showArea: "0",hideArea: "0"}),

/**
 * Declares a new render context for the select Shipping Address dropdown.
 */
wcRenderContext.declare("shippingAddressDropDownBoxContext", [], {}),

/**
 * Declares a new render context for the Category display with pagination.
 */
wcRenderContext.declare("CategoryDisplay_Context", [], {pageView:"", beginIndex:""}),

/**
 * Declares a new render context for the Sub-category display with pagination.
 */
wcRenderContext.declare("SubCategoryDisplay_Context", [], null),

/**
 * Declares a new render context for Shopping Cart with pagination,
 * and initializes it with the beginning index value.
 */
wcRenderContext.declare("ShopCartPaginationDisplay_Context", [], {}),
/**
* Declares a new render context for Pending order details page with pagination,
* and initializes it with the beginning index value.
*/
wcRenderContext.declare("PendingOrderPaginationDisplay_Context", [], {}),
/**
* Declares a new render context for the pending order details page with pagination,
* and initializes it with the beginning index value.
*/
wcRenderContext.declare("PendingOrderDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for Single Shipment Order Summmary/Confirmation with pagination,
 * and initializes it with the beginning index value.
 */
wcRenderContext.declare("OrderItemPaginationDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for the Order Status Details with pagination,
 * and initializes it with the beginning index value.
 */
wcRenderContext.declare("OrderDetailPaginationDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for Multiple Shipment Order Summary/Confirmation with pagination,
 * and initializes it with the beginning index value.
 */
wcRenderContext.declare("MSOrderItemPaginationDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for the Coupon Wallet display.
 */
wcRenderContext.declare("CouponDisplay_Context", [], null),
/**
 * Declares a new render context for the Promotion Choice of free gifts pop-up display.
 */
wcRenderContext.declare("PromotionFreeGifts_Context", [], {}),

/**
 *  Declares a new render context for the saved orders list.
 */
wcRenderContext.declare("ListOrdersDisplay_Context", [], {startNumber: "0"}),

/**
 * Declares a new render context for the scheduled orders status display.
 */
wcRenderContext.declare("ScheduledOrdersStatusDisplay_Context", [], {beginIndex: "0", selectedTab: "Scheduled"}),

/**
 * Declares a new render context for the processed orders status display.
 */
wcRenderContext.declare("ProcessedOrdersStatusDisplay_Context", [], {beginIndex: "0", selectedTab: "PreviouslyProcessed"}),

/**
 * Declares a new render context for the waiting-for-approval orders status display.
 */
wcRenderContext.declare("WaitingForApprovalOrdersStatusDisplay_Context", [], {beginIndex: "0", selectedTab: "WaitingForApproval"}),

/**
 * Declares a new render context for the Browsing History Espot.
 */
wcRenderContext.declare("BrowsingHistoryContext", [], {status:"init"}),

/**
 * Declares a new render context for the Browsing History Display in My Account.
 */
wcRenderContext.declare("BrowsingHistoryDisplay_Context", [], {currentPage: "0", pageView: ""}),

/**
 * Declares a new render context for the subscription display area on category pages.
 */
wcRenderContext.declare("CategorySubscriptionContext", [], null),

/**
 * Declares a new render context for the recurring order display.
 */
wcRenderContext.declare("RecurringOrderDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for the subscription display.
 */
wcRenderContext.declare("SubscriptionDisplay_Context", [], {beginIndex: "0"}),

/**
 * Declares a new render context for the recent recurring order display.
 */
wcRenderContext.declare("RecentRecurringOrderDisplay_Context", [], {beginIndex: "0",isMyAccountMainPage:"true"}),

/**
 * Declares a new render context for the recent subscription display.
 */
wcRenderContext.declare("RecentSubscriptionDisplay_Context", [], {beginIndex: "0",isMyAccountMainPage:"true"}),

/**
 * Declares a new render context for the recurring order child orders display.
 */
wcRenderContext.declare("RecurringOrderChildOrdersDisplay_Context", [], {beginIndex: "0",orderId: ""}),

/**
 * Declares a new render context for the subscription child orders display.
 */
wcRenderContext.declare("SubscriptionChildOrdersDisplay_Context", [], {beginIndex: "0",orderItemId: "",subscriptionName: ""}),

/**
 * Declares a new render context for the QuickInfo.
 */
wcRenderContext.declare("QuickInfoContext", ["quickInfoRefreshArea"], {}),

/**
 * Declares a new render context for the Discounts.
 */
wcRenderContext.declare("DiscountDetailsContext", [], null),

/**
 * Declares a new render context for the Discounts in quick info.
 */
wcRenderContext.declare("QuickInfoDiscountDetailsContext", [], {}),

/**
 * Declares a new render context for double content area espot.
 */
wcRenderContext.declare("DoubleContentAreaESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for scrollable espot.
 */
wcRenderContext.declare("ScrollableESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for top categories espot.
 */
wcRenderContext.declare("TopCategoriesESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for featured products in category espot.
 */
wcRenderContext.declare("CategoryFeaturedProductsESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for home hero espot.
 */
wcRenderContext.declare("HomeHeroESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for home left espot.
 */
wcRenderContext.declare("HomeLeftESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for home right top espot.
 */
wcRenderContext.declare("HomeRightTopESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for home right bottom espot.
 */
wcRenderContext.declare("HomeRightBottomESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for tall double espot.
 */
wcRenderContext.declare("TallDoubleContentAreaESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for top category hero espot.
 */
wcRenderContext.declare("TopCategoryHeroESpot_Context", [], {emsName: ""}),

/**
 * Declares a new render context for top category tall double espot.
 */
wcRenderContext.declare("TopCategoryTallDoubleESpot_Context", [], {emsName: ""}),


wcRenderContext.declare("AttachmentPagination_Context", [], {beginIndex: "0"})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides the common controller variables and functions,
 * and links these controllers to listen to the defined render contexts in CommonContextsDeclarations.js.
 */

/**
 * @class The CommonControllersDeclarationJS class defines all the common variables and functions
 * for the controllers of the defined render contexts across all store pages.
 */
CommonControllersDeclarationJS = {

	/**
        * This variable stores the ID of the language that the store is currently using.
        * @private
        */
       langId: "-1",

       /**
        * This variable stores the ID of the current store.
        * @private
        */
       storeId: "",

       /**
        * This variable stores the ID of the catalog that is used in the store.
        * @private
        */
       catalogId: "",

       /**
        * Sets the common ids used in the store - language id, store id, and catalog id.
        *
        * @param {string} langId The id of the store language.
        * @param {string} storeId The id of the store.
        * @param {string} langId The id of the catalog used in the store.
        */
       setCommonParameters:function(langId,storeId,catalogId){
              this.langId = langId;
              this.storeId = storeId;
              this.catalogId = catalogId;
       },

       /**
        * Sets the URL of the specified refresh area.
        *
        * @param {string} refreshAreaId The id of the target refresh area.
        * @param {string} url The link to specify for the refresh area.
        */
       setRefreshURL:function(refreshAreaId,url){
              $("#" + refreshAreaId).attr("refreshurl", url);
       },

        declareAccountCouponRefreshArea:function() {
            // ============================================
            // div: CouponDisplay_Widget refresh area
            // Declares a new refresh controller for Coupon Wallet display.
            var myWidgetObj = $("#CouponDisplay_Widget");

            // model change
            wcTopic.subscribe(["AjaxCouponsAddRemove","AjaxWalletItemProcessServiceDelete"], function() {
                myWidgetObj.refreshWidget("refresh");
            });

            // initialize widget
            myWidgetObj.refreshWidget();
        },

        declareShopCartDisplayRefreshArea: function() {
					// ============================================
					// div: ShopCartDisplay refresh area
					// Declares a new refresh controller for the Shopping Cart display.
					var myWidgetObj = $("#ShopCartDisplay");
					var myRCProperties = wcRenderContext.getRenderContextProperties("ShopCartPaginationDisplay_Context");
					
					/**
					 * Refreshs the shopping cart area when an update to the order is made,
					 * such as add/remove items or update quantity/promotions etc.
					 * This function is called when a modelChanged event is detected.
					 */
						wcTopic.subscribe(order_updated, function() {
							myWidgetObj.refreshWidget("refresh", myRCProperties);
							submitRequest(); //Till shop cart is refreshed, do not allow any other requests..
							cursor_wait();
            });

            /**
             * Displays the discounts and promotions area upon a successful refresh.
             *
             * @param {object} widget The registered refresh area
             */
            var postRefreshHandler = function () {
                resetRequest(); //Shop cart is refreshed, give the control to shopper...
                if (typeof(savedOrdersJS) != null && typeof(savedOrdersJS) != 'undefined') {
                    savedOrdersJS.isCurrentOrderPage(true);
                }
                // Order level discount tooltip section - if the tooltip is defined, show the section after area is refreshed
                $("#discountDetailsSection").css("display", "block");
                // Promotion code tooltip section - if the tooltip is defined, show the section after area is refreshed
                $("#appliedPromotionCodes").css("display", "block");

                // select the proper shipmode that is saved in the cookie
                var orderId = myRCProperties["orderId"];
                if ($("#currentOrderId").length) {
                    orderId = document.getElementById("currentOrderId").value;
                }
                ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(orderId);
                if ($("#OrderFirstItemId").length) {
                    ShipmodeSelectionExtJS.orderItemId = document.getElementById("OrderFirstItemId").value;
                }

                // evaluate scripts in shopping list
								/* TODO - Fix globalEval issue later.
                $('div[id^="shoppingListScript_"]').each(function(i, e) {
                   $.globalEval($(e).html());
                });

                $('input[id^="orderItem_"]').each(function(i, e) {
                    if ($('addToRequisitionListScript_' + $(e).val()) != null) {
                        $.globalEval($('addToRequisitionListScript_' + $(e).val()).html());
                    }
                    if ($('addReqListsJS_' + $(e).val()) != null) {
                        $.globalEval('addReqListsJS' + $(e).val() + '.setCatEntryId("' + $('catalogId_' + $(e).attr("id").substring($(e).attr("id").indexOf('_')+1)).val() + '");');
                    }
                });*/

                cursor_clear();
							/* APPLEPAY BEGIN */
							if (typeof(showApplePayButtons) == "function") {
								showApplePayButtons();
							}
							/* APPLEPAY END */
		
            };

            // initialize widget
						myWidgetObj.refreshWidget({postRefreshHandler: postRefreshHandler});
        },

		declareShopCartPagingDisplayRefreshArea: function() {
            // ============================================
            // div: ShopCartPagingDisplay refresh area
            // Declares a new refresh controller for the Shopping Cart pagination display.
            var myWidgetObj = $("#ShopCartPagingDisplay");
			wcRenderContext.addRefreshAreaId("ShopCartPaginationDisplay_Context", "ShopCartPagingDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("ShopCartPaginationDisplay_Context");
		   /**
			* Displays the previous/next page of order items in the shopping cart.
			* This function is called when a render context changed event is detected.
			*
			* @param {string} message The render context changed event message
			* @param {object} widget The registered refresh area
			*/
			var renderContextChangedHandler = function() {
				if(wcRenderContext.testForChangedRC("ShopCartPaginationDisplay_Context", ["beginIndex"])){
                     myWidgetObj.refreshWidget("refresh", myRCProperties);
				}
            };

		   /**
			* Hide the progress bar upon a successful refresh.
			*
			* @param {object} widget The registered refresh area
			*/
            var postRefreshHandler = function () {
              cursor_clear();

              //select the proper shipmode that is saved in the cookie
              var orderId = myRCProperties["orderId"];
              if(document.getElementById("currentOrderId")) {
                orderId = document.getElementById("currentOrderId").value;
              }
              ShipmodeSelectionExtJS.displaySavedShipmentTypeForOrder(orderId);
              // evaluate scripts in shopping list
              $('div[id^="shoppingListScript_"]').each(function(i, e){
                 $.globalEval($(e).html());
              });
              $('input[id^="orderItem_"]').each(function(i,orderItem) {
                if($('addToRequisitionListScript_' + orderItem.value) != null){
                      $.globalEval($('addToRequisitionListScript_' + orderItem.value).innerHTML);
                }
                if($('addReqListsJS_' + orderItem.value).length != 0){
                  $.globalEval('addReqListsJS' + orderItem.value + '.setCatEntryId("' + $('catalogId_' + (orderItem.id.substring(orderItem.id.indexOf('_') + 1))).value + '");');
                }
              });
			};

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

		declarePromotionFreeGiftsDisplayRefreshArea: function() {
            // ============================================
            // div: PromotionFreeGiftsDisplay refresh area
            // Declares a new refresh controller for the Promotion Free Gifts display.
            var myWidgetObj = $("#PromotionFreeGiftsDisplay");
            wcRenderContext.addRefreshAreaId("PromotionFreeGifts_Context", "PromotionFreeGiftsDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("PromotionFreeGifts_Context");


			var renderContextChangedHandler = function() {
				myWidgetObj.refreshWidget("refresh", myRCProperties);
            };

            var postRefreshHandler = function () {
			    PromotionChoiceOfFreeGiftsJS.showFreeGiftsDialog();
			};

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareRecentRecurringOrderDisplayRefreshArea: function() {
            // ============================================
            // div: RecentRecurringOrderDisplay refresh area
            // Declares a new refresh controller for Recent Recurring Orders in My Account landing page.
            var myWidgetObj = $("#RecentRecurringOrderDisplay");
            wcRenderContext.addRefreshAreaId("RecentRecurringOrderDisplay_Context", "RecentRecurringOrderDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("RecentRecurringOrderDisplay_Context");

            /**
             * Displays the previous/next page of recurring orders.
             * This function is called when a render context changed event is detected.
             */
            wcTopic.subscribe("AjaxCancelSubscription", function () {
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            });

            /**
            * Hide the progress bar upon a successful refresh.
            */
            var postRefreshHandler = function() {
                cursor_clear();
            };

            // initialize widget
            myWidgetObj.refreshWidget({postRefreshHandler: postRefreshHandler});
        },

        declareRecentSubscriptionDisplayRefreshArea: function() {
            // ============================================
            // div: RecentSubscriptionDisplay refresh area
            // Declares a new refresh controller for recent Subscription display in My Account landing page.
            var myWidgetObj = $("#RecentSubscriptionDisplay");
            wcRenderContext.addRefreshAreaId("RecentSubscriptionDisplay_Context", "RecentSubscriptionDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("RecentSubscriptionDisplay_Context");

            /**
             * Displays the previous/next page of subscriptions.
             * This function is called when a render context changed event is detected.
             */
            wcTopic.subscribe("AjaxCancelSubscription", function () {
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            });

            /**
            * Hide the progress bar upon a successful refresh.
            */
            var postRefreshHandler = function() {
                cursor_clear();
            };

            // initialize widget
            myWidgetObj.refreshWidget({postRefreshHandler: postRefreshHandler});
        },

        declareOrderItemPaginationDisplayRefreshArea: function(widgetId) {
            // ============================================
            // old controller: OrderItemPaginationDisplayController
            // div: OrderConfirmPagingDisplay refresh area
            // Declares a new refresh controller for Single Shipment Order Item display with pagination
            // on the Order Summary and Confirmation pages.
        	if(typeof widgetId == "object" || typeof widgetId == "array") {
        		widgetId = widgetId[0];
        	}

            var myWidgetObj = $("#" + widgetId);
            wcRenderContext.addRefreshAreaId("OrderItemPaginationDisplay_Context", widgetId);
            var myRCProperties = wcRenderContext.getRenderContextProperties("OrderItemPaginationDisplay_Context");

            /**
             * Displays the previous/next page of order items for Single Shipment Order Summary/Confirmation display.
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                if (wcRenderContext.testForChangedRC("OrderItemPaginationDisplay_Context", ["beginIndex"])){
                	myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            }

            /**
             * Hide the progress bar upon a successful refresh.
             */
            var postRefreshHandler = function() {
                cursor_clear();
                if (myRCProperties["analytics"] == 'true') {
                    wcTopic.publish("order_contents_ProductRec", $("#orderPartNumbers").val());
                }
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareRecurOrderDisplayRefreshArea: function() {
            // ============================================
            // div: RecurringOrderDisplay refresh area
            // Declares a new refresh controller for Recurring Order display with pagination
            // in My Recurring Order page.
            var myWidgetObj = $("#RecurringOrderDisplay");
            wcRenderContext.addRefreshAreaId("RecurringOrderDisplay_Context", "RecurringOrderDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("RecurringOrderDisplay_Context");

            /**
             * Displays the previous/next page of recurring orders.
             * This function is called when a render context changed event is detected.
             */

            wcTopic.subscribe("AjaxCancelSubscription", function () {
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            });


            var renderContextChangedHandler = function() {
                if(wcRenderContext.testForChangedRC("RecurringOrderDisplay_Context", ["beginIndex"])){
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            }

            /**
             * Hide the progress bar upon a successful refresh.
             */
            var postRefreshHandler = function() {
                cursor_clear();
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareRecurOrderChildOrdersRefreshArea: function() {
            // ============================================
            // div: RecurringOrderChildOrdersDisplay refresh area
            // Declares a new refresh controller for Recurring Order child orders display with pagination
            // in Recurring Order Details History page.
            var myWidgetObj = $("#RecurringOrderChildOrdersDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("RecurringOrderChildOrdersDisplay_Context");

            /**
             * Displays the previous/next page of recurring orders.
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                if(wcRenderContext.testForChangedRC("RecurringOrderChildOrdersDisplay_Context", ["beginIndex"])){
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            };

            /**
             * Hide the progress bar upon a successful refresh.
             */
            var postRefreshHandler = function() {
                cursor_clear();
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareSubscriptionDisplayRefreshArea: function() {
            // ============================================
            // div: SubscriptionDisplay refresh area
            // Declares a new refresh controller for Subscription display with pagination
            // in My Subscription page.
            var myWidgetObj = $("#SubscriptionDisplay");
            wcRenderContext.addRefreshAreaId("SubscriptionDisplay_Context", "SubscriptionDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("SubscriptionDisplay_Context");

            /**
             * Displays the previous/next page of subscriptions.
             * This function is called when a render context changed event is detected.
             */
            wcTopic.subscribe("AjaxCancelSubscription", function () {
                myWidgetObj.refreshWidget("refresh", myRCProperties);
            });


            var renderContextChangedHandler = function() {
                if(wcRenderContext.testForChangedRC("SubscriptionDisplay_Context", ["beginIndex"])){
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            }

            /**
             * Hide the progress bar upon a successful refresh.
             */
            var postRefreshHandler = function() {
                cursor_clear();
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareSubscriptionChildOrdersRefreshArea: function() {
            // ============================================
            // div: SubscriptionChildOrdersDisplay refresh area
            // Declares a new refresh controller for Subscription child orders display with pagination
            // in Subscription Details History page.
            var myWidgetObj = $("#SubscriptionChildOrdersDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("SubscriptionChildOrdersDisplay_Context");

            /**
             * Displays the previous/next page of subscriptions.
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                if(wcRenderContext.testForChangedRC("SubscriptionChildOrdersDisplay_Context", ["beginIndex"])){
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            };

            /**
             * Hide the progress bar upon a successful refresh.
             */
            var postRefreshHandler = function() {
                cursor_clear();
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareQuickInfoDetails: function() {
            var widgetObj = $("#quickInfoRefreshArea"),
                rcProperties = wcRenderContext.getRenderContextProperties("QuickInfoContext");

            widgetObj.refreshWidget({
                formId: "",
                /**
                 * Refreshs the wishlist drop down in the quick info popup.
                 */
                renderContextChangedHandler: function() {
                    widgetObj.refreshWidget("refresh", rcProperties);
                },

                /**
                 * Hide the progress bar upon a successful refresh.
                 */
                postRefreshHandler: function() {
                	if ($("#catEntryParamsForJS").length){
                        var catEntryParams = $.parseJSON($("#catEntryParamsForJS").val());
                    }

                    if ($("#QuickInfostoreParams").length){
                        var storeParams = $("#QuickInfostoreParams").val();
                        var shoppingListNames = $("#QuickInfoshoppingListNames").val();

                        shoppingListJSQuickInfo = new ShoppingListJS($.parseJSON(storeParams), catEntryParams, $.parseJSON(shoppingListNames),"shoppingListJSQuickInfo");


                        if (!this.quickInfoEvenSubscribed){
                            this.quickInfoEvenSubscribed = true;
                            wcTopic.subscribe("DefiningAttributes_Resolved", function(catEntryId, productId) {
                                shoppingListJSQuickInfo.setItemId(catEntryId, productId);
                            });
                            wcTopic.subscribe("QuickInfo_attributesChanged", function(catEntryAttributes) {
                                shoppingListJSQuickInfo.setCatEntryAttributes(catEntryAttributes);
                            });
                            wcTopic.subscribe("Quantity_Changed", function(catEntryQuantityObject) {
                                shoppingListJSQuickInfo.setCatEntryQuantity(catEntryQuantityObject);
                            });
                            wcTopic.subscribe("ShoppingList_Changed", function(serviceResponse) {
                                shoppingListJSQuickInfo.updateShoppingListAndAddItem(serviceResponse);
                            });
                            wcTopic.subscribe("ShoppingListItem_Added", function() {
                                shoppingListJSQuickInfo.deleteItemFromCart();
                            });
                            $("#QuickInfoaddToShoppingListDropdown").on("mouseover", function(){
                                shoppingListJSQuickInfo.mouseOnArrow = true;
                            });
                            $("#QuickInfoShoppingList_0").on("mouseover", function(){
                                shoppingListJSQuickInfo.exceptionFlag = true; $("#QuickInfoShoppingListLink_0").focus();
                            });
                        }

                        var catEntryId = catEntryParams.id;
                        if(null != catEntryId && '' != catEntryId){
                            wcRenderContext.updateRenderContext('QuickInfoDiscountDetailsContext', {productId: catEntryParams.id});
                        }
                    }
                    if ($("#catEntryParamsForJS").length){
                        QuickInfoJS.catEntryParams = $.parseJSON($("#catEntryParamsForJS").val());
                    }
                    //the quick info dialog is hidden by default. We have to display it after the area is refreshed.
                    var quickInfoPopup = $("#quickInfoPopup").data("wc-WCDialog");
                    if (quickInfoPopup) {
                        closeAllDialogs(); //close other dialogs(quickinfo dialog, etc) before opening this.
                        // if itemId is present, then quickInfo popup is from change attribute link in shopping cart page, which will explicitly set the quantity
                        if(QuickInfoJS.itemId == ''){
                            QuickInfoJS.setCatEntryQuantity(1);
                            QuickInfoJS.selectDefaultSwatch();
                        } else {
                            QuickInfoJS.selectCurrentAttributes();
                        }
                        quickInfoPopup.open();
                        // disable dialog re-position for ios and android right after the dialog is opened, this is to avoid virtual keyboard conflict
                        //if (ios || android) {
                        // quickInfoPopup._relativePosition = new Object();
                        //}
                        if(typeof TealeafWCJS !== 'undefined'){
                            TealeafWCJS.rebind("quickInfoPopup");
                        }
                    }else {
                        console.debug("quickInfoPopup does not exist");
                    }
                    cursor_clear();
                }
            });
        },

        /**
         * Refresh controller for fetching discount details for quick info.
         */
        declareQuickInfoDiscountDetailsController: function() {
            var widgetObj = $("#quickInfoDiscountDetailsRefreshArea");
            wcRenderContext.addRefreshAreaId("QuickInfoDiscountDetailsContext", "quickInfoDiscountDetailsRefreshArea");
            var renderContextProperties = wcRenderContext.getRenderContextProperties("QuickInfoDiscountDetailsContext");

            widgetObj.refreshWidget({
                formId: "",
                /**
                 * Refreshes the discount section.
                 */
                renderContextChangedHandler: function() {
                    widgetObj.refreshWidget("refresh", renderContextProperties);
                },
                /**
                 * Hide the progress bar upon a successful refresh.
                 */
                postRefreshHandler: function() {
                    cursor_clear();
                }
            });

        },

		declareMSOrderItemPagingDisplayRefreshArea:function(widgetName) {

			var contextName = "MSOrderItemPaginationDisplay_Context";
			if(typeof widgetName == "object") {
				widgetName = widgetName[0];
			}
			var myWidgetObj = $("#"+widgetName);

			if (!wcRenderContext.checkIdDefined(contextName)) {
				wcRenderContext.declare(contextName, [],null);
			}
			var myRCProperties = wcRenderContext.getRenderContextProperties(contextName);
			wcRenderContext.addRefreshAreaId(contextName, widgetName);

		   /**
			* Displays the previous/next page of order items for Multiple Shipment Order Summary/Confirmation display.
			* This function is called when a render context changed event is detected.
			*
			*/
		   renderContextChangedHandler = function() {
			    if(wcRenderContext.testForChangedRC(contextName,["beginIndex"])){
					myWidgetObj.refreshWidget("refresh", myRCProperties);
				}
		   };

		   /**
			* Hide the progress bar upon a successful refresh.
			*
			* @param {object} widget The registered refresh area
			*/
		   postRefreshHandler = function() {
				  cursor_clear();
				  if (myRCProperties["analytics"] == 'true') {
					  wcTopic.publish("order_contents_ProductRec", $("#orderPartNumbers").value);
				  }
		   };

			// initialize widget
			myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
		},

        /**
         * Declares a new refresh controller for Single Shipment Order Item display with pagination
         * on the Order Summary pages when inegrating with Sterling.
         */
        declareSSFSOrderItemPaginationDisplayController: function() {
            var myWidgetObj = $("#OrderConfirmPagingDisplay");
            wcRenderContext.addRefreshAreaId("OrderItemPaginationDisplay_Context", "OrderConfirmPagingDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("OrderItemPaginationDisplay_Context");

            // initialize widget
            myWidgetObj.refreshWidget({
                /**
                 * Displays the previous/next page of order items for Single Shipment Order Summary/Confirmation display.
                 * This function is called when a render context changed event is detected.
                 */
                renderContextChangedHandler: function() {
                    if(wcRenderContext.testForChangedRC("OrderItemPaginationDisplay_Context", ["beginIndex"])){
                        myWidgetObj.refreshWidget("refresh", myRCProperties);
                    }
                },

                /**
                 * Hide the progress bar upon a successful refresh.
                 */
                postRefreshHandler: function() {
                    var orderStr = document.getElementById("jsonOrderStr").innerHTML;
                    var beginIndex = myRCProperties['beginIndex'];
                    var pageSize = myRCProperties['pageSize'];
                    sterlingIntegrationJS.populateOrderLineInfoForSingleShipment(orderStr, beginIndex, pageSize);
                    cursor_clear();
                }
            });
        },

        /**
         * Declares a new refresh controller for Multiple Shipment Order Item display with pagination
         * on the Order Summary when integrating with Sterling.
         */
        declareSSFSMSOrderItemPaginationDisplayController: function() {
            var myWidgetObj = $("#MSOrderDetailPagingDisplay");
            wcRenderContext.addRefreshAreaId("MSOrderItemPaginationDisplay_Context", "MSOrderDetailPagingDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("MSOrderItemPaginationDisplay_Context");

            // initialize widget
            myWidgetObj.refreshWidget({
                /**
                 * Displays the previous/next page of order items for Multiple Shipment Order Summary/Confirmation display.
                 * This function is called when a render context changed event is detected.
                 */
                renderContextChangedHandler: function() {
                    if(wcRenderContext.testForChangedRC("MSOrderItemPaginationDisplay_Context", ["beginIndex"])){
                        myWidgetObj.refreshWidget("refresh", myRCProperties);
                    }
                },

                /**
                 * Hide the progress bar upon a successful refresh.
                 */
                postRefreshHandler: function() {
                    var orderStr = document.getElementById("jsonOrderStr").innerHTML;
                    var beginIndex = myRCProperties['beginIndex'];
                    var pageSize = myRCProperties['pageSize'];
                    sterlingIntegrationJS.populateOrderLineInfoForMultipleShipment(orderStr, beginIndex, pageSize);
                    cursor_clear();
                }
            });
        }
}

// convert in future - move from CommonControllersDeclaration.js:
        // id: "ShopCartPaginationDisplayController",
        // id: "PendingOrderPaginationDisplayController",
        // id: "ListOrdersDisplay_Controller",
        // id: "PendingOrderDisplayController",
        // id: "BrowsingHistoryController",
        // id: "BrowsingHistoryDisplay_Controller",
        // id: "CategorySubscriptionController",
        // id: "RecentSubscriptionDisplayController",
        // id: "DiscountDetailsController",
        // id: "DoubleContentAreaESpot_Controller",
        // id: "ScrollableESpot_Controller",
        // id: "TopCategoriesESpot_Controller",
        // id: "CategoryFeaturedProductsESpot_Controller",
        // id: "HomeHeroESpot_Controller",
        // id: "HomeLeftESpot_Controller",
        // id: "HomeRightTopESpot_Controller",
        // id: "HomeRightBottomESpot_Controller",
        // id: "TallDoubleContentAreaESpot_Controller",
        // id: "TopCategoryHeroESpot_Controller",
        // id: "TopCategoryTallDoubleESpot_Controller",
        // id: "AttachmentPagination_Controller",

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript file declares services used by Dynamic Kits.
 * @version 1.0
 */

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxAddPreConfigurationToCart",
		actionId: "AjaxAddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
			cursor_clear();
			if(categoryDisplayJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					categoryDisplayJS.selectedAttributes = [];
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
 					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

   /**
   * Adds a pre-defined dynamic kit to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
	wcService.declare({
		id: "AjaxAddPreConfigurationToCart_shopCart",
		actionId: "AjaxAddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,successHandler: function(serviceResponse) {
			//Now delete from cart..
			var url = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
			document.location.href = url;
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
			 	} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
 					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
// Geolocation.js contains the JavaScript functions to call HTML5 Geolocation API
// to return the current device location coordinates
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////

var GeolocationJS = {

    /**
     * Get the current coordinates
     * @param position      geolocation position returned by the device
     */
    showPosition: function(position) {
        if (position !== undefined && position != null) {
            storeLocatorJSStore.refreshResultsFromNearest(position.coords.latitude,position.coords.longitude);
        }
    },

    /**
     * Handle the error returned from geolocation call
     * @param error     the error returned by the device
     */
    locationError: function(error) {
        var errorMsgKey;
        switch (error.code) {
            case error.PERMISSION_DENIED:
                errorMsgKey = "LBS_ERROR_PERMISSION_DENIED";
                break;
            case error.POSITION_UNAVAILABLE:
                errorMsgKey = "LBS_ERROR_NO_USER_CURRENT_LOC";
                break;
            case error.TIMEOUT:
                errorMsgKey = "LBS_ERROR_TIMEOUT";
                break;
            default:
                break;
        }
        storeLocatorJSStore.refreshResultsWithLocationError(errorMsgKey);
    },

    /**
     * Call the HTML5 geolocation API with callback function
     */
    launch: function() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(GeolocationJS.showPosition,GeolocationJS.locationError,{timeout:10000,enableHighAccuracy:true});
        }
    }

};;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used to display
 *and handle the information messages, error messages.

 This class is defined on MessageHelper.js


 */


//
//if (typeof (MessageHelper) == "undefined" || !MessageHelper || !MessageHelper.topicNamespace) {
//
//    /**
//     * @class The MessageHelper class contains variables and functions that are used
//     * to initialize, display and handle informational and error message.
//     */
//    MessageHelper = {
//        /**A variable that contains all the messages to be displayed*/
//        messages: {},
//
//        /**
//         * internal variable to keep track of the current element id that has
//         * an error tooltip assigned to it */
//        identifier: "",
//
//        /**
//         * internal variable to keep track of the element id that needs to
//         * give focus to on dialog dismissal */
//        focusElement: "",
//
//        /**
//         * returns the current year
//         * @return (int) the current year
//         */
//        getCurrentYear: function () {
//            return new Date().getFullYear();
//        },
//
//        /**
//         * returns the current month. January is 1, and December is 12.
//         * @return (int) the current month
//         */
//        getCurrentMonth: function () {
//            return new Date().getMonth() + 1;
//        },
//
//        /**
//         * returns the current day of the current month, starting from 1.
//         * @return (int) the current day
//         */
//        getCurrentDay: function () {
//            return new Date().getDate();
//        },
//
//        /**
//         *
//         *summary: retrieves the value of the property from a render context
//         *description: This function retrieves the value of the property whose name is propertName
//         *from the given context.
//         *
//         * @param (wc.render.Content) content The context in which the properties
//         * belong to.
//         * @param (string) propertyName The property to be retrieved
//         * @return (string) null if the context is null. undefined if the property is not found.
//         * otherwise, the value of the property int he given context.
//         */
//        getRenderContextProperty: function ( /*wc.render.Context*/ context, /*String*/ propertyName) {
//
//            console.debug("enter getRenderContextProperty with propertyName = " + propertyName);
//            if (context == null) {
//                console.debug("context is null. Return null...");
//                return null;
//            }
//
//            var result = context.properties[propertyName]
//            console.debug("the found property value is: " + result);
//
//            return result;
//        },
//
//        /**
//         * This function is used to initialize the messages object with all the
//         * required messages. It is used to setup a JS object with any key/value.
//         * @param (string) key The key used to access this message.
//         * @param (string) msg The message in the correct language.
//         *
//         */
//        setMessage: function (key, msg) {
//            this.messages[key] = msg;
//        },
//        /**
//         * This function is used to initialize the element that needs to give focus to on dialog dismissal.
//         * @param (string) element The element needs to give focus to.
//         *
//         */
//        setFocusElement: function (element) {
//            this.focusElement = element;
//        },
//
//
//
//        /**
//         * Use fadeIn and fadeOut to display error and informative messages in the store.
//         * @param (int) topOffset how far from the top the message display area will be displayed.
//         */
//        showHideMessageArea: function (topOffset) {
//            cursor_clear();
//            if (topOffset == null || topOffset == undefined) {
//                topOffset = 0;
//            }
//            var node = $("#MessageArea");
//
//            if ($("#MessageArea_ACCE_Title") !== null) {
//                $("#MessageArea_ACCE_Title").css("display", "block");
//            }
//            // fade in
//            $(node).fadeIn(200);
//
//
//        },
//
//        /**
//         * Use fadeOut to hide error and informative messages in the store.
//         */
//        hideMessageArea: function () {
//            cursor_clear();
//            var focusOnElement = "";
//            if (this.focusElement !== "" && $("#" + this.focusElement) !== null) {
//                focusOnElement = $("#" + this.focusElement);
//            }
//            var node = $("#MessageArea");
//
//            if ($("#MessageArea_ACCE_Title") !== null) {
//                $("#MessageArea_ACCE_Title").css("display", "none");
//            }
//            if (document.getElementById(focusOnElement) != null) {
//                focusOnElement.focus();
//            }
//            $(node).fadeOut(500);
//            $('#ErrorMessageText').html("");
//            this.focusElement = "";
//        },
//
//        /**
//         * This function is used to display the error messages to the user.
//         * @param (string) msg The error/information message to be displayed
//         * @param (int) topOffset how far from the top the message display area will be displayed.
//         * @param (boolean) showType whether or not the message type should be appended to the actual message
//         *
//         * @return (element) a HTML element that contains the error message.
//         *
//         */
//        displayErrorMessage: function (msg, topOffset, showType) {
//            if (topOffset == null || topOffset == undefined) {
//                topOffset = 0;
//            }
//
//            if (showType == undefined || showType == null || showType == true) {
//                //if showType is undefined, keep the FEP1 behaviour.
//                if (this.messages["ERROR_MESSAGE_TYPE"] != null && this.messages["ERROR_MESSAGE_TYPE"] != 'undefined') {
//                    var MsgType = this.messages["ERROR_MESSAGE_TYPE"];
//                    msg = MsgType + msg;
//                }
//            }
//
//            this.setMessageAreaStyle('error_icon');
//            $('#ErrorMessageText').html(msg);
//            this.showHideMessageArea(topOffset);
//            $('#clickableErrorMessageImg').focus();
//            setTimeout(function () {
//                if ($('#ErrorMessageText') !== null) {
//                    $('#ErrorMessageText').focus();
//                }
//            }, 1000);
//            if (typeof TealeafWCJS != "undefined") {
//                TealeafWCJS.logClientValidationCustomEvent({
//                    fieldId: "-1",
//                    message: msg
//                });
//            }
//        },
//
//
//        /**
//         * Sets the style for the message area on the page.
//         * @param (String) styleId The style Id.
//         */
//        setMessageAreaStyle: function (styleId) {
//            $("#success_icon").css("display", "none");
//            $("#error_icon").css("display", "none");
//            if ($("#" + styleId) != null) {
//                $("#" + styleId).css("display", "inline");
//            }
//        },
//
//
//        /**
//         * This function is used to display the informative messages to the user.
//         * @param (string) msg The status message to be displayed.
//         * @param (int) topOffset how far from the top of the browser the message will be displayed.
//         * @return (element) a HTML element that contains the status message.
//         */
//        displayStatusMessage: function (msg, topOffset) {
//            if (topOffset == null || topOffset == undefined) {
//                topOffset = 0;
//            }
//            this.setMessageAreaStyle('success_icon');
//            $('#ErrorMessageText').html(msg);
//            this.showHideMessageArea(topOffset);
//            $('#clickableErrorMessageImg').focus();
//            setTimeout(function () {
//                if ($('#ErrorMessageText') !== null) {
//                    $('#ErrorMessageText').focus();
//                }
//            }, 1000);
//        },
//
//        /**
//         * This function is used to hide and clear the message display area in
//         * the page.
//         */
//        hideAndClearMessage: function () {
//            $('#ErrorMessageText').html("");
//            $('#MessageArea').css("display", "none");
//        },
//
//        /**
//         * This function is used to re-adjust the coordinates of the message display area on the page. Its location is relative to the "page" element.
//         * @param (int) topOffset how far from the top the message display area will be displayed.
//         */
//        adjustCoordinates: function (topOffset) {
//            if ($("#MessageArea").css("display") != "none") {
//                var page = $("#page");
//                var node = $("#MessageArea");
//                if (page != null && node != null) {
//                    var postion = $(page).position();;
//                    var width = $(page).width();
//
//
//                    if (topOffset == null || topOffset == undefined) {
//                        topOffset = 0;
//                    }
//
//                    $(node).css({
//                        "width": width + 20 + "px",
//                        "left": postion.left - 10 + "px",
//                        "top": (postion.top + topOffset) + "px"
//                    });
//                }
//            }
//        },
//
//        /**
//         * This function will show the an error message tooltip
//         * around the input field with the problem.
//         *
//         * The function assumes the "serviceResponse" is the
//         * JSON object from a WebSphere Commerce exception. The error
//         * field is in the serviceResponse.errorMessageParam and the
//         * error message is in the serviceResponse.errorMessage.
//         *
//         * @see MessageHelper.formErrorHandleClient
//         * @param (object) serviceResponse The JSON object with the error data.
//         * @param (string) formName The name of the form where the error field is.
//         *
//         */
//        formErrorHandle: function (serviceResponse, formName) {
//
//            this.formErrorHandleClient(serviceResponse.errorMessageParam, serviceResponse.errorMessage);
//
//        },
//
//
//        /**
//         * This function will show the an error message tooltip
//         * around the input field with the problem.
//         *
//         * This function will check for the emptiness of the required
//         * filed and displays the "errorMessage" related to that field as a tooltip.
//         * The tooltip will be closed on focus lost.
//         *
//         * @param (string) id The identifier for the filed in the form.
//         * @param (string) errorMessage The message that should be displayed to the user.
//         */
//
//       formErrorHandleClient: function (id, errorMessage) {
//            if (id.id) {
//                id = id.id;
//            }
//            var element = $("#"+id);
//            if (errorMessage == null) {
//                console.debug("formErrorHandleClient: The error message is null.");
//                return;
//            }
//            if (element) {
//                if (Utils.has_ios()) {
//                    this.setMessageAreaStyle('error_icon');
//                    $('#MessageArea').css("display", "block");
//                    $('#ErrorMessageText').html(errorMessage);
//                    window.setTimeout(function () {
//                        window.scrollTo(0, 0);
//                    }, 0);
//                } else if (this.identifier != (id + "_tooltip")) {
//                    element.focus();
//                    this.identifier = id + "_tooltip";
//                    var node = document.createElement('span');
//                    var imgDirPath = getImageDirectoryPath();
//                    if (Utils.get_IE_version() < 7) {
//                        node.innerHTML = errorMessage + "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" + imgDirPath + "images/empty.gif'></iframe>";
//                    } else {
//                        node.innerHTML = errorMessage;
//                    }
//
//
//                    if (Utils.hasTouch()) {
//                        var _this = this;
//                        setTimeout(function () {
//                        var _this = this;
//                        var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
//                        this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
//                        $("#" + id).after(this.tooltip);
//                        this.tooltip.position({
//                            my: "center top",
//                            at: "center bottom",
//                            of: $("#" + id)
//
//                        });
//
//                        $("#" + id).blur(function () {
//                            if (_this.tooltip) {
//                                _this.tooltip.hide();
//                                _this.tooltip.remove();
//                            }
//                            MessageHelper.clearCurrentIdentifier();
//
//                        });
//
//                        }, 1000);
//                    } else {
//                        var _this = this;
//                        var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
//                        this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
//                        $("#" + id).after(this.tooltip);
//                        this.tooltip.position({
//                            my: "center top",
//                            at: "center bottom",
//                            of: $("#" + id)
//
//                        });
//
//                        $("#" + id).blur(function () {
//                            if (_this.tooltip) {
//                                _this.tooltip.hide();
//                                _this.tooltip.remove();
//                            }
//                            MessageHelper.clearCurrentIdentifier();
//
//                        });
//
//                    }
//                }
//                if (typeof TealeafWCJS != "undefined") {
//                    TealeafWCJS.logClientValidationCustomEvent({
//                        fieldId: element.id,
//                        message: errorMessage
//                    });
//                }
//	        }
//        },
//
//
//        /**
//         * This function hides and destroys the current form error handler tooltip that is displayed
//         * and clears the identifier that is currently tracked.
//         */
//        hideFormErrorHandle: function () {
//                if (this.tooltip != null) {
//                    this.tooltip.destroyRecursive();
//                    this.tooltip = null;
//                    this.clearCurrentIdentifier();
//                }
//            },
//
//            /**
//             * This function clears the internal variable that has the element id
//             * with the error tooltip.
//             *
//             */
//            clearCurrentIdentifier: function () {
//
//                this.identifier = "";
//            },
//
//            /**
//             * This function is used to override any of the default functions
//             * associated with the events. Ex: Tooltip widget tracks onMouseOver event
//             * and display the tooltip. To remove this association,
//             * tooltip widgets onMouseOver function will be overridden by this empty
//             * function.
//             *
//             * It is an empty implementation which does nothing.
//             *
//             * @param (string) event  The event which triggers this function.
//             */
//            emptyFunc: function (event) {
//
//            },
//
//
//
//            /**
//             * Checks whether a string contains a double byte character.
//             *
//             * @param (string) target the string to be checked
//             * @return (boolean) true if target contains a double byte char;
//             * false otherwise
//             */
//            containsDoubleByte: function (target) {
//
//                var str = new String(target);
//                var oneByteMax = 0x007F;
//
//                for (var i = 0; i < str.length; i++) {
//                    chr = str.charCodeAt(i);
//                    if (chr > oneByteMax) {
//                        return true;
//                    }
//                }
//                return false;
//            },
//
//            /**
//             * This function validate email address. It does not allow double byte
//             * characters in the email address.
//             *
//             * @return (boolean) true if the email address is valid; false otherwise
//             *
//             * @param (string) strEmail the email address string to be validated
//             */
//            isValidEmail: function (strEmail) {
//
//                if (this.containsDoubleByte(strEmail)) {
//                    return false;
//                }
//
//                if (strEmail.length == 0) {
//                    return true;
//                } else if (strEmail.length < 5) {
//                    return false;
//                } else {
//                    if (strEmail.indexOf(" ") > 0) {
//                        return false;
//                    } else {
//                        if (strEmail.indexOf("@") < 1) {
//                            return false;
//                        } else {
//                            if (strEmail.lastIndexOf(".") < (strEmail.indexOf("@") + 2)) {
//                                return false;
//                            } else {
//                                if (strEmail.lastIndexOf(".") >= strEmail.length - 2) {
//                                    return false;
//                                }
//                            }
//                        }
//                    }
//                }
//                return true;
//            },
//
//            /**
//             * This function will check if the number of bytes of the string
//             * is within the maxlength specified.
//             *
//             * @param (string) UTF16String the UTF-16 string
//             * @param (int) maxlength the maximum number of bytes allowed in your input
//             *
//             * @return (boolean) false is this input string is larger than maxlength
//             */
//            isValidUTF8length: function (UTF16String, maxlength) {
//                if (this.utf8StringByteLength(UTF16String) > maxlength) return false;
//                else return true;
//            },
//
//            /**
//             * This function will count the number of bytes represented in a UTF-8
//             * string.
//             *
//             * @param (string) UTF16String the UTF-16 string you want a byte count of
//             * @return (int) the integer number of bytes represented in a UTF-8 string
//             */
//            utf8StringByteLength: function (UTF16String) {
//
//                if (UTF16String === null) return 0;
//
//                var str = String(UTF16String);
//                var oneByteMax = 0x007F;
//                var twoByteMax = 0x07FF;
//                var byteSize = str.length;
//
//                for (i = 0; i < str.length; i++) {
//                    chr = str.charCodeAt(i);
//                    if (chr > oneByteMax) byteSize = byteSize + 1;
//                    if (chr > twoByteMax) byteSize = byteSize + 1;
//                }
//                return byteSize;
//            },
//
//            /**
//             * this function will check whether the text is a numeric or not.
//             *
//             * @param allowDot is a boolean wich specifies whether to consider
//             * the '.' or not.
//             *
//             * @return (boolean) true if text is numeric
//             */
//            IsNumeric: function (text, allowDot) {
//                if (allowDot) var ValidChars = "0123456789.";
//                else var ValidChars = "0123456789";
//
//                var IsNumber = true;
//                var Char;
//
//
//                for (i = 0; i < text.length && IsNumber == true; i++) {
//                    Char = text.charAt(i);
//                    if (ValidChars.indexOf(Char) == -1) {
//                        IsNumber = false;
//                    }
//                }
//                return IsNumber;
//            },
//
//            /**
//             *
//             *This function will check for a valid Phone Number
//             *
//             *@param (string) text The string to check
//             *
//             *@return (boolean) true if text is a phone number, ie if each character of
//             *input is one of 0123456789() -+
//             */
//            IsValidPhone: function (text) {
//
//                var ValidChars = "0123456789()-+ ";
//
//                var IsValid = true;
//                var Char;
//
//                for (i = 0; i < text.length && IsValid == true; i++) {
//                    Char = text.charAt(i);
//                    if (ValidChars.indexOf(Char) == -1) {
//                        IsValid = false;
//                    }
//                }
//                return IsValid;
//            },
//
//            /**
//             *  To use confirmation popup, the ${StoreDirectory}/Common/ConfirmationPopup.jspf must be included
//             *  in the jsp page where the confirmation popup launches from.
//             *	This function launch confirmation popup
//             *
//             * @param (string) topicName The name of the topic that calling widget subscribing to.
//             * @param (stirng) message The message to be displayed in the confirmation dialog.
//             */
//            showConfirmationDialog: function (topicName, message) {
//                $("#confirmationPopupMessage").html(message);
//                var confirmationPopupWidget = $("#confirmationPopup").data("wc-WCDialog"),
//                    // Also add a namespace to the click event so we
//                    // only remove our click handler instead of other click handlers
//                    eventName = "click.MessageHelper";
//                // Do this only once.
//                confirmationPopupWidget.primary_button.one(eventName, function (e) {
//                    e.preventDefault();
//                    confirmationPopupWidget.secondary_button.off(eventName);
//                    wcTopic.publish(topicName, {
//                        action: "YES"
//                    });
//                });
//
//                confirmationPopupWidget.secondary_button.one(eventName, function (e) {
//                    e.preventDefault();
//                    confirmationPopupWidget.primary_button.off(eventName);
//                    wcTopic.publish(topicName, {
//                        action: "NO"
//                    });
//                });
//                confirmationPopupWidget.open();
//
//            }
//        }
//    }
//

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
* @fileOverview This javascript contains javascript functions used by the quick order function
*/

quickOrderJS={
	/** language ID to be used, default to -1 (English) */
	langId: "-1",

	/** store ID to be used */
	storeId: "",

	/** catalog ID to be used */
	catalogId: "",

	/** used to hold error messages when bad SKU is entered */
	skuErrorMessage: "",

	/** used to hold error messages when bad quantity is entered */
	qtyErrorMessage: "",

	/**
	 * This constant stores the number of items that are allowed to be submitted in a single quick order.
	 * @private
	 * @constant
	 */
	numberOfItemsSupportedPerQuickOrder: "12",

	/**
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use
	* @param {String} catalog Catalog ID to use
	* @param {String} skuErrorMessage Error message to use when bad SKU is entered
	* @param {String} qtyErrorMessage Error message to use when bad quantity is entered
	*/
	setCommonParameters:function(langId,storeId,catalogId,skuErrorMessage,qtyErrorMessage){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
			this.skuErrorMessage = skuErrorMessage;
			this.qtyErrorMessage = qtyErrorMessage;
	},

	/**
	* This function validates the SKU input values and their corresponding quantities on the quick order form before sending the request to the server to add the SKUs to the order.
	* An error message would be displayed if an input is invalid and the requested will be stopped.
	* @param {String} formName The name of the quick order form..
	*/
	addToOrderAjax:function(formName){
		if (browseOnly){
			MessageHelper.displayErrorMessage(storeNLS['ERROR_ADD2CART_BROWSE_ONLY']);
			return;
		}
		var params = [];
		var form = document.forms[formName];
		params.storeId = form.storeId.value;
		params.catalogId = form.catalogId.value;
		params.langId = form.langId.value;
		// Remove calculations for performance
		// params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
		params.calculateOrder="0";

		var orderItemsCount = 0;
		for(var i=1; i<=this.numberOfItemsSupportedPerQuickOrder; i++){
			var currentPartNumberInputFieldId = form["partNumber_" + i].id;
			var currentQuantityInputFieldId = form["quantity_" + i].id;
			var currentPartNumber = trim(form["partNumber_" + i].value);
			var currentQuantity = trim(form["quantity_" + i].value);
			if((currentPartNumber != null && currentPartNumber != "") || (currentQuantity != null && currentQuantity != "")){
				if(currentPartNumber == null || currentPartNumber == ""){
					MessageHelper.formErrorHandleClient(currentPartNumberInputFieldId, this.skuErrorMessage);
					return;
				}
				if(!isPositiveInteger(currentQuantity)){
					MessageHelper.formErrorHandleClient(currentQuantityInputFieldId, this.qtyErrorMessage);
					return;
				}
				orderItemsCount = orderItemsCount + 1;
				form["partNumber_" + i].value = currentPartNumber;
				form["quantity_" + i].value = currentQuantity;
				this.updateParamObject(params,"partNumber_"+orderItemsCount, form["partNumber_" + i].value);
				this.updateParamObject(params,"quantity_"+orderItemsCount, form["quantity_" + i].value);
			}
		}

		if(orderItemsCount > 0){
			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke("QuickOrderAddOrderItem", params);
		}
	},

	/**
	* This function updates the given params object with Key value pair.
	* It is useful while making a service call which excepts few paramters of type array
	* @param {Object} params Object containing data to be passed to commerce services
	* @param {String} key Key to store and retrieve the parameter
	* @param {String} value	Value of the parameter
	* @return {Object} params A JavaScript Object having key - value pair.
	*/
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},

	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	}

}

/**
* Add an item to a shopping cart in Ajax mode. A message is displayed after the service call.
* The URL "AjaxRESTOrderAddPreConfigurationToCart" is a superset of the URL
* "AjaxRESTOrderItemAdd", allowing dynamic kit partnumbers to be entered into the quick order form.
*/
wcService.declare({
		id: "QuickOrderAddOrderItem",
		actionId: "AjaxAddOrderItem",
		url: "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

		/**
		* display a success message
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation
		*/
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
			cursor_clear();
			quickOrderJS.clearForm("MQuickOrderForm");
		}

		/**
		* display an error message
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation
		*/
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
			 	} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
 					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2013 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

if(typeof(ResponsiveJS) == "undefined" || ResponsiveJS == null || !ResponsiveJS){

	ResponsiveJS = {



	init: function(){
		$("#footerCustomerService").on("click", $.proxy(ResponsiveJS._cSToggleAndShow, ResponsiveJS));
		$("#footerCorporateInfo").on("click", $.proxy(ResponsiveJS._cIToggleAndShow, ResponsiveJS));
		$("#footerExplore").on("click", $.proxy(ResponsiveJS._eToggleAndShow, ResponsiveJS));
		$("#footerFollowUs").on("click", $.proxy(ResponsiveJS._FUToggleAndShow, ResponsiveJS));

	},

	_cSToggleAndShow:function(evt){
		this.toggle($("#cSTog"));
		this.show($("#expandCS"));
	},

	_cIToggleAndShow:function(evt){
		this.toggle($("#cITog"));
		this.show($("#expandCI"));
	},

	_eToggleAndShow:function(evt){
		this.toggle($("#eTog"));
		this.show($("#expandE"));
	},

	_FUToggleAndShow:function(evt){
		this.toggle($("#fUTog"));
		this.show($("#expandFU"));
	},

	toggle:function(node){
		var srcElement = node;
		if(srcElement != null) {
		      if(srcElement.style.backgroundPosition== '-161px -1px') {
		        srcElement.style.backgroundPosition= '-181px -1px';
		        srcElement.style.width='12px';
		        srcElement.style.height='6px';
		        srcElement.style.left='6px';
		        srcElement.style.top='14px';
		      }
		      else {
		        srcElement.style.backgroundPosition= '-161px -1px';
		        srcElement.style.width='6px';
		        srcElement.style.height='12px';
		        srcElement.style.left='10px';
		        srcElement.style.top='10px';
		  }
		}
	},

	show:function(node){
		srcElement = node;
	    if(srcElement != null) {
	      if(srcElement.style.display == "block") {
	        close('searchDropdown');
	        srcElement.style.display= 'none';
	      }
	      else {
	    	$(".subDeptDropdown ").each(function(i,node){
	    		close(node.id);
		    });
		    close("departmentsDropdown");
	        close('qLinkDropdown');
	        close('mobileSearchDropdown');
	        close('searchDropdown');
	        close('pageDropdown');
	        close('sortDropdown');
	        srcElement.style.display='block';
	      }
	    }
	}


 };
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

function nullCartTotalCookie(orderId){
	setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; i++) {
		var index = cookies[i].indexOf("=");
		var name = cookies[i].substr(0,index);
		var value = cookies[i].substr(index+1)
		name = name.replace(/^\s+|\s+$/g,"");
		value = value.replace(/^\s+|\s+$/g,"");
		if (value == orderId) {
			setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
			break;
		}
	}
}

	/**
	* Adds an item to to the wishlist and remove the same item from the shopping
	* cart.
	* @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAddAndDeleteFromCart",
		actionId: "AjaxInterestItemAddAndDeleteFromCart",
		url: getAbsoluteURL() + "AjaxInterestItemAdd",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			//Now delete from cart..
			MessageHelper.hideAndClearMessage();
			resetRequest();
			CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxAddOrderItem",
		actionId: "AjaxAddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
			cursor_clear();
			if(categoryDisplayJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					categoryDisplayJS.selectedAttributes = [];
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
				} else {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
	wcService.declare({
		id: "AjaxAddOrderItem_shopCart",
		actionId: "AjaxAddOrderItem",
		url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
		formId: ""

	 /**
	 * redirects to the shopping cart page
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			//Now delete from cart..
			document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
				} else {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Remove an item from shopping cart. A message is displayed after the service
	 * call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxDeleteOrderItem",
		actionId: "AjaxDeleteOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
		formId: ""
	/**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"]);
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),


	/**
	 * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxDeleteOrderItemForShippingBillingPage",
		actionId: "AjaxDeleteOrderItemForShippingBillingPage",
		url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
		formId: ""

		/**
		 * display a success message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"]);
		}

		/**
		 * display an error message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
	}),


	/**
	 * Remove an item from shopping cart. A message is only displayed if the service
	 * call returns an error Message. It is used to remove an item from the shopping
	 * cart and add the same item to the wish list.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxDeleteOrderItemFromCart",
		actionId: "AjaxDeleteOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
		formId: ""
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}


	}),

	/**
	 * Remove an item from shopping cart.
	 * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
	 * An error message will be displayed otherwise.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxDeleteOrderItem1",
		actionId: "AjaxDeleteOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
		formId: ""

	/**
	 *redirect to the Shopping Cart Page
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"]);
			if (!CheckoutHelperJS.pendingOrderDetailsPage)
			{
				setDeleteCartCookie();
				if(CheckoutHelperJS.shoppingCartPage){

					document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
				}else{
					document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
				}
			}
			else
			{
				cursor_clear();
			}
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),


	/**
	 * This service updates an order item in the shopping cart.
	 * A message is displayed after the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxUpdateOrderItem",
		actionId: "AjaxUpdateOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.hideFormErrorHandle();
			cursor_clear();
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
				}
				else{
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),

	/**
	 * Updates an order item in the shopping cart.
	 * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
	 * An error message will be displayed otherwise.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxUpdateOrderItem1",
		actionId: "AjaxUpdateOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
		formId: ""
	/**
	 *redirect to the Shopping Cart Page
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			if (!CheckoutHelperJS.pendingOrderDetailsPage)
			{
				if(CheckoutHelperJS.shoppingCartPage){
					document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
				}
			}
			else
			{
				cursor_clear();
			}
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
				}
				else{
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service updates shipping information (shipping mode, shipping address)
	 * for a shopping cart. A message is displayed after the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxUpdateOrderShippingInfo",
		actionId: "AjaxUpdateOrderShippingInfo",
		url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service prepares an order for submission. Upon success, it submits the order.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxPrepareOrderForSubmit",
		actionId: "AjaxPrepareOrderForSubmit",
		url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
		formId: ""

	/**
	 * On success, checkout the order by calling order submit.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			CheckoutHelperJS.setOrderPrepared("true");
			CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),


	/**
	 * This service submits the order. Upon success, the order billing confirmation
	 * page is shown. A error message is displayed otherwise.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxSubmitOrder",
		actionId: "AjaxSubmitOrder",
		url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
		formId: ""

	/**
	 *redirect to the Order Confirmation page
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			nullCartTotalCookie(serviceResponse.orderId);
			var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
			document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service submits the quote. Upon success, the quote  confirmation
	 * page is shown. A error message is displayed otherwise.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxSubmitQuote",
		actionId: "AjaxSubmitQuote",
		url: getAbsoluteURL() + "AjaxSubmitQuote",
		formId: ""

   /**
	*redirect to the Quote Confirmation page
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation
	*/
		,successHandler: function(serviceResponse) {
			var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
			+ "&catalogId=" + ServicesDeclarationJS.catalogId
			+ "&langId=" + ServicesDeclarationJS.langId
			+ "&orderId=" + CheckoutHelperJS.getOrderId()
			+ "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
			+ "&isQuote=true"
			+ "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

			if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
				redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
			}
			document.location.href = appendWcCommonRequestParameters(redirectURL);
		}

   /**
	* display an error message
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation
	*/
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds an address for the person. An error message is displayed
	 * if the service failed.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxAddAddressForPerson",
		actionId: "AjaxAddAddressForPerson",
		url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			AddressHelper.updateOrderAfterAddressUpdate();
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds an address for the person. An error message is displayed
	 * if the service failed.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxUpdateAddressForPerson",
		actionId: "AjaxUpdateAddressForPerson",
		url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			AddressHelper.updateOrderAfterAddressUpdate();
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
	 */
	wcService.declare({
		id: "AjaxUpdateOrderAfterAddressUpdate",
		actionId: "AjaxUpdateOrderAfterAddressUpdate",
		url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	/**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds an item to the wishlist. This is different from
	 * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
	 * the item from the shopping cart. It is used mainly in catalog browsing.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd",
		actionId: "AjaxInterestItemAdd",
		url: getAbsoluteURL() + "AjaxInterestItemAdd",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
			if(categoryDisplayJS)
			categoryDisplayJS.selectedAttributes = [];
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds an item to the wishlist in non-Ajax mode. Upon success,
	 * the shopping cart page is displayed. This is different from
	 * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
	 * the item from the shopping cart. It is used mainly in catalog browsing.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd_shopCart",
		actionId: "AjaxInterestItemAdd",
		url: getAbsoluteURL() + "AjaxInterestItemAdd",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
	wcService.declare({
		id: "AjaxInterestItemDelete",
		actionId: "AjaxInterestItemDelete",
		url: getAbsoluteURL() + "AjaxInterestItemDelete",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service sends the wish list to a specified email address.
	 */
	wcService.declare({
		id: "AjaxInterestItemListMessage",
		actionId: "AjaxInterestItemListMessage",
		url: getAbsoluteURL() + "AjaxInterestItemListMessage",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service applies the promotion code to the order(s).
	 */
	wcService.declare({
		id: "AjaxPromotionCodeManage",
		actionId: "AjaxPromotionCodeManage",
		url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
		formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();

			var params = [];

			params.storeId		= ServicesDeclarationJS.storeId;
			params.catalogId	= ServicesDeclarationJS.catalogId;
			params.langId		= ServicesDeclarationJS.langId;
			params.orderItemId 	= "";
			params.orderId = serviceResponse.orderId;
			if(CheckoutHelperJS.shoppingCartPage){
				params.calculationUsage = "-1,-2,-5,-6,-7";
			}else{
				params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
			}
			params.calculateOrder = "1";

			wcService.invoke("AjaxUpdateOrderItem",params);

		}

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service applies the promotion code to the order(s).
	 */
	wcService.declare({
		id: "AjaxPromotionCodeDelete",
		actionId: "AjaxPromotionCodeManage",
		url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
		formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();

			var params = [];

			params.storeId		= ServicesDeclarationJS.storeId;
			params.catalogId	= ServicesDeclarationJS.catalogId;
			params.langId		= ServicesDeclarationJS.langId;
			params.orderItemId 	= "";
			params.orderId = serviceResponse.orderId;
			if(CheckoutHelperJS.shoppingCartPage){
				params.calculationUsage = "-1,-2,-5,-6,-7";
			}else{
				params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
			}
			params.calculateOrder = "1";

			wcService.invoke("AjaxUpdateOrderItem",params);

		}

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

  /**
   * This services adds or removes a coupon from the order(s).
   */
	wcService.declare({
		id: "AjaxCouponsAdd",
		actionId: "AjaxCouponsAddRemove",
		url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
		formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();

			var params = [];

			params.storeId		= ServicesDeclarationJS.storeId;
			params.catalogId	= ServicesDeclarationJS.catalogId;
			params.langId		= ServicesDeclarationJS.langId;
			params.orderItemId	= "";
			params.orderId = serviceResponse.orderId;
			if(CheckoutHelperJS.shoppingCartPage){
				params.calculationUsage = "-1,-2,-5,-6,-7";
			}else{
				params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
			}
			params.calculateOrder = "1";

			wcService.invoke("AjaxUpdateOrderItem",params);

		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

  /**
   * This services adds or removes a coupon from the order(s).
   */
	wcService.declare({
		id: "AjaxCouponsRemove",
		actionId: "AjaxCouponsAddRemove",
		url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
		formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();

			var params = [];

			params.storeId		= ServicesDeclarationJS.storeId;
			params.catalogId	= ServicesDeclarationJS.catalogId;
			params.langId		= ServicesDeclarationJS.langId;
			params.orderItemId	= "";
			params.orderId = serviceResponse.orderId;
			if(CheckoutHelperJS.shoppingCartPage){
				params.calculationUsage = "-1,-2,-5,-6,-7";
			}else{
				params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
			}
			params.calculateOrder = "1";

			wcService.invoke("AjaxUpdateOrderItem",params);

		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds a billing address to the order(s).
	 */
	wcService.declare({
		id: "AddBillingAddress",
		actionId: "AddBillingAddress",
		url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
	id: "ScheduleOrder",
	actionId: "ScheduleOrder",
	url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
	formId: ""

	/**
	 * Hides all the messages and the progress bar.
	 * Constructs a URL that deletes the current order and forward to the order confirmation page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		var originalOrderId = document.getElementById("orderIdToSchedule").value;
		var newOrderId = serviceResponse.orderId;
		nullCartTotalCookie(serviceResponse.orderId);
		var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
		var purchaseOrderNumber = "";
		if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
			purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
		}
		var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
		document.location.href = appendWcCommonRequestParameters(url);
	}

	/**
	 * Displays an error message if the the service call failed.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
	id: "SubmitRecurringOrder",
	actionId: "SubmitRecurringOrder",
	url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
	formId: ""

	/**
	 * Hides all the messages and the progress bar.
	 * Constructs a URL that deletes the current order and forward to the order confirmation page.
	 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		nullCartTotalCookie(serviceResponse.orderId);
		var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
		var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
		document.location.href = appendWcCommonRequestParameters(url);
		cursor_clear();
	}

	/**
	 * Displays an error message if the the service call failed.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
	id: "AjaxUpdateRewardOption",
	actionId: "AjaxUpdateRewardOption",
	url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
	formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();

	}
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

}),

	/**
	 * Create a new saved order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxOrderCreate",
		actionId: "AjaxOrderCreate",
		url: getAbsoluteURL() + "AjaxOrderCreate",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

			cursor_clear();

		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {

				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
	}),

	/**
	 * Cancel a single saved order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxSingleOrderCancel",
		actionId: "AjaxSingleOrderCancel",
		url: getAbsoluteURL() + "AjaxRESTOrderCancel",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
			cursor_clear();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
	}),

	/**
	 * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxOrderCancel",
		actionId: "AjaxOrderCancel",
		url: getAbsoluteURL() + "AjaxRESTOrderCancel",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			// Call again to delete any other orders in the list.
			savedOrdersJS.cancelSavedOrder(false);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
	}),

	/**
	 * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxOrderSave",
		actionId: "AjaxOrderSave",
		url: getAbsoluteURL() + "AjaxOrderCopy",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			// Call again to delete any other orders in the list.
			savedOrdersJS.saveOrder(false);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}
	}),

	/**
	 * Set the current order to be that of a saved order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxSetPendingOrder",
		actionId: "AjaxSetPendingOrder",
		url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

			MessageHelper.hideAndClearMessage();

			MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

			savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

			cursor_clear();

		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),


	/**
	 * Updates the current pending order setting it to the current shopping cart.
	 * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
	 * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
	 * Perform the service or command call.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxUpdatePendingOrder",
		actionId: "AjaxUpdatePendingOrder",
		url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
		formId: ""

	 /**
	 * There is nothing to do in the event of a success of this service since it is executed in the background.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

			savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
			cursor_clear();

		}
	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Copy a saved order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxSingleOrderCopy",
		actionId: "AjaxSingleOrderCopy",
		url: getAbsoluteURL() + "AjaxOrderCopy",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

		var params = [];

		params.storeId		= ServicesDeclarationJS.storeId;
		params.catalogId	= ServicesDeclarationJS.catalogId;
		params.langId		= ServicesDeclarationJS.langId;
		params.URL="";
		params.updatePrices = "1";

		params.orderId = serviceResponse.orderId;
		params.calculationUsageId = "-1";

		wcService.invoke("AjaxSingleOrderCalculate", params);
			MessageHelper.hideAndClearMessage();

		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Copy a saved order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxOrderCopy",
		actionId: "AjaxOrderCopy",
		url: getAbsoluteURL() + "AjaxOrderCopy",
		formId: ""

	/**
	* display a success message
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation
	*/

		,successHandler: function(serviceResponse) {

		var params = [];

		params.storeId		= ServicesDeclarationJS.storeId;
		params.catalogId	= ServicesDeclarationJS.catalogId;
		params.langId		= ServicesDeclarationJS.langId;
		params.URL="";
		params.updatePrices = "1";

		params.orderId = serviceResponse.orderId;
		params.calculationUsageId = "-1";

		wcService.invoke("AjaxOrderCalculate", params);
			MessageHelper.hideAndClearMessage();

		}

	/**
	* display an error message
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation
	*/
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				 if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Perform the order calculation operations to compute the contract prices for the order items in an order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxSingleOrderCalculate",
		actionId: "AjaxSingleOrderCalculate",
		url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
			cursor_clear();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Perform the order calculation operations to compute the contract prices for the order items in an order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxCurrentOrderCalculate",
		actionId: "AjaxCurrentOrderCalculate",
		url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
			cursor_clear();
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * Perform the order calculation operations to compute the contract prices for the order items in an order.
	 * Perform the service or command call.
	 */
	wcService.declare({
		id: "AjaxOrderCalculate",
		actionId: "AjaxOrderCalculate",
		url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
		formId: ""

	 /**
	 * display a success message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */

		,successHandler: function(serviceResponse) {

			MessageHelper.hideAndClearMessage();
			// Call again to copy any other orders in the list.
			savedOrdersJS.copyOrder(false);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				if (serviceResponse.errorCode == "CMN0409E")
				 {
					 MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
				 }
				 else
				 {
					 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				 }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),


	/**
	 * Processes a punchout payment request.
	 */
	wcService.declare({
		id: "AjaxPunchoutPay",
		actionId: "AjaxPunchoutPay",
		url: "AjaxRESTOrderRePay",
		formId: ""

		/**
		 * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			PunchoutJS.handleResponse(serviceResponse.orderId);
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	}),


	/**
	 * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
	 */
	wcService.declare({
		id: "AjaxCategorySubscribe",
		actionId: "AjaxCategorySubscribe",
		url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
		formId: ""

		/**
		 * Clear messages on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

//<%--
//********************************************************************


/**
 * @fileOverview This class contains key-value paired variables that are
 * mapped to their respective services. The variables are used to determine
 * which refresh areas to update. For example, the order_updated variable is
 * used update order related refresh areas.
 */


/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */
var order_updated = {	'AjaxAddOrderItem':'AjaxAddOrderItem',
											'AjaxAddOrderItemWithShipingInfo':'AjaxAddOrderItemWithShipingInfo',
											'AjaxDeleteOrderItem':'AjaxDeleteOrderItem',
											'AjaxUpdateOrderItem':'AjaxUpdateOrderItem',
											'AjaxUpdateOrderShippingInfo':'AjaxUpdateOrderShippingInfo',
											'AjaxOrderCalculate':'AjaxOrderCalculate',
											'AjaxLogoff':'AjaxLogoff',
											'AjaxSetPendingOrder':'AjaxSetPendingOrder',
											'AjaxUpdatePendingOrder':'AjaxUpdatePendingOrder',
											'AjaxSingleOrderCancel':'AjaxSingleOrderCancel',
											'AjaxUpdateRewardOption':'AjaxUpdateRewardOption'
										};

/**
 *  map address_updated to all the services that result in changes to a shopper's
 *  address book
 *  @static
 */
var address_updated = {	'AjaxDeleteAddressForPerson':'AjaxDeleteAddressForPerson',
			'AjaxAddAddressForPerson':'AjaxAddAddressForPerson',
			'AjaxUpdateAddressForPerson':'AjaxUpdateAddressForPerson',
			'AjaxAddShippingAndBillingAddressForPersonDuringCheckout':'AjaxAddShippingAndBillingAddressForPersonDuringCheckout',
			'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout':'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout'
		};

/**
 *  map user_changed to all the services that result in the user in session
 *  change
 *  @static
 */
var user_changed = {	'AjaxLogonService':'AjaxLogonService',
											'AjaxLogoff':'AjaxLogoff'
										};

/**
 *  map wishlist_changed to all the services that result in the changes to a wish list
 *  @static
 */
var wishlist_changed = {	'AjaxInterestItemAdd':'AjaxInterestItemAdd',
												'AjaxInterestItemDelete':'AjaxInterestItemDelete',
												'AjaxLogonService':'AjaxLogonService',
												'AjaxLogoff':'AjaxLogoff'
											};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

wcTopic.subscribe("ajaxRequestInitiated", incrementNumAjaxRequest);
wcTopic.subscribe("ajaxRequestCompleted", decrementNumAjaxRequest);
wcTopic.subscribe("ajaxRequestCompleted", initializeInactivityWarning);

/**
 * @fileOverview This file provides the common functions which are specific to the Aurora store.
 * This JavaScript file is used by StoreCommonUtilities.jspf.
 */

// Handle Order error.
wcTopic.subscribe("OrderError", function (errorObj){
    if(errorObj.errorCode == 'CMN4512I'){
        //CMN4512I is OrderLocked error. So refresh miniCart.
        setDeleteCartCookie();
        //Since cart cookie is deleted, we don't need to pass currency/lang. It will be fetched from server
        loadMiniCart(null,null);
    }
});

/** This variable indicates whether the dropdown is shown or not. */
var showDropdown = false;

/** This variable stores the current dropdown dialog element. */
var dropDownDlg = null;

/** This variable stores the current product added dropdown dialog element. */
var productAddedDropDownDlg = null;

/** This variable is used to store the width of the mini shopping cart on page load. It is used when shopper's browser is IE6. */
var originalMiniCartWidth = 0;

/** This variable indicates whether the browser used is Internet Explorer or not. */
var isIE = (document.all) ? true : false;

/** Initializes the variable to false. **/
    var correctBrowser = false;

/**
 * This variable indicates whether a request has been submitted or not.
 * The value is initialized to true and resets to false on full page load.
 */
var requestSubmitted = true;

/**
 * This variable stores the id of the element (ex: button/link) which the user clicked.
 * This id is set when the user clicks an element which triggers an Ajax request.
 */
var currentId = "";

/**
 * This variable keeps track of the number of active ajax requests currently running on the page
 * The value is initialized to 0.
 */
var numAjaxRequests = 0,

widgetsList = [];

/**
 * Variable to save whether a tab or shift-tab was pressed
 */
var tabPressed = false;

/** This variable is used to keep track of the quick info/compare touch events */
var currentPopup = '';

/** This variable indicates whether Android is used or not */
var android = null;

/** This variable indicates whether iOS is used or not */
var ios = null;

/**
 * This variable contains the cookie domain for current store cookies.
 * Modify the cookie domain once here and it will be applied everywhere else for the particular store.
 */
var cookieDomain = "";

/** Base Text Direction Preference */
var _BTD_PREFS = "WC_Base_Text_Direction",

detectedLocale = Utils.getLocale();

/**
 * Initialize the client side inactivity warning dialog, this function is called at every page load and at
 * every the time when ajax request completed.  Be default, 30 seconds before the session timeout, a dialog
 * will popup and display a warning to let the user to extend the time.  The timing of when the dialog
 * will be displayed can be modified with "inactivityWarningDialogBuffer" variable in CommonJSToInclude.jspf
 */
function initializeInactivityWarning() {

    // only set timer if user is not guest, in a full-auth session, and is able to retrieve inactivityTimeout from server
    if (storeUserType != "G" && inactivityTimeout != 0 && document.cookie.indexOf("WC_USERACTIVITY_") > 0) {
        // Reset the inactivity timer dialog
        if (inactivityTimeoutTracker != null) {
            clearTimeout(inactivityTimeoutTracker);
        }

        // setup the inactivity timout tracker
        inactivityTimeoutTracker = setTimeout(showInactivityWarningDialog, inactivityTimeout - inactivityWarningDialogBuffer);
    }
}

/**
 * Show the inactivity warning dialog, the dialog will be closed in 20 seconds.  The timing of when the dialog
 * will be closed can be modified with "inactivityWarningDialogDisplayTimer" variable in CommonJSToInclude.jspf
 */
function showInactivityWarningDialog() {
    $("#inactivityWarningPopup").data("wc-WCDialog").open();
    if (dialogTimeoutTracker != null) {
        clearTimeout(dialogTimeoutTracker);
    }
    dialogTimeoutTracker = setTimeout(hideInactivityWarningDialog, inactivityWarningDialogDisplayTimer);
}

/**
 * Hide the inactivity warning dialog
 */
function hideInactivityWarningDialog() {
    $("#inactivityWarningPopup").hide();
}

/**
 * Send a Ping request to server to reset the inactivity timer.  The client side timer to display the inactivity warning
 * dialog will also be reset.
 */
function resetServerInactivity() {
    $.post({
        url: getAbsoluteURL() + "Ping",
        //handleAs: "json-comment-filtered",
        success: function(data, textStatus, jqXHR) {
            if (data.success) {
                initializeInactivityWarning();
            } else {
                console.error("Ping service failed");
            }
        },
        error: function(jqXHR, textStatus, error) {
            console.error("Ping service failed");
        }
    });
}

/**
 * DOM Shorthand
 */
function byId(r){
    return document.getElementById(r);
}

/**
 * Sends back focus to the first focusable element on tabbing from the last focusable element.
 */
function focusSetter(){
    if($("#MiniCartFocusReceiver1").length)
        $("#MiniCartFocusReceiver1").focus();
    else
        $("#MiniCartFocusReceiver2").focus();
}

/**
 * Sends back focus to the last focusable element on reverse tabbing from the first focusable element.
 *
 * @param {object} event The event triggered from user actions
 */
function determineFocus(event) {
        if(event.shiftKey && event.keyCode === KeyCodes.TAB)
        {
            if(event.srcElement)
            {
                if(event.srcElement.id=="MiniCartFocusReceiver1")
                {
                    $("#WC_MiniShopCartDisplay_link_5").focus();
                    Utils.stopEvent(event);
                }
                else if(event.srcElement.id=="MiniCartFocusReceiver2")
                {
                    $("#MiniCartFocusReceiver2").focus();
                    Utils.stopEvent(event);
                }
            }
            else
            {
                if(event.target.id=="MiniCartFocusReceiver1")
                {
                    $("#WC_MiniShopCartDisplay_link_5").focus();
                    Utils.stopEvent(event);
                }
                else if(event.target.id=="MiniCartFocusReceiver2")
                {
                    $("#MiniCartFocusReceiver2").focus();
                    Utils.stopEvent(event);
                }
            }
        }
}

/**
 * Destroys the existing dialogs with outdated data.
 * @param {string} contentId The identifier of the dialog to destroy. If undefined, the default is 'quick_cart_container'.
 */
function destroyDialog(contentId){
    if(contentId == undefined){
        contentId = 'quick_cart_container';
    }
    //If data has changed, then we should destroy the quick_cart_container dialog and recreate it with latest data
    var dialog = $("#" + contentId).data("wc-WCDialog");
    if (dialog) {
        dialog.destroy();
    }

    if(contentId != undefined && contentId == 'quick_cart_container'){
         dropDownDlg = null;
    } else {
        productAddedDropDownDlg = null;
    }
}

/**
 * Loads the specified URL.
 *
 * @param {string} url The URL of the page to be loaded.
 */
function loadLink(url){
    document.location.href=url;
}

/**
 * Clears the Search term string displayed in Simple Search field.
 */
function clearSearchField() {
    searchText = $("#SimpleSearchForm_SearchTerm").val()
    if(searchText == $("#searchTextHolder").html()){
        $("#SimpleSearchForm_SearchTerm").val("");
    }
    else{
        document.getElementById("SimpleSearchForm_SearchTerm").select();
        showAutoSuggestIfResults();
        autoSuggestHover = false;
    }
}

/**
 * Displays the Search term string in Simple Search field.
 */
function fillSearchField() {
    if ($("#SimpleSearchForm_SearchTerm").val()== "") {
        document.getElementById("SimpleSearchForm_SearchTerm").className = "search_input gray_color";
        $("#SimpleSearchForm_SearchTerm").val($("#searchTextHolder").html());
    }
    // hide the search box results
    if(!autoSuggestHover) {
        showAutoSuggest(false);
    }
}

/**
 * Displays the top dropdown menu, including the category dropdowns and the mini shopping cart.
 */
function showDropDownMenu(){
    $("#header_menu_dropdown").css("display", "block");
    $("#outerCartContainer").css("display", "block");
}

/**
 * Displays the progress bar dialog to indicate a request is currently running.
 * There are certain cases where displaying the progress bar causes problems in Opera,
 * the optional parameter "checkForOpera" is passed to specifically check if the browser used is Opera,
 * if so, do not display the progress bar in these cases.
 *
 * @param {boolean} checkForOpera Indicates whether to check if the browser is Opera or not.
 */
function cursor_wait(checkForOpera) {
    var showPopup = true;

    //Since dijit does not support Opera
    //Some progress bar dialog will be blocked in Opera to avoid error
    if(checkForOpera == true){
        if(Utils.isOpera()){
            showPopup = false;
        }
    }

    //For all other browsers and pages that work with Opera
    //Display the progress bar dialog
    if(showPopup && ENV_SHOWLOADER){
        //Delay the progress bar from showing up
        setTimeout('showProgressBar()',500);
    }
}

/**
 * Helper method for cursor_wait() to display the progress bar pop-up.
 * Displays progress bar, next to the element if the element id was specified in currentId,
 * or defaults to the center of the page if currentId is empty.
 * Progress bar will only be displayed if the submitted request has not been completed.
 * This method is only called implicitly by the cursor_wait() method, which is triggered before a request is submitted.
 */
function showProgressBar(){
    //After the delay, if the request is still not finished
    //Then continue and show the progress bar
    //Otherwise, do not execute the following code
    if(!requestSubmitted){
        return;
    }

    displayProgressBar();

}


/**
 * Helper method for showProgressBar() to display the progress bar pop-up.
 * It can also be forced to show the progress bar directly in special cases.
 * The function also displays the progress bar next to the element if the element id was specified in currentId,
 * or defaults to the center of the page if currentId is empty.
 * This method can be called implicitly by the cursor_wait() method or explicitly by itself.
 */
function displayProgressBar() {
    var dialog = $('#progress_bar_dialog').data("wc-WCDialog");

    //Make sure the dialog is created
    if (dialog) {

        var progressBar = $('#progress_bar');
        progressBar.css("display", "block");

        //Check whether or not an element ID is provided
        //If yes, point the progress bar to this element
        //Otherwise, show the progress bar in a dialog
        if (this.currentId !== "") {
            dialog.option("position", {
                my: "left top",
                at: "right top",
                of: $("#" + this.currentId)
            });
        } else {
            //dialog.containerNode.innerHTML === "";
            progressBar.css("left", '');
            progressBar.css("top", '');
            dialog.element.html(progressBar);
            //dialog.containerNode.appendChild(progressBar);

        }
        dialog.open();
        //Make sure the progress bar dialog goes away after 30 minutes
        //and does not hang if server calls does not return
        //Assuming the longest server calls return before 30 minutes
        setTimeout("cursor_clear()", 1800000);
    }
}

/**
 * Stores the id of the element (ex: button/link) that triggered the current submitted request.
 * Store the new element id only when no request is currently running.
 *
 * @param {string} id The id of element triggering the submitted request.
 */
function setCurrentId(id){
    //If there is no request already submitted, update the id
    if(!requestSubmitted && this.currentId === ""){
        this.currentId = id;
    }
}

/**
 * This function trims the spaces from the pased in word.
 * Delete all pre and trailing spaces around the word.
 *
 * @param {string} inword The word to trim.
 */
function trim(inword)
{
    word = inword.toString();
    var i = 0,
    j = word.length-1;
    while(word.charAt(i) == " ") i++;
    while(word.charAt(j) == " ") j=j-1;
    if (i > j) {
        return word.substring(i,i);
    } else {
        return word.substring(i,j+1);
    }
}

/**
 * Hides the progress bar dialog when the submitted request has completed.
 * Set the visibility of the progress bar dialog to hide from the page.
 */
function cursor_clear() {
    //Reset the flag
    requestSubmitted = false;

    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
    //Hide the progress bar dialog
    var dialog = $('#progress_bar_dialog').data("wc-WCDialog"),
    progressBar = document.getElementById('progress_bar');
    if(dialog != null){
        if(progressBar != null){
            $(progressBar).css("display", 'none');
        }
        dialog.close();
        this.currentId="";
    }
}

function escapeXml (str, fullConversion){
    if(fullConversion){
        str = str.replace(/&(?!(quot;|#34;|#034;|#x27;|#39;|#039;))/gm, "&amp;").replace(/</gm, "&lt;").replace(/>/gm, "&gt;");
    }
    str = str.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;");
    return str;
}
/**
 * Checks whether a request can be submitted or not.
 * A new request may only be submitted when no request is currently running.
 * If a request is already running, then the new request will be rejected.
 *
 * @return {boolean} Indicates whether the new request was submitted (true) or rejected (false).
 */
function submitRequest() {
    if(!requestSubmitted) {
        requestSubmitted  = true;
        wcTopic.publish("requestSubmittedChanged", requestSubmitted);
        return true;
    }
    return false;
}

function resetRequest() {
    requestSubmitted = false;
    wcTopic.publish("requestSubmittedChanged", requestSubmitted);
}

/**
 * Set the current page to a new URL.
 * Takes a new URL as input and set the current page to it, executing the command in the URL.
 * Used for Non-ajax calls that requires multiple clicks handling.
 *
 * @param {string} newPageLink The URL of the new page to redirect to.
 */
function setPageLocation(newPageLink) {
    //For Handling multiple clicks
    if(!submitRequest()){
        return;
    }

    document.location.href = newPageLink;
}

/**
 * Submits the form parameter.
 * Requires a form element to be passed in and submits form with its inputs.
 * Used for Non-ajax calls that requires multiple clicks handling.
 *
 * @param {element} form The form to be submitted.
 */
function submitSpecifiedForm(form) {
    if(!submitRequest()){
        return;
    }
    console.debug("form.action == "+form.action);
    processAndSubmitForm(form);
}

/**
 * get location information of a given url
 * @param href
 * @returns url
 */
function getLocation(href) {
    var urlHref = href;
    if (!urlHref.match(/^[a-zA-Z]+:\/\//))
    {
        urlHref = 'http://' + urlHref;
    }
     var urlLocation = document.createElement("a");
     urlLocation.href = urlHref;

     return urlLocation;
}

/**
 * If the return URL belongs to a different domain from the current host,
 * return a blank page while go back button is clicked
 * @param url
 * @returns {String}
 */
function getReturnUrl(url) {
    var returnUrl;
    var urlLocation = this.getLocation(decodeURIComponent(url));
    if (urlLocation.hostname === location.hostname)
         returnUrl = url;
    else returnUrl = 'about:blank';
    location.href = returnUrl;
}

/**
 * solve issues in case cache is turned on, sometimes url is cached with
 * http or https portocol while accessed from an https or http protocol later on.
 * In this case we will match the protocol for ajax calls consistent with document.location.href
 * protocol
 * @param url
 * @returns {URL}
 */
function matchUrlProtocol(url){
	if(!stringStartsWith(url, "http")){
		//If it is relative URL, just return it.
		return url;
	}
    var href = document.location.href,
    index = href.lastIndexOf("s", 4),
    newUrl = url,
    urlIndex = newUrl.lastIndexOf("s", 4);
    if (index != -1 && urlIndex == -1){
         newUrl=newUrl.substring(0,4) + "s" + (newUrl.substring(4));
    }
    else if(index == -1 && urlIndex != -1)
    {
        newUrl = newUrl.substring(0,4) + (newUrl.substring(5));
    }
    return newUrl;
}

 /**
  * This function is used to hide an element with the specified id.
  * @param {string} elementId The id of the element to be hidden.
  */

  function hideElementById(elementId){
        $("#" + elementId).css("display", "none");
 }

/**
  * This function is used to display an element with the specified id.
  * @param {string} elementId The id of the element to be displayed.
  */

   function showElementById(elementId){
       $("#" + elementId).css("display", "block");
}

/**
  * This function is used to hide the background image of an element.
  * @param {DomNode} element The node whose background image is to be hidden.
  */
    function hideBackgroundImage(element){
        $(element).css("backgroundImage", 'none');
}

/**
  * This function is used to display the background image of a product onhover.
  * @param {DomNode} element The node for which the product hover background image is to be displayed.
  */

     function showBackgroundImage(element){
        $(element).css("backgroundImage", 'url('+getImageDirectoryPath()+getStyleDirectoryPath()+'product_hover_background.png)');
}
    /**
    * checkIE8Browser checks to see if the browser is IE 8 or less. It then sets correctBrowser to true if it is.
    *
    **/

    function checkIE8Browser() {
       if( Utils.get_IE_version() && Utils.get_IE_version() <= 8 ){
            correctBrowser = true;
       }
   }

    /**
    * ApprovalToolLink provides the appropriate URL if the browser is correct, otherwise displays a message.
    *
    * @param {String} idTag Used to identify the id tag in the jsp that is calling it.
    * @param {String} approvalToolLinkURL This is a URL which is passed from the calling jsp.
    *
    **/

    function ApprovalToolLink(idTag, approvalToolLinkURL) {

        //checks if the browser is IE 8 or less.
        checkIE8Browser();

        if (correctBrowser) {
          RFQwindow=window.open(approvalToolLinkURL);
        }
        else {
          MessageHelper.formErrorHandleClient(idTag,MessageHelper.messages["ERROR_INCORRECT_BROWSER"]); return;
        }
    }


/**
 * Updates view (image/detailed) and starting index of pagination of product display in SetCurrencyPreferenceForm when currency is changed from the drop-down menu.
 * These are later passed as url parameters.
 */

function updateViewAndBeginIndexForCurrencyChange(){
    if($("#fastFinderResultControls").length && document.getElementById('fastFinderResultControls')!='')
    {
        if(document.SetCurrencyPreferenceForm.pageView!=null){
            document.SetCurrencyPreferenceForm.pageView.value = document.FastFinderForm.pageView.value;
        }
        if(document.SetCurrencyPreferenceForm.beginIndex!=null){
            document.SetCurrencyPreferenceForm.beginIndex.value = document.FastFinderForm.beginIndex.value;
        }
    }
    else if($("#CategoryDisplay_Widget").length && document.getElementById('CategoryDisplay_Widget')!='')
    {
        if(wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['pageView'] !== '' && document.SetCurrencyPreferenceForm.pageView!=null){
            document.SetCurrencyPreferenceForm.pageView.value = wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['pageView'];
        }
        if(wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['beginIndex'] !== '' && document.SetCurrencyPreferenceForm.beginIndex!=null){
            document.SetCurrencyPreferenceForm.beginIndex.value = wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['beginIndex'];
        }
    }
    else if($("#Search_Result_Summary").length && document.getElementById('Search_Result_Summary')!='')
    {
        if(wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsView'] !== '' && document.SetCurrencyPreferenceForm.pageView!=null){
            document.SetCurrencyPreferenceForm.pageView.value = wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsView'];
        }
        if(wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsPageNum'] !== '' && document.SetCurrencyPreferenceForm.beginIndex!=null){
            document.SetCurrencyPreferenceForm.beginIndex.value=wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsPageNum']
        }
    }
    else if($("#Search_Result_Summary2").length && document.getElementById('Search_Result_Summary2')!='')
    {
        if(wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsView'] !== '' && document.SetCurrencyPreferenceForm.pageView!=null){
            document.SetCurrencyPreferenceForm.pageView.value = wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsView'];
        }
        if(wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsPageNum'] !== '' && document.SetCurrencyPreferenceForm.beginIndex!=null){
            document.SetCurrencyPreferenceForm.beginIndex.value=wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsPageNum']
        }
    }

    //allow coshopper to change currency. Only used for coshopping
    try {
        if (window.top._ceaCollabDialog!=undefined || window.top._ceaCollabDialog!=null) {
            $('#SetCurrencyPreferenceForm')[0].URL.value=
                    $('#SetCurrencyPreferenceForm')[0].URL.value + "&coshopChangeCurrency=" +
                    $('#currencySelection').find(":selected").text();
        }
    }catch(err) {
        console.log(err);
    }
}


/**
 * Updates view (image/detailed) and starting index of pagination of product display in LanguageSelectionForm when language is changed from the drop-down menu.
 * These are later passed as url parameters.
 */

function updateViewAndBeginIndexForLanguageChange(){
    if($("#fastFinderResultControls").length && document.getElementById('fastFinderResultControls')!='')
    {
        if(document.LanguageSelectionForm.pageView!= null){
            document.LanguageSelectionForm.pageView.value = document.FastFinderForm.pageView.value;
        }
        if(document.LanguageSelectionForm.beginIndex!= null){
            document.LanguageSelectionForm.beginIndex.value = document.FastFinderForm.beginIndex.value;
        }
    }
    else if($("#CategoryDisplay_Widget").length && document.getElementById('CategoryDisplay_Widget')!='')
    {
        if(wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['pageView'] !== '' && document.LanguageSelectionForm.pageView!= null){
            document.LanguageSelectionForm.pageView.value = wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['pageView'];
        }
        if(wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['beginIndex'] !== '' && document.LanguageSelectionForm.beginIndex!= null){
            document.LanguageSelectionForm.beginIndex.value = wcRenderContext.getRenderContextProperties('CategoryDisplay_Context').properties['beginIndex'];
        }
    }
    else if($("#Search_Result_Summary").length && document.getElementById('Search_Result_Summary')!='')
    {
        if(wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsView'] !== '' && document.LanguageSelectionForm.pageView!= null){
            document.LanguageSelectionForm.pageView.value = wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsView'];
        }
        if(wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsPageNum'] !== '' && document.LanguageSelectionForm.beginIndex!= null){
            document.LanguageSelectionForm.beginIndex.value = wcRenderContext.getRenderContextProperties('catalogSearchResultDisplay_Context').properties['searchResultsPageNum'];
        }
    }
    else if($("#Search_Result_Summary2").length && document.getElementById('Search_Result_Summary2')!='')
    {
        if(wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsView'] !== '' && document.LanguageSelectionForm.pageView!= null){
            document.LanguageSelectionForm.pageView.value = wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsView'];
        }
        if(wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsPageNum'] !== '' && document.LanguageSelectionForm.beginIndex!= null){
            document.LanguageSelectionForm.beginIndex.value = wcRenderContext.getRenderContextProperties('contentSearchResultDisplay_Context').properties['searchResultsPageNum'];
        }
    }

    //appending landId to the URL. Only used for coshopping
    try {
        if (window.top._ceaCollabDialog!=undefined || window.top._ceaCollabDialog!=null) {
            $('#LanguageSelectionForm').attr("action",  $("#LanguageSelectionForm").attr("action") + "&langId=" +
                $('#languageSelection').find(":selected").text());
        }
    }catch(err) {
        console.log(err);
    }
}

/**
 * Displays the header links in two lines.
 */
function showHeaderLinksInTwoLines(){
    if($("#header_links").length){
        if($("#header_links").width() > 750){
            $("#header_links1").css("display", "block");
            $("#headerHomeLink").css("display", "none");
            $("#headerShopCartLink").css("display", "none");
        }
        $("#header_links").css("visibility", "visible");
    }
}

/**
  * Displays the header links in one line.
  */
 function showLinksInOneLine(){
    $("#header_links").css("visibility", "visible");
 }

/**
 * Validates if the input value is a non-negative integer using regular expression.
 *
 * @param {String} value The value to validate.
 *
 * @return {Boolean} Indicates if the given value is a non-negative integer.
 */
function isNonNegativeInteger(value){
    var regExpTester = new RegExp(/^\d*$/);
    return (value != null && value !== "" && regExpTester.test(value));
}

/**
* Validates if the input value is a positive integer.
*
* @param {String} value The value to validate.
*
* @return {Boolean} Indicates if the given value is a positive integer.
*/
function isPositiveInteger(value){
    return (isNonNegativeInteger(value) && value != 0);
}

/**
 * This function closes all dialogs on the page.
 */
function closeAllDialogs(){
    $("[data-widget-type='wc.WCDialog']").each(function (i, e) {
        $(e).hide();
    });
}

/**
 * This function store a error key in the cookie. The error key will be used to retrieve error messages.
 * @param {String} errorKey  The key used to retrieve error/warning messages.
 */
function setWarningMessageCookie(errorKey) {
    setCookie("signon_warning_cookie",errorKey, {path: "/", domain: cookieDomain});
}
/**
* This function removes a cookie
* @param {String} name the name of the cookie to be removed.
*/
function removeCookie(name) {
    setCookie(name, null, {expires: -1});
}
/**
* This function gets a cookie
* @param {String} c the name of the cookie to be get.
*/
function getCookie(c) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("="),
        name = cookies[i].substr(0,index);
        name = name.replace(/^\s+|\s+$/g,"");
        if (name == c) {
            return decodeURIComponent(cookies[i].substr(index + 1));
        }
    }
}

function deleteOnBehalfRoleCookie(){
    var deleteOnBhealfRoleCookieVal = getCookie("WC_OnBehalf_Role_"+WCParamJS.storeId);

    if(deleteOnBhealfRoleCookieVal != null){
        setCookie("WC_OnBehalf_Role_"+WCParamJS.storeId, null, {expires:-1,path:'/', domain:cookieDomain});
    }
}

/**
* This function gets a cookie by name which starts with the provided string
* @param {String} c the partial name (starts with) of the cookie to be get.
*/
function getCookieName_BeginningWith(c) {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("="),
        name = cookies[i].substr(0,index);
        name = name.replace(/^\s+|\s+$/g,"");
        if (stringStartsWith(name,c)) {
            return name;
        }
    }
}

/**
* This function checks to see if the string start with the specified set of characters
* @param {String} basestr the string
* @param {String} c the substring to check for
*/
function stringStartsWith(basestr, str) {
    return str.length > 0 && basestr.substring( 0, str.length ) === str
}

/**
 * checks if the store is in preview mode
 * @param {String} contextPathUsed The context path being used by the Store.
 * @param {String} criteria criteria used to check if contextPathUsed is the preview context.
 */
function isStorePreview(contextPathUsed,criteria) {
    return contextPathUsed.indexOf(criteria) > -1;
}

/**
 * checks hides the ESpot info popup window
 * @param {String} The id of the popup dialog
 * @param {String} The browser event
 */
function hideESpotInfoPopup(id,event) {
    if(event!=null && event.type=="keypress" && event.keyCode !== KeyCodes.ESCAPE) {
        return;
    }
    else {
        var quickInfo = $("#" + id);
        if(quickInfo.length) {
            quickInfo.data("wc-WCDialog").close();
        }
    }
}

/**
 * checks shows the ESpot info popup window
 * @param {String} The id of the popup dialog
 * @param {String} The browser event
 */
function showESpotInfoPopup(id, event) {
    if (event != null && event.type == "keypress" && event.keyCode !== KeyCodes.RETURN) {
        return;
    } else {
        if (!parent.checkPopupAllowed()) {
            return;
        }
        var quickInfo = $("#" + id).data("wc-WCDialog");
        if (quickInfo) {
            // Bring this Dialog on top of other dialogs
	        quickInfo.bringToFront();
            // Bring this Dialog on top of eSpot overlay button
            quickInfo.bringToFront($(".ESpotInfo"));
            quickInfo.open();
            quickInfo.reposition();
        }
    }
}

/**
* This function increments the numAjaxRequests counter by 1.
*/
function incrementNumAjaxRequest(){
    if(numAjaxRequests != 'undefined'){
        numAjaxRequests++;
    }
}

/**
* This function decrements the numAjaxRequests counter by 1.
*/
function decrementNumAjaxRequest(){
    if(numAjaxRequests != 'undefined'){
        if(numAjaxRequests != 0){
            numAjaxRequests--;
        }
    }
}

/**
* updateParamObject This function updates the given params object with a key to value pair mapping.
*                   If the toArray value is true, It creates an Array for duplicate entries otherwise it overwrites the old value.
*                   This is useful while making a service call which accepts a few parameters of type array.
*                   This function is used to prepare a a map of parameters which can be passed to XMLHttpRequests.
*                   The keys in this parameter map will be the name of the parameter to send and the value is the corresponding value for each parameter key.
* @param {Object} params The parameters object to add name value pairs to.
* @param {String} key The new key to add.
* @param {String} value The new value to add to the specified key.
* @param {Boolean} toArray Set to true to turn duplicate keys into an array, or false to override previous values for a specified key.
* @param {int} index The index in an array of values for a specified key in which to place a new value.
*
* @return {Object} params A parameters object holding name value pairs.
*
**/
function updateParamObject(params, key, value, toArray, index){

    if(params == null) {
        params = [];
    }
    if(params[key] != null && toArray) {
        if($.isArray(params[key])) {
            //3rd time onwards
            if(index != null && index !== "") {
                //overwrite the old value at specified index
                params[key][index] = value;
            } else {
                params[key].push(value);
            }
        } else {
            //2nd time
            var tmpValue = params[key];
            params[key] = [];
            params[key].push(tmpValue);
            params[key].push(value);
        }
   } else {
       //1st time
       if(index != null && index !== "" && index != -1) {
           //overwrite the old value at specified index
           params[key+"_"+index] = value;
       } else if(index == -1) {
           var i = 1;
           while(params[key + "_" + i] != null) {
               i++;
           }
           params[key + "_" + i] = value;
       } else {
           params[key] = value;
       }
   }
   return params;
 }

/**
 * Show the html element
 *
 * @param {string} id The id of the section to show.
 */
function showSection (id){
    $("#" + id).css("visibility", "visible");
}

/**
 * Hides the html element.
 *
 * @param {string} id The id of the section to hide.
 */
function hideSection (id){
    $("#" + id).css("visibility", "");
}

/**
 * hides the section if the user clicks shift+tab.
 *
 * @param {string} id The id of the div area to hide.
 * @param {event} event The keystroke event entered by the user.
 */
function shiftTabHideSection (id, event){
    if (event.shiftKey && (event.keyCode === KeyCodes.TAB)){
        hideSection(id);
    }
}

/**
 * hides the section if the user clicks tab.
 *
 * @param {string} id The id of the div area to hide.
 * @param {event} event The keystroke event entered by the user.
 */
function tabHideSection (id, event, nextId){
    if (!event.shiftKey && (event.keyCode === KeyCodes.TAB)){
        if(null != nextId){
            $("#" + nextId).focus();
        }
        hideSection(id);
        Utils.stopEvent(event);
    }
}

/**
 * Saves whether the shift and tab keys were pressed or not.  Ignores tab.
 * @param {event} event The event that happened by pressing a key
 */
function saveShiftTabPress(event) {
    if (event.shiftKey == true && event.keyCode === KeyCodes.TAB) {
        tabPressed = true;
    }
}

/**
 * Saves whether the tab key was pressed or not.  Ignores SHIFT-tab.
 * @param {event} event The event that happened by pressing a key
 */
function saveTabPress(event) {
    if (event.shiftKey == false && event.keyCode === KeyCodes.TAB) {
        tabPressed = true;
    }
}
/**
 * Sets the focus to the given form element if a tab or shift-tab was pressed.  Workaround to tabbing from a country dropdown
 * to a dynamic state element that becomes a dropdown when it was a textbox and vice versa.  Defect was Firefox specific.
 * @param {String} formElementId The form element id to set the focus to
 */
function setFocus(formElementId) {
    if (tabPressed) {
        tabPressed = false;
        document.getElementById(formElementId).focus();
    }
}

/**
 * Increase the height of a container due to the addition of a message
 * @param ${String} The id of the container whose height will be increased
 * @param ${Integer} Number of pixels to increase height by
 */
function increaseHeight(containerId, increase) {
    var temp = document.getElementById(containerId).offsetHeight;
    $("#" + containerId).css("height", (temp + increase) + 'px');
}

/**
 * Reload the current page.
 * @param ${forcedUrl} The url which sends user to the expected page.
 */
function redirectToSignOn(forcedUrl) {
	var widgetId = 'Header_GlobalLogin'; // This widgetId is defined in Header_UI.jspf / GlobalLoginActions.js / UserTimeoutView.jsp
	setCookie("WC_RedirectToPage_"+WCParamJS.storeId, forcedUrl, {path:'/', domain:cookieDomain});
	GlobalLoginJS.InitHTTPSecure(widgetId);
}

/**
 * Keeps track of the current quick info/compare touch event in tablets
 * @param ${String} link The link of the product detail page
 * @param ${String} newPopup The id of the new product quick info/compare touched
 */
function handlePopup(link,newPopup) {
    if (currentPopup == newPopup){
        document.location.href = link;
    } else {
        currentPopup = newPopup;
    }
}

/**
 * Check to see if the device in use is running the android OS
 * @return {boolean} Indicates whether the device is running android
 */
function isAndroid() {
    if(android == null){
        if(navigator != null){
            if(navigator.userAgent != null){
                var ua = navigator.userAgent.toLowerCase();
                android = ua.indexOf("android") > -1;
            }
        }
    }
    return android;
}

/**
 * Check to see if the device in use is running iOS
 * @return {boolean} Indicates whether the device is running iOS
 */
function isIOS() {
    if(ios == null){
        if(navigator != null){
            if(navigator.userAgent != null){
                var ua = navigator.userAgent.toLowerCase();
                ios = (ua.indexOf("mac") > -1) || (ua.indexOf("ipad") > -1) || (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1);
            }
        }
    }
    return ios;
}


/**
* This function highlight all marketing spots and catalog objects in preview mode, overwriting the implementation in site level (StorePreviewerHeader.jsp)
*/
function outlineSpots(){
    $(document.body).addClass('editMode');
    $(".carousel > .content").css("zIndex", 'auto');
    $(".ESpotInfo").css("display", "block" );
    $(".searchScore").css("display", "block" );
    $(".editManagedContent").css("display", "block" );
    $(".genericESpot,.product,.searchResultSpot,.productDetail,.categorySpot").each(function (i, currEl) {
        if ($(currEl).hasClass("emptyESpot")) {
            var elementWidth = $('.ESpotInfo', currEl)[0].offsetWidth + 4,
                elementHeight = $('.ESpotInfo', currEl)[0].offsetHeight + 4;
            $(currEl).attr("_width", $(currEl).css('width'));
            $(currEl).attr("_height", $(currEl).css('height'));
            $(currEl).css({
                'width': +elementWidth + 'px',
                'height': elementHeight + 'px'
            });

        }
        if ($(".borderCaption").length) {
            $(currEl).prepend("<div class='borderCaption'></div>");
        } else {
            $(".borderCaption", currEl).css({
                'display': 'block'
            });
        }
        if (currEl.addEventListener) {
            currEl.addEventListener('mouseover', function (evt) {
                if (!window.parent.frames[0].isSpotsShown()) {
                    return;
                }
                $(".caption").css("display", "none"
                );
                $(".caption", this).first().css({
                    display: "block"
                });
                evt.stopPropagation();
            }, false);
            currEl.addEventListener('mouseout', function (evt) {
                if (!window.parent.frames[0].isSpotsShown()) {
                    return;
                }
                $(".caption", this).css({
                    display: "none"
                });
                evt.stopPropagation();
            }, false);
        } else if (currEl.attachEvent) {
            currEl.onmouseover = (
                (function (currEl) {
                    return (function () {
                        if (!window.parent.frames[0].isSpotsShown()) {
                            return;
                        }
                        $(".caption").css("display", "none");
                        $(".caption", currEl).first().css({
                            display: "block"
                        });
                        window.event.cancelBubble = true;
                    });
                })(currEl)
            );
            currEl.onmouseleave = (
                (function (currEl) {
                    return (function () {
                        if (!window.parent.frames[0].isSpotsShown()) {
                            return;
                        }
                        $(".caption", currEl).css({
                            display: "none"
                        });
                        window.event.cancelBubble = true;

                    });
                })(currEl)
            );
        }
    });
}

/**
* This function un-highlight all marketing spots and catalog objects in preview mode, overwriting the implementation in site level (StorePreviewerHeader.jsp)
*/
function hideSpots(){
    $(document.body).removeClass("editMode");
    $(".carousel > .content").css("zIndex", '');
    $(".ESpotInfo").css("display", "none");
    $(".caption").css("display", "none");
    $(".searchScore").css("display", "none");
    $(".editManagedContent").css("display", "none");
    $(".borderCaption").css("display", "none");
    $(".emptyESpot").each(function (i, e) {
        $(e).css({
            'width': $(e).attr("_width") + 'px'
        });
        $(e).css({
            'height': $(e).attr("_height") + 'px'
        });
    });

}

/**
* This function resets the mini cart cookie values, then continues to log off the shopper.
*/
function logout(url){
    setDeleteCartCookie();
    document.location.href = url;
}

/**
 * This function submits the Language and Currency selection form.
 * @param formName The name of the Language and Currency selection form.
 */
function switchLanguageCurrency(formName) {
    //to get the browser current url
    var browserURL = document.location.href,
    currentLangSEO = '/'+$("#currentLanguageSEO").val()+'/';

    // get rid of anything after pound sign(#) in the URL if it is a SearchDisplay request.
    // search processes the query parameters and cannot handle a redirect URL with pound sign(#)
    if ((browserURL.indexOf('SearchDisplay') !== -1 || browserURL.indexOf('CategoryDisplay') !== -1) && browserURL.indexOf('#') !== -1) {
        var poundTokens = browserURL.split('#');
        browserURL = poundTokens[0];
    }

    //set the form URL to the updated URL with the new language keyword
    //for example: replace /en/ with the new keyword
    var modifiedFormURL = browserURL;
    if (browserURL.indexOf(currentLangSEO) !== -1) {
        if (document.getElementById('langSEO'+document.getElementById('languageSelection').options[document.getElementById('languageSelection').selectedIndex].value)) {
            var newLangSEO = '/'+document.getElementById('langSEO'+document.getElementById('languageSelection').options[document.getElementById('languageSelection').selectedIndex].value).value+'/';
            modifiedFormURL = browserURL.replace(currentLangSEO,newLangSEO);
        }
    }
    //replace langId with the newly selected langId
    if (modifiedFormURL.indexOf('&') !== -1) {
        var tokens = modifiedFormURL.split('&');
        modifiedFormURL = "";
        for (var i=0; i<tokens.length; i++) {
            if (tokens[i].indexOf('langId=') === -1) {
                if (modifiedFormURL === '') {
                    modifiedFormURL = tokens[i];
                } else {
                    modifiedFormURL = modifiedFormURL + "&" + tokens[i];
                }
            } else if (tokens[i].indexOf('langId=') > 0) {
                if (i==0) {
                    //langId is the first token next to ?
                    modifiedFormURL = tokens[0].substring(0,tokens[0].indexOf('langId='));
                } else {
                    modifiedFormURL = modifiedFormURL + "&";
                }
                modifiedFormURL = modifiedFormURL + "langId=" + document.getElementById('languageSelection').options[document.getElementById('languageSelection').selectedIndex].value;
            }
        }
    }
    modifiedFormURL = switchLanguageCurrencyFilter(modifiedFormURL);
    document.forms[formName].URL.value = modifiedFormURL;
    document.forms[formName].languageSelectionHidden.value = document.getElementById('languageSelection').options[document.getElementById('languageSelection').selectedIndex].value;

    //hide pop up and submit the form
    $('#widget_language_and_currency_popup').data("wc-WCDialog").close();
    //delete buyOnBehalfOf cookie if exists
    //if (typeof(GlobalLoginShopOnBehalfJS) != 'undefined' && GlobalLoginShopOnBehalfJS != null ){
    //  GlobalLoginShopOnBehalfJS.deleteBuyerUserNameCookie();
    //}
    if (typeof changeStoreViewLanguage == 'function') {
        changeStoreViewLanguage(document.forms[formName].languageSelectionHidden.value);
    }
    document.getElementById(formName).submit();
}

/**
 * This function checks replaces url in a exclusion list with string from the replacement list
 * @param url The url to process
*/
function switchLanguageCurrencyFilter(url) {
    var filterList = [];

    // Add any new exclude and replace view name in filterList
    // exclude UserRegistrationAdd in URL and replace with UserRegistrationForm?new=Y
    var paramList = [{"key": "registerNew", "value": "Y"}];
    filterList.push({"exclude": "UserRegistrationAdd", "replace": "UserRegistrationForm", "param": paramList});

    for (var i=0; i<filterList.length; i++) {
        if (url.indexOf(filterList[i].exclude) > 0) {
            url = url.replace(filterList[i].exclude, filterList[i].replace);
            if (filterList[i].param != undefined) {
                var urlParamList = filterList[i].param;
                for (var j=0; j<urlParamList.length; j++) {
                    url = appendToURL(url, urlParamList[j].key, urlParamList[j].value, false);
                }
            }
            break;
        }
    }
    return url;
}

/**
 * This function check the <code>url</code> <code>paramterName</code> pair against the URLConfig exclusion list.
 * @param url The url to send request.
 * @param parameterName The name of the parameter to be sent with request.
 * @returns {Boolean} True if the parameter and url is not in an exclusion list, false otherwise.
 */
function isParameterExcluded(url, parameterName){
    try{
    if(typeof URLConfig === 'object'){
        if (typeof URLConfig.excludedURLPatterns === 'object'){
            for ( var urlPatternName in URLConfig.excludedURLPatterns){
                var exclusionConfig = URLConfig.excludedURLPatterns[urlPatternName],
                urlPattern = urlPatternName;
                if(typeof exclusionConfig === 'object'){
                    if(exclusionConfig.urlPattern){
                        urlPattern = exclusionConfig.urlPattern;
                    }
                    console.debug("URL pattern to match : " + urlPattern);
                    urlPattern = new RegExp(urlPattern);

                    if(url.match(urlPattern)){
                        var excludedParametersArray = exclusionConfig.excludedParameters;
                        for(var excludedParameter in excludedParametersArray){
                            if(parametername == excludedParameter){
                                return true;
                            }
                        }
                    }
                }
            }
        } else {
            console.debug("The parameter " + parameterName + " is not excluded");
        }
    } else {
        console.debug("No URLConfig defined.")
    }
    } catch (err){
        console.debug("An error occured while trying to exclude " + err);
    }
return false;
}

/**
 *  The utility function to append name value pair to a URL
 *  @param allowMultipleValues (boolean) Indicates whether a parameterName can have multiple values or not, default value is <code>false</code>.
 *  @returns url The updated url.
 */
function appendToURL(url, parameterName, value, allowMultipleValues){
    allowMultipleValues = (null == allowMultipleValues) ? false : allowMultipleValues;
    var paramPattern = new RegExp(parameterName + "=[^&]+"),
    newParamString = parameterName + "=" + value;
    if ( url.indexOf(newParamString) !== -1 ) {
        //console.debug("parameter value pair " + newParamString + " is already indcluded.");
    } else if (!paramPattern.test(url) || allowMultipleValues){
        if (url.indexOf('?') === -1 ){
            url = url + '?';
        }else{
            url = url + '&';
        }
        url = url + newParamString;
    } else {
        // replace it if the old one does not match with the one in wcCommonRequestParameters, possible caching case?
        url = url.replace(paramPattern, newParamString);
        //console.debug("replace " + url.match(paramPattern) + " with " + newParamString);
    }
    return url;
}


/**
 * The function append parameters, such as <code>forUserId</code>, in <code>wcCommonRequestParameters</code>
 * as URL parameters to the give URL.
 * @param allowMultipleValues (boolean) Indicates whether a parameterName can have multiple values or not, default value is <code>false</code>
 * @returns url The updated url.
 */
function appendWcCommonRequestParameters(url, allowMultipleValues){
    allowMultipleValues = (null == allowMultipleValues) ? false : allowMultipleValues;
    if(typeof wcCommonRequestParameters === 'object'){
        for(var parameterName in wcCommonRequestParameters){
            if(!isParameterExcluded(url, parameterName)){
                url = appendToURL(url, parameterName, wcCommonRequestParameters[parameterName], allowMultipleValues);
            }
            //else {
            //console.debug("parameter " + parameterName + " is excluded.");
            //}
        }
    }
    return url;
}

/**
 *  Update the form the <code>wcCommonRequestParameters</code>.
 *  @param form The form to update.
 */
function updateFormWithWcCommonRequestParameters(form, allowMultipleValues) {
    allowMultipleValues = (null == allowMultipleValues) ? false : allowMultipleValues;
    if(typeof wcCommonRequestParameters === 'object'){
        for(var parameterName in wcCommonRequestParameters){
            if(form.action !== undefined && null !== form.action && !isParameterExcluded(form.action, parameterName) ){
                var exist = false;
                $("input[name=" + "'" + parameterName + "']", form).each(function(i, param){
                    if (param.value == wcCommonRequestParameters[parameterName]){
                        exist = true;
                        //console.debug("parameter " + parameter + " with same value alreday exist.")
                    } else if (!allowMultipleValues) {
                        form.removeChild(param);
                    }
                });
                if (!exist ) {
                    if (form.method == 'get') {
                        //the parameter in the URL for form get is not read, need to use hidden input.
                        $("<input></input>", {name: parameterName, type:'hidden', value: wcCommonRequestParameters[parameterName]}).appendTo(form);
                    } else {
                        //post action url probably already has this parameter, use 'appendToURL' to handle duplication
                        form.action = appendToURL(form.action, parameterName, wcCommonRequestParameters[parameterName], allowMultipleValues);
                    }
                }
            }
        }
    }
}

function addAuthToken(form){
    try{
        if($("#csrf_authToken").length){
            $("<input></input>", {name: "authToken", type:'hidden', value: $("#csrf_authToken").val()}).appendTo(form);
        } else {
            console.debug("auth token is missing from the HTML DOM");
        }
        return true;
    } catch (err){
        console.debug("An error occured while trying to add authToken to the form..." + err);
    }
    return false;
}

/**
 *  Process the form update and submit. All forms' submission are recommended to be done this function.
 *  @param form The form to submit.
 */
function processAndSubmitForm (form) {
    updateFormWithWcCommonRequestParameters(form);
    addAuthToken(form);
    form.submit();
}


function getCommonParametersQueryString(){
    return "storeId="+WCParamJS.storeId+"&langId="+WCParamJS.langId+"&catalogId="+WCParamJS.catalogId;
}

/**
 *  Handle service requests after user login for these scenarios:
 *  - timeout while trying to execute an Ajax request
 *  - need authentication while trying to execute an Ajax request
 *
 *  The nextUrl is a parameter returned from wc dojo framework when an error has occured when excuting an AJAX action.
 *  It specifies the next Ajax action to be performed after the user has logged on
 **/

    /**
    * This function checks to see if the passed in URL contains a parameter named 'finalView'. If it does, it will construct a new URL
    * using value from 'finalView' paramter as the view name
    * @param {String} myURL The URL to check if it contains finalView param
    */
    function getFinalViewURL(myURL) {
        var finalViewBeginIndex = myURL.indexOf('finalView');

        // check if finalView parameter is passed in the URL
        if (finalViewBeginIndex != -1){

            // index after parameter 'finalView', when it is -1, that means final view is the last paramter in the URL
            var finalViewEndIndex = myURL.indexOf('&', finalViewBeginIndex);
            if (finalViewEndIndex == -1) {
                var finalViewName = myURL.substring(finalViewBeginIndex + 10);
            } else {
                var finalViewName = myURL.substring(finalViewBeginIndex + 10, finalViewEndIndex);
            }
            var originalActionEndIndex = myURL.indexOf('?');

            // firstPartURL is everything after the '?' sign and before finalView parameter
            var firstPartURL = myURL.substring(originalActionEndIndex + 1, finalViewBeginIndex);
            // secondPartURL is everything after finalView parameter
            if (finalViewEndIndex == -1) {
                var secondPartURL = "";
            } else {
                var secondPartURL = myURL.substring(finalViewEndIndex);
            }

            // to make things simple, remove all leading and trailing '&' for firstPartURL and secondPartURL
            if (firstPartURL.charAt(firstPartURL.length - 1) == '&') {
                firstPartURL = firstPartURL.substring(0, firstPartURL.length-1);
            }
            if (firstPartURL.charAt(0) == '&') {
                firstPartURL = firstPartURL.substring(1);
            }
            if (secondPartURL.charAt(secondPartURL.length - 1) == '&') {
                secondPartURL = secondPartURL.substring(0, secondPartURL.length-1);
            }
            if (secondPartURL.charAt(0) == '&') {
                secondPartURL = secondPartURL.substring(1);
            }

            var finalURL = "";
            if (firstPartURL !== "") {
                finalURL = finalViewName + '?' + firstPartURL;
                if (secondPartURL !== "") {
                    finalURL = finalURL + '&' + secondPartURL;
                }
            } else {
                finalURL = finalViewName + '?' + secondPartURL;
            }
            return finalURL;
        } else {
            return "";
        }
    }

    wcService.declare({
        id: "MyAcctAjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: "",
        formId: ""
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            setCookie("WC_nextURL_"+WCParamJS.storeId, null, {expires:-1,path:'/', domain:cookieDomain});
            cursor_clear();
        }
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    });

    wcService.declare({
        id: "MyAcctGenericService",
        actionId: "",
        url: "",
        formId: ""
        ,successHandler: function(serviceResponse) {
            setCookie("WC_nextURL_"+WCParamJS.storeId, null, {expires:-1,path:'/', domain:cookieDomain});
            MessageHelper.hideAndClearMessage();
            finalViewURL = getFinalViewURL(this.url);
            if (finalViewURL !== "") {
                document.location.href = finalViewURL;
            } else {
                MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("MYACCOUNT_ACTION_PERFORMED"));
                cursor_clear();
            }
        }
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    });

    function invokeItemAdd(inUrl) {
        wcService.getServiceById("MyAcctAjaxAddOrderItem").url=inUrl;
        var addToCartParams = [];
        // PasswordRequestAuthenticated is required by PasswordRequestCmdImpl - to indicate password is already entered by user. As we are in the my
        // account page, password is already entered and accepted.
        addToCartParams.PasswordRequestAuthenticated = 'TRUE';

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        setCookie("WC_nextURL_"+WCParamJS.storeId, null, {expires:-1,path:'/', domain:cookieDomain});
        wcService.invoke("MyAcctAjaxAddOrderItem", addToCartParams);
    }
    function invokeOtherService(inUrl) {
        wcService.getServiceById("MyAcctGenericService").url=inUrl;
        var params = {PasswordRequestAuthenticated: 'TRUE'};

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        setCookie("WC_nextURL_"+WCParamJS.storeId, null, {expires:-1,path:'/', domain:cookieDomain});
        wcService.invoke("MyAcctGenericService", params);
    }

    /**
     * In order to handle the case that IE handles cookie domain differently from other browsers,
     * Use this centerlized function to handle cookie value assignment and ingore domain prop for cookie
     * creation when domain name is an empty string.
     */
    function setCookie(cookieName, cookieVal, props) {
        var createCookie = function(name, value, props){
            if (!props) {
                props = {};
            }

            var exp = props.expires;
            if (exp) {
                if(typeof exp == "number"){
                    var d = new Date();
                    d.setTime(d.getTime() + exp*24*60*60*1000);
                    exp = d;
                }
                if (exp.toUTCString){
                    props.expires = exp.toUTCString();
                } else {
                    props.expires = exp;
                }
            }

            value = encodeURIComponent(value);
            var propString = name + "=" + value;
            for(var name in props){
                propString += "; " + name;
                var propValue = props[name];
                if(propValue !== true){
                    propString += "=" + propValue;
                }
            }
            document.cookie = propString;
        };

        if (!props) {
            createCookie(cookieName, cookieVal);
        } else {
            var cookieProps = props;
            for (var propName in cookieProps) {
                if (!cookieProps[propName]) {
                    delete cookieProps[propName];
                }
            }
            createCookie(cookieName, cookieVal, cookieProps);
        }
    }

    function getBaseTextDir() {
        // summary:
        //      returns the value of the "baseTextDirection" preference.
        var btd = getCookie(_BTD_PREFS);
        if (!btd){
            return "";
        }
        return btd;
    }

    function setBaseTextDir(btd) {
        // summary:
        //      Sets the value of the baseTextDirection" preferences.
        var oldItem = getCookie(_BTD_PREFS);
        if (oldItem != btd){
            setCookie(_BTD_PREFS, btd.toLowerCase());
        }
    }

    function isRTLValue(stringValue) {
        for (var ch in stringValue) {
            if (isBidiChar(stringValue.charCodeAt(ch)))
                return true;
            else if(isLatinChar(stringValue.charCodeAt(ch)))
                return false;
        }
        return false;
    }

    function isBidiChar(c)  {
        if (c >= 0x05d0 && c <= 0x05ff)
            return true;
        else if (c >= 0x0600 && c <= 0x065f)
            return true;
        else if (c >= 0x066a && c <= 0x06ef)
            return true;
        else if (c >= 0x06fa && c <= 0x07ff)
            return true;
        else if (c >= 0xfb1d && c <= 0xfdff)
            return true;
        else if (c >= 0xfe70 && c <= 0xfefc)
            return true;
        else
            return false;
    }

    function isLatinChar(c){
        if((c > 64 && c < 91)||(c > 96 && c < 123))
            return true;
        else
            return false;
    }

    function resolveBaseTextDir(value, txtDir) {
        if (txtDir == "auto") {
            if (isRTLValue(value)) {
                return "rtl";
            } else {
                return "ltr";
            }
        }
        else {
            return txtDir;
        }
    }

    function handleTextDirection(requiredElement) {
        var txtDir = getBaseTextDir();
        if (requiredElement != null && txtDir !== "") {
            if (["INPUT", "TEXTAREA"].indexOf(requiredElement.tagName) > -1) {
                $(requiredElement).css("direction", resolveBaseTextDir(requiredElement.value, txtDir));
            }
        }
    }

    function enforceTextDirectionOnPage() {
        var txtDir = getBaseTextDir();
        if (txtDir !== "") {
            $(".bidiAware").each(function(i, element) {
                element.dir = $(element).css("direction", resolveBaseTextDir(element.value || element.text || element.outerText || element.innerHTML, txtDir));
            });
        }
    }

    /**
    * Common failure handler function which can be used with most of the
    * service definitions.
    * This function displays errorMessage present in serviceResponse object.
    * If errorMessage is null, then it displays errorMessageKey.
    */
    function commonServiceFailureHandler(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }

    function isChrome(){
        return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }

    function isSafari(){
        return /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
    }

    /**
    * Success handler function used with services which does URL chaining.
    * This function retrieves the next URL in the URLChain and invokes ajax service
    * with appropriate input parameters specified for the URL.
    * If the next URL is specified with requestType = 'GET', then it just
    * redirects the page to nextURL without invoking any further service
    */
    function successHandlerForURLChainingService(serviceResponse){
        console.debug("Success Handler of AjaxCustomServiceForURLChaining", serviceResponse);
        if(this.postRefreshHandlerParameters != null && this.postRefreshHandlerParameters !== ''){
            var nextServiceURL = "";
            // Retrieve the first element from the array...
            nextServiceURLObject = this.postRefreshHandlerParameters.splice(0,1)[0];
            console.debug("nextServiceURLObject ",nextServiceURLObject);

            var params = [];
            if(nextServiceURLObject != null && typeof(nextServiceURLObject) != 'undefined'){
                var nextServiceURL = nextServiceURLObject["URL"],
                requestType = nextServiceURLObject["requestType"],
                requestParams = nextServiceURLObject["requestParams"];
                console.debug("nextServiceURL ", nextServiceURL);
                console.debug("requestType ", requestType);
                console.debug("requestParams ", requestParams);
            }
            if(nextServiceURL !== "") {
                if(requestType == "GET"){
                    if(nextServiceURL.indexOf("?") === -1){
                        nextServiceURL = nextServiceURL + "?" + getCommonParametersQueryString();
                    }
                    for(var key in requestParams){
                        nextServiceURL = nextServiceURL+"&"+ key +"=" + requestParams[key];
                    }
                    document.location.href = nextServiceURL;
                } else {
                    var service = getCustomServiceForURLChaining(nextServiceURL, this.postRefreshHandlerParameters);
                    wcService.invoke(service.getParam("id"), requestParams);
                }
            } else {
                console.debug("End of URL chaining with AjaxCustomServiceForURLChaining service");
                //TODO.. should we show generic success message here ???
            }
        }
    }

    /**
    * This is a common service which can be used to chain 'N' number of service calls.
    *
    * Input parameters to this function are:
    * @url -> The URL for this service definition.
    * @postRefreshHandlerParameters -> JSON object specifying the chained service URLS along with input parameters for each of the service URLs.
    * @formId -> Form that needs to be submitted with the initial service invocation.
    * @return -> wc.service object.
    *
    * Example code:
    *
    * // Define the initial URL
    * initialURL = 'AjaxPersonChangeServiceAddressAdd';
    *
    * // Form to be submitted along with initial request.
    * formId = "addressForm"
    *
    * // Define subsequent set of chained requests
    * var postRefreshHandlerParameters = {};
    * postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderPIDelete", "requestParams":{"piId":"12345"}});
    * postRefreshHandlerParameters.push({"URL":"AjaxRESTOrderItemUpdate", "requestParams":{calculationUsage:"-1,-2,-3,-4,-5,-6,-7", calculateOrder:"1", orderItemId="10001"}});
    * postRefreshHandlerParameters.push({"URL":"DOMOrderShippingBillingView","requestType":"GET", "requestParams":{"payInStore":1}});
    *
    * // Get the service definition.
    * var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,formId);
    *
    * // Invoke the service.
    * wcService.invoke(service.id, null);
    *
    * With above sample code, the request chain will be:
    * Request 1: POST : AjaxPersonChangeServiceAddressAdd?<addressForm parameters>
    * Request 2: POST : AjaxRESTOrderPIDelete?piId=12345
    * Request 3: POST : AjaxRESTOrderItemUpdate?calculationUsage=-1,-2,-3,-4,-5,-6,-7&calculateOrder=1&orderItemId=10001
    * Request 4: GET  : DOMOrderShippingBillingView?payInStore=1
    */
    function getCustomServiceForURLChaining(url, postRefreshHandlerParameters,formId){
        var service = wcService.getServiceById('AjaxCustomServiceForURLChaining');

        if(service == null || service == undefined){
            console.debug("Start creating AjaxCustomServiceForURLChaining");
            wcService.declare({
                id: "AjaxCustomServiceForURLChaining",
                actionId: "AjaxCustomServiceForURLChaining",
                url: "",
                formId: "",
                successHandler: successHandlerForURLChainingService,
                failureHandler: commonServiceFailureHandler
            });
            service = wcService.getServiceById('AjaxCustomServiceForURLChaining');
        }

        if(url != null && url != 'undefined'){
            if (!stringStartsWith("url", "http")) {
                service.setUrl(getAbsoluteURL() + url);
            } else {
                service.setUrl(url);
            }
        }
        if(postRefreshHandlerParameters != null && postRefreshHandlerParameters != 'undefined'){
            service.setParam("postRefreshHandlerParameters", postRefreshHandlerParameters);
        } else {
            service.setParam("postRefreshHandlerParameters", null);
        }
        if(formId != null && formId != 'undefined'){
            service.setFormId(formId);
        } else {
            service.setFormId(null);
        }
        console.debug("Return AjaxCustomServiceForURLChaining", service);
        return service;
    };//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2012, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file contains functions that are used to manage the cookies that are used by the Store Locator
 * feature.
 *
 * @version 1.0
 *
 */

/**
 * The functions defined in the class are used for managing the physical store IDs and the store locator user
 * inputs.  Both information is stored in the cookie.
 *
 * @class This PhysicalStoreCookieJSStore class defines all the variables and functions to add / update / delete physical
 * store IDs and store locator user inputs.
 *
 */
PhysicalStoreCookieJSStore = {
	/* the store array is used to store physical store IDs to the cookie */
	storeArray: null,

	/* the maximum number of physical store IDs to be saved */
	arrayMaxSize: 5,

	/**
	 * This function retrieves the physical store IDs from the cookie.  These physical stores IDs are saved
	 * in the store array.  If no physical store IDs is found in the cookie, an empty store array is created.
	 *
	 * @returns {Array} The store array that contains all physical store IDs saved in the cookie.
	 *
	 */
	getStoreIdsFromCookie:function() {
        var cookieValue = getCookie("WC_physicalStores");
		this.storeArray = new Array;

		if (cookieValue != null) {
			var subValue = "";
			var remainingString = cookieValue;
			var length = cookieValue.length;
			var end = remainingString.indexOf(",");

			/* more than 1 entry */
			if (end > 0) {
				while (end >=0) {
					subValue = remainingString.substring(0, end);
					this.addToStoreArray(subValue);
					remainingString = remainingString.substring(end+1,length);
					length = remainingString.length;
					end = remainingString.indexOf(",")
				}

				subValue = remainingString;
				this.addToStoreArray(subValue);
			}
			/* 0 to 1 entry */
			else {
				/* 1 entry */
				if (length > 0) {
					this.addToStoreArray(remainingString);
				}
			}
		}
		return this.storeArray;
	},

	/**
	 * This function checks whether adding one more physical store ID to the cookie will exceed the maximum
	 * number of stores allowed to be saved limit.  The function is default to return false; otherwise, true is
	 * returned.
	 *
	 * @returns {boolean} The flag to indicate check result.
	 *
	 */
	isAddOneStoreIdExceedMax:function() {
		var exceedMax = false;

		if ((this.getNumStores() + 1) > this.arrayMaxSize) {
			exceedMax = true;
		}

		return exceedMax;
	},

	/**
	 * This function saves all the physical store IDs in the store array to the cookie.  It loops through the store
	 * array and saves all physical store IDs into the cookie.  It also ensures the cookie do not expire after the
	 * session closes.
	 *
	 */
	setStoreIdsToCookie:function() {
		var newCookieValue = "";

		for (i=0; i<this.storeArray.length; i++) {
			newCookieValue = newCookieValue + this.storeArray[i];
			if (i < (this.storeArray.length-1)) {
				newCookieValue = newCookieValue + ",";
			}
		}

		if (newCookieValue.length == 0) {
			/* delete the cookie then */
			setCookie("WC_physicalStores", null, {path: "/", expires: -1, domain: cookieDomain});
		}
		else {
			/* add or update the cookie */
			setCookie("WC_physicalStores", newCookieValue, {path: "/", domain: cookieDomain});
		}
	},

	/**
	 * This function adds the store ID to the store array.  It ensures that the store array does contain the
	 * information from the cookie and the store ID to be added does not exist in the store array.
	 *
	 * @param {String} record The physical store ID to be added.
	 *
	 */
	addToStoreArray:function(record) {
		if (this.storeArray == null) {
			this.getStoreIdsFromCookie();
		}

		for (i=0; i<this.storeArray.length; i++) {
			if (this.storeArray[i] == record) {
				return;
			}
		}

		/* do not add the new record if the array has reached the max size */
		if (this.storeArray.length < this.arrayMaxSize) {
			this.storeArray.push(record);
		}
	},

	/**
	 * This function adds the store ID to the cookie by calling the following 2 functions:
	 *       addToStoreArray()
	 *       setStoreIdsToCookie()
	 *
	 * @param {String} record The physical store ID to be added.
	 *
	 */
	addToCookie:function(record) {
		this.addToStoreArray(record);
		this.setStoreIdsToCookie();
	},

	/**
	 * This function removes the store ID from the store array.  It ensures that the store array does contain the
	 * information from the cookie and the store ID to be removed does exist in the store array.
	 *
	 * @param {String} record The physical store ID to be removed.
	 *
	 */
	removeFromStoreArray:function(record) {
		if (this.storeArray == null) {
			this.getStoreIdsFromCookie();
		}

		var recordIndex = -1;

		for (i=0; i<this.storeArray.length; i++) {
			if (this.storeArray[i] == record) {
				recordIndex = i;
				i = this.storeArray.length;
			}
		}

		this.storeArray.splice(recordIndex, 1);
	},

	/**
	 * This function removes the store ID from the cookie by calling the following 2 functions:
	 *       removeFromStoreArray()
	 *       setStoreIdsToCookie()
	 *
	 * @param {String} record The physical store ID to be removed.
	 *
	 */
	removeFromCookie:function(record) {
		this.removeFromStoreArray(record);
		this.setStoreIdsToCookie();
	},

	/**
	 * This function empties the store array.
	 *
	 */
	clearStoreArray:function() {
		this.storeArray = new Array;
	},

	/**
	 * This function updates the cookie with the empty store array.
	 *
	 */
	clearCookie:function() {
		this.clearStoreArray();
		this.setStoreIdsToCookie();
	},

	/**
	 * This function returns the number of physical stores saved in the cookie.  It ensures the store array contains
	 * the information retrieved from the cookie before getting the number of stores.
	 *
	 * @returns {int} The number of physical stores saved.
	 *
	 */
	getNumStores:function() {
		if (this.storeArray == null) {
			this.getStoreIdsFromCookie();
		}

		return this.storeArray.length;
	},

	/**
	 * This function retrieves the pick up store ID from the cookie.  If no pick up store ID is found in the cookie,
	 * null is returned.
	 *
	 * @returns {String} The pick up store IDs.
	 *
	 */
	getPickUpStoreIdFromCookie:function() {
        var pickUpStoreId = getCookie("WC_pickUpStore");
		return pickUpStoreId;
	},

	/**
	 * This function adds or updates the pick up store ID to the cookie.
	 *
	 * @param {String} value The new pick up store ID.
	 *
	 * @returns {element} .
	 *
	 */
	setPickUpStoreIdToCookie:function(value) {
		var newPickUpStoreId = value;
		if (newPickUpStoreId != null && newPickUpStoreId != "undefined" && newPickUpStoreId != "") {
			var currentPickUpStoreId = this.getPickUpStoreIdFromCookie();
			if (newPickUpStoreId != currentPickUpStoreId) {
				setCookie("WC_pickUpStore", null, {path: "/", expires: -1, domain: cookieDomain});
				setCookie("WC_pickUpStore", newPickUpStoreId, {path: "/", domain: cookieDomain});
			}
		}
	},

	/**
	 * This function clears the pick up store ID from the cookie when the parameter matches the current pick up
	 * store ID in the cookie.
	 *
	 * @param {String} value The pick up store ID for comparison.
	 *
	 */
	clearPickUpStoreIdFromCookie:function(value) {
		var newPickUpStoreId = value;
		if (newPickUpStoreId != null && newPickUpStoreId != "undefined" && newPickUpStoreId != "") {
			var currentPickUpStoreId = this.getPickUpStoreIdFromCookie();
			if (newPickUpStoreId == currentPickUpStoreId) {
				setCookie("WC_pickUpStore", null, {path: "/", expires: -1, domain: cookieDomain});
			}
		}
	},

	/**
	 * This generic function retrieves the value from the cookie based on the cookie key.  It is used to store
	 * "country: WC_stCntry", "province: WC_stProv", "city: WC_stCity" and "search performed flag: WC_stFind".  If no
	 * value is found in the cookie for the cookie key, null is returned.
	 *
	 * @param {String} cookieKey The key of the cookie.
	 *
	 * @returns {String} The value obtained from the cookie.
	 *
	 */
	getValueFromCookie:function(cookieKey) {
        var cookieValue = getCookie(cookieKey);
		return cookieValue;
	},

	/**
	 * This function adds or updates the value to the cookie using the key provided.  It is used to store
	 * "country: WC_stCntry", "province: WC_stProv", "city: WC_stCity" and "search performed flag: WC_stFind".
	 *
	 * @param {String} cookieKey The key of the cookie.
	 * @param {String} cookieValue The new value of the cookie.
	 *
	 */
	setValueToCookie:function(cookieKey, cookieValue) {
		var newValue = cookieValue;
		if (newValue != null && newValue != "undefined" && newValue != "") {
			var currentValue = this.getValueFromCookie(cookieKey);
			if (newValue != currentValue) {
				setCookie(cookieKey, null, {path: "/", expires: -1, domain: cookieDomain});
				setCookie(cookieKey, newValue, {path: "/", domain: cookieDomain});
			}
		}
	},

	/**
	 * This function clears the value referred by a key from the cookie.
	 *
	 * @param {String} cookieKey The key of the cookie.
	 *
	 */
	clearValueFromCookie:function(cookieKey) {
		var currentValue = this.getValueFromCookie(cookieKey);
		if (currentValue != null && currentValue != "undefined") {
			setCookie(cookieKey, null, {path: "/", expires: -1, domain: cookieDomain});
		}
	}

}
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2008, 2013
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file contains functions that are used by Store Locator.
 *
 * @version 1.0
 *
 */


/**
 * The functions defined in the class are used for the Store Locator feature.
 *
 * @class This storeLocatorJSStore class defines all the functions to be used on pages that contain the Store Locator feature.
 *
 */
storeLocatorJSStore = {

    /**
     * This function initializes the state/province selection drop down list by extracting the selected value
     * of the country selection.  Nothing is done when no selected country is found.
     *
     */
    initProvinceSelections: function () {
        var countrySelectedIndex = $("#selectCountry").prop("selectedIndex");
        if (countrySelectedIndex > -1) {
            var indexToUse = countrySelectedIndex;
            var indexFromSavedId = storeLocatorJSStore.getSavedCountrySelectionIndex();

            if (indexFromSavedId != null && indexFromSavedId != countrySelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectCountry")[0].options[indexToUse].selected = true;
            }
            wcRenderContext.updateRenderContext('provinceSelectionsContext', {
                'countryId': $("#selectCountry")[0].options[indexToUse].value
            });
        }
    },

    /**
     * This function refreshes the city selection drop down list by extracting the selected value of the
     * state/province selection.  Nothing is done when no selected state/province is found.
     *
     */
    refreshCities: function () {
        var stateSelectedIndex = $("#selectState").prop("selectedIndex");
        if (stateSelectedIndex > -1) {
            var indexToUse = stateSelectedIndex;
            var indexFromSavedId = storeLocatorJSStore.getSavedProvinceSelectionIndex();
            if (indexFromSavedId != null && indexFromSavedId != stateSelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectState")[0].options[indexToUse].selected = true;
            }
            wcRenderContext.updateRenderContext('citySelectionsContext', {
                'provinceId': $("#selectState")[0].options[indexToUse].value
            });
        }
    },

    /**
     * This function refreshes the store location search results by extracting the selected value of the city
     * selection.  Nothing is done when no selected city is found.  Store location search results are refreshed
     * automatically once when a search intend (i.e. Find button is pressed) was done before.
     *
     * @param {String} fromPage Parameter value passed by the calling page.
     *
     */
    refreshSearchResults: function (fromPage) {
        var citySelectedIndex = $("#selectCity").selectedIndex;
        if (citySelectedIndex > -1) {
            var indexToUse = citySelectedIndex;
            var indexFromSavedId = storeLocatorJSStore.getSavedCitySelectionIndex();
            if (indexFromSavedId != null && indexFromSavedId != citySelectedIndex) {
                indexToUse = indexFromSavedId;
                $("#selectCountry")[0].options[indexToUse].value("selectCity").options[indexToUse].selected = true;
            }

            var performFindFlag = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stFind");
            if (performFindFlag != null) {
                wcRenderContext.updateRenderContext('storeLocatorResultsContext', {
                    'cityId': document.getElementById("selectCountry").options[indexToUse].value("selectCity").options[indexToUse].value,
                    'fromPage': fromPage
                });
            }
        }
    },

    /**
     * This function adds the user selected physical store to the cookie when the maximum number of physical
     * stores has not reached; otherwise, a message is displayed.
     *
     * @param {String} physicalStoreId The physical store Unique ID to be added.
     * @param {String} optionIndex The index of the physical store to be added.
     *
     * @returns {boolean} A flag to indicate whether the add is performed.
     *
     */
    addPhysicalStore: function (physicalStoreId, optionIndex) {
        if (PhysicalStoreCookieJSStore.isAddOneStoreIdExceedMax() == true) {
            if (document.getElementById("addPhysicalStoreToCookieButton" + optionIndex) != null) {
                MessageHelper.formErrorHandleClient("addPhysicalStoreToCookieButton" + optionIndex, MessageHelper.messages["EXCEED_PHYSICAL_STORE_SIZE"]);
                return false;
            } else {
                MessageHelper.displayErrorMessage(MessageHelper.messages["EXCEED_PHYSICAL_STORE_SIZE"]);
                return false;
            }
        }

        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        PhysicalStoreCookieJSStore.addToCookie(physicalStoreId);
        storeLocatorJSStore.showRemoveOption(physicalStoreId);
        return true;
    },

    /**
     * This function removes the user selected physical store from the cookie.
     *
     * @param {String} physicalStoreId The physical store Unique ID to be removed.
     *
     */
    removePhysicalStore: function (physicalStoreId) {
        PhysicalStoreCookieJSStore.removeFromCookie(physicalStoreId);
        PhysicalStoreCookieJSStore.clearPickUpStoreIdFromCookie(physicalStoreId);
        storeLocatorJSStore.showAddOption(physicalStoreId);
    },

    /**
     * This function shows the disabled "add physical store" option and hides the "add physical store" option
     * of the physical store.
     *
     * @param {String} physicalStoreId The physical store Unique ID.
     *
     */
    showRemoveOption: function (physicalStoreId) {
        var addDisabledDiv = $("#addPhysicalStoreToCookieDisabled" + physicalStoreId);
        var addDiv = $("#addPhysicalStoreToCookie" + physicalStoreId);

        if (addDisabledDiv != null && addDisabledDiv != "undefined") {
            $(addDisabledDiv).css("display", "block");
        }

        if (addDiv != null && addDiv != "undefined") {
            $(addDiv).css("display", "none");
        }
    },

    /**
     * This function shows the "add physical store" option and hides the disabled "add physical store" option
     * of the physical store.
     *
     * @param {String} physicalStoreId The physical store Unique ID.
     *
     */
    showAddOption: function (physicalStoreId) {
        var addDisabledDiv = $("#addPhysicalStoreToCookieDisabled" + physicalStoreId);
        var addDiv = $("#addPhysicalStoreToCookie" + physicalStoreId);

        if (addDisabledDiv != null && addDisabledDiv != "undefined") {
            $(addDisabledDiv).css("display", "none");
        }

        if (addDiv != null && addDiv != "undefined") {
            $(addDiv).css("display", "block");
        }
    },

    /**
     * This function manages the cookie values when OK button is pressed from city search.
     *
     */
    manageCookieFromCity: function () {
        PhysicalStoreCookieJSStore.setValueToCookie('WC_stFind', 1);
    },

    /**
     * This function refreshes the result area when a city is selected.  It refreshes the physical store
     * information.
     *
     * @param form The form that contains the "city" selections.
     * @param {String} fromPage The fromPage parameter value passed by the calling page.
     *
     */
    refreshResultsFromCity: function (form, fromPage) {
        if (form.selectCity.selectedIndex < 0) {
            MessageHelper.formErrorHandleClient(form.selectCity.id, MessageHelper.messages["MISSING_CITY"]);
            return;
        }

        /* manage cookie values */
        storeLocatorJSStore.manageCookieFromCity();

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsContext', {
            'cityId': form.selectCity.options[form.selectCity.selectedIndex].value,
            'fromPage': fromPage,
            'geoCodeLatitude': '',
            'geoCodeLongitude': '',
            'errorMsgKey': ''
        });
    },

    /**
     * This function refreshes the result area when the geolocation feature is used.  It refreshes the
     * physical store information.
     *
     * @param {String} geoCodeLatitude The user's latitude coordinate.
     * @param {String} geoCodeLongitude The user's longitude coordinate.
     *
     */
    refreshResultsFromNearest: function (geoCodeLatitude, geoCodeLongitude) {
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCntry");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsContext', {
            'geoCodeLatitude': geoCodeLatitude,
            'geoCodeLongitude': geoCodeLongitude,
            'errorMsgKey': ''
        });
    },

    /**
     * This function refreshes the result area when the geolocation feature is used.  It refreshes the
     * physical store information.
     *
     * @param {String} errorMsgKey The resource key for the error message.
     *
     */
    refreshResultsWithLocationError: function (errorMsgKey) {
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");

        /* refresh the result area */
        wcRenderContext.updateRenderContext('storeLocatorResultsContext', {
            'errorMsgKey': errorMsgKey
        });
    },

    /**
     * This function refreshes the store list area.
     *
     * @param {String} fromPage The fromPage parameter value passed by the calling page.
     *
     */
    refreshStoreList: function (fromPage) {
        /* refresh the store list area */
        wcRenderContext.updateRenderContext('selectedStoreListContext', {
            'fromPage': fromPage
        });
    },

    removeFromStoreList: function (fromPage, tableRowId) {
        var numStores = PhysicalStoreCookieJSStore.getNumStores();
        if (numStores == 0) {
            // Refresh to remove complete table and display status message
            this.refreshStoreList(fromPage);
        } else {
            // Just remove store from the table.
            var tableRow = document.getElementById(tableRowId);
            tableRow.remove();
        }
    },

    /**
     * This function hides the store list area.
     *
     */
    hideStoreList: function () {
        var storeListDiv = $("#selectedStoreList");
        var showListHeaderDiv = $("#showStoreListHeader");
        var hideListHeaderDiv = $("#hideStoreListHeader");

        if (storeListDiv != null && storeListDiv != "undefined") {
            $(storeListDiv).css("display", "none");
        }
        if (showListHeaderDiv != null && showListHeaderDiv != "undefined") {
            $(showListHeaderDiv).css("display", "block");
        }
        if (hideListHeaderDiv != null && hideListHeaderDiv != "undefined") {
            $(hideListHeaderDiv).css("display", "none");
        }
    },

    /**
     * This function shows the store list area.
     *
     */
    showStoreList: function () {
        var storeListDiv = $("#selectedStoreList");
        var showListHeaderDiv = $("#showStoreListHeader");
        var hideListHeaderDiv = $("#hideStoreListHeader");

        if (storeListDiv != null && storeListDiv != "undefined") {
            $(storeListDiv).css("display", "block");
        }
        if (showListHeaderDiv != null && showListHeaderDiv != "undefined") {
            $(showListHeaderDiv).css("display", "none");
        }
        if (hideListHeaderDiv != null && hideListHeaderDiv != "undefined") {
            $(hideListHeaderDiv).css("display", "block");
        }
    },

    /**
     * This function is called after the counry selection list is changed.
     *
     * @param {String} countryId The unique ID of the selected country.
     *
     */
    changeCountrySelection: function (countryId) {
        PhysicalStoreCookieJSStore.setValueToCookie("WC_stCntry", countryId);
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stProv");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");

        wcRenderContext.updateRenderContext("provinceSelectionsContext", {
            "countryId": countryId
        });
    },

    /**
     * This function is called after the province selection list is changed.
     *
     * @param {String} provinceId The unique ID of the selected province.
     *
     */
    changeProvinceSelection: function (provinceId) {
        PhysicalStoreCookieJSStore.setValueToCookie("WC_stProv", provinceId);
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stCity");
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");

        wcRenderContext.updateRenderContext("citySelectionsContext", {
            "provinceId": provinceId
        });
    },

    /**
     * This function is called after the city selection list is changed.
     *
     * @param {String} cityId The unique ID of the selected city.
     *
     */
    changeCitySelection: function (cityId) {
        PhysicalStoreCookieJSStore.setValueToCookie("WC_stCity", cityId);
        PhysicalStoreCookieJSStore.clearValueFromCookie("WC_stFind");
    },

    /**
     * This function retrieves the index of the country selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved country ID.
     *
     * @returns {int} The index of the country selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedCountrySelectionIndex: function () {
        var index = null;
        var savedCountryId = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCntry");
        if (savedCountryId != null) {
            /* search for matching ID */
            var selectedCountryList = $("#selectCountry");
            if (selectedCountryList != null && selectedCountryList != "undefined") {
                var listSize = selectedCountryList.length;
                for (i = 0; i < listSize; i++) {
                    if (savedCountryId == selectedCountryList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    },

    /**
     * This function retrieves the index of the province selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved province ID.
     *
     * @returns {int} The index of the province selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedProvinceSelectionIndex: function () {
        var index = null;
        var savedProvinceId = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stProv");
        if (savedProvinceId != null) {
            /* search for matching ID */
            var selectedProvinceList = $("#selectState");
            if (selectedProvinceList != null && selectedProvinceList != "undefined") {
                var listSize = selectedProvinceList.length;
                for (i = 0; i < listSize; i++) {
                    if (savedProvinceId == selectedProvinceList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    },

    /**
     * This function retrieves the index of the city selection list which has a value matches the one saved in
     * the cookie.  Null is returned when cookie does not contain any saved city ID.
     *
     * @returns {int} The index of the city selection list which has a value matches the one saved in the
     * cookie.
     *
     */
    getSavedCitySelectionIndex: function () {
        var index = null;
        var savedCityId = PhysicalStoreCookieJSStore.getValueFromCookie("WC_stCity");
        if (savedCityId != null) {
            /* search for matching ID */
            var selectedCityList = $("#selectCity");
            if (selectedCityList != null && selectedCityList != "undefined") {
                var listSize = selectedCityList[0].options.length;
                for (i = 0; i < listSize; i++) {
                    if (savedCityId == selectedCityList[0].options[i].value) {
                        index = i;
                        i = listSize;
                    }
                }
            }
        }

        return index;
    }

}
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2008, 2009
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file declares the contexts of the store locator.
 *
 * @version 1.0
 *
 */


/**
 * The functions defined in the class are used to initialize the common parameters of the contexts and set the
 * properties of a specific context.
 *
 * @class This StoreLocatorContextsJSStore class defines all the variables and functions for manipuating the contexts
 * of the store locator.
 *
 */
StoreLocatorContextsJSStore = {
    /* common paramater declarations */
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",

    /**
     * This function initializes the common parameters.
     *
     * @param {String} langId The language ID.
     * @param {String} storeId The store ID.
     * @param {String} catalogId The catalog ID.
     * @param {String} orderId The order ID.
     * @param {String} fromPage The constants indicates what the calling page is.
     *
     */
    setCommonParameters: function (langId, storeId, catalogId, orderId, fromPage) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.orderId = orderId;
        this.fromPage = fromPage;
    },

    /**
     * This function sets a property of a context.
     *
     * @param {String} contextId The context identifier.
     * @param {String} property The property name.
     * @param {String} value The property value.
     *
     */
    setContextProperty: function (contextId, property, value) {
        wcRenderContext.getRenderContextProperties(contextId)[property] = value;
    }

}


/* context declaration for "provinceSelectionsContext" */
wcRenderContext.declare("provinceSelectionsContext", ["provinceSelections"], ""),

    /* context declaration for "citySelectionsContext" */
    wcRenderContext.declare("citySelectionsContext", ["citySelections"], ""),

    /* context declaration for "storeLocatorResultsContext" */
    wcRenderContext.declare("storeLocatorResultsContext", ["storeLocatorResults"], ""),

    /* context declaration for "selectedStoreListContext" */
    wcRenderContext.declare("selectedStoreListContext", ["selectedStoreList"], "")
;//<%--
//********************************************************************
//*-------------------------------------------------------------------
//* Licensed Materials - Property of IBM
//*
//* WebSphere Commerce
//*
//* (c) Copyright IBM Corp.  2008, 2009
//* All Rights Reserved
//*
//* US Government Users Restricted Rights - Use, duplication or
//* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
//*
//*-------------------------------------------------------------------
//*
//--%>

/**
 * @fileOverview This file declares the controllers of the store locator.
 *
 * @version 1.0
 *
 */

/**
 * The functions defined in the class are used to initialize the common parameters of the controllers and set the
 * URL of a specific controller.
 *
 * @class This StoreLocatorContextsJSStore class defines all the variables and functions for manipuating the controllers
 * of the store locator.
 *
 */
StoreLocatorControllersDeclarationJSStore = {
    /* common paramater declarations */
    langId: "-1",
    storeId: "",
    catalogId: "",
    orderId: "",
    fromPage: "StoreLocator",

    /**
     * This function initializes the common parameters.
     *
     * @param {String} langId The language ID.
     * @param {String} storeId The store ID.
     * @param {String} catalogId The catalog ID.
     * @param {String} orderId The order ID.
     * @param {String} fromPage The constants indicates what the calling page is.
     *
     */
    setCommonParameters: function (langId, storeId, catalogId, orderId, fromPage) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.orderId = orderId;
        this.fromPage = fromPage;
    },

	/* refresh controller declaration for "provinceSelectionsController" */
	provinceSelectionsRefreshArea: function () {

		var myWidgetObj = $("#provinceSelections"),
			myRCProperties = wcRenderContext.getRenderContextProperties("provinceSelectionsContext");

		myWidgetObj.refreshWidget({
			formId: "",


			renderContextChangedHandler: function () {

				cursor_wait();
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			},

			postRefreshHandler: function () {

				storeLocatorJSStore.refreshCities();
				cursor_clear();
			}
		});
	},

	/* refresh controller declaration for "citySelectionsController" */
	citySelectionsRefreshController: function () {

		var myWidgetObj = $("#citySelections"),
			myRCProperties = wcRenderContext.getRenderContextProperties("citySelectionsContext");

		myWidgetObj.refreshWidget({
			formId: "",


			renderContextChangedHandler: function () {

				cursor_wait();
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			},


			postRefreshHandler: function (widget) {

				storeLocatorJSStore.refreshSearchResults(StoreLocatorControllersDeclarationJSStore.fromPage);
				cursor_clear();
			}

		});
	},


	/* refresh controller declaration for "storeLocatorResultsController" */
	storeLocatorResultsRefreshController: function () {

		var myWidgetObj = $("#storeLocatorResults"),
			myRCProperties = wcRenderContext.getRenderContextProperties("storeLocatorResultsContext");

		myWidgetObj.refreshWidget({
			formId: "",

			renderContextChangedHandler: function () {
				cursor_wait();
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			},

			postRefreshHandler: function () {

				var bopisTable = $("#bopis_table");
				if (bopisTable != null && bopisTable != "undefined") {
					bopisTable.focus();
				}
				var noStoreMsg = $("#no_store_message");
				if (noStoreMsg != null && noStoreMsg != "undefined") {
					noStoreMsg.focus();
				}

				cursor_clear();
			}

		});
	},

	/* refresh controller declaration for "selectedStoreListController" */
	selectedStoreListRefreshController: function () {

		var myWidgetObj = $("#selectedStoreList"),
			myRCProperties = wcRenderContext.getRenderContextProperties("selectedStoreListContext");

		myWidgetObj.refreshWidget({
			formId: "",


			renderContextChangedHandler: function () {

				cursor_wait();
				myWidgetObj.refreshWidget("refresh", myRCProperties);
			},

			postRefreshHandler: function () {

				var bopisTable = $("#bopis_table");
				if (bopisTable != null && bopisTable != "undefined") {
					bopisTable.focus();
				}

				cursor_clear();
			}

		})
	}
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by AddressBookForm.jsp and UnregisteredCheckout.jsp.
 * @version 1.0
 */

/**
 *  The functions defined in this class enable the customer to maintain an address book.
 *	@class The AddressBookFormJS class defines all the functions and variables to update an address book. The customer can add or
 *  remove an address form the address book. The fields that can be entered while creating an address are first name, last name,
 *  street address, city, country/region, state/province, ZIP/postal code, phone number, e-mail address.
 */

AddressBookFormJS = {
	/* The common parameters used in service calls. */
		langId: "-1",
		storeId: "",
		catalogId: "",
	/* flag set on address delete which is used to display the success message. */
		addressDeleted: "false",
	/* flag set on creation of new address which is used to display the success message. */
		addressNew: "false",
	/* variable set on address update which is used to display the success message. */
		pageVar: "",

	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
	},

	/**
	 * This function returns the handler for the refresh controller corresponding to the action.
	 * @param {string} handlerKey The key of the handler.
	 * @param {string} actionName The name of the action to be performed.
	 *
	 * @return function handler.
	 */
	getControllerActionHandler: function(handlerKey, actionName){
		console.debug("entering getControllerActionHandler(controller, handlerKey, actionName): "+actionName);
		var handler = AddressBookFormJS[actionName+'s'][handlerKey];
		if(handler){
			return function(message, widget, controller){
				handler(message, widget, controller);

			}
		}else{
			return function(message, widget, controller){
				console.debug("empty handler. This is a no-op");
			}
		}
	},

	/**
	 *  This defines function registries for handling address forms. We register functions that handle different operations
	 *	on address forms. The key of each function will be the value of the property "addressFormAreaAction" in render context.
	 *  Each function takes three parameters: message, widget, and controller. The parameters message and widget are the same as those for
	 *	a controller's renderContextChangedHandler(). The parameter controller is the controller that will call this function.
	 */
	addressFormAreaActions: {
		/* The function that loads an empty address for for creating new address. */
		create: function(message, widget, controller){
			widget.refresh(controller.renderContext.properties);
			controller.renderContext.properties['addressFormAreaState'] = 'create';
		},

		/* The function that loads an address form that contains the information of currently displayed address, so that the
		 * address can be edited.
		 */
		edit: function(message, widget, controller){
			console.debug("starting to getting editing area");
			widget.refresh(controller.renderContext.properties);
			controller.renderContext.properties['addressFormAreaState'] = 'edit';
		},

		/* Destroy the address forms that are handled by this controller. */
		clean: function(message, widget, controller){
			widget.setInnerHTML("");
			controller.renderContext.properties['addressFormAreaState'] = 'clean';
		},

		/* This function behaves same as {@link clean} function. */
		handleModelChange: function(message, widget, controller){
			widget.setInnerHTML("");
			controller.renderContext.properties['addressFormAreaState'] = 'clean';
		}

	},

	/*
	 * This defines function registries handling address display.The registered functions handle operations on
     * the refresh area that displays user addresses.Each function takes three parameters: message, widget, and controller.
	 *
	 * @see AddressBookFormJS.addressFormAreaActions
	 */
	addressDisplayAreaActions: {

		/* This function reloads the refresh areas that display user addresses. */
		reload: function(message, widget, controller){
			console.debug("reloading "+widget);
			widget.refresh(controller.renderContext.properties);
		},

		/* This function behaves similar to {@link reload} function. */
		handleModelChange: function(message, widget, controller){
			console.debug("reloading "+widget);
			widget.refresh(controller.renderContext.properties);
		}
	},

	/*
	 * This defines function registries for handling the display of states and province. The registered functions displays states upon changes made
	 * in address country. Each function takes three parameters: message, widget, and controller.
	 */
	statesDisplayAreaActions: {

		/* This function  refreshes the area that displays states/provinces corresponding to the updated country */
		countryUpdated: function(message, widget, controller){
			console.debug("IN countryUpdated handler: message = "+message);

			var paramPrefix = controller.renderContext.properties['paramPrefix'];
			if(widget.widgetId.match(paramPrefix)){
				console.debug("matchin paramPrefix: "+paramPrefix+" refreshing "+widget.widgetId);

				widget.refresh(controller.renderContext.properties);
			}else{
				console.debug("no maching paramPrefix "+paramPrefix);
			}

		}

	},

	/**
	 *  This function displays the address that has the selected address Id, and hides all the other addresses.
	 *  This function is supposed to be called when an addressId is selected from an HTML form selection control.
	 *	This function makes a few assumptions. It assumes each ddress is displayed in the same way. Each chunk
	 *	of address information has the same class, tableClass. It also assumes the area that displays
	 *	an address has an ID in the form of <tableIdPrefix><addressId>.
	 *  @param {DomNode} selection The DomNode of a form selection. This node contains selected addressId.
	 *  @param {string} tableClass The class of the table that contains an address.
	 *  @param {string} tableIdPrefix The prefix of the Id of each address table.
	 */
	toggleAddressDisplay: function(selection, tableClass, tableIdPrefix){
		console.debug('toggle address display');
		var selectedAddressId = selection.options[selection.selectedIndex].value;
			$("."+tableClass).each(function(i, div){
			var tableId = tableIdPrefix+selectedAddressId;
			if(div.id == tableId && selectedAddressId != "MyBillingAddress"){
				$(div).css("display", "block");
			}else{
				$(div).css("display", "none");
			}
		});
	},

	/*
	 * This function is used to load the details corresponding to an address selection. When the customer
	 * selects an address from the dropdown, this function displays the stored address details
	 * corresponding to the selection.
	 * @param {string} selection The id of the address dropdown box.
	 * @param {array} addresses Array of address objects.
	 * @param {object} form The actual HTML form object containing address information.
	 */
	populateTextFields: function(selection, addresses, form){

		if(document.getElementById("adding").style.display=='block')
		{
			var hidediv = document.getElementById("adding");
			hideElementById(hidediv);
			var div = document.getElementById("normal");
			div.style.display = "block";
		}
		var selectedAddressId = selection.options[selection.selectedIndex].value;

		var radioButton = form.sbAddress;
		for (var i=0; i<radioButton.length; i++)
		{
			if (radioButton[i].value == addresses[selectedAddressId].addressType)
			{
				radioButton[i].checked = "checked";
			}
		}
		form.nickName.value = addresses[selectedAddressId].nickName;
		form.firstName.value = addresses[selectedAddressId].firstName;
		form.lastName.value = addresses[selectedAddressId].lastName;
		form.address1.value = addresses[selectedAddressId].address1;
		form.address2.value = addresses[selectedAddressId].address2;
		form.country.value = addresses[selectedAddressId].country;
		form.zipCode.value = addresses[selectedAddressId].zipCode;
		form.email1.value = addresses[selectedAddressId].email1;
		form.phone1.value = addresses[selectedAddressId].phone1;
		form.city.value = addresses[selectedAddressId].city;
		AddressHelper.loadStatesUI('AddressForm','','stateDiv','state');
		form.state.value = addresses[selectedAddressId].state;
		if(form.middleName)
			form.middleName.value = addresses[selectedAddressId].middleName;
		document.getElementById("addr_title").innerHTML="<h2 class='status_msg'>"+addresses[selectedAddressId].nickName+"</h2>";
	},

	/*
	 * This function displays the default customer address on load of the address book page.
	 * @param {string} selection The id of the address dropdown box.
	 * @param {array} addresses Array of address objects.
	 * @param {object} form The actual HTML form object containing address information.
	 */

	populateTextFieldsOnLoad: function(selection, addresses, form){

		var selectedAddressId = selection.options[selection.selectedIndex].value;

		var radioButton = form.sbAddress;
		for (var i=0; i<radioButton.length; i++)
		{
			if (radioButton[i].value == addresses[selectedAddressId].addressType)
			{
				radioButton[i].checked = "checked";
			}
		}
		form.nickName.value = addresses[selectedAddressId].nickName;
		form.firstName.value = addresses[selectedAddressId].firstName;
		form.lastName.value = addresses[selectedAddressId].lastName;
		form.address1.value = addresses[selectedAddressId].address1;
		form.address2.value = addresses[selectedAddressId].address2;
		form.state.value = addresses[selectedAddressId].state;
		form.country.value = addresses[selectedAddressId].country;
		form.zipCode.value = addresses[selectedAddressId].zipCode;
		form.email1.value = addresses[selectedAddressId].email1;
		form.phone1.value = addresses[selectedAddressId].phone1;
		form.city.value = addresses[selectedAddressId].city;
		if(form.middleName)
			form.middleName.value = addresses[selectedAddressId].middleName;
		AddressHelper.loadStatesUI('AddressForm','','stateDiv','state', true);
		document.getElementById("addr_title").innerHTML="<h2 class='status_msg'>"+addresses[selectedAddressId].nickName+"</h2>";
	},

	/**
	 *  This function is used to clear the values of all the form input fields in the address book.
	 *  The function obtains each form field by id and clears its value. This is usually done after form submit.
	 */

	clearTextFields: function(form){
		form.nickName.value="";
		form.firstName.value="";
		form.lastName.value="";
		form.address1.value="";
		form.address2.value="";
		form.city.value="";
		form.state.value="";
		form.country.value="";
		form.zipCode.value="";
		form.email1.value="";
		form.phone1.value="";
		if(form.middleName) {
			form.middleName.value="";
		}
	},

	/**
	 *  This function loads the address form when addnew button is clicked. This loads the form with all the input fields cleared.
	 */
	showAdd: function(){

		var hidediv = document.getElementById("normal");
		hideElementById(hidediv);
		var div = document.getElementById("adding");
		div.style.display = "block";
	},


	/**
	 * This function is used during Unregistered checkout and makes the Shipping address same as the Billing address.
	 * This function takes shipping and billing forms as input and copies the billing address information to the shipping address.
	 * @param {string} fromName The name of the Billing address form.
	 * @param {string} toName The name of the Shipping address form.
	 */
	copyBillingFormNew: function(fromName,toName){

			var form = document.forms[fromName];
			var to = document.forms[toName];
			var sameaddress = document.getElementById("SameShippingAndBillingAddress");
			if (sameaddress.checked){
				hideElementById("shippingAddressCreateEditFormDiv_1");

				to.firstName.value = form.firstName.value;
				to.lastName.value = form.lastName.value;
				to.address1.value = form.address1.value;
				to.address2.value = form.address2.value;
				to.city.value = form.city.value;
				if(isIE){(document.getElementById("stateDiv2").firstChild).value = (document.getElementById("stateDiv1").firstChild).value;}
				else {to.state.value = form.state.value;}
				to.zipCode.value = form.zipCode.value;
				to.country.value = form.country.value;
				to.phone1.value = form.phone1.value;
				to.email1.value = form.email1.value;
				if(form.middleName)
					to.middleName.value = form.middleName.value;
			}

			if (!sameaddress.checked){
				showElementById("shippingAddressCreateEditFormDiv_1");
				to.firstName.value = "";
				to.lastName.value = "";
				to.address1.value = "";
				to.address2.value = "";
				to.city.value = "";
				if(isIE){(document.getElementById("stateDiv2").firstChild).value= "";}
				else{to.state.value = "";}
				to.zipCode.value = "";
				to.phone1.value = "";
				to.email1.value = "";
				if(to.middleName)
					to.middleName.value = "";
			}
		}

};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the store jsp's related to address creation and maintenance.
 * @version 1.0
 */

/**
 * The functions defined in this class enable address creation across the store.
 * @class The functions and variables defined in this class validate the form input field values entered by
 * the customer. Another set of functions help in loading the UI for the state field when there is a change
 * in the country field. Another set of functions enable creating an address in the shopcart page and
 * guest user checkout page.
 */

//
//AddressHelper = {
//	/* The name of the state field div. */
//	stateDivName : "stateDiv",
//	/* styling class for the state field. */
//	stateClass   : null,
//
//	/**
//	 * This function sets the name for the state field.
//	 * @param {string} stateDivName The name to be set for the state field.
//	 */
//	setStateDivName:function(stateDivName){
//		this.stateDivName = stateDivName;
//	 },
//
//	 /**
//	  * This function sets the styling class for the state field.
//	  * @param {string} stateClass The name of the styling class to be set for the state field.
//	  */
//	setStateClass:function(stateClass){
//		this.stateClass = stateClass;
//	},
//
//
//	/**
//	 * This function return an array of countries from a global variable called countries.
//	 * If that variable does not already exist then it will be created and populated from a JSON of country objects which should
//	 * have been loaded into a div on the page prior to calling this function.
//	 *
//	 * @returns {Array} countries An array of countries.
//	 **/
//	 getCountryArray:function()
//	{
//
//		//If the countries array does not already exist then create it.
//
//			if (document["countries"] == null)
//			{
//				countries = new Array();
//				var theDiv = document.getElementById("countryListSelectionHelper");
//
//				if (typeof theDiv == 'undefined') return null;
//				var divJSON = eval('('+ theDiv.innerHTML +')');
//				var countriesObject = divJSON.countries;
//
//				for (var i = 0; i < countriesObject.length; i++)
//				{
//					var countryObject = countriesObject[i];
//					countries[countryObject.code] = new Object();
//					countries[countryObject.code].name = countryObject.displayName;
//					countries[countryObject.code].countryCallingCode = countryObject.callingCode;
//
//					if (countryObject.states.length > 0)
//					{
//						countries[countryObject.code].statesArray = new Array();
//						countries[countryObject.code].states = new Object();
//						for (var j = 0; j < countryObject.states.length; j++)
//						{
//							var state = countryObject.states[j];
//							countries[countryObject.code].statesArray.push({value:state.code, label:state.displayName});
//							countries[countryObject.code].states[state.code] = state.displayName;
//						}
//					}
//				}
//			}
//
//			return countries;
//
//	},
//
//
//	/**
//	 * This function will load the state field depending on the country selection.
//	 * @param {string} formName  The name of the address form containing the state field and country field.
//	 * @param {string} stateDiv  The name of the state field.
//	 * @param {string} id The id of the state field to be created.
//	 * @param {boolean} keepCurrentState A true or false value used to determine whether to keep the current value in the state field or to remove it.
//	 * @param {string} copyValue The value to be copied to the newly generated state field.
//	 */
//	loadStatesUI:function(formName,paramPrefix,stateDiv,id, keepCurrentState, copyValue){
//
//		this.getCountryArray();
//		var form = document.getElementById(formName);
//		if(paramPrefix == null || paramPrefix == 'undefined' || paramPrefix == ""){
//			paramPrefix = "";
//		}
//		var newid = paramPrefix + id;
//		var currentState;
//		var required;
//		if ($("#" + newid).length) {
//			required = ($("#" + newid)).attr("aria-required");
//		}
//		if (keepCurrentState != null && keepCurrentState != 'undefined' && keepCurrentState == true)
//		{
//			currentState = $("#" + newid).val()
//		}
//		else
//		{
//			currentState = "";
//		}
//
//		if(copyValue != null && copyValue != 'undefined' && copyValue != '')
//		{
//			currentState = copyValue;
//		}
//		if(id=="_state1"){
//			this.setStateClass("form_input");
//			var currentCountryCode =form[paramPrefix + "_country"].value;
//		} else{
//			var currentCountryCode =form[paramPrefix + "country"].value;
//		}
//
//		var stateDivObj = document.getElementById(stateDiv);
//		if(Utils.get_IE_version()){ /* For IE */
//			var stateClass = ($("#" + newid)).attr("className");
//		} else {
//			var stateClass = ($("#" + newid)).attr("class");
//		}
//
//		if(stateClass!="drop_down_country") {
//			this.setStateClass(stateClass);
//		}
//		while(stateDivObj.hasChildNodes()) {
//			stateDivObj.removeChild(stateDivObj.firstChild);
//		}
//
//		if (countries[currentCountryCode].states) {
//			/* switch to state list. */
//			stateDivObj.appendChild(this.createStateWithOptions(paramPrefix, currentCountryCode, currentState, id, required));
//		} else {
//			/* switch to state text input. */
//			stateDivObj.appendChild(this.createState(paramPrefix, currentState, id, required));
//		}
//	},
//
//	/**
//	 *	This function creates an input element to represent the state.
//	 *  @param {string} paramPrefix The value can be shipping, billing or blank.
//	 *  @param {string} currentState The value in the state field.
//	 *  @param {string} id The id of the state field.
//	 */
//	createState:function(paramPrefix,currentState,id,required){
//		var stateInput = document.createElement("input");
//		stateInput.setAttribute("id",paramPrefix + id);
//		if(id=="_state1"){
//		stateInput.setAttribute("name", paramPrefix + "_state");}
//		else{
//		stateInput.setAttribute("name", paramPrefix + "state");}
//		if (required) {
//			stateInput.setAttribute("aria-required", "true");
//		}
//		stateInput.setAttribute("class", this.stateClass);
//		stateInput.setAttribute("className",this.stateClass);
//		stateInput.setAttribute("size", "35");
//		stateInput.setAttribute("maxlength", "49");
//		if (currentState != null && currentState != 'undefined')
//		{
//			stateInput.setAttribute("value", currentState);
//		}
//		return stateInput;
//	},
//
//	/**
//	 * This function creates a <select> element to represent the state field and loads it with the
//	 * states corresponding to the country field.
//     * @param {string} paramPrefix The value can be shipping, billing or blank.
//	 * @param {string} currentCountryCode The country code of the selected country.
//	 * @param {string} currentState The value in the state field.
//	 * @param {string} id The id of the state field.
//	 */
//	createStateWithOptions:function(paramPrefix, currentCountryCode, currentState, id, required){
//
//		this.getCountryArray();
//		var stateSelect = document.createElement("select");
//		stateSelect.setAttribute("id", paramPrefix + id);
//		if(id=="_state1"){
//		stateSelect.setAttribute("name", paramPrefix + "_state");}
//		else{
//		stateSelect.setAttribute("name", paramPrefix + "state");}
//		if (required) {
//			stateSelect.setAttribute("aria-required", "true");
//		}
//		stateSelect.setAttribute("class","drop_down_country");
//		stateSelect.setAttribute("className","drop_down_country");
//		/*clear old options. */
//		stateSelect.options.length = 0;
//
//		/* add all states. */
//		for (state_code in countries[currentCountryCode].states) {
//
//			aOption = document.createElement("option");
//			stateSelect.options[stateSelect.length] = aOption;
//			aOption.text = countries[currentCountryCode].states[state_code];
//			aOption.value = state_code;
//
//			if (state_code == currentState || countries[currentCountryCode].states[state_code] == currentState) {
//				aOption.selected = true;
//			}
//		}
//
//		return stateSelect;
//	},
//
//	/**
//	 * This function will load the state field for selection dropdown using wc.Select in AdressForm.jsp depending on the country selection.
//	 * @param {string} formName  The name of the address form containing the state field and country field.
//	 * @param {string} stateDiv  The name of the state field.
//	 * @param {string} id The id of the state field to be created.
//	 * @param {boolean} keepCurrentState A true or false value used to determine whether to keep the current value in the state field or to remove it.
//	 * @param {string} copyValue The value to be copied to the newly generated state field.
//	 * @param {boolean} addEmptyOption - If true, it adds 'Please Select' as the first option with value set to ''.
//	 */
//	loadAddressFormStatesUI:function(formName,paramPrefix,stateDiv,id, keepCurrentState, copyValue, addEmptyOption){
//
//		this.getCountryArray();
//		var form = document.getElementById(formName);
//		if(paramPrefix == null || paramPrefix == 'undefined' || paramPrefix == ""){
//			paramPrefix = "";
//		}
//		var newid = paramPrefix + id;
//		var currentState;
//		var required = false;
//		if ($("#" + newid).length) {
//			required = ($("#" + newid)).attr("aria-required");
//		}
//		if (keepCurrentState != null && keepCurrentState != 'undefined' && keepCurrentState == true)
//		{
//			currentState = $("#" + newid).val()
//		}
//		else
//		{
//			currentState = "";
//		}
//
//		if(copyValue != null && copyValue != 'undefined' && copyValue != '')
//		{
//			currentState = copyValue;
//		}
//
//		if(id=="_state1") {
//			this.setStateClass("form_input");
//			var currentCountryCode = form[paramPrefix + "_country"].value;
//		} else {
//			var currentCountryCode =form[paramPrefix + "country"].value;
//		}
//
//		var stateDivObj = document.getElementById(stateDiv);
//		var stateClass = ($("#" + newid)).attr("class");
//
//		if(stateClass!=="drop_down_country") {
//			this.setStateClass(stateClass);
//		}
//
//		while(stateDivObj.hasChildNodes()) {
//			stateDivObj.removeChild(stateDivObj.firstChild);
//		}
//
//		if (countries[currentCountryCode] && countries[currentCountryCode].statesArray) {
//			/* switch to state list. */
//			var statesData = countries[currentCountryCode].statesArray;
//			if(addEmptyOption){
//				var option1 = new Object({
//					label: Utils.getLocalizationMessage("PLEASE_SELECT"),
//					value: ''
//				});
//				statesData.unshift(option1);
//			}
//
//			if(this.stateClass == "" || this.stateClass == null || this.stateClass == undefined || this.stateClass == "null") {
//				this.stateClass = "wcSelect";
//			}
//
//			$('<select>').attr({
//				'name': paramPrefix + 'state',
//				'id': paramPrefix + id,
//				'class': this.stateClass,
//				required: 'required'
//			}).appendTo(stateDivObj);
//			statesData.forEach(function( item ) {
//				$('<option>').attr({'value':item.value})
//							.html(item.label)
//							.appendTo('#' + paramPrefix + id);
//			});
//
//			var options = {
//					"wcMenuClass": "wcSelectMenu",
//			}
//			var statesSelect = $("#" + paramPrefix + id).Select(options);
//			statesSelect.val(currentState);
//			statesSelect.Select("refresh_noResizeButton");
//
//		} else {
//			/* switch to state text input. */
//			stateDivObj.appendChild(this.createState(paramPrefix, currentState, id, required));
//		}
//	},
//
//	/**
//	 * This function validates the address form independently from the order of the fields displayed on the form, i.e. independent from the locale.
//	 * A hidden field named "fields" must be set in the jsp/jspf file that calls this method. The purpose of this hidden field is
//	 * to set all the mandatory input fields and the order of these fields displayed on each locale-specific address entry page, so that
//	 * this method knows which input fields to validate and in which order it should validate them.
//	 *
//	 * assumptions:1. Mandatory fields use UPPER CASE, non-mandatory fields use lower case.
//	 *	     	   2. The error messages used in this method are declared in the jsp/jspf files that call this method.
//	 * @param {string} form The name of the address form obtained from the page containing address input fields.
//	 * @param {string} prefix The value is set to shipping or billing.
//	 *
//	 * @return {boolean} return true if no error was found, or the hidden field "fields" were not set in the jsp/jspf file that calls this method,
//	 * return false if form could not be found, or if there was an error validating a particular field.
//	 */
//
//	validateAddressForm: function(form,prefix){
//		reWhiteSpace = new RegExp(/^\s+$/);
//		if(prefix == null){prefix = ""};
//		if(prefix){this.setStateDivName(prefix + "stateDiv")};
//		if(form != null){
//			var fields="";
//			if(form["UserDetailsForm_FieldsOrderByLocale"] != null && form["UserDetailsForm_FieldsOrderByLocale"].value != null && form["UserDetailsForm_FieldsOrderByLocale"].value != ""){
//				fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
//			}
//			else if(form["UserAddressForm_FieldsOrderByLocale"] != null && form["UserAddressForm_FieldsOrderByLocale"].value != null && form["UserAddressForm_FieldsOrderByLocale"].value != ""){
//				fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
//			}
//			else if(form[prefix + "AddressForm_FieldsOrderByLocale"] != null && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null && form[prefix + "AddressForm_FieldsOrderByLocale"].value != ""){
//				fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
//			}
//			else if(form["AddressForm_FieldsOrderByLocale"] != null && form["AddressForm_FieldsOrderByLocale"].value != null && form["AddressForm_FieldsOrderByLocale"].value != ""){
//				fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
//			}
//			else if(document.getElementById("AddressForm_FieldsOrderByLocale").value!= null && document.getElementById("AddressForm_FieldsOrderByLocale").value!= ""){
//				fields=document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
//			}
//			var nickName = prefix + "nickName";
//			var lastName = prefix + "lastName";
//			var firstName = prefix + "firstName";
//			var middleName = prefix + "middleName";
//			var address1 = prefix + "address1";
//			var address2 = prefix + "address2";
//			var city = prefix + "city";
//			var state = prefix + "state";
//			var country = prefix + "country";
//			var zipCode = prefix + "zipCode";
//			var email1 = prefix + "email1";
//			var phone1 = prefix + "phone1";
//
//			for(var i=0; i<fields.length; i++){
//				var field = fields[i];
//				if(field == "NICK_NAME" || field == "nick_name"){
//					form[nickName].value = trim(form[nickName].value);
//					if(field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))){
//						MessageHelper.formErrorHandleClient(form[nickName].id, MessageHelper.messages["ERROR_RecipientEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[nickName].value, 254)){
//						MessageHelper.formErrorHandleClient(form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]);
//						return false;
//					}
//				}else if(field == "LAST_NAME" || field == "last_name"){
//					form[lastName].value = trim(form[lastName].value);
//					if(field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))){
//						MessageHelper.formErrorHandleClient(form[lastName].id, MessageHelper.messages["ERROR_LastNameEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[lastName].value, 128)){
//						MessageHelper.formErrorHandleClient(form[lastName].id, MessageHelper.messages["ERROR_LastNameTooLong"]);
//						return false;
//					}
//				}else if(field == "FIRST_NAME" || field == "first_name"){
//					form[firstName].value = trim(form[firstName].value);
//					if(field == "FIRST_NAME" && (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value))){
//						MessageHelper.formErrorHandleClient(form[firstName].id, MessageHelper.messages["ERROR_FirstNameEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[firstName].value, 128)){
//						MessageHelper.formErrorHandleClient(form[firstName].id, MessageHelper.messages["ERROR_FirstNameTooLong"]);
//						return false;
//					}
//				}else if(field == "MIDDLE_NAME" || field == "middle_name"){
//					form[middleName].value = trim(form[middleName].value);
//					if(field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))){
//						MessageHelper.formErrorHandleClient(form[middleName].id, MessageHelper.messages["ERROR_MiddleNameEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[middleName].value, 128)){
//						MessageHelper.formErrorHandleClient(form[middleName].id, MessageHelper.messages["ERROR_MiddleNameTooLong"]);
//						return false;
//					}
//				}else if(field == "use_org_address" || field == 'new_line'|| field == "PASSWORD" || field == "PASSWORD_VERIFY"){
//				}else if(field == "ADDRESS" || field == "address"){
//					form[address1].value = trim(form[address1].value);
//					form[address2].value = trim(form[address2].value);
//					if(field == "ADDRESS" && ((form[address1].value == "" || reWhiteSpace.test(form[address1].value)) && (form[address2].value=="" || reWhiteSpace.test(form[address2].value)))){
//						MessageHelper.formErrorHandleClient(form[address1].id, MessageHelper.messages["ERROR_AddressEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[address1].value, 100)){
//						MessageHelper.formErrorHandleClient(form[address1].id, MessageHelper.messages["ERROR_AddressTooLong"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[address2].value, 50)){
//						MessageHelper.formErrorHandleClient(form[address2].id, MessageHelper.messages["ERROR_AddressTooLong"]);
//						return false;
//					}
//				}else if(field == "CITY" || field == "city"){
//					form[city].value = trim(form[city].value);
//					if(field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))){
//						MessageHelper.formErrorHandleClient(form[city].id, MessageHelper.messages["ERROR_CityEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[city].value, 128)){
//						MessageHelper.formErrorHandleClient(form[city].id, MessageHelper.messages["ERROR_CityTooLong"]);
//						return false;
//					}
//				}else if(field == "STATE/PROVINCE" || field == "state/province"){
//					var state = form[state];
//					if(state == null || state == ""){
//						state = document.getElementById(this.stateDivName).firstChild;
//					}
//					state.value = trim(state.value);
//					if(field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))){
//						if(state.tagName == "SELECT" || state.tagName == "select") {
//							MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateEmpty"]);
//						} else {
//							MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR_StateEmpty"]);
//						}
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(state.value, 128)){
//						if(state.tagName == "SELECT" || state.tagName == "select") {
//							MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
//						} else {
//							MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR_StateTooLong"]);
//						}
//						return false;
//					}
//				}else if(field == "COUNTRY/REGION" || field == "country/region"){
//					console.log(form[country].value);
//					form[country].value = trim(form[country].value);
//					if(field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value))){
//						MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[country].value, 128)){
//						MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
//						return false;
//					}
//				}else if(field == "ZIP" || field == "zip"){
//					form[zipCode].value = trim(form[zipCode].value);
//					//check zip code for validation
//					if(field == "ZIP" && (form[zipCode].value=="" || reWhiteSpace.test(form[zipCode].value))){
//						MessageHelper.formErrorHandleClient(form[zipCode].id, MessageHelper.messages["ERROR_ZipCodeEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[zipCode].value, 40)){
//						MessageHelper.formErrorHandleClient(form[zipCode].id, MessageHelper.messages["ERROR_ZipCodeTooLong"]);
//						return false;
//					}
//				}else if(field == "EMAIL1" || field == "email1"){
//					form[email1].value = trim(form[email1].value);
//					if(field == "EMAIL1" && (form[email1].value == "" || reWhiteSpace.test(form[email1].value))){
//						MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_EmailEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[email1].value, 256)){
//						MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_EmailTooLong"]);
//						return false;
//					}
//					if(!MessageHelper.isValidEmail(form[email1].value)){
//						MessageHelper.formErrorHandleClient(form[email1].id, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
//						return false;
//					}
//				}else if(field == "PHONE1" || field == "phone1"){
//					form[phone1].value = trim(form[phone1].value);
//					if(field == "PHONE1" && (form[phone1].value == "" || reWhiteSpace.test(form[phone1].value))){
//						MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
//						return false;
//					}
//					if(!MessageHelper.isValidUTF8length(form[phone1].value, 32)){
//						MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_PhoneTooLong"]);
//						return false;
//					}
//					if(!MessageHelper.IsValidPhone(form[phone1].value)){
//						MessageHelper.formErrorHandleClient(form[phone1].id, MessageHelper.messages["ERROR_INVALIDPHONE"]);
//						return false;
//					}
//				}else{
//					console.debug("error: mandatory field name " + mandatoryField + " is not recognized.");
//					return false;
//				}
//			}
//			if (form[address1] && form[address1].value == "" && form[address2].value != "") {
//
//			form[address1].value = form[address2].value;
//			form[address2].value = "";
//			}
//			return true;
//		}
//		return false;
//	},
//
//	/**
//	 * This function saves the address entry form when a registered customer wants to edit/add a new address
//	 * during checkout from  his/her shopping cart.
//	 * @param {string} The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
//	 * @param {string} The name of the form containing address information.
//	 * @param {string} The addressTypeIn being saved.
//	 */
//
//	saveShopCartAddress: function(serviceId, formName, addressTypeIn){
//		var form = document.forms[formName];
//		if( addressTypeIn == 'ShippingAndBilling' || addressTypeIn == 'Shipping'){
//			if (serviceId == 'AjaxUpdateAddressForPerson') {
//				serviceId = 'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout';
//			} else {
//				serviceId = 'AjaxAddShippingAndBillingAddressForPersonDuringCheckout';
//			}
//		}
//		if(this.validateAddressForm(form)){
//			this.saveAddress(serviceId, formName);
//		}
//	},
//
//
//	/**
//	 * This function saves the address entry form on an unregistered user's checkout page.
//	 * @param {string} formName1 The name of the billing address form.
//	 * @param {string} formName2 The name of the shipping address form.
//	 * @param {string} stateDivName1 The name of the state field in the billing address form.
//	 * @param {string} stateDivName2 The name of the state field in the shipping address form.
//	 */
//
//	saveUnregisteredCheckoutAddress: function(formName1, formName2, stateDivName1, stateDivName2)
//	{
//		var form1 = document.forms[formName1];
//
//		this.setStateDivName(stateDivName1);
//		/*Validate form input fields */
//		if(this.validateAddressForm(form1))
//		{
//			var sameaddress = document.getElementById("SameShippingAndBillingAddress");
//			if (!sameaddress.checked)
//			{
//				var form2 = document.forms[formName2];
//				this.setStateDivName(stateDivName2);
//				/*Validate form input fields */
//				if(this.validateAddressForm(form2))
//				{
//					this.saveAddress('AddBillingAddress', 'billingAddressCreateEditFormDiv_1');
//				}
//			}
//			else
//			{
//				form1.addressType.value='ShippingAndBilling';
//				this.saveAddress('AddShippingAddress', 'billingAddressCreateEditFormDiv_1');
//			}
//		}
//	},
//
//	/**
//	 * This function saves an address entry form to the associated service.
//	 * @param {string} serviceId The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
//	 * @param {string} formName The name of the form containing address information.
//	 */
//
//	saveAddress:function(serviceId, formName) {
//		var form = document.forms[formName];
//		if (form.address1.value == "" && form.address2.value != "") {
//			form.address1.value = form.address2.value;
//			form.address2.value = "";
//		}
//	 	var addressService = wcService.getServiceById(serviceId);
//	 	addressService.setFormId(formName);
//		/* For Handling multiple clicks */
//		if(!submitRequest()){
//			return;
//		}
//	 	cursor_wait();
//	 	wcService.invoke(serviceId);
//	},
//
//	/**
//	 * This function calls UpdateOrderItem/AjaxUpdateOrderItem service to update order calculation
//	 */
//
//	updateOrderAfterAddressUpdate:function() {
//		var params = {
//			storeId: this.storeId,
//			catalogId: this.catalogId,
//			langId: this.langId
//			};
//		params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
//		params.calculateOrder = "1";
//		params.orderId = ".";
//
//	 	cursor_wait();
//	 	wcService.invoke("AjaxUpdateOrderAfterAddressUpdate", params);
//	},
//
//	/**
//	 *  This function populates the country code to mobile phone based on the selected country.
//	 *  @param {string} countryDropDownId The id of the mobile country drop down list
//	 *  @param {string} countryCallingCodeId The id of the mobile country calling code text box.
//	 */
//
//	loadCountryCode:function(countryDropDownId,countryCallingCodeId){
//		this.getCountryArray();
//		var countryCode = $("#" + countryDropDownId).val()
//		if ( countryCode === undefined || countryCode === null )
//		// we are using wc.Select
//		{
//			var countryDropDownWidget = $("#" + countryDropDownId);
//			if (countryDropDownWidget !== undefined && countryDropDownWidget !== null)
//			{
//				countryCode = countryDropDownWidget.val();
//			}
//		}
//		$("#" + countryCallingCodeId).val(countries[countryCode].countryCallingCode);
//	},
//
//	/**
//	 *  This function checks for an entry in the Mobile Phone Number field.
//	 *  If a Mobile Phone number has been entered, it enables the SMS Notifications/Promotions checkbox,
//	 *  else it disables the SMS Notifications/Promotions checkbox.
//	 *  @param {string} form The name of the form containing the Mobile Phone Number entry field.
//	 *  @param {string} jspStoreImgDir The directory for images
//	 */
//	enableSMSNotifications:function(form, jspStoreImgDir){
//		var form = document.forms[form];
//		if(form.mobilePhone1.value !== ""){
//			form.sendMeSMSNotification.disabled = false;
//			form.sendMeSMSPreference.disabled = false;
//			$(".checkedCheckBox.mobileOption").removeClass("disabled").attr("tabindex", "0");
//		}
//		else{
//			form.sendMeSMSNotification.disabled = true;
//			form.sendMeSMSPreference.disabled = true;
//			form.sendMeSMSNotification.checked = false;
//			form.sendMeSMSPreference.checked = false;
//			$(".checkedCheckBox.mobileOption").addClass("disabled").attr("tabindex", "-1")
//					.removeClass("checked").attr("aria-checked", "false").attr("src", jspStoreImgDir + "images/checkbox.png");
//		}
//	},
//	/**
//	 * Sets the address type when a user wants to add a new address of type shipping and billing during order check out.
//	 * @param {Object} checkbox The HTML checkbox input object.
//	 * @param {Object} form The form that contains the new address information.
//	 */
//	setAddressTypeInCreatingNewAddressDuringCheckout: function(checkbox, form){
//		if(form.addressType != null && form.originalAddressType != null){
//			if(checkbox.checked){
//				form.addressType.value = 'ShippingAndBilling';
//			}else{
//				form.addressType.value = form.originalAddressType.value;
//			}
//		}
//	},
//
//	/**
//	 * Set checkbox state to true when checked and false when unchecked
//	 * @param String jspStoreImgDir The directory for store images.
//	 * @param String checkbox The checkbox element.
//	 * @param String checkboxImg The checkbox image element.
//	 * @param String checkedValue The value of the input when checked.
//	 * @param String uncheckedValue The value of the input when unchecked.
//	 */
//	changeCheckboxState: function(jspStoreImgDir, checkbox, checkboxImg, checkedValue, uncheckedValue){
//		var $checkboxImg = $("#" + checkboxImg),
//			$checkbox = $("#" + checkbox);
//		if (!$checkboxImg.hasClass("disabled")) {
//			if ($checkboxImg.hasClass("checked")){
//				$checkboxImg.removeClass("checked");
//				$checkboxImg.attr("aria-checked", "false");
//				$checkboxImg.attr("src", jspStoreImgDir + "images/checkbox.png");
//				$checkbox.attr("value", uncheckedValue);
//				$checkbox.removeAttr("checked");
//			} else {
//				$checkboxImg.addClass("checked");
//				$checkboxImg.attr("src", jspStoreImgDir + "images/checkbox_checked.png");
//				$checkboxImg.attr("aria-checked", "true");
//				$checkbox.attr("value", checkedValue);
//				$checkbox.attr("checked", "checked");
//			}
//		}
//	}
//}
//
//
//;


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by UserRegistrationAddForm.jsp and CheckoutLogon.jsp.
 * @version 1.0
 */

/**
 *  The functions defined in the class helps the customer to register with the store. Another function enables a returning
 *  customer to Sign in for quickcheckout from the shopping cart page.
 *
 *  @class This LogonForm class defines all the functions and variables used to validate the information provided by the
 *  customer to register with the store.To register, a customer creates a logon ID and password. Then, the customer provides their first name,
 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number. Other registration options
 *  include promotional e-mails, preferred language and currency, age, gender, and the remember me option.
 */

//
//LogonForm ={
//
//    /**
//     * This function validates the logon ID and password for returning customers to sign in and complete the checkout process.
//     * @param {string} form The name of the form containing logon ID and password fields.
//     */
//    SubmitAjaxLogin:function(form){
//
//        if(!this.validateAjaxLogin(form)){
//            return;
//        };
//
//        /* HB-528
//        //For Handling multiple clicks.
//        if(!submitRequest()){
//            return;
//        }
//        */
//        setDeleteCartCookie();
//
//        form.submit();
//
//    },
//
//    validateAjaxLogin:function(form){
//        reWhiteSpace = new RegExp(/^\s+$/);
//
//        if(form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == ""){
//            MessageHelper.formErrorHandleClient(form.logonId.id,MessageHelper.messages["LOGON_REQUIRED_FIELD_ENTER"]); return false;}
//
//        if(form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == ""){
//            MessageHelper.formErrorHandleClient(form.logonPassword.id,MessageHelper.messages["PASSWORD_REQUIRED_FIELD_ENTER"]); return false;}
//
//        return true;
//    },
//
//    /**
//     * This function is called when the Submit button is clicked on the Registration page. All the fields containing customer
//     * information are validated and PersonProcessServicePersonRegistration is called.
//     * @param {string} form The name of the registration form containing all the customer information.
//     */
//    prepareSubmit:function (form){
//        //cursor_clear();
//        if(CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' || CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true'){
//            var random = Math.random();
//            var randomPassword = random.toString(36).slice(-7); // Get last 7 chars. Will add one numeric char to make it 8 char long...
//            var randomInt = Math.floor((random * 9) + 1);
//            randomPassword += randomInt; //Password should contain atleast one numeric character...
//            if ($("#logonPassword").val() == null || $("#logonPassword").val() == "") {
//                $('<input>').attr({
//                    type: 'hidden',
//                    value: randomPassword,
//                    name: "logonPassword",
//                    id: "logonPassword",
//                }).appendTo('form');
//            }
//
//            if ($("#logonPasswordVerify").val() == null || $("#logonPasswordVerify").val() == "") {
//                $('<input>').attr({
//                    type: 'hidden',
//                    value: randomPassword,
//                    name: "logonPasswordVerify",
//                    id: "logonPasswordVerify"
//                }).appendTo('form');
//            }
//
//            if ($("#passwordExpired").val() == null || $("#passwordExpired").val() == "") {
//                $("#passwordExpired").val("1");
//            }
//        }
//        if (!this.validatePrepareForm(form)){
//            return;
//        }
//        /* For Handling multiple clicks. */
//        /* HB-585
//        if(!submitRequest()){
//            return;
//        }
//        */
//        setCookie("WC_SHOW_USER_ACTIVATION_" + WCParamJS.storeId, "true", {path:'/', domain:cookieDomain});
//        if(CSRWCParamJS.env_shopOnBehalfEnabled_CSR == 'true' ||
//                (CSRWCParamJS.env_shopOnBehalfSessionEstablished == 'true' &&  form.userId != null && form.userId.value != null)){
//            // CSR is creating the user OR
//            // OnBehalf session is started and CSR is registering existing guestUser.
//            // Uses UserRegistrationAdminAddCmd
//            if(registeredCustomersJS != null) {
//                registeredCustomersJS.createRegisteredUser(form.landingURL_CSR.value);
//            }
//        } else {
//            // 1. Normal guest / generic user registering for themselves. OR
//            // 2. CSR registering guest / generic user using the guest / generic user flow. And not using UserRegistrationAdminAddCmd.
//            form.submit();
//        }
//    },
//
//    /**
//     * The function is called to validate and prepare the form.
//     * @param {string} form The name of the registration form containing all the customer information.
//     * @return (Boolean) true if the form is ready to submit, false otherwise.
//     */
//    validatePrepareForm: function(form){
//        reWhiteSpace = new RegExp(/^\s+$/);
//        if(form.logonId != null && reWhiteSpace.test(form.logonId.value) || form.logonId.value == ""){
//            MessageHelper.formErrorHandleClient(form.logonId.id,MessageHelper.messages["ERROR_LogonIdEmpty"]); return false;
//        } else if (typeof this.validateLoginId == "function") {
//                if (!this.validateLoginId(form.logonId)) {
//                    return false;
//                }
//        }
//
//        if (form.ancestorOrgs != null) {
//            if (form.ancestorOrgs.value == "") {
//                MessageHelper.formErrorHandleClient(form.ancestorOrgs.id,MessageHelper.messages["ERROR_OrgNameEmpty"]);
//                return false;
//            } else if (form.ancestorOrgs.value == "Default Organization") {
//                MessageHelper.formErrorHandleClient(form.ancestorOrgs.id,MessageHelper.messages["ERROR_DefaultOrgRegistration"]);
//                return false;
//            }
//        }
//
//        if(form.logonPassword != null && reWhiteSpace.test(form.logonPassword.value) || form.logonPassword.value == ""){
//            MessageHelper.formErrorHandleClient(form.logonPassword.id,MessageHelper.messages["ERROR_PasswordEmpty"]); return false;}
//        if(form.logonPasswordVerify != null && reWhiteSpace.test(form.logonPasswordVerify.value) || form.logonPasswordVerify.value == ""){
//            MessageHelper.formErrorHandleClient(form.logonPasswordVerify.id,MessageHelper.messages["ERROR_VerifyPasswordEmpty"]); return false;}
//        if(form.logonPassword.value!= form.logonPasswordVerify.value){
//            MessageHelper.formErrorHandleClient(form.logonPasswordVerify.id,MessageHelper.messages["PWDREENTER_DO_NOT_MATCH"]);
//            return false;
//        }
//
//        /** Uses the common validation function defined in AddressHelper class for validating first name,
//         *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
//         */
//        if(!AddressHelper.validateAddressForm(form)){
//            return false;
//        }
//
//        /* Checks whether the customer has registered for promotional e-mails. */
//        if(form.sendMeEmail && form.sendMeEmail.checked){
//            form.receiveEmail.value = true;
//        }
//        else {
//            form.receiveEmail.value = false;
//        }
//
//        if(form.sendMeSMSNotification &&  form.sendMeSMSNotification.checked){
//            form.receiveSMSNotification.value = true;
//        }
//        else {
//            form.receiveSMSNotification.value = false;
//        }
//
//        if(form.sendMeSMSPreference && form.sendMeSMSPreference.checked){
//            form.receiveSMS.value = true;
//        }
//        else {
//            form.receiveSMS.value = false;
//        }
//
//        if(form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true"){
//            if(!MyAccountDisplay.validateMobileDevice(form)){
//                return false;
//            }
//        }
//        if(form.birthdayEnabled != null && form.birthdayEnabled.value == "true"){
//            if(!MyAccountDisplay.validateBirthday(form)){
//                return false;
//            }
//        }
//        return true;
//    },
//
//    /**
//     *  This function validates the customer's input for age. If the user is under age, pop up a message to ask the user to review the store policy.
//     *  @param {string} The name of the form containing personal information of the customer.
//     */
//    validateAge: function(form){
//
//        var birth_year = parseInt(form.birth_year.value);
//        var birth_month = parseInt(form.birth_month.value);
//        var birth_date = parseInt(form.birth_date.value);
//
//        if (birth_year == 0 || birth_month == 0 || birth_date == 0) {
//            return;
//        }
//
//        var curr_year = parseInt(form.curr_year.value);
//        var curr_month = parseInt(form.curr_month.value);
//        var curr_date = parseInt(form.curr_date.value);
//
//        /*Check whether age is less than 13, if so, pop up a message to ask the user to review the store policy. */
//        if((curr_year - birth_year) < 13){
//            alert(MessageHelper.messages["AGE_WARNING_ALERT"]);
//        }else if((curr_year - birth_year) == 13){
//            if(curr_month < birth_month){
//                alert(MessageHelper.messages["AGE_WARNING_ALERT"]);
//            }else if((curr_month == birth_month) && (curr_date < birth_date)){
//                alert(MessageHelper.messages["AGE_WARNING_ALERT"]);
//            }
//        }
//    },
//
//    /**
//      * This function is used when "Age" option is changed.
//      * This will show one alert message if the user age is under 13.
//      * @param {string} form The name of the registration form containing customer's age.
//      */
//
//    checkAge:function (form)
//    {
//        if(form.age.value==1) {
//            alert(MessageHelper.messages["AGE_WARNING_ALERT"]);
//        }
//    }
//}
//;


//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2010, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

MultipleWishLists = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * variable that stores the default gift list ID
     * @private
     */
    defaultListId: null,

    /**
     * indicate whether or not an item should be added after the wish list is created.
     * @private
     */
    addItemAfterCreate: false,

    /**
     * stores the preferred default wish list name
     * @private
     */
    preferredDefaultWishListName: "",

    /**
     * stores the wish list prefix
     * @private
     */
    wishListPrefix: "",

    /**
     * Indicates whether to update wish list display context after switching to a new wish list
     */
    updateAfterSwitch: false,

    /**
     * This is the variable that controls how many characters from the wish list name are displayed before dots are added as suffix
     * @private
     */
    maxCharsToDisplay: 30,

    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
    }

    /**
     * switch to show a different wish list, by switching to a new wish list, the newly selected wish list will
     * also become the default wish list
     * @param {string} newListId The wish list id of wish list to be switched to
     */
    ,
    switchList: function (newListId) {

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        $("#multipleWishlistController_select").attr('disabled', 'true');
        this.updateAfterSwitch = true;
        this.setAsDefault(newListId);
    }

    /** update wish list display context after switching to a new wish list
     * @param {string} newListId The wish list id of new default wish list
     */
    ,
    updateContextPostSwitch: function (newListId) {
        if (this.updateAfterSwitch) {
            wcRenderContext.updateRenderContext('WishlistDisplay_Context', {
                'giftListId': newListId
            });
            wcRenderContext.updateRenderContext('WishlistSelect_Context', {
                'giftListId': newListId
            });
        }
        this.updateAfterSwitch = false;
    }

    /**
     * remove item from a wish list
     * @param {long} giftItemId ID of the wish list item to be removed
     */
    ,
    removeItem: function (giftItemId) {
        var params = {};
        params["storeId"] = this.storeId;
        params["catalogId"] = this.catalogId;
        params["langId"] = this.langId;
        params["quantity"] = 0;

        if (($("#multipleWishlistController_select") != null && $("#multipleWishlistController_select") != 'undefined') && $("#multipleWishlistController_select").val() != 0) {
            // get wish list ID
        	params["giftListId"] = $("#wishlistId").val();

            if (!this.empty(giftItemId)) {

                params["giftListItemId"] = giftItemId;

                /*For Handling multiple clicks. */
                if (!submitRequest()) {
                    return;
                }

                cursor_wait();
                wcService.invoke('ShoppingListServiceRemoveItem', params); //calling the service to save the new list name

            }
        }
    }

    /**
     * This function is used to set the selected wish list ID for the email form.
     * @param {string} formId  The formId of the email form.
     */
    ,
    getWishListIdForEmail: function (formId) {
        var form = document.getElementById(formId);
        if (($("#multipleWishlistController_select") != null && $("#multipleWishlistController_select") != 'undefined') && $("#multipleWishlistController_select").val() != 0) {
            form.giftListId.value=$('#multipleWishlistController_select').val();
        }
    }

    /**
     * This function is used to check user input in the wish list email form, if user input is valid, it invokes the InterestItemListMessage service to send out the email.
     * @param {string} formId  The formId of the email form.
     */
    ,
    checkSOAEmailForm: function (formId) {
        $("#WishListEmailSucMsg_Div").css('display', 'none');
        var form = document.getElementById(formId);
        form.sender_name.value = form.sender_name.value.replace(/^\s+/g, "");
        form.recipient.value = form.recipient.value.replace(/^\s+/g, "");

        if (form.recipient.value == '') {
            MessageHelper.formErrorHandleClient(document.getElementById('SendWishListForm_Recipient_Email').id, Utils.getLocalizationMessage("WISHLIST_MISSINGEMAIL"));
            return;
        }
        if (!MultipleWishLists.validateWishListEmailString(form.recipient.value)) {
            MessageHelper.formErrorHandleClient(document.getElementById('SendWishListForm_Recipient_Email').id, Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT"));
            return;
        }
        if (form.sender_name.value == '') {
            MessageHelper.formErrorHandleClient(document.getElementById('SendWishListForm_Sender_Name').id, Utils.getLocalizationMessage("WISHLIST_MISSINGNAME"));
            return;
        }
        if (!MultipleWishLists.validateWishListEmailString(form.sender_email.value)) {
            MessageHelper.formErrorHandleClient(document.getElementById('SendWishListForm_Sender_Email').id, Utils.getLocalizationMessage("WISHLIST_INVALIDEMAILFORMAT"));
            return;
        }
        if (form.giftListId.value == '' || form.wishListHasItem.value == "false" || form.giftListId.value == '-1') {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("WISHLIST_EMPTY"));
            return;
        }
        if (!MultipleWishLists.validateSenderName(form.sender_name.value)) {
            // show error message saying that
            form.sender_name.value = ''
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("WISHLIST_INVALIDSENDERNAME"));
            return;
        }

        // maps email input to param required by AjaxGiftListAnnouncement
        form.recipientEmail.value = form.recipient.value;
        form.recipient.value = "";
        form.senderName.value = form.sender_name.value;
        if (form.sender_email.value != '') {
            form.senderEmail.value = form.sender_email.value;
        }
        if (form.wishlist_message.value != '') {
            form.message.value = form.wishlist_message.value;
        }

        /* Handles multiple clicks */
        if (!submitRequest()) {
            return;
        }

        cursor_wait();
        wcService.getServiceById("AjaxGiftListAnnouncement").setFormId(formId);
        wcService.invoke("AjaxGiftListAnnouncement");


        // reset values
        form.senderEmail.value = "SOAWishListEmail@SOAWishListEmail.com";
        form.message.value = "SOAWishListEmail";
    }

    /**
     * set a specified wish list as default wish list
     *	@param {long} giftListId ID of the wish list to be set as default
     */
    ,
    setAsDefault: function (giftListId) {

        if (giftListId != '-1') {
            var params = {};
            params["storeId"] = this.storeId;
            params["catalogId"] = this.catalogId;
            params["langId"] = this.langId;
            params["giftListId"] = giftListId;
            params["giftListState"] = 'Default';
            cursor_wait();
            wcService.invoke('AjaxGiftListServiceChangeGiftListStatus', params);
        } else {
            MultipleWishLists.setDefaultListId('-1');
            MultipleWishLists.updateContextPostSwitch('-1');
        }
    }

    /**
     *return true if a string is undefined or null
     *@param {string} String to be checked
     */
    ,
    empty: function (str) {
        return (str == null || str == undefined || str == "");
    }

    /**
     * sets the default wish list Id
     * @param {String} id the default wish list id
     */
    ,
    setDefaultListId: function (id) {
        this.defaultListId = id;
    }

    /**
     * returns the default wish list Id
     */
    ,
    getDefaultListId: function () {
        return this.defaultListId;
    }

    /**
     * sets the preferred default wish list name
     * @param {String} name default wish list name
     */
    ,
    setPreferredDefaultWishListName: function (name) {
        this.preferredDefaultWishListName = name;
    }

    /**
     * Sets the wish list prefix. It's the text displayed before the wish list name.
     * @param {String} prefix wish list prefix
     */
    ,
    setWishListPrefix: function (prefix) {
        this.wishListPrefix = prefix;
    }


    /**
     * validate the sender name
     */
    ,
    validateSenderName: function (senderName) {
            var invalidChars = "~!@#$%^&*()+=[]{};:,<>?/|`"; // invalid chars
            invalidChars += "\t\'\"\\\/"; // escape sequences

            // look for presence of invalid characters.  if one is
            // found return false.  otherwise return true
            for (var i = 0; i < senderName.length; i++) {
                if (invalidChars.indexOf(senderName.substring(i, i + 1)) >= 0) {
                    return false;
                }
            }
            return true;
        }
        /**
         * validate the email string (which can be a comma separated list)
         */
        ,
    validateWishListEmailString: function (emailString) {
        var allEmailsAreGood = true;
        var emails = emailString.split(",");
        // validate each email
        for (var i = 0; i < emails.length; i++) {
            if (!MessageHelper.isValidEmail(emails[i])) {
                allEmailsAreGood = false;
            }
        }
        return allEmailsAreGood;
    }
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2009 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides the controller variables and functions for My Account pages,
 * and links these controllers to listen to the defined render contexts in CommonContextsDeclarations.js.
 */

/**
 * @class The MyAccountControllersDeclarationJS class defines the common variables and functions that control
 * the defined render contexts on the My Account store pages. Controller provides the JavaScript logic
 * that listens to changes in the render context and the model. A defined render context is a set of
 * client-side context information which keeps track of information about a page. The context information
 * helps decide if changes to refresh areas are needed.
 */
MyAccountControllersDeclarationJS = {
        declareProcessedOrdersStatusDisplayRefreshArea: function() {
            // ============================================
            // div: ProcessedOrdersStatusDisplay refresh area
            // Declares a new refresh controller for the processed orders status display.
            var myWidgetObj = $("#ProcessedOrdersStatusDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("ProcessedOrdersStatusDisplay_Context");

            /**
             * Displays the previous/next page of order items on the processed order status page.
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                if (wcRenderContext.testForChangedRC("ProcessedOrdersStatusDisplay_Context", ["beginIndex"])) {
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            };

            /**
             * Clears the progress bar
             */
            var postRefreshHandler = function() {
                 cursor_clear();
            };

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareWaitingForApprovalOrdersStatusDisplayRefreshArea: function() {
            // ============================================
            // div: WaitingForApprovalOrdersStatusDisplay refresh area
            // Declares a new refresh controller for the waiting-for-approval orders status display.
            var myWidgetObj = $("#WaitingForApprovalOrdersStatusDisplay");
            var myRCProperties = wcRenderContext.getRenderContextProperties("WaitingForApprovalOrdersStatusDisplay_Context");

            /**
             * Displays the previous/next page of order items in the order status page.
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                if(wcRenderContext.testForChangedRC("WaitingForApprovalOrdersStatusDisplay_Context", ["beginIndex"])){
                    myWidgetObj.refreshWidget("refresh", myRCProperties);
                }
            }

            /**
             * Clears the progress bar
             */
            var postRefreshHandler = function() {
                 cursor_clear();
            }

            // initialize widget
            myWidgetObj.refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        }

}



;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by jsp's related to 'Personal Information','My Orders' and 'My Coupons'.
 * @version 1.0
 */

/**
 * The functions defined in this class are used for enabling 'My Account' related customer operations.
 *
 * @class This MyAccountDisplay class defines all the variables and functions for 'My Account' page history tracking.
 *  Another function enables customers to update their current personal information.
 *  Another function enables the customer to create a new order by duplicating a previous order.Another function is
 *  used to remove a coupon from the coupon wallet.
 */
MyAccountDisplay={

    /*Flag which indicates if a context change happened. */
    contextChanged:false,

    /*Flag which indicates whether refresh is caused by browser back or forward event. */
    isHistory:false,

    /* This indicates the current link highlighted in the leftSideBar. */
    currentSelection:"",

    /**
     * This variable stores the identifier of the tab currently being displayed.
     * The default value is "PreviouslyProcessed".
     */
    currentTabId: "PreviouslyProcessed",

    /**
     * This variable keeps track of whether the preferred language is updated
     */
    isPreferredLanguageUpdated: false,

    /**
     * This variable stores the current dropdown dialog element.
     * @private
     */
    dropDownDlg: null,

    /**
     * This variable stores the identifier of the tab currently being displayed in the recurring order details page.
     * The default value is "recurring_order_details".
     */
    currentOrderTabId: "recurring_order_details",

    /**
     * This variable stores the expiry date of a subscription. For renewal, the start date is expiry date plus one day.
     */
    subscriptionDate: "",

    /**
     * This variable stores the orderId for subscription renewal
     */
    subscriptionOrderId: "",

    /**
     * This variable stores the orderItemId for subscription renewal
     */
    subscriptionOrderItemId: "",

    /**
     * set the isPreferredLanguageUpdated variable
     * @param {boolean} value either true or false. True if preferred language is updated. False otherwise.
     */
    setPreferredLanguageUpdated: function (value) {
        this.isPreferredLanguageUpdated = value;
    },

    /**
     * return a boolean value which indicates whether preferred lanaguage is changed.
     */
    getPreferredLanguageUpdated: function () {
        return this.isPreferredLanguageUpdated;
    },

    /**
     * set the subscriptionDate variable
     * @param {string} The expiry date of the subscription to be renewed.
     */
    setSubscriptionDate: function (value) {
        this.subscriptionDate = value;
    },

    /**
     * get the last order record info in render context
     * @param {Integer} The current page number.
     * @param {string} The last order external id in current page.
     * @param {string} The last order record info in render context.
     * @param {boolean} value either true or false. True if it's for next page. False otherwise.
     */
    getLastRecordInfo: function (currentPage, lastExtOrderId, lastRecordInfoInContext, nextOrNot) {
        var lastRecordArray = lastRecordInfoInContext.split(";");
        var refinedRecordInfoIncontext;

        if(!nextOrNot){
            //previous page
            if(lastRecordInfoInContext != '' && lastRecordInfoInContext != undefined){
                if(lastRecordInfoInContext.lastIndexOf(";")>-1){
                    refinedRecordInfoIncontext = lastRecordInfoInContext.substring(0, lastRecordInfoInContext.lastIndexOf(";"));
                }else{
                    refinedRecordInfoIncontext = "";
                }
            }
        }else{
            //next page
            if(currentPage==1 || currentPage==''|| currentPage == undefined){
                //first page
                if(lastExtOrderId !='' && lastExtOrderId!=undefined){
                    refinedRecordInfoIncontext = lastExtOrderId;
                }else{
                    refinedRecordInfoIncontext = " ";
                }
            }else{
                if(lastRecordInfoInContext != '' && lastRecordInfoInContext != undefined){
                    if(lastExtOrderId !='' && lastExtOrderId!=undefined){
                        refinedRecordInfoIncontext = lastRecordInfoInContext.concat(";").concat(lastExtOrderId);
                    }else{
                        refinedRecordInfoIncontext = lastRecordInfoInContext.concat(";").concat(" ");
                    }
                }
            }

        }

        return refinedRecordInfoIncontext;
    },

    /**
     * update the last order record info for current page in render context
     * @param {string} The context id.
     * @param {Integer} The begin index for next page or previous page.
     * @param {Integer} The page size.
     * @param {boolean} value either true or false. True if it's for quote. False otherwise.
     * @param {Integer} The current page number.
     * @param {string} The last order external id in current page.
     * @param {string} The last order record info in render context.
     * @param {boolean} value either true or false. True if it's for next page. False otherwise.
     * @param {integer} The record set total.
     */
    updateRenderContextForPagination:function(contextId, beginIndex, pageSize, isQuote, currentPage, lastExtOrderId, lastRecordInfoInContext, nextOrNot, recordSetTotal){
        var currentBeginIndex;
        var lastRecordInfo = this.getLastRecordInfo(currentPage, lastExtOrderId, lastRecordInfoInContext, nextOrNot);
        if(!nextOrNot){
            currentBeginIndex = parseInt(beginIndex) - parseInt(pageSize);

        }else{
            currentBeginIndex = parseInt(beginIndex) + parseInt(pageSize);
        }
        wcRenderContext.updateRenderContext(contextId,{'beginIndex':currentBeginIndex,'pageSize':pageSize,'isQuote':isQuote,'lastExternalOrderIds':lastRecordInfo,'recordSetTotal':recordSetTotal});
    },

    escapeXML: function(value) {
        //don't use jazz.util.html.escape(value). This function doesn't encode character "
        if (!value) {
            return ProcessAuthoringConstants.EMPTY;
        }
        return value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/\'/g, "&#039;"); //$NON-NLS-1$ //$NON-NLS-2$  //$NON-NLS-3$ //$NON-NLS-4$ //$NON-NLS-5$
    },

    /**
     * return a string which indicates the start date of the renewed subscription. The start date is one day plus the end date of that subscription.
     */
    getSubscriptionDate: function () {
        var year = parseInt(this.subscriptionDate.substring(0,4),10);
        var month = parseInt(this.subscriptionDate.substring(5,7),10);
        var date = parseInt(this.subscriptionDate.substring(8,10),10);

        if(month == 2){
            if((year % 4 == 0) && (year % 100 != 0) && (year % 400 == 0))
            {
                if(date != 29)
                {
                    date = date + 1;
                    if(date < 10)
                        date = "0" + date;
                    month = "02";
                }
                else
                {
                    date = "01";
                    month = "03";
                }
            }
            else
            {
                if(date != 28)
                {
                    date = date + 1;
                    if(date < 10)
                        date = "0" + date;
                    month = "02";
                }
                else
                {
                    date = "01";
                    month = "03";
                }
            }
        }
        else if(month == 12){
            if(date != 31)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
                month = "12";
            }
            else
            {
                date = "01";
                month = "01";
                year = year + 1;
            }
        }
        else if(month == 4 || month == 6 || month == 9 || month == 11){
            if(date != 30)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
            }
            else
            {
                date = "01";
                month = month + 1;
            }
            if(month < 10)
                month = "0" + month;
        }
        else{
            if(date != 31)
            {
                date = date + 1;
                if(date < 10)
                    date = "0" + date;
            }
            else
            {
                date = "01";
                month = month + 1;
            }
            if(month < 10)
                month = "0" + month;
        }

        var start = this.subscriptionDate.indexOf("T",0);
        var end = this.subscriptionDate.indexOf("Z",start);
        var appendString= this.subscriptionDate.substring(start+1,end);
        var newDateString = year+'-'+month+'-'+date+'T'+appendString+'Z';
        return(newDateString);
    },

    /**
     * Hides the tab with the specified identifier.
     * This function unhides the 'off' tab,
     * and hides the 'on' tab by setting the style.display attribute respectively.
     *
     * @param {string} id The identifier of the HTML element representing the tab to hide.
     */
    setOff:function(id){
        document.getElementById(id+"_On").style.display = "none";
        document.getElementById(id+"_Off").style.display = "inline";
        document.getElementById(id).style.display = "none";
    },

    /**
     * Displays the tab with the specified identifier.
     * This function unhides the 'on' tab,
     * and hides the 'off' tab by setting the style.display attribute respectively.
     *
     * @param {string} id The identifier of the HTML element representing the tab to display.
     */
    setOn:function(id){
        document.getElementById(id+"_On").style.display = "inline";
        document.getElementById(id+"_Off").style.display = "none";
        document.getElementById(id).style.display = "block";
    },

    /**
     * Switches a tab selection to the tab specified by 'tabId' parameter.
     * Turns off the currently selected tab and hides it's content.
     * Also, this function turns on the tab indicated by the 'tabId' and displays it's contents.
     *
     * @param {string} tabId The HTML element identifier to turn 'on'.
     */
    selectTab:function(tabId){
        this.currentSelection='trackOrderStatus';
        this.setOff(this.currentTabId);
        this.setOn(tabId);
        this.currentTabId = tabId;
    },


    /**
     * This function sets the url for ordercopy service and then it invokes the service to copy the old order.
     * @param {string} OrderCopyURL The url for the order copy service.
     */
    prepareOrderCopy:function(OrderCopyURL){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("OrderCopy").setUrl(OrderCopyURL);
        wcService.invoke("OrderCopy");
    },

    /**
     * This function sets the url for ssfs order copy service and then it invokes the service to copy the old order.
     * @param {string} SSFSOrderCopyUrl The url for the ssfs order copy service.
     */
    prepareSSFSOrderCopy:function(SSFSOrderCopyUrl){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("SSFSOrderCopy").setUrl(SSFSOrderCopyUrl);
        wcService.invoke("SSFSOrderCopy");
    },

    /**
     * This function sets the url for subscriptionrenew service and then it invokes the service to renew the subscription.
     * @param {string} SubscriptionCopyURL The url for the subscription copy service.
     */
    prepareSubscriptionRenew:function(SubscriptionCopyURL){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        wcService.getServiceById("SubscriptionRenew").url = SubscriptionCopyURL;
        wcService.invoke("SubscriptionRenew");
    },


    /**
     * This function sets the parameters for the AjaxScheduledOrderCancel service and invokes the service to cancel the order.
     * @param {Integer} orderId The Id of the order to cancel.
     */
    cancelScheduledOrder:function(orderId){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        var params = [];
        params["orderId"] = orderId;
        params["URL"] = "";
        params["storeId"] = MyAccountServicesDeclarationJS.storeId;
        params["catalogId"] = MyAccountServicesDeclarationJS.catalogId;
        params["langId"] = MyAccountServicesDeclarationJS.langId;
        wcService.invoke("AjaxScheduledOrderCancel", params);
    },

    /**
     *  This function will highlight the selection in MyAccount left sidebar. When the user clicks on any of the links in left sidebar,
     *  the link is made bold indicating that it is selected.
     *  @param {string} url This is the url of the link that is selected in the left sidebar.
     */
    changeSelection: function(url){
        var start = url.indexOf("currentSelection",0);
        if(start != '-1'){
            var end = url.indexOf("Slct",start);
            var id= url.substring(start+17,end);
        }
        /*The previously highlighted link is deselected. */
        if(this.currentSelection){
            document.getElementById(this.currentSelection).setAttribute("class","");
            document.getElementById(this.currentSelection).setAttribute("className","");/*For IE */
        }
        document.getElementById('MyAccountBreadcrumbLink').style.display = "none";
        if(document.getElementById("RecurringOrderBreadcrumb")){
            document.getElementById("RecurringOrderBreadcrumb").style.display = "none";
            document.getElementById("RecurringOrderBreadcrumb1").style.display = "none";
        }
        if(document.getElementById("SubscriptionBreadcrumb")){
            document.getElementById("SubscriptionBreadcrumb").style.display = "none";
            document.getElementById("SubscriptionBreadcrumb1").style.display = "none";
        }
        if(document.getElementById("OrderHistoryBreadcrumb")){
            document.getElementById("OrderHistoryBreadcrumb").style.display = "none";
            document.getElementById("OrderHistoryBreadcrumb1").style.display = "none";
        }
        if(id){
            if(id == "trackOrderStatus"){
                document.getElementById("OrderHistoryBreadcrumb1").style.display = "inline";
            }
            else if(id == "OrderDetail"){
                document.getElementById("OrderHistoryBreadcrumb").style.display = "inline";
                var start1 = url.indexOf("breadCrumb",0);
                if(start1 != '-1'){
                    var end1 = url.indexOf("Brcmb", start1);
                    var id1 = url.substring(start1+11, end1);
                }
                id1 = id1.replace(/%[0-9]*B/g," ");
                document.getElementById("OrderHistoryDetailBreadcrumbLink").innerHTML = id1.replace(/\+/g, " ");
            }
            else if(id == "trackRecurringOrderStatus"){
                document.getElementById("RecurringOrderBreadcrumb1").style.display = "inline";
            }
            else if(id == "RecurringOrderDetail"){
                document.getElementById("RecurringOrderBreadcrumb").style.display = "inline";
                var start1 = url.indexOf("breadCrumb",0);
                if(start1 != '-1'){
                    var end1 = url.indexOf("Brcmb", start1);
                    var id1 = url.substring(start1+11, end1);
                }
                id1 = id1.replace(/%[0-9]*B/g," ");
                document.getElementById("RecurringOrderDetailBreadcrumbLink").innerHTML = id1.replace(/\+/g, " ");
            }
            else if(id == "trackSubscriptionStatus"){
                document.getElementById("SubscriptionBreadcrumb1").style.display = "inline";
            }
            else if(id == "SubscriptionDetail"){
                document.getElementById("SubscriptionBreadcrumb").style.display = "inline";
                var start1 = url.indexOf("breadCrumb",0);
                if(start1 != '-1'){
                    var end1 = url.indexOf("Brcmb", start1);
                    var id1 = url.substring(start1+11, end1);
                }
                id1 = id1.replace(/%[0-9]*B/g," ");
                document.getElementById("SubscriptionDetailBreadcrumbLink").innerHTML = id1.replace(/\+/g, " ");
            }
            /* The newly selected link is highlighted. */
            else if(document.getElementById(id)){
                document.getElementById('MyAccountBreadcrumbLink').style.display = "inline";
                document.getElementById(id).setAttribute("class","strong");
                document.getElementById(id).setAttribute("className","strong");/* For IE */
                this.currentSelection = id;
            }
        }
        else{
            document.getElementById('MyAccountBreadcrumbLink').style.display = "inline";
        }
    },

    /**
     * This function enables customers to update their current personal information. The user can also
     * update their password through this function.
     * @param {string} form The name of the form containing personal information of the customer.
     * @param {string} logonPassword The value of the 'password' field.
     * @param {string} logonPasswordVerify The value of the 'verify password' field.
     */
    prepareSubmit:function(form,logonPassword,logonPasswordVerify){

        /** Uses the common validation function defined in AddressHelper class for validating first name,
         *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
         */

        if(!AddressHelper.validateAddressForm(form)){
            return;
        }

        /* Checks whether the customer has registered for promotional e-mails. */
        if(form.sendMeEmail && form.sendMeEmail.checked){
            form.receiveEmail.value = true;
        }
        else {
            form.receiveEmail.value = false;
        }

        if(form.sendMeSMSNotification && form.sendMeSMSNotification.checked){
            form.receiveSMSNotification.value = true;
        }
        else {
            form.receiveSMSNotification.value = false;
        }

        if(form.sendMeSMSPreference && form.sendMeSMSPreference.checked){
            form.receiveSMS.value = true;
        }
        else {
            form.receiveSMS.value = false;
        }

        if(form.mobileDeviceEnabled != null && form.mobileDeviceEnabled.value == "true"){
            if(!this.validateMobileDevice(form)){
                return;
            }
        }
        if(form.birthdayEnabled != null && form.birthdayEnabled.value == "true"){
            if(!this.validateBirthday(form)){
                return;
            }
        }

        /* For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }

        processAndSubmitForm(form);
        if(CSRWCParamJS.env_shopOnBehalfSessionEstablished != "true"){
            // Update shopperName only if they are updating it for themself.
            // If CSR is updating onBehalf of shopper, then no need to update the logonUserId.
            // LogonUserId will be of CSR in that case and it doesn't match with shopper name read from personal information form.
            var shopperName = getCookie("WC_LogonUserId_"+WCParamJS.storeId);
            if (trim(shopperName) != (form.firstName.value + " " + form.lastName.value)){
                setCookie("WC_LogonUserId_"+WCParamJS.storeId, form.firstName.value + " " + form.lastName.value , {path:'/', domain:cookieDomain});
            }
        }
    },

    /**
     *  This function opens up the passed in url in a new browser window.
     *  @param {string} URL The url to be invoked from the new window.
     */
    popupWindow:function(URL) {

        window.open(URL, "mywindow", "status=1,scrollbars=1,resizable=1");
    },

   /**
    * This function removes a coupon. If a customer has a that has not been applied to an order
    * then this function can be used to remove that coupon from the customer's coupon wallet.
    * @param {string} formName The name of the form that contains the table which holds the coupon to be deleted.
    * @param {string} returnView The view to return to after the request has been processed.
    * @param {string} couponId The unique ID of the coupon. This is set in the form to be sent to the service.
    */

    deleteCoupon:function(formName,couponId)
    {

        var form = document.forms[formName];

        form.couponId.value = couponId;
        form.taskType.value= "D";

        /* For Handling multiple clicks. */
        if(!submitRequest()){
             return;
        }
        var service = wcService.getServiceById('AjaxRESTWalletCouponsDelete');
        service.setFormId(formName);
        //CommonContextsJS.setContextProperty("CouponDisplay_Context","returnView",returnView);
        cursor_wait();
        wcService.invoke('AjaxRESTWalletCouponsDelete');
    },

    /**
     * This function cancels a recurring order.
     * @param {String} subscriptionId The unique ID of the subscription to cancel.
     * @param {int} popupIndex the index of the action drop down
     */
    cancelRecurringOrder:function(subscriptionId, popupIndex){

        /*For Handling multiple clicks. */
        if(!submitRequest()){
            return;
        }
        cursor_wait();
        // Destroy the action drop down associated with this recurring order/subscription
        $("[data-widget-type='wc.WCDialog'][data-popupIndex='" + popupIndex + "']").data("wc-WCDialog").destroy();

        var params = {
            subscriptionId: subscriptionId,
            URL: "",
            storeId: MyAccountServicesDeclarationJS.storeId,
            catalogId: MyAccountServicesDeclarationJS.catalogId,
            langId: MyAccountServicesDeclarationJS.langId
        };
        wcService.invoke("AjaxCancelSubscription", params);
    },

    /**
     * Updates the list of contracts that are available to the current user.
     * @param {string} formName  The name of the form that contains the table of selected contracts.
      * @param {string} currentContracts  The IDs of the active contracts that are in the current trading agreement.
      * @param {string} errorMessage  An error message ID which displays the error message thrown by the server
      * and is to be displayed if the optional parameter is passed in.
     */
    updateContract:function(formName, currentContracts, errorMessage){
        var form = document.forms[formName];
        var selected = false;

        /* For Handling multiple clicks. */
        if(!submitRequest()){ return; }

        if(form.contractId.length != undefined){
            for(var i = 0; i < form.contractId.length; i++){
                if(form.contractId[i].checked){
                    selected = true;
                    break;
                }
            }
            if(!selected){
                var current = currentContracts.split(";");
                for(var t = 0; t < current.length; t++){
                    document.getElementById("WC_B2BMyAccountParticipantRole_checkbox_"+current[t]).checked = true;
                }
                MessageHelper.displayErrorMessage(errorMessage);
                resetRequest();
            }
        }else if(form.contractId.checked){
            selected = true;
        }else{
            document.getElementById("WC_B2BMyAccountParticipantRole_checkbox_"+form.contractId.value).checked = true;
            MessageHelper.displayErrorMessage(errorMessage);
            resetRequest();
        }

        if(selected){
            processAndSubmitForm(form);
        }
    },

    /**
     * Changes the organization that is used by the current user.
     * @param {string} formName  The name of the form that contains the table with the selected organization.
     */
    updateOrganization:function(formName){
        var form = document.forms[formName];
        /* For Handling multiple clicks. */
        if(!submitRequest()){ return; }
        processAndSubmitForm(form);
    },

    /**
     * This function forms history state object for history tracking.
     * @param {string} workAreaModeValue A value to uniquely identify a context, which is among the following:
     * myAccountMain, personalInformation, addressBook, checkoutProfile, wishList,trackOrderStatus, mycoupons ,bookmarkedPage
     * @param {string} elementId The id of the widget.
     * @param {string} changeUrl url to update the context of the refresh area.
     */
    HistoryTracker:function(workAreaModeValue, elementId, changeUrl){

        this.workAreaModeValue = workAreaModeValue;
        this.elementId = elementId;
        this.changeUrl =  changeUrl;

    },

    /**
     * This function validates the customer's input for birthday, i.e. whether the year/month/date combination is correct.
     * @param {string} form The name of the form containing personal information of the customer.
     *
     * @return {boolean} This indicates whether the birthday entered is valid or not.
     */

    validateBirthday: function(form){
        if(form.birth_year != null && form.birth_month != null && form.birth_date != null){
            if(form.birth_year.value != 0 || form.birth_month.value != 0 || form.birth_date.value != 0){
                /* if any of the year/month/date fields contains non-empty inforamtion, validate. */
                if(form.birth_month.value == 0){
                    MessageHelper.formErrorHandleClient(form.birth_month.id + "-button", MessageHelper.messages["ERROR_SpecifyMonth"]);
                    return false;
                }
                if(form.birth_date.value == 0){
                    MessageHelper.formErrorHandleClient(form.birth_date.id + "-button", MessageHelper.messages["ERROR_SpecifyDate"]);
                    return false;
                }

                /* set the number of days in Feburary for validation. */
                var febDays = 29;
                if(form.birth_year.value != 0 && ((form.birth_year.value % 4) != 0)){
                    febDays = 28;
                }

                var months = ["4","6","9","11"]; /* these months only have 30 days in total. */
                var monthFound = false;
                for(var i=0; i<months.length; i++){
                    if(months[i] == form.birth_month.value){
                        monthFound = true;
                        break;
                    }
                }
                if(monthFound && (form.birth_date.value > 30)){
                    /* if month entered is April/June/Sept/Nov, check if the date is larger than 30 */
                    MessageHelper.formErrorHandleClient(form.birth_date.id + "-button", MessageHelper.messages["ERROR_InvalidDate1"]);
                    return false;
                }

                if((form.birth_month.value == 2) && (form.birth_date.value > febDays)){
                    /* in the case if the month entered is Feburary, validate the date against febDays. */
                    MessageHelper.formErrorHandleClient(form.birth_date.id + "-button", MessageHelper.messages["ERROR_InvalidDate1"]);
                    return false;
                }
                if(form.curr_year != null && form.curr_month != null && form.curr_date != null){
                    var birth_year = parseInt(form.birth_year.value);
                    var birth_month = parseInt(form.birth_month.value);
                    var birth_date = parseInt(form.birth_date.value);

                    var curr_year = parseInt(form.curr_year.value);
                    var curr_month = parseInt(form.curr_month.value);
                    var curr_date = parseInt(form.curr_date.value);

                    if(birth_year > curr_year){
                        /* if birth year entered is in the future. */
                        MessageHelper.formErrorHandleClient(form.birth_year.id + "-button", MessageHelper.messages["ERROR_InvalidDate2"]);
                        return false;
                    }else if((birth_year == curr_year) && (birth_month > curr_month)){
                        /* if birth year entered is the same as the current year, then check the month entered. */
                        MessageHelper.formErrorHandleClient(form.birth_month.id + "-button", MessageHelper.messages["ERROR_InvalidDate2"]);
                        return false;
                    }else if((birth_year == curr_year) && (birth_month == curr_month) && (birth_date > curr_date)){
                        /* if birth year and month entered are the same as the current year and month, then check the date entered. */
                        MessageHelper.formErrorHandleClient(form.birth_date.id + "-button", MessageHelper.messages["ERROR_InvalidDate2"]);
                        return false;
                    }else{
                        /* the date of birth provided is valid, now verify if the user is under age. */
                        if(form.dateOfBirthTemp != null){
                            if(form.birth_month.value != 0 && form.birth_date.value != 0){
                                var final_birth_year = birth_year;
                                var final_birth_month = birth_month;
                                var final_birth_date = birth_date;
                                if(birth_year == 0){
                                    /* If the user does not specify the year in his/her date of birth, set the year to 1896. */
                                    final_birth_year = 1896;
                                }
                                if(birth_month < 10){
                                    final_birth_month = '0' + birth_month;
                                }
                                if(birth_date < 10){
                                    final_birth_date = '0' + birth_date;
                                }
                                form.dateOfBirthTemp.value = final_birth_year + '-' + final_birth_month + '-' + final_birth_date;
                                document.getElementById(form.dateOfBirthTemp.id).name = 'dateOfBirth';
                            }else{
                                form.dateOfBirthTemp.value = null;
                            }
                        }
                    }
                }
                return true;
            }else{
                if(form.dateOfBirthTemp != null){
                    form.dateOfBirthTemp.value = "";
                    if(document.getElementById(form.dateOfBirthTemp.id) != null){
                        document.getElementById(form.dateOfBirthTemp.id).name = 'dateOfBirth';
                    }
                }
 
                return (isGDPR && !gdpr_error || !isGDPR);
            }
        }
        return true;
    },

    /**
     *  This function validates the Mobile phone number provided by the customer.
     *  The Mobile Phone number option is not a required input by default, but if the customer has entered something,
     *  this method will be called to validate the mobile phone information entered by the customer.
     *  @param {string} form The name of the registration form containing the customer's mobile phone number.
     *  @return {boolean} returns true if the mobile number entered is valid, else returns false.
     */

    validateMobileDevice: function(form){
        if(form.mobilePhone1 != null && form.mobilePhone1!="" ){
            if(!MessageHelper.isValidUTF8length(form.mobilePhone1.value, 32)){
                MessageHelper.formErrorHandleClient(form.mobilePhone1.id, MessageHelper.messages["ERROR_PhoneTooLong"]);
                return false;
            }

            if(!MessageHelper.IsValidPhone(form.mobilePhone1.value)){
                MessageHelper.formErrorHandleClient(form.mobilePhone1.id, MessageHelper.messages["ERROR_INVALIDPHONE"]);
                return false;
            }
        }
        return true;
    },

    /**
     * Displays the actions list drop down panel.
     * @param {object} event The event to retrieve the input keyboard key.
     * @param {string} dialogId The id of the content pane containing the action popup details
     */
    showActionsPopup: function(event, dialogId){
        if(event == null || event.keyCode == KeyCodes.DOWN_ARROW){
            var dialog = $("#" + dialogId).data("wc-WCDialog");
            if(dialog) {
                this.dropDownDlg = dialog;
                this.dropDownDlg.open();
            }
        }

    },

    /**
     *This function displays the Recurring Order / Subscription action popup.
     *@param {String} action This variable can be either reccuring_order or subscription.
     *@param {String} subscriptionId This variable gives the subscription id to be canceled.
     *@param {String} popupIndex the index of the action popup (required to close it later)
     *@param {String} message This variable gives the message regarding cancel notice period.
     */
    showPopup:function(action, subscriptionId, popupIndex, message){
        var popup = $("#Cancel_"+action+"_popup").data("wc-WCDialog");
        if (popup !=null) {
            closeAllDialogs(); //close other dialogs(quickinfo dialog, etc) before opening this.
            popup.element.attr("data-popupIndex", popupIndex);
            popup.open();
            document.getElementById("Cancel_yes_"+action).setAttribute("onclick", "MyAccountDisplay.cancelRecurringOrder("+ subscriptionId + "," + popupIndex + ");");

            if(document.getElementById("cancel_notice_"+action) && document.getElementById(message)){
                $("#cancel_notice_"+action).html($("#" + message).val());
            }
        }else {
            console.debug("Cancel_subscription_popup"+" does not exist");
        }
    },

    /**
     * Switches a tab selection to the tab specified by 'tabId' parameter.
     * Turns off the currently selected tab and hides it's content.
     * Also, this function turns on the tab indicated by the 'tabId' and displays it's contents.
     *
     * @param {string} tabId The HTML element identifier to turn 'on'.
     */
    selectRecurringOrderTab:function(tabId){

        this.setOff(this.currentOrderTabId);
        this.setOn(tabId);
        this.currentOrderTabId = tabId;
    }
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript contains declarations of AJAX services used within
 * WebSphere Commerce.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
MyAccountServicesDeclarationJS = {
	/* The common parameters used in service calls */
	langId: "-1",
	storeId: "",
	catalogId: "",
	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */

	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 *  Removes an item from the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemDelete",
		actionId: "InterestItemDelete",
		url: "AjaxInterestItemDelete",
		formId: ""

	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_REMOVEITEM"]);
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  Adds an item to the customer wishlist in Ajax mode.
	 *  @constructor
	 */
	wcService.declare({
		id: "AjaxInterestItemAdd",
		actionId: "AjaxInterestItemAdd",
		url: "AjaxInterestItemAdd",
		formId: ""
	/**
	 * display a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables the customer to email his/her wishlist.
	 *  @constructor
	 */
	wcService.declare({
		id: "InterestItemListMessage",
		actionId: "InterestItemListMessage",
		url: "AjaxInterestItemListMessage",
		formId: ""

	/**
	 * hdes the progress bar and displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			cursor_clear();
		}
	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds a billing address to the order(s).
	 * @constructor
	 */
	wcService.declare({
		id: "AddBillingAddress",
		actionId: "AddBillingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	 /**
	  *	 calls the saveAddress function defined in the AddressHelper class.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			resetRequest();
			javascript:AddressHelper.saveAddress('AddShippingAddress','shippingAddressCreateEditFormDiv_1');
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "AddShippingAddress",
		actionId: "AddShippingAddress",
		url: "AjaxPersonChangeServiceAddressAdd",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			//document.location.href=appendWcCommonRequestParameters("OrderShippingBillingView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&shipmentType=single&orderPrepare=true");
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
						 MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				  } else {
						 if (serviceResponse.errorMessageKey) {
								MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
						 }
				  }
		}

	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "UpdateShippingAddress",
		actionId: "UpdateShippingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
		}
	}),

	/**
	 *  This service adds a shipping address to the order(s).
	 *  @constructor
	 */
	wcService.declare({
		id: "UpdateBillingAddress",
		actionId: "UpdateBillingAddress",
		url: "AjaxPersonChangeServiceAddressUpdate",
		formId: ""

	/**
	 *  redirects to the Shipping and Billing Method page.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			CheckoutHelperJS.updateAddressIdForOrderItem(serviceResponse.addressId);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
		}
	}),

  /**
   * This services adds or removes a coupon from the order(s).
   * @constructor
   */
	wcService.declare({
		id: "AjaxCouponsAddRemove",
		actionId: "AjaxCouponsAddRemove",
		url: "AjaxCouponsAddRemove",
		formId: ""

   /**
	 * Hides all the messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	}),


	/**
	 * This services deletes a coupon from the wallet.
	 *
	 * @constructor
	 */
	wcService.declare({
		id : "AjaxRESTWalletCouponsDelete",
		actionId : "AjaxCouponsAddRemove",
		url : "AjaxRESTWalletCouponsDelete",
		formId : ""

		/**
		 * Hides all the messages and the progress bar.
		 *
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		successHandler : function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
		}

		/**
		 * display an error message.
		 *
		 * @param (object)
		 *            serviceResponse The service response object,
		 *            which is the JSON object returned by the
		 *            service invocation.
		 */
		,
		failureHandler : function(serviceResponse) {

			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}

	}),

	/**
	 * This service adds or removes a wallet item.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxWalletItemProcessServiceDelete",
		actionId: "AjaxWalletItemProcessServiceDelete",
		url: "AjaxWalletItemProcessServiceDelete",
		formId: ""

	/**
	 * Hides all messages and the progress bar.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
	}

	/**
	 * Displays an error message in case of a failure.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {
		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		} else {
			if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			}
		}
		cursor_clear();
		}

	}),

	/**
	 * This service cancels a subscription.
	 * @constructor
	 */
	wcService.declare({
		id: "AjaxCancelSubscription",
		actionId: "AjaxCancelSubscription",
		url: "AjaxRESTRecurringOrSubscriptionCancel",
		formId: ""

		/**
		 * Clear messages on the page.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
		 */
		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
            closeAllDialogs();
			if(serviceResponse.subscriptionType == "RecurringOrder"){
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SCHEDULE_ORDER_CANCEL_MSG"]);
				}
			}
			else{
				if(serviceResponse.state == "PendingCancel"){
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_PENDING_CANCEL_MSG"]);
				}
				else{
					MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_CANCEL_MSG"]);
				}
			}
		}

		/**
		 * Displays an error message on the page if the request failed.
		 * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			} else {
				if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				}
			}
			cursor_clear();
		}
	}),


	/**
	 *  This service enables customer to Reorder an already existing order.
	 *  @constructor
	 */
	wcService.declare({
		id: "OrderCopy",
		actionId: "OrderCopy",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}
			if (serviceResponse.newOrderItemsCount != null && serviceResponse.newOrderItemsCount<=0){
				MessageHelper.displayErrorMessage(MessageHelper.messages["CANNOT_REORDER_ANY_MSG"]);
			}
			else {
				setDeleteCartCookie();

				var postRefreshHandlerParameters = [];
				var initialURL = "AjaxRESTOrderPrepare";
				var urlRequestParams = [];
				urlRequestParams["orderId"] = serviceResponse.orderId;

				postRefreshHandlerParameters.push({"URL":"AjaxCheckoutDisplayView","requestType":"GET", "requestParams":{}});
				var service = getCustomServiceForURLChaining(initialURL,postRefreshHandlerParameters,null);
				wcService.invoke(service.getParam("id"), urlRequestParams);

			}
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),

	/**
	 *  This service enables customer to Reorder an already existing order in external system.
	 *  @constructor
	 */
	wcService.declare({
		id: "SSFSOrderCopy",
		actionId: "SSFSOrderCopy",
		url: "AjaxSSFSOrderCopy",
		formId: ""

		 /**
		  *  Copies all the items from the existing order to the shopping cart and redirects to the shopping cart page.
		  *  @param (object) serviceResponse The service response object, which is the
		  *  JSON object returned by the service invocation.
		  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			setDeleteCartCookie();
			document.location.href=appendWcCommonRequestParameters("AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

		/**
		* display an error message.
		* @param (object) serviceResponse The service response object, which is the
		* JSON object returned by the service invocation.
		*/
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service enables customer to Renew a subscription.
	 *  @constructor
	 */
	wcService.declare({
		id: "SubscriptionRenew",
		actionId: "SubscriptionRenew",
		url: "AjaxRESTOrderCopy",
		formId: ""

	 /**
	  *  Copies all the items from the existing subscription to the shopping cart and calls service to update requested shipping date.
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
		,successHandler: function(serviceResponse) {
			for (var prop in serviceResponse) {
				console.debug(prop + "=" + serviceResponse[prop]);
			}

			var params = [];

			params.storeId		= MyAccountServicesDeclarationJS.storeId;
			params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
			params.langId		= MyAccountServicesDeclarationJS.langId;
			params.orderId      = serviceResponse.orderId;
			params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
			params.requestedShipDate = MyAccountDisplay.getSubscriptionDate();

			MyAccountDisplay.subscriptionOrderId = serviceResponse.orderId;
			MyAccountDisplay.subscriptionOrderItemId = serviceResponse.orderItemId[0];

			wcService.invoke("SetRequestedShippingDate",params);
		}

	/**
	 * display an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["PRODUCT_NOT_BUYABLE"]);
			} else if (serviceResponse.errorMessageKey == "_ERR_INVALID_ADDR") {
				MessageHelper.displayErrorMessage(MessageHelper.messages["INVALID_CONTRACT"]);
			}else {
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					 if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
			}
			cursor_clear();
		}

	}),


	/**
	 *  This service sets the requested shipping date for a subscription renewal.
	 *  @constructor
	 */
	wcService.declare({
		id: "SetRequestedShippingDate",
		actionId: "SetRequestedShippingDate",
		url: "AjaxRESTOrderShipInfoUpdate",
		formId: ""
	/**
	 * hides all the messages and the progress bar
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,successHandler: function(serviceResponse) {
			cursor_clear();
			document.location.href=appendWcCommonRequestParameters("RESTOrderPrepare?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId+"&orderId="+serviceResponse.orderId+"&URL=AjaxCheckoutDisplayView?langId="+MyAccountServicesDeclarationJS.langId+"&storeId="+MyAccountServicesDeclarationJS.storeId+"&catalogId="+MyAccountServicesDeclarationJS.catalogId);
		}

	 /**
	 * display an error message
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation
	 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessageKey == "_ERR_ORDER_ITEM_FUTURE_SHIP_DATE_OVER_MAXOFFSET") {
				var params = [];

				params.storeId		= MyAccountServicesDeclarationJS.storeId;
				params.catalogId	= MyAccountServicesDeclarationJS.catalogId;
				params.langId		= MyAccountServicesDeclarationJS.langId;
				params.orderId      = MyAccountDisplay.subscriptionOrderId;
				params.orderItemId      = MyAccountDisplay.subscriptionOrderItemId;
				params.calculationUsage  = "-1,-2,-3,-4,-5,-6,-7";
				wcService.invoke("RemoveSubscriptionItem",params);

				MessageHelper.displayStatusMessage(MessageHelper.messages["CANNOT_RENEW_NOW_MSG"]);
			}
			else{
				if (serviceResponse.errorMessage) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
				}
				else {
					if (serviceResponse.errorMessageKey) {
						MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					 }
				}
				cursor_clear();
			}
		}

	}),

	/**
	 * This service removes the subscription item from the shopping cart if renewal fails.
	 * @constructor
	 */
	wcService.declare({
		id: "RemoveSubscriptionItem",
		actionId: "RemoveSubscriptionItem",
		url: "AjaxRESTOrderItemDelete",
		formId: ""

		/**
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation.
		 */
		,successHandler: function(serviceResponse) {
				cursor_clear();
		}

		 /**
		 * display an error message
		 * @param (object) serviceResponse The service response object, which is the
		 * JSON object returned by the service invocation
		 */
		,failureHandler: function(serviceResponse) {
			if (serviceResponse.errorMessage) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}
			cursor_clear();
		}

	}),

/**
 *  This service enables customer to cancel a scheduled order or an order waiting for approval.
 *  @constructor
 */
wcService.declare({
	id: "AjaxScheduledOrderCancel",
	actionId: "AjaxScheduledOrderCancel",
	url: "AjaxRESTRecurringOrSubscriptionCancel",
	formId: ""

	/**
	 * Displays a success message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,successHandler: function(serviceResponse) {
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MO_ORDER_CANCELED_MSG"]);
	}

	/**
	 * Displays an error message.
	 * @param (object) serviceResponse The service response object, which is the
	 * JSON object returned by the service invocation.
	 */
	,failureHandler: function(serviceResponse) {

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}
})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------
//

/**
 * @fileOverview This javascript is used by AjaxMyAccountQuickCheckoutProfileForm.jsp and MyAccountQuickCheckoutProfileForm.jsp.
 * @version 1.0
 */

/**
 * The functions defined in this class enable the customer to update an existing quickcheckout profile.
 * @class This QuickCheckoutProfile class defines all the functions and variables to manage a quickcheckout profile.
 * A quick address profile can be used to identify shipping addresses, billing addresses, or both shipping and billing addresses when completing the quick checkout process.
 * The fields that can be entered into the quick checkout profile are first name, last name, street address, city, country/region, state/province, ZIP/postal code,
 * phone number, e-mail address, payment method, and shipping method.
 */
QuickCheckoutProfile = {
		/* The common parameters used in service calls. */
		langId: "-1",
		storeId: "",
		catalogId: "",
		/* variable set on quickcheckout profile update which is used to display the success message. */
		pageVar: "aa",
		/** flag to indicate whether the credit card field is updated or not. The value is automatically populated
		 *  by the jsp using the {@link valueChanged} function.
		 *
		 *  @private
		 */
		changed: "false",

	/**
	 * This function initializes common parameters used in all service calls.
	 * @param {int} langId The language id to use.
	 * @param {int} storeId The store id to use.
	 * @param {int} catalogId The catalog id to use.
	 */

	setCommonParameters:function(langId,storeId,catalogId){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;

	},

	/**
	 * This function will declare a refreshArea controller if no controller with the same controller ID exits yet. The
	 * declared controller is designed to handle address specific tasks. If user passes a "url" parameter when updating context, it will
     * replace the value of its own "url" parameter to the one given by the user.
	 * @param {string} controllerId The ID of the controller that is going to be declared.
	 * @param {string} defaultURL The url this controller used for getting data from server. It will be set to controller.url.
	 */
/*
	declareRefreshAreaController: function(controllerId, defaultURL){
		if(wc.render.getRefreshControllerById(controllerId)){
			console.debug("controller with id = "+controllerId+" already exists. No declaration will be done");
			return;
		}
		wc.render.declareRefreshController({
			id: controllerId,
			renderContext: wc.render.getContextById("default"),
			url: defaultURL,
			renderContextChangedHandler: function(message, widget) {
				console.debug("entering renderContextChangedHandler for "+controllerId);

				var controller = this;
				var renderContext = this.renderContext;

				if(typeof actionName == "undefined" || !Common.getRenderContextProperty(renderContext, actionName)){
					console.debug("no actionName is specified. This handler will not be called. Exiting...");
					return;
				}

				if(Common.getRenderContextProperty(renderContext, "url")){
					controller.url = Common.getRenderContextProperty(renderContext, "url");
				}

				widget.refresh(controller.renderContext.properties);

				// Make sure this handler will always know whether a user gives an addressDisplayAreaAction in the future.
				delete renderContext.properties[actionName];
				delete renderContext.properties["url"];
			},

			modelChangedHandler: function(message, widget){
				console.debug(message);
				widget.refresh(this.renderContext.properties);

				cursor_clear();
			}
		});

	}, */

	/**
	 * This function is used when the creditcard field is updated by the user.
	 * @param {boolean} value The value assigned to the {@ link changed} variable of the QuickCheckoutProfile class.
	 */
	valueChanged:function(value){
		QuickCheckoutProfile.changed = value;
	},

	/**
	 * This function is used to validate all the quickcheckout profile form input fields.
	 * @param {string} formName The name of the form containing all the information required to create a quick address profile.
	 *
	 * @private
	 *
	 * @return {boolean} The validation is successful or not.
	 */
	validateForm:function(formName){
		reWhiteSpace = new RegExp(/^\s+$/);
		var form = document.forms[formName];
		var expiry = null;
		if (form.pay_expire_year != null) {
			expiry = new Date(form.pay_expire_year.value,form.pay_expire_month.value - 1,1);
		}
		var currMonth = form.curr_month.value;
		if (currMonth.length == 1) {
			currMonth = "0" + currMonth;
		} else {
			currMonth = form.curr_month.value;
		}

		/** Uses the common validation function defined in AddressHelper class for validating first name,
		 *  last name, street address, city, country/region, state/province, ZIP/postal code, e-mail address and phone number.
		 */
		if(!AddressHelper.validateAddressForm(form,"billing_")){return false;}
		if(!AddressHelper.validateAddressForm(form,"shipping_")){return false;}

		var payMethodId = $('#payMethodId');
		if (payMethodId.find(":selected").val() != null) {
			if (form.pay_temp_account != null && reWhiteSpace.test(form.pay_temp_account.value) || form.pay_temp_account.value == "") {
				  MessageHelper.formErrorHandleClient(form.pay_temp_account.id,MessageHelper.messages["REQUIRED_FIELD_ENTER"]); return false;
			}
			if(QuickCheckoutProfile.changed == 'true')
			{
				form.pay_temp_account.name = 'pay_account';
			}
			else
				QuickCheckoutProfile.changed = 'false';
			/* Checks for a valid credit card expiry date. */
			 if (form.pay_expire_year != null && form.pay_expire_year.value < form.curr_year.value) {
				  MessageHelper.formErrorHandleClient(form.pay_expire_year.id,MessageHelper.messages["INVALID_EXPIRY_DATE"]); return false;
			 }
			 else if ( (form.pay_expire_year != null) && (form.pay_expire_year.value == form.curr_year.value) && (currMonth > form.pay_expire_month.value)) {
				 MessageHelper.formErrorHandleClient(form.pay_expire_month.id,MessageHelper.messages["INVALID_EXPIRY_DATE"]); return false;
			 }
		}
		return true;
	},

	/**
	 * This function loads the current quickcheckout profile.
	 * @param {array} addresses This is a shippingProfile or billingProfile address object.
	 * @param {string} prefix The value is set to shipping or billing.
 	 */
	getCurrentProfile: function(addresses, prefix){
		var firstname = $("input[name=" + prefix + "_firstName]")[0];
		var lastname = $("input[name=" + prefix + "_lastName]")[0];
		var address1 = $("input[name=" + prefix + "_address1]")[0];
		var address2 = $("input[name=" + prefix + "_address2]")[0];
		var zipCode = $("input[name=" + prefix + "_zipCode]")[0];
		var email1 = $("input[name=" + prefix + "_email1]")[0];
		var phone1 = $("input[name=" + prefix + "_phone1]")[0];
		var city = $("input[name=" + prefix + "_city]")[0];
		var middleName = "";
		if($("input[name=" + prefix + "_middleName]")[0])
			middleName = $("input[name=" + prefix + "_middleName]")[0];

		firstname.value = addresses.firstName;
		lastname.value = addresses.lastName;
		address1.value = addresses.address1;
		address2.value = addresses.address2;
		zipCode.value = addresses.zipCode;
		email1.value = addresses.email1;
		phone1.value = addresses.phone1;
		city.value = addresses.city;
		if(middleName)
		{
			middleName.value = addresses.middleName;
		}

		var stateId = prefix+'_WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_'+prefix+'_state_1';
		var state = $('#' + stateId);
		if(addresses.state != ''){
			if (state !== undefined && state !== null){
				state.val(addresses.state);
				state.Select("refresh_noResizeButton");
			} else {
				state = $("input[name=" + prefix + "_state]")[0].val();
				state.val(addresses.state);
			}
		}

		if(addresses.country != '') {
			var country = $('#' + 'WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_'+prefix+'_country_1');
			country.val(addresses.country);
			country.Select("refresh_noResizeButton");
			AddressHelper.loadAddressFormStatesUI('QuickCheckout',prefix + "_", prefix+'_stateDiv','WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_'+ prefix + '_state_1', false, addresses.state);
		}
	},

	/**
	 * This function is used to show/hide the shipping address div if the 'same as my billing address' checkbox is unchecked/checked.
	 * @param {string} form The name of the form containing all the information required to create a quick address profile.
	 */

	showHide:function(form){
		var sameaddress = document.getElementById("SameShippingAndBillingAddress");
		if (sameaddress.checked){
				hideElementById("shipAddr");
				this.copyBillingAddress(form);
		}
		else{
			showElementById("shipAddr");
			$("input[name=shipping_firstName]")[0].value = "";
			$("input[name=shipping_lastName]")[0].value = "";
			$("input[name=shipping_address1]")[0].value = "";
			$("input[name=shipping_address2]")[0].value = "";
			$("input[name=shipping_city]")[0].value = "";
			$("input[name=shipping_zipCode]")[0].value = "";
			$("input[name=shipping_phone1]")[0].value = "";
			$("input[name=shipping_email1]")[0].value = "";
			$("select,input[name=shipping_state]")[0].value = "";
			if($("input[name=shipping_middleName]")[0])
				$("input[name=shipping_middleName]")[0].value = "";
		}
	},

	/**
	 * This function makes the shipping same as the billing address.
	 * @param {string} form The name of the quickcheckout profile form.
	 */
	copyBillingAddress:function(form){
		$("input[name=shipping_firstName]")[0].value = form.billing_firstName.value;
		$("input[name=shipping_lastName]")[0].value = form.billing_lastName.value;
		$("input[name=shipping_address1]")[0].value = form.billing_address1.value;
		$("input[name=shipping_address2]")[0].value = form.billing_address2.value;
		$("input[name=shipping_city]")[0].value = form.billing_city.value;
		$("input[name=shipping_zipCode]")[0].value = form.billing_zipCode.value;
		$("input[name=shipping_phone1]")[0].value = form.billing_phone1.value;
		$("input[name=shipping_email1]")[0].value = form.billing_email1.value;
		if ($("input[name=shipping_middleName]")[0])
			$("input[name=shipping_middleName]")[0].value = form.billing_middleName.value;

		var country = $('#WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_country_1');
		country.val(form.billing_country.value);
		country.Select("refresh_noResizeButton");

		AddressHelper.loadAddressFormStatesUI('QuickCheckout','shipping_','shipping_stateDiv','WC_QuickCheckoutAddressForm_AddressEntryForm_FormInput_shipping_state_1', false, form.billing_state.value);
	},

	/**
	 * This function updates the quickCheckout profile.
	 * @param {string} form The name of the form containing all the information required to create a quick address profile.
	 */
	UpdateProfile: function(form){
		var sameaddress = document.getElementById("SameShippingAndBillingAddress");
		if (sameaddress.checked){
			this.copyBillingAddress(form);
		}
		/* validates the form input fields. */
		if(this.validateForm(form.name))
		{
			var paymentMethodWidget = $("#payMethodId");
			var paymentMethod;
			if (paymentMethodWidget.length !== 0) {
					paymentMethod = paymentMethodWidget.val();
			}

			form.pay_payment_method.value = paymentMethod;
			form.pay_cc_brand.value = paymentMethod;
			form.pay_payMethodId.value = paymentMethod;

			/*For Handling multiple clicks. */
			if(!submitRequest()){
				return;
			}

			processAndSubmitForm(form);
		}
	}
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

//
//

/**
* @fileOverview This file holds methods to perform display logic in History Order Details page when the order info is retrieved from Sterling Selling And Fulfillment Suite.<b>
*			This file is referenced in SBSOrderDetails.jsp, SBSOrderDetailSummary.jsp and SBSMSOrderItemDetailSummary.jsp.
*
* @version 1.0
**/

/**
* @class sterlingIntegrationJS This class defines all the variables and functions used by the SterlingIntegration.js. Any page that will use a function in this file
*		can access that function thru this class. Pages that use sterlingIntegrationJS include SBSOrderDetails.jsp, SBSOrderDetailSummary.jsp and SBSMSOrderItemDetailSummary.jsp.
*
**/

sterlingIntegrationJS={

			/** The language ID currently in use **/
			langId: "-1",

			/** The store ID currently in use **/
			storeId: "",

			/** The catalog ID currently in use **/
			catalogId: "",

			/** The locale currently in use **/
			locale: "",

			/** The image files directory in current store **/
			jspStoreImgDir: "",

			orderBeingCanceled: "",
				/**
				* setCommonParameters This function initializes storeId, catalogId, langId, locale and store image directory.
				*
				* @param {String} langId The language id to use.
				* @param {String} storeId The store id to use.
				* @param {String} catalogId The catalog id to use.
				* @param {String} locale The locale to use.
				* @param (String) jspStoreImgDir the store image files directory to use.
				*
				**/
				setCommonParameters:function(langId,storeId,catalogId,locale,jspStoreImgDir){
					this.langId = langId;
					this.storeId = storeId;
					alert('-1 '+this.storeId);
					this.catalogId = catalogId;
					this.locale = locale;
					this.jspStoreImgDir = jspStoreImgDir;
				},

				/**
				* populateOrderLevelInfo This function populates the order level information for the order retrieved from Sterling * in history order details page.
				*
				* @param {String} orderStr The json string for complete order information.
				*
				**/
				populateOrderLevelInfo:function(orderStr){
					//alert('0 '+this.storeId);
					//orderStr = orderStr.replace("'", '&quot;');
					var jsonOrder = eval("("+orderStr+")");
					var locale = document.getElementById('Locale_String').innerHTML;
					var shipmentType = 2;
					if(!this.isNullObj(jsonOrder.Root.Order.shipmentTypeId)){
						shipmentType = jsonOrder.Root.Order.shipmentTypeId;
					}
					var pmTotalNumber = 0;
					if(!this.isNullObj(jsonOrder.Root.Order.countOfPaymentMethods)){
						pmTotalNumber = jsonOrder.Root.Order.countOfPaymentMethods;
					}
					var oiTotalNumber = 1;
					if(!this.isNullObj(jsonOrder.Root.Order.countOfOrderLines)){
						oiTotalNumber = jsonOrder.Root.Order.countOfOrderLines;
					}

					//Order Number field
					if(!this.isNullObj(jsonOrder.Root.Order.OrderNo)){
						var orderNo = jsonOrder.Root.Order.OrderNo;
						if(!this.isNullObj(jsonOrder.Root.Order.EntryType)){
							var entryType = jsonOrder.Root.Order.EntryType;
							if(entryType == 'WCS'){
								document.getElementById('OrderNo').innerHTML = orderNo.substring(3);
							}else{
								document.getElementById('OrderNo').innerHTML = orderNo;
							}
						}else{
							document.getElementById('OrderNo').innerHTML = orderNo;
						}
					}

					//Order Date field
					if(!this.isNullObj(jsonOrder.Root.Order.OrderDate)){
						var orderDate = jsonOrder.Root.Order.OrderDate;
						var parsedOrderDate = new Date(orderDate);
						document.getElementById('OrderDate').innerHTML = Globalize.formatDate(parsedOrderDate, {date: "long"});
					}

					//Single Shipment
					if(shipmentType == 1){

						//Shipping Address
						var shippingAddress = null;
						var orderLinePersonInfoShipTo = null;

						if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine)){
							if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo)){
								orderLinePersonInfoShipTo = jsonOrder.Root.Order.OrderLines.OrderLine.PersonInfoShipTo;
							}else if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])){
								if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo)){
									orderLinePersonInfoShipTo = jsonOrder.Root.Order.OrderLines.OrderLine[0].PersonInfoShipTo;
								}
							}
						}
						if(!this.isNullObj(orderLinePersonInfoShipTo)){
							this.populateAddress(orderLinePersonInfoShipTo, 'Single_Shipping_Address', locale);
						}else if(!this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo)){
							this.populateAddress(jsonOrder.Root.Order.PersonInfoShipTo, 'Single_Shipping_Address', locale);
						}

						//Shipping Method
						var shippingMethod = null;
						if(!this.isNullObj(jsonOrder.Root.Order.Shipments)){
						if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment)){
						 	if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription)){
								shippingMethod = jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription;
							}else if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0])){
								if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0].shipModeDescription)){
									shippingMethod = jsonOrder.Root.Order.Shipments.Shipment[0].shipModeDescription;
								}
							}
						}
						}
						if(this.isNullObj(shippingMethod)){
							if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine)){
								if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine.shipModeDescription)){
									shippingMethod = jsonOrder.Root.Order.OrderLines.OrderLine.shipModeDescription;
								}else if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])){
									if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0].shipModeDescription)){
										shippingMethod = jsonOrder.Root.Order.OrderLines.OrderLine[0].shipModeDescription;
									}
								}
							}
						}
						if(this.isNullObj(shippingMethod)){
							if(!this.isNullObj(jsonOrder.Root.Order.CarrierServiceCode)){
								shippingMethod = jsonOrder.Root.Order.shipModeDescription;
							}
						}
						if(!this.isNullObj(shippingMethod)){
							document.getElementById('Single_Shipping_Method').innerHTML = shippingMethod;
						}

						//Shipping Instruction
						if(!this.isNullObj(document.getElementById('Single_Shipping_Instruction'))){
							var instructions = null;
							if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine)){
								if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine.Instructions)){
									instructions = jsonOrder.Root.Order.OrderLines.OrderLine.Instructions;
								}else if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])){
									if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions)){
										instructions = jsonOrder.Root.Order.OrderLines.OrderLine[0].Instructions;
									}
								}
							}
							if(!this.isNullObj(instructions)){
								if(!this.isNullObj(instructions.Instruction)){
									var instruction = instructions.Instruction;
									if(!this.isNullObj(instruction.InstructionType)){
										if(instruction.InstructionType=='SHIP'){
											if(!this.isNullObj(instruction.InstructionText)){
												document.getElementById('Single_Shipping_Instruction_Label').style.display = 'inline';
												document.getElementById('Single_Shipping_Instruction').innerHTML = instruction.InstructionText;
											}
										}
									}else if(!this.isNullObj(instructions.Instruction[0])){
										//more than one instruction
										for(var k in instructions.Instruction){
											if(!this.isNullObj(instructions.Instruction[k].InstructionType)){
												if(instructions.Instruction[k].InstructionType=='SHIP'){
													if(!this.isNullObj(instructions.Instruction[k].InstructionText)){
														document.getElementById('Single_Shipping_Instruction_Label').style.display = 'inline';
														document.getElementById('Single_Shipping_Instruction').innerHTML = document.getElementById('Single_Shipping_Instruction').innerHTML + instructions.Instruction[k].InstructionText+'<br/>';
													}
												}
											}
										}
									}
								}else{
									//no instruction
								}
							}//no instructions

						}
					}

					//Ship As Complete
					if(!this.isNullObj(document.getElementById('Shipping_As_Complete_Y'))){
						if(!this.isNullObj(jsonOrder.Root.Order.IsShipComplete)){
							var shipAsComplete = jsonOrder.Root.Order.IsShipComplete;
							if(shipAsComplete == 'Y'){
								document.getElementById('Shipping_As_Complete_Y').style.display = 'inline';
								document.getElementById('Shipping_As_Complete_N').style.display = 'none';
							}else{
								document.getElementById('Shipping_As_Complete_Y').style.display = 'none';
								document.getElementById('Shipping_As_Complete_N').style.display = 'inline';
							}
						}
					}

					var currencyCode = 'USD';
					if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency)){
						currencyCode = jsonOrder.Root.Order.PriceInfo.Currency;
					}
					var currencyDecimals = 2;
					if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal)){
						currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal;
					}
					var currencySymbol = '$'
					if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol)){
						currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol;
					}
					//Line SubTotal
					if(!this.isNullObj(jsonOrder.Root.Order.OverallTotals.LineSubTotal)){
						document.getElementById('Order_SubTotal').innerHTML = this.formatCurrency(jsonOrder.Root.Order.OverallTotals.LineSubTotal, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Grand Discount
					var grandDiscount = jsonOrder.Root.Order.OverallTotals.GrandDiscount;
					if(!this.isNullObj(grandDiscount)){
						if(grandDiscount > 0){
							grandDiscount = 0 - grandDiscount;
						}
						document.getElementById('Order_Discount').innerHTML = this.formatCurrency(grandDiscount, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Grand Shipping Base Charge
					if(!this.isNullObj(jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge)){
						document.getElementById('Order_Shipping').innerHTML = this.formatCurrency(jsonOrder.Root.Order.OverallTotals.GrandShippingBaseCharge, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Total Tax
					if(!this.isNullObj(jsonOrder.Root.Order.OverallTotals.salesTax)){
						document.getElementById('Order_Tax').innerHTML = this.formatCurrency(jsonOrder.Root.Order.OverallTotals.salesTax, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Shipping Tax
					if(!this.isNullObj(jsonOrder.Root.Order.OverallTotals.shippingTax)){
						document.getElementById('Order_ShippingTax').innerHTML = this.formatCurrency(jsonOrder.Root.Order.OverallTotals.shippingTax, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Grand Total
					if(!this.isNullObj(jsonOrder.Root.Order.OverallTotals.GrandTotal)){
						document.getElementById('Order_Totals').innerHTML = this.formatCurrency(jsonOrder.Root.Order.OverallTotals.GrandTotal, currencyDecimals, currencySymbol, currencyCode, locale);
					}

					//Billing Address When No Payment Method
					if(pmTotalNumber == 0){
						if(!this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo)){
							this.populateAddress(jsonOrder.Root.Order.PersonInfoBillTo, 'Billing_Address_With_No_Payment_Method', locale);
						}
					}

					//Payment section
						for(var i=0; i<pmTotalNumber; i++ ){
							var paymentMethod = null;
							if(pmTotalNumber == 1){
								paymentMethod = jsonOrder.Root.Order.PaymentMethods.PaymentMethod;
							}else{
								paymentMethod = jsonOrder.Root.Order.PaymentMethods.PaymentMethod[i];
							}

							//Payment Method Billing Address
							if(!this.isNullObj(paymentMethod.PersonInfoBillTo)){
								this.populateAddress(paymentMethod.PersonInfoBillTo, 'Billing_Address_'+i, locale);
							}else if(!this.isNullObj(jsonOrder.Root.Order.PersonInfoBillTo)){
								this.populateAddress(jsonOrder.Root.Order.PersonInfoBillTo, 'Billing_Address_'+i, locale);
							}

							//Payment Method Name
							if(!this.isNullObj(paymentMethod.paymentMethodName)){
								document.getElementById('Payment_Method_Name_'+i).innerHTML = paymentMethod.paymentMethodName;
							}
							//for CAAS
							/*if(!this.isNullObj(paymentMethod.PaymentType)){
								if(paymentMethod.PaymentType == 'CREDIT_CARD'){
									if(!this.isNullObj(paymentMethod.CreditCardType)){
										document.getElementById('Payment_Method_Name_'+i).innerHTML = paymentMethod.CreditCardType;
									}
								}else{
									document.getElementById('Payment_Method_Name_'+i).innerHTML = paymentMethod.PaymentType;
								}
							}*/

							if(!this.isNullObj(paymentMethod.PaymentType)){
								if(paymentMethod.PaymentType == 'CREDIT_CARD'){
									document.getElementById('Div_CreditCard_'+i).style.display = 'inline';
									document.getElementById('Div_Check_'+i).style.display = 'none';
									document.getElementById('Div_LineOfCredit_'+i).style.display = 'none';

									if(!this.isNullObj(paymentMethod.DisplayCreditCardNo)){
										document.getElementById('CreditCard_Account_'+i).innerHTML = '************'+ paymentMethod.DisplayCreditCardNo;
									}
									if(!this.isNullObj(paymentMethod.CreditCardExpDate)){
										document.getElementById('CreditCard_Expiration_Month_'+i).innerHTML = paymentMethod.CreditCardExpDate.substring(0,2);
										document.getElementById('CreditCard_Expiration_Year_'+i).innerHTML = paymentMethod.CreditCardExpDate.substring(3,7);
										//document.getElementById('CreditCard_Expiration_Year_'+i).innerHTML = paymentMethod.CreditCardExpDate.substring(2,6);
									}
								}
								if(paymentMethod.PaymentType == 'Check'){
									document.getElementById('Div_CreditCard_'+i).style.display = 'none';
									document.getElementById('Div_Check_'+i).style.display = 'inline';
									document.getElementById('Div_LineOfCredit_'+i).style.display = 'none';

									if(!this.isNullObj(paymentMethod.DisplayPaymentReference1)){
										document.getElementById('Check_Account_'+i).innerHTML = '************'+ paymentMethod.DisplayPaymentReference1;
									}
								}

								if(paymentMethod.PaymentType == 'LineOfCreidt'){
									document.getElementById('Div_CreditCard_'+i).style.display = 'none';
									document.getElementById('Div_Check_'+i).style.display = 'none';
									document.getElementById('Div_LineOfCredit_'+i).style.display = 'inline';

									if(!this.isNullObj(paymentMethod.DisplayCustomerAccountNo)){
										document.getElementById('LineOfCredit_Account_'+i).innerHTML = '************'+ paymentMethod.DisplayCustomerAccountNo;
									}
								}

								if(!this.isNullObj(paymentMethod.MaxChargeLimit)){
									document.getElementById('Payment_Method_Amount_'+i).innerHTML = this.formatCurrency(paymentMethod.MaxChargeLimit, currencyDecimals, currencySymbol, currencyCode, locale);
								}
							}

						}
				},

				populateAddress: function(address, addrDiv, locale){
					var addressId = '';
					if(!this.isNullObj(address.AddressID)){addressId = address.AddressID;}
					var firstName = '';
					if(!this.isNullObj(address.FirstName)){firstName = address.FirstName;}
					var middleName = '';
					if(!this.isNullObj(address.MiddleName)){middleName = address.MiddleName;}
					var lastName = '';
					if(!this.isNullObj(address.LastName)){lastName = address.LastName;}
					var addressLine1 = '';
					if(!this.isNullObj(address.AddressLine1)){addressLine1 = address.AddressLine1;}
					var addressLine2 = '';
					if(!this.isNullObj(address.AddressLine2)){addressLine2 = address.AddressLine2;}
					var city = '';
					if(!this.isNullObj(address.City)){city = address.City;}
					var state = '';
					if(!this.isNullObj(address.stateDisplayName)){state = address.stateDisplayName;}
					var country = '';
					if(!this.isNullObj(address.countryDisplayName)){country = address.countryDisplayName;}
					var zipCode = '';
					if(!this.isNullObj(address.ZipCode)){zipCode = address.ZipCode;}
					var telephone = '';
					if(!this.isNullObj(address.DayPhone)){telephone = address.DayPhone;}
					var email = '';
					if(!this.isNullObj(address.EMailID)){email = address.EMailID;}

					var addressContent = '<p>'+addressId+'</p>';
					if(locale == 'ar_EG'){

						if(firstName.length > 0 || middleName.length > 0 || lastName.length > 0){
							addressContent = addressContent + firstName + '&nbsp;' + middleName + '&nbsp;' + lastName + '<br />';
						}
						if(addressLine1.length > 0 || addressLine2.length > 0){
							addressContent = addressContent + addressLine1 + '&nbsp;'+ addressLine2 + '<br />';
						}
						if(city.length > 0){
							addressContent = addressContent + city +'<br />';
						}
						if(state.length > 0){
							addressContent = addressContent + state +'<br />';
						}
						if(country.length > 0){
							addressContent = addressContent + country +'<br />';
						}
						if(telephone.length > 0){
							addressContent = addressContent + telephone +'<br />';
						}

					}else if(locale == 'ja_JP' || locale == 'ko_KR' || locale == 'zh_CN' || locale == 'zh_TW'){

						if(lastName.length > 0 || firstName.length > 0){
							addressContent = addressContent + lastName + '&nbsp;' + firstName + '<br />';
						}
						if(country.length > 0 || zipCode.length > 0){
							addressContent = addressContent + country +'&nbsp;'+ zipCode +'&nbsp;<br />';
						}
						if(state.length > 0 || city.length > 0){
							addressContent = addressContent + state +'&nbsp;'+ city +'&nbsp;<br />';
						}
						if(addressLine1.length > 0 || addressLine2.length > 0){
							addressContent = addressContent + addressLine1 + '&nbsp;'+ addressLine2 + '<br />';
						}
						if(telephone.length > 0){
							addressContent = addressContent + telephone +'<br />';
						}

					}else if(locale == 'de_DE' || locale == 'es_ES' || locale == 'fr_FR' || locale == 'it_IT' || locale == 'pl_PL' || locale == 'ro_RO' || locale == 'ru_RU'){

						if(firstName.length > 0 || middleName.length > 0 || lastName.length > 0){
							addressContent = addressContent + firstName + '&nbsp;' + middleName + '&nbsp;' + lastName + '<br />';
						}
						if(addressLine1.length > 0 || addressLine2.length > 0){
							addressContent = addressContent + addressLine1 + '&nbsp;'+ addressLine2 + '<br />';
						}
						if(zipCode.length > 0 || city.length > 0){
							addressContent = addressContent + zipCode +'&nbsp;'+ city +'&nbsp;<br />';
						}
						if(state.length > 0){
							addressContent = addressContent + state +'<br />';
						}
						if(country.length > 0){
							addressContent = addressContent + country +'<br />';
						}
						if(telephone.length > 0){
							addressContent = addressContent + telephone +'<br />';
						}

					}else{

						if(firstName.length > 0 || lastName.length > 0){
							addressContent = addressContent + firstName + '&nbsp;' + lastName + '<br />';
						}
						if(addressLine1.length > 0 || addressLine2.length > 0){
							addressContent = addressContent + addressLine1 + '&nbsp;'+ addressLine2 + '<br />';
						}
						if(city.length > 0 || state.length > 0){
							addressContent = addressContent + city +'&nbsp;'+ state +'&nbsp;<br />';
						}
						if(country.length > 0 || zipCode.length > 0){
							addressContent = addressContent + country +'&nbsp;'+ zipCode +'&nbsp;<br />';
						}
						if(telephone.length > 0){
							addressContent = addressContent + telephone +'<br />';
						}
						if(email.length > 0){
							addressContent = addressContent + email +'<br />';
						}

					}
					document.getElementById(addrDiv).innerHTML = addressContent;
				},

				isNullObj: function(obj){
					if(obj != null && typeof(obj) != undefined){
						return false;
					}else{
						return true;
					}
				},

				formatCurrency: function(amount, decimals, symbol, currency, locale){
					return Utils.formatCurrency(amount, {
						minimumFractionDigits: parseInt(decimals),
						maximumFractionDigits: parseInt(decimals),
						currency: currency,
						locale: locale
					});
				},

				/**
				 * This function replace the special chars back for the path related string.
				 *
				 * @param {String} str The string relates to path.
				 * @return (String) The replaced String.
				 */
				revertAllSpecialChars: function (str) {
					if(!this.isNullObj(str)){
						return str.replace(/&#62;/g, ">").replace(/&#60;/g, "<").replace(/&#39;/g, "'").replace(/&#34;/g, "\"").replace(/&#92;/g, "\\").replace(/&#38;/g, "&");
					} else {
						return str;
					}
				},

				/**
				* populateOrderLineInfoForSingleShipment This function populates the order line level information for the order
				* retrieved from Sterling in history order details page with single shipment layout.
				*
				* @param {String} orderStr The json string for complete order information.
				* @param {Integer} beginIndex The begin index of the current order items page.
				* @param {Integer} pageSize The page size of the current order items page.
				*
				**/
				populateOrderLineInfoForSingleShipment: function(orderStr, beginIndex, pageSize){
					//alert('1 '+this.storeId);
					if(orderStr == null || orderStr === "") return;

					orderStr = orderStr.replace("'", "27%");
					var jsonOrder = eval("("+orderStr+")");
					var imgDir = document.getElementById('Image_Dir').innerHTML;
					var endIndex = document.getElementById('endIndex').innerHTML;
					var locale = document.getElementById('Locale_String_S').innerHTML;

					var orderLineNum = 1;
					if(!this.isNullObj(jsonOrder.Root.Order.countOfOrderLines)){
						orderLineNum = jsonOrder.Root.Order.countOfOrderLines;
					}
					//alert(document.getElementById('order_details').childNodes[1]);
					//alert(document.getElementById('order_details').childNodes[1].tagName);
					if(document.getElementById('order_details').childNodes[0].tagName == 'TBODY'){
						var parentTable = document.getElementById('order_details').childNodes[0];
					}else if(document.getElementById('order_details').childNodes[1].tagName == 'TBODY'){
						var parentTable = document.getElementById('order_details').childNodes[1];
					}


					for(var i=beginIndex; i<endIndex; i++){
						var orderLine = null;
						if(orderLineNum == 1){
							if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])){
							    orderLine = jsonOrder.Root.Order.OrderLines.OrderLine[0];
							} else {
							    orderLine = jsonOrder.Root.Order.OrderLines.OrderLine;
							}
						}else{
							orderLine = jsonOrder.Root.Order.OrderLines.OrderLine[i];
						}
						var nobottom = null;
						if(!this.isNullObj(orderLine.CalculationCodes)){
							if(!this.isNullObj(orderLine.CalculationCodes.CalculationCode)){
								nobottom = 'th_align_left_no_bottom';
							}
						}
						if(!this.isNullObj(nobottom)){
							document.getElementById('SingleShipment_rowHeader_product'+i).setAttribute('class', document.getElementById('SingleShipment_rowHeader_product'+i).getAttribute('class')+nobottom);
							document.getElementById('SingleShipment_rowHeader_product'+i).setAttribute('className', document.getElementById('SingleShipment_rowHeader_product'+i).getAttribute('className')+nobottom);
							if(!this.isNullObj(document.getElementById('WC_OrderItemDetailsSummaryf_td_requestedShippingDate_'+i))){
								document.getElementById('WC_OrderItemDetailsSummaryf_td_requestedShippingDate_'+i).setAttribute('class', document.getElementById('WC_OrderItemDetailsSummaryf_td_requestedShippingDate_'+i).getAttribute('class')+nobottom);
								document.getElementById('WC_OrderItemDetailsSummaryf_td_requestedShippingDate_'+i).setAttribute('className', document.getElementById('WC_OrderItemDetailsSummaryf_td_requestedShippingDate_'+i).getAttribute('className')+nobottom);
							}
							document.getElementById('WC_OrderItemDetailsSummaryf_td_1_'+i).setAttribute('class', document.getElementById('WC_OrderItemDetailsSummaryf_td_1_'+i).getAttribute('class')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_1_'+i).setAttribute('className', document.getElementById('WC_OrderItemDetailsSummaryf_td_1_'+i).getAttribute('className')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_2_'+i).setAttribute('class', document.getElementById('WC_OrderItemDetailsSummaryf_td_2_'+i).getAttribute('class')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_2_'+i).setAttribute('className', document.getElementById('WC_OrderItemDetailsSummaryf_td_2_'+i).getAttribute('className')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_3_'+i).setAttribute('class', document.getElementById('WC_OrderItemDetailsSummaryf_td_3_'+i).getAttribute('class')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_3_'+i).setAttribute('className', document.getElementById('WC_OrderItemDetailsSummaryf_td_3_'+i).getAttribute('className')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_4_'+i).setAttribute('class', document.getElementById('WC_OrderItemDetailsSummaryf_td_4_'+i).getAttribute('class')+nobottom);
							document.getElementById('WC_OrderItemDetailsSummaryf_td_4_'+i).setAttribute('className', document.getElementById('WC_OrderItemDetailsSummaryf_td_4_'+i).getAttribute('className')+nobottom);
						}
						//catalog entry info
						var catEntryName = null;
						var thumbNail = null;
						var objectPath = null;
						var itemID = null;
						if(!this.isNullObj(orderLine.Item.CatalogEntry)){
							if(!this.isNullObj(orderLine.Item.CatalogEntry.objectPath)){
								objectPath = orderLine.Item.CatalogEntry.objectPath;
							}
							if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription)){
								if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription.catalogEntryName)){
									catEntryName = orderLine.Item.CatalogEntry.CatalogEntryDescription.catalogEntryName;
								}
								if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail)){
									thumbNail = orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail;
								}
							}
						}
						if(!this.isNullObj(orderLine.Item.ItemID)){
							itemID = orderLine.Item.ItemID;
						}

						if(!this.isNullObj(thumbNail)){
							thumbNail = this.revertAllSpecialChars(thumbNail);
							if(!this.isNullObj(objectPath)){
								objectPath = this.revertAllSpecialChars(objectPath);
								document.getElementById('Product_Thumbnail_'+i).setAttribute('src', objectPath+thumbNail);
							}else {
								document.getElementById('Product_Thumbnail_'+i).setAttribute('src', thumbNail);
							}

						}else{
							document.getElementById('Product_Thumbnail_'+i).setAttribute('src', imgDir+'images/NoImageIcon_sm.jpg');
						}
						if(!this.isNullObj(catEntryName)){
							document.getElementById('SingleShipment_rowHeader_product'+i).setAttribute('abbr', document.getElementById('SingleShipment_rowHeader_product'+i).getAttribute('abbr')+catEntryName);
							document.getElementById('Product_Thumbnail_'+i).setAttribute('alt',	catEntryName);
							document.getElementById('Catalog_Entry_Name_'+i).innerHTML = catEntryName;
						}
						if(!this.isNullObj(itemID)){
							document.getElementById('Catalog_Entry_SKU_'+i).innerHTML = itemID;
						}

						//Defining attributes
						if(!this.isNullObj(orderLine.Item.CatalogEntry)){
							if(!this.isNullObj(orderLine.Item.CatalogEntry.catalogEntryAttributes)){
								document.getElementById('Catalog_Entry_Defining_Attributes_'+i).style.display = 'inline';
								for(var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute){
									document.getElementById('Catalog_Entry_Defining_Attributes_'+i).innerHTML = document.getElementById('Catalog_Entry_Defining_Attributes_'+i).innerHTML + orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute[dAttr].catalogEntryAttrName + ':'+ orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute[dAttr].catalogEntryAttrValue + '<br/>';
								}
							}
						}

						//Component names for DK
						if(!this.isNullObj(orderLine.componentNames)){
							var dkLabel = document.getElementById('Dynamic_Kit_Components_Label_'+i);
							if(!this.isNullObj(dkLabel)){
								document.getElementById('Dynamic_Kit_Components_Label_'+i).style.display = 'inline';
							}

							var ulForDK = document.getElementById('Dynamic_Kit_Components_'+i);
							if(!this.isNullObj(ulForDK)){
								var compNames = orderLine.componentNames.split(',');
								for(var j in compNames){
									var li = document.createElement('li');
									li.innerHTML = compNames[j];
									ulForDK.appendChild(li);
								}
							}
						}

						//request ship date
						if(!this.isNullObj(document.getElementById('Order_Item_Requested_Ship_Date_'+i))){
							if(!this.isNullObj(orderLine.ReqShipDate)){
								var parsedReqShipDate = new Date(orderLine.ReqShipDate);
								document.getElementById('Order_Item_Requested_Ship_Date_'+i).innerHTML = Globalize.formatDate(parsedReqShipDate, {date: "long"});
							}
						}

						//order line status
						if(!this.isNullObj(orderLine.MaxLineStatus)){
							document.getElementById('Order_Item_Status_'+i).innerHTML = Utils.getLocalizationMessage("ORDER_LINE_STATUS_"+orderLine.MaxLineStatus);
						}

						//quantity
						if(!this.isNullObj(orderLine.OrderedQty)){
							document.getElementById('Order_Item_Quantity_'+i).innerHTML = Utils.formatNumber(orderLine.OrderedQty,{
								minimumFractionDigits:0,
								maximumFractionDigits:0
							});
						}

						var currencyCode = 'USD';
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency)){
							currencyCode = jsonOrder.Root.Order.PriceInfo.Currency;
						}

						var currencyDecimals = 2;
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal)){
							currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal;
						}

						var currencySymbol = '$'
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol)){
							currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol;
						}

						//unit price
						if(!this.isNullObj(orderLine.LinePriceInfo.UnitPrice)){
							document.getElementById('Order_Item_Unit_Price_'+i).innerHTML = this.formatCurrency(orderLine.LinePriceInfo.UnitPrice, currencyDecimals, currencySymbol, currencyCode, locale);
						}

						//total price
						var isFree = false;
						if(!this.isNullObj(orderLine.Awards)){
							if(!this.isNullObj(orderLine.Awards.Award)){
								if(!this.isNullObj(orderLine.Awards.Award.AwardType)){
									if(orderLine.Awards.Award.AwardType == 'FreeGift'){
										isFree = true;
									}
								}else if(!this.isNullObj(orderLine.Awards.Award[0])){
									for(var award in orderLine.Awards.Award){
										if(orderLine.Awards.Award[award].AwardType == 'FreeGift'){
											isFree = true;
											break;
										}
									}
								}
							}
						}
						if(isFree == true){
							document.getElementById('Order_Item_Total_Price_Free_'+i).style.display = 'inline';
							document.getElementById('Order_Item_Total_Price_'+i).style.display = 'none';
						}else{
							document.getElementById('Order_Item_Total_Price_Free_'+i).style.display = 'none';
							document.getElementById('Order_Item_Total_Price_'+i).style.display = 'inline';
							if(!this.isNullObj(orderLine.ComputedPrice.ExtendedPrice)){
								document.getElementById('Order_Item_Total_Price_'+i).innerHTML = this.formatCurrency(orderLine.ComputedPrice.ExtendedPrice, currencyDecimals, currencySymbol, currencyCode, locale);
							}
						}

						//promotion info
						if(!this.isNullObj(orderLine.CalculationCodes)){

							var counter = 0;
							for(var j in orderLine.CalculationCodes.CalculationCode){
								//if(calCode.displayLevel == 0){
									var calCode = orderLine.CalculationCodes.CalculationCode[j];
									var code = calCode.code;
									code = this.revertAllSpecialChars(code);
									var tr = document.createElement('tr');

									parentTable.insertBefore(tr, document.getElementById('Product_Line_'+(parseInt(i)+1)));

									var th = document.createElement('th');
									th.setAttribute('colSpan', '4');
									//For firefox and other browsers
									th.setAttribute('class', 'th_align_left_dotted_top_solid_bottom');
									//For IE
									th.setAttribute('className', 'th_align_left_dotted_top_solid_bottom');
									var abbrText = document.getElementById('Product_Discount_Text').innerHTML;
									th.setAttribute('abbr', abbrText+catEntryName);
									th.setAttribute('id', 'SingleShipment_rowHeader_discount'+i+'_'+counter);
									tr.appendChild(th);

									var div = document.createElement('div');
									div.setAttribute('id', 'WC_OrderItemDetailsSummaryf_div_3_'+i+'_'+counter);
									div.setAttribute('class', 'itemspecs');
									div.setAttribute('className', 'itemspecs');
									th.appendChild(div);

									var a = document.createElement('a');
									a.setAttribute('class', 'discount hover_underline');
									a.setAttribute('className', 'discount hover_underline');
									a.setAttribute('id', 'WC_OrderItemDetails_Link_ItemDiscount_1_'+i+'_'+counter);

									var url_innerHTML = document.getElementById('Promotion_Url').innerHTML;
									if(!this.isNullObj(url_innerHTML)){
										url_innerHTML = url_innerHTML.replace(/&amp;/g, "&");
									}
									var promotionUrl = url_innerHTML + '&code='+ encodeURIComponent(code);
									a.setAttribute('href', promotionUrl);
									div.appendChild(a);

									var img = document.createElement('img');
									img.setAttribute('src', imgDir+'images/empty.gif');
									img.setAttribute('alt', abbrText+catEntryName);
									a.appendChild(img);
									if(!this.isNullObj(calCode.calculationCodeDescription)){
										var calCodeDesc = this.revertAllSpecialChars(calCode.calculationCodeDescription);
										a.appendChild(document.createTextNode(calCodeDesc));
									}

									var td = document.createElement('td');
									td.setAttribute('class', 'th_align_left_dotted_top_solid_bottom total');
									td.setAttribute('className', 'th_align_left_dotted_top_solid_bottom total');
									td.appendChild(document.createTextNode(' '))
									tr.appendChild(td);

									var td1 = document.createElement('td');
									td1.setAttribute('class', 'th_align_left_dotted_top_solid_bottom total');
									td1.setAttribute('className', 'th_align_left_dotted_top_solid_bottom total');
									td1.setAttribute('id', 'WC_OrderItemDetailsSummaryf_td_5_'+i+'_'+counter);
									td1.setAttribute('headers', 'SingleShipment_rowHeader_discount'+i+'_'+counter);
									td1.appendChild(document.createTextNode(this.formatCurrency(calCode.TotalAmount, currencyDecimals, currencySymbol, currencyCode, locale)));
									tr.appendChild(td1);

									counter++;
								//}
							}
						}

					}
				},

				/**
				* populateOrderLineInfoForMultipleShipment This function populates the order line level information for the order
				* retrieved from Sterling in history order details page with multiple shipment layout.
				*
				* @param {String} orderStr The json string for complete order information.
				* @param {Integer} beginIndex The begin index of the current order items page.
				* @param {Integer} pageSize The page size of the current order items page.
				*
				**/
				populateOrderLineInfoForMultipleShipment: function(orderStr, beginIndex, pageSize){
					//orderStr = escape(orderStr);
					var jsonOrder = eval("("+orderStr+")");
					var imgDir = document.getElementById('Image_Dir').innerHTML;
					var locale = document.getElementById('Locale_String_M').innerHTML;
					var endIndex = document.getElementById('endIndex').innerHTML;
					var orderLineNum = 1;
					if(!this.isNullObj(jsonOrder.Root.Order.countOfOrderLines)){
						orderLineNum = jsonOrder.Root.Order.countOfOrderLines;
					}

					if(document.getElementById('order_details').childNodes[0].tagName == 'TBODY'){
						var parentTable = document.getElementById('order_details').childNodes[0];
					}else if(document.getElementById('order_details').childNodes[1].tagName == 'TBODY'){
						var parentTable = document.getElementById('order_details').childNodes[1];
					}
					for(var i=beginIndex; i<endIndex; i++){
						var orderLine = null;
						if(orderLineNum == 1){
							if(!this.isNullObj(jsonOrder.Root.Order.OrderLines.OrderLine[0])){
							    orderLine = jsonOrder.Root.Order.OrderLines.OrderLine[0];
							} else {
							    orderLine = jsonOrder.Root.Order.OrderLines.OrderLine;
							}
						}else{
							orderLine = jsonOrder.Root.Order.OrderLines.OrderLine[i];
						}

						var nobottom = null;
						if(!this.isNullObj(orderLine.CalculationCodes)){
							if(!this.isNullObj(orderLine.CalculationCodes.CalculationCode)){
								nobottom = 'th_align_left_no_bottom';
							}
						}
						if(!this.isNullObj(nobottom)){
							document.getElementById('MultipleShipping_rowHeader_product'+i).setAttribute('class', nobottom+document.getElementById('MultipleShipping_rowHeader_product'+i).getAttribute('class'));
							document.getElementById('MultipleShipping_rowHeader_product'+i).setAttribute('className', nobottom+document.getElementById('MultipleShipping_rowHeader_product'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_1_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_1_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_1_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_1_'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_2_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_2_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_2_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_2_'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_3_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_3_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_3_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_3_'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_4_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_4_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_4_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_4_'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_5_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_5_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_5_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_5_'+i).getAttribute('className'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_6_'+i).setAttribute('class', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_6_'+i).getAttribute('class'));
							document.getElementById('WC_MSOrderItemDetailsSummaryf_td_6_'+i).setAttribute('className', nobottom+document.getElementById('WC_MSOrderItemDetailsSummaryf_td_6_'+i).getAttribute('className'));
						}
						//catalog entry info
						var catEntryName = null;
						var thumbNail = null;
						var objectPath = null;
						var itemID = null;
						if(!this.isNullObj(orderLine.Item.CatalogEntry)){
							if(!this.isNullObj(orderLine.Item.CatalogEntry.objectPath)){
								objectPath = orderLine.Item.CatalogEntry.objectPath;
							}
							if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription)){
								if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription.catalogEntryName)){
									catEntryName = orderLine.Item.CatalogEntry.CatalogEntryDescription.catalogEntryName;
								}
								if(!this.isNullObj(orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail)){
									thumbNail = orderLine.Item.CatalogEntry.CatalogEntryDescription.thumbNail;
								}
							}
						}
						if(!this.isNullObj(orderLine.Item.ItemID)){
							itemID = orderLine.Item.ItemID;
						}
						if(!this.isNullObj(thumbNail)){
							thumbNail = this.revertAllSpecialChars(thumbNail);
							if(!this.isNullObj(objectPath)){
								objectPath = this.revertAllSpecialChars(objectPath);
								document.getElementById('Product_Thumbnail_'+i).setAttribute('src', objectPath+thumbNail);
							}else {
								document.getElementById('Product_Thumbnail_'+i).setAttribute('src', thumbNail);
							}

						}else{
							document.getElementById('Product_Thumbnail_'+i).setAttribute('src', imgDir+'images/NoImageIcon_sm.jpg');
						}
						if(!this.isNullObj(catEntryName)){
							document.getElementById('MultipleShipping_rowHeader_product'+i).setAttribute('abbr', document.getElementById('MultipleShipping_rowHeader_product'+i).getAttribute('abbr')+catEntryName);
							document.getElementById('Product_Thumbnail_'+i).setAttribute('alt',	catEntryName);
							document.getElementById('Catalog_Entry_Name_'+i).innerHTML = catEntryName;
						}
						if(!this.isNullObj(itemID)){
							document.getElementById('Catalog_Entry_SKU_'+i).innerHTML = itemID;
						}

						//Defining attributes
						if(!this.isNullObj(orderLine.Item.CatalogEntry)){
							if(!this.isNullObj(orderLine.Item.CatalogEntry.catalogEntryAttributes)){
								document.getElementById('Catalog_Entry_Defining_Attributes_'+i).style.display = 'inline';
								for(var dAttr in orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute){
									document.getElementById('Catalog_Entry_Defining_Attributes_'+i).innerHTML = document.getElementById('Catalog_Entry_Defining_Attributes_'+i).innerHTML + orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute[dAttr].catalogEntryAttrName + ':'+ orderLine.Item.CatalogEntry.catalogEntryAttributes.catalogEntryAttribute[dAttr].catalogEntryAttrValue + '<br/>';
								}
							}
						}

						//Component names for DK
						if(!this.isNullObj(orderLine.componentNames)){
							var dkLabel = document.getElementById('Dynamic_Kit_Components_Label_'+i);
							if(!this.isNullObj(dkLabel)){
								document.getElementById('Dynamic_Kit_Components_Label_'+i).style.display = 'inline';
							}

							var ulForDK = document.getElementById('Dynamic_Kit_Components_'+i);
							if(!this.isNullObj(ulForDK)){
								var compNames = orderLine.componentNames.split(',');
								for(var j in compNames){
									var li = document.createElement('li');
									li.innerHTML = compNames[j];
									ulForDK.appendChild(li);
								}
							}
						}

						//Shipping address
						if(!this.isNullObj(orderLine.PersonInfoShipTo)){
							this.populateAddress(orderLine.PersonInfoShipTo, 'WC_MSOrderItemDetailsSummaryf_div_3_'+i, locale);
						}else if(!this.isNullObj(jsonOrder.Root.Order.PersonInfoShipTo)){
							this.populateAddress(jsonOrder.Root.Order.PersonInfoShipTo, 'WC_MSOrderItemDetailsSummaryf_div_3_'+i, locale);
						}

						//Shipping method
						var shippingMethod = null;
						if(!this.isNullObj(orderLine.ShipmentLines.ShipmentLine)){
							var shipmentKey = null;
							if(!this.isNullObj(orderLine.ShipmentLines.ShipmentLine.ShipmentKey)){
								shipmentKey = orderLine.ShipmentLines.ShipmentLine.ShipmentKey;
							}else if(!this.isNullObj(orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey)){
								shipmentKey = orderLine.ShipmentLines.ShipmentLine[0].ShipmentKey;
							}
							if(!this.isNullObj(shipmentKey)){
							if(!this.isNullObj(jsonOrder.Root.Order.Shipments)){
								if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment)){
									if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey)){
										if(jsonOrder.Root.Order.Shipments.Shipment.ShipmentKey == shipmentKey){
											if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription)){
												shippingMethod = jsonOrder.Root.Order.Shipments.Shipment.shipModeDescription;
											}
										}
									}else if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[0])){
										for(var s in jsonOrder.Root.Order.Shipments.Shipment){
											if(jsonOrder.Root.Order.Shipments.Shipment[s].ShipmentKey == shipmentKey){
												if(!this.isNullObj(jsonOrder.Root.Order.Shipments.Shipment[s].shipModeDescription)){
													shippingMethod = jsonOrder.Root.Order.Shipments.Shipment[s].shipModeDescription;
												}
												break;
											}
										}
									}
								}
							  }
							}
						}
						if(this.isNullObj(shippingMethod)){
							if(!this.isNullObj(orderLine.shipModeDescription)){
								shippingMethod = orderLine.shipModeDescription;
							}else if(!this.isNullObj(jsonOrder.Root.Order.shipModeDescription)){
								shippingMethod = jsonOrder.Root.Order.shipModeDescription;
							}
						}
						if(!this.isNullObj(shippingMethod)){
							document.getElementById('Shipping_Mode_Description_'+i).innerHTML = shippingMethod;
						}

						var isFree = false;
						if(!this.isNullObj(orderLine.Awards)){
							if(!this.isNullObj(orderLine.Awards.Award)){
								if(!this.isNullObj(orderLine.Awards.Award.AwardType)){
									if(orderLine.Awards.Award.AwardType == 'FreeGift'){
										isFree = true;
									}
								}else if(!this.isNullObj(orderLine.Awards.Award[0])){
									for(var award in orderLine.Awards.Award){
										if(orderLine.Awards.Award[award].AwardType == 'FreeGift'){
											isFree = true;
											break;
										}
									}
								}
							}
						}

						if(isFree == false){
							if(!this.isNullObj(document.getElementById('Shipping_Instruction_'+i))){
								//shipping instruction
								if(!this.isNullObj(orderLine.Instructions)){
									var instructions = orderLine.Instructions;
									if(!this.isNullObj(instructions.Instruction)){
										var instruction = instructions.Instruction;
										if(!this.isNullObj(instruction.InstructionType)){
											if(instruction.InstructionType=='SHIP'){
												if(!this.isNullObj(instruction.InstructionText)){
													document.getElementById('Shipping_Instruction_Label_'+i).style.display = 'inline';
													document.getElementById('Shipping_Instruction_'+i).innerHTML = instruction.InstructionText;
												}
											}
										}else if(!this.isNullObj(instructions.Instruction[0])){
											//more than one instruction
											for(var k in instructions.Instruction){
												if(!this.isNullObj(instructions.Instruction[k].InstructionType)){
													if(instructions.Instruction[k].InstructionType=='SHIP'){
														if(!this.isNullObj(instructions.Instruction[k].InstructionText)){
															document.getElementById('Shipping_Instruction_Label_'+i).style.display = 'inline';
															document.getElementById('Shipping_Instruction_'+i).innerHTML = document.getElementById('Shipping_Instruction_'+i).innerHTML + instructions.Instruction[k].InstructionText+'<br/>';
														}
													}
												}
											}
										}
									}else{
										//no instruction
									}
								}//no instructions
							}

							if(!this.isNullObj(document.getElementById('Order_Item_Requested_Ship_Date_'+i))){
								//request ship date
								if(!this.isNullObj(orderLine.ReqShipDate)){
									document.getElementById('Requested_Shipping_Date_Label_'+i).style.display = 'inline';
									var parsedReqShipDate = new Date(orderLine.ReqShipDate);
									document.getElementById('Order_Item_Requested_Ship_Date_'+i).innerHTML = Globalize.formatDate(parsedReqShipDate, {date: "long"});
								}
							}
						}

						//order line status
						if(!this.isNullObj(orderLine.MaxLineStatus)){
							//document.getElementById('Order_Item_Status_'+i).innerHTML = orderLine.Status;
							document.getElementById('Order_Item_Status_'+i).innerHTML = Utils.getLocalizationMessage('ORDER_LINE_STATUS_'+orderLine.MaxLineStatus);
						}

						//quantity
						if(!this.isNullObj(orderLine.OrderedQty)){
							document.getElementById('Order_Item_Quantity_'+i).innerHTML = Utils.formatNumber(orderLine.OrderedQty,{
								minimumFractionDigits:0,
								maximumFractionDigits:0
							});
						}

						var currencyCode = 'USD';
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.Currency)){
							currencyCode = jsonOrder.Root.Order.PriceInfo.Currency;
						}

						var currencyDecimals = 2;
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencyDecimal)){
							currencyDecimals = jsonOrder.Root.Order.PriceInfo.currencyDecimal;
						}

						var currencySymbol = '$'
						if(!this.isNullObj(jsonOrder.Root.Order.PriceInfo.currencySymbol)){
							currencySymbol = jsonOrder.Root.Order.PriceInfo.currencySymbol;
						}

						//unit price
						if(!this.isNullObj(orderLine.LinePriceInfo.UnitPrice)){
							document.getElementById('Order_Item_Unit_Price_'+i).innerHTML = this.formatCurrency(orderLine.LinePriceInfo.UnitPrice, currencyDecimals, currencySymbol, currencyCode, locale);
						}

						//total price
						if(isFree == true){
							document.getElementById('Order_Item_Total_Price_Free_'+i).style.display = 'inline';
							document.getElementById('Order_Item_Total_Price_'+i).style.display = 'none';
						}else{
							document.getElementById('Order_Item_Total_Price_Free_'+i).style.display = 'none';
							document.getElementById('Order_Item_Total_Price_'+i).style.display = 'inline';
							if(!this.isNullObj(orderLine.ComputedPrice.ExtendedPrice)){
								document.getElementById('Order_Item_Total_Price_'+i).innerHTML = this.formatCurrency(orderLine.ComputedPrice.ExtendedPrice, currencyDecimals, currencySymbol, currencyCode, locale);
							}
						}

						//promotion info
						if(!this.isNullObj(orderLine.CalculationCodes)){

							var counter = 0;
							for(var j in orderLine.CalculationCodes.CalculationCode){
									var calCode = orderLine.CalculationCodes.CalculationCode[j];
									var code = calCode.code;
									code = this.revertAllSpecialChars(code);
									var tr = document.createElement('tr');
									parentTable.insertBefore(tr, document.getElementById('Product_Line_'+(parseInt(i)+1)));

									var th = document.createElement('th');
									th.setAttribute('colSpan', '5');
									th.setAttribute('class', 'th_align_left_dotted_top_solid_bottom');
									th.setAttribute('className', 'th_align_left_dotted_top_solid_bottom');
									var abbrText = document.getElementById('Product_Discount_Text').innerHTML;
									th.setAttribute('abbr', abbrText+catEntryName);
									th.setAttribute('id', 'MultipleShipment_rowHeader_discount'+i+'_'+counter);
									tr.appendChild(th);

									var div = document.createElement('div');
									div.setAttribute('id', 'WC_MSOrderItemDetailsSummaryf_div_5_'+i+'_'+counter);
									div.setAttribute('class', 'itemspecs');
									div.setAttribute('className', 'itemspecs');
									th.appendChild(div);

									var a = document.createElement('a');
									a.setAttribute('class', 'discount');
									a.setAttribute('className', 'discount');
									a.setAttribute('id', 'WC_OrderItemDetails_Link_ItemDiscount_1_'+i+'_'+counter);

									var url_innerHTML = document.getElementById('Promotion_Url').innerHTML;
									if(!this.isNullObj(url_innerHTML)){
										url_innerHTML = url_innerHTML.replace(/&amp;/g, "&");
									}
									var promotionUrl =  url_innerHTML + '&code='+ encodeURIComponent(code);

									a.setAttribute('href', promotionUrl);
									div.appendChild(a);

									var img = document.createElement('img');
									img.setAttribute('src', imgDir+'images/empty.gif');
									img.setAttribute('alt', abbrText+catEntryName);
									a.appendChild(img);
									if(!this.isNullObj(calCode.calculationCodeDescription)){
										var calCodeDesc = this.revertAllSpecialChars(calCode.calculationCodeDescription);
										a.appendChild(document.createTextNode(calCodeDesc));
									}

									var td = document.createElement('td');
									td.setAttribute('class', 'th_align_left_dotted_top_solid_bottom total');
									td.setAttribute('className', 'th_align_left_dotted_top_solid_bottom total');
									td.appendChild(document.createTextNode(' '))
									tr.appendChild(td);

									var td1 = document.createElement('td');
									td1.setAttribute('class', 'th_align_left_dotted_top_solid_bottom total');
									td1.setAttribute('className', 'th_align_left_dotted_top_solid_bottom total');
									td1.setAttribute('id', 'WC_MSOrderItemDetailsSummaryf_td_7_'+i+'_'+counter);
									td1.setAttribute('headers', 'MultipleShipment_rowHeader_discount'+i+'_'+counter);
									td1.appendChild(document.createTextNode(this.formatCurrency(calCode.TotalAmount, currencyDecimals, currencySymbol, currencyCode, locale)));
									tr.appendChild(td1);

									counter++;
							}
						}

					}
				},

				/**
				 * This function sets the url for ssfs order copy service and then it invokes the service to copy the old order.
				 * @param {string} OrderCancelURL The url for the ssfs order copy service.
				 * @param {string} orderHeaderKeyBeingCanceled The order header key of the order being canceled.
				 */
				cancelOrder:function(OrderCancelURL, orderHeaderKeyBeingCanceled){

					/*For Handling multiple clicks. */
					if(!submitRequest()){
						return;
					}
					cursor_wait();
					this.orderBeingCanceled = orderHeaderKeyBeingCanceled;
					wcService.getServiceById("CancelExternalOrder").setUrl(OrderCancelURL);
					wcService.invoke("CancelExternalOrder");
				}

}

/**
 *  This service enables customer to Cancel an existing order on the external system.
 *  @constructor
 */
wcService.declare({
	id: "CancelExternalOrder",
	actionId: "CancelExternalOrder",
	url: "AJAXProcessExternalOrder",
	formId: ""

	 /**
	  *  This method updates the order table with the
	  *  @param (object) serviceResponse The service response object, which is the
	  *  JSON object returned by the service invocation.
	  */
	,successHandler: function(serviceResponse) {
		for (var prop in serviceResponse) {
			console.debug(prop + "=" + serviceResponse[prop]);
		}
		//change the status to canceled.
		var idToLookFor = "OrderDetails_status_span_" + sterlingIntegrationJS.orderBeingCanceled;
		var $element = $("#" + idToLookFor);
		if($element.length){
			$element.html(MessageHelper.messages["MO_OrderStatus_X"]);
		}

		//Hide the cancel button
		idToLookFor = "OrderDetails_cancelButton_" + sterlingIntegrationJS.orderBeingCanceled;
		var $element = $("#" + idToLookFor);
		if($element.length){
			$element.css('display', 'none');
			$element.css('visibility', 'hidden');
		}

		//Show canceled message.
		MessageHelper.hideAndClearMessage();
		cursor_clear();
		MessageHelper.displayStatusMessage(MessageHelper.messages["MO_ORDER_CANCELED_MSG"]);
	}

	/**
	* display an error message.
	* @param (object) serviceResponse The service response object, which is the
	* JSON object returned by the service invocation.
	*/
	,failureHandler: function(serviceResponse) {
		for (var prop in serviceResponse) {
			console.debug(prop + "=" + serviceResponse[prop]);
		}

		if (serviceResponse.errorMessage) {
			MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
		}
		else {
			 if (serviceResponse.errorMessageKey) {
				MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
			 }
		}
		cursor_clear();
	}

})
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

var toggleCollapsible = function(collapsible) {
	var content = collapsible.querySelector(".content");
	var expanded = $(collapsible).attr("aria-expanded");
	var mainESpotHome = document.getElementById("mainESpotHome");
	(content.id.match(/homeESpotDetails/)) ? ((mainESpotHome.className == "closed") ? mainESpotHome.className = "expand" : mainESpotHome.className = "closed") : 0;
	if (expanded == "true") {
		window.setTimeout(function() {
			$(collapsible).attr("aria-expanded", "false");
			$(content).css("transition", "max-height .2s");
		}, 0);
		window.setTimeout(function() {
			$(content).css("transition", null);
		}, 200);
		window.setTimeout(function() {
			$(content).css("display", "none");
		}, 300);
	} else if (expanded == "false") {
		$(collapsible).attr("aria-expanded", "true");
		$(content).css("transition", "max-height .2s");
		window.setTimeout(function() {
			$(content).css("transition", null);
		}, 200);
		window.setTimeout(function() {
			$(content).css("display", "block");
		}, 300);
	}
};

var updateGrid = function(i, grid) {
	var width = grid.clientWidth;
	var minColWidth = $(grid).attr("data-min-col-width");
	var minColCount = $(grid).attr("data-min-col-count");
	var colCount = Math.floor(width/minColWidth);
	if (colCount < minColCount) {
		colCount = minColCount;
	}
	var colWidth = Math.floor(100/colCount) + "%";
    $(".col", grid).css("width", colWidth);
};

var toggleExpandNav = function(id) {
	var icon = byId("icon_" + id);
	var section_list = byId("section_list_" + id);
	if(icon.className == "arrow") {
		icon.className = "arrow arrow_collapsed";
		$(section_list).attr("aria-expanded", "false");
		$(section_list).css("display", "none");
	} else {
		icon.className = "arrow";
		$(section_list).attr("aria-expanded", "true");
		$(section_list).css("display", "block");
	}
};

$(document).ready(function() {
    var updateCollapsibles = function(mediaQuery) {
        var expanded = mediaQuery ? !mediaQuery.matches : document.documentElement.clientWidth > 583;
        if (expanded == false){
            $(".collapsible").attr("aria-expanded", expanded.toString());
        }else {
            $(".collapsible:not(.collapsedOnInit)").attr("aria-expanded", expanded.toString());
        }
    };
    if (window.matchMedia) {
        var mediaQuery = window.matchMedia("(max-width: 600px)");
        updateCollapsibles(mediaQuery);
        mediaQuery.addListener(updateCollapsibles);
    }
    else {
        updateCollapsibles();

        $(window).on("resize", function(event) {
            updateCollapsibles();
        });
    }

    Utils.onOnce($(document), "click", "collapsible", ".collapsible .toggle", function(event) {
        toggleCollapsible($(event.target).parents(".collapsible")[0]);
        event.preventDefault();
    });
    Utils.onOnce($(document), "keydown", "collapsible", ".collapsible .toggle", function(event) {
        if (event.keyCode === KeyCodes.RETURN || event.keyCode === KeyCodes.SPACE) {
            toggleCollapsible($(event.target).parents(".collapsible")[0]);
            event.preventDefault();
        }
    });

    $(".grid").each(updateGrid);

    $(window).on("resize", function(event) {
        $(".grid").each(updateGrid);
    });
});


;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2012, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file contains all the global variables and JavaScript functions needed by the compare product page and the compare zone.
 */

if(typeof(CompareProductJS) == "undefined" || CompareProductJS == null || !CompareProductJS) {

	/**
	 * @class The functions defined in the class are used for comparing products.
	 *
	 * This CompareProductJS class defines all the variables and functions for the page that uses the comparison functionality in the store.
	 * The compare accepts a maximum of 4 products to compare.
	 * The compare product display page compares various products' attributes side-by-side.
	 *
	 */
	CompareProductJS = {
		/**
		 * Object to store langId, storeId and catalogId of the store.
		 */
		params: [],

		/**
		* The compareReturnName is a string to store the current name of the category from where the compare link was clicked
		*/
		compareReturnName: "",

		/**
		* The returnUrl is a string to store the url of the category from where the compare link was clicked
		*/
		returnUrl: "",

		/**
		 * The prefix of the cookie key that is used to store item Ids.
		 */
		cookieKeyPrefix: "CompareItems_",

		/**
		 * The delimiter used to separate item Ids in the cookie.
		 */
		cookieDelimiter: ";",

		/**
		 * The maximum number of items allowed in the compare zone.
		 */
		maxNumberProductsAllowedToCompare: 4,

		/**
		 * Sets the common parameters used in all service calls like langId, storeId and catalogId.
		 * @param {String} langId The language Id.
		 * @param {String} storeId The store Id.
		 * @param {String} catalogId The catalog Id.
		 * @param {String} compareReturnName The return page name
		 * @param {String} returnUrl The url of the return page to go back
		 */
		setCommonParameters:function(langId,storeId,catalogId, compareReturnName, returnUrl){
			this.params.langId = langId;
			this.params.storeId = storeId;
			this.params.catalogId = catalogId;
			this.compareReturnName = compareReturnName;
			this.returnUrl = decodeURIComponent(returnUrl);
		},

		/**
		 * Removes an item from the products compare page.
		 * @param {String} key The Id of the item to remove.
		 */
		remove: function(key){
			var cookieKey = this.cookieKeyPrefix + this.params.storeId;
			var cookieValue = getCookie(cookieKey);
			if(cookieValue != null){
				if(cookieValue.trim() == ""){
					setCookie(cookieKey, null, {expires: -1});
				}else{
					var cookieArray = cookieValue.split(this.cookieDelimiter);
					var newCookieValue = "";
					for(index in cookieArray){
						if(cookieArray[index] != key){
							if(newCookieValue === ""){
								newCookieValue = cookieArray[index];
							}else{
								newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index]
							}
						}
					}
					setCookie(cookieKey, newCookieValue, {path:'/', domain:cookieDomain});
				}

				// Now remove this catentry from URL and re-submit it...
				//replace catentryId=[0-9;]*&? with the current set of catentryIds present in cookie...
				var cookieKey = this.cookieKeyPrefix + this.params.storeId;
				var cookieValue = getCookie(cookieKey);
				var tempURL = "";
				var tokens = document.URL.split('catentryId=');
				if (tokens.length == 2) {
					tempURL = tokens[0] + 'catentryId=' + cookieValue;
					var tokens2 = tokens[1].split('&');
					for (var i=0; i<tokens2.length; i++) {
						if (i > 0) {
							tempURL = tempURL + "&" + tokens[i];
						}
					}
				}
				var tempURL = tempURL.replace(/&&/, "&"); //we might end up with &&, when newCatentryIdsToCompare is empty..Handle this scenario...
				location.href = tempURL;
			}
		},

		/**
		 * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
		 */
		compareProducts:function(){
			var url = "CompareProductsDisplayView?storeId=" + this.params.storeId + "&catalogId=" + this.params.catalogId + "&langId=" + this.params.langId + "&compareReturnName=" + this.compareReturnName;

			var cookieKey = this.cookieKeyPrefix + this.params.storeId;
			var cookieValue = getCookie(cookieKey);
			if(cookieValue != null && cookieValue.trim() != ""){
				url = url + "&catentryId=" + cookieValue;
			}
			url = url + "&returnUrl=" + encodeURIComponent(this.returnUrl);
			location.href = getAbsoluteURL() + url;
		},

		/**
		* add2ShopCart Adds product to the shopping cart
		* @param {String} catEntryId The catalog entry Id.
		* @param {String} quantity The quantity.
		* @param {String} productId The product Id.
		**/
		add2ShopCart: function(catEntryId, quantity, productId){
			var shoppingParams = {
                storeId: WCParamJS.storeId,
                catalogId: WCParamJS.catalogId,
                langId: WCParamJS.langId,
                orderId: "."
            };
			// Remove calculations for performance
			// shoppingParams.calculationUsage = "-1,-2,-5,-6,-7";
			shoppingParams.calculateOrder="0";

			//Add the catalog entry to the cart.
			updateParamObject(shoppingParams,"catEntryId",catEntryId,false,-1);
			updateParamObject(shoppingParams,"quantity",quantity,false,-1);

			var shopCartService = "AddOrderItem";

			var skuAttributes = this.getSkuAttributes(catEntryId);
			if (skuAttributes == null) {
				skuAttributes = this.getSkuAttributes(productId);
			}

			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}
			cursor_wait();

			shoppingActionsJS.saveAddedProductInfo(quantity, productId, catEntryId, skuAttributes);
			wcService.invoke(shopCartService, shoppingParams);
		},

		/**
		 * Returns the SKU attributes from the skuAttributesJSON div.
		 * @param {String} catEntryId The catalog entry Id.
		 * @returns {Object} The object containing all of the attributes for the SKU.
		 **/
		getSkuAttributes : function(catEntryId)
		{
			var jsonDiv = null;
			var node = $("#SKUAttributesJSON_" + catEntryId);

			if (node && node != null && node != 'undefined') {
				jsonDiv = eval('('+ node.innerHTML +')');
			}

			if (jsonDiv != null && jsonDiv != 'undefined') {
				return jsonDiv;
			}

			return null;
		}
	}
};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2014 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------
/* global Utils, $, document, window, wc, setTimeout, cX, processAndSubmitForm, updateFormWithWcCommonRequestParameters, cursor_wait, cursor_clear */

// Declare functions/variables needed by the declareDeptDropdownRefreshArea function here
var updateDepartmentsMenu,
    activate,
    ajaxRefresh = "",

// We need this function to be global for Header_UI.jspf to call it
    setAjaxRefresh = function (refresh) {
        ajaxRefresh = refresh;
    };

$(document).ready(function () {
    var mouseDownRegistered = false,
        activeMenuNode = null,
        toggleControlNode = null,
        active = {},
        departmentMenuId = "departmentMenu_",
        registerMouseDown = function () {
            if (!mouseDownRegistered) {
                $(document.documentElement).on("mousedown.wc.header", handleMouseDown);
                mouseDownRegistered = true;
            }
        },
        unregisterMouseDown = function () {
            if (mouseDownRegistered) {
                $(document.documentElement).off("mousedown.wc.header");
                mouseDownRegistered = false;
            }
        },
        handleMouseDown = function (evt) {
            var node = evt.target;
            if (activeMenuNode !== null && node != document.documentElement) {
                var close = true;
                var parent = activeMenuNode.getAttribute("data-parent");
                while (node && node != document.documentElement) {
                    if (node == activeMenuNode || node == toggleControlNode || $(node).hasClass("dijitPopup") || parent == node.getAttribute("data-parent")) {
                        close = false;
                        break;
                    }
                    node = node.parentNode;
                }
                if (node === null) {
                    var children = $("div", activeMenuNode);
                    for (var i = 0; i < children.length; i++) {
                        var position = Utils.position(children[i]);
                        if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                            evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                            close = false;
                            break;
                        }
                    }
                }
                if (close) {
                    deactivate(activeMenuNode);
                }
            }
        },
        deactivate = function (target) {
            if (active[target.id]) {
                deactivate(active[target.id]);
            }
            $(target).removeClass("active");
            $("a[data-activate='" + target.id + "']").removeClass("selected");
            $("a[data-toggle='" + target.id + "']").removeClass("selected");
            var parent = target.getAttribute("data-parent");
            delete active[parent];
            if (target == activeMenuNode) {
                activeMenuNode = null;
                toggleControlNode = null;
                unregisterMouseDown();
            }
        },
        toggle = function (target) {
            if ($(target).hasClass("active")) {
                deactivate(target);
            } else {
                activate(target);
            }
        },
        setUpEventActions = function () {
            $(document).on("click", "a[data-activate]", function (e) {
                var target = this.getAttribute("data-activate");
                activate(document.getElementById(target));
                Utils.stopEvent(e);
            });
            $(document).on("click", "a[data-deactivate]", function (e) {
                var target = this.getAttribute("data-deactivate");
                deactivate(document.getElementById(target));
                Utils.stopEvent(e);
            });
            $(document).on("click", "a[data-toggle]", function (e) {
                var target = this.getAttribute("data-toggle");
                toggle(document.getElementById(target));
                Utils.stopEvent(e);
            });
            $(document).on("keydown", "a[data-toggle]", function (e) {
                var target;
                if (e.keyCode === 27) {
                    target = this.getAttribute("data-toggle");
                    deactivate(document.getElementById(target));
                    Utils.stopEvent(e);
                } else if (e.keyCode === 40) {
                    target = this.getAttribute("data-toggle");
                    var targetElem = document.getElementById(target);
                    activate(targetElem);
                    $('[class*="menuLink"]', targetElem)[0].focus();
                    Utils.stopEvent(e);
                }
            });

            var ie_version = Utils.get_IE_version();
            if (ie_version && ie_version < 10) {
                $("input[placeholder]").each(function (i, input) {
                    var placeholder = input.getAttribute("placeholder");
                    if (placeholder) {
                        var label = document.createElement("label");
                        label.className = "placeholder";
                        label.innerHTML = placeholder;
                        input.parentNode.insertBefore(label, input);
                        var updatePlaceholder = function () {
                            label.style.display = (input.value ? "none" : "block");
                        };
                        window.setTimeout(updatePlaceholder, 200);
                        $(input).on("blur focus keyup", updatePlaceholder);
                        $(label).click(function (e) {
                            input.focus();
                        });
                    }
                });
            }
        };

    activate = function (target) {
        var startsWith = (target.id.slice(0, departmentMenuId.length) == departmentMenuId);
        if (ajaxRefresh == "true" && startsWith) {
            setAjaxRefresh(""); // No more refresh till shopper leaves this page
            // Update the Context, so that widget gets refreshed..
            wcRenderContext.updateRenderContext("departmentSubMenuContext", {
                "targetId": target.id
            });
            if (typeof cX === 'function') {
                // For Coremetrics tagging to generate linkclick tags when clicking on navigation buttons
                setTimeout(function () {
                    cX("");
                }, 1000);
            }
            return;
        }

        var parent = target.getAttribute("data-parent");
        if (parent && active[parent]) {
            deactivate(active[parent]);
        }
        if (parent) {
            activate(document.getElementById(parent));
        }
        $(target).addClass("active");
        $("a[data-activate='" + target.id + "']").addClass("selected");
        var toggleControl = $("a[data-toggle='" + target.id + "']");
        toggleControl.addClass("selected");
        if (parent) {
            active[parent] = target;
            if (activeMenuNode === null) {
                activeMenuNode = target;
                toggleControlNode = toggleControl.length > 0 ? toggleControl[0] : null;
                registerMouseDown();
            }
        }
    };

    setUpEventActions();

    window.setTimeout(function () {
        var quickLinksBar = document.getElementById("quickLinksBar");
        var quickLinksButton = document.getElementById("quickLinksButton");
        var quickLinksMenu = document.getElementById("quickLinksMenu");
        var quickLinksMenuItems = $("> ul > li > a", quickLinksMenu);
        var signInOutQuickLink = document.getElementById("signInOutQuickLink");
        $("#quickLinksMenu > ul > li").each(function (i, li) {
            if (li.id != "facebookQuickLinkItem" && li.id != "globalLoginWidget") {
                li = li.cloneNode(true);
                $("[id]", li).each(function (j, node) {
                    node.id += "_alt";
                });
                quickLinksBar.insertBefore(li, quickLinksBar.firstChild);
            }
        });
        $("#quickLinksBar > li > a, #quickLinksBar > li > span").each(function (i, node) {
            if (node.id != "miniCartButton" && node.id != "barcodeScanButton" && node.id.indexOf("signOutQuickLink") === -1 && node.id != "contactQuickLink_alt") {
                var s = $.trim(node.innerHTML);
                var it = node.childNodes;
                //find the first non-blank text node (type=3)
                for (i = 0; i < it.length; i++) {
                    if (it[i].nodeType === 3 && $.trim(it[i].nodeValue) !== "") {
                        s = $.trim(it[i].nodeValue);
                        break;
                    }
                }
                var n = s.lastIndexOf(",");
                if (n === -1) {
                    n = s.lastIndexOf(" ");
                }
                if (n != -1) {
                    var sBr = s.substring(0, n + 1) + "<br/>" + s.substring(n + 1, s.length);
                    node.innerHTML = node.innerHTML.replace(s, sBr);
                }
            }
        });
        $(quickLinksButton).click(function (e) {
            var target = this.getAttribute("data-toggle");
            toggle(document.getElementById(target));
            Utils.stopEvent(e);
        });
        $(quickLinksButton).keydown(function (e) {
            var target;
            if (e.keyCode === 40) {
                target = this.getAttribute("data-toggle");
                activate(document.getElementById(target));
                quickLinksMenuItems[0].focus();
                Utils.stopEvent(e);
            } else if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                deactivate(quickLinksMenu);
            } else if (e.keyCode === 27) {
                target = this.getAttribute("data-toggle");
                deactivate(document.getElementById(target));
                Utils.stopEvent(e);
            }
        });
        $(quickLinksMenu).keydown(function (e) {
            if (e.keyCode === 27 || e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                deactivate(quickLinksMenu);
            } else if (e.keyCode === 27) {
                var target = this.getAttribute("data-toggle");
                deactivate(document.getElementById(target));
                Utils.stopEvent(e);
            }
        });
        quickLinksMenuItems.each(function (i, quickLinksMenuItem) {
            quickLinksMenuItem.setAttribute("role", "menuitem");
            quickLinksMenuItem.setAttribute("tabindex", "-1");
            $(quickLinksMenuItem).keydown(function (e) {
                switch (e.keyCode) {
                case 38:
                    quickLinksMenuItems[i === 0 ? quickLinksMenuItems.length - 1 : i - 1].focus();
                    Utils.stopEvent(e);
                    break;
                case 40:
                    quickLinksMenuItems[(i + 1) % quickLinksMenuItems.length].focus();
                    Utils.stopEvent(e);
                    break;
                }
            });
        });
        var searchFilterButton = document.getElementById("searchFilterButton");
        if (searchFilterButton) {
            $(searchFilterButton).keydown(function (e) {
                if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                    deactivate(document.getElementById(searchFilterButton.getAttribute("data-toggle")));
                }
            });
        }
        var searchForm = document.getElementById("SimpleSearchForm_SearchTerm");
        if (searchForm) {
            $(searchForm).click(function (e) {
                $('.selected:not(a[data-toggle="searchBar"])', document.getElementById("header")).each(function (i, selectedDataToggle) {
                    deactivate(document.getElementById(selectedDataToggle.getAttribute("data-toggle")));
                });
            });
        }
        var searchFilterMenu = document.getElementById("searchFilterMenu");
        if (searchFilterMenu) {
            $('[class*="menuLink"]', searchFilterMenu).each(function (i, searchFilterMenuItems) {
                $(searchFilterMenuItems).keydown(function (e) {
                    if (e.keyCode === 27) {
                        deactivate(searchFilterMenu);
                        Utils.stopEvent(e);
                    } else if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                        deactivate(searchFilterMenu);
                    } else if (e.keyCode === 38) {
                        searchFilterMenuItems[i === 0 ? searchFilterMenuItems.length - 1 : i - 1].focus();
                        Utils.stopEvent(e);
                    } else if (e.keyCode === 40) {
                        searchFilterMenuItems[(i + 1) % searchFilterMenuItems.length].focus();
                        Utils.stopEvent(e);
                    }
                });
            });
        }
    }, 100);

    var header = document.getElementById("header"),
        direction = Utils.getTextDirection(header),
        updateQuickLinksBar = function () {
            var logo = document.getElementById("logo");
            var quickLinksBar = document.getElementById("quickLinksBar");
            var availableWidth = (direction === "rtl" ? logo.offsetLeft - quickLinksBar.offsetLeft : (quickLinksBar.offsetLeft + quickLinksBar.offsetWidth) - (logo.offsetLeft + logo.offsetWidth));
            // BEGIN Facebook quick link workaround
            var facebookQuickLinkItem = document.getElementById("facebookQuickLinkItem");
            if (facebookQuickLinkItem && facebookQuickLinkItem.parentNode != quickLinksBar && availableWidth > 1024) {
                quickLinksBar.insertBefore(facebookQuickLinkItem, quickLinksBar.firstChild);
            } else if (facebookQuickLinkItem && facebookQuickLinkItem.parentNode == quickLinksBar && availableWidth <= 1024) {
                var quickLinksMenuList = $("#quickLinksMenu > ul")[0];
                quickLinksMenuList.append(facebookQuickLinkItem);
            }
            // END Facebook quick link workaround
            var quickLinksBarItems = $("#quickLinksBar > li");
            if (quickLinksBarItems != undefined && quickLinksBarItems.length > 1) {
	            var quickLinksItem = quickLinksBarItems[quickLinksBarItems.length - 2];
	            var miniCartItem = quickLinksBarItems[quickLinksBarItems.length - 1];
	            availableWidth -= quickLinksItem.offsetWidth + miniCartItem.offsetWidth;
	            for (var i = quickLinksBarItems.length - 3; i >= 0; i--) {
	                availableWidth -= quickLinksBarItems[i].offsetWidth;
	                $(quickLinksBarItems[i]).toggleClass("border-right", (availableWidth >= 0));
	                $(quickLinksBarItems[i]).toggleClass("hidden", (availableWidth < 0));
	            }
    		}
        };
    window.setTimeout(updateQuickLinksBar, 200);
    $(window).resize(updateQuickLinksBar);

    updateDepartmentsMenu = function () {
        var departmentsMenu = document.getElementById("departmentsMenu");
        var searchBar = document.getElementById("searchBar");
        var departmentButtons = $(".departmentButton");
        var departmentMenus = $(".departmentMenu");
        var departmentsMenuItems = $("#departmentsMenu > li");
        var allDepartmentsItem = departmentsMenuItems[departmentsMenuItems.length - 1];
        var availableWidth = null;
        if (searchBar) {
            availableWidth = (direction === "rtl" ? (departmentsMenu.offsetLeft + departmentsMenu.offsetWidth) - (searchBar.offsetLeft + searchBar.offsetWidth) : searchBar.offsetLeft - departmentsMenu.offsetLeft) - allDepartmentsItem.offsetWidth;
        } else {
            //TODO This is a test //availableWidth = departmentsMenu.offsetWidth - allDepartmentsItem.offsetWidth;
            availableWidth = 300;
        }
        for (var i = 0; i < departmentsMenuItems.length - 1; i++) {
            availableWidth -= departmentsMenuItems[i].offsetWidth;
            $(departmentsMenuItems[i]).toggleClass("hidden", (availableWidth < 0));
        }
        departmentButtons.each(function (i, departmentButton) {
            $(departmentButton).keydown(function (e) {
                if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                    deactivate(document.getElementById(departmentButton.getAttribute("data-toggle")));
                }
            });
        });
        departmentMenus.each(function (i, departmentMenu) {
            $(departmentMenu).click(function (e) {
                var target = this.getAttribute("data-toggle");
                if (target !== null) {
                    toggle(document.getElementById(target));
                    Utils.stopEvent(e);
                }
            });
            var departmentMenuItems = $('[class*="menuLink"]', departmentMenu);
            departmentMenuItems.each(function (j, departmentMenuItem) {
                $(departmentMenuItem).keydown(function (e) {
                    if (e.keyCode === 27) {
                        deactivate(document.getElementById(departmentMenu.getAttribute("id")));
                        Utils.stopEvent(e);
                    } else if (e.keyCode === 9 || (e.keyCode === 9 && e.shiftKey)) {
                        deactivate(document.getElementById(departmentMenu.getAttribute("id")));
                    } else if (e.keyCode === 38) {
                        departmentMenuItems[j === 0 ? departmentMenuItems.length - 1 : j - 1].focus();
                        Utils.stopEvent(e);
                    } else if (e.keyCode === 40) {
                        departmentMenuItems[(j + 1) % departmentMenuItems.length].focus();
                        Utils.stopEvent(e);
                    }
                });
            });
        });
    };
    window.setTimeout(updateDepartmentsMenu, 200);
    var ie_version = Utils.get_IE_version();
    if (!ie_version || ie_version > 8) {
        // Disabled in IE8 due to an IE8 bug causing the page to go partially black
        $(window).resize(updateDepartmentsMenu);
    }

    $("#searchFilterMenu > ul > li > a").click(function (e) {
        document.getElementById("searchFilterButton").innerHTML = this.innerHTML;
        document.getElementById("categoryId").value = this.getAttribute("data-value");
        deactivate(document.getElementById("searchFilterMenu"));
    });
    $("#searchBox > .submitButton").click(function (e) {
        var searchTerm = document.getElementById("SimpleSearchForm_SearchTerm");
        searchTerm.value = $.trim(searchTerm.value);
        var unquote = $.trim(searchTerm.value.replace(/'|"/g, ""));
        if (searchTerm.value && unquote !== "") {
            processAndSubmitForm(document.getElementById("searchBox"));
        }
    });
    var searchBox = document.getElementById("searchBox");
    if (searchBox) {
        $(searchBox).submit(function (e) {
            updateFormWithWcCommonRequestParameters(e.target);
            var searchTerm = document.getElementById("SimpleSearchForm_SearchTerm");
            var origTerm = searchTerm.value;
            var unquote = $.trim(searchTerm.value.replace(/'|"/g, ""));
            searchTerm.value = unquote;

            if (!searchTerm.value) {
                Utils.stopEvent(e);
                return false;
            }
            searchTerm.value = $.trim(origTerm);
        });
    }

});

function declareDeptDropdownRefreshArea(divId) {
    // ============================================
    // div: drop_down_${department.uniqueID} refresh area
    // Context and Controller to refresh department drop-down

    // common render context
    wcRenderContext.declare("departmentSubMenuContext", [divId], { targetId: "" });

    // render content changed handler
    var renderContextChangedHandler = function() {
        $("#"+divId).refreshWidget("refresh", wcRenderContext.getRenderContextProperties("departmentSubMenuContext"));
    };

    // post refresh handler
    var postRefreshHandler = function() {
        updateDepartmentsMenu(); // Browser may be re-sized. From server we return entire department list.. updateHeader to fit to the list within available size
        activate(document.getElementById(wcRenderContext.getRenderContextProperties("departmentSubMenuContext").targetId)); // We have all the data.. Activate the menu...
        cursor_clear();
    };

    // initialize widget
    $("#"+divId).refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});

};

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

if (typeof (ProductTabJS) == "undefined" || ProductTabJS == null || !ProductTabJS) {

    ProductTabJS = {
        lastTabId: null,
        /**
         * To make the tab selected and remove all other tabs from the tab order
         * See http://www.w3.org/TR/wai-aria-practices/#tabpanel for ARIA best practices
         *
         * @param {String} tabId The ID of the tab to be selected
         */
        selectTab: function (tabId) {
            $("div.tab_container").each(function (i, tab) {
                $(tab).attr("aria-selected", "false")
                      .attr("class", "tab_container inactive_tab")
                      .attr("tabindex", "-1");
            });
            $("div.tab").each(function (i, tabPanel) {
                $(tabPanel).css("display", "none");
            });

            $("#" + tabId).attr("aria-selected", "true")
                          .attr("tabindex", "0")
                          .attr("class", "tab_container active_tab");
            $("#" + tabId + "Widget").css("display", "block");
            $("#" + tabId + "Widget").each(function (i, widget) {
                if (widget.resize) {
                    widget.resize();
                }
            });

            if (this.lastTabId == null || this.lastTabId != tabId) {
                this.lastTabId = tabId;
            }
        },

        /**
         * To select the previous or next tab with the keyboard arrow keys.  If there are no more tabs to the
         * left or right, wrap to the other end of the tab list.
         * See http://www.w3.org/TR/wai-aria-practices/#tabpanel for ARIA best practices
         *
         * @param {int} tabIndex The index of the tab to be selected
         * @param {int} tabSetSize The number of total tabs in the tablist
         * @param {event} event
         */
        selectTabWithKeyboard: function (tabIndex, tabSetSize, event) {
            if (event.keyCode == keys.DOWN_ARROW || event.keyCode == keys.RIGHT_ARROW) {
                tabIndex++;
                if ($("#tab" + tabIndex)) {
                    this.selectTab("tab" + tabIndex);
                    this.focusTab("tab" + tabIndex);
                } else {
                    this.selectTab("tab1");
                    this.focusTab("tab1");
                }
                this.cancelEvent(event);
            }

            if (event.keyCode == keys.UP_ARROW || event.keyCode == keys.LEFT_ARROW) {
                if ($("#tab" + (tabIndex - 1))) {
                    this.selectTab("tab" + (tabIndex - 1));
                    this.focusTab("tab" + (tabIndex - 1));
                } else {
                    this.selectTab("tab" + tabSetSize);
                    this.focusTab("tab" + tabSetSize);
                }
                this.cancelEvent(event);
            }
        },

        /**
         * Stop event propagation
         *
         * @param {event} e
         */
        cancelEvent: function (e) {
            Utils.stopEvent(e);
        },

        /**
         * To bring the focus to the tab
         *
         * @param {String} tabId The ID of the tab to be selected
         */
        focusTab: function (tabId) {
            if ($("#" + tabId).hasClass("focused_tab")) {
                $("> div", "#" + tabId).css("border", "1px dotted #000000");
                return;
            } else {
                $("#" + tabId).addClass("focused_tab");
                $("> div", $("#" + tabId)).css("border", "1px dotted #000000");
                $("#" + tabId).focus();
            }
        },

        /**
         * To take the focus out from the tab
         *
         * @param {String} tabId The ID of the tab to be selected
         */
        blurTab: function (tabId) {
            $(tabId).removeClass("focused_tab");
            $("> div", "#" + tabId).css("border", "1px solid transparent");
        }
    };
}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------
if(typeof(QuickInfoJS) == "undefined" || QuickInfoJS == null || !QuickInfoJS) {

	QuickInfoJS = {
		productImgDimensions: "1000x1000",
		quickInfoImgDimensions: "330x330",
		catEntryParams: {},
		selectedAttributes: new Object(),
		catEntryQuantity: 1,
		itemDetailsArr: new Object(),
		params: null,
		replaceOrderItemId: '', // the orderItemId to be replaced after changing the attributes
		itemId: '', // the current item in the cart to be replaced
		selectedSkuIndex: null, // selected sku index
		selectedThumbnailIndex: null, // selected thumbnail index

		/**
		 * Sets the replaceOrderItemId
		 */
		setReplaceOrderItemId: function(replaceOrderItemId){
			this.replaceOrderItemId = replaceOrderItemId;
		},

		/**
		 * Sets other values
		 */
		setValues: function(){
			if ($("#catEntryParamsForJS").length){
				this.catEntryParams = $.parseJSON($("#catEntryParamsForJS").val());
			}

			this.catEntryParams.attributes = this.selectedAttributes;
		},

		/**
		 * Setter for catEntryQuantity
		 *
		 * @param Integer catEntryQuantity
		 */
		setCatEntryQuantity: function(catEntryQuantity){
			this.catEntryQuantity = catEntryQuantity;
		},

		/**
		 * To display quick info details
		 *
		 * @param {String} productId
		 * @param {Object} params
		 * @param {String} itemId
		 * @param {String} quantity
		 */
		showDetails: function(productId, params, itemId, quantity, parentPage){
			/*
			 * If showDetails is called from merchandising association,
			 * params will be filled with cat entry of the first product to be added to shopping cart
			 */
			if(params){
				this.params = params;
			} else {
				// resetting to null, if no params passed
				this.params = null;
			}
			// Clearing the selected attributes
			this.selectedAttributes = new Object();
			this.selectedSkuIndex = null; // clearing selected sku index
			this.selectedThumbnailIndex = null; // clearing selected thumbnail index

			// For Handling multiple clicks.
			if(!submitRequest()){
				return;
			}
			this.close();
			cursor_wait();

			var contextValues = this.setCommonParams();
			if(itemId){
				this.itemId = itemId;
				contextValues.updateAttributes = "true";
			} else {
				this.itemId = '';
				contextValues.updateAttributes = "false";
			}
			if (parentPage) {
				contextValues.parentPage = parentPage;
			}

			if(quantity){
				this.catEntryQuantity = quantity;
			}

			contextValues.productId = productId;
			wcRenderContext.updateRenderContext('QuickInfoContext', contextValues);
		},

		/**
		 * To display quick info details - to change attribute values
		 *
		 * @param {String} orderItemId
		 * @param {String} productId
		 * @param {String} itemId
		 * @param {String} quantity
		 */
		changeAttributes: function(orderItemId, productId, itemId, quantity){
			this.setReplaceOrderItemId(orderItemId);
			this.showDetails(productId, null, itemId, quantity);
		},

		/**
		 * Change the main image based on the angle thumbnail clicked
		 *
		 */
		changeImage: function(elementId, imgSrc){
			this.selectedThumbnailIndex = elementId-1;
			$("#quickInfoMainImage").attr("src", this.getQuickInfoImage(this.catEntryParams.skus[this.selectedSkuIndex].thumbnailAttachments[this.selectedThumbnailIndex].path))
			$(".widget_quick_info_popup .other_views li").removeClass("selected");
			if (isProduct === 'true') {
				$("#quickInfoProductThumbnail" + elementId).addClass("selected");
			} else {
				$("#quickInfoThumbnail" + elementId).addClass("selected");
			}
		},

		/**
		* setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
		*					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
		*
		* @param {String} selectedAttributeName The name of the attribute.
		* @param {String} selectedAttributeValue The value of the selected attribute.
		*
		*/
		setSelectedAttribute : function(selectedAttributeName , selectedAttributeValue){
			this.selectedAttributes[selectedAttributeName] = selectedAttributeValue;
		},

		/**
		 * To notify the change in attribute to other components that is subscribed to attributesChanged event.
		 */
		notifyAttributeChange: function(){
			wcTopic.publish('QuickInfo_attributesChanged', [JSON.stringify(this.selectedAttributes)]);
			this.setValues();
			var catEntryId = this.resolveSKU();
			if (catEntryId != -1) {
				wcTopic.publish('DefiningAttributes_Resolved', catEntryId, this.catEntryParams.id);
				QuickInfoJS.selectItem(true);
			}
			else {
				wcTopic.publish('DefiningAttributes_Resolved', null, null);
				var attrSelected = false;
				for (var attribute in this.selectedAttributes) {
					if (this.selectedAttributes[attribute] !== null && this.selectedAttributes[attribute] !== '') {
						attrSelected = true;
					}
				}

				if (!attrSelected) {
					$("div[id^='quickinfoAngleImagesArea']").css("display", 'none');
					$("div[id^='quickinfoProductAngleImagesArea']").css("display", 'block');

					this.showDetails(this.catEntryParams.id, null, null, null, '');
				}
			}
		},

		/**
		 * Selects the sku and updates the item name and price.
		 *
		 * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then do not display the price range.
		 * @param {Boolean} updateItemImageOnly If the value is true, then only change the item image. If it is false then update all product details.
		 */
		selectItem: function(displayPriceRange, updateItemImageOnly){
			this.displayPriceRange = displayPriceRange;
			this.setValues();
			var catEntryId = this.resolveSKU();

			if(catEntryId == -1 && updateItemImageOnly){
				var skuId = -1;
				for(idx=0;idx<this.catEntryParams.skus.length;idx++){
					for(attribute in this.catEntryParams.skus[idx].attributes){
						if(this.catEntryParams.attributes && this.catEntryParams.skus[idx].attributes[attribute] == this.catEntryParams.attributes[attribute]){
							skuId = this.catEntryParams.skus[idx].id;
							break;
						}
					}
				}
				if(skuId != -1){
					catEntryId = skuId;
					this.updateItemImageOnly = updateItemImageOnly;
				}
			}

			if(catEntryId!=-1){
				//check if the object is already present for the catEntryId.
				if(this.itemDetailsArr[catEntryId] != null && this.itemDetailsArr[catEntryId] != 'undefined'){
					this.displayItemDetails(this.itemDetailsArr[catEntryId]);
				}
				//if json object is not present, call the service to get the details.
				else{
					var params = this.setCommonParams();
					params.catalogEntryId = catEntryId;

					//Declare a service for retrieving catalog entry detailed information for an item...
					wcService.declare({
						id: "getCatalogEntryDetailsQI",
						actionId: "getCatalogEntryDetailsQI",
						url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
						formId: ""

						,successHandler: function(serviceResponse, ioArgs) {
							QuickInfoJS.setItemDetails(serviceResponse, ioArgs);
						}

						,failureHandler: function(serviceResponse, ioArgs) {
							console.debug("QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request.");
						}

					});
					wcService.invoke("getCatalogEntryDetailsQI", params);
				}
			}
		},

		/**
		* Handles the case when a swatch is selected. Set the border of the selected swatch.
		* @param {String} selectedAttributeName The name of the selected swatch attribute.
		* @param {String} selectedAttributeValue The value of the selected swatch attribute.
		* @param {String} swatchId id of the swatch element
		* @param {String} swatchGrp starting pattern of id of the swatch element group
		*
		**/
		selectSwatch: function(selectedAttributeName, selectedAttributeValue, swatchId, swatchGrp) {
			if($("[id='quickInfoSwatch_" + selectedAttributeName + "_" + selectedAttributeValue + "']").hasClass("color_swatch_disabled")){
				alert("return..");
				return false;
			}
			// sets the store parameters and catalog details from the hidden fields
			this.setValues();
			// picks all the swatch names
			var swatchNames = $("#WC_QuickInfo_SwatchNames").val().split("_");
			// identifies the position of the current swatch
			var currentSwatchPos = -1;
			for(var i=0; i<swatchNames.length;i++){
				if(swatchNames[i] == selectedAttributeName){
					currentSwatchPos = i;
					break;
				}
			}
			var currentSwatchkey = "quickInfoSwatch_" + selectedAttributeName + "_" +selectedAttributeValue;
			var currentSwatchkeyLink = "WC_QuickInfo_Swatch_" + selectedAttributeName + "_" +selectedAttributeValue;
			var validSwatchArr = new Array();
			// iterates through each sku and its attributes to identify valid attribute combination
			for(idx in this.catEntryParams.skus){
				var validItem = false;
				var entitledItem = this.catEntryParams.skus[idx];
				for(attribute in entitledItem.attributes){

					if(selectedAttributeName == attribute && selectedAttributeValue == entitledItem.attributes[attribute] && entitledItem.buyable){
						validItem = true;
						break;
					}
				}
				if(validItem){
					for(attribute in entitledItem.attributes){
						var attributePos = -1;
						for(var i=0; i<swatchNames.length;i++){
							if(swatchNames[i] == attribute){
								attributePos = i;
								break;
							}
						}
						if(attributePos > currentSwatchPos){
							// picks the valid swatch attributes for the current swatch selection
							validSwatchArr.push(attribute + "_" + entitledItem.attributes[attribute]);
						}
					}
				}
			}

			var swatchesDisabled = new Array();
			var selectedSwatches = new Array();
			for(idx in this.catEntryParams.skus){
				var entitledItem = this.catEntryParams.skus[idx];
				for(attribute in entitledItem.attributes){
					var attributePos = -1;
					for(var i=0; i<swatchNames.length;i++){
						if(swatchNames[i] == attribute){
							attributePos = i;
							break;
						}
					}
					if(attributePos > currentSwatchPos){
						var swatchSelection = attribute + "_" + entitledItem.attributes[attribute];
						var swatchId = "quickInfoSwatch_" + swatchSelection;
						var swatchLinkId = "WC_QuickInfo_Swatch_" + swatchSelection;
						var validSwatchArrPos = -1;
						for(var i=0; i<validSwatchArr.length;i++){
							if(validSwatchArr[i] == swatchSelection){
								validSwatchArrPos = i;
								break;
							}
						}
						var swatchesDisabledPos = -1;
						for(var i=0; i<swatchesDisabled.length;i++){
							if(swatchesDisabled[i] == swatchSelection){
								swatchesDisabledPos = i;
								break;
							}
						}
						// enable valid swatches
						if(validSwatchArrPos > -1){
							if(!$("[id='" + swatchId + "']").hasClass("color_swatch_selected")){
								$("[id='" + swatchId + "']").attr("class", "color_swatch");
								$("[id='" + swatchId + "']").attr("src", $("[id='" + swatchId + "']").attr("src").replace("_disabled.png","_enabled.png"))
								$("[id='" + swatchLinkId + "']").attr("aria-disabled", "false");
							}
						}
						// disable invalid swatches
						else if(swatchesDisabledPos == -1){
							swatchesDisabled.push(swatchSelection);
							if($("[id='" + swatchId + "']").hasClass("color_swatch_selected")){
								selectedSwatches.push(swatchId);
							}
							$("[id='" + swatchId + "']").attr("class", "color_swatch_disabled");
							$("[id='" + swatchId + "']").attr("src", $("[id='" + swatchId + "']").attr("src").replace("_enabled.png","_disabled.png"))
							$("[id='" + swatchLinkId + "']").attr("aria-disabled", "true");
						}
					}
					$("[id='WC_QuickInfo_Swatch_" + attribute + "_" + entitledItem.attributes[attribute] + "']").attr("aria-checked", "false");
				}
			}

			// if any of the disabled swatches were previously selected, change the selection to the first valid value
			for(idx in selectedSwatches){
				var selectedSwatch = selectedSwatches[idx];
				var idSelector = "img[id^='" + selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_")) + "']";
				var swatchSelected = false;
				$(idSelector).each(function(index, node, arr){
					if(!swatchSelected && $(node).hasClass("color_swatch")){
						var values = node.id.split("_");
						QuickInfoJS.selectSwatch(values[1],values[2], "quickInfoSwatch_" + values[1] + "_" + values[2],"quickInfoSwatch_"+values[1]+"_");
						QuickInfoJS.selectItem(true);
						swatchSelected = true;
					}
				});
			}

			selector = "img[id^='"+swatchGrp+"']";

			$(selector).each(function(index, node, arr){
			    if(!$(node).hasClass("color_swatch_disabled")){
			    	$(node).addClass("color_swatch");
			    	if($(node).hasClass("color_swatch_selected")){
				    	$(node).removeClass("color_swatch_selected");
				    }
			    }
			});

			$("[id='" + currentSwatchkey + "']").attr("class", "color_swatch_selected");
			$("[id='quickinfo_swatch_selection_"+selectedAttributeName + "']").html(selectedAttributeValue)
			$("[id='" + currentSwatchkeyLink + "']").attr("aria-checked", "true");
			this.setSelectedAttribute(selectedAttributeName, selectedAttributeValue);
		},

		/**
		 * Sets the store specific values such as storeId, catalogId and langId in a Object and returns it.
		 *
		 * @return {Object} params with store specific values
		 */
		setCommonParams: function(){
			var params = new Object();
			params.storeId		= WCParamJS.storeId;
			params.catalogId	= WCParamJS.catalogId;
			params.langId		= WCParamJS.langId;
			return params;
		},

		/**
		 * Displays price of the catEntry selected with the JSON objrct returned from the server.
		 *
		 * @param {object} serviceRepsonse The JSON response from the service.
		 * @param {object} ioArgs The arguments from the service call.
		 */
		setItemDetails: function(serviceResponse, ioArgs) {
			QuickInfoJS.itemDetailsArr[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse.catalogEntry;
			QuickInfoJS.displayItemDetails(serviceResponse.catalogEntry);
		},

		displayItemDetails: function(catalogEntry) {
			if(null != this.catEntryParams){
				for(idx in this.catEntryParams.skus){
					if(null != this.catEntryParams.skus[idx] && (this.catEntryParams.skus[idx].id == catalogEntry.catalogEntryIdentifier.uniqueID)){
						var angleImageAreaList = $("div[id^='quickinfoAngleImagesArea']");
						var prodAngleImageAreaList = $("div[id^='quickinfoProductAngleImagesArea']");

						if(angleImageAreaList.length){
							var angleImageArea = angleImageAreaList[0];
						}
						if(this.catEntryParams.skus[idx].thumbnailAttachments != null && this.catEntryParams.skus[idx].thumbnailAttachments.length > 0){
							prodAngleImageAreaList.css("display", 'none');

							var thumbnailAreaList = $("ul[id^='quickInfoAngleImagesAreaList']");
							if(thumbnailAreaList.length){
								var thumbnailArea = thumbnailAreaList[0];
								if(angleImageArea != null){
									$(angleImageArea).css("display", "block");
								}
								for(idx2 = 1; idx2 <= this.catEntryParams.skus[idx].thumbnailAttachments.length; idx2++){
									var angleThumbnail = document.createElement("li");
									var angleThumbnailLink = document.createElement("a");
									var angleThumbnailImg = document.createElement("img");

									angleThumbnail.id = "quickInfoThumbnail" + idx2;

									angleThumbnailLink.href = "javaScript:QuickInfoJS.changeImage(" + idx2 + ",'" + this.catEntryParams.skus[idx].fullImageAttachments[idx2-1].path + "');";
									angleThumbnailLink.id = "WC_QuickInfo_Link_thumbnail_" + idx2;
									angleThumbnailLink.className = "tlignore";
									if(this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc != 'undefined' && this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc != null){
										angleThumbnailLink.title = this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc;
									}

									angleThumbnailImg.src = this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].path;
									if(this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc != 'undefined' && this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc != null){
										angleThumbnailImg.alt = this.catEntryParams.skus[idx].thumbnailAttachments[idx2-1].shortDesc;
									}
									if(idx2 == 1){
										$(thumbnailArea).empty();
									}
									angleThumbnailLink.appendChild(angleThumbnailImg);
									angleThumbnail.appendChild(angleThumbnailLink);
									thumbnailArea.appendChild(angleThumbnail);
								}
							}
						} else {
							var prodDisplayClass = 'block';
							for (attribute in this.selectedAttributes){
								if(null != this.selectedAttributes[attribute] && '' != this.selectedAttributes[attribute]){
									prodDisplayClass = 'none';
								}
							}

							if(prodAngleImageAreaList != null){
								for(var i = 0; i < prodAngleImageAreaList.length; i++){
									if(null != prodAngleImageAreaList[i]){
										$(prodAngleImageAreaList[i]).css("display", prodDisplayClass);
									}
								}
							}

							if (angleImageArea != null){
								$(angleImageArea).css("display", "none");
							}
						}
						if(null == this.selectedThumbnailIndex){
							this.selectedThumbnailIndex = 0;
						}
						this.selectedSkuIndex = idx;
						var imagePath = catalogEntry.description[0].thumbnail;
						if (null != imagePath && imagePath.length != 0){
							$("#quickInfoMainImage").attr("src", imagePath)
						}
						if ($("#ProductInfoImage_"+this.catEntryParams.id).length){
							document.getElementById("ProductInfoImage_"+this.catEntryParams.id).value = imagePath;
						}
					}
				}
			}

			if(this.updateItemImageOnly){
				this.updateItemImageOnly = false;
				return;
			}

			$(".widget_quick_info_popup .main_header").first().html(catalogEntry.description[0].name);
			if ($("#ProductInfoName_"+this.catEntryParams.id).length){
				document.getElementById("ProductInfoName_"+this.catEntryParams.id).value = catalogEntry.description[0].name;
			}

			if(catalogEntry.listPriced && catalogEntry.listPrice > catalogEntry.offerPrice){
				if(null != $(".widget_quick_info_popup .old_price")[0]){
					$(".widget_quick_info_popup .old_price").first().html(catalogEntry.listPrice);
				} else {
					var oldPriceTag = "<span class='old_price'>" + catalogEntry.listPrice + "</span>";
					var priceTag = $(".widget_quick_info_popup .price")[0];
					$(oldPriceTag).before(priceTag);
				}
			} else if(null != $(".widget_quick_info_popup .old_price")[0]){
				$(".widget_quick_info_popup .old_price").remove();
			}
			$(".widget_quick_info_popup .price").first().html(catalogEntry.offerPrice);

			$(".widget_quick_info_popup .sku").first().html(Utils.getLocalizationMessage('SKU') + " " + catalogEntry.catalogEntryIdentifier.externalIdentifier.partNumber);

			if ($("#ProductInfoPrice_"+this.catEntryParams.id).length){
				document.getElementById("ProductInfoPrice_"+this.catEntryParams.id).value = catalogEntry.offerPrice;
			}
		},

		validate: function(){
			if(this.catEntryParams.type =='ProductBean' &&
					(null == this.catEntryParams.attributes || "undefined" == this.catEntryParams.attributes)) {
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage['ERR_RESOLVING_SKU']);
				return false;
			} else if(!isPositiveInteger(this.catEntryQuantity)){
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage['QUANTITY_INPUT_ERROR']);
				return false;
			}
			return true;
		},

		/**
		* add2ShopCart Adds displayed product to the shopping cart
		*
		*
		**/
		add2ShopCart: function(customParams){

			if (browseOnly){
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage['ERROR_ADD2CART_BROWSE_ONLY']);
				return;
			}
			this.setValues();
			if(!this.validate()){
				return;
			}
			/*
			 * params is null means, no product is waiting to be added to shopping cart.
			 * params will not be null if the call originated from merchandising association
			 */
			if(null == this.params){
				this.params = this.setCommonParams();
				this.params.orderId		= ".";
				// Remove calculations for performance
				// this.params.calculationUsage = "-1,-2,-5,-6,-7";
				this.params.inventoryValidation = "true";
				this.params.calculateOrder="0";
			}

			var productId = '';
			//Add the catalog entry to the cart.
			if(this.catEntryParams.type.toLowerCase() == 'itembean'
				|| this.catEntryParams.type.toLowerCase() == 'packagebean'
				|| this.catEntryParams.type.toLowerCase() == 'dynamickitbean'){
				updateParamObject(this.params,"catEntryId",this.catEntryParams.id,false,-1);
				updateParamObject(this.params,"quantity",this.catEntryQuantity,false,-1);
				productId = this.catEntryParams.id;
			} else {
				// Resolve ProductBean to an ItemBean based on the attributes in the main page
				var sku = this.resolveSKU();
				if(-1 == sku){
					MessageHelper.displayErrorMessage(Utils.getLocalizationMessage['ERR_RESOLVING_SKU']);
					return;
				} else {
					updateParamObject(this.params,"catEntryId",sku,false,-1);
					updateParamObject(this.params,"quantity",this.catEntryQuantity,false,-1);
				}
				productId = sku;
			}

			var shopCartService = "AddOrderItem";

			//Pass any other customParams set by other add on features
			if(customParams != null && customParams != 'undefined'){
				for(i in customParams){
					this.params[i] = customParams[i];
				}
				if(customParams['catalogEntryType'] == 'dynamicKit' ){
					shopCartService = "AddPreConfigurationToCart";
				}
			}
			if(this.params['catalogEntryType'] == 'dynamicKit' ){
				shopCartService = "AddPreConfigurationToCart";
			}

			shoppingActionsJS.saveAddedProductInfo(this.catEntryQuantity, this.catEntryParams.id, productId, this.selectedAttributes);

			this.close();

			//For Handling multiple clicks
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			wcService.invoke(shopCartService, this.params);
		},

		/**
		 * This resolves the product SKUs to a single item by comparing the attributes selected by the user
		 *
		 * @return {Integer} uniqueId, of the selected SKU.
		 * 					 -1, if no match found
		 */
		resolveSKU: function() {
			// if there is only one sku, no need to resolve.
			if(this.catEntryParams.skus.length == 1){
				return this.catEntryParams.skus[0].id;
			}
			for(idx=0;idx<this.catEntryParams.skus.length;idx++){
				var matches = 0;
				var attributeCount = 0;
				for(attribute in this.catEntryParams.skus[idx].attributes){
					attributeCount++;
					if(this.catEntryParams.attributes && this.catEntryParams.skus[idx].attributes[attribute] == this.catEntryParams.attributes[attribute]){
						matches++;
					} else {
						break;
					}
				}
				// if there are multiple skus for a product, there should be atleast one attribute for that product
				if(0 != matches && matches == attributeCount){
					return this.catEntryParams.skus[idx].id;
				}
			}
			return -1;
		},

		/**
		 * Displays the Product Quick Info button.
		 *
		 * @param {string} id The id of the div area to show.
		 */
		showQuickInfoButton: function(id){
            $("#" + id).css("visibility", "visible");
		},

		/**
		 * Hides the Product Quick Info button.
		 *
		 * @param {string} id The id of the div area to hide.
		 */
		hideQuickInfoButton: function(id){
            $("#" + id).css("visibility", "");
		},

		/**
		 * Overrides the hidePopupButton function above by also checking to see if the user clicks shift+tab.
		 *
		 * @param {string} id The id of the div area to hide.
		 * @param {event} event The keystroke event entered by the user.
		 */
		shiftTabHideQuickInfoButton: function(id, event){
			if ((event.shiftKey) && (event.keyCode === KeyCodes.TAB)){
				this.hideQuickInfoButton(id);
			}
		},

		/**
		 * Close the quick info popup
		 */
		close: function(focusElement){
			$('#quickInfoPopup').WCDialog("close");
			if(focusElement !=null && focusElement !='undefined' && document.getElementById(focusElement)){
				document.getElementById(focusElement).focus();
			}
		},


		/**
		 * Sets the focus back to the product image after quick info is closed.
		 */
		setFocus: function(event){
			if(event.keyCode === KeyCodes.ESCAPE && $('#catEntryParamsForJS').length){
				var catEntryParams = $("#catEntryParamsForJS").val();
				var catEntryId = $.parseJSON(catEntryParams).id;
				if(document.getElementById('catalogEntry_img' + catEntryId)){
					document.getElementById('catalogEntry_img' + catEntryId).focus();
				}
			}
		},


		/**
		 * Selects first swatch element
		 */
		selectDefaultSwatch: function(){
			var swatchElement = $("a[id^='WC_QuickInfo_Swatch_']")[0];
			if(swatchElement){
				eval($(swatchElement).attr("href"));
			}
		},

		/**
		* replaceCartItem This function is used to replace an item in the shopping cart. This will be called from the shopping cart and checkout pages.
		*
		**/
		replaceCartItem : function(){
			this.setValues();
			if(!this.validate()){
				return;
			}

			var catalogEntryId = this.resolveSKU();
			if(-1 == catalogEntryId){
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage['ERR_RESOLVING_SKU']);
				return;
			}
			this.close();

			var addressId = "";
			var shipModeId = "";
			var physicalStoreId = "";
			var typeId = $("#shipmentTypeId");

			if($("#addressId_all").length && $("#shipModeId_all").length){
				//Single Shipment..get the common addressId and shipModeId..
				if(typeId.length === 0 || typeId.val() != "1"){
					addressId = $("#addressId_all").val();
				} else if($("#physicalStoreId").length){
					physicalStoreId = $("#physicalStoreId").val();
				}
				shipModeId = $("#shipModeId_all").val();
			} else if ($("#MS_ShipmentAddress_" + this.replaceOrderItemId).length && $("#MS_ShippingMode_" + this.replaceOrderItemId).length){
				//Multiple shipment..each orderItem will have its own addressId and shipModeId..
				addressId = $("#MS_ShipmentAddress_" + this.replaceOrderItemId).val();
				shipModeId = $("#MS_ShippingMode_" + this.replaceOrderItemId).val();
			}

			if(this.replaceOrderItemId != "" && categoryDisplayJS){
				//Else remove existing catEntryId and then add new one...
				shoppingActionsJS.replaceItemAjaxHelper(catalogEntryId,this.catEntryQuantity,this.replaceOrderItemId,addressId,shipModeId,physicalStoreId);
			} else {
				console.error("categoryDisplayJS not defined");
			}
		},

		/**
		 * select the attributes of an sku
		 */
		selectCurrentAttributes: function(){
			for(idx=0;idx<this.catEntryParams.skus.length;idx++){
				var selectedSKU = this.catEntryParams.skus[idx];
				if(selectedSKU.id == this.itemId){
					for(attribute in selectedSKU.attributes){
						var selectNode = $("select[alt='" + attribute + "']")[0];
						if(selectNode){
							selectNode.value = selectedSKU.attributes[attribute];
							this.setSelectedAttribute(attribute,selectNode.value);
						} else {
							var attrValue = selectedSKU.attributes[attribute];
							if ($("[id='quickInfoSwatch_" + attribute + "_" + attrValue + "']").length){
								this.selectSwatch(attribute, attrValue, "quickInfoSwatch_" + attribute + "_" + attrValue, "quickInfoSwatch_" + attribute + "_");
							}
						}
					}

					this.notifyAttributeChange();
					this.selectItem(true);

					return;
				}
			}

		}

	}

};//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2013, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------


if(typeof(SearchJS) == "undefined" || SearchJS == null || !SearchJS){

    SearchJS = {

        /**
         * This variable controls the timer handler before triggering the autoSuggest.  If the user types fast, intermittent requests will be cancelled.
         * The value is initialized to -1.
         */
        autoSuggestTimer: -1,

        /**
         * This variable controls the delay of the timer in milliseconds between the keystrokes before firing the search request.
         * The value is initialized to 400.
         */
        autoSuggestKeystrokeDelay : 400,

        /**
         * This variable indicates whether or not the user is hovering over the autoSuggest results popup display.
         * The value is initialized to false.
         */
        autoSuggestHover : false,

        /**
         * This variable stores the old search term used in the auto suggest search box
         * The value is initialized to empty string.
         */
        autoSuggestPreviousTerm : "",

        /**
         * This variable stores the URL of currently selected static autosuggest recommendation
         * The value is initialized to empty string.
         */
        autoSuggestURL : "",

        /**
         * This variable stores the index of the selected auto suggestion item when using up/down arrow keys.
         * The value is initialized to -1.
         */
        autoSelectOption : -1,

        /**
         * This variable stores the index offset of the first previous history term
         * The value is initialized to -1.
         */
        historyIndex : -1,

        /**
         * This variable indicates whether a the cached suggestions have been retrieved.
         * The value is initialized to false.
         */
        retrievedCachedSuggestions : false,

        /**
         * This variable sets the total number of static autosuggest recommendations used for each static category/grouping.
         * The value is initialized to 4.
         */
        TOTAL_SUGGESTED : 4,

        /**
         * This variable sets the total number of previous search history terms.
         * The value is initialized to 2.
         */
        TOTAL_HISTORY : 2,

        /**
         * This variable controls when to trigger the auto suggest box.  The number of characters greater than this threshold will trigger the auto suggest functionality.
         * The static/cached auto suggest will be performed if this threshold is exceeded.
         * The value is initialized to 1.
         */
        AUTOSUGGEST_THRESHOLD : 1,

        /**
         * This variable controls when to trigger the dynamic auto suggest.  The number of characters greater than this threshold will trigger the request for keyword search.
         * The static/cached auto suggest will be be displayed if the characters exceed the above config parameter, but exceeding this threshold will additionally perform the dynamic search to add to the results in the static/cached results.
         * This value should be greater or equal than the AUTOSUGGEST_THRESHOLD, as the dynamic autosuggest is secondary to the static/cached auto suggest.
         * The value is initialized to 1.
         */
        DYNAMIC_AUTOSUGGEST_THRESHOLD : 1,

        /**
         * This variable is an internal constant used in the element ID's generated in the autosuggest content.
         * The value is initialized to 1000.
         */
        CACHED_AUTOSUGGEST_OFFSET : 1000,

        /**
         * This variable is used to indicate whether or not the auto suggest selection has reached the end of the list.
         * The value is initialized to false.
         */
        END_OF_LIST : false,
        /**
          * The auto suggest container ID's
         */
        STATIC_CONTENT_SECTION_DIV: ["autoSuggestStatic_1", "autoSuggestStatic_2", "autoSuggestStatic_3"],


        /**
         * NLS message for header
        */
        staticContentHeaderHistory:"",

        /**
         * URL to retrieve auto suggest keywords
        */
        SearchAutoSuggestServletURL:"",

        /**
         * Timeout variable for department dropdown list
        */
        searchDepartmentHoverTimeout:"",
        /**
         * Timeout variable for suggestions dropdown list
        */
        searchSuggestionHoverTimeout:"",
        /**
         * Handle for on mousedown event.
         */
        mouseDownConnectHandle: null,

        searchDepartmentSelect: function (categoryId, lel) {
            $("#searchDepartmentLabel").html(lel.innerHTML);
            //$('#search_categoryId').val() = categoryId; //store.js compile error
            $('#search_categoryId').value = categoryId;
            this.hideSearchDepartmentList();
            return false;
        },

        cancelEvent: function(e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            }
            if (e.preventDefault) {
                e.preventDefault();
            }
            e.cancelBubble = true;
            e.cancel = true;
            e.returnValue = false;
        },

        searchDepartmentKeyPressed: function(event, pos, size, categoryId, item){
            if (event.keyCode === KeyCodes.RETURN) { // enter
                this.searchDepartmentSelect(categoryId, item);
                var scrElement = document.getElementById("mobileSearchDropdown");
                if (scrElement != null && scrElement.style.display == 'block'){
                    $("#MobileSimpleSearchForm_SearchTerm").focus();
                }else{
                    document.CatalogSearchForm.searchTerm.focus();
                }
            } else if (event.keyCode === KeyCodes.UP_ARROW) { // up arrow
                if (pos != 0) {
                    $('#searchDepartmentList_' + (pos - 1)).focus();
                    this.cancelEvent(event);
                }
            } else if (event.keyCode === KeyCodes.DOWN_ARROW) { // down arrow
                if (pos != size) {
                    $('#searchDepartmentList_' + (pos + 1)).focus();
                    this.cancelEvent(event);
                }
            } else if (event.keyCode === KeyCodes.ESCAPE) { // escape
                var scrElement = document.getElementById("mobileSearchDropdown");
                if (scrElement != null && scrElement.style.display == 'block'){
                    $("#MobileSimpleSearchForm_SearchTerm").focus();
                }else{
                    document.CatalogSearchForm.searchTerm.focus();
                }
                this.hideSearchDepartmentList();
            } else if (event.shiftKey && event.keyCode === KeyCodes.TAB) { // tab
                var scrElement = document.getElementById("mobileSearchDropdown");
                if (scrElement != null && scrElement.style.display == 'block'){
                    $("#MobileSimpleSearchForm_SearchTerm").focus();
                }else{
                    document.CatalogSearchForm.searchTerm.focus();
                }
                this.cancelEvent(event);
                this.hideSearchDepartmentList();
            } else if (event.keyCode === KeyCodes.TAB) { // tab
                $('#search_submit').focus();
                this.cancelEvent(event);
                this.hideSearchDepartmentList();
            }

            return false;
        },

        hideSearchDepartmentList: function () {
            $('#searchDepartmentList').css('display', 'none');
        },

	init:function(){
	     $(document.CatalogSearchForm.searchTerm).on("focus",$.proxy (SearchJS._onFocus, SearchJS));
	     $(document.CatalogSearchForm.searchTerm).on("keydown",$.proxy (SearchJS._onKeyDown, SearchJS));
	     $(document.CatalogSearchForm.searchTerm).on("keyup",$.proxy (SearchJS._onKeyUp, SearchJS));
	     $("#searchDropdown").on("keyup",$.proxy (SearchJS._onKeyTab, SearchJS));
	//   $("#"Mobilesearch_submit").on("click",$.proxy (SearchJS._MobileonClick, SearchJS));
	//   $("#"navSearchMobile").on("click",$.proxy (SearchJS._showMobileSearchComponent, SearchJS));
	//   $("#"search_submit").on("click",$.proxy (SearchJS._onClick, SearchJS));

	     //this.staticContentHeaderHistory = Utils.getLocalizationMessage("HISTORY");
        },

        showSearchComponent:function(){
            var srcElement = document.getElementById("searchDropdown");
            if(srcElement != null) {
                srcElement.style.display= 'block';
            }
          },

        hideSearchComponent:function(){
            var srcElement = document.getElementById("searchDropdown");
            if(srcElement != null) {
                srcElement.style.display= 'none';
            }
        },

        _showMobileSearchComponent:function(){
            var srcElement = document.getElementById("mobileSearchDropdown");
            if(srcElement != null) {
              if(srcElement.style.display == "block") {
                  DepartmentJS.close('mobileSearchDropdown');
                srcElement.style.display= 'none';
              }
              else
              {
                $(".subDeptDropdown ").each(function (i, node) {
                    DepartmentJS.close(node.id);
                });
                DepartmentJS.close("departmentsDropdown");
                srcElement.style.display='block';
              }
            }
          },

        setAutoSuggestURL:function(url){
            this.SearchAutoSuggestServletURL = getAbsoluteURL() + url;
        },

        _onFocus:function(evt){
            this.showSearchComponent();
            this.retrieveCachedSuggestions();
        },

        _MobileonFocus:function(evt){
            this.showSearchComponent();
            this.retrieveCachedSuggestions();
        },

        _MobileonBlur:function(evt){
            clearTimeout(this.searchSuggestionHoverTimeout);
            this.searchSuggestionHoverTimeout = setTimeout("SearchJS.showAutoSuggest(false)",100);
        },

        _onKeyPress:function(evt){
            return evt.keyCode !== KeyCodes.RETURN;
        },
        _onKeyDown:function(evt){
            if (evt.keyCode === KeyCodes.RETURN) {
                this._handleEnterKey();
                this.cancelEvent(evt);
            }
            // else if (evt.keyCode === KeyCodes.TAB) {
            //     clearTimeout(this.searchSuggestionHoverTimeout);
            //     this.searchSuggestionHoverTimeout = setTimeout("SearchJS.showAutoSuggest(false)",200);
            // }
        },
        _onKeyUp:function(evt){
            var srcElement = document.getElementById("searchDropdown");
            srcElement.style.display='block';
            this.doAutoSuggest(evt, this.SearchAutoSuggestServletURL, document.CatalogSearchForm.searchTerm.value);
        },
        _onKeyTab: function (evt) {
            if (evt.keyCode === KeyCodes.TAB) {
                $("#searchFilterButton").focus();
            }
        },
        _MobileonKeyUp:function(evt){
            var srcElement = document.getElementById("mobileSearchDropdown");
            srcElement.style.display='block';
            this.doAutoSuggest(evt, this.SearchAutoSuggestServletURL, $("#MobileSimpleSearchForm_SearchTerm").val());
        },

        _handleEnterKey:function() {
            document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
            if(document.CatalogSearchForm.searchTerm.value.length > 0) {
                if(this.END_OF_LIST) {
                    this.gotoAdvancedSearch(byId("advancedSearch").href);
                }
                else if(this.autoSuggestURL !== "" &&  this.autoSuggestURL != (document.location.href + "#")) {
                    //When enter key is hit with one of the suggested keywords or results highlighted, then go to the URL specified for that result..
                    // go to suggested URL
                    document.location.href = appendWcCommonRequestParameters(this.autoSuggestURL);
                }
                else {
                    //Enter key is hit, when the focus was in search term input box.. Submit the form and get the results..
                    document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
                    submitSpecifiedForm(document.CatalogSearchForm);
                }
            }

        },


        _onClick:function(evt){
            document.CatalogSearchForm.searchTerm.value = trim(document.CatalogSearchForm.searchTerm.value);
            if(document.CatalogSearchForm.searchTerm.value.length > 0) {
                if(typeof TealeafWCJS != "undefined"){
                    TealeafWCJS.processDOMEvent(evt);
                }
                submitSpecifiedForm(document.CatalogSearchForm);
            }
            return false;
        },

        _MobileonClick:function(evt){
            document.MobileCatalogSearchForm.searchTerm.value = trim(document.MobileCatalogSearchForm.searchTerm.value);
            if(document.MobileCatalogSearchForm.searchTerm.value.length > 0) {
                if(typeof TealeafWCJS != "undefined"){
                    TealeafWCJS.processDOMEvent(evt);
                }
                submitSpecifiedForm(document.MobileCatalogSearchForm);
            }
            return false;
        },

        doDynamicAutoSuggest:function(url, searchTerm, showHeader) {
            // if pending autosuggest triggered, cancel it.
            if(this.autoSuggestTimer != -1) {
                clearTimeout(this.autoSuggestTimer);
                this.autoSuggestTimer = -1;
            };

            // call the auto suggest
            this.autoSuggestTimer = setTimeout(function() {
                var newurl = url + "&term=" + encodeURIComponent(searchTerm) + "&showHeader=" + showHeader;
                $("#autoSuggestDynamic_Result_div").refreshWidget("updateUrl", newurl);
                console.debug("update autosuggest "+url);
                wcRenderContext.updateRenderContext("AutoSuggest_Context", {});
                this.autoSuggestTimer = -1;
            }, this.autoSuggestKeystrokeDelay);
        },

        gotoAdvancedSearch:function(url) {
            var searchTerm = $("#SimpleSearchForm_SearchTerm").val();
            document.location.href = appendWcCommonRequestParameters(url) + '&searchTerm=' + searchTerm;

        },

        showAutoSuggest:function(display) {
            var autoSuggest_Result_div = document.getElementById("autoSuggest_Result_div");
            var ie_version = Utils.get_IE_version();
            if (ie_version && ie_version < 7) {
                var autoSuggest_content_div = document.getElementById("autoSuggest_content_div");
                var autoSuggestDropDownIFrame = document.getElementById("autoSuggestDropDownIFrame");
            }

            if(autoSuggest_Result_div != null && typeof autoSuggest_Result_div != 'undefined') {
                if(display) {
                    autoSuggest_Result_div.style.display = "block";
                    if (ie_version && ie_version < 7) {
                        autoSuggestDropDownIFrame.style.height = autoSuggest_content_div.scrollHeight;
                        autoSuggestDropDownIFrame.style.display = "block";
                    }
                    this.registerMouseDown();
                }
                else {
                    if (ie_version && ie_version < 7) {
                        autoSuggestDropDownIFrame.style.display = "none";
                        autoSuggestDropDownIFrame.style.height = 0;
                    }
                    autoSuggest_Result_div.style.display = "none";
                    this.unregisterMouseDown();
                }
            }
            else {
                this.unregisterMouseDown();
            }
        },

        showAutoSuggestIfResults:function() {
            // if no results, hide the autosuggest box

            var scrElement = document.getElementById("mobileSearchDropdown");
            if(typeof(staticContent) != "undefined" && $("#" + this.STATIC_CONTENT_SECTION_DIV[0]).html() === "" && $("#autoSuggestHistory").html() === "" && document.getElementById("dynamicAutoSuggestTotalResults") == null) {
                this.showAutoSuggest(false);
            }
            else if(scrElement != null && scrElement.style.display == 'block')
            {
                    if($("#MobileSimpleSearchForm_SearchTerm").val().length <= this.AUTOSUGGEST_THRESHOLD)
                    {
                        this.showAutoSuggest(false);
                    }
                    else
                    {
                        this.showAutoSuggest(true);
                    }
            }
            else {
                    if(document.CatalogSearchForm.searchTerm.value.length <= this.AUTOSUGGEST_THRESHOLD)
                    {
                        this.showAutoSuggest(false);
                    }
                    else
                    {
                        this.showAutoSuggest(true);
                    }
            }
        },

        selectAutoSuggest:function(term) {
            var scrElement = document.getElementById("mobileSearchDropdown");
            if (scrElement != null && scrElement.style.display == 'block'){
                var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
            }else{
                var searchBox = document.CatalogSearchForm.searchTerm;
            }

            searchBox.value = term;
            searchBox.focus();
            this.autoSuggestPreviousTerm = term;
            if(typeof TealeafWCJS != "undefined"){
                TealeafWCJS.createExplicitChangeEvent(searchBox);
            }
            submitSpecifiedForm(document.CatalogSearchForm);
        },

        highLightSelection:function(state, index) {
            var selection = document.getElementById("autoSelectOption_" + index);
            if(selection != null && typeof selection != 'undefined') {
                if(state) {
                    selection.className = "autoSuggestSelected";
                    var scrElement = document.getElementById("mobileSearchDropdown");
                    if (scrElement != null && scrElement.style.display == 'block'){
                        var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
                    }else{
                        var searchBox = document.CatalogSearchForm.searchTerm;
                    }
                    $(searchBox).attr("aria-activedescendant", "suggestionItem_" + index);
                    var totalDynamicResults = document.getElementById("dynamicAutoSuggestTotalResults");
                    if((totalDynamicResults != null && typeof totalDynamicResults != 'undefined' && index < totalDynamicResults.value) || (index >= this.historyIndex)) {
                        searchBox.value = selection.title;
                        this.autoSuggestPreviousTerm = selection.title;
                    }
                    this.autoSuggestURL = selection.href;
                }
                else {
                    selection.className = "";
                }
                return true;
            }
            else {
                return false;
            }
        },

        enableAutoSelect:function(index) {
            this.highLightSelection(false, this.autoSelectOption);
            var item = document.getElementById('autoSelectOption_' + index);
            item.className = "autoSuggestSelected";
            this.autoSelectOption = index;
        },

        resetAutoSuggestKeyword:function() {
            var originalKeyedSearchTerm = document.getElementById("autoSuggestOriginalTerm");
            if(originalKeyedSearchTerm != null && typeof originalKeyedSearchTerm != 'undefined') {
                var scrElement = document.getElementById("mobileSearchDropdown");
                if (scrElement != null && scrElement.style.display == 'block')
                {
                    var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
                }else{
                    var searchBox = document.CatalogSearchForm.searchTerm;
                }
                searchBox.value = originalKeyedSearchTerm.value;
                this.autoSuggestPreviousTerm = originalKeyedSearchTerm.value;
            }
        },


        clearAutoSuggestResults:function() {
            // clear the static search results.
            for (var i = 0; i < staticContent.length; i++) {
                $("#" + this.STATIC_CONTENT_SECTION_DIV[i]).html("");
            }
            this.autoSuggestPreviousTerm = "";
            this.autoSuggestURL = "";
            // clear the dynamic search results;
            $("#autoSuggestDynamic_Result_div").html("");
            this.showAutoSuggest(false);
        },

        doAutoSuggest:function(event, url, searchTerm) {
            searchTerm = searchTerm.trim();
            if(searchTerm.length <= this.AUTOSUGGEST_THRESHOLD ) {
                this.showAutoSuggest(false);
            }

            if (event.keyCode === KeyCodes.RETURN) {
                return;
            }

            if (event.keyCode === KeyCodes.TAB) {
                this.autoSuggestHover = true;
                return;
            }

            if (event.keyCode === KeyCodes.ESCAPE) {
                this.showAutoSuggest(false);
                return;
            }

            if (event.keyCode === KeyCodes.UP_ARROW) {
                var totalDynamicResults = document.getElementById("dynamicAutoSuggestTotalResults");
                if(this.END_OF_LIST) {
                    $("#autoSuggestAdvancedSearch").removeClass("autoSuggestSelected");
                    this.END_OF_LIST = false;
                    this.autoSelectOption--;
                    if(!this.highLightSelection(true, this.autoSelectOption)) {
                        if(this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET && totalDynamicResults != null && typeof totalDynamicResults != 'undefined') {
                            this.autoSelectOption = totalDynamicResults.value-1;
                            this.highLightSelection(true, this.autoSelectOption);
                        }
                    }
                }
                else if (this.highLightSelection(true, this.autoSelectOption-1)) {
                    this.highLightSelection(false, this.autoSelectOption);
                    if(this.autoSelectOption == this.historyIndex) {
                        this.resetAutoSuggestKeyword();
                    }
                    this.autoSelectOption--;
                }
                else if(this.autoSelectOption == this.CACHED_AUTOSUGGEST_OFFSET && totalDynamicResults != null && typeof totalDynamicResults != 'undefined') {
                    this.highLightSelection(false, this.CACHED_AUTOSUGGEST_OFFSET);
                    this.autoSelectOption = totalDynamicResults.value-1;
                    this.highLightSelection(true, this.autoSelectOption);
                }
                else {
                    // up arrow back to the very top
                    this.highLightSelection(false, this.autoSelectOption);
                    this.autoSelectOption = -1;
                    var originalKeyedSearchTerm = document.getElementById("autoSuggestOriginalTerm");
                    this.resetAutoSuggestKeyword();
                }
                return;
            }

            if (event.keyCode === KeyCodes.DOWN_ARROW) {
                if(this.highLightSelection(true, this.autoSelectOption+1)) {
                    this.highLightSelection(false, this.autoSelectOption);
                    this.autoSelectOption++;
                }
                else if(this.autoSelectOption < this.CACHED_AUTOSUGGEST_OFFSET && this.highLightSelection(true, this.CACHED_AUTOSUGGEST_OFFSET)) {
                    // down arrow into the cached autosuggest section
                    this.highLightSelection(false, this.autoSelectOption);
                    this.autoSelectOption = this.CACHED_AUTOSUGGEST_OFFSET;
                    this.resetAutoSuggestKeyword();
                }
                else if(!this.END_OF_LIST) {
                    $("#autoSuggestAdvancedSearch").addClass("autoSuggestSelected");
                    this.highLightSelection(false, this.autoSelectOption);
                    this.autoSelectOption++;
                    this.END_OF_LIST = true;
                    var scrElement = document.getElementById("mobileSearchDropdown");
                    if (scrElement != null && scrElement.style.display == 'block'){
                        var searchBox = document.getElementById("MobileSimpleSearchForm_SearchTerm");
                    }else{
                        var searchBox = document.CatalogSearchForm.searchTerm;
                    }
                    $(searchBox).attr("aria-activedescendant", "advancedSearch");
                }
                return;
            }

            if(searchTerm.length > this.AUTOSUGGEST_THRESHOLD && searchTerm == this.autoSuggestPreviousTerm) {
                return;
            }
            else {
                this.autoSuggestPreviousTerm = searchTerm;
            }

            if(searchTerm.length <= this.AUTOSUGGEST_THRESHOLD) {
                return;
            };

            // cancel the dynamic search if one is pending
            if(this.autoSuggestTimer != -1) {
                clearTimeout(this.autoSuggestTimer);
                this.autoSuggestTimer = -1;
            }

            if(searchTerm !== "") {
                this.autoSelectOption = -1;
                var hasResults = this.doStaticAutoSuggest(searchTerm);
                if(searchTerm.length > this.DYNAMIC_AUTOSUGGEST_THRESHOLD) {
                    var showHeader = true; // hasResults;
                    this.doDynamicAutoSuggest(url, searchTerm, showHeader);
                }
                else {
                    // clear the dynamic results
                    $("#autoSuggestDynamic_Result_div").html("");
                }
            }
            else {
                this.clearAutoSuggestResults();
            }
        },

        tokenizeForBidi:function(displayName, searchName, searchTerm, searchTermLower) {
            var tokens = displayName.split( " > " );
            var html = "";
            var str = "";
            if(tokens.length > 0) {
                html = html + "<div class='category_list'>";
                for(i = 0; i < tokens.length; i++) {
                    if(i!=0) {
                        // not the first token
                        html = html + "<span class='gt'>&nbsp; > &nbsp;</span>";
                    }
                    if(i == tokens.length - 1) {
                        // last token
                        var index = searchName.toLowerCase().indexOf(searchTermLower);
                        var subStringBefore = searchName.substr(0, index);
                        var subStringAfter =  searchName.substr(index + searchTerm.length);
                        var highLighted = "<span class='highlight'>" + searchTerm + "</span>";
                        str = subStringBefore + highLighted + subStringAfter;
                    }
                    else {
                        str = tokens[i];
                    }
                    html = html + str;
                }
                html = html + "</div>";
            }
            return html;
        },

        // doStaticAutoSuggest:function(searchTerm) {
        //     var resultList = ["", "", "", "", "", ""];
        //     var emptyCell = 0;
        //     var searchTermLower = searchTerm.toLowerCase();
        //     var listCount = this.CACHED_AUTOSUGGEST_OFFSET;
        //     var divStart = "<div class='list_section'><div";
        //     var divEnd =   "</div></div>";

        //     for(var i = 0; i < staticContent.length; i++) {
        //         var count = 0;
        //         for(var j = 0; j < staticContent[i].length; j++) {
        //             var searchName = staticContent[i][j][0];
        //             var searchURL = staticContent[i][j][1];
        //             var displayName = staticContent[i][j][2];
        //             var index = searchName.toLowerCase().indexOf(searchTermLower);
        //             if(index != -1) {

        //                 var htmlDisplayName = this.tokenizeForBidi(displayName, searchName, searchTerm, searchTermLower);

        //                 resultList[i] = resultList[i] + "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" + listCount + "' role='listitem' tabindex='-1'><a id='autoSelectOption_" + listCount + "' title='" + escapeXml(searchName, true) + "' onmouseout='this.className=\"\"; this.autoSuggestURL=\"\";' onclick='SearchJS.hideSearchComponent();' onmouseover='SearchJS.enableAutoSelect(" + listCount + "); this.autoSuggestURL=this.href;' href=\"" + searchURL + "\">" + htmlDisplayName + "</a></li></ul>";
        //                 count++;
        //                 listCount++;
        //                 if(count >= this.TOTAL_SUGGESTED) {
        //                     break;
        //                 }
        //             }
        //         }
        //     }

        //     for (var i = 0; i < staticContent.length; i++) {
        //         $("#" + this.STATIC_CONTENT_SECTION_DIV[i]).html("");
        //         if(resultList[i] !== "") {
        //             var heading =  "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" + staticContentHeaders[i] + "</span></li></ul>";
        //             $("#" + this.STATIC_CONTENT_SECTION_DIV[emptyCell]).html(heading + divStart + " role='list' title='" + staticContentHeaders[i] + "' aria-label='" + staticContentHeaders[i] + "'>" + resultList[i] + divEnd);
        //             emptyCell++;
        //         }
        //     }

        //     var historyList = "";
        //     var searchHistorySection = document.getElementById("autoSuggestHistory");
        //     searchHistorySection.innerHTML = "";
        //     var historyArray = [];
        //     this.historyIndex = listCount;

        //     var searchHistoryCookie = getCookie("searchTermHistory");
        //     if(typeof(searchHistoryCookie) != 'undefined') {
        //         var termsArray = searchHistoryCookie.split("|");
        //         var count = 0;
        //         for(var i = termsArray.length - 1; i > 0; i--) {
        //             var theTerm = termsArray[i];
        //             var theLowerTerm = theTerm.toLowerCase();
        //             if(theLowerTerm.match("^"+searchTermLower) == searchTermLower) {
        //                 var repeatedTerm = false;
        //                 for(var j = 0; j < historyArray.length; j++) {
        //                     if(historyArray[j] == theLowerTerm) {
        //                         repeatedTerm = true;
        //                         break;
        //                     }
        //                 }
        //                 if(!repeatedTerm) {
        //                     if(count >= this.TOTAL_HISTORY) {
        //                         break;
        //                     }
        //                     historyList = historyList + "<ul class='autoSuggestDivNestedList'><li id='suggestionItem_" + listCount + "' role='listitem' tabindex='-1'><a href='#' onmouseout='this.className=\"\"' onmouseover='SearchJS.enableAutoSelect(" + listCount + ");' onclick='SearchJS.selectAutoSuggest(this.title); return false;' title='" + theTerm + "' id='autoSelectOption_" + listCount+ "'><strong>" + searchTerm + "</strong>" + theTerm.substring(searchTerm.length, theTerm.length) + "</a></li></ul>";
        //                     historyArray.push(theLowerTerm);
        //                     count++;
        //                     listCount++;
        //                 }
        //             }
        //         }
        //     }

        //     if (this.staticContentHeaderHistory === "") {
        //         this.staticContentHeaderHistory = Utils.getLocalizationMessage("HISTORY");
        //     }

        //     if(historyList !== "") {
        //         var heading =  "<ul class='autoSuggestDivNestedList'><li class='heading'><span>" + this.staticContentHeaderHistory + "</span></li></ul>"
        //         searchHistorySection.innerHTML = heading + divStart + " title='" + this.staticContentHeaderHistory + "'>" + historyList + divEnd;
        //         emptyCell++;
        //     }

        //     if(emptyCell > 0) {
        //         this.showAutoSuggest(true);
        //         return true;
        //     }

        //     return false;
        // },

        // retrieveCachedSuggestions:function() {
        //     if(!this.retrievedCachedSuggestions) {
        //         wcRenderContext.updateRenderContext("CachedSuggestions_Context", {});
        //     }
        // },

        /**
         * Updates the searchTermHistory cookie value...
         */
        // updateSearchTermHistoryCookie:function(updatedSearchTerm){
        //     var cookieKey = "searchTermHistory";
        //     var cookieValue = "|" + updatedSearchTerm;
        //     var searchTermHistoryCookie = getCookie(cookieKey);
        //     if(typeof(searchTermHistoryCookie) != 'undefined') {
        //         cookieValue = setCookie(cookieKey) + cookieValue;
        //     }
        //     setCookie(cookieKey, cookieValue, {path:'/', domain:cookieDomain});
        // },

        // updateSearchTermHistoryCookieAndRedirect:function(updatedSearchTerm, redirectURL){
        //     this.updateSearchTermHistoryCookie(updatedSearchTerm);
        //     if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
        // },

        isValidNumber:function(n) {
            return !isNaN(parseFloat(n)) && isFinite(n) && n >= 0;
        },

        /**
         * Validation method for advanced search form
         */
        validateForm: function(form) {
            form["minPrice"].value = trim(form["minPrice"].value);
            form["maxPrice"].value = trim(form["maxPrice"].value);

            var minValue = form["minPrice"].value;
            var maxValue = form["maxPrice"].value;

            var minIsValid = this.isValidNumber(minValue);
            var maxIsValid = this.isValidNumber(maxValue);

            if(minValue.length > 0 && !minIsValid) {
                MessageHelper.formErrorHandleClient(form["minPrice"].id, MessageHelper.messages["EDPPaymentMethods_AMOUNT_NAN"]);
                return false;
            }
            else if(maxValue.length > 0 && !maxIsValid) {
                MessageHelper.formErrorHandleClient(form["maxPrice"].id, MessageHelper.messages["EDPPaymentMethods_AMOUNT_NAN"]);
                return false;
            }
            else if (minValue.length > 0 && maxValue.length > 0 && parseFloat(minValue) > parseFloat(maxValue)) {
                MessageHelper.formErrorHandleClient(form["maxPrice"].id, MessageHelper.messages["ERROR_PRICE_RANGE"]);
                return false;
            }

            form["searchTerm"].value = trim(form["searchTerm"].value);
            form["filterTerm"].value = trim(form["filterTerm"].value);
            form["manufacturer"].value = trim(form["manufacturer"].value);

            var searchTerm = form["searchTerm"].value;
            var filterTerm = form["filterTerm"].value;
            var manufacturer = form["manufacturer"].value;

            if (searchTerm.length == 0 && filterTerm.length == 0 && manufacturer.length == 0) {
                MessageHelper.formErrorHandleClient(form["searchTerm"].id, MessageHelper.messages["ERROR_EMPTY_SEARCH_FIELDS"]);
                return false;
            }

            processAndSubmitForm(form);
        },

        registerMouseDown: function() {
            if (this.mouseDownConnectHandle == null) {
                this.mouseDownConnectHandle = $(document.documentElement).on("mousedown", $.proxy("handleMouseDown", this));
            }
        },

        unregisterMouseDown: function() {
            if (this.mouseDownConnectHandle != null) {
                $(document.documentElement).off("mousedown");
                this.mouseDownConnectHandle = null;
            }
        },

        handleMouseDown: function(evt) {
            var node = evt.target;
            if (node != document.documentElement) {
                var searchDropdown = document.getElementById("searchDropdown");
                var searchTerm = document.CatalogSearchForm.searchTerm;
                var close = true;
                while (node) {
                    if (node == searchDropdown || node == searchTerm) {
                        close = false;
                        break;
                    }
                    node = node.parentNode;
                }
                if (close) {
                    this.showAutoSuggest(false);
                }
            }
        },

        declareAutoSuggestRefreshArea: function() {
            // ============================================
            // div: autoSuggestDynamic_Result_div refresh area
            // Declares a new refresh controller for Auto Suggest

            // common render context
            wcRenderContext.declare("AutoSuggest_Context", ["autoSuggestDynamic_Result_div"], null);

            /**
             * Displays the keyword suggestions from the search index
             * This function is called when a render context changed event is detected.
             */
            var renderContextChangedHandler = function() {
                var renderContext = wcRenderContext.getRenderContextProperties("AutoSuggest_Context");
                $("#autoSuggestDynamic_Result_div").refreshWidget("refresh", renderContext);
            };

            /**
             * Display the results.
             */
            var postRefreshHandler = function() {
                  var response = document.getElementById('suggestedKeywordResults');
                  var productsResponse = document.getElementById('suggestedProductsResults');
                  if(response == null && productsResponse == null) {
                    // No response or an error page.   Clear the contents.
                    $("#autoSuggestDynamic_Result_div").html("");
                  }
                  SearchJS.showAutoSuggestIfResults();
            };

            // initialize widget
            $("#autoSuggestDynamic_Result_div").refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        },

        declareAutoSuggestCachedSuggestionRefreshArea: function() {
            // ============================================
            // div: autoSuggestCachedSuggestions_div refresh area
            // Declares a new refresh controller for Auto Suggest

            // common render context
            wcRenderContext.declare("CachedSuggestions_Context", ["autoSuggestCachedSuggestions_div"], null);

           /**
            * Retrieves the cached suggestions used in the autosuggest box.
            * This function is called when a render context changed event is detected.
            */
            var renderContextChangedHandler = function() {
                var renderContext = wcRenderContext.getRenderContextProperties("CachedSuggestions_Context");
                $("#autoSuggestCachedSuggestions_div").refreshWidget("refresh", renderContext);
            };

            /**
             * Updates the cached suggestions.
             */
            var postRefreshHandler = function() {
                var response = document.getElementById('cachedSuggestions');
                if(response == null) {
                    // No response or an error page.   Clear the contents.
                    $("#autoSuggestCachedSuggestions_div").html("");
                }
                else {
                    var scripts = response.getElementsByTagName("script");
                    var j = scripts.length;
                    for (var i = 0; i < j; i++){
                        var newScript = document.createElement('script');
                        newScript.type = "text/javascript";
                        newScript.text = scripts[i].text;
                        document.getElementById('autoSuggestCachedSuggestions_div').appendChild (newScript);
                    }
                    SearchJS.retrievedCachedSuggestions = true;
                    var scrElement = document.getElementById("mobileSearchDropdown");
                    if (scrElement != null && scrElement.style.display == 'block')
                    {
                        searchTerm = $("#MobileSimpleSearchForm_SearchTerm").val();
                    }
                        else
                    {
                    searchTerm = document.CatalogSearchForm.searchTerm.value;
                    }
                    if(searchTerm.length > SearchJS.AUTOSUGGEST_THRESHOLD) {
                        SearchJS.doStaticAutoSuggest(searchTerm);
                    }
                }
            };

            // initialize widget
            $("#autoSuggestCachedSuggestions_div").refreshWidget({renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler});
        }
    };
};

;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

function ShoppingListJS(storeParams, catEntryParams, shoppingListNames, jsObjectName) {

	this.storeParams = storeParams;

	this.catEntryParams = catEntryParams;

	this.catEntryParams.quantity = 1;

	this.shoppingListNames = shoppingListNames;

	this.addItemAfterCreate = false;

	this.jsObjectName = jsObjectName;

	this.dropDownVisible = false;

	this.dropDownInFocus = false;

	this.dropDownOpen = false;

	this.exceptionFlag = false;

	this.mouseOnArrow = false;

	this.pageName = "";

	this.itemId = -1;

	var eventName = "";

	/**
	 * Keep track of the wish list name that is to be deleted. This is needed only for the my account personal wish
	 * list management UI.
	 **/
	this.nameToDelete = "";

	/**
	 * Keep track of the orderItemId that is to be deleted from the shopping cart after successfully adding an item to the
	 * wish list. This is needed only for the shopping cart and checkout related UI that uses this button code.
	 **/
	this.orderItemId = "";

	/**
	 * Keep track of the current action being performed by this button widget. This action is needed when there are several
	 * same button widgets in the same page such as the shopping cart page UI. We need to know which button is actually doing
	 * actions so that we know when to display success dialogs. Otherwise, all buttons display success dialogs.
	 **/
	this.actionBeingPerformed = "";

	if(jsObjectName != 'shoppingListJS'){
		this.pageName = jsObjectName.replace('shoppingListJS', '');
		eventName = this.pageName + "_";
	}

	/**
	 * Setter for catEntryQuantity
	 *
	 * @param {Integer} catEntryQuantity
	 */
	this.setCatEntryQuantity = function(catEntryQuantity){
        	var catEntryQuantity = $.parseJSON(catEntryQuantity);
		// If the quantity is an object
        	if ($.isPlainObject(catEntryQuantity)) {
			var component = this.catEntryParams.components[catEntryQuantity.baseItemId];
			// component is a product and a new sku is available
			if(component.id != catEntryQuantity.baseItemId && catEntryQuantity.id !=0){
				component.id = catEntryQuantity.id;
			}
			component.quantity = catEntryQuantity.quantity;
		// If the quantity is a single value
		} else {
			this.catEntryParams.quantity = catEntryQuantity;
		}
	};

	/**
	 * Setter for catEntryAttributes
	 *
	 * @param {Integer} catEntryAttributes
	 */
	this.setCatEntryAttributes = function(catEntryAttributes){
        	this.catEntryParams.attributes = $.parseJSON(catEntryAttributes);
	};

	/**
	 * Setter for itemId
	 *
	 * @param {Integer} catEntryId
	 */
	this.setItemId = function(catEntryId){
		this.itemId = catEntryId;
	};

	/**
	 * Hides the dropdown with shopping list names if it exists
	 */
	this.hideDropDown = function() {
        	var dropDown = $('#' + this.pageName + 'shoppingListDropDown');
		if (dropDown) {
	            	$(dropDown).css('display', 'none');
	            	$("#" + this.pageName + "addToShoppingListBtn .drop").first().focus();
			this.dropDownVisible = false;
			this.dropDownInFocus = false;
			this.dropDownOpen = false;

            		var contentRightBorder = $(".widget_quick_info_popup .content_right_border").first();
			if (contentRightBorder != undefined) {
                		$(contentRightBorder).css('height', 'auto');
			}
		}
	};

	/**
	 * Shows the dropdown with shopping list names & a create a new shopping list link - if authenticated
	 * If not authenticated, redirects user to login page
	 */
	this.showDropDown = function() {
		if(this.dropDownOpen == false){
            var contentRightBorder = $(".widget_quick_info_popup .content_right_border").first();
            var ocontentRightBorderH = $(contentRightBorder).height();
            var dropDown = ('#' + this.pageName + 'shoppingListDropDown');
            $(dropDown).css('display', '');
			this.dropDownVisible = true;

            $("#" + this.pageName + "shoppingListDropDown.dropdown_list div").removeClass("focused");

            if ($("#quickInfoRefreshArea") && $("#QuickInfoshoppingListDropDown")) { // check if dropdown is shown in a QuickInfo popup
                var quickInfoRefreshAreaH = $("#quickInfoRefreshArea").height();
                var shoppingListDropDownH = $("QuickInfoshoppingListDropDown").height();
                var contentRightBorderH = $(contentRightBorder).height();
			}
			this.dropDownOpen = true;
		}
		else{
			this.hideDropDown();
		}
	};

	/**
	 * Show appropriate popups to create, update or delete Shopping List
	 *
	 * @param {String}
	 *            action type of popup to be shown (create, update or delete)
	 */
	this.showPopup = function(action){
		this.hideDropDown();
		this.clearPopupText();
		var popup = $("#" + this.pageName + action + "ShoppingListPopup").data("wc-WCDialog");
		var newListName = $("#" + this.pageName + "newListName");
		popup.option("close_on_primary_click", false);
		this.hideErrorMessage();
		this.hideEditErrorMessage();
		if (popup) {
			closeAllDialogs(); //close other dialogs(quickinfo dialog, etc) before opening this.
			popup.close();//close all popups
			// Add a delay to showing the popup to give closeAllDialogs() a bit of time to do it's job
			setTimeout(function() {
				popup.open();
				if (action === 'create') {
					$(newListName).focus();
				} else if (action === 'edit') {
					$("#editListName").focus();
				}
			}, 250);
		}else {
			console.debug(action+"ShoppingListPopup"+" does not exist");
		}
	};

	/**
	 * Method to display message dialog on successful creation of shopping list.
	 *
	 */
	 this.showSuccessDialog = function(){
		var popup = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data("wc-WCDialog");
		if (popup && this.actionBeingPerformed !== "") {
			$("#" + this.pageName + "successMessageAreaText").html(Utils.getLocalizationMessage('LIST_CREATED'));
			popup.open();
			this.actionBeingPerformed = "";
		}
	 };

	/**
	 * Method to display message dialog on successful creation of shopping list.
	 *
	 */
	 this.showMessageDialog = function(message){
		var popup = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data("wc-WCDialog");

		if (popup) {
			$("#" + this.pageName + "successMessageAreaText").html(message);
			popup.open();
		}
	 };

	/**
	 * Method to close/hide message dialog on successful creation of shopping list.
	 *
	 */
	this.hideMessageDialog = function(){
		var popup = $("#" + this.pageName + "shoppingListCreateSuccessPopup").data("wc-WCDialog");

		if (popup) {
			popup.close();
		}
	};

	/**
	 * Method to display error message pertaining to shopping list
	 * @param (string) msg The error/information message to be displayed
	 *
	 */
	this.showErrorMessage = function(msg){
		if(document.getElementById(this.pageName + "shoppingListErrorMessageArea") && document.getElementById(this.pageName + "shoppingListErrorMessageText")){
			document.getElementById(this.pageName + "shoppingListErrorMessageText").innerHTML = msg;
			document.getElementById(this.pageName + "shoppingListErrorMessageArea").style.display = "block";
		}
	};

	/**
	 * Method to hide error message display area
	 *
	 */
	this.hideErrorMessage = function(){
		if(document.getElementById(this.pageName + "shoppingListErrorMessageArea") && document.getElementById(this.pageName + "shoppingListErrorMessageText")){
			document.getElementById(this.pageName + "shoppingListErrorMessageText").innerHTML = "";
			document.getElementById(this.pageName + "shoppingListErrorMessageArea").style.display = "none";
		}
	};

	/**
	 * Method to display error message pertaining to change shopping list name
	 * @param (string) msg The error/information message to be displayed
	 *
	 */
	this.showEditErrorMessage = function(msg){
		if(document.getElementById("editShoppingListErrorMessageArea") && document.getElementById("editShoppingListErrorMessageText")){
			document.getElementById("editShoppingListErrorMessageText").innerHTML = msg;
			document.getElementById("editShoppingListErrorMessageArea").style.display = "block";
		}
	};

	/**
	 * Method to hide error message display area from the change shopping list name dialog
	 *
	 */
	this.hideEditErrorMessage = function(){
		if(document.getElementById("editShoppingListErrorMessageArea") && document.getElementById("editShoppingListErrorMessageText")){
			document.getElementById("editShoppingListErrorMessageText").innerHTML = "";
			document.getElementById("editShoppingListErrorMessageArea").style.display = "none";
		}
	};

	/**
	 * Method to create a new shopping list
	 *
	 */
	this.create = function(){
		// picks the new shopping list name and trims it
        var name = trim($("#" + this.pageName + "newListName").val());
        var maxlength = $("#" + this.pageName + "newListName").maxLength;
		var defaultName = Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME');

		if (this.empty(name)) {
			// display error message saying list name is empty.
			this.showErrorMessage(Utils.getLocalizationMessage('ERR_NAME_EMPTY'));
		} else if(!MessageHelper.isValidUTF8length(name, maxlength)){
			// check for max length
			this.showErrorMessage(Utils.getLocalizationMessage('ERR_NAME_TOOLONG'));
		} else if(name == defaultName) {
			// show error message saying that DEFAULT cannot be used
			this.showErrorMessage(Utils.getLocalizationMessage('ERR_NAME_SHOPPING_LIST'));
		} else if(this.isDuplicate(name)){
			// show error message saying that a wish list with the same name already exists
			this.showErrorMessage(Utils.getLocalizationMessage('ERR_NAME_DUPLICATE'));
		} else if(!this.validateWishName(name)){
			// show error message saying that wish list name is invalid
			this.showErrorMessage(Utils.getLocalizationMessage('INVALID_NAME_SHOPPING_LIST'));
		} else {
			var params = this.setCommonParams();
			params.name = name;

			// For Handling multiple clicks.
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			// calling the service to save the new list name
			wcService.invoke('ShoppingListServiceCreate',params);
			this.actionBeingPerformed = "create";
		}
	};

	/**
	 * Creates the default shopping list with name 'Wish List' and adds the displayed item to this list.
	 * If the default shopping list is already created, just adds the item to the existing list.
	 * Also, redirects the user to login page if not authenticated.
	 *
	 * @param {Integer} listId - id of the default shopping list if present, else -1 is passed
	 */
	this.createDefaultListAndAddItem = function(listId, orderItemId, focusElement){
		if (orderItemId && orderItemId != "") {
			this.orderItemId = orderItemId;
		}

		if("-1" == listId){
			var params = this.setCommonParams();
			params.name = Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME');

			// For Handling multiple clicks.
			if(!submitRequest()){
				return;
			}
			cursor_wait();
			this.addItemAfterCreate = true;
			// calling the service to save the new list name
			wcService.invoke('ShoppingListServiceCreate',params);
		} else {
			if (orderItemId && orderItemId != "") {
				this.addToListAndDelete(listId, orderItemId, focusElement);
			} else {
				this.addToList(listId, focusElement);
			}
		}
	};

	/**
	 * add an item/product/bundle/package to a wish list
	 *
	 * @param {string}
	 *            listId id of the item/product/bundle/package be
	 *            added
	 */
	this.addToList = function(listId, focusElement){
		this.hideDropDown();

		var params = this.setCommonParams();
		params.giftListId = listId;

		var catEntryId = this.catEntryParams.id;
		//Add the parent product to the cart.
		if(this.catEntryParams.type.toLowerCase() == 'itembean'
			|| this.catEntryParams.type.toLowerCase() == 'packagebean'
			|| this.catEntryParams.type.toLowerCase() == 'preddynakitbean'
			|| this.catEntryParams.type.toLowerCase() == 'dynamickitbean'){
			updateParamObject(params,"catEntryId",this.catEntryParams.id,false,-1);
			updateParamObject(params,"quantity",this.catEntryParams.quantity,false,-1);
		} else if (this.catEntryParams.type.toLowerCase() == 'bundlebean') {
			// Add items in the bundle
			var resolved = true;
			for (baseItemId in this.catEntryParams.components) {
				if (this.catEntryParams.components[baseItemId].skus && this.catEntryParams.components[baseItemId].skus.length > 1) {
					// If component has multiple SKUs, meaning defining attributes
					var resolvedValue = this.catEntryParams.components[baseItemId].resolved;
					if (resolvedValue == null || resolvedValue == "undefined" || resolvedValue == false) {
						// If any component is unresolved (ie. attributes not selected), do not allow adding to the list
						resolved = false;
						break;
					}
				}
			}
			if (!resolved) {
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
				return;
			}
			else {
				for(baseItemId in this.catEntryParams.components){
					updateParamObject(params,"catEntryId",this.catEntryParams.components[baseItemId].id,false,-1);
					updateParamObject(params,"quantity",this.catEntryParams.components[baseItemId].quantity,false,-1);
				}
			}
		} else {
			// Resolve ProductBean to an ItemBean based on the attributes in the main page
			var sku = this.itemId;
			if (sku == -1){
				sku = this.resolveSKU();
			}
			if(-1 == sku){
				MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
				return;
			} else {
				catEntryId = sku;
				updateParamObject(params,"catEntryId",sku,false,-1);
				updateParamObject(params,"quantity",this.catEntryParams.quantity,false,-1);
			}
		}
		if(this.jsObjectName != 'shoppingListJS'){
			QuickInfoJS.close();
		}

		// For Handling multiple clicks.
		if(!submitRequest()){
			return;
		}

		cursor_wait();
		ShoppingListDialogJS.setDialogParams(this.storeParams, {catEntryId:catEntryId, thumbnail: 'imgPath', focusElement: focusElement});
		wcService.invoke('ShoppingListServiceAddItem',params);

	};

	/**
	 * Checks if shopping list name already exists
	 *
	 * @param {String} listName, name of the shopping list to be created
	 * @return {Boolean} true, if a duplicate is present
	 * 					 false, if no duplicates present
	 */
	this.isDuplicate = function(listName) {
		var listName = this.escapeXml(listName, true);
		return (this.shoppingListNames[listName.toUpperCase()] == 1);
	};

	/**
	 * Updates the dom object representing the default shopping list with onclick function and also updates the shopping list
	 *
	 * @param {Integer} listId, default shopping list id
	 */
    	this.updateDefaultListId = function(listId){
		this.shoppingListNames[Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME')] = 1;
    		if ($('#'+this.pageName+'addToShoppingList')) {
    			$('#'+this.pageName+'addToShoppingList').attr('href' ,'"javascript:" + this.jsObjectName + ".createDefaultListAndAddItem(" + listId + ");"');
		}
    	};

	/**
	 * Adds an entry in shopping list dropdown. Also updates the shopping list names with the new name.
	 *
	 * @param {Integer} listId, id of the new shopping list that got created
	 * @param {String} listName, name of the new shopping list that got created
	 */
	this.updateShoppingList = function(listId, listName, action){
		var listNameEsc = this.escapeXml(listName, false);
		this.shoppingListNames[listNameEsc.toUpperCase()] = 1;

		if (action && (action == 'edit' || action == 'delete')) {
			this.shoppingListNames[this.nameToDelete.toUpperCase()] = -1;
		}

        var dropdownWidgetNode = $('#' + this.pageName + 'ShoppingListDivider');
        if (dropdownWidgetNode) {
            var eventHandlerString = "javascript: this.className = 'created_list';";

            if (this.pageName.indexOf("OI") == -1) {
                $('#' + this.pageName + 'ShoppingListDivider').before('<div role="menuitem" id="' + this.pageName + 'ShoppingList_' + listId + '" class="created_list" onfocus="javascript:' + jsObjectName + '.focusList(\'' + listId +
                    '\'); "  onblur="' + eventHandlerString + '" onclick="javascript:' + jsObjectName + '.addToList(\'' + listId +
                    '\');"><a role="menuitem" id="' + this.pageName + 'ShoppingListLink_' + listId + '" href="javascript:' + jsObjectName + '.addToList(\'' + listId +
                    '\');" onfocus="javascript:' + jsObjectName + '.focusListLink(\'' + listId + '\');">' + listName + '</a></div>');
            } else {
                var oiId = this.pageName.replace("OI", "");
                $('#' + this.pageName + 'ShoppingListDivider').before('<div role="menuitem" id="' + this.pageName + 'ShoppingList_' + listId + '" class="created_list" onfocus="javascript:' + jsObjectName + '.focusList(\'' + listId +
                    '\'); "  onblur="' + eventHandlerString + '" onclick="javascript:' + jsObjectName + '.addToListAndDelete(\'' + listId +
                    '\',\'' + oiId + '\');"><a role="menuitem" id="' + this.pageName + 'ShoppingListLink_' + listId + '" href="javascript:' + jsObjectName + '.addToListAndDelete(\'' + listId +
                    '\',\'' + oiId + '\');" onfocus="javascript:' + jsObjectName + '.focusListLink(\'' + listId + '\');">' + listName + '</a></div>');
            }
        }
    };

	/**
	 * Clears the textbox in the popup
	 */
	this.clearPopupText = function(){
        $("#" + this.pageName + "newListName").val("");
	};

	/**
	 * Converts & < > " ' to xml accepted form
	 *
	 * @param {String} str, String to be converted
	 * @param {Boolean} fullConversion, if true converts & < > " ' chars
	 * 									if false converts only " ' chars
	 *
	 * @return {String} converted string
	 */
	this.escapeXml = function(str, fullConversion){
		if(fullConversion){
			str = str.replace(/&/gm, "&amp;").replace(/</gm, "&lt;").replace(/>/gm, "&gt;");
		}
		str = str.replace(/"/gm, "&#034;").replace(/'/gm, "&#039;");
		return str;
	};

	 /**
	  * Based on the selected attributes, resolve the SKU of the product.
	  *
	  * @return {Integer} uniqueId of the SKU
	  */
	 this.resolveSKU = function() {
		// if there is only one sku, no need to resolve.
		if(this.catEntryParams.skus.length == 1){
			return this.catEntryParams.skus[0].id;
		}
		for (idx = 0; idx < this.catEntryParams.skus.length; idx++) {
			var matches = 0;
			var attributeCount = 0;
			// iterate through each attribute
			for (attribute in this.catEntryParams.skus[idx].attributes) {
				attributeCount++;
				// check for matches
				if (this.catEntryParams.attributes
						&& this.catEntryParams.skus[idx].attributes[attribute] == this.catEntryParams.attributes[attribute]) {
					matches++;
				} else {
					break;
				}
			}
			// if all the attributes match, pick that SKU
			if (0 != matches && matches == attributeCount) {
				return this.catEntryParams.skus[idx].id;
			}
		}
		// no match found
		return -1;
	};

	/**
	 * Sets the store specific values such as storeId, catalogId and langId in a Object and returns it.
	 *
	 * @return {Object} params with store specific values
	 */
	this.setCommonParams = function(){
		var params = {};
		params.storeId		= this.storeParams.storeId;
		params.catalogId	= this.storeParams.catalogId;
		params.langId		= this.storeParams.langId;
		return params;
	};

	/**
	 * Checks if the string is null, undefined or empty
	 *
	 * @param {String} str, value to be checked
	 * @return {Boolean} true, if empty
	 * 					 false, if not empty
	 */
	this.empty = function(str) {
		return (str == null || str == undefined || str == "");
	};

	/**
	 * redirect users to the sign on page
	 */
	this.redirectToSignOn = function() {
		// 3 scenario's are possible
		/*
		*	Scenario 1 - Current Page Loaded with HTTP
		*				 In this case, the page will be reloaded with HTTPS and globalLogIn panel is opened up.
		*				 GlobalLoginJS.updateGlobalLoginSignInContent does this work and uses WC_RedirectToPage_xxx cookie to
		*				 identify the page to display after logIn.
		*   Scenario 2 - Current page is loaded with HTTPS and signIn panel is already loaded.
		*				 In this case, before displayiong signIn panel, update the URL field value of the signIn panel form.
		*	Scenario 3 - Current page is laoded with HTTPS, but signIn panel is NOT yet loaded.
		*				 Ajax call is made to load the panel. Send reload URL as part of the ajax call, based on WC_RedirectToPage_xxx cookie value.
		*/
		var currentURL = document.location.href;
		var widgetId = 'Header_GlobalLogin'; // This widgetId is defined in Header_UI.jspf / GlobalLoginActions.js / UserTimeoutView.jsp
		setCookie("WC_RedirectToPage_"+WCParamJS.storeId, currentURL , {path:'/', domain:cookieDomain});
		GlobalLoginJS.InitHTTPSecure(widgetId);
	};


	/**
	 * changes the style class to show which shopping list is currently focused
	 */
	this.focusList = function(listId){
		this.focusListByElementId(this.pageName + "ShoppingList_" +listId);
	};

	/**
	 * changes the style class to show which shopping list is currently focused
	 */
	this.focusListByElementId = function(elementId){
        if ($("#" + elementId).hasClass("focused")) {
			return;
		}
        $("#" + elementId.replace("ShoppingList", "ShoppingListLink")).focus();

	};

	/**
	 * changes the style class to show which shopping list is currently focused
	 */
	this.focusListLink = function(listId){
        $("#" + this.pageName + "shoppingListDropDown.dropdown_list div").removeClass("focused");
        $("#" + this.pageName + "ShoppingList_" + listId).addClass("focused");
	};

	this.updateShoppingListAndAddItem = function(serviceResponse){
		if(serviceResponse.listName == Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME')){
			this.updateDefaultListId(serviceResponse.listId);
		} else {
			this.updateShoppingList(serviceResponse.listId, serviceResponse.listName, serviceResponse.action);
		}

		if(this.addItemAfterCreate){
			this.addItemAfterCreate = false;
			if (this.orderItemId != "") {
				this.addToListAndDelete(serviceResponse.listId, this.orderItemId);
			} else {
				this.addToList(serviceResponse.listId);
			}
		} else {
			if (serviceResponse.action == 'add') {
				this.showSuccessDialog();
			}
		}
	};

	this.navigateDropDown = function(event){
		var shoppingListObj = this;
		if (event.keyCode === KeyCodes.UP_ARROW) {
			Utils.stopEvent(event);

			var focusChanged = false;
			var dropdownList = $( "#" + shoppingListObj.pageName + "shoppingListDropDown.dropdown_list div.created_list" );
			dropdownList.each(function (index, element) {
				if (!focusChanged && ($(element).hasClass("focused"))) {
					if(0 == index){
						shoppingListObj.focusListByElementId($(dropdownList).get(dropdownList.length-1).id);
					} else {
						shoppingListObj.focusListByElementId($(dropdownList).get(index-1).id);
					}
					focusChanged = true;
				}
			});
		} else if (event.keyCode === KeyCodes.DOWN_ARROW) {
			Utils.stopEvent(event);

			var focusChanged = false;
			var dropdownList = $("#" + shoppingListObj.pageName + "shoppingListDropDown.dropdown_list div.created_list");
			dropdownList.each(function (index, element) {
				if (!focusChanged && ($(element).hasClass("focused"))) {
					if(dropdownList.length-1 == index){
						shoppingListObj.focusListByElementId($(dropdownList).get(0).id);
					} else {
						shoppingListObj.focusListByElementId($(dropdownList).get(index+1).id);
					}
					focusChanged = true;
				}
			});
		} else if (event.keyCode === KeyCodes.ESCAPE || event.keyCode === KeyCodes.TAB) {
			Utils.stopEvent(event);
			this.hideDropDown();
		}
	};

	this.hideIfNoFocus = function(){
		if(this.dropDownVisible && !this.dropDownInFocus && !this.mouseOnArrow){
			this.hideDropDown();
		}
	};

	this.hasFocus = function(event){
		$(document).on("contextmenu", function (event) {
			if (event.which == 1) {
				this.dropDownInFocus = true;
			} else {
				this.dropDownInFocus = false;
			}
		});
	};


	/**
	 * Method to update the name of an existing shopping list
	 *
	 */
	this.edit = function(){
		// picks the new shopping list name and trims it
                    var name = trim($("#editListName").val());
		var maxlength = name.maxLength;
		var defaultName = Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME');

		if (this.empty(name)) {
			// display error message saying list name is empty.
			this.showEditErrorMessage(Utils.getLocalizationMessage('ERR_NAME_EMPTY'));
		} else if(!MessageHelper.isValidUTF8length(name, maxlength)){
			// check for max length
			this.showEditErrorMessage(Utils.getLocalizationMessage('ERR_NAME_TOOLONG'));
		} else if(name == defaultName) {
			// show error message saying that DEFAULT cannot be used
			this.showEditErrorMessage(Utils.getLocalizationMessage('ERR_NAME_SHOPPING_LIST'));
		} else if(this.isDuplicate(name)){
			// show error message saying that DEFAULT cannot be used
			this.showEditErrorMessage(Utils.getLocalizationMessage('ERR_NAME_DUPLICATE'));
		} else if(!this.validateWishName(name)){
			// show error message saying that
			this.showErrorMessage(Utils.getLocalizationMessage('INVALID_NAME_SHOPPING_LIST'));
		} else {
			var params = this.setCommonParams();
			params.name = name;

                        var dropdown = $('#multipleWishlistController_select');
			if((dropdown != null && dropdown != 'undefined') && dropdown.value != 0){
				// get wish list ID
                            params["giftListId"] = $("#multipleWishlistController_select").val();
                            this.nameToDelete = $('#multipleWishlistController_select options:dropdown.selectedIndex').text();
			}
                        $("#editShoppingListPopup").data("wc-WCDialog").close();

                        // For Handling multiple clicks.
                        if (!submitRequest()) {
                            return;
                        }
                        cursor_wait();
                        // calling the service to save the new list name
                        wcService.invoke('ShoppingListServiceUpdate', params);
                    }
                };

	/**
	 * Method to delete an existing shopping list
	 *
	 */
	this.deleteList = function(){
		var params = this.setCommonParams();
                    var dropdown = $('#multipleWishlistController_select');
		if((dropdown != null && dropdown != 'undefined') && dropdown.value != 0){
			// get wish list ID
                        params["giftListId"] = $("#multipleWishlistController_select").val();
                        this.nameToDelete = $('#multipleWishlistController_select options:dropdown.selectedIndex').text();
		}
                    $("#deleteShoppingListPopup").data("wc-WCDialog").close();

                    // For Handling multiple clicks.
                    if (!submitRequest()) {
                        return;
                    }
                    cursor_wait();
                    // calling the service to save the new list name
                    wcService.invoke('ShoppingListServiceDelete', params);
                };

	/**
	 * Method that knows how to hide or un-hide the links to delete and rename a wish list in the my account
	 * wish list select controller area.
	 *
	 */
	this.refreshLinkState = function() {
        var dropdown =$('#multipleWishlistController_select')[0];
		if (dropdown != null) {
			var wName = $('#multipleWishlistController_select')[0].options[dropdown.selectedIndex].text;
			var defaultName = Utils.getLocalizationMessage('DEFAULT_WISH_LIST_NAME');
			if (wName == defaultName) {
				//hide the delete and rename links, default wish list cannot be changed nor deleted
                        	$('#editDivider').css('display','none');
                        	$('#edit_popup_link').css('display','none');
                        	$('#deleteDivider').css('display','none');
                        	$('#delete_popup_link').css('display','none');
                        } else {
                        	$('#editDivider').css('display','block');
                        	$('#edit_popup_link').css('display','block');
                        	$('#deleteDivider').css('display','block');
                        	$('#delete_popup_link').css('display','block');
                        }
                    }
                };

	/**
	  * move an order item to the default wish list
	  * @param {string} listId id of the shopping list to add the item to
	  * @param {string} orderItemId the order item id of the item to be removed from shopping cart
	  */
	this.addToListAndDelete = function(listId, inOrderItemId, focusElement) {
		this.orderItemId = inOrderItemId;

                    wcTopic.publish("modelChanged/AnalyticsConversionEvent");

		this.hideDropDown();

		var params = this.setCommonParams();
		params.giftListId = listId;
		params["catEntryId_1"] = this.catEntryParams.id;
		params["quantity_1"] = 1;

		// For Handling multiple clicks.
		if(!submitRequest()){
			return;
		}
		cursor_wait();
		ShoppingListDialogJS.setDialogParams(this.storeParams, {catEntryId:this.catEntryParams.id, name:this.catEntryParams.name, image:this.catEntryParams.image, thumbnail: 'imgPath', focusElement: focusElement});
		wcService.invoke('ShoppingListServiceAddItemAndRemoveFromCart',params);
	};

	/**
	 * delete an order item from the shopping cart
	*/
	this.deleteItemFromCart = function() {
		if (this.orderItemId != "") {
			var test = this.orderItemId;
			this.orderItemId = "";
			if(test != ""){
				CheckoutHelperJS.deleteFromCart(test, true);
			}
		}
	};
	/**
	 * validate the wish name
	 */
	this.validateWishName = function(wishName) {
		var invalidChars = "~!@#$%^&*()+=[]{};:,<>?/|`"; // invalid chars
		invalidChars += "\t\'\"\\\/"; // escape sequences

		// look for presence of invalid characters.  if one is
		// found return false.  otherwise return true
		for (var i=0; i<wishName.length; i++) {
		  if (invalidChars.indexOf(wishName.substring(i, i+1)) >= 0) {
			return false;
		  }
		}
		return true;
	};
	/**
	 * Indicate a catEntry component has been resolved or unresolved (attributes selected or not selected)
	 */
	this.setResolved = function(baseItemId, value) {
		this.catEntryParams.components[baseItemId].resolved = value;
	};

                $(document.documentElement).on("mousedown", $.proxy("hideIfNoFocus", this));
	for (baseItemId in this.catEntryParams.components) {
		// For each catEntry component, subscribe to SKU resolution
                    wcTopic.subscribe('DefiningAttributes_Resolved_' + baseItemId, function (catEntryId, productId) {
			eval(jsObjectName + ".setResolved('" + productId + "', true)");
		});
                    wcTopic.subscribe('DefiningAttributes_Changed_' + baseItemId, function (catEntryId, productId) {
			if (catEntryId == 0) {
				// Some attribute has not been selected after SKU resolution
				eval(jsObjectName + ".setResolved('" + productId + "', false)");
			}
		});
	};
}

if(typeof(ShoppingListDialogJS) == "undefined" || ShoppingListDialogJS == null || !ShoppingListDialogJS) {

	ShoppingListDialogJS = {
		storeParams: null,
		dialogParams: null,

		setDialogParams: function(storeParams, dialogParams){
			this.storeParams = storeParams;
			this.dialogParams = dialogParams;
			if(this.dialogParams.image == null || this.dialogParams.image == ''){
				// when item image is not available, we need to fetch separately
				this.fetchAddedItem();
			} else {
				// when item is moved - the ones available in cart pages
				this.displayItemAddedWithoutFetching();
			}
		},

		fetchAddedItem: function(){
			var params = this.setCommonParams();
			params.productId = this.dialogParams.catEntryId;
			params.catalogEntryId = this.dialogParams.catEntryId;

			$.ajax({
				url: getAbsoluteURL() + "GetCatalogEntryDetailsByIDView",
				method:"post",
                		dataType: "json",
                		data: params,
				success: ShoppingListDialogJS.displayItemAddedDialog,
				error: function(jqXHR, textStatus, err) {
					console.debug("QuickInfoJS.selectItem: Unexpected error occurred during an xhrPost request.");
				}
			});
		},

		displayItemAddedDialog: function(serviceResponse) {
			var itemAddedPopup = $("#shoppingListItemAddedPopup");
			if (itemAddedPopup.length > 0) {
                var data = serviceResponse.catalogEntry.description[0];
                $("#shoppingListItemAddedImg").attr("src", data.thumbnail)
                                            .attr("alt", data.name);
				$("#shoppingListItemAddedName").html(data.name);
                $("#shoppingListItemAddedPopup").data("wc-WCDialog").open();
			} else {
				console.debug("shoppingListItemAddedPopup does not exist");
			}
		},

		/**
		 * This method can be used to display "Added to Wish List" popup in cart pages
		 * because cart has only items and no products, so no need to make another call to pick item image & name
		 */
		displayItemAddedWithoutFetching: function() {
                            if ($("#shoppingListItemAddedPopup").length) {
                                $("#shoppingListItemAddedImg").attr("src", this.dialogParams.image);
                                $("#shoppingListItemAddedImg").attr("alt", this.dialogParams.name);
                                $("#shoppingListItemAddedName").html(this.dialogParams.name);
                            } else {
                                console.debug("shoppingListItemAddedPopup does not exist");
                            }
                        },

		/**
		 * show popup
		 */
		showDialog: function(){
			var itemAddedPopup = $("#shoppingListItemAddedPopup");
			if (itemAddedPopup.length > 0) {
				itemAddedPopup.data("wc-WCDialog").open();
			} else {
				console.debug("shoppingListItemAddedPopup does not exist");
			}
		},

		setCommonParams: function(){
			var params = new Object();
			params.storeId		= this.storeParams.storeId;
			params.catalogId	= this.storeParams.catalogId;
			params.langId		= this.storeParams.langId;
			return params;
		},

		close: function(){
			$("#shoppingListItemAddedPopup").hide();
			if (this.dialogParams.focusElement && this.dialogParams.focusElement != "") {
				$("#" + this.dialogParams.focusElement).focus();
			}
		}
	}
	/*
	 * itemAddedReadyForDelete applies to items in cart - since cart has only items and no products,
	 * so no need to make another call to pick item image & name
	 */
	wcTopic.subscribe("ShoppingListItem_Added", ShoppingListDialogJS.showDialog);

}
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2012 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the wish list pages to handle CRUD operations.
 * @version 1.0
 */


/**
/**
         * Declares a new render context for the Wishlist display,
         * and initializes it with the post URL to load.
         */
        wcRenderContext.declare("WishlistDisplay_Context", ["WishlistDisplay_Widget"], {
            url: ""
        });
/**
 * Declares a new render context for the Shared Wishlist display,
 * and initializes it with the post URL to load.
 */
wcRenderContext.declare("SharedWishlistDisplay_Context", ["SharedWishlistDisplay_Widget"], {
            url: ""
        });



ShoppingListControllersJS = {


    declareWishlistDisplayWidgetRefreshController: function () {
        // ============================================
        // div: WishlistDisplay_Widget refresh area
        // Declares a new refresh controller for the Wishlist display
        var myWidgetObj = $("#WishlistDisplay_Widget");


        var myRCProperties = wcRenderContext.getRenderContextProperties("WishlistDisplay_Context");

        /**
         * Displays the previous/next page of items on the Wishlist display page.
         * This function is called when a render context changed event is detected.
         */
        var renderContextChangedHandler = function () {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        };

        /**
         * Refreshs the wishlist display when an item is added to or deleted from the wishlist.
         * This function is called when a modelChanged event is detected.
         */
        wcTopic.subscribe(["ShoppingListServiceCreate", "ShoppingListServiceUpdate", "ShoppingListServiceDelete", "ShoppingListServiceRemoveItem", "ShoppingListServiceAddItem"], function () {
            myWidgetObj.refreshWidget("refresh");
        });

        /**
         * This function handles paging and browser back/forward functionalities upon a successful refresh.
         */
        var postRefreshHandler = function () {
            if (($("#multipleWishlistController_select") != null && $("#multipleWishlistController_select") != 'undefined')) {
                $("#multipleWishlistController_select").disabled = false;
            }
            cursor_clear();
        }

        // initialize widget with properties
        myWidgetObj.refreshWidget({
            renderContextChangedHandler: renderContextChangedHandler,
            postRefreshHandler: postRefreshHandler
        });
    },

    declareSharedWishlistDisplayRefreshController: function () {
        // ============================================
        // div: SharedWishlistDisplay_Widget refresh area
        // Declares a new refresh controller for the shared Wishlist display
        var myWidgetObj = $("#SharedWishlistDisplay_Widget");


        var myRCProperties = wcRenderContext.getRenderContextProperties("SharedWishlistDisplay_Context");

        /**
         * Displays the previous/next page of items on the Shared Wishlist display page.
         * This function is called when a render context changed event is detected.
         */
        var renderContextChangedHandler = function () {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        };

        /**
         * This function handles paging and browser back/forward functionalities upon a successful refresh.
         */
        var postRefreshHandler = function () {
            cursor_clear();
        }

        // initialize widget with properties
        myWidgetObj.refreshWidget({
            renderContextChangedHandler: renderContextChangedHandler,
            postRefreshHandler: postRefreshHandler
        });
    },
    declareWishlistSelectWidgetRefreshController: function () {
        // ============================================
        // div: WishlistSelect_Widget refresh area
        // Declares a new refresh controller for the Wishlist select display

	/**
 * Declares a new render context for the multiple Wishlist select display
 */
 wcRenderContext.declare("WishlistSelect_Context", ["WishlistSelect_Widget"], "");
        var myWidgetObj = $("#WishlistSelect_Widget");

        /**
         * Declares a new render context for the multiple Wishlist select display
         */

        var myRCProperties = wcRenderContext.getRenderContextProperties("WishlistSelect_Context");


        /**
         * Displays the previous/next page of items on the Wishlist display page.
         * This function is called when a render context changed event is detected.
         */
        var renderContextChangedHandler = function () {
            myWidgetObj.refreshWidget("refresh", myRCProperties);
        };

        /**
         * Refreshs the wishlist select drop down display when a new wish list is added or when a wish list is deleted.
         * This function is called when a modelChanged event is detected.
         */
        wcTopic.subscribe(["ShoppingListServiceCreate", "ShoppingListServiceUpdate", "ShoppingListServiceDelete", "ShoppingListServiceAddItem"], function () {
            myWidgetObj.refreshWidget("refresh");
        });

        /**
         * Hide the progress bar upon a successful refresh.
         */
        var postRefreshHandler = function () {
            cursor_clear();
            //ensure default wish list name is used if all lists are deleted.
            var dropdown = $('#multipleWishlistController_select');
            if (dropdown == null) {
                //if the drop down does not exist, that means there is no wish list
                MultipleWishLists.defaultListId = null;
                MultipleWishLists.addItemAfterCreate = null;
            } else if (dropdown.length > 0) {
                //ensure the name of the wish list is the same as the one selected in the drop down
                MultipleWishLists.defaultListId = $('#multipleWishlistController_select').val();

                shoppingListJS.refreshLinkState();
            }
        }

        // initialize widget with properties
        myWidgetObj.refreshWidget({
            renderContextChangedHandler: renderContextChangedHandler,
            postRefreshHandler: postRefreshHandler
        });

    }


};
;//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the wish list pages to handle CRUD operations.
 * @version 1.0
 */

/**
 * This REST service allows customers to create a new shopping list
 * @constructor
 */
wcService.declare({
        id: "ShoppingListServiceCreate",
        actionId: "ShoppingListServiceCreate",
        url: getAbsoluteURL() + "AjaxRestWishListCreate",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            closeAllDialogs(); //close the create popup

            wcTopic.publish("ShoppingList_Changed", {
                listId: serviceResponse.uniqueID,
                listName: serviceResponse.descriptionName,
                action: 'add'
            });




        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to update the name of a shopping list
     * @constructor
     */
    wcService.declare({
        id: "ShoppingListServiceUpdate",
        actionId: "ShoppingListServiceUpdate",
        url: getAbsoluteURL() + "AjaxRestWishListUpdate",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            closeAllDialogs();
            shoppingListJS.showMessageDialog(Utils.getLocalizationMessage('LIST_EDITED'));

            wcTopic.publish("ShoppingList_Changed", {
                listId: serviceResponse.uniqueID,
                listName: serviceResponse.descriptionName,
                action: 'edit'
            });

        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to delete a selected shopping list
     * @constructor
     */
    wcService.declare({
        id: "ShoppingListServiceDelete",
        actionId: "ShoppingListServiceDelete",
        url: getAbsoluteURL() + "AjaxRestWishListDelete",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            closeAllDialogs();
            shoppingListJS.showMessageDialog(Utils.getLocalizationMessage('LIST_DELETED'));

            wcTopic.publish("ShoppingList_Changed", {
                listId: serviceResponse.uniqueID,
                listName: '',
                action: 'delete'
            });

        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to add an item to a shopping list
     * @constructor
     */
    wcService.declare({
        id: "ShoppingListServiceAddItem",
        actionId: "ShoppingListServiceAddItem",
        url: getAbsoluteURL() + "AjaxRestWishListAddItem",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            wcTopic.publish("ShoppingListItem_Added");

            //disable add to wishlist after item successfully added
            var wishListAdd = document.getElementById("addToShoppingListBtn");
            if(wishListAdd != null){
            	wishListAdd.style.display = 'none';
            }
        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to remove an item from a shopping list
     * @constructor
     */
    wcService.declare({
        id: "ShoppingListServiceRemoveItem",
        actionId: "ShoppingListServiceRemoveItem",
        url: getAbsoluteURL() + "AjaxRestWishListRemoveItem",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            MessageHelper.hideAndClearMessage();

            var popup = $("#shoppingListCreateSuccessPopup").data("wc-WCDialog");
    		if (popup) {
    			$("#successMessageAreaText").html(Utils.getLocalizationMessage('ITEM_REMOVED'));
    			popup.open();
    		}
            //shoppingListJS.showMessageDialog(Utils.getLocalizationMessage('ITEM_REMOVED'));
        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to add an item to a shopping list and remove from the shopping cart
     * @constructor
     */
    wcService.declare({
        id: "ShoppingListServiceAddItemAndRemoveFromCart",
        actionId: "ShoppingListServiceAddItemAndRemoveFromCart",
        url: getAbsoluteURL() + "AjaxRestWishListAddItem",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            wcTopic.publish("ShoppingListItem_Added");
        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service allows customers to set a wish list as the default list
     * @constructor
     *
     **/
    wcService.declare({
        id: "AjaxGiftListServiceChangeGiftListStatus",
        actionId: "AjaxGiftListServiceChangeGiftListStatus",
        url: getAbsoluteURL() + "AjaxRestWishListChangeState",
        formId: ""

        /**
         * Hides all the messages and the progress bar.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        successHandler: function (serviceResponse) {
            cursor_clear();
            MessageHelper.hideAndClearMessage();

            //	MultipleWishLists.updateDefaultListName('multipleWishListButton',serviceResponse.descriptionName);
            //	MultipleWishLists.updateDefaultListName('addToMultipleWishListLink',serviceResponse.descriptionName);
            MultipleWishLists.setDefaultListId(serviceResponse.uniqueID);
            MultipleWishLists.updateContextPostSwitch(serviceResponse.uniqueID);
        }

        /**
         * display an error message.
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation.
         */
        ,
        failureHandler: function (serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),

    /**
     * This REST service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxGiftListAnnouncement",
        actionId: "AjaxGiftListAnnouncement",
        url: getAbsoluteURL() + "AjaxRESTWishListAnnounce",
        formId: ""

        /**
         * hides all the messages and the progress bar
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,
        successHandler: function (serviceResponse) {
                cursor_clear();
                MessageHelper.hideAndClearMessage();
                shoppingListJS.showMessageDialog(Utils.getLocalizationMessage('WISHLIST_EMAIL_SENT'));
                $("#WishListEmailSucMsg_Div").css("display","block");
                //limit the recipient number of characters in To: email address of email success message to 25 characters
                $("#recipientEmail_wishListDisplay").html(serviceResponse.recipient[0].substring(0, 25));
            }
            /**
             * display an error message
             * @param (object) serviceResponse The service response object, which is the
             * JSON object returned by the service invocation
             */
            ,
        failureHandler: function (serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }

    })

var mobileBig = 1024;
var mobileSmall = 450;
var mobileExtraSmall = 360;
var productPrice = '';
var countPrescription = 0;
//********************************************************************************************************************************************************************************************************/
/* BEGIN - HEADER FUNCTIONS */

$(document).ready(function () {
    // sunglasses menu script 
    $(document).ready(function(){if(storeDirectory=="OliverUS" || storeDirectory=="OliverUK" || storeDirectory=="OliverDE"){$("#li-sun-prescription").show();}});
	
	document.body.addEventListener('mousedown', function() {
        document.body.classList.add('using-mouse');
    });


    document.body.addEventListener('wheel', function() {
        document.body.classList.add('using-mouse');
    });


    document.body.addEventListener('keydown', function(e) {
         if(e.keyCode == 9){
              document.body.classList.remove('using-mouse');
         }
    });

    /**
    * Function that shows the navigation menu from the left side
    * and close newsletter and login
    */
    $('.header__nav-title').click(function () {
    	var headerObj = $(".header__nav-menu");
        headerObj.attr("data-description","MainNav");
        tealiumPushClickMenu(headerObj[0]);
        $('body').addClass('no-scroll');
         //checkout_3.0 HB-8410 add class when menu is open and there si a promo banner 

         if($('.cart-promoBanner').length > 0){
            $('.cart-promoBanner').addClass('promoBanner_menuOpened');
        }  
        if ($('.newsletter').hasClass('opend') || $('.GlobalLoginWidgetAlt').hasClass('opend')) {
            if ($('.newsletter').hasClass('opend')) {
                $('.newsletter__close').click();
                if(checkMobilePdpPage()){
                    changeHeaderIndex(false)
                }
            }
            if ($('.GlobalLoginWidgetAlt').hasClass('opend')) {
                $('.global-login__close').click();
                if(checkMobilePdpPage()){
                    changeHeaderIndex(false)
                }
            }
            setTimeout(function () {
                $('.header__nav-menu').addClass('opend').attr('aria-hidden','false');
                if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
                    hideHeaderTimeout.cancel();
                    $('#page-overflow-wrapper').addClass('overflow-hidden');
                }
                if(checkMobilePdpPage()){
                    hideHeaderTimeout.cancel();
                    changeHeaderIndex(true)
                }
               
                $('.header__nav-fade').show();
            }, 500);
        } else {
            $('.header__nav-menu').addClass('opend').attr('aria-hidden','false');
            $('.header__nav-fade').show();
            if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
                hideHeaderTimeout.cancel();
                $('#page-overflow-wrapper').addClass('overflow-hidden');
            }
            if(checkMobilePdpPage()){
                hideHeaderTimeout.cancel();
                changeHeaderIndex(true)
            }
        }
        $('.global-login__close').click();
        if ($(window).innerWidth() <= mobileBig) {
            $('body').addClass('no-scroll');
        }
        changeTabIndex($('.header__nav-menu'));

        // HB-5150 - Adapting menu height on landing
        adaptMenuHeight();
        if (checkMobilePdpPage()) {
            hideHeaderTimeout.cancel();
        }

       
    });

    /**
    * Function that hide the navigation menu at the left side
    */
    $('.header__nav-close').click(function () {
        // $('#page-overflow-wrapper').removeClass('overflow-hidden');

        
         //checkout_3.0 HB-8410 add class when menu is open and there si a promo banner 
         if($('.cart-promoBanner').length > 0){
            $('.cart-promoBanner').removeClass('promoBanner_menuOpened');
        }  
        if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
            hideHeaderTimeout.setup();
            $('#page-overflow-wrapper').removeClass('overflow-hidden');
        }
        if(checkMobilePdpPage()){
            hideHeaderTimeout.setup();
            changeHeaderIndex(false)
        }
        $('.header__nav-menu').removeClass('opend').attr('aria-hidden','true');
        $('.header__nav-fade').hide();
        if ($(window).innerWidth() <= mobileBig) {
            $('body').removeClass('no-scroll');
        }
        changeTabIndex($('.header__nav-menu'));
        $('body').removeClass('no-scroll');
        if (checkMobilePdpPage()) {
            hideHeaderTimeout.setup();
        }
    });

    /**
    * Function that hide the navigation menu at the left side 
    * when you click outside
    */
    $('.header__nav-fade').click(function () {
        $('.header__nav-close').click();
        if(checkMobilePdpPage()){
            changeHeaderIndex(false)
        }
        if (checkMobilePdpPage()) {
            hideHeaderTimeout.setup();
        }
    });

    /**
    * Function that open the category section in the nav menu
    */
    $('.header__nav-category').click(function () {
        if ($(window).innerWidth() <= mobileBig) {
            $('.header__nav-back').removeClass('hide');
            $(this).siblings('.nav-category__wrapper').addClass('opend');
            $('.nav-category__wrapper').removeClass('opstories-mobile');
            if(checkMobilePdpPage()){
                changeHeaderIndex(true)
            }

            var sectionTitle = $(this).text()
            $('#subcategoriesTitle').text(sectionTitle);

            if (sectionTitle.includes('Takumi')) {
                $('.arrow-icon__back').removeClass('arrow-white');
                $('.header__nav-back').addClass('header__nav-list__takumi');
                $('.arrow-icon__back').addClass('arrow-black');
                $('#takumi-menu-mobile .nav-category__wrapper').addClass('header__nav-list__takumi');
            } else {
                $('.header__nav-back').removeClass('header__nav-list__takumi');
                $('.arrow-icon__back').removeClass('arrow-black');
                $('.arrow-icon__back').addClass('arrow-white');
                $('#takumi-menu-mobile .nav-category__wrapper').removeClass('header__nav-list__takumi');
            }

            if (sectionTitle.includes('Stories')) {
                switchFromDesktopToMobileMenu();
            }

        } else {
            var pageLink = $(this).attr('data-link');
            window.location.href = pageLink;
        }
    });

    /**
    * Function that hide the category section in the nav menu
    */
    $('.arrow-icon__back').click(function () {
        $('.nav-category__wrapper').removeClass('opend');
        $('.header__nav-back').addClass('hide');

        var sectionTitle = $('#subcategoriesTitle').text();
        if (sectionTitle.includes('Stories')) {
            switchFromMobileToDesktopMenu();
        }
    
    });

    /**
    * Function that open the search box in desktop mode
    */
    // $('.header__icons--search > .icone.lens').click(function () {
    //     if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
    //         hideHeaderTimeout.cancel();
    //         $("#page-overflow-wrapper").addClass("overflow-hidden");
    //     } 
    //         if(checkMobilePdpPage()) hideHeaderTimeout.cancel();

    //    // $('#page-overflow-wrapper').addClass('overflow-hidden')
    //     changeTabIndex($('#searchBox'));
    //     changeTabIndex($('.header__search-close'));
    //     $('.header--bottom--search').addClass('opend');
    //     $("#searchTermWrapper input").focus();
    //     $('.search--fade').show();
    // });

    // $('#SimpleSearchForm_SearchTerm').keydown(function(e){
    //     var key = e.which;
    //     if(key == 9) {
    //         $('#autoSuggest_Result_div').show();
    //     }
    // });  

    /**
    * Function that close the search box in desktop mode
    */
   

    /**
    * Function that close the search box when click in fade layer on desktop mode
    */
    $('.search--fade').click(function () {
        $('.header__search-close').click();
    });

    /**
    * Function that open the search box in mobile mode
    */
    $('.nav-user__item--search').click(function () {
        $('.header__search-back').removeClass('hide');
        if(checkMobilePdpPage()){
            changeHeaderIndex(true)
        }
        openSearchBar();// search Optimization
        $('#searchInput').focus();
    });

    /**
    * Function that close the search box in mobile mode
    */
    $('.header__search-back').click(function () {
        $('.header__search-back').addClass('hide');
        $('.header--bottom--search').removeClass('opend');
    });

    /**
    * Function that open the newsletter from nav menu in desktop mode
    * and hide the nav menu
    */
    $('.nav-social__item-newsletter').click(function () {
        $('.header__nav-close').click();
        setTimeout(function () {
            $('.newsletter').addClass('opend').find(':focusable').first().focus().addClass('focus');
            $('.newsletter--fade').show();
            $('body').addClass('no-scroll');
            $('body, html').css('height', '100%');
            $('body, html').css('overflow', 'hidden');
            changeTabIndex($('.newsletter'));
        }, 500);
    });

    /**
    * Function that open the newsletter from nav menu in mobile mode 
    */
    $('.nav-user__item--newsletter').click(function () {
        changeTabIndex($('.newsletter'));
        if(checkMobilePdpPage()){
            changeFooterIndex(true)
        }
        $('.newsletter').addClass('opend');
        $('.newsletter--fade').show();
        $('body').addClass('no-scroll');
        $('body, html').css('height', '100%');
        $('body, html').css('overflow', 'hidden');
    });

    /**
    * Function that open the newsletter from footer 
    */
    $('.newsletter-cta__button').click(function () {
        if(checkMobilePdpPage()){
            changeFooterIndex(true);
            
        }
        changeTabIndex($('.newsletter'));
        $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
        $('.newsletter--fade').show();
        $('body').addClass('no-scroll');
        $('body, html').css('height', '100%');
        $('body, html').css('overflow', 'hidden');
        $('#header').css('z-index','1');
        if (!getCookie($("#welcomePopupCookieName").val())) {
        	$("#newsletter-wrapper").hide();
        }
    });

    /**
    * Function that close the newsletter
    */
    $('.newsletter__close').click(function () {
        if(checkMobilePdpPage()){
            changeFooterIndex(false)
        }
        changeTabIndex($('.newsletter'));
        $('.newsletter').removeClass('opend');
        $('.newsletter--fade').hide();
        $('body').removeClass('no-scroll');
        $('body, html').css('height', 'auto');
        $('body, html').css('overflow', 'visible');
        $('#header').css('z-index','');
        if (!getCookie($("#welcomePopupCookieName").val())) {
        	$("#newsletter-wrapper").show();
        }
    });

    /**
    * Function that close the newsletter when click in fade layer
    */
    $('.newsletter--fade').click(function () {
        $('.newsletter__close').click();
        $('body').removeClass('no-scroll');
        $('body, html').css('height', 'auto');
        $('body, html').css('overflow', 'visible');
        $('#header').css('z-index','');
    });

    /**
    * Function that open the login/register form in Desktop
    */

    $("#Header_GlobalLogin_signInQuickDiv a, #Header_GlobalLogin_signOutQuickDiv a,#return_page .shipping_sign_in ").click(function () {
        if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
            hideHeaderTimeout.cancel();
        }
        if(checkMobilePdpPage()) hideHeaderTimeout.cancel();

        // $('#page-overflow-wrapper').addClass('overflow-hidden')
        console.dir($(this).parent().attr('id')); 
        if($(this).parent().attr('id') == 'Header_GlobalLogin_signInQuickDiv' ||  ($(this).parents("div[id]").attr('id') == 'return_page') ) {
            $("#Header_GlobalLogin").addClass("opend").addClass("active");
        } else {
            $("#Header_GlobalLogin_1").addClass("opend").addClass("active");
        }
        // changeTabIndex($('#Header_GlobalLogin_signInDropdown'));
        $(".panelLinkSelected").addClass("selected");
        $(".myaccount--fade").show();

        var waitForEl = function(selector, callback) {
            if ($(selector).length) {
                callback();
            } else {
                setTimeout(function() {
                    waitForEl(selector, callback);
                }, 1000);
            }
        };
        
        var selector = '#Header_GlobalLogin > div';
    
        waitForEl(selector, function() {
            // work the magic
            changeTabIndex($('#Header_GlobalLogin > div'));
        });

    });

    /**
    * Function that open the login/register form in Mobile
    */

    $(".nav-user__item--account").click(function () {
        $('.login--icon').click();
    });

    /**
    * Function that open minishopcart
    */

    $(document).on('click', '#widget_minishopcart', function (e) {
        if($('#page').hasClass('pdp') && !(window.mobilecheck() || window.tabletPortraitCheck())){
            hideHeaderTimeout.cancel();
        }
        if(checkMobilePdpPage()){
            changeHeaderIndex(true)
            hideHeaderTimeout.cancel();
        }
       // $('#page-overflow-wrapper').addClass('overflow-hidden')
        e.preventDefault();
        var waitForEl = function(selector, callback) {
            if ($(selector).length) {
                callback();
            } else {
                setTimeout(function() {
                    waitForEl(selector, callback);
                }, 1000);
            }
        };
        
        var selector = '[aria-describedby="quick_cart_container"]';
    
        waitForEl(selector, function() {
            // work the magic
            $('[aria-describedby="quick_cart_container"]').addClass("opend");
            $(".quickcart--fade").show();
        });
    });

    /**
    * Function that close My Account section when you click in the fade layer
    */

    $(".myaccount--fade").click(function () {
        $(".global-login__close").click();
    });

    /**
    * Function that prevent a styles malfunction when you resize the window
    */
    $(window).resize(function () {
        if (window.innerWidth <= mobileBig) {
            if ($(".header--bottom--search").hasClass("opend") || $("#Header_GlobalLogin").hasClass("opend")
                || $(".newsletter").hasClass("opend")) {
                $('.header__search-back').removeClass('hide');
                if (!$(".header__nav-menu").hasClass("opend")) {
                    $(".header__nav-menu").addClass("opend");
                }
            }
            if (!$('.footer--payment').hasClass('desktop-hide')) {
                $(".payment--close-wrapper").click();
                $(".footer--payment span").click();
            }
        } else {
            if ($(".header--bottom--search").hasClass("opend") || $("#Header_GlobalLogin").hasClass("opend")
                || $(".newsletter").hasClass("opend")) {
                $('.header__search-back').addClass('hide');
                if ($(".header__nav-menu").hasClass("opend")) {
                    $(".header__nav-menu").removeClass("opend");
                }
            }
        }

        // HB-5150
        adaptMenuHeight();

        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            // if hasClass 'hide', we are moving from mobile to desktop view
            if ($('.header__nav-menu__opstories__top').css('display') == 'none') {
                switchFromMobileToDesktopMenu();
            }
        }
    });


    /*
    Toggle for the Header.
    If we click in a span, menu of this span will be shown.
    If we click in the same span when it is shown, the menu will hide.
    If we click in another spam when another one is shown, the open one will close
    and the one we click on will show.
    */
    // $('.header--nav--wrapper--item > span').click(function() {
    //   if ($(this).siblings('div').length > 0) {
    //     if ($(this).parent().hasClass('opend')) {
    //       $(this).parent().removeClass('opend');
    //       setTimeout(function() {
    //         $('.shadow-blur').removeClass('visible');
    //         $('#page').removeAttr('style');
    //       }, 200);
    //     } else {
    //       $('.header--nav--wrapper--item').removeClass('opend');
    //       $(this).parent().addClass('opend');
    //       $('.shadow-blur').addClass('visible');
    //      $('#page').css('overflow','hidden');
    //     }
    //   }
    // });

    // $(".header--bottom--nav.active").on('blur', function() {
    //   $('.header--bottom--nav').removeClass('active');
    // });

    // $("[id^='nav-']").click(function() {
    //   if ($(this).prop('checked') == true) {
    //     $("[id^='nav-']").prop('checked', false);
    //     $(this).prop('checked', true);
    //   } else {
    //     $(this).prop('checked', false);
    //   }
    // });

    // $('#headerRow2--ms--search > .icone.lens').click(function() {
    //   if ($('#searchBar').length > 0) {
    //     $('#searchBar').hasClass('opend') ? $('#searchBar').removeClass('opend') : $('#searchBar').addClass('opend');
    //     setTimeout(function() {
    //       $('#SimpleSearchForm_SearchTerm').focus();
    //     }, 400);
    //   }
    // });

    // $('#closeSearch').click(function() {
    //   $('#searchBar').hasClass('opend') ? $('#searchBar').removeClass('opend') : '';
    // });

    // Check if the LOCATION pop-up is opend when we click on the
    // SIGN IN/REGISTRATION link.

    // $('#Header_GlobalLogin_signInQuickDiv').click(function() {
    //   if ($('.header--top--right--popup').length > 0)
    //     $('.header--top--right--popup').hasClass('opend') ? $('.header--top--right--popup').removeClass('opend') : '';
    // });

    // $('#headerRow2--ham').click(function() {
    //   $('#navi-ham').prop('checked') ? $('.header').addClass('opend') : $('.header').removeClass('opend');
    // });

    // $('.header--nav__header').click(function() {
    //   if ($(window).innerWidth() <= mobileBig) {
    //     var openMenu = $(this).parent().find('.header--nav__glasses, .header--nav__list');
    //     openMenu.hasClass('opend') ? openMenu.removeClass('opend') : openMenu.addClass('opend');
    //   }
    // });

    // Owl Carousel of the header with messages.
    // $('.header--top--left').owlCarousel({
    //     items: 1,
    //     singleItem: true,
    //     navigation: true,
    //     navigationText: ["<i class='btn-carousel btn-carousel--left'></i>", "<i class='btn-carousel btn-carousel--right'></i>"],
    //     pagination: false,
    //     addClassActive: true
    // });

    /*
    $('#headerRow2--ms--minicart').click(function() {
        $('#header').hasClass('opend-cart') ? $('#header').removeClass('opend-cart') : $('#header').addClass('opend-cart');
    });
    */

    /* START - OP Tab Integration */
    if (typeof boutiques !== 'undefined'){
       
        var langId = WCParamJS.langId;
        if(langId == "-2"){
           
            var botiqueButtonHtml = '<div id="book-appointment-section"><div class="fade book-appointment--fade" style="display: none;"></div><div class="book-appointment"><div id="bookAppointmentClose" class="book-appointment__close" tabindex="-1"><span class="close--text book-appointment-mobile">Close</span><span class="close--icon"></span></div><div class="book-appointment__wrapper"><div class="book-appointment__title"><h3>PROGRAMMEZ VOTRE RENDEZ-VOUS PRIVÉ</h3></div><div class="book-appointment__iframe-wrapper"><iframe id="book-appointment-iframe" src="" width="100%" height="100%"></iframe></div></div></div></div>';

        }
        else if(langId == "-3"){
           
            var botiqueButtonHtml = '<div id="book-appointment-section"><div class="fade book-appointment--fade" style="display: none;"></div><div class="book-appointment"><div id="bookAppointmentClose" class="book-appointment__close" tabindex="-1"><span class="close--text book-appointment-mobile">Close</span><span class="close--icon"></span></div><div class="book-appointment__wrapper"><div class="book-appointment__title"><h3>PLANEN SIE IHREN PRIVATEN TERMIN</h3></div><div class="book-appointment__iframe-wrapper"><iframe id="book-appointment-iframe" src="" width="100%" height="100%"></iframe></div></div></div></div>';

        }
        else if(langId == "-4"){
            
            var botiqueButtonHtml = '<div id="book-appointment-section"><div class="fade book-appointment--fade" style="display: none;"></div><div class="book-appointment"><div id="bookAppointmentClose" class="book-appointment__close" tabindex="-1"><span class="close--text book-appointment-mobile">Close</span><span class="close--icon"></span></div><div class="book-appointment__wrapper"><div class="book-appointment__title"><h3>PRENOTA IL TUO APPUNTAMENTO PRIVATO</h3></div><div class="book-appointment__iframe-wrapper"><iframe id="book-appointment-iframe" src="" width="100%" height="100%"></iframe></div></div></div></div>';

        }
        else if(langId == "-5"){
            
            var botiqueButtonHtml = '<div id="book-appointment-section"><div class="fade book-appointment--fade" style="display: none;"></div><div class="book-appointment"><div id="bookAppointmentClose" class="book-appointment__close" tabindex="-1"><span class="close--text book-appointment-mobile">Close</span><span class="close--icon"></span></div><div class="book-appointment__wrapper"><div class="book-appointment__title"><h3>PROGRAMA TU CITA PRIVADA</h3></div><div class="book-appointment__iframe-wrapper"><iframe id="book-appointment-iframe" src="" width="100%" height="100%"></iframe></div></div></div></div>';

        }
        else{
		var botiqueButtonHtml = '<div id="book-appointment-section"><div class="fade book-appointment--fade" style="display: none;"></div><div class="book-appointment"><div id="bookAppointmentClose" class="book-appointment__close" tabindex="-1"><span class="close--text book-appointment-mobile">Close</span><span class="close--icon"></span></div><div class="book-appointment__wrapper"><div class="book-appointment__title"><h3>Schedule your private appointment</h3></div><div class="book-appointment__iframe-wrapper"><iframe id="book-appointment-iframe" src="" width="100%" height="100%"></iframe></div></div></div></div>';
        }

        $('.boutiques-page .store-hours.text-upper').append(botiqueButtonHtml);
		
	    $("#book-appointment-button-container").hide();

	    for(var boutiqueKey in boutiques) {
	        var boutique = boutiques[boutiqueKey];
	        if(boutique.showBookAppointment) {
                var regex = new RegExp('/' + boutique.url,"g");
	            if(regex.test(window.location.href)) {
 
	                var urlBookAppointment = WCParamJS.homePageURL + "/book-appointment?storeNumber=" + boutique.id; 
	                $('#book-appointment-button-container a.button_primary').attr("href", urlBookAppointment);
                    $("#book-appointment-button-container").show();
                    $(".book-appointment__title").hide();
                    

	                break;
	            }
	        }
	    }
	}
	if ($('.bookAppointment').length > 0){
        //evitare la duplicazione testo privacy 
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            $(document).on('click','.footer .container--footer :button',function() { //back button
                $('.privacy-policy-box').attr('style', 'display: none !important')
             });
             $(document).on('click','.footer .container--footer .cta-container :button',function() { //continue button
               
                if( $('.calendar-section').length >0){ //only from step 1 to step 2
                    $('.privacy-policy-box').eq(0).css("display","block");
                    setTimeout(function() {  //non fa comparire policy-box se non si preme l'orario ed esce l'errore 
                        if(($('.calendar-section').length >0) && ($('.msg-error').length > 0)){
                            $('.privacy-policy-box').eq(0).css("display","none");
                        }
                    }, 500);
                }
                else{
                    $('.privacy-policy-box').eq(0).css("display","none");
                }
               
             });
    }
        $('#footer').css("display",'none');//in book appointment no footer
        
		$('.scheduler-widget .page-content').prepend('<div class="schedule_infotext"></div>');
		if ($('.scheduler-widget .map-container').length > 0){
			$('html').addClass('show-overflow');
			$('body').addClass('show-overflow');
		}
		if (window.mobilecheck() || window.tabletPortraitCheck()) {
			$('.scheduler-widget .info-content').addClass('info-content--show');
        }
        /* START - Mutation observer for placeholders in booking section */

        var baObserver;
        baObserver = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function( mutation ) {
                mutation.addedNodes.forEach(function( added) {
                    var footerHeight = $('.scheduler-widget .footer .container--footer').height();//altezza strip cta continua back 
                    // add aria label to close button
                    $('.scheduler-widget .close-button').attr( "aria-label", "close popup button" )
                    
                    // phone
                    console.log("footer",footerHeight);
                    if(window.mobilecheck() || window.tabletPortraitCheck()){
                        $('.scheduler-widget .booking-form .row.no-wrap-md').siblings('.privacy-policy-box').insertBefore('.scheduler-widget footer');
                    }
                    else{
                       //style dopo aver tolto il footer in dekstop
                        $('.schedule--section').css('margin-bottom',footerHeight+'px');
                        $('.booking-form').css('margin-bottom',footerHeight+'px');
                    }
                    
                    var labelFormTab = $( ".scheduler-widget .booking--section form label span" );
                    	labelFormTab.each(function(){
                    		$(this).siblings(':not(textarea)').attr('placeholder', $(this).text() + '*');
                    		$(this).siblings('textarea').attr('placeholder', $(this).text());
                    	});
                        //  To be called at the end of the operations
                        if (typeof baObserver != 'undefined'){
                           baObserver.disconnect();
                        }
                });
            });
        }).observe(document.querySelector(".bookAppointment #root") || document, {
            subtree: true,
            childList: true,
        });

        /* END - Mutation observer for placeholders in booking section */
    
	} 
	
    /* END - OP Tab Integration */

    /* Show default payment placement */
    if($('#page').hasClass('pdp')){
        var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
        showDefaultPaymentPlacement(defaultPaymentPlacement);
    }

      //Search Optimization -- Init search Panel
    if (typeof fn_InitSearchPanel == 'function') {
         fn_InitSearchPanel();
    }

  //setCidCookie
    if(getUrlParam("cid") != undefined){
        var cidCookieValue = getUrlParam("cid");
        const d = new Date();
        d.setTime(d.getTime() + (28*24*60*60*1000)); //cookie 28 days
        var expires = "expires="+ d.toUTCString();
        document.cookie = "X_WC_CID=" + cidCookieValue + ";" + expires + ";path=/"
        
    }

    //set back step-shipping
    if($('#page').hasClass('checkout-page')){
        const queryStringShipping = window.location.search;
        window.history.pushState({ page: 1 }, "", queryStringShipping);
        window.addEventListener("popstate", (event) => {
            if($('.shipping-step_payment_section_activated').length > 0){
                $('.edit-button').click();
                window.history.pushState({ page: 1 }, "", queryStringShipping);
            }else{
                window.history.go(-1);
            }
            
        });
    }
    

}).mouseup(function (e) {
    // var container = $(".header--bottom--nav.active");
    // if (!container.is(e.target) && container.has(e.target).length === 0) {
    //   $('.header--bottom--nav').removeClass('active');
    // }

    // var containerNav = $(".header--nav__wrapper");
    // var containerNav2 = $(".header--nav--wrapper--item > span");
    // if ((!containerNav.is(e.target) && containerNav.has(e.target).length === 0) && (!containerNav2.is(e.target) && containerNav2.has(e.target).length === 0)) {
    //   $('.header--nav--wrapper--item').removeClass('opend');
    //   setTimeout(function() {
    //     $('.shadow-blur').removeClass('visible');
    //     $('#page').removeAttr('style');
    //   }, 200);
    // }  

    /*
    var containerCart = $("[aria-describedby='quick_cart_container']");
    var containerCart2 = $("#widget_minishopcart");
    if ((!containerCart.is(e.target) && containerCart.has(e.target).length === 0) && (!containerCart2.is(e.target) && containerCart2.has(e.target).length === 0)) {
        // $("[aria-describedby='quick_cart_container']").css('display') !== 'none' && $("[aria-describedby='quick_cart_container']").length > 0 ? toggleMiniShopCartDropDown('widget_minishopcart','quick_cart_container','orderItemsList') : '';
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    }
    
    var containerCartAdded = $("[aria-describedby='MiniShopCartProductAdded']");
    var containerCart2Added = $("#widget_minishopcart");
    if ((!containerCartAdded.is(e.target) && containerCartAdded.has(e.target).length === 0) && (!containerCart2Added.is(e.target) && containerCart2Added.has(e.target).length === 0)) {
        // $("[aria-describedby='MiniShopCartProductAdded']").css('display') !== 'none' && $("[aria-describedby='MiniShopCartProductAdded']").length > 0 ? toggleMiniShopCartDropDown('widget_minishopcart','MiniShopCartProductAdded','orderItemsList') : '';
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    }
    
    var containerCartLabel = $("[aria-describedby='MiniShoppingCart_Label']");
    var containerCart2Label = $("#MiniShoppingCart");
    if ((!containerCartLabel.is(e.target) && containerCartLabel.has(e.target).length === 0) && (!containerCart2Label.is(e.target) && containerCart2Label.has(e.target).length === 0)) {
        // $("[aria-describedby='MiniShoppingCart_Label']").css('display') !== 'none' && $("[aria-describedby='MiniShoppingCart_Label']").length > 0 ? toggleMiniShopCartDropDown('widget_minishopcart','MiniShoppingCart_Label','orderItemsList') : '';
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    }
    */

    //MiniShopCartProductAddedWrapper
});

function switchFromMobileToDesktopMenu() {
    //we have to re-build carousel controls and to re-add carousel's style
    buildCarousel();
    $('#owl-op-stories').addClass('owl-op-stories owl-carousel owl-theme');
    $('.header__nav-menu__opstories__top').css({'display': ''});
    $('#opstories-area').addClass('header__nav-menu__opstories');

    // we have to remove width for cards
    $('#owl-op-stories .owl-wrapper').removeClass('nav-category__wrapper__mobile-card');
    $('#owl-op-stories .owl-item').removeClass('nav-category__wrapper__mobile-card');

    //we have to remove scrolling
    $('#owl-op-stories').removeClass('nav-category__wrapper opend scroll-mobile-stories');
    $('#owl-op-stories').css({'z-index': ''});
}

function switchFromDesktopToMobileMenu() {
    // we have to restart carousel (switching to first card)
    goToCarouselCard(0);
    $(".header__nav-menu__opstories__arrow.left").prop("disabled", true);
    $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);

    // we have to destroy carousel controls and to remove carousel's style
    destroyCarousel();
    $('#owl-op-stories').removeClass('owl-op-stories owl-carousel owl-theme');
    $('.header__nav-menu__opstories__top').css({'display': 'none'});
    $('#opstories-area').removeClass('header__nav-menu__opstories');

    // we have to set width for cards
    $('#owl-op-stories .owl-wrapper').addClass('nav-category__wrapper__mobile-card');
    $('#owl-op-stories .owl-item').addClass('nav-category__wrapper__mobile-card');

    //we have to add scrolling
    $('#owl-op-stories').addClass('nav-category__wrapper opend scroll-mobile-stories');
    $('#owl-op-stories').css({'z-index': 20});
}

function adaptMenuHeight() {
    if((window.mobilecheck() || window.tabletPortraitCheck())){
        // we have to adapt menu height with overflow if viewport height is less than a specified value
        $('.header__nav-menu__categories').height('');
        $('.header__nav-menu__takumi').height('');

        var menuScrollHeight = $('#menu_container')[0].scrollHeight;
        var visibleMenuHeight = parseInt($('.header__nav-menu__categories').css('height'), 10);
        if (window.innerHeight < menuScrollHeight && visibleMenuHeight < menuScrollHeight) {
            menuContainerHeight = $('#menu_container')[0].scrollHeight + 5;
            $('.header__nav-menu__categories').height(menuContainerHeight);
            $('.header__nav-menu__takumi').height(menuContainerHeight);
        }
    }
}

function changeHeaderIndex(isOpening){
    isOpening ? $('#header').css('z-index', '1001') :  $('#header').css('z-index', '600')
}
function changeFooterIndex(isOpening){
    isOpening ? $('#footerWrapper').css('z-index', '1002') :  $('#footerWrapper').css('z-index', '600')
}

/**
 * Function that open the newsletter from footer 
 */

function openNewsletterSticky() {
	changeTabIndex($('.newsletter'));
	 if(checkMobilePdpPage()){
	     changeFooterIndex(true)
	 }
	 $('.newsletter:not(.newsletter-page)').addClass('opend').focus().addClass('focus');
	 $('.newsletter--fade').show();
	 $('body').addClass('no-scroll');
	 $('body, html').css('height', '100%');
	 $('body, html').css('overflow', 'hidden');
	 $("#newsletter-wrapper").hide();
	 $(this).attr("data-element-id","X_HP_OverlayNewsletter");
	 tealiumPushHPNewsletterSticky($(this)[0]);
}
    
/**
 * Function close sticky and save cookie
 */
function closeNewsletterSticky() {
	 $("#newsletter-wrapper").fadeOut('fast');
     setCookie("WELCOME_STICKY_SHOWN_"+storeDirectory,true,{expires: 10000,path: "/", domain: cookieDomain});
     $('body').removeClass('no-scroll');
     $('body, html').css('overflow', 'auto');
}

/**
 * This function close the slide menus (nav menu, search, minishopcart...) when you press escape.
 */
$(window).on('load', function(){
    $('*').keyup(function (e) {
        var key = e.which;
        if (key == 27) {
            if ($('.header__nav-menu').hasClass('opend')) {
                $('.header__nav-close').click();
            }
            if ($('.header--bottom--search').hasClass('opend')) {
                $('.header__search-close').click();
            }
            if ($('#Header_GlobalLogin').hasClass('opend') || $('#Header_GlobalLogin_1').hasClass('opend')) {
                $('.global-login__close').click();
            }
            if ($('[aria-describedby="quick_cart_container"]').hasClass('opend')) {
                $('.close-button-wrapper').click();
            }
            if ($('[aria-describedby="MiniShopCartProductAdded"]').hasClass('opend')) {
                $('.close-button-wrapper').click();
            }
            if ($('.newsletter').hasClass('opend')) {
                $('.newsletter__close').click();
            }
            if ($('#sign_in_popUp .checkout-logon').hasClass('opend')) {
                $('.checkout-logon__close').click();
            }
            if (!$('.footer--payment').hasClass('desktop-hide')) {
                $('.payment--close-wrapper').click();
            }
            if($('#welcomeStorePopup').length > 0 && $('#welcomeStorePopup').css("display") != "none") {
                $('#welcomeStorePopup .closebutton').click()
            }
            if($('.presc').length > 0 && $('.presc').is(':visible')) {
                $('.presc--content__close').click();
            }
            if($('.facet__content').length > 0) {
                $('.facet__content').each(function() {
                    if($(this).hasClass('opend')) {
                        var className = $(this).attr('class').split(' ');
                        var facetElement = '.facet__chk-' + (className[1].split('--'))[1];
                        $(facetElement).click().focus();
                    }
                });
            }
        } 
    });
});

/* Show default payment placement */
/* PDP called function: #11
* prev function: setInventoryMapEntry()
* next function:  ()
*/
function showDefaultPaymentPlacement(payment) {
    var defaultPaymentPlacementCookie = getCookie("defaultPaymentPlacement");
    if (defaultPaymentPlacementCookie != undefined && defaultPaymentPlacementCookie != ""){
        payment = defaultPaymentPlacementCookie;
    }
    if (payment == ""){
        if (klarnaEnabled == 'true'){
            showKlarnaPlacements();
        } else if (affirmEnabled == 'true'){
            $('.pdp .affirm').show();
            $(".checkout__affirm").show();
        }
    } else {
        if (payment == 'klarna'){
            showKlarnaPlacements();
        } else if (payment == 'affirm'){
            $('.pdp .affirm').show();
            $(".checkout__affirm").show();
        }
    }
}

/*
$('document').ready(function() {
    $('#closeButton').click(function() {
        $('#MiniShopCartProductAddedWrapper').hide();
    });
    $('#widget_minishopcart .closeButton').click(function() {
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    });
    $('#MiniShoppingCart .closeButton').click(function() {
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    });
    
    $('#MiniShopCartProductAdded').click(function() {
        dialogWidget ? dialogWidget.uiDialog.css('display', 'block') : console.log('Does not exist');
    });
    
    $('#quick_cart_container .closeButton').click(function() {
        (dialogWidget && dialogWidget._isOpen) ? dialogWidget.close() : '';
    });
});
*/
/* END - HEADER FUNCTIONS */

//********************************************************************************************************************************************************************************************************/

/* BEGIN - MY ACCOUNT FUNCTIONS */
$('.myAccount').ready(function () {
    $('.myAccount--content--left .wrapperTitle').click(function () {
        $(this).hasClass('opend') ? $(this).removeClass('opend') : $(this).addClass('opend');
        $(this).next().toggle();
    });
});
/* END - MY ACCOUNT FUNCTIONS */

//********************************************************************************************************************************************************************************************************/

/* BEGIN - FOOTER FUNCTIONS */
$(document).ready(function () {
    /* Only for responsive design */
    $('#footer .footer--blocks--list--menu > span').click(function () {
        if ($(window).innerWidth() <= mobileBig) {
            /*
            Toggle for the footer section.
            If we click in a span, menu of this span will be shown.
            If we click in the same span when it is shown, the menu will hide.
            If we click in another span when another one is shown, the opened one will close
            and the one we click on will show.
            */
            if ($(this).parent().length > 0) {
                if ($(this).parent().hasClass('opend')) {
                    $(this).parent().removeClass('opend');
                } else {
                    $('#footer .footer--blocks--list--menu').removeClass('opend');
                    $(this).parent().addClass('opend');
                }
            }
        }
    });

    /**
    * Function that open the payment methods popup in desktop
    */

    $("#orders--payment").click(function () {
        $('.footer--payment').removeClass('desktop-hide');
        $('.payment--fade').show();
        changeTabIndex($('.footer--payment'));
        $(".payment--close-wrapper").focus().addClass('focus');
    });

    /**
    * Function that hide the payment methods popup in desktop
    */

    $(".payment--close-wrapper").click(function () {
        $('.footer--payment').addClass('desktop-hide');
        $('.payment--fade').hide();
        $('#orders--payment').focus().addClass('focus');
    });

    $(".payment--fade.fade").click(function(){
        $(".payment--close-wrapper").click();
    });
    
    $("#openSeoLinks").click(function(e){
    	e.preventDefault();
        $(".footer--bottom__allsites").removeClass('footer--bottom__allsites-hide');
    });
    
    $("#allSitesCloseLink").click(function(e){
    	e.preventDefault();
        $(".footer--bottom__allsites").addClass('footer--bottom__allsites-hide');
    });

	
});

function hideshowallsite() {
    var allsite = $("#allsite-content").html();
    if (allsite !== ''){
        var row4 = document.getElementById("footerRow4");
        $("#allsite-content").empty();
        row4.innerHTML = allsite;
    }else;
    
    if ( $("#otherall label").hasClass("active") ){
        $("#otherall label").toggleClass('active');
        $("#footerRow4").hide();
    }
    else{
        $("#otherall label").addClass('active');
        $("#footerRow4").show();
    }
}

function closeCountrySelector() {
    var countrySelector = $('#country-selector-wrapper');
    var dropdownIcone = $(this).find('.icone.triangle-dropdown');
    var documentBody = $("body");
    var fadeDiv=$(".footer--fade.fade");
    if (countrySelector.hasClass('opend')) {
        countrySelector.removeClass('opend');
        $('.country-current__name').focus().addClass('focus');
        manageScrollOverlay(false);
    } else {
        countrySelector.addClass('opend');
        $(countrySelector).find('*:focusable').first().focus().addClass('focus');
        manageScrollOverlay(true);
    }
    documentBody.hasClass('overflowHidden') ? documentBody.removeClass('overflowHidden') : documentBody.addClass('overflowHidden');
    fadeDiv.toggle();
    if (dropdownIcone.length > 0)
        dropdownIcone.hasClass('opend') ? dropdownIcone.removeClass('opend') : dropdownIcone.addClass('opend');
    changeTabIndex($(countrySelector));
}

function validateFormNewsletter() {
    //var inputValue = $('#mce-EMAIL').val();
    var inputValue = $('#newsletterEmail').val();

    if (inputValue == '') {
        $('#mce-error-response').show();
        $('#mce-error-response').children().hide();
        $("#mce-error-response-empty").show();
    } else {
        $('#mce-error-response').css('display') != 'none' ? $('#mce-error-response').hide() : '';
        $('#mce-error-response').css('display') != 'none' ? $('#mce-success-response').hide() : '';

        //if (validateEmail(inputValue)) {
        if (!validateEmail(inputValue)) {
            $('#mce-error-response').show();
            $('#mce-error-response').children().hide();
            $('#mce-error-response-invalid').show();
        }
        else {
            $('#mc-embedded-subscribe-form').submit();
        }
    }
}

/* Function to validate the email */
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
/* END - FOOTER FUNCTIONS */

//********************************************************************************************************************************************************************************************************/

//FAQ ACCORDION
$(function () {
    if ($(".faqs-page").length > 0) {
        $(".faq-set").click(function () {
            $(".faq-a").hide();
            $(this).find(".faq-a").toggle(300, "swing");
        });
    }
});
//END FAQ ACCORDION

//********************************************************************************************************************************************************************************************************/

/**
* Issue for the hover on iOS devices.
*/
$(document).ready(function () {
    /*
    $('.product__name a').on('touchend', function(e) {
        console.log("touchend");
        if (touchmoved != true) {
            console.log("touchmoved != true");
            var el = $(this);
            var link = el.attr('href');
            window.location = link;
        }
    }).on('touchmove', function() {
        console.log("touchmove");
        touchmoved = true;
    }).on('touchstart', function() {
        console.log("touchstart");
        touchmoved = false;
    });
    */

    /**
    * This is for the onclick workaround.
    * When the onclick is removed, we have to
    * uncomment the code above
    */
    $('.product-list__product').on('touchend', function (e) {
        if (touchmoved != true)
            $(this).click();
    }).on('touchmove', function () {
        touchmoved = true;
    }).on('touchstart', function () {
        touchmoved = false;
    });
});

//********************************************************************************************************************************************************************************************************/

//STATIC PAGES ACTIVE NAV-BAR
$(function () {
    if ($('.EMS--project--navMenu').length > 0) {
        var pageSection = $("[page-section]").attr("page-section");
        // console.log(pageSection);
        var menuItem = $(".project--navMenu--item");
        var lenght = menuItem.length;
        // for(var i in menuItem){
        for (var i = 0; i <= lenght; i++) {
            var menuItemId = $(menuItem[i]).attr("id");

            if (pageSection == menuItemId)
                $(menuItem[i]).css("font-weight", "bold");
        }
    }
});
//STATIC PROJECT PAGES ACTIVE NAV-BAR

//STATIC PAGES CAROUSEL
$(function () {
    if ($('.row--project-carousel').length > 0) {
        $("#owl-sliderSmall").owlCarousel({
            items: 4,
            addClassActive: true,
            navigationText: ["<img src='/wcsstore/OliverSAS/images/svg/arrow-carousel.svg' alt='previous slide'></img>", "<img src='/wcsstore/OliverSAS/images/svg/arrow-carousel.svg' alt='next slide'></img>"],
            navigation: true,
            autoHeight: false,
            itemsDesktopSmall: [980, 4],
            itemsMobile: [479, 2],
            singleItem: false,
            slideSpeed: 600
        });

        $("#owl-sliderBig").owlCarousel({
            items: 1,
            singleItem: true,
            navigationText: ["<img src='/wcsstore/OliverSAS/images/svg/arrow-carousel.svg' alt='previous slide'></img>", "<img src='/wcsstore/OliverSAS/images/svg/arrow-carousel.svg' alt='next slide'></img>"],
            navigation: true,
            pagination: true,
            paginationNumbers: false,
            baseClass: "owl-carousel",
            theme: "owl-theme",
            dragBeforeAnimFinish: true,
            mouseDrag: true,
            touchDrag: true,
            addClassActive: true,
            slideSpeed: 600
        });

        //Sync big and small slider
        var owlSmall = $("#owl-sliderSmall").data('owlCarousel');
        var currentSlide;
        
        var owlBig = $("#owl-sliderBig").data('owlCarousel');
        $(".slide-small").click(function () {
            var currentSlide = this.getAttribute("slide-index");
            currentSlide++;
            owlBig.goTo(currentSlide);
        });
    }
});
//END STATIC PAGES CAROUSEL

//STATIC PAGES -FOOTER THUMBS FILTER
$(function () {
    if ($('.row--project-config').length > 0) {
        var thumbParam = $("#thumb-param");
        //var thumb_img=new Array();
        //var thumb_id=new Array();
        var thumb_img = [];
        var thumb_id = [];
        thumb_img[0] = thumbParam.attr("thumb_img1");
        thumb_img[1] = thumbParam.attr("thumb_img2");
        thumb_img[2] = thumbParam.attr("thumb_img3");
        thumb_id[0] = thumbParam.attr("thumb_id1");
        thumb_id[1] = thumbParam.attr("thumb_id2");
        thumb_id[2] = thumbParam.attr("thumb_id3");
        var thumb = $(".thumb");
        // var lenghtParam=thumb_id.length; /*3*/
        var lenghtThumbs = thumb.length;
        // for(var i=0;i<=lenghtParam;i++){
        for (var i in thumb_id) {
            var currentThumb_imgParam = thumb_img[i];
            var currentThumb_idParam = thumb_id[i];
            for (var j = 0; j < lenghtThumbs; j++) {
                var currentThumb = $(thumb[j]);
                var currentThumbId = $(thumb[j]).attr("id");
                if (currentThumbId == currentThumb_idParam) {
                    $(currentThumb).find("img").attr("src", currentThumb_imgParam);
                    $(thumb[j]).show();
                }
            }
        }
    }
});
//END STATIC PAGES -FOOTER THUMBS FILTER

//********************************************************************************************************************************************************************************************************/

//BOUTIQUES MAIN GRID and SINGLE STORE PAGE FUNCTIONS
$(function () {
    // Show title in main grid
    if ($('.boutiques-mainPage').length > 0)
        $('.boutiques_title').css('display', 'block');

    // Hide title in single boutique page and show retail separator
    if ($('.boutiques-page').length > 0) {
        $('.boutiques_title').css('display', 'none');
        $('.separator_container').css('display', 'block');
        // Hide current store thumbnail in footer section
        var currentPage = $(".boutiques-page").attr("id");
        var currentPageNum = currentPage.substring(9);
        // console.log("Numero pagina actual = "+currentPageNum);
        var thumbs = $(".boutique_min");
        for (var i = 0; i < thumbs.length; i++) {
            var id = $(thumbs[i]).attr("thumb_Id");

            if (id === currentPageNum)
                $(thumbs[i]).hide();
        }
    }
});
//END BOUTIQUES MAIN GRID and SINGLE STORE PAGE FUNCTIONS


//********************************************************************************************************************************************************************************************************/

// Cut long product tile names and add ...

$(document).ready(function () {
    if($(".home-page").length==0){

    var modelName_mobile = document.querySelectorAll(".modelName_mobile");
    var limitMobile = 15;
    jQuery.each(modelName_mobile, function (i) {
        var text = modelName_mobile[i].textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
        if (text.length > limitMobile)
            modelName_mobile[i].textContent = text.substring(0, limitMobile) + " ...";

        $(".modelName_mobile").text = modelName_mobile[i].textContent;
        return;
    });

    var modelName_desktop = document.querySelectorAll(".modelName_desktop");
    var limitDesktop = 45;
    jQuery.each(modelName_desktop, function(i) {
            var text = modelName_desktop[i].textContent.replace(/[\n\r]+|[\s]{2,}/g, ' ').trim();
            if (text.length > limitDesktop)
                modelName_desktop[i].textContent = text.substring(0, limitDesktop) + " ...";

            $(".modelName_desktop").text = modelName_desktop[i].textContent;
            return;
        });
    }

});

//********************************************************************************************************************************************************************************************************/

// HB-1028 BEGIN Restore all loadingInternal buttons to its initial state

function showLoadingInternal(hide, id) {
    console.log("PSL::LEGACY::showLoadingInternal function invoked");
}

function disableButton(id) {
    console.log("PSL::LEGACY::disableButton function invoked");
}
function enableButton(id) {
    console.log("PSL::LEGACY::enableButton function invoked");
}

function restoreLoadingInternalButtons() {
    console.log("PSL::LEGACY::restoreLoadingInternalButtons function invoked");
}
// HB-1028 END

//********************************************************************************************************************************************************************************************************/

/* BEGIN PAYMENT VALIDATE FUNCTION*/
/**
* This functions validates payment form input fields and legal terms checkbox to continue checkout
* @param payType Currently, possible values are 'cc' for Credit Card and 'paypal' for Paypal
* Related files: OliverSAS\Snippets\EDP\PaymentMethods\StandardVisa.jsp
*/
function makePayment(payType) {
    var error = false;
    var cardType;
    
    if (payType == 'cc') {
        var validCardNumber = $.payment.validateCardNumber($('#account1_1').val());

        //if not valid card number...
        if ($("#account1_1").val().length == 0 || !validCardNumber) {
            $("#account1_1").addClass("field-error-message");
            $('#emptyCreditCard').css('display', 'inline-block');
            newTealiumPushFormError($('#emptyCreditCard').html());
            removeCheckoutLoader();
            $('#account1_1').css('border-color', 'red');
            $('#account1_1').css('color', 'red');
            $('#account1_1').closest('.input-style').addClass('input-style-checkout-error');
            error = true;
        } else {
        	cardType = GetCardType($("#account1_1").val());
            $("#account1_1").removeClass("field-error-message");
            $('#emptyCreditCard').css('display', 'none');
            $('#account1_1').closest('.input-style').removeClass('input-style-checkout-error');
        }

        //if name on card number...
        if ($('#cc_nameoncard_1').val().trim().length == 0) {
            $('#cc_nameoncard_1').addClass("field-error-message");
            $('#emptyNameCard').css('display', 'inline-block');
            newTealiumPushFormError($('#emptyNameCard').html());
            $('#cc_nameoncard_1').css('border-color', 'red');
            $('#cc_nameoncard_1').css('color', 'red');
            error = true;
        } else {
            $('#cc_nameoncard_1').removeClass("field-error-message");
            $('#emptyNameCard').css('display', 'none');
        }

        //if Month select box empty...
        var monthError, yearError;
        if ($('#expire_month_1').val() == undefined || $('#expire_month_1')[0].value == "") {
            $('#emptyExpirationDate').css('display', 'inline-block');
            newTealiumPushFormError($('#emptyExpirationDate').html());
            $('#expire_month_1').addClass("field-error-message");
            $('#expire_month_1').css('border-color', 'red');
            $('#expire_month_1').css('color', 'red');
            error = true;
            monthError = true;
        } else {
            monthError = false;
            $('#expire_month_1').removeClass("field-error-message");
            if (!monthError && !yearError)
                $('#emptyExpirationDate').css('display', 'none');
        }

        //if Year select box empty...
        if ($('#expire_year_1').val() == undefined || $('#expire_year_1')[0].value == "") {
            $('#emptyExpirationDate').css('display', 'inline-block');
            newTealiumPushFormError($('#emptyExpirationDate').html());
            $('#expire_year_1').addClass("field-error-message");
            $('#expire_year_1').css('border-color', 'red');
            $('#expire_year_1').css('color', 'red');
            error = true;
            yearError = true;
        } else {
            yearError = false;
            $('#expire_year_1').removeClass("field-error-message");
            if (!monthError && !yearError)
                $('#emptyExpirationDate').css('display', 'none');
        }

        //if CVV empty...
        var cvvErrors = 0;
        if ($('#cc_cvc_1').val().trim().length == 0) {
            $('#emptyCVV').css('display', 'inline-block');
            error = true;
            cvvErrors++;
        } else {
            $('#emptyCVV').css('display', 'none');
        }

        if (cvvErrors == 0 && !matchCreditCardCVV($("#account1_1").val(), $('#cc_cvc_1').val().trim())) {
            $('#wrongCVVLength').css('display', 'inline-block');
            newTealiumPushFormError($('#wrongCVVLength').html());
            error = true;
            cvvErrors++;
        } else {
            $('#wrongCVVLength').css('display', 'none');
        }
        if (cvvErrors > 0) {
            $('#cc_cvc_1').addClass("field-error-message");
            //$('#cc_cvc_1').css('border-color', 'red');
            //$('#cc_cvc_1').css('color', 'red');
        } else {
            $('#cc_cvc_1').removeClass("field-error-message");
        }
    }

    if ($('.card-info--wrapper--terms--input').length > 0) {
        if ($('.card-info--wrapper--terms--input')[0].checked == false) {
            $('.card-info--wrapper--terms--alert').css('display', 'inline-block');
            $('.card-info--wrapper--terms--input').closest("div").addClass("field-error-message");
            error = true;
        } else {
            $('.card-info--wrapper--terms--input').closest("div").removeClass("field-error-message");
            $('.card-info--wrapper--terms--alert').css('display', 'none');
        }
    }

    if ($('#pres-checkout__input').length > 0) {
    	if(storeDirectory=="OliverUK" || storeDirectory=="OliverUS" || storeDirectory=="OliverDE"){
    		if ($('#pres-checkout__input').prop('checked') === false) {
    			$('.pres-checkout').addClass('pres-checkout__error--show');
                error = true;
            } else {
                $('.pres-checkout').removeClass('pres-checkout__error--show');
            }
    	}
    }

    if (countPrescription > 1) {
        $(".prescription__wrapper-error-msg").show();
        $("html, body").animate({ scrollTop: 0 }, 500);
        error = true;
    }

    if (error) {
        restoreAjaxButtons();
        moveToError();
        setTimeout(removeCheckoutLoader, 250);
  } else {
      try {
        var paymentForm = document.getElementById('PaymentForm1');

        if (payType == 'cc') {
        //console.log("PSL::store-oliver.js::makePayment::Payment method = Credit Card");
        setCurrentId('shippingBillingPageNext');
        //Remove all payMethodId input and insert the good one
        $(paymentForm).find('input[name="payMethodId"]').remove();
        $(paymentForm).append('<input type="hidden" name="payMethodId" value="Cybersource" />');
        setCurrentId('shippingBillingPageNext');
        //The event should not be triggered on the click, it should be triggered when the user is going to be redirected to the payment gateway
        tealiumPushCheckoutStep(cardType);
        CheckoutPayments.processCheckout('PaymentForm');
        
        
        } else if (payType == 'paypal') {
        addCheckoutLoader();
        //console.log("PSL::store-oliver.js::makePayment::Payment method = PayPal");
        //Remove all payMethodId input and insert the good one
        $(paymentForm).find('input[name="payMethodId"]').remove();
        $(paymentForm).append('<input type="hidden" name="payMethodId" value="PayPal" />');
        $(paymentForm).find('input[name="customerWebId"]').val(window.forterWebId);
        $(paymentForm).find('input[name="customerWebId"]').val(window.ipaddress);
        $(paymentForm).find('input[name="forterToken"]').val(window.forterToken);
        setCurrentId('shippingBillingPayPal');
        tealiumPushCheckoutStep("PayPal");
        document.getElementById('PaymentForm1').submit();
        
        
        } else if (payType == 'affirm'){
            addCheckoutLoader();
            //Remove all payMethodId input and insert the good one
            $(paymentForm).find('input[name="payMethodId"]').remove();
            $(paymentForm).append('<input type="hidden" name="payMethodId" value="Affirm" />');
            $(paymentForm).attr('action', 'AffirmForwardCmd');
            setCurrentId('shippingBillingPageNext');
            tealiumPushCheckoutStep("Affirm");
            document.getElementById('PaymentForm1').submit();
            
        } else if (payType == 'klarna') {
            addCheckoutLoader();
            //Remove all payMethodId input and insert the good one
            $(paymentForm).find('input[name="payMethodId"]').remove();
            setCurrentId('shippingBillingPageNext');
            tealiumPushCheckoutStep("Klarna");
            
            // Call Klarna Credit authorize and retrieve authorization_token
            Klarna.Credit.authorize({}, function (res) {
                var auth_token = res["authorization_token"];
                var isApproved = res["approved"];
                var show_form = res["show_form"];
                if (!auth_token || auth_token.length == 0 || !isApproved || isApproved.length == 0) {
                    if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                        MessageHelper.displayErrorMessage("Beim Autorisieren der Klarna-Zahlung ist ein Fehler aufgetreten.");
                    } else{
                        MessageHelper.displayErrorMessage("There was an error with Authorize Klarna Payment.");
                    }
                    setTimeout(removeCheckoutLoader, 250);
                } else {
                        // Note: we need to pass the token store in auth_token to authorize against it.
                        $(paymentForm).append('<input type="hidden" name="payMethodId" value="Klarna" />');
                        $(paymentForm).append('<input type="hidden" name="checkout_token" value="' + auth_token + '" />');
                        $(paymentForm).attr('action', 'KlarnaReturnCmd');
                        document.getElementById('PaymentForm1').submit();
                }
            });

        } else {
            console.log("PSL::store-oliver.js::makePayment::Unknown Payment Method = " + payType);
        }
    } catch (e) {
        console.error("Error in makePayment:",e);
        setTimeout(removeCheckoutLoader, 250);
    }
  }
}
/* END PAYMENT VALIDATE FUNCTION*/

//********************************************************************************************************************************************************************************************************/

$(document).ready(function () {
    $(".card-info--wrapper input, select").change(function () {
        if ($(this).val() && $(this).val() != "") {
            $(this).closest("div").find(".error-message").css("display", "none");
            $(this).removeClass("field-error-message");
        }
    });

    $(".card-info--wrapper--terms--input").change(function () {
        if (this.checked) {
            $(this).closest("div").removeClass("field-error-message");
        }
    });

    //BEGIN HIDE/SHOW VISA FORM FIELDS
    //$('#shippingBillingPayPal-wrapper').hide();
    $('.payment-method-block input').click(function () {
        $('.payment-method-block input').removeAttr('checked');
        $(this).attr('checked');

        if ($(this).hasClass('payment-method-block--text-Cybersource')) {
            $('.payment-method').val('payMethodId_1');
            $('#shippingBillingPayPal-wrapper').hide();
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('#shippingBillingAffirm-wrapper').hide();
            $('#shippingBillingRecap-wrapper').show();
            $('#shippingBillingKlarna-wrapper').hide();
            $('.card-fields').slideDown(400);
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        } else if ($(this).hasClass('payment-method-block--text-PayPal')) {
            $('.payment-method').val('payMethodId_2');
            $('#shippingBillingRecap-wrapper').hide();
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('#shippingBillingAffirm-wrapper').hide();
            $('#shippingBillingPayPal-wrapper').show();
            $('#shippingBillingKlarna-wrapper').hide();
            $('.card-fields').slideUp(400);
            $('#klarna-payments-container').empty();
        /**
        * BEGIN - DRF -> NERD-309 ApplePay
        */
        } else if ($(this).hasClass('payment-method-block--text-ApplePay')) {
            $('.payment-method').val('payMethodId_3');
            $('#shippingBillingRecap-wrapper').hide();
            $('#shippingBillingPayPal-wrapper').hide();
            $('#shippingBillingAffirm-wrapper').hide();
            $('#shippingBillingKlarna-wrapper').hide();
            $('#applePayButtonDiv').show();
            $('.card-fields').slideUp(400);
            $('.affirm-redirect-msg').hide();
            $('#klarna-payments-container').empty();
        /**
        * END - DRF -> NERD-309 ApplePay
        */
        } else if ($(this).hasClass('payment-method-block--text-Affirm')) {
            $('.payment-method').val('payMethodId_4');
            $('#shippingBillingRecap-wrapper').hide();
            $('#applePayButtonDiv').hide(); /** DRF -> NERD-309 ApplePay */
            $('#shippingBillingPayPal-wrapper').hide();
            $('#shippingBillingAffirm-wrapper').show();
            $('#shippingBillingKlarna-wrapper').hide();
            $('.card-fields').slideUp(400);
            $('.affirm-redirect-msg').show();
            $('#klarna-payments-container').empty();
        }
        /**
         * Klarna
         */
        else if ($(this).hasClass('payment-method-block--text-Klarna')) {
            $('.payment-method').val('payMethodId_5');
            $('#shippingBillingRecap-wrapper').hide();
            $('#applePayButtonDiv').hide(); 
            $('#shippingBillingPayPal-wrapper').hide();
            $('#shippingBillingAffirm-wrapper').hide();
            $('#shippingBillingKlarna-wrapper').show();
            $('.card-fields').slideUp(400);
            $('.affirm-redirect-msg').hide();
            /* in case of change radio button and return in radio klarna then show */
            $('#klarna-payments-container').show();

            /* Init SDK Klarna and load the Klarna widget*/ 
            if($('#WC_Klarna_Session_Client_token').val() &&
                $('#WC_Klarna_Session_Client_requestid').val()){

                $('#loader_klarna').show();
                    
                /* Perform an ajax call to update the session with user's billing informations*/
                var params = {};
                
                params.orderId = $('#WC_CheckoutPaymentsAndBillingAddressf_orderId_1').val();
                params.storeId = WCParamJS.storeId;
                params.billing_address_id = $('[name=billing_address_id] [selected=selected]').attr('value');
                params.requestID = $('#WC_Klarna_Session_Client_requestid').val();
                params.nameStore = WCParamJS.countryCode.toUpperCase();
                
                var countryCode = WCParamJS.countryCode.toUpperCase();
                if (countryCode == 'UK') {
                    countryCode = 'GB';
                }

                params.lang = locale.substring(0,2).toUpperCase() + "-" + countryCode;

                wcService.declare({
                    id: "KlarnaUpdateSessionCmd",
                    actionId: "KlarnaUpdateSessionCmd",
                    url: "KlarnaUpdateSessionCmd",

                    successHandler: function (resKlarnaUpdate) {
                        console.log(resKlarnaUpdate);
                        try {
                            $('#loader_klarna').hide();
                            Klarna.Credit.load({
                                container: '#klarna-payments-container'
                            }, function (res) {
                                if (res["show_form"] == false) {
                                    if (WCParamJS.countryCode.toUpperCase() == 'DE'){
                                        MessageHelper.displayErrorMessage("Beim Laden des Klarna Payment Widget ist ein Fehler aufgetreten.");
                                    } else{
                                        MessageHelper.displayErrorMessage("There was an error loading Klarna Payment Widget.");
                                    }
                                }
                            })
                        } catch (e) {
                            console.log(e);
                        }
                    },
                    failureHandler: function (resKlarnaUpdate) {
                        if (resKlarnaUpdate.errorMessage) {
                            MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessage);
                        } else {
                            if (resKlarnaUpdate.errorMessageKey) {
                                MessageHelper.displayErrorMessage(resKlarnaUpdate.errorMessageKey);
                            }
                        }
                    }
                });

                wcService.invoke("KlarnaUpdateSessionCmd", params);
        	}
        }
    });
});
//END HIDE/SHOW VISA FORM FIELDS

$(document).ready(function () {
    $('.wc-Select-disabled').each(function () {
        $(this).parent().addClass('check-disabled');
    });
});


function assureCityValue() {
    var userData = $(".shipping_address_summary");
    var city = $(userData).find("#city").html().trim();
    $("#WC_UserRegistrationAddForm_AddressEntryForm_FormInput_city_1").val(city);
}

/* END QUICK REGISTER FORM ON THANKYOU PAGE

//********************************************************************************************************************************************************************************************************/

//BEGIN TWITTER AJAX REQUEST FUNCTION

//
//$(".projects_page_sidebar > .twitter").ready(function() {
//        $.ajax({
//            type:"GET",
//            //url: "https://api.twitter.com/1.1/search/tweets.json?q=oliverpeoples&result_type=recent&count=3",
//            //https://api.twitter.com/1.1/statuses/user_timeline.json?oauth_consumer_key=C6xMJ9R8AYoSlEoDsCrauHxN4&oauth_token=999212431258849280-vFpo7rfrKsnxwjPGLyreBHujXyXRDaG&screen_name=oliverpeoples&count=2
//            url: "https://api.twitter.com/1.1/statuses/user_timeline.json?screen_name=oliverpeoples&count=2",
//            headers: {
//                "Content-Type": "application/json",
//                "Cache-Control": "no-cache, no-store, must-revalidate",
//                "authorization": {
//                    OAuth : {
//                        oauth_consumer_key : "C6xMJ9R8AYoSlEoDsCrauHxN4",
//                //        oauth_nonce : "kYjzVBB8Y0ZFabxSWaWovY3uYSQ2pTgmZeNu2VS4cg",
//                //        oauth_signature : "generated-signature",
//                //        oauth_signature_method : "HMAC-SHA1",
//                        oauth_timestamp : "1527071811 ",
//                        oauth_token : "999212431258849280-vFpo7rfrKsnxwjPGLyreBHujXyXRDaG",
//                        oauth_version : "1.0"
//                    }
//                }
//            },
//
//            dataType: 'json',
//            //data: jsonDataShipping,
//            success : function(msg){
//                console.log("DGA::"+msg);
//                cursor_clear();
//                var result = JSON.parse(msg);
//                console.log("DGA::"+result);
//
//            },
//            error: function(XMLHttpRequest, textStatus, errorThrown) {
//                error=true;
//                console.log("DGA::Status: " + textStatus + " ; DGA::Error: " + errorThrown);
//            }
//        });
//
//
//});
//$(document).ready(function(){
//$.ajax({
//  type : 'GET',
//  url : 'https://api.instagram.com/oauth/authorize',
//  data : {
//            'client_id' : 'd5a348efe4eb470e9a507704e10bdb61',
//            'redirect_uri' : 'https%3A%2F%2Fwww.oliverpeoples.com',
//            'response_type' : 'token'
//  },
//  success : function(msg){
//                          console.log("DGA Success::");
//                          //console.log("DGA msg::"+msg);
//                          cursor_clear();
//                          //var result = JSON.parse(msg);
//                          //console.log("DGA parseMsg::"+result);
//          },
//  error : function(XMLHttpRequest, textStatus, errorThrown) {
//                          console.log("DGA::Status: " + textStatus + " ; DGA::Error: " + errorThrown);
//  }
//
//
//})

//$.ajax({
//          type: 'POST',
//          url: "https://api.instagram.com/oauth/access_token",
//          //url: "https://instagram.com/oauth/access_token",
//          headers: {
//              //"Content-Type" : "application/json; charset=utf-8",
//              //"Cache-Control" : "no-cache, no-store, must-revalidate",
//          },
//          dataType: 'json',
//          data: {
//                'client_id' : 'd5a348efe4eb470e9a507704e10bdb61',
//                'client_secret' : '54cca66c328f4c82a7a868e482f15247',
//                'grant_type' : 'authorization_code',
//                'redirect_uri' : 'https%3A%2F%2Fwww.oliverpeoples.com',
//                'code' : 'd5a348efe4eb470e9a507704e10bdb61',
//                'jsoncallback': "%3F"
//
//          },
//          success : function(msg){
//                                  console.log("DGA success::");
//                                  cursor_clear();
//
//          },
//          error : function(XMLHttpRequest, textStatus, errorThrown) {
//                                  console.log("DGA::Status: " + textStatus + " ; DGA::Error: " + errorThrown);
//          }
//});

//})


/**
* HB-638 BEGIN Disable context menu on images
*/
function disableContextMenuOnImages() {
    for (var i = 0; i < document.images.length; i++) {
        document.images[i].addEventListener("contextmenu", function (e) {
            e.preventDefault();
        });
    }
    return false;
}

$(document).ready(function () {
    //disableContextMenuOnImages();
});

$(document).ajaxComplete(function () {
    //disableContextMenuOnImages();
});
/* HB-638 END *************************************************************************************************/

/**
* Function for the checking of the State.
* If the State is California, we have to
* show a new line with a link to a popup
* with a message about some risks.
*/
// function changeState(sel) {
//   sel.value === 'CA' ? $('.prop65').addClass('shown') : $('.prop65').removeClass('shown');
// }

/**
* GDPR BEGIN
*/

/**
* Calculates if age greater than 16 years
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {boolean} true if age >= 16, false otherwise
*/
function olderThan16(year, month, day) {
    var year = parseInt(year);
    var month = parseInt(month);
    var day = parseInt(day);
    var age = calculateAge(year, month, day);
    if (age >= 16)
        return true;
    return false;
} 

/**
* Calculates age in years.
* @param {int} year format yyyy
* @param {int} month values from 1 to 12
* @param {int} day
* @return {int} age in years
*/
function calculateAge(year, month, day) {
    var birthdate = new Date(year, month - 1, day);
    var cur = new Date();
    var diff = cur - birthdate; // This is the difference in milliseconds
    var age = Math.floor(diff / 31557600000); // Divide by 1000*60*60*24*365.25
    return age;
}
/*GDPR END *************************************************************************************************/

/**
* HB-828 BEGIN Expansible address2 line in US
$(document).ready(function () {
    $(".address2_wrapper").click(function () {
        $(this).find(".address2-label").slideUp("fast");
        $(this).find(".address2-input_wrapper").slideDown("fast");
        $(this).animate({
            marginBottom: 0
        }, "fast");
        $(this).css("text-decoration", "none");
    });

    if ($(".address2_wrapper input").first().val() != "") {
        $(".address2_wrapper").click();
    }
});
*/
/* HB-828 END ******************************************************************************/

/**
* Shows a price without the currency, note that the string decimals MUST match the NUMBER_OF_DECIMALS constant
* @param {String} inPrice String with price i.e. something like "$ 100.00"
* @param {boolean} If true, decimals are removed (Default false)
* @returns String without the currency "100.00"
*/
function cleanPrice(inPrice, removeDecimals) {
    if (typeof removeDecimals === 'undefined' || removeDecimals != true) {
        removeDecimals = false;
    }
    var NUMBER_OF_DECIMALS = 2;
    var numbers = "0123456789";
    var validSeparators = ",.";
    var validChars = numbers + ",.";
    var decimalSeparator = "";
    var tempPrice = "";
    var cleanedPrice = "";
    var hasDecimals = true;
    var decimalChar = ".";

    for (var i = 0; i < inPrice.length; i++) {
        if (validChars.includes(inPrice[i])) {
            tempPrice += inPrice[i];
        }
    }

    if (tempPrice.length >= NUMBER_OF_DECIMALS + 2) {
        decimalChar = tempPrice[tempPrice.length - (NUMBER_OF_DECIMALS + 1)];
        if (!validSeparators.includes(decimalChar)) {
            hasDecimals = false;
        }
    }

    if (removeDecimals) {
        if (hasDecimals) {
            tempPrice = tempPrice.substring(0, tempPrice.length - (NUMBER_OF_DECIMALS + 1));
        }
    }

    for (var i = 0; i < tempPrice.length; i++) {
        if (numbers.includes(tempPrice[i]) || tempPrice[i] == decimalChar) {
            cleanedPrice += tempPrice[i];
        }
    }

    return cleanedPrice;
}

/**************************************************************************************************************************************************
* NEW HOME PAGE FUNCTIONS
*/

/**
* Splash image Function
* When user scrolls the home page, the splash image increase its border
*/
$(window).scroll(function () {
    var isHome = $('#header').hasClass('header--home-page');
    var y = $(window).scrollTop();
    if (y > 15) {
        $(".splash__frame").addClass("splash__frame--scrollDown");
        if (isHome == true) {
            $("#headerInfo").addClass("scrolled");
            if (window.innerWidth > mobileBig) {
                hideSplashHeader();
            }
        }
    }
    else {
        $(".splash__frame").removeClass("splash__frame--scrollDown");
        if (isHome == true) {
            $("#headerInfo").removeClass("scrolled");
            if (window.innerWidth > mobileBig) {
                showSplashHeader();
            }
        }
    }
});

$(document).ready(function () {
    var isHome = $('#header').hasClass('header--home-page');
    if (window.innerWidth <= mobileBig) {
        if (isHome == true) {
            hideSplashHeader();
        }
        setTimeout(function () { $("#headerRow2Nav").addClass("show--mobile"); }, 500);
    }
});

$(window).resize(function () {
    var isHome = $('#header').hasClass('header--home-page');
    if (window.innerWidth <= mobileBig) { 
        if (isHome == true) {
            hideSplashHeader();
        }
        $("#headerRow2Nav").addClass("show--mobile");
        $('.header__nav-menu').each(function () {
            if ($(this).hasClass('opend')) {
                $('body').addClass('no-scroll');
            }
        });
    } else {
        var y = $(window).scrollTop();
        if (y < 15 && isHome == true) {
            showSplashHeader();
        }
        $("#headerRow2Nav").removeClass("show--mobile");
        $('body').removeClass('no-scroll');
        $('.nav-category__wrapper.opend').removeClass('opend');
        $('.header__nav-back').addClass('hide');
    }
    if($('#Header_GlobalLogin').hasClass('opend') || $('.header__nav-menu').hasClass('opend') 
    		|| $('#Header_GlobalLogin_1').hasClass('opend') || $("div[aria-describedby='quick_cart_container']").hasClass('opend')
    		|| $("div[aria-describedby='MiniShopCartProductAdded']").hasClass('opend')){
    	$('body').addClass('no-scroll'); 
    }
});

/**
* Function that changes styling header from "splash header" to "scrolled header" when you scroll down
*/
function hideSplashHeader() {
    $(".header--logo--scrolled").removeClass("hide");
    $(".header--logo--splash").addClass("hide");
    $("#headerWrapper").addClass("scrolled");
}

/**
* Function that change styling header from "scrolled header" to "splash header" when you scroll up
*/
function showSplashHeader() {
    $("#headerWrapper").removeClass("scrolled");
    $(".header--logo--splash").removeClass("hide");
    $(".header--logo--scrolled").addClass("hide");
}

/**
 * Footer country selector widget
 */
$(document).ready(function () {
    /*Insert the Footer country selector widget into an empty div in the Footer_Footer_EMS*/
    $(".country-current").html("<!--Injected from store-oliver.js-->" + $("#country-current").html());
    /*Delete the original html to avoid duplicated ids*/
    $("#country-current").html("");


    $('.country-current__wrapper').click(function() {
        closeCountrySelector();
    });
    

    $("#country-selector-close-bar").click(function() {
        closeCountrySelector();
    });

    $(".footer--fade.fade").click(function() {
        closeCountrySelector(); 
    });


});

/**
* Home Page Product Carousel initialization
*/
$(document).ready(function () {
    var totalProductsSlot3 = $('.home-page__slot3 .content > div').length;
    $('.home-page__slot3 .content').owlCarousel({
        items: totalProductsSlot3,
        itemsMobile: [700, 1],
        itemsTablet: [1024, 2],
        itemsDesktop: [1199, totalProductsSlot3],
        pagination: true,
        paginationNumbers: false,
        responsive: true,
        addClassActive: true
    });

    $('.home-page__slot4 .content').owlCarousel({
        items: 4,
        itemsMobile: [700, 1],
        itemsTablet: [1024, 2],
        // itemsDesktopSmall: [1300, 3],
        itemsDesktop: [1199, 4],
        pagination: true,
        paginationNumbers: false,
        responsive: true,
        addClassActive: true
    });
});  

/**
* Function to generate the Book Style SliderS placed in homepage
* The function uses an html structure inserted in the Content.
* Then fills this structure with the data placed in the same content
* After inserts the result into an owl carousel
*/
$(document).ready(function () {
    if($(".home-page").length > 0) {
        // HOME PAGE ZONE3 Book Slider
        if (hpslider3 !== "") {
            var finalSlider = "";
            var currentSlide = "slide1";

            // Main Image Slider
            var leftImageSlider = "";
            var leftImageElements = hpslider3[currentSlide].imageLeft;
            var sliderElements = leftImageElements.length;
            for (var i = 1; i <= leftImageElements.length; i++) {
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a").attr('href', leftImageElements[i-1].imageLink);
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a").attr('aria-label', leftImageElements[i-1].imageAriaLabel);
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a > img").attr('src', leftImageElements[i-1].imageUrl);
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a > img").attr('alt', leftImageElements[i-1].imageAlt);
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a > img").attr('alt', leftImageElements[i-1].imageDataDescription);
                $("#x-hp-zone3-slider-hidden .x-hp__image .x-hp__image-left > a > img").attr('data-element-id', leftImageElements[i-1].imageDataElementID);
                // Pagination
	            if (leftImageElements.length > 1) {
	                $("#x-hp-zone3-slider-hidden .page-current").html(i + "/");
	                $("#x-hp-zone3-slider-hidden .page-total").html(sliderElements);
	                $("#x-hp-zone3-slider-hidden .x-hp__cta__slash").html(" ___ ");
	            }
                leftImageSlider = leftImageSlider + $('#x-hp-zone3-slider-hidden .x-hp__image').html();
            }

            $("#x-hp-zone3-slider-hidden .x-hp__image").html(leftImageSlider);

            // Title and text
            $("#x-hp-zone3-slider-hidden .x-hp__title").html(hpslider3[currentSlide].title);
            $("#x-hp-zone3-slider-hidden .x-hp__text").html(hpslider3[currentSlide].description);

            // Product image
            $("#x-hp-zone3-slider-hidden .x-hp__prod-image>a").attr('id', 'hp-zone3-slide'+i+'-prod-image-link');
            $("#x-hp-zone3-slider-hidden .x-hp__prod-image>a").attr('href', hpslider3[currentSlide].imageLink);
            $("#x-hp-zone3-slider-hidden .x-hp__prod-image>a").attr('aria-label', hpslider3[currentSlide].imageAriaLabel);
            document.querySelector("#x-hp-zone3-slider-hidden .x-hp__prod-image>a").setAttribute('data-element-id', hpslider3[currentSlide].imageDataElementID);
            $("#x-hp-zone3-slider-hidden .x-hp__prod-image img").attr('src', hpslider3[currentSlide].imageProd);
            $("#x-hp-zone3-slider-hidden .x-hp__prod-image img").attr('alt', hpslider3[currentSlide].nameProd);

            // Product name
            $("#x-hp-zone3-slider-hidden .x-hp__prod-name").html(hpslider3[currentSlide].nameProd);

            // cta1
            $("#x-hp-zone3-slider-hidden .x-hp__cta__text").html(hpslider3[currentSlide].cta1);
            $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('href', hpslider3[currentSlide].cta1Link);
            $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('id', 'hp-zone3-slide'+i+'-cta1');
            $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('aria-label', hpslider3[currentSlide].cta1AriaLabel);
            $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('data-element-id', hpslider3[currentSlide].cta1DataElementID);
            $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('data-description', hpslider3[currentSlide].cta1DataDescription);
            
            var cta1Html = $("#x-hp-zone3-slider-hidden .x-hp__cta").html();
            var cta2Html = "";

            // cta2
            if (hpslider3[currentSlide].cta2.length > 0) {
                $("#x-hp-zone3-slider-hidden .x-hp__cta__text").html(hpslider3[currentSlide].cta2);
                $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('href', hpslider3[currentSlide].cta2Link);
                $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('id',  'hp-zone3-slide'+i+'-cta2');
                $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('aria-label', hpslider3[currentSlide].cta2AriaLabel);
                $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('data-element-id', hpslider3[currentSlide].cta2DataElementID);
                $("#x-hp-zone3-slider-hidden .x-hp__cta__link").attr('data-description', hpslider3[currentSlide].cta2DataDescription);
                var cta2Html = $("#x-hp-zone3-slider-hidden .x-hp__cta").html();
                $('#x-hp-zone3-slider-hidden .x-hp__cta').html(cta1Html + cta2Html)
            }
            finalSlider = finalSlider + $('#x-hp-zone3-slider-hidden').html();

            // Render the result
            $('#x-hp-zone3-slider').html(finalSlider);
            // Delete the original html to avoid duplicated ids
            $("#x-hp-zone3-slider-hidden").html("<div></div>");

            // initializing owl Carousel
            var owlzone3slider = $('#x-hp-zone3-slider .x-hp__image');
            owlzone3slider.owlCarousel({
            	responsiveBaseWidth: window,
                itemsMobile: [600, 1],
                itemsTablet: false,
                itemsDesktopSmall: true,
                itemsDesktop: [2000, 1],
                responsive: true,
                lazyLoad: true,
                rewindNav: false,
                pagination: true,
                navigation: false,
                singleItem: true,
                slideSpeed: 1000,
                addClassActive: true

            });

            // Pagination behaviourr
            $(".x-hp__zone3 .page-prev").click(function (event) {
                event.preventDefault();
                owlzone3slider.trigger('owl.prev');
            });

            $(".x-hp__zone3 .page-next").click(function (event) {
                event.preventDefault();
                owlzone3slider.trigger('owl.next');
            });

            $(".x-hp__zone3 .x-hp__image.owl-carousel .owl-item").width(function() {
            	return ($(this).width() + 1); 
            });
        };

        // HOME PAGE ZONE6 Book Slider
        if (hpslider6 !== "") {
            var sliderElements = Object.keys(hpslider6).length;
            var finalSlider = "";

            for (var i = 1; i <= sliderElements; i++) {
                var currentSlide = "slide" + i.toString();

                // Main Image
                $("#x-hp-zone6-slider-hidden .x-hp__image-link").attr('href', hpslider6[currentSlide].ctaLink);
                document.querySelector("#x-hp-zone6-slider-hidden .x-hp__image-link").setAttribute('data-element-id', hpslider6[currentSlide].imgDataElementID);

                $("#x-hp-zone6-slider-hidden .x-hp__image img").attr('src', hpslider6[currentSlide].imageHero);
                $("#x-hp-zone6-slider-hidden .x-hp__image img").attr('alt', hpslider6[currentSlide].imgDataDescription);

                // Pagination
                if (sliderElements > 1) {
                    $("#x-hp-zone6-slider-hidden .page-current").html(i + "/");
                    $("#x-hp-zone6-slider-hidden .page-total").html(sliderElements);
                    $("#x-hp-zone6-slider-hidden .x-hp__cta__slash").html(" ___ ");
                }

                // Title and text
                $("#x-hp-zone6-slider-hidden .x-hp__title").html(hpslider6[currentSlide].title);
                $("#x-hp-zone6-slider-hidden .x-hp__text").html(hpslider6[currentSlide].description);
              
                // cta1
                $("#x-hp-zone6-slider-hidden .x-hp__cta__text").html(hpslider6[currentSlide].cta);
                $("#x-hp-zone6-slider-hidden .x-hp__cta__link").attr('href', hpslider6[currentSlide].ctaLink);
                $("#x-hp-zone6-slider-hidden .x-hp__cta__link").attr('id', 'hp-zone5-slide'+i+'-cta');
                $("#x-hp-zone6-slider-hidden .x-hp__cta__link").attr('aria-label', hpslider6[currentSlide].ctaAriaLabel);
                $("#x-hp-zone6-slider-hidden .x-hp__cta__link").attr('data-element-id', hpslider6[currentSlide].ctaDataElementID);
                $("#x-hp-zone6-slider-hidden .x-hp__cta__link").attr('data-description', hpslider6[currentSlide].ctaDataDescription);

                finalSlider = finalSlider + $('#x-hp-zone6-slider-hidden').html();
            }

            // Render the result
            $('#x-hp-zone6-slider').html(finalSlider);
            // Delete the original html to avoid duplicated ids
            $("#x-hp-zone6-slider-hidden").html("<div></div>");

            // initializing owl Carousel
            var owlzone6slider = $('#x-hp-zone6-slider');
            owlzone6slider.owlCarousel({
                items: 3,
                singleItem: true,
                itemsMobile: [600, 1],
                itemsTablet: false,
                itemsDesktopSmall: [1024,1],
                itemsDesktop: [1199, 1],
                responsive: true,
                lazyLoad: true,
                mouseDrag: false,
                rewindNav: true,
                pagination: true,
                navigation: true,
                navigationText: true,
                slideSpeed: 1000,
                addClassActive: true
            });

            // Pagination behaviourr
            $(".x-hp__zone6 .page-prev").click(function (event) {
                event.preventDefault();
                owlzone6slider.trigger('owl.prev');
            });

            $(".x-hp__zone6 .page-next").click(function (event) {
                event.preventDefault();
                owlzone6slider.trigger('owl.next');
            });         
        };
    }
});

/**
 * This function changes the image of the minishopcart whether the cart is empty or full.
 */

function updateMiniCartImage() {
    var nelements = parseInt($('#minishopcart_total').text());
    if(nelements > 0) {
        $('.minishopcart-image').removeClass('empty');
    } else {
        if (!$('.minishopcart-image').hasClass('empty')) {
            $('.minishopcart-image').addClass('empty');
        }
    }
}

/**
 * Function that fix the splash text in Android Chrome and iOS
 */

$(document).ready(function(){
    if($(".home-page").length > 0) {
        if((isMobile.android.device == true && isMobile.other.chrome == true) || (isMobile.apple.device == true)) {
            $('.splash__text-sideA').css('padding-bottom','2rem');
            $('.header--home-page.scrolled~#contentWrapper.content--home-page').css('padding-top', '0');
        }
    }
});


/**
 * This function override the Accessible Mega Menu default classes
 */
$(document).ready(function(){
    $("nav:first").accessibleMegaMenu({
        /* prefix for generated unique id attributes, which are required 
           to indicate aria-owns, aria-controls and aria-labelledby */
        uuidPrefix: "accessible-megamenu",

        /* css class used to define the megamenu styling */
        menuClass: "header__nav-list",

        /* css class for a top-level navigation item in the megamenu */
        topNavItemClass: "header__nav-item",

        /* css class for a megamenu panel */
        panelClass: "nav-category__wrapper",

        /* css class for a group of items within a megamenu panel */
        panelGroupClass: "nav-category__list",

        /* css class for the hover state */
        hoverClass: "hover",

        /* css class for the focus state */
        focusClass: "focus",

        /* css class for the open state */
        openClass: "open"
    });
});


/**
 * 
 */

function createErrorContactUsEmea(whereToPlaceError, errorMsg) {
	whereToPlaceError.html('<span class="contact-us-form__error-msg" tabindex="0">' + errorMsg + '</span>');
}

function createErrorContactUs(errorType, errorMsg) {
    errorType.parentElement.insertAdjacentHTML('afterend', '<span tabindex="0" class="contact-us-form__error">'+errorMsg+'</span>');
}

function validateEmailFormFieldContactForm (formField) {
	var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,3})$/;
	$('#errorEmail .contact-us-form__error-msg').hide();
	var formFieldValue = trim(formField.value);
    var isEmpty = formFieldValue == "";
	var isValid = true;
	
	if (isEmpty || !emailRegexp.test(formFieldValue)) {
		errorToPlace = document.querySelector("#errorEmail");
	    errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
		error = true;
		isValid = false;
	} 
	return isValid
	
}

function validateOnlyNumberContactForm(field){
	if($(field).attr('id') == 'ContactUsForm_User_Phone'){
		$('#errorPhone .contact-us-form__error-msg').hide();
	}else{
		$(field).parent().parent().find(".error-message--form .contact-us-form__error-msg").hide();
	}
	
	phone = trim(field.value);
	var isValid = true;
    var digits = "0123456789";
    var digitsCount = 0;
    var validCharsRegexp = /^-?\d+\.?\d*$/;

    for (var i = 0; i < phone.length; i++) {
        if (digits.includes(phone[i])){
            digitsCount++;
        }
    }

    if ((digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp) == null) && phone.length != 0){
        isValid = false;
    }

    if(!isValid){
    	var errorToPlace;
        var errorMessagge = "";
        if(field.id=="ContactUsForm_User_Phone"){
        	errorMessagge = $("#error_phoneNumber").attr('value');
        	errorToPlace = $('#errorPhone');
        }else if(field.id=="ContactUsForm_OrderNumber"){
        	errorMessagge = $("#error_order").attr('value');
        	errorToPlace = $(field).parent().parent().find(".error-message--form");
        }
    	errorToPlace ? createErrorContactUsEmea((errorToPlace), errorMessagge) : '';
		error = true;
    }
    return isValid;
}

$("ContactUsPage").ready(function() {
	
	if($('#contactus-form_EMEA').length > 0){
		manageEMEAForm();
	}else{
		manageOldForm();
	}
	
	
	
	function manageEMEAForm(){
		
		$('#textRemove').on('click', function(){
			document.getElementById('attachInput').value = "";
		});
		
		var urlFillPhonePrefix  = '/wcs/resources/store/' + WCParamJS.storeId + '/country/country_state_list';
		
		$.ajax({
	        url: urlFillPhonePrefix,
	        dataType: "json"}
	    ).then(function(phoneList){
	    	for(var i = 0; i < phoneList.countries.length; i++){
	    		$('#containerPhoneNumber .select-items').append('<div class="listReason" id="'+ phoneList.countries[i].callingCode +'"><span>'+  phoneList.countries[i].displayName+'</span><span>'+ phoneList.countries[i].callingCode +'</span></div>')
	    		if((WCParamJS.countryCode === phoneList.countries[i].code) || (WCParamJS.countryCode == 'UK' && phoneList.countries[i].code == 'GB')){
	    			$('#prefixNumber').html(phoneList.countries[i].callingCode); 
	    			$('#prefixNumber').attr('value', phoneList.countries[i].callingCode);
	    		}
	    	}
	    	$('#containerPhoneNumber .listReason').on('click', function(){
	    		$('#prefixNumber').html($(this).attr('id')); 
	    		$('#prefixNumber').attr('value', $(this).attr('id'));
	    	});
	    });
		
		function toBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
			    reader.readAsDataURL(file);
			    reader.onload = () => resolve(reader.result);
			    reader.onerror = reject;
			});
		}
		
		var btnSubmitContactUs = document.querySelector('#ContactUs_submit');
		
		btnSubmitContactUs.addEventListener('click', function(e) {
			var topicValue = $('#selection4ReasonDSK').attr('codeReason');
		    var firstNameValue = document.querySelector("#ContactUsForm_User_FirstName");
		    var lastNameValue = document.querySelector("#ContactUsForm_User_LastName");
		    var emailValue = document.querySelector("#ContactUsForm_User_Email");
		    var orderValue =  document.querySelector("#ContactUsForm_OrderNumber");
		    var phoneNumber = $('#prefixNumber').attr('value') + document.getElementById("ContactUsForm_User_Phone").value;
		    var msgValue = document.querySelector("#ContactUs_message");
		    var file = document.querySelector('#attachInput').files[0];
		    var attach64 = null;
		    var attachName = null;
		    var error = false;
		    
		    var allErrors = document.querySelectorAll('.contact-us-form__error-msg');
		    if (allErrors.length > 0) {
		    	allErrors.forEach(function(el) {
		        	el.remove();
		    	})
		    }
		    
		    if(file != null){
		    	if(file.size > 2097152 || !(file.type.includes('jpeg') || file.type.includes('png') || file.type.includes('pdf'))){
			    	var errorToPlace = document.querySelector("#errorAttach");
			        errorToPlace ? createErrorContactUsEmea($("#errorAttach"), $("#error_attachment").attr('value')) : '';
			        error = true;
			    }else{
			    	attachName = file.name;
			    }
		    }
		    if(orderValue.value != ''){
		    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_OrderNumber"))){
			    	error = true;
			    }
		    }
		    
		    
		    if(document.getElementById("ContactUsForm_User_Phone").value === '' && document.getElementById("ContactUsForm_User_Phone")){
		    	phoneNumber = '';
		    }else if (document.getElementById("ContactUsForm_User_Phone").value != ''){
		    	if(!validateOnlyNumberContactForm(document.querySelector("#ContactUsForm_User_Phone"))){
			    	error = true;
			    }
		    }
		    
		    
		    if (topicValue == null) {
		    	var errorToPlace = document.querySelector("#errorTopic");
		        errorToPlace ? createErrorContactUsEmea($("#errorTopic"), $("#error_topic").attr('value')) : '';
		        error = true;
		    }

		    if (firstNameValue && firstNameValue.value === '') {
		    	var errorToPlace = document.querySelector("#errorFirstname");
		        errorToPlace ? createErrorContactUsEmea($("#errorFirstname"), $("#error_firstName").attr('value')) : '';
		        error = true;
		    }
		    
		    if (lastNameValue && lastNameValue.value === '') {
		    	var errorToPlace = document.querySelector("#errorLastname");
		        errorToPlace ? createErrorContactUsEmea($("#errorLastname"), $("#error_lastName").attr('value')) : '';
		        error = true;
		    }

		    if (!validateEmailFormFieldContactForm(document.querySelector("#ContactUsForm_User_Email")) || (emailValue && emailValue.value === '')) {
			    	var errorToPlace = document.querySelector("#errorEmail");
			        errorToPlace ? createErrorContactUsEmea($("#errorEmail"), $("#error_Email").attr('value')) : '';
			        error = true;
		    }

		    if (msgValue && msgValue.value === '') {
		    	var errorToPlace = document.querySelector("#errorNotes");
		        errorToPlace ? createErrorContactUsEmea($("#errorNotes"), $("#error_desription").attr('value')) : '';
		        error = true;
		    }

		    if (error === true) {
		    	return false;
		    }
		    
		    var action = document.querySelector("#contactus-form_EMEA").getAttribute('action');
		    
		    if (action) {
		    	if(attachName != null){
		    		toBase64(file).then(function (data) {
			    		attach64 = data;
			    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
			    	});
		    	}else{
		    		callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber);
		    	}
		    	
		    	// HB-16527 Disable button after first click
		    	btnSubmitContactUs.classList.add('disabled');
		    	btnSubmitContactUs.setAttribute('aria-disabled', 'true');
		    	btnSubmitContactUs.style.cursor = 'default';
		    	btnSubmitContactUs.removeEventListener('click', arguments.callee);
		    	
		    } else {
		    	// ERROR WITH ACTION
		    	console.error("Can not retrieve the form's action.");
		    }
	    });
		
		
		
		a = document.getElementsByClassName("select-selected");

		for (var i = 0; i < a.length; i++) {
			a[i].addEventListener("click", function(e) {
				/*when the select box is clicked, close any other select boxes,
			    and open/close the current select box:*/
			    e.stopPropagation();
			    closeAllSelect(this);
			    this.nextElementSibling.classList.toggle("select-hide");
			    this.classList.toggle("select-arrow-active");
			});
		}
		
		function closeAllSelect(elmnt) {
			/*a function that will close all select boxes in the document,
			except the current select box:*/
			var x, y, i, xl, yl, arrNo = [];
			x = document.getElementsByClassName("select-items");
			y = document.getElementsByClassName("select-selected");
			xl = x.length;
			yl = y.length;
			for (i = 0; i < yl; i++) {
				if (elmnt == y[i]) {
			    	arrNo.push(i)
				} else {
			    	y[i].classList.remove("select-arrow-active");
			    }
			}
			
			for (i = 0; i < xl; i++) {
				if (arrNo.indexOf(i)) {
			    	x[i].classList.add("select-hide");
				}
			}
		}
		
		/*if the user clicks anywhere outside the select box,
		then close all select boxes:*/
		document.addEventListener("click", closeAllSelect);
		
		$('#reason-of-contact .listReason').on('click', function(){
			$(this).parent().attr('codeReason',$(this).attr('id'));
			$(this).parent().siblings().text(this.textContent);
			$('#ContactUsForm_Topic_div label').show();
			$('#ContactUsForm_Topic_div .select-selected').removeClass('color-placeholder');
		});
		
		function callContactActionEmea(action, firstNameValue,lastNameValue, emailValue, topicValue, orderValue, msgValue, attachName, attach64, phoneNumber){

			$.post(action, {
				firstName: firstNameValue.value,
				lastName: lastNameValue.value,
		        email: emailValue.value,
		        intentCode: topicValue,
		        order_id: orderValue.value,
		        note: msgValue.value,
		        attachName: attachName,
		        attach64: attach64,
		        mobile: phoneNumber
		    }, function(data) {
		    	var response = data.replace(/\*/g,"");
		        response = response.replace(/\//g,"");
		        var arr = JSON.parse(response);
		        if (arr['ResponseMessage'] == '1') {
		        	var msgOK = $("#ContactUsForm_msgOK").text();
		            $("#ContactUsForm_Returnmessage").text(msgOK);
		            $("#ContactUsForm_Returnmessage").show();
		        } else {
		        	var msgKO = $("#ContactUsForm_msgKO").text();
		            $("#ContactUsForm_Returnmessage").text(msgKO);
		            $("#ContactUsForm_Returnmessage").show();
		        }
		        // Append returned message to message paragraph.
		        $("#contactus-form_EMEA").hide();
		    });

		}
	}
    
	function manageOldForm(){
		$('#ContactUs_submit').click(function() {
			// Remove previous errors
            removeErrorContactUs();
 
			var contactUsTopic = document.querySelector('#ContactUsForm_Topic');
            var contactUsName = document.querySelector('#ContactUsForm_User_Name');
            var contactUsEmail = document.querySelector('#ContactUsForm_User_Email');
            var contactUsMsg = document.querySelector('#ContactUs_message');
            
            var contactUsTopicVal = contactUsTopic.value;
            var contactUsNameVal = contactUsName.value;
            var contactUsEmailVal = contactUsEmail.value;
            var contactUsMsgVal = contactUsMsg.value;

            contactUsTopicVal === '' ? createErrorContactUs(contactUsTopic, contactUsError.topic) : '';
            contactUsNameVal === '' ? createErrorContactUs(contactUsName, contactUsError.name) : '';
            contactUsEmailVal === '' ? createErrorContactUs(contactUsEmail, contactUsError.email) : '';
            contactUsMsgVal === '' ? createErrorContactUs(contactUsMsg, contactUsError.message) : '';

            if (contactUsTopicVal === '' || contactUsNameVal === '' || contactUsEmailVal === '' || contactUsMsgVal === '' ) {
                return false;
            }

            var action = document.querySelector('#contactus-form').getAttribute('action');
            
	        if (contactUsNameVal == '' || contactUsTopicVal == '' || contactUsEmailVal == '' || contactUsMsgVal == '') {
	            $("#ContactUsForm_Returnmessage").text("Please Fill Required Fields");
	        } else {
	            $.post(action, {
	                name: contactUsNameVal,
	                email: contactUsEmailVal,
	                topic: contactUsTopicVal,
	                message: contactUsMsgVal
	            }, function(data) {
	                var response = data.replace(/\*/g, "");
	                response = response.replace(/\//g, "");
	                var arr = JSON.parse(response);
	                if (arr['ResponseMessage'] == 'MSG_SENT') {
	                    var msgOK = $("#ContactUsForm_msgOK").text();
	                    $("#ContactUsForm_Returnmessage").text(msgOK);
	                    $("#ContactUsForm_Returnmessage").show();
	                } else {
	                    var msgKO = $("#ContactUsForm_msgKO").text();
	                    $("#ContactUsForm_Returnmessage").text(msgKO);
	                    $("#ContactUsForm_Returnmessage").show();
	                } /* Append returned message to message paragraph.*/
	                $("#contactus-form").hide();
	            });
	        }
	    });
	}
	
});


function removeErrorContactUs() {
    var errorContactUs = document.querySelectorAll('.contact-us-form__error');
    if (errorContactUs.length > 0) {
        errorContactUs.forEach(function(el) {
            el.remove();
        });
    }
}

function showReturnMessageContactUs(msg) {
    var returnMsg = document.querySelector('#ContactUsForm_Returnmessage');
    returnMsg.text(msgKO);
    returnMsg.show();
}

/**
 * Create sign in pop-up in checkout flow.
 */
$(document).ready(function () {
    $('.have_an_account').on('click', '.shipping_sign_in',function(e){
        e.preventDefault();
        e.stopPropagation();
        var signInPopUp = $(this).parent().find('#sign_in_popUp');
        if (signInPopUp.length > 0) {

            var waitForEl = function(selector, callback) {
                if ($(selector).length) {
                    callback();
                } else {
                    setTimeout(function() {
                        waitForEl(selector, callback);
                    }, 1000);
                }
            };
            
            var selector = '#sign_in_popUp .checkout-logon';
        
            waitForEl(selector, function() {
                // work the magic
                changeTabIndex(signInPopUp);
                signInPopUp.find('.checkout-logon').addClass('opend').find(':focusable').first().focus().addClass('focus');
                $('.sign_in_popUp--fade').show();
                $('body').addClass('no-scroll');
                $('body, html').css('height', '100%');
                $('body, html').css('overflow', 'hidden');
                $('.checkout-form').keydown(function(e) {
                    if(e.keyCode == 13) {
                        $('#guestShopperLogon').click();
                    }
                });
            });
        }
    });
    /**
    * Function that close the sign in pop-up
    */
    $('.checkout-logon__close').click(function () {
        var checkoutLogon = $('#sign_in_popUp .checkout-logon');
        changeTabIndex(checkoutLogon);
        checkoutLogon.removeClass('opend');
        $('body').removeClass('no-scroll');
        $('body, html').css('height', 'auto');
        $('body, html').css('overflow', 'visible');
        $('.sign_in_popUp--fade').hide();
    });

    /**
    * Function that close the sign in pop-up when click in fade layer
    */
    $('.sign_in_popUp--fade').click(function () {
        $('.checkout-logon__close').click();
    });
    if($('#newsletter-wrapper .newsletter-subscribe span').length > 0)
    	$('#newsletter-wrapper .newsletter-subscribe span')[0].setAttribute('onclick','openNewsletterSticky()');
});


/***
 * Error Message
 */
displayLoginErrorMessage = function() {
    var loginError = $('.login-error');
    if (loginError.length > 0) {
        loginError.find('.myaccount_error').text(MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"]);
    }
};


/*
// Newsletter Landing Page CTA event -- Deprecato, codice nel content
$(document).ready(function() { 
    var newsLetterLandingPage = document.getElementById('newsLetterLandingPage');
    if(newsLetterLandingPage !== null) {
        newsLetterLandingPage.addEventListener("click", function(e) {
            e.preventDefault();
            NewsLetterJS.setCommonParameters(WCParamJS.langId, WCParamJS.storeId, WCParamJS.catalogId);
            NewsLetterJS.subscribeToNewsLetter('newsLetterFormLandingPage');
        });
    }
});
*/

/**
* PLP mobile select-bean control
*/
$(document).ready(function () {
    $('select.select-bean').change(function(e){
    	document.location.href = $(e.target).val();
    });

});  

//open pop up klarna payment page
function openPopup(){
    $('.pop-container iframe').eq(0).attr('scrolling','yes');
    if (window.mobilecheck() || window.tabletPortraitCheck()){
        $(".pop-container.only-mobile").css('display','block');
        bodyScrollLock.disableBodyScroll(document.querySelector('.pop-wrap'));
    } else {
        $(".pop-container.only-desktop").css('display','block');
    }
    //$("body").css("overflow","hidden");
	$(".pop-bg, .pop-x").bind("click", function() {
		pop_close();
	});

}

function pop_close() {
    $(".pop-container").css('display','none');
    //$("body").css("overflow","auto");
	$("body").unbind("click");
    if (window.mobilecheck() || window.tabletPortraitCheck()){
        bodyScrollLock.enableBodyScroll(document.querySelector('.pop-wrap'));
    }
}

function updateTealiumProductsUpsell(upsell){
    $('body').append('<div id="upsell-added-inicart"><span id="upsell-list-price">' + $('.espot-complete-order-upsell #listPrice_' + upsell).text().replace(/\s/g, '') + ' </span><span id="upsell-offer-price">' + $('.espot-complete-order-upsell #offerPrice_' + upsell).text().replace(/\s/g, '') + '</span></div>')

	if(typeof tealiumProducts === 'undefined'){
        tealiumProducts = {};
    }
    var upSellDetails = $('[data-catentry-id='+upsell+'] .product__name a');
    var upsellSku = upSellDetails.length > 0 ? upSellDetails[0].dataset.partnumber : upsell;
    if (typeof tealiumProducts[upsellSku]=== 'undefined'){
        var tealiumProduct = {};

        var listPrice = $('#listPrice_'+upsell).length > 0 ? cleanPrice($('#listPrice_'+upsell)[0].innerText) : '';
        var offerPrice = $('#offerPrice_'+upsell).length > 0 ? cleanPrice($('#offerPrice_'+upsell)[0].innerText) : '';
        if (listPrice != ""){
            listPrice = parseFloat(listPrice).toFixed(2);
        }
        else 
            listPrice = parseFloat(offerPrice).toFixed(2);

        if (offerPrice != ""){
            offerPrice = parseFloat(offerPrice).toFixed(2);
        }
        
        tealiumProduct['Sku']= upsellSku;
        tealiumProduct['ModelName']= upSellDetails.length > 0 ? upSellDetails[0].dataset.description : '';
        tealiumProduct['Category'] = upSellDetails.length > 0 ? upSellDetails[0].dataset.category.toUpperCase() : '';
        tealiumProduct['Price'] = offerPrice;
        tealiumProduct['Status'] = "Available";
        tealiumProduct['PriceFull'] = listPrice;
        tealiumProduct['Engraving'] = "N";
        tealiumProduct['Brand'] = currentBrand;
        tealiumProduct['Units'] = 1;
        
        tealiumProducts[upsellSku] = tealiumProduct;
    } else {
        tealiumProducts[upsellSku].Units++;
    }       
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
shoppingActionsServicesDeclarationJS = {
	langId: "-1", /* language of the  store */
	storeId: "", /*numeric unique identifier of the store */
	catalogId: "", /*catalog of the store that is currently in use */

	/**
	 * Sets common parameters used by the services
	 * @param (int) langId The language of the store.
	 * @param (int) storeId The store currently in use.
	 * @param (int) catalogId The catalog of the store currently in use.
	 */
	setCommonParameters:function(langId,storeId,catalogId){
			this.langId = langId;
			this.storeId = storeId;
			this.catalogId = catalogId;
	}
}

	/**
	 * Add an item to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddOrderItem",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxCustomRESTOrderItemAdd",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			
			//START Wunderkind
			if(typeof updateWkndCartValue == 'function') {
				updateWkndCartValue();
			}
			//END Wunderkind

			MessageHelper.hideAndClearMessage();
			// Do not show this message. When item is added, we open up mini cart to display the currently added item.
			// MessageHelper.displayStatusMessage(Utils.getLocalizationMessage("SHOPCART_ADDED"));
            cursor_clear();
            
            //HB-1988 BEGIN
            restoreAjaxButtons();
            //HB-1988 END
            
			if(shoppingActionsJS){

				var attributes_container = $('div[id^="attrValue_"]');

				if (($(".definingAttributes")[0]) != null) {
					var attributes_container = $(".definingAttributes");
				}
				else if (($(".product_sizes")[0]) != null) {
					var attributes_container = $(".product_sizes");
				}
				else if (($(".product_info")[0]) != null) {
					var attributes_container = $(".product_info");
				}

				var attributes = new Array();
				for (var i = 0; i < attributes_container.length; i++) {
					var attribute_selectors = attributes_container[i].querySelectorAll(".dijitSelect");
					for (var j = 0; j < attribute_selectors.length; j++) {
						attributes = attributes.concat(attribute_selectors[j]);
					}
				}

				var dijitSelect = new Array();
				for (var i = 0; i < attributes.length; i++) {
					dijitSelect[i] = dijit.registry.byNode(attributes[i]);
				}

				var singleSKU = true;
				for(var i=0; i<dijitSelect.length; i++){
					if (dijitSelect[i].options.length > 2)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					wcTopic.publish('DefiningAttributes_Resolved_'+shoppingActionsJS.baseCatalogEntryId, shoppingActionsJS.baseCatalogEntryId, -1);
					for(var i=0; i<dijitSelect.length; i++){
						if(dijitSelect[i] != null){
							dijitSelect[i].value = "";
						}
					}
				}

			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
			}


			//BEGIN Lens Configurator
			//update prescription with the generated orderitemsid from cart service
			if(productDisplayJS.prescription === true){
                _prescriptionObject = $.cookie("_prescriptionObject");
				if(_prescriptionObject != undefined){
	
                    $.ajax({
                        url: "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self",
                        method: "GET",
                        async: false,
						headers: {
							"Content-Type": "application/json",
							"Cache-Control": "no-cache, no-store, must-revalidate"
						},
						data: {
							"timestamp": Date.now()
						},
                        success: function(data) {
                                var maxOrderItemId = 0;
								var roxFrameSelected = $('#roxFrameID').val();
                                //retrieve object with roxframeId in the array orderitem and extract the orderitemsid
                                //in case there are more than one item with same catentry take the greater one
                                $.each(data.orderItem,(index,element) => {
                                    if(element.productId === roxFrameSelected && maxOrderItemId < element.orderItemId){
                                        console.log(element.orderItemId);
                                         maxOrderItemId = element.orderItemId;
                                    }
                                });
                                
                                _prescriptionObject = JSON.parse(_prescriptionObject);
                                parameters = {};
                                parameters.orderItemsId = maxOrderItemId;
                                parameters.prescriptionId = _prescriptionObject.prescriptionId;
                                
                                parameters.type = "S";
                                if (productDisplayJS.lensOptionValue === "Progressive"){
                                    parameters.type = "P";
                                }
                                
                            
                                var docStr = generateXML(parameters);
                                var xmldoc = {};
                                xmldoc.XML = docStr;
                                //asynchronous call: if the prescription hasn't be updated it will not go to the cart
                                AddPrescription(xmldoc).then(function(){
                                    console.log("prescription updated with orderitemsid"  + parameters.orderItemsId);
                                    
                                    /* remove cookie when item have been added to cart so if the same user add a new prescription
                                     both for error (more the one prescription are not allowed) or for replace the old one
                                     it will be treated as new prescription in the configurator */
                                     //$.removeCookie("_prescriptionObject");
									 $.removeCookie("_userId");
                                    goToCart2();

                                }).catch(function(){
                                    console.log("prescription not updated");
                                    console.log("orderitemsId used" + parameters.orderItemsId);
                                });
                        
                        },
                        error: function(err) {
                            console.log("failed to updated the prescription");
                        }
                    });
                }else{
                    //it has choosen the send it later option
                    goToCart2();
                }
			}

			if(productDisplayJS.isFrameOnly){ //this if is necessary because the sunglasses still have add to cart button 
				//it has choose the frame  only option
				goToCart2();
			}

			//END

			wcTopic.publish('ProductAddedToCart');
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {
			if(productDisplayJS && productDisplayJS.YMALProductFlag) //reset flag if add fails
				productDisplayJS.YMALProductFlag = false;
		    var productUPC = $('#parentProductUpc').val();
			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT", {0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
                } else if ("_API_CANT_RESOLVE_FFMCENTER" == serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(API_CANT_RESOLVE_FFMCENTER_MSG);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
			 	
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING" || serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE" 
                    || serviceResponse.errorMessageKey == "_API_CANT_RESOLVE_FFMCENTER" || serviceResponse.errorMessageKey == "_ERR_PROD_NOT_ORDERABLE") {
                   trackAddToCartFailure('Product', serviceResponse.errorMessage, productUPC);
                }
                else{
                   trackAddToCartFailure('Server', serviceResponse.errorMessage, productUPC); 
                }
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
					trackAddToCartFailure('Product', serviceResponse.errorMessageKey, productUPC);
				 }
			}

			if(serviceResponse.errorCode){
				wcTopic.publish("OrderError",serviceResponse);
			}

			cursor_clear();
		}

	}),

	/**
	 * Adds a pre-defined dynamic kit to a shopping cart in Ajax mode. A message is displayed after
	 * the service call.
	 * @constructor
	 */
	wcService.declare({
		id: "AddPreConfigurationToCart",
		actionId: "AddOrderItem",
		url: getAbsoluteURL() + "AjaxRESTOrderAddPreConfigurationToCart",
		formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

		,successHandler: function(serviceResponse) {
			MessageHelper.hideAndClearMessage();
			cursor_clear();
			if(shoppingActionsJS){

				var attributes = document.getElementsByName("attrValue");

				var singleSKU = true;

				for(var i=0; i<attributes.length; i++){
					if (attributes[i].options.length > 1)
					{
						singleSKU = false;
					}
				}

				if (!singleSKU)
				{
					shoppingActionsJS.selectedAttributes = new Object();
					for(var i=0; i<attributes.length; i++){
						if(attributes[i] != null){
							attributes[i].value = "";
							attributes[i].onchange();
						}
					}
				}
			}
			if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
				ShipmodeSelectionExtJS.setOrderItemId(serviceResponse.orderItem[0].orderItemId);
			}
		}
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
		,failureHandler: function(serviceResponse) {

			if (serviceResponse.errorMessage) {
			 	if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
			 		MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("ERROR_CONTRACT_EXPIRED_GOTO_ORDER"));
 				} else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
					var tempString = Utils.getLocalizationMessage("GENERICERR_MAINTEXT",{0:Utils.getLocalizationMessage("GENERICERR_CONTACT_US")});
 					MessageHelper.displayErrorMessage(tempString);
 				} else {
 					MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
 				}
			}
			else {
				 if (serviceResponse.errorMessageKey) {
					MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
				 }
			}
			cursor_clear();
		}

	})

// -----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2006, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
// -----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the store jsp's related to address creation and maintenance.
 * @version 1.0
 */

/**
 * The functions defined in this class enable address creation across the store.
 *
 * @class The functions and variables defined in this class validate the form
 *        input field values entered by the customer. Another set of functions
 *        help in loading the UI for the state field when there is a change in
 *        the country field. Another set of functions enable creating an address
 *        in the shopcart page and guest user checkout page.
 */
var zipCodeError= false;
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}





var continents = [
    {
      continent: 'AF',
      countries: ['DZ','AO','BW','BI','CM','CV','CF','TD','KM','YT','CG','CD','BJ','GQ','ET','ER','DJ','GA','GM','GH','GN','CI','KE','LS','LR','LY','MG','MW','ML','MR','MU','MA','MZ','NA','NE','NG','GW','RE','RW','SH','ST','SN','SC','SL','SO','ZA','ZW','SS','EH','SD','SZ','TG','TN','UG','EG','TZ','BF','ZM']
    },
    {
      continent: 'AS',
      countries: ['AF','AZ','BH','BD','AM','BT','IO','BN','MM','KH','LK','CN','TW','CX','CC','CY','GE','PS','HK','IN','ID','IR','IQ','IL','JP','KZ','JO','KP','KR','KW','KG','LA','LB','MO','MY','MV','MN','OM','NP','PK','PH','TL','QA','RU','SA','SG','VN','SY','TJ','TH','AE','TR','TM','UZ','YE','XE','XD','XS']
    },
    {
      continent: 'EU',
      countries: ['AL','UK','AD','AZ','AT','AM','BE','BA','BG','BY','HR','CY','CZ','DK','EE','FO','FI','AX','FR','GE','DE','GI','GR','VA','HU','IS','IE','IT','KZ','LV','LI','LT','LU','MT','MC','MD','ME','NL','NO','PL','PT','RO','RU','SM','RS','SK','SI','ES','SJ','SE','CH','TR','UA','MK','GB','GG','JE','IM']
    },
    {
      continent: 'NA',
      countries: ['AG','BS','BB','BM','BZ','VG','CA','KY','CR','CU','DM','DO','SV','GL','GD','GP','GT','HT','HN','JM','MQ','MX','MS','AN','CW','AW','SX','BQ','NI','UM','PA','PR','BL','KN','AI','LC','MF','PM','VC','TT','TC','US','VI']
    },
    {
        continent: 'OC',
        countries: ['AS','AU','SB','CK','FJ','PF','KI','GU','NR','NC','VU','NZ','NU','NF','MP','UM','FM','MH','PW','PG','PN','TK','TO','TV','WF','WS','XX']
    },
    {
        continent: 'SA',
        countries: ['AR','BO','BR','CL','CO','EC','FK','GF','GY','PY','PE','SR','UY','VE']
    }
  ];

function getContinent(country){
	for (var key in continents) {
	    // check if the property/key is defined in the object itself, not in parent
	    if (continents.hasOwnProperty(key)) {
	    	if(continents[key].countries.includes(country)){
	    		return continents[key].continent;
	    	}        
	    }
	}
}

//ChangeDone
AddressHelper = {
    /* The name of the state field div. */
    stateDivName: "stateDiv",
    storeCountry: "",
    storeName: "",
    /* styling class for the state field. */
    stateClass: null,
    selectedCountryCode: null,
    cityId: null,
    stateId: null,
    maxNeighborhoodChar : 31,
    validZipCode: null,
    zipCodeNotFound:false,
    validZipCodeShipping: null,
    validZipCodeBilling: null,
    isSameCountryAsStore: true,
    zipCount: 0,
    validCPF: false,
    hasTaxes: false,

    setStoreName: function (storeName) {
        this.storeName = storeName;
    },

    /**
     * This function set the value of hasTaxes
     *
     * @param {boolean} hasTaxes show if store has taxes or not
     */
    setStoreHasTaxes: function (hasTaxes) {
        this.hasTaxes = (hasTaxes == 'true');
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
            $('.ui-widget-overlay').hasClass('custom-overlay') ? '' : $('.ui-widget-overlay').addClass('custom-overlay');
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showAddEditAddressPopup: function (widgetId, addressIdDiv, storeId) {
        this.showWCDialogPopup(widgetId);
        if (addressIdDiv && addressIdDiv != '') {
            var addressId = $('#' + addressIdDiv)[0].value;
            if (addressId && addressId != '') {
                $.ajax({
                    type: "GET",
                    url: "/wcs/resources/store/" + storeId  + "/person/@self/contact/byAddressId/" + addressId,
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    success: function (data) {
                     // fill address
                        var addEditAddressForm = document.forms['addEditAddressForm'];

                        addEditAddressForm.firstName.value = data.firstName;
                        addEditAddressForm.lastName.value = data.lastName;
                        addEditAddressForm.address1.value = data.addressLine[0];
                        addEditAddressForm.state.value = data.state;
                        addEditAddressForm.city.value = data.city;
                        addEditAddressForm.zipCode.value = data.zipCode;
                        addEditAddressForm.phone1.value = data.phone1;
                        if($('#emailAddress1')[0]) {
                            addEditAddressForm.email1.value = data.email1;
                        }

                        if (typeof addEditAddressForm.addressId == 'undefined' ) {
                            $('<input>').attr({
                                type: 'hidden',
                                id: 'addressId',
                                name: 'addressId',
                                value: addressId
                            }).appendTo(addEditAddressForm);
                        } else {
                            addEditAddressForm.addressId.value = addressId;
                        }

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {

                    }
                });
            }

        } else {
            // clears
            var addEditAddressForm = document.forms['addEditAddressForm'];

            addEditAddressForm.firstName.value = '';
            addEditAddressForm.lastName.value = '';
            addEditAddressForm.address1.value = '';
            addEditAddressForm.state.value = '';
            addEditAddressForm.city.value = '';
            addEditAddressForm.zipCode.value = '';
            addEditAddressForm.phone1.value = '';
            if (addEditAddressForm.addressId) {
                addEditAddressForm.addressId.remove();
            }
        }

    },
    /**
     * This function sets the name for the state field.
     *
     * @param {string}
     *            stateDivName The name to be set for the state field.
     */
    setStateDivName: function (stateDivName) {
        this.stateDivName = stateDivName;
    },

    /**
     * This function sets the styling class for the state field.
    *
    * @param {string}
    *            stateClass The name of the styling class to be set for the
    *            state field.
     */
    setStateClass: function (stateClass) {
        this.stateClass = stateClass;
    },

    /**
     * set selected country code on change country event
     */
    setSelectedCountryCode: function (selectedCountryCode) {
        this.selectedCountryCode = selectedCountryCode;
    },

    setStoreCountry: function (storeCountry) {
        this.storeCountry = storeCountry;
    },

    /**
     * set default selected country onload, in order to perfom zip validation
     */
    setSelectedCountryId: function (selectedCountryId) {
        this.selectedCountryId = selectedCountryId;

        var selectedCountry = document.getElementById(selectedCountryId);

        if (selectedCountry != null) {
            //set default selectedcountry code
            var currentCountryCode = null;

            if (selectedCountryId == "_state1") {
                currentCountryCode = selectedCountry.value;
            } else {
                currentCountryCode = selectedCountry.value;
            }

            this.setSelectedCountryCode(currentCountryCode);
        }


    },

    /**
     * This function return an array of countries from a global variable called
     * countries. If that variable does not already exist then it will be
     * created and populated from a JSON of country objects which should have
     * been loaded into a div on the page prior to calling this function.
     *
     * @returns {Array} countries An array of countries.
     */
    getCountryArray: function () {

        //If the countries array does not already exist then create it.

        if (document["countries"] == null) {
            countries = new Array();
            var theDiv = document.getElementById("countryListSelectionHelper");

            if (typeof theDiv == 'undefined')
                return null;
            var divJSON = eval('(' + theDiv.innerHTML + ')');
            var countriesObject = divJSON.countries;

            for (var i = 0; i < countriesObject.length; i++) {
                var countryObject = countriesObject[i];
                countries[countryObject.code] = new Object();
                countries[countryObject.code].name = countryObject.displayName;
                countries[countryObject.code].countryCallingCode = countryObject.callingCode;

                if (countryObject.states.length > 0) {
                    countries[countryObject.code].statesArray = new Array();
                    countries[countryObject.code].states = new Object();
                    for (var j = 0; j < countryObject.states.length; j++) {
                        var state = countryObject.states[j];
                        countries[countryObject.code].statesArray.push({
                            value: state.code,
                            label: state.displayName
                        });
                        countries[countryObject.code].states[state.code] = state.displayName;
                    }
                }
            }
        }

        return countries;

    },

    /**
     * This function will load the state field depending on the country
     * selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     */
    loadStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }
        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
        }

        var stateDivObj = document.getElementById(stateDiv);
        if (Utils.get_IE_version()) { /* For IE */
            var stateClass = ($("#" + newid)).attr("className");
        } else {
            var stateClass = ($("#" + newid)).attr("class");
        }

        if (stateClass != "drop_down_country") {
            this.setStateClass(stateClass);
        }
        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode].states) {
            /* switch to state list. */
            stateDivObj.appendChild(this.createStateWithOptions(paramPrefix,
                currentCountryCode, currentState, id, required));
        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     *	This function creates an input element to represent the state.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createState: function (paramPrefix, currentState, id, required) {
        var stateInput = document.createElement("input");
        stateInput.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateInput.setAttribute("name", paramPrefix + "_state");
        } else {
            stateInput.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateInput.setAttribute("aria-required", "true");
        }
        stateInput.setAttribute("class", this.stateClass);
        stateInput.setAttribute("className", this.stateClass);
        stateInput.setAttribute("size", "35");
        stateInput.setAttribute("maxlength", "49");
        if (currentState != null && currentState != 'undefined') {
            stateInput.setAttribute("value", currentState);
        }
        return stateInput;
    },

    /**
     * This function creates a <select> element to represent the state field and
     * loads it with the states corresponding to the country field.
     *
     * @param {string}
     *            paramPrefix The value can be shipping, billing or blank.
     * @param {string}
     *            currentCountryCode The country code of the selected country.
     * @param {string}
     *            currentState The value in the state field.
     * @param {string}
     *            id The id of the state field.
     */
    createStateWithOptions: function (paramPrefix, currentCountryCode, currentState, id, required) {

        this.getCountryArray();
        var stateSelect = document.createElement("select");
        stateSelect.setAttribute("id", paramPrefix + id);
        if (id == "_state1") {
            stateSelect.setAttribute("name", paramPrefix + "_state");
        } else {
            stateSelect.setAttribute("name", paramPrefix + "state");
        }
        if (required) {
            stateSelect.setAttribute("aria-required", "true");
        }
        stateSelect.setAttribute("class", "drop_down_country");
        stateSelect.setAttribute("className", "drop_down_country");
        /*clear old options. */
        stateSelect.options.length = 0;

        /* add all states. */
        for (state_code in countries[currentCountryCode].states) {

            aOption = document.createElement("option");
            stateSelect.options[stateSelect.length] = aOption;
            aOption.text = countries[currentCountryCode].states[state_code];
            aOption.value = state_code;

            if (state_code == currentState
                || countries[currentCountryCode].states[state_code] == currentState) {
                aOption.selected = true;
            }
        }

        return stateSelect;
    },

    /**
     * This function will load the state field for selection dropdown using
     * wc.Select in AdressForm.jsp depending on the country selection.
     *
     * @param {string}
     *            formName The name of the address form containing the state
     *            field and country field.
     * @param {string}
     *            stateDiv The name of the state field.
     * @param {string}
     *            id The id of the state field to be created.
     * @param {boolean}
     *            keepCurrentState A true or false value used to determine
     *            whether to keep the current value in the state field or to
     *            remove it.
     * @param {string}
     *            copyValue The value to be copied to the newly generated state
     *            field.
     * @param {boolean}
     *            addEmptyOption - If true, it adds 'Please Select' as the first
     *            option with value set to ''.
     */
    loadAddressFormStatesUI: function (formName, paramPrefix, stateDiv, id, keepCurrentState, copyValue, addEmptyOption) {

        this.getCountryArray();
        var form = document.getElementById(formName);
        if (paramPrefix == null || paramPrefix == 'undefined'
            || paramPrefix == "") {
            paramPrefix = "";
        }
        var newid = paramPrefix + id;
        var currentState;
        var required = false;
        if ($("#" + newid).length) {
            required = ($("#" + newid)).attr("aria-required");
        }
        if (keepCurrentState != null && keepCurrentState != 'undefined'
            && keepCurrentState == true) {
            currentState = $("#" + newid).val()
        } else {
            currentState = "";
        }

        if (copyValue != null && copyValue != 'undefined' && copyValue != '') {
            currentState = copyValue;
        }

        if (id == "_state1") {
            this.setStateClass("form_input");
            var currentCountryCode = form[paramPrefix + "_country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        } else {
            var currentCountryCode = form[paramPrefix + "country"].value;
            this.setSelectedCountryCode(currentCountryCode);
        }

        var stateDivObj = document.getElementById(stateDiv);
        var stateClass = ($("#" + newid)).attr("class");

        if (stateClass !== "drop_down_country") {
            this.setStateClass(stateClass);
        }

        while (stateDivObj.hasChildNodes()) {
            stateDivObj.removeChild(stateDivObj.firstChild);
        }

        if (countries[currentCountryCode]
            && countries[currentCountryCode].statesArray) {
            /* switch to state list. */
            var statesData = countries[currentCountryCode].statesArray;
            if (addEmptyOption) {
                var option1 = new Object({
                    label: Utils.getLocalizationMessage("PLEASE_SELECT"),
                    value: ''
                });
                statesData.unshift(option1);
            }

            if (this.stateClass == "" || this.stateClass == null
                || this.stateClass == undefined
                || this.stateClass == "null") {
                this.stateClass = "wcSelect";
            }

            $('<select>').attr({
                'name': paramPrefix + 'state',
                'id': paramPrefix + id,
                'class': this.stateClass,
                required: 'required'
            }).appendTo(stateDivObj);
            statesData.forEach(function (item) {
                $('<option>').attr({
                    'value': item.value
                }).html(item.label).appendTo('#' + paramPrefix + id);
            });

            var options = {
                "wcMenuClass": "wcSelectMenu",
            }
            var statesSelect = $("#" + paramPrefix + id).Select(options);
            statesSelect.val(currentState);
            statesSelect.Select("refresh_noResizeButton");

        } else {
            /* switch to state text input. */
            stateDivObj.appendChild(this.createState(paramPrefix, currentState,
                id, required));
        }
    },

    /**
     * This function validates the address form independently from the order of the fields displayed on the form, i.e. independent from the locale.
     * A  hidden field named "fields" must be set in the jsp/jspf file that calls this method. The purpose of this hidden field is to set all the mandatory
     * input fields and the order of these fields displayed on each locale-specific address entry page, so that this method knows which input
     * fields to validate and in which order it should validate them.
     *
     * assumptions:
     **1. Mandatory fields use UPPER CASE, non-mandatory fields use lower case.
     **2. The error messages used in this method are declared in the
     * jsp/jspf files that call this method.
     *
     * @param {string} form: The name of the address form obtained from the page containing address input fields.
     * @param {string} prefix: The value is set to shipping or billing.
     * @return {boolean} return: true if no error was found, or the hidden field "fields" were not set in the jsp/jspf file that calls this
     * method, return false if form could not be found, or if there was  an error validating a particular field.
     */
    validateAddressForm: function (form, prefix) {
        reWhiteSpace = new RegExp(/^\s+$/);
        if (prefix == null) {
            prefix = ""
        };
        if (prefix) {
            this.setStateDivName(prefix + "stateDiv")
        };

        if (form != null) {
            var fieldsOrderByLocaleInput = $(form).find("input[id^='AddressForm_FieldsOrderByLocale']");
            if (fieldsOrderByLocaleInput.length>0){
                $(fieldsOrderByLocaleInput).attr("id","AddressForm_FieldsOrderByLocale");
            }

            var fields = "";
            /** The hidden field "AddressForm_FieldsOrderByLocale" is to set all the mandatory fields AND the order of the fields
            *   that are going to be displayed in each locale-dependent address form, so that the JavaScript
            *   used for validation knows which fields to validate and in which order it should validate them. **/
            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
            	fields = document.getElementById("AddressForm_PickUp").value.split(",");
            }else{
            	if (form["UserDetailsForm_FieldsOrderByLocale"] != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != null
                        && form["UserDetailsForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserDetailsForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["UserAddressForm_FieldsOrderByLocale"] != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != null
                        && form["UserAddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["UserAddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form[prefix + "AddressForm_FieldsOrderByLocale"] != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != null
                        && form[prefix + "AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form[prefix + "AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (form["AddressForm_FieldsOrderByLocale"] != null
                          && form["AddressForm_FieldsOrderByLocale"].value != null
                          && form["AddressForm_FieldsOrderByLocale"].value != "") {
                            fields = form["AddressForm_FieldsOrderByLocale"].value.split(",");
                    }
                    else if (document.getElementById("AddressForm_FieldsOrderByLocale").value != null
                          && document.getElementById("AddressForm_FieldsOrderByLocale").value != "") {
                            fields = document.getElementById("AddressForm_FieldsOrderByLocale").value.split(",");
                    }
            }
            

            var nickName = prefix + "nickName";
            var lastName = prefix + "lastName";
            var firstName = prefix + "firstName";
            var middleName = prefix + "middleName";
            var address1 = prefix + "address1";
            var address2 = prefix + "address2";
            var address3 = prefix + "address3";
            var city = prefix + "city";
            var state = prefix + "state";
            var country = prefix + "country";
            var zipCode = prefix + "zipCode";
            var email1 = prefix + "email1";
            var phone1 = prefix + "phone1";
            var cpf = prefix + "fax1";
            var neighborhood = prefix + "fax2";
            var birth_date = prefix + "birth_date";
            var birth_month = prefix + "birth_month";
            var birth_year = prefix + "birth_year";

            var isValid = true;
            for (var i = 0; i < fields.length; i++) {
                var field = fields[i];
                //console.log("PSL::"+field);
                if (field == "NICK_NAME" || field == "nick_name") {
                    if (form[nickName] != null) {
                        form[nickName].value = trim(form[nickName].value);
                        if (field == "NICK_NAME" && (form[nickName].value == "" || reWhiteSpace.test(form[nickName].value))) {
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], false);
                            isValid = false;
                        } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[nickName], MessageHelper.messages["ERROR_RecipientEmpty"], true);
                        }
                        if (!MessageHelper.isValidUTF8length(form[nickName].value, 254)) {
                            MessageHelper.formErrorHandleClient( form.nickName.id, MessageHelper.messages["ERROR_RecipientTooLong"]);
                            //tealiumPushFormError(MessageHelper.messages["ERROR_RecipientTooLong"]);
                            isValid = false;
                        }
                    }
                } else if (field == "LAST_NAME" || field == "last_name") {
                    if ($(form[lastName]).attr("disabled") == undefined){
                        form[lastName].value = trim(form[lastName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (field == "LAST_NAME" && (form[lastName].value == "" || reWhiteSpace.test(form[lastName].value))) {
                            this.manageMultipleEmptyFields(form[lastName], MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        } else if(xss.test(form[lastName].value)){
                            this.manageMultipleEmptyFields(form[lastName],MessageHelper.messages["ERROR_LastNameEmpty"], false);
                            this.removeSuccesIcon(form.lastName);
                            isValid = false;
                        }else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[lastName], "", true);
                            this.validateNotEmpty(form.lastName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[lastName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[lastName].id,MessageHelper.messages["ERROR_LastNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_LastNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "FIRST_NAME" || field == "first_name") {
                    if ($(form[firstName]).attr("disabled") == undefined){
                        form[firstName].value = trim(form[firstName].value);
                        xss = new RegExp(".*[%<>&;'\0-].*");
                        if (form[firstName].value == "" || reWhiteSpace.test(form[firstName].value)) {
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                            this.removeSuccesIcon(form.firstName);
                            isValid = false;
                        }else if(xss.test(form[firstName].value)){
                        		this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], false);
                                this.removeSuccesIcon(form.firstName);
                                isValid = false;
                          } else {
                            //delete error Message
                            this.manageMultipleEmptyFields(form[firstName],MessageHelper.messages["ERROR_FirstNameEmpty"], true);
                            this.validateNotEmpty(form.firstName,true);
                        }
                    }
                    if (!MessageHelper.isValidUTF8length(form[firstName].value,128)) {
                        MessageHelper.formErrorHandleClient(form[firstName].id,MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_FirstNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "MIDDLE_NAME" || field == "middle_name") {
                    form[middleName].value = trim(form[middleName].value);
                    if (field == "MIDDLE_NAME" && (form[middleName].value == "" || reWhiteSpace.test(form[middleName].value))) {
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[middleName],MessageHelper.messages["ERROR_MiddleNameEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[middleName].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[middleName].id,MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_MiddleNameTooLong"]);
                        isValid = false;
                    }
                } else if (field == "use_org_address" || field == 'new_line' || field == "PASSWORD" || field == "PASSWORD_VERIFY") {
                } else if (field == "ADDRESS" || field == "address") {
                    form[address1].value = trim(form[address1].value);
                    xss = new RegExp(".*[%<>&;'\0].*"); 
                    if (field == "ADDRESS" && (form[address1].value == "" || reWhiteSpace.test(form[address1].value))) {
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    } /*else if(xss.test(form[address1].value)){
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], false);
                        this.removeSuccesIcon(form.address1);
                        isValid = false;
                    }*/else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[address1],MessageHelper.messages["ERROR_AddressEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(form[address1].value,100)) {
                        MessageHelper.formErrorHandleClient(form[address1].id,MessageHelper.messages["ERROR_AddressTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_AddressTooLong"]);
                        isValid = false;
                    }
                } else if (field == "ZIP" || field == "zip") {
                   var isMandatory = field == "ZIP";
                   if(zipCodeError){
                       isValid= false;
                   }
                   if (!this.validateZipCodeFormField(form[zipCode], isMandatory)){
                       isValid = false;
                   }

                } else if (field == "CITY" || field == "city") {
                    form[city].value = trim(form[city].value);
                    if (field == "CITY" && (form[city].value == "" || reWhiteSpace.test(form[city].value))) {
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], false);
                        this.removeSuccesIcon(form.city);
                            isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[city],MessageHelper.messages["ERROR_CityEmpty"], true);
                        }
                    if (!MessageHelper.isValidUTF8length(form[city].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[city].id,MessageHelper.messages["ERROR_CityTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CityTooLong"]);
                        isValid = false;
                    }
                } else if ((field == "STATE/PROVINCE" || field == "state/province") && form.action.indexOf("PersonChangeServiceAddressAdd") == -1) {
                    state = form[state];
                    if (state == null || state == "") {
                        state = document.getElementById(this.stateDivName).firstElementChild;
                    }

                   
                    if(state.value==""){
                        var stateProvince = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
                        state.value = trim(stateProvince.value);
                    }
                    if (state.value != undefined) {
                        state.value = trim(state.value);
                    }
                    if (field == "STATE/PROVINCE" && (state.value == null || state.value == "" || reWhiteSpace.test(state.value))) {
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(state, MessageHelper.messages["ERROR_StateEmpty"], true);
                    }
                    if (!MessageHelper.isValidUTF8length(state.value, 128)) {
                        if (state.tagName == "INPUT" || state.tagName == "input") {
                            MessageHelper.formErrorHandleClient(state.id + "-button", MessageHelper.messages["ERROR_StateTooLong"]);
                        } else {
                            MessageHelper.formErrorHandleClient(state.id, MessageHelper.messages["ERROR _StateTooLong"]);
                        }
                        //tealiumPushFormError(MessageHelper.messages["ERROR_StateTooLong"]);
                        isValid = false;
                    }
                } else if (field == "COUNTRY/REGION" || field == "country/region") {
                    form[country].value = trim(form[country].value);
                    // if (field == "COUNTRY/REGION" && (form[country].value == "" || reWhiteSpace.test(form[country].value)) || !this.isSameCountryAsStore) {
                    if (form[country].value == "" || reWhiteSpace.test(form[country].value)) {
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], false);
                        isValid = false;
                    } else {
                        //delete error Message
                        this.manageMultipleEmptyFields(form[country], MessageHelper.messages["ERROR_CountryEmpty"], true)
                    }
                    if (!MessageHelper.isValidUTF8length(form[country].value, 128)) {
                        MessageHelper.formErrorHandleClient(form[country].id + "-button", MessageHelper.messages["ERROR_CountryTooLong"]);
                        //tealiumPushFormError(MessageHelper.messages["ERROR_CountryTooLong"]);
                        isValid = false;
                    }
                } else if (field == "EMAIL1" || field == "email1") {
                    if  (form.name !== "Register" && form.action.indexOf("PersonChangeServiceAddressAdd") == -1){
                        var isMandatory = field == "EMAIL1";
                        if (!this.validateEmailFormField(form.email1, isMandatory)){
                            isValid = false;
                        }
                    }
                } else if ((field == "PHONE1" || field == "phone1") && (form.id.includes("shipping") || form.id.includes("billing") ||form.id.includes("recipient"))) {
                    var isMandatory = field == "PHONE1";
                    if (!this.validatePhoneNumberFormField(form.phone1, isMandatory)){
                        isValid = false;
                    }
                } else if (field == "CODICE_FISCALE" || field == "codice_fiscale") {
                    var isMandatory = field == "CODICE_FISCALE";
                    //codice fiscale is stored in the custom address field 1
                    if (!this.validateCodiceFiscaleFormField(form.addressField1, isMandatory)){
                        isValid = false;
                    }
                } else if ((field == "NUMERO" || field == "numero")){
                    var formField = form[address2];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NUMERO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NUMERO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NUMERO field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "COMPLEMENTO" || field == "complemento")){
                    var formField = form[address3];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "COMPLEMENTO") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_COMPLEMENTO_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: COMPLEMENTO field empty.NEEDS COMPLETITION");
                    } else  {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "NEIGHBORHOOD" || field == "neighborhood")){
                    var formField = form[neighborhood];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "NEIGHBORHOOD") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_NEIGHBORHOOD_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: NEIGHBORHOOD field empty.NEEDS COMPLETITION");
                    } else {
                        //delete error Messages
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "CPF" || field == "cpf")){
                    var formField = form[cpf];
                    var formFieldValue = trim(formField.value);
                    var isEmpty = (formFieldValue == "" || reWhiteSpace.test(formFieldValue));
                    if ((field == "CPF") && (isEmpty)) {
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Empty"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field empty.NEEDS COMPLETITION");
                    }
                    else if(!(validateCPFCNPJ(formField, false))){
                        this.manageMultipleErrorFields(formField, MessageHelper.messages["ERROR_CPF_Invalid"], false);
                        isValid = false;
                        console.error("Form validation error: cpf field not valid");
                    } else {
                        this.manageMultipleErrorFields(formField, "", true);
                    }
                } else if ((field == "DATEOFBIRTH" || field == "dateofbirth") && $('.checkout-quick-register .dob').length == 0){
                    var formField = document.getElementsByClassName("dob__content")[0];

                    if ($(formField).parent().attr("disabled") == undefined){
                        // var formField = form[birth_date];
                        var birthdate = trim(form[birth_date].value);
                        var birthmonth = trim(form[birth_month].value);
                        var birthyear = trim(form[birth_year].value);


                        var isEmpty =  false;
                        if (  (birthdate == "" || reWhiteSpace.test(birthdate))
                            ||(birthmonth == "" || reWhiteSpace.test(birthmonth))
                            ||(birthyear == "" || reWhiteSpace.test(birthyear)) ){
                                isEmpty = true;
                        };

                        if (isEmpty) {
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Empty"]);
                        }
                        else if (!this.validateAge(birthyear)){
                            isValid = false;
                            this.manageFormErrorMessageFields(formField, MessageHelper.messages["ERROR_BIRTHDATE_Invalid"]);
                        }
                    }

                    else {
                        //delete error Messages
                        // this.manageFormErrorFields(formField, "");
                        this.deleteFormErrorMessageFields(formField);
                    }
                }
            } //end for loop

            if (!isValid) {
                $("body").scrollTop(0);

                //this if prevents js error if WCAG.js are not imported
                if(typeof moveToError === 'function'){
                    moveToError();
                }
                restoreAjaxButtons();
                return false;
            }

            return true;
        }
        // /The form is null so..
        return false;
    },
    ////************************************************************************************************* */

/**
 * Function to validate that the register user is older than 18
 * @param {*} form
 */
    validateAge: function(birthYear){
        var isValidAge=true;
        var currentYear = new Date().getFullYear();
        if (isGDPR){
            if (currentYear-birthYear<16){
                isValidAge = false;
            }
        }else if (isCarol){
            if (currentYear-birthYear<18){
                isValidAge = false;
            }
        }
        return isValidAge;
    },

    createFormErrorMessageField: function (fieldID, errorMsg) {
    //If the error message does not exist, sets a generic error message.
        // if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
        //     errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        // }
    //Otherwise, creates a new div to display the error message
        var errorMessageField = document.createElement('div');
        errorMessageField.setAttribute("class", "address-erros-message-cont error-message-wrapper");
        errorMessageField.innerHTML = '<span tabindex="0" id="errorMessageFieldFor_' + fieldID + '" class="error-message form-error-message wcag__error">' + errorMsg + '</span>';

        return errorMessageField;
    },

/**
 * Manage multiple address form error messages for each concerned field.
 */
    manageFormErrorMessageFields: function (field, errorMsg) {


            this.deleteFormErrorMessageFields(field);
            var errorMessageField = this.createFormErrorMessageField(field.id, errorMsg);
            $(field).addClass("field-error-message inputField--invalid");
            field.parentNode.appendChild(errorMessageField);






            //Prevents js error if WCAG.js is not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }

            //Tealium filling form Errors
            //if (typeof tealiumPushFormError !== "undefined" ) {
                //tealiumPushFormError(errorMsg);
                //tealiumPushFormError(errorMsg);
            //}
    }, 

    /**
     * Deletes the error message if the field is not empty anymore.
     * @param {*} field
     */
    deleteFormErrorMessageFields: function (field){
        $("#"+field.id).parent().find(".address-erros-message-cont").remove();
        $("#"+field.id).parent().find(".error-message-wrapper").remove();
    },

    ////************************************************************************************************* */



    /**
     * mandatory field shown when one or multiple empty fields in forms
     */
    getMandatoryField: function (parentID, errorMsg, isNotEmpty) {
    //If the error message does not exist, sets a generic error message.
        if (typeof errorMsg === 'undefined' || errorMsg == null || errorMsg == "") {
            errorMsg = MessageHelper.messages["ADDR_MANDATORY_FIELD"];
        }
    //Otherwise, creates a new div to display the error message
        var mandatoryField = document.createElement('div');
        mandatoryField.setAttribute("class", "address-erros-message-cont");
        mandatoryField.innerHTML = '<span tabindex="0" id="mandatoryField_' + parentID + '" class="error-message wcag__error">' + errorMsg + '</span>';

        return mandatoryField;
    },
    /**
      * manage multiple address form empty fields add Error message for each
      * concerned field
     */
    manageMultipleEmptyFields: function (field, errorMsg, isNotEmpty) {

        var mandatoryErrorFieldId = "mandatoryField_" + field.id;

        // delete error message if field is no more empty
        var currentField = document.getElementById(mandatoryErrorFieldId);
        if (currentField != null) {
            $(field).removeClass("field-error-message");
            if (currentField.parentNode != null && currentField.parentNode.className != undefined && currentField.parentNode.className.indexOf("address-erros-message-cont") >= 0) {
                $(currentField.parentNode).remove();
            } else {
                currentField.remove();
            }
        }

        if (!isNotEmpty) {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // if (!isOliver && field.name != undefined && field.name.toLocaleLowerCase().indexOf('address') >= 0) {
                    //     field.after(mandatoryField);
                    // } else {
                    //     field.parentNode.appendChild(mandatoryField);
                    // }
                    if(isVogue && field.name != 'state' ){//pre modifica ||(isPersol && field.name == 'address1' && $('.myAccountSummary').length == 0) 
                        field.insertAdjacentElement('afterend', mandatoryField);
                    } else {
                        field.parentNode.insertAdjacentElement('beforeend', mandatoryField);
                    }
                    //Tealium filling form Errors
                    //tealiumPushFormError(errorMsg);
                }
            }
        }

    },


    manageMultipleErrorFields: function (field, errorMsg, isNotEmpty) {
        //Sets the field that the error will be associated to.
        var mandatoryErrorFieldId = 'mandatoryField_' + field.id;

        // Deletes the error message if the field is not empty anymore.
        if (isNotEmpty) {
            var currentField = document.getElementById(mandatoryErrorFieldId);
            if (currentField != null) {
                $(field).removeClass("field-error-message");
                currentField.remove();
            }
        } else {
            if (!document.getElementById(mandatoryErrorFieldId)) {
                var mandatoryField = this.getMandatoryField(field.id, errorMsg, isNotEmpty);
                if (field != null && field.parentNode != null) {
                    $(field).addClass("field-error-message");
                    // field.parentNode.appendChild(mandatoryField);
                    field.parentNode.insertAdjacentElement('beforeend', mandatoryField);

                    //this if prevents js error if WCAG.js are not imported
                    if(typeof moveToError === 'function'){
                        moveToError();
                    }

                    //Tealium filling form Errors
                    //if (typeof tealiumPushFormError !== "undefined" ) {
                        //tealiumPushFormError(errorMsg);
                    //}
                }
            }
        }

    },

    /**
     *
     * @param {*} formName Controls if the field is still empty
     */
    isEmpty: function (formField){
        if (formField.value == "" || reWhiteSpace.test(formField.value)){
            return true;
        }
        else{
            this.manageMultipleErrorFields(formField, "", true);
            return false;
        }
    },


    /* NEW */
    validateZipCodeFormField: function(formField, isMandatory){
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value.toUpperCase());
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeEmpty"]);       
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,40)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeTooLong"]); 
            //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeTooLong"]);
        } else if (!isEmpty) {
            var zipCodeRegexp = this.getZipCodeRegexpForCurrentCountryCode();
            if (!zipCodeRegexp.test(formFieldValue)){
                isValid = false;
                this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //BEGIN HB-10030 - when the call is from goToOrderPaymentViewOnClickHandler
                //if(typeof arguments.callee.caller.caller.name !== 'undefined' && arguments.callee.caller.caller.name == 'goToOrderPaymentViewOnClickHandler')
                    //tealiumPushFormError(MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                //END HB-10030
            }
        }
        if (!isValid) {
            isValid = false;
        } else if (!isEmpty) {
            //We check if the country is the same as in the store
            if (this.storeCountry == 'UK') {
                this.storeCountry = 'GB';
            }
            this.isSameCountryAsStore = (this.storeCountry === countryCode);

            this.autofillFormAddressFromZipCode(formField);

            if (this.hasTaxes && formField.form.name.includes("shipping")) {
                CheckoutHelperJS.calculateTaxesFromZipCode(formField);
            }
            isValid = true;
        }
        if(isValid){
            this.addSuccesIcon(formField);
            setTimeout(function() { 
               AddressHelper.showHiddenField(formField);
            }, 500);   
            
        }
        this.removeSuccesIcon(formField);
        return isValid;
    },

    validatePhoneNumberFormField: function(formField, isMandatory){
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var phoneNumber = formFieldValue;
        var isValid = true;

        function isCybersourceValidPhoneNumber(phone){
            var isValid = true;
            var digits = "0123456789";
            var digitsCount = 0;
            var validCharsRegexp = /[a-zA-Z0-9\-\(\)\+\,\*\.\#\/\s]/g;

            for (var i = 0; i < phone.length; i++) {
                if (digits.includes(phone[i])){
                    digitsCount++;
                }
            }

            if (digitsCount<6 || digitsCount>32 || phone.match(validCharsRegexp).length != phone.length){
                isValid = false;
            }
            
        
            return isValid;
        }

        function parsePhoneNumberSAP(phone){
            var invalidCharsSAP = "-;/+";
            var parsedPhoneNumber = "";
            for (var i = 0; i < phone.length; i++) {
                var element = phone[i];
                if (invalidCharsSAP.includes(element)){
                    parsedPhoneNumber += " ";
                } else {
                    parsedPhoneNumber += element;
                }
            }
            return parsedPhoneNumber;
        }

        this.removeFieldErrorMessages(formField);
        if (isMandatory && isEmpty) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhonenumberEmpty"]);
        } else if (!isCybersourceValidPhoneNumber(phoneNumber)){
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_PhoneFormatNotValid"]);
        } else {
            formField.value = parsePhoneNumberSAP(phoneNumber);
        }
        if (isValid){
            this.addSuccesIcon(formField);
            return true;
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateEmailFormField: function(formField, isMandatory) {
        //var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@(([a-zA-Z0-9]([a-zA-Z0-9\-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;
        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        this.removeFieldErrorMessages(formField);
        $(formField).next().removeClass('labelOnTop');
        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailEmpty"]);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_EmailTooLong"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!emailRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            //We have to clear input's email value before setting it again because of
            //the "special" behavior of the <input type="email"> tag containing spaces
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            this.addSuccesIcon(formField);
            return true;
        }else if(!isEmpty){
            $(formField).next().addClass('labelOnTop');//class that block label on top when the email is invalid and not empty
        }

        this.removeSuccesIcon(formField);
        return false;
    },

    validateCodiceFiscaleFormField: function(formField, isMandatory) {

        var codiceFiscaleRegexp = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale mandatory and empty"/*MessageHelper.messages["ERROR_EmailEmpty"]*/);
        } else if (!MessageHelper.isValidUTF8length(formFieldValue,256)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale too long"/*MessageHelper.messages["ERROR_EmailTooLong"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_EmailTooLong"]);
        } else if (!isEmpty && !codiceFiscaleRegexp.test(formFieldValue)) {
            isValid = false;
            this.addFieldErrorMessage(formField, "Codice fiscale bad format"/*MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]*/);
            //tealiumPushFormError(MessageHelper.messages["ERROR_INVALIDEMAILFORMAT"]);
        } else {
            formField.value = "";
            formField.value = formFieldValue;
        }

        if (isValid) {
            return true;
        }
        return false;
    },
    showHiddenField : function(formField){
            if(formField.matches(":-webkit-autofill") || $(formField).is(".GoogleAutoFilled")){
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").each(function(index){$( this ).prop("readonly",true)})
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").addClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
            }else{
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").removeClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.prov").find("input").addClass("readonly");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").removeClass("notEditableForm");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide.cityfield").find("input").prop("readonly",false);               
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input + label").addClass("labelOnTop");
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").show();
               $(formField).parents().first().siblings(".hideForBoss.defaulthide").find("input").trigger("change");
            }
            
         },
      
      
    validateNotEmpty : function (formField, isMandatory) {

        this.removeFieldErrorMessages(formField);
        var formFieldValue = trim(formField.value);
        var isEmpty = formFieldValue == "";
        var isValid = true;

        if (isEmpty && isMandatory) {
            isValid = false;
        }
        if (isValid) {


            this.addSuccesIcon(formField);
            
            return true;
        }
        this.removeSuccesIcon(formField);
        
       
        return false;


    },
   
    addFieldErrorMessage: function(formField, errorText){
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        var errorMessageClassName = "address-field-error-message--"+formField.name;

        //Add class to the field in order to change its CSS
        $(formField).addClass("field-error-message");
        //Create error messages container if it does not exist already
        if ($("."+errorContainerClassName).length==0){
            $(formField).parent().append("<div class='" + errorContainerClassName + " error-message wcag__error' tabindex='0'></div>");
        }
        $("."+errorContainerClassName).append("<div class='"+errorMessageClassName+"'>"+errorText+"</div>");
    },

    removeFieldErrorMessages: function(formField){
        $(formField).removeClass("field-error-message");
        var errorContainerClassName = "address-field-error-messages--" + formField.form.name +"--"+ formField.name.toLowerCase();
        if ($("."+errorContainerClassName).length>0){
            $("."+errorContainerClassName).remove();
        }
    },

    /**
     * Returns data into shipping/billing form as JSON
     */
    getJSONContactDataFromAddressForm: function (formName) {
        var form = document.forms[formName];
        var dataArray = {};
        if (form.addressType != undefined) dataArray.addressType = form.addressType.value;
        if (form.nickName != undefined) dataArray.nickName = form.nickName.value;
        if (form.firstName != undefined) dataArray.firstName = form.firstName.value;
        if (form.lastName != undefined) dataArray.lastName = form.lastName.value;
        if (form.phone1 != undefined) dataArray.phone1 = form.phone1.value;
        if (form.email1 != undefined) dataArray.email1 = form.email1.value;
        dataArray.addressLine = ["", "", ""];
        if (form.address1 != undefined) dataArray.addressLine[0] = form.address1.value;
        if (form.address2 != undefined) dataArray.addressLine[1] = form.address2.value;
		if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        if (form.zipCode != undefined) dataArray.zipCode = form.zipCode.value;
        if (form.city != undefined) dataArray.city = form.city.value;
        if (form.country != undefined) dataArray.country = form.country.value;
        if (form.state != undefined) dataArray.state = form.state.value;
        if (form.fax1 != undefined) dataArray.fax1 = form.fax1.value;
        if (form.fax2 != undefined) dataArray.fax2 = form.fax2.value;

        if (countryCode == "US" || countryCode == "CA"){
            //In US and Canada Address3 field will be set as ZIPCODE-STATE. E.g. 10507-NW
            dataArray.addressLine[2] = dataArray.zipCode + "-" + dataArray.state;
        } else {
            if (form.address3 != undefined) dataArray.addressLine[2] = form.address3.value;
        }

        return JSON.stringify(dataArray);
    },

    /**
     * This function saves the address entry form when a registered customer
     * wants to edit/add a new address during checkout from his/her shopping
     * cart.
     *
     * @param {string}
     *            The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            The name of the form containing address information.
     * @param {string}
     *            The addressTypeIn being saved.
     */

    saveShopCartAddress: function (serviceId, formName, addressTypeIn) {
        var form = document.forms[formName];
        if (addressTypeIn == 'ShippingAndBilling' || addressTypeIn == 'Shipping') {
            if (serviceId == 'AjaxUpdateAddressForPerson') {
                serviceId = 'AjaxUpdateShippingAndBillingAddressForPersonDuringCheckout';
            } else {
                serviceId = 'AjaxAddShippingAndBillingAddressForPersonDuringCheckout';
            }
        }
        if (this.validateAddressForm(form)) {
            this.saveAddress(serviceId, formName);
        }
    },

    /**
     *
     * @param {*} addressId
     * @param {*} addressType Accepted values are "S" for Shipping, "B" for Billing, and "SB" for ShippingBilling
     */
    updateAddressCookies: function(addressId, addressType){
        var error = false;

        if (typeof addressId !== 'undefined' && addressId != null
            && typeof addressType !== 'undefined' && addressType != null){

            if (addressType === "Billing") {
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "Shipping") {
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else if (addressType === "ShippingAndBilling"){
                setCookie("addressId_formS_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
                setCookie("addressId_formB_" + storeDirectory, addressId, { path: "/", domain: cookieDomain });
            } else {
                error = true;
            }
        } else {
            error = true;
        }

        if (error){
            console.log("PSL::AddressHelper.js::updateAddressCookies::Invalid parameters: "
            + "addressType = " + addressType + ", "
            + "addressId = " + addressId);
        } else {
            console.log("PSL::AddressHelper.js::updateAddressCookies::Address cookies updated");
            addressId_formS = getCookie("addressId_formS_"+storeDirectory);
            addressId_formB = getCookie("addressId_formB_"+storeDirectory);
        }
    },

    /**
     *
     */
    initAddressCookies: function(){

        function logAddressErrors(shippingAddressType, billingAddressType){
            if ((shippingAddressType == "" && billingAddressType == "")
            ||(shippingAddressType == "SB" && billingAddressType == "")
            ||(shippingAddressType == "S" && billingAddressType == "B")) {
                plog("AddressHelper.js::initAddressCookies:: Address settings OK");
            } else {
                plog("AddressHelper.js::initAddressCookies:: Address settings KO");
            }
        }

        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
        $.ajax({
            method: "GET",
            url: url,
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            dataType: "json",
            data: {
                "timestamp": Date.now()
            },
            success: function(data, textStatus, jqXHR){
                if (typeof data.contact === 'undefined'){
                    plog("AddressHelper.js::initAddressCookies::Address not found");
                } else {
                    for (var i = 0; i<data.contact.length; i++){
                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
                        }
                    }
                }
            },
            error: function(jqXHR, exception){
                plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
            },
            complete: function(){
            }
        });
    },

    /**
     *
     * @param storeId current store id
     * @param onSuccessURL if the update is ok, go to this url
     * @returns
     */
    updateUnregisteredCheckoutAddress: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        location.href = onSuccessURL; 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
                form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    resetUnregisteredCheckoutAddressCookies: function () {
        setCookie("addressId_formS_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
        setCookie("addressId_formB_" + storeDirectory, "unset", { path: "/", domain: cookieDomain });
    },

    /**
     * This function saves the address entry form on an unregistered user's
     * checkout page.
     *
     * @param {string} formName1 The name of the billing address form.
     * @param {string} formName2 The name of the shipping address form.
     * @param {string} stateDivName1 The name of the state field in the billing address form.
     * @param {string} stateDivName2 The name of the state field in the shipping address form.
     */
    saveUnregisteredCheckoutAddress: function (formName1, formName2, stateDivName1, stateDivName2/*, buttonId, event*/) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];

        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: Valores iniciales:");
        console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form1.nickName.value = " + form1.nickName.value);
        if (form2) {
            console.log("PSL::AddressHelper.js::saveUnregisteredCheckoutAddress:: form2.nickName.value = " + form2.nickName.value);
        }

        this.setStateDivName(stateDivName1);
        /* Validate form input fields */
        if (this.validateAddressForm(form1)) {
            var addressNickNameBase = "MyAddress_";
            var sameaddress = document.getElementById("SameShippingAndBillingAddress");

            if (!sameaddress || sameaddress.checked) {
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }

                form1.addressType.value = 'ShippingAndBilling';
                if (form1.addressId == undefined || form1.addressId.value === '') {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('AddShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }
                else {
                    //$(buttonId).off(event);
                    console.log("PSL::AddressHelper.js::SameSBAddress, UpdateShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                    this.saveAddressCheckoutGuest('UpdateShippingAddress', 'shippingAddressCreateEditFormDiv_1');
                }

            }
            else {
                //var form2 = document.forms[formName2];
                if (form1.nickName.value == undefined || form1.nickName.value == "") {
                    form1.nickName.value = addressNickNameBase + "Shipping";
                }
                if (form2.nickName.value == undefined || form2.nickName.value == "") {
                    form2.nickName.value = addressNickNameBase + "Billing";
                }

                console.log("PSL::AddressHelper.js:: form1.nickName.value = " + form1.nickName.value);
                console.log("PSL::AddressHelper.js:: form2.nickName.value = " + form2.nickName.value);

                // Store form1 email as billing address email
                if(!isPersol && !isOliver){
                    form2.email1.value = form1.email1.value;
                }
                

                /* Validate form input fields */
                if (this.validateAddressForm(form2)) {
                    this.setStateDivName(stateDivName2);

                    /*
                     * Note that, when want to save different shipping and billing addresses, we only call AddBillingAddress,
                     * because AddShippingAddress will be called in the successHandler of the service AddBillingAddress
                     * declared in MyAccountServicesDeclaration.js
                     * This is the out-of-the-box behavior in AuroraStorefrontStore
                     */
                    if (form2.addressId == undefined || form2.addressId.value === '') {
                        //console.log("PSL::AddressHelper.js::Add billing address");
                        //$(buttonId).off(event);
                        if (form1.addressId != undefined && form2.addressId != undefined &&
                            form2.addressId.value == form1.addressId.value) {
                            form2.addressId.value = "";
                        }
                        console.log("PSL::AddressHelper.js::SameSBAddress, AddShippingAddress -> form1.nickName.value = " + form1.nickName.value);
                        this.saveAddressCheckoutGuest('AddBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                    else {
                        //$(buttonId).off(event);
                        console.log("PSL::AddressHelper.js::Update billing address");
                        this.saveAddressCheckoutGuest('UpdateBillingAddress', 'billingAddressCreateEditFormDiv_1');
                    }
                }
                else {
                    //FIXME
                    restoreAjaxButton("WC_UnregisteredCheckout_links_4");
                }
            }
        }
        else {
            //FIXME over only a form
            restoreAjaxButton("WC_UnregisteredCheckout_links_4");
        }
    },

    /**
     * This function saves an address entry form to the associated service.
     *
     * @param {string}
     *            serviceId The id of the service that was invoked, e.g.
     *            AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string}
     *            formName The name of the form containing address information.
     */
    saveAddress: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        //		if (form.address1.value == "" && form.address2.value != "") {
        //			form.address1.value = form.address2.value;
        //			form.address2.value = "";
        //		}
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */

        // should migrate this solution to GlobalLoginActions.js to avoid
        // GlobalLoginJS.updateGlobalLoginUserDisplay("...");
        var header = document.getElementById("header");
        if (header == null || !this.hasClass(header, "checkout")) {
            if (!submitRequest()) {
                return;
            }
        }

        cursor_wait();
        wcService.invoke(serviceId);
    },

    ajaxSaveAddress: function (serviceId, formName) {
        // AjaxAddAddressForPerson or AjaxUpdateAddressForPerson
        resetRequest();
        var service = serviceId;
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        if(!this.validateAddressForm(form)) {

            return false;
        } else {
            var dialog = $("#addEditAddressPopup").data("wc-WCDialog");
            if (dialog) {
                dialog.close();
                $("#addEditAddressPopup").css("display", "none");
            }

        }
        if (form.addressId != undefined && form.addressId.value != '') {
            service = 'AjaxUpdateAddressForPerson';
            form.nickName.remove();
        }
        if (form.nickName && form.nickName.value == '') {
            form.nickName.value = new Date().getTime();
        }

        var addressService = wcService.getServiceById(service);
        addressService.setFormId(formName);
        /* For Handling multiple clicks */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(service);
    },

    /**
     * This function saves an address entry form to the associated service only
     * in the ShippingAndBilling screen in checkout as a Guest.
     *
     * @param {string} serviceId The id of the service that was invoked, e.g. AjaxUpdateAddressForPerson, AjaxAddAddressForPerson, etc.
     * @param {string} formName The name of the form containing address information.
     */
    saveAddressCheckoutGuest: function (serviceId, formName) {
        var country = document.getElementById('country');
        if (country != null) {
            country.disabled = false;
        }
        var form = document.forms[formName];
        var addressService = wcService.getServiceById(serviceId);
        addressService.setFormId(formName);

        cursor_wait();
        wcService.invoke(serviceId);
    },

    hasClass: function (element, inputClass) {
        return (" " + element.className + " ").indexOf(" " + inputClass + " ") > -1;
    },

    /**
     * This function calls UpdateOrderItem/AjaxUpdateOrderItem service to update
     * order calculation
     */
    updateOrderAfterAddressUpdate: function () {
        var params = {
            storeId: ServicesDeclarationJS.storeId,
            catalogId: ServicesDeclarationJS.catalogId,
            langId: ServicesDeclarationJS.langId
        };
        params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        params.calculateOrder = "1";
        params.orderId = ".";

        cursor_wait();
        //wcService.invoke("AjaxUpdateOrderAfterAddressUpdate", params);
    },

    /**
     * This function populates the country code to mobile phone based on the
     * selected country.
     *
     * @param {string} countryDropDownId The id of the mobile country drop down list
     * @param {string} countryCallingCodeId The id of the mobile country calling code  text box.
     */
    loadCountryCode: function (countryDropDownId, countryCallingCodeId) {
        this.getCountryArray();
        var countryCode = $("#" + countryDropDownId).val()
        if (countryCode === undefined || countryCode === null)
        // we are using wc.Select
        {
            var countryDropDownWidget = $("#" + countryDropDownId);
            if (countryDropDownWidget !== undefined
                && countryDropDownWidget !== null) {
                countryCode = countryDropDownWidget.val();
            }
        }
        $("#" + countryCallingCodeId).val(
            countries[countryCode].countryCallingCode);
    },

    /**
     * This function checks for an entry in the Mobile Phone Number field. If a
     * Mobile Phone number has been entered, it enables the SMS
     * Notifications/Promotions checkbox, else it disables the SMS
     * Notifications/Promotions checkbox.
     *
     * @param {string} form The name of the form containing the Mobile Phone Number entry field.
     * @param {string} jspStoreImgDir The directory for images
     */
    enableSMSNotifications: function (form, jspStoreImgDir) {
        var form = document.forms[form];
        if (form.mobilePhone1.value !== "") {
            form.sendMeSMSNotification.disabled = false;
            form.sendMeSMSPreference.disabled = false;
            $(".checkedCheckBox.mobileOption").removeClass("disabled").attr(
                "tabindex", "0");
        } else {
            form.sendMeSMSNotification.disabled = true;
            form.sendMeSMSPreference.disabled = true;
            form.sendMeSMSNotification.checked = false;
            form.sendMeSMSPreference.checked = false;
            $(".checkedCheckBox.mobileOption").addClass("disabled").attr(
                "tabindex", "-1").removeClass("checked").attr(
                    "aria-checked", "false").attr("src",
                        jspStoreImgDir + "images/checkbox.png");
        }
    },


    /**
     * Sets the address type when a user wants to add a new address of type
     * shipping and billing during order check out.
     *
     * @param {Object}: checkbox The HTML checkbox input object.
     * @param {Object}: form The form that includes the new address information.
     */
    setAddressTypeInCreatingNewAddressDuringCheckout: function (checkbox, form) {
        if (form.addressType != null && form.originalAddressType != null) {
            if (checkbox.checked) {
                form.addressType.value = 'ShippingAndBilling';
            } else {
                form.addressType.value = form.originalAddressType.value;
            }
        }
    },

    /**
     * Set checkbox state to true when checked and false when unchecked
     *
     * @param String jspStoreImgDir The directory for store images.
     * @param String checkbox The checkbox element.
     * @param String checkboxImg The checkbox image element.
     * @param String checkedValue The value of the input when checked.
     * @param String uncheckedValue The value of the input when unchecked.
     */
    changeCheckboxState: function (jspStoreImgDir, checkbox, checkboxImg, checkedValue, uncheckedValue) {
        var $checkboxImg = $("#" + checkboxImg), $checkbox = $("#" + checkbox);
        if (!$checkboxImg.hasClass("disabled")) {
            if ($checkboxImg.hasClass("checked")) {
                $checkboxImg.removeClass("checked");
                $checkboxImg.attr("aria-checked", "false");
                $checkboxImg
                    .attr("src", jspStoreImgDir + "images/checkbox.png");
                $checkbox.attr("value", uncheckedValue);
                $checkbox.removeAttr("checked");
            } else {
                $checkboxImg.addClass("checked");
                $checkboxImg.attr("src", jspStoreImgDir
                    + "images/checkbox_checked.png");
                $checkboxImg.attr("aria-checked", "true");
                $checkbox.attr("value", checkedValue);
                $checkbox.attr("checked", "checked");
            }
        }
    },
/** FORM VALIDATIONS *************************************************************************************************************************/

    validateEmail: function (email) {
        var emailRegexp = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var isValidEmail = emailRegexp.test(email.value);
        // managing inline style and error message
        this.manageInlineValidationError(isValidEmail, email, 'emailError');
        return isValidEmail;
    },

    validateZipCode: function (zipCodeId, countryId, stateId, cityId, lang, storeName) {
        //getting zip code value
        var countrySelected = document.getElementById(countryId).value;
        var zipCode = document.getElementById(zipCodeId);

        //getting zipcode pattern per selected country
        var selectedCountryPattern = this.returnZipCodePattern();
        var zipRegex = new RegExp(selectedCountryPattern);

        //We match it to uppercase, always have to be like 'ZIP'
        var isValidZip = zipCode != '' && zipRegex.test(zipCode.value.toUpperCase());
        var isZipCodeChange = false;

        //We check if the country is the same as in the store
        if (this.storeCountry == 'UK') {
            this.storeCountry = 'GB';
        }
        this.isSameCountryAsStore = (this.storeCountry === countrySelected);

        //managing inline style and error message
        this.manageInlineValidationError(isValidZip, zipCode, zipCodeId + '_Error');

        // if(!isSameCountryAsStore) this.manageInlineValidationError(isSameCountryAsStore, countrySelected, countryId + '_Error');
        if (isValidZip) {
            //autofill city and state with data
            if (zipCode.value !== "") {
                this.fillFormAddressWithData(zipCode, countryId, stateId, cityId, lang);
            }

            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = true;
            } else {
                this.validZipCodeShipping = true;
            }
            var countryCode = jQuery('#' + countryId).val();
            if (zipCodeId.indexOf("shippingAddress") >= 0) {
                isZipCodeChange= (getCookie("addressId_formB_"+storeDirectory)!=undefined|| getCookie("addressId_formS_"+storeDirectory)!=undefined);
                if (this.hasTaxes) {
                    CheckoutHelperJS.calculateEstematedTax(zipCode.value, countryCode, lang, true, isZipCodeChange, storeName);
                }
            }

        } else {
            if (zipCodeId.includes("billing")) {
                this.validZipCodeBilling = false;
            } else {
                this.validZipCodeShipping = false;
            }
        }
    },

    /**
     * HB-343 , inline codice fiscale validation
     */
    validateCodiceFiscale: function (codiceId) {
        var selectedCountryCode = this.selectedCountryCode;

        if (selectedCountryCode == 'IT') {
            // getting zip code value
            var codice = document.getElementById(codiceId);

            // getting zipcode pattern per selected country
            var codiceRegex = new RegExp(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i);

            var isValidCodice = (codice == undefined || codice == null
                || codice.value == undefined || codice.value == ''
                || codiceRegex.test(codice.value));

            // managing inline style and error message
            this.manageInlineValidationError(isValidCodice, codice, codiceId + '_Error');

            return isValidCodice;

        } else {
            return true;
        }
    },

    /**
     * show,hide error message for inline validation
     * @param : isValidInput boolean for valid / invalid input
     * @param : element : input element concerned by validation
     * @param : errorMessageId : span containing error message for input
     */
    manageInlineValidationError: function (isValidInput, element, errorMessageId) {
        if (isValidInput) {
            return true;
        } else {
            return false;
        }
    },


/** END FORM VALIDATIONS *************************************************************************************************************************/

    /* NEW */
    getZipCodeRegexpForCurrentCountryCode: function () {
        var countryregex = "";

        if (countryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        } else if (countryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        } else if (countryCode == 'IT' || countryCode == 'FR' || countryCode == 'ES') {
            countryregex = /^\d{5}$/;
        } else if (countryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        } else if (countryCode == 'GB' || countryCode == 'UK') {
            countryregex = /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/;
        } else {
            countryregex = /./;
            plog("AddressHelper.js::getZipCodeRegexpForCurrentCountryCode()::Error: Regexp not found for countryCode:"+countryCode);
        }

        return countryregex;
    },


    /**
     * return country zipCode pattern per country
     * @param : countryCode : code of concerned country
     */
    returnZipCodePattern: function () {
        var selectedCountryCode = this.selectedCountryCode;
        var countryregex = "";

        if (selectedCountryCode == 'US') {
            countryregex = /^\d{5}$|^\d{5}-\d{4}$/;
        }
        if (selectedCountryCode == 'CA') {
            countryregex = /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/;
        }
        if (selectedCountryCode == 'IT' || selectedCountryCode == 'FR' || selectedCountryCode == 'ES') {
            countryregex = /^\d{5}$/;
        }
        if (selectedCountryCode == 'DE') {
            countryregex = /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/;
        }
        if (selectedCountryCode == 'GB') {
            countryregex = /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/;
        }

        return countryregex;

    },


    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     * @param {*} countryId
     * @param {*} stateId
     * @param {*} cityId
     * @param {*} lang
     */
    fillFormAddressWithData: function (zip, countryId, stateId, cityId, lang) {
        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zip.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zip.value;
            var neightborhoodChars = this.maxNeighborhoodChar;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                //Tuncate string -> OCPD-670
                                autofilledNeighborhood.val((data.addressInfo[0].neighborhood).substring(0,neightborhoodChars));
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zip.value, lang, function(result){
                var error = false;
                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                		AddressHelper.zipCodeNotFound = true;
                		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                	}
                	else {
                		error=true;
	                    console.log("PSL::AddressHelper.js::fillFormAddressWithData function ajax error (GoogleAPI):"+result.error_description);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zip, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
                	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zip.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zip, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
                        var city = "";

                        if(document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1')!=null){
                            city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
                        }else{
                            city = document.getElementById('WC_UserRegistrationUpdateForm_AddressEntryForm_FormInput_city_1').value;
                        }
	                	
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zip, "", true);
                	}
                	/*else {
                		if(autofilledState != null && autofilledState.value != '') {
                			autofilledStateHidden.value = autofilledState.value;
                		}
                	}*/
                }

            });
        }
    },

    /**
     * Calls google service to autofill Address data depending of the ZIP CODE
     *
     * @param {*} zip
     */
    autofillFormAddressFromZipCode: function (zipCodeFormField /*, countryId, stateId, cityId, lang*/) {

        var zipCodeFormFieldId = zipCodeFormField.id;
        var countryId = zipCodeFormFieldId.replace("_zipCode_","_country_");
        var stateId = zipCodeFormFieldId.replace("_zipCode_","_state_");
        var cityId = zipCodeFormFieldId.replace("_zipCode_","_city_");

        var countryCode = null;
        //case of address Book
        if (this.selectedCountryCode != null) {
            countryCode = this.selectedCountryCode;
        } else if (document.getElementById(countryId) !== null) {
            countryCode = document.getElementById(countryId).value;
        }
        var idZipCode = zipCodeFormField.id;

        var autofilledCity = document.getElementById(cityId);
        var autofilledState = document.getElementById(stateId);
        var autofilledStateHidden = document.getElementById(stateId + "_hidden");

        if (isCarol) {
            var autofilledAddress;
            var autofilledNeighborhood;
            if ($("#billingAddressCreateEditFormDiv_1").css("display") == "none"){
                autofilledAddress = $("#shippingAddressCreateEditFormDiv_1").find("[name='address1']");
                autofilledNeighborhood = $("#shippingAddressCreateEditFormDiv_1").find("[name='fax2']");
            } else {
                autofilledAddress = $("[name='address1']");
                autofilledNeighborhood = $("[name='fax2']");
            }
            var url = "/wcs/resources/store/"+ WCParamJS.storeId +"/customAddressValidation/byZipCode/" + zipCodeFormField.value;
            $.ajax({
                url: url,
                dataType: 'json',
                type: 'GET',
                async: false,
                success: function (data) {
                    if (data != null && data.addressInfo[0] != null) {
                        if ( data.addressInfo[0].country == null) {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = false : AddressHelper.validZipCodeShipping = false;
                            console.error("Zip code invalid / NOT FOUND, ZERO_RESULTS");
                        } else {
                            idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
                            if (data.addressInfo[0].city != null) {
                                autofilledCity.value = data.addressInfo[0].city;
                            }
                            if (data.addressInfo[0].state != null) {
                                autofilledState.value = data.addressInfo[0].state;
                            }
                            if (data.addressInfo[0].neighborhood != null) {
                                autofilledNeighborhood.val(data.addressInfo[0].neighborhood);
                            }
                            if (data.addressInfo[0].address != null) {
                                autofilledAddress.val(data.addressInfo[0].address);
                            }
                            $("[name='state']").parent().find("span.ui-selectmenu-text").text(data.addressInfo[0].state);
                        }
                    }
                },
                error: function(data){
                    console.log(data);
                }
            });
        } else {
            //HB-2302 BEGIN Use google address common interface
            getGoogleAddress(countryCode, zipCodeFormField.value, storeLanguage, function(result){
                var error = false;
                if (typeof zipCodeFormField.form.city !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.city);
                }
                if (typeof zipCodeFormField.form.state_full !== 'undefined'){
                    AddressHelper.removeFieldErrorMessages(zipCodeFormField.form.state_full);
                }

                if (result.status == "error"){
                	if(result.error_description == "zipcode_not_found"){
                 		AddressHelper.zipCodeNotFound = true;
                 		if(autofilledState != null){
	                 		autofilledState.classList.remove("readonly");
	                 		autofilledState.readOnly = false;
                 		}
                 	}
                 	else {
                 		error=true;
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error (GoogleAPI): "+result.error_description);
	                    console.log("PSL::AddressHelper.js::autofillFormAddressFromZipCode function ajax error: ",result.raw);
	                    AddressHelper.validZipCode = false;
	                    idZipCode.includes("billing") ? AddressHelper.validZipCodeBilling = true : AddressHelper.validZipCodeShipping = true;
	                    AddressHelper.addFieldErrorMessage(zipCodeFormField, MessageHelper.messages["ERROR_ZipCodeInvalid"]);
	                    $(zipCodeFormField.form).find("input[name=city]").val("");
	                    $(zipCodeFormField.form).find("input[name=state]").val("");
	                    $(zipCodeFormField.form).find("input[name=state_full]").val("");
                 	}
                } else {
                	if(autofilledState != null) {
	                	autofilledState.classList.add("readonly");
	                	autofilledState.readOnly = true;
                	}
                	AddressHelper.zipCodeNotFound = false;
                    $('.prop65').removeClass('shown');
                    $('.prop65__a').attr('tabindex', '-1');
                    if (result.address.country_short === 'US' && result.address.prov_state_short === 'CA') {
                        $('.prop65').addClass('shown');
                        $('.prop65__a').attr('tabindex', '0');
                    }
                }

                //HB-1956 BEGIN
                if (!error && typeof notAllowedShippingRegions !== 'undefined'
                    && typeof result.address !== 'undefined'
                    && typeof result.address.prov_state_short !== 'undefined'
                    && !idZipCode.includes("billing")){

                    //IE fix: Array​.prototype​.includes() not working in IE
                    var notAllowedShippingRegion = false;
                    for (var i = 0; i < notAllowedShippingRegions.length; i++) {
                        if (notAllowedShippingRegions[i] == result.address.prov_state_short){
                            notAllowedShippingRegion = true;
                            break;
                        };
                    }

                    if (notAllowedShippingRegion){
                        zipCodeFormField.value="";
                        autofilledCity.value = "";
                        autofilledState.value = "";
                        autofilledStateHidden.value = "";

                        AddressHelper.manageMultipleEmptyFields(zipCodeFormField, MessageHelper.messages["ERROR_NotAllowedShippingRegion"], false);
                        error = true;
                    }
                //HB-1956 END
                }

                if (!error){
                	if(!AddressHelper.zipCodeNotFound){
	                	var city = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1').value;
	                	if(city==''){
	                    	autofilledCity.value = result.address.city;
	                    	$(autofilledCity).trigger("change");
	                    }
	                    if (autofilledState != null) {
	                        autofilledState.value = result.address.prov_state;
	                    }
	                    if (autofilledStateHidden != null) {
	                        autofilledStateHidden.value = result.address.prov_state_short;
	
	                    }
	                    AddressHelper.validZipCode = true;
	                    AddressHelper.manageMultipleEmptyFields(zipCodeFormField, "", true);
                     
	                    if(($('#errorAddressValidation').is(":visible") && $('#addressValidationFirstTime').val() == 'false') || $('#errorAddressValidation').is(":hidden")){
	                    	AddressHelper.addSuccesIcon(zipCodeFormField);
	                    }
	                    
                        AddressHelper.addSuccesIcon('#'+countryId);
                        AddressHelper.addSuccesIcon('#'+stateId);
                        AddressHelper.addSuccesIcon('#'+cityId);
                        
                	}
                }else{
                    AddressHelper.removeSuccesIcon(zipCodeFormField);
                        AddressHelper.removeSuccesIcon('#'+countryId);
                        AddressHelper.removeSuccesIcon('#'+stateId);
                        AddressHelper.removeSuccesIcon('#'+cityId);
                }
                var shippingSelected = $('.shipping_method_content input[name="singleShipmentShippingMode"]:checked').attr("typeshipping").toUpperCase();
                if(shippingSelected == 'COLLECT IN STORE') {
                    autofilledCity.classList.add("blockForBoss");
                    autofilledState.classList.add("blockForBoss");
                }

            });
        }
    },

    fillFormAddressFromAddressDataObject: function(destForm, addressObj){
        if (typeof destForm.city !== 'undefined') {
            destForm.city.value = addressObj.address.city;
        }
        if (typeof destForm.state !== 'undefined') {
            destForm.state.value = addressObj.address.prov_state_short;
        }
        if (typeof destForm.state_full !== 'undefined') {
            destForm.state_full.value = addressObj.address.prov_state;
        }
        if (typeof destForm.zipCode !== 'undefined') {
            destForm.zipCode.value = addressObj.address.zipcode;
        }
    },

    /**
     * Function that launches the command to join the newsletter with the email from the Shipping address
     */
    joinNewsletter: function (form, langId, storeId) {
        reWhiteSpace = new RegExp(/^\s+$/);

        var subscriptionOn = false;
        var updateop = true;
        if ($('#joinNewsletterCheck').is(':checked')) {
        	subscriptionOn = true;
        }else{
        	if(userType == 'R' ){
        		updateop = false;
        	}
        }

        var emailValue = $("#" + form).find("input[name='email1']").val();
        if (localStorage != undefined) {
            localStorage.setItem('encryptedUserEmail',md5(emailValue.toLowerCase()).toString());
            if(isPersol || isOliver || isVogue)
                localStorage.setItem('encryptedUserEmailSHA256',sha256(emailValue.toLowerCase().trim()).toString());
        }
        var fName = $("#" + form).find("input[name='firstName']").val();
        var lName = $("#" + form).find("input[name='lastName']").val();
        
        var cidCookie = null;
        
        if(document.cookie.includes('X_WC_CID')){
        	cidCookie = $.cookie("X_WC_CID");
        }
        
        // Validation of email not in blank and well-formed
        if (emailValue != undefined && emailValue != "" && !reWhiteSpace.test(trim(emailValue))
            && MessageHelper.isValidUTF8length(emailValue, 256)
            && MessageHelper.isValidEmail(emailValue)) {
            var params = {
                storeId: storeId,
                langId: langId,
                email: emailValue,
                viewName: "",
                subscription: subscriptionOn,
                firstName: fName,
                lastName: lName,
                update: updateop,
                isCheckoutForm: true,
                cid: cidCookie
            };

            cursor_wait();

            wcService.invoke("JoinNewsletterService", params);
        }

    }, 
    joinSMS: function (fromPopup) {
        var params = {};
        var phone1Value = $("input[name='phone1']").val();
        if(phone1Value.indexOf("+") == -1 && localStorage.prefixNumberPhone1 != 'undefined'){
            var phone1ValuePrefix = String(localStorage.prefixNumberPhone1) + String(phone1Value);
        }
        
        //start CRM - BANNER
        if(fromPopup){
        	params.isFromPopup = fromPopup;
        }else{
        	params.isFromPopup = false;
        }
        //end CRM - BANNER
        
        
        if (localStorage != undefined ) {
            if(phone1ValuePrefix != undefined){
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1ValuePrefix.trim().toLowerCase()).toString());
                if(typeof sha256(phone1ValuePrefix.toString()) === 'object' && typeof sha256(phone1ValuePrefix.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } ); 
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1ValuePrefix.toString()));
                
            }else{
                localStorage.setItem('encryptedUserPhoneMd5',md5(phone1Value.trim().toLowerCase()).toString());
                if(typeof sha256(phone1Value.toString()) === 'object' && typeof sha256(phone1Value.toString()).then === 'function')
                    sha256(phone1ValuePrefix.toString()).then(result => {  localStorage.setItem('encryptedUserPhoneSHA256',result); } );  
                else
                    localStorage.setItem('encryptedUserPhoneSHA256',sha256(phone1Value.toString())); 
            }
        }

        wcService.declare({
            id: "JoinSMSCmdService",
            actionId: "JoinSMSCmd",
            url: "JoinSMSCmd",
        
            successHandler: function(serviceResponse) {
                if(serviceResponse.responseMessage == 'duplicate'){
                    $('#mce-error-sms-duplicate').show();
                    console.log("Duplicate - This Number is already registered");
                    if(serviceResponse.userSMSOptin != 'undefined')
                        tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }else if(serviceResponse.responseMessage == 'success'){
                    tealiumUserSMSOptin = String(serviceResponse.userSMSOptin);
                }
                if(isVogue)
                    localStorage.setItem('tealiumUserSMSOptin',tealiumUserSMSOptin);
            },
            failureHandler: function(serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
        }
        });
        if(userType == 'R'){
            params.userRegistered = 'true';
            params.user_id = userInfo.userId;
        }else{
            params.userRegistered = 'false';
            if(fromPopup){
            	 params.email = $("#homepageSmsPopupFormDiv .emailLbl input").val();
            	if(getUserId() == '-1002'){
            		userId = setUserIdentity();
            	}
            	params.user_id = userId;
            }
        }
        params.store_id = WCParamJS.storeId;
        params.language_id = WCParamJS.langId;
        params.phone1 = phone1Value;
        params.store_identifier = storeDirectory;
        
        var myaccountCheckbox = $("div[id*='WC_UserRegistrationAddForm_myAccount_CheckBoxSMS']").is(":visible");
        var checkoutCheckbox  = $("div[name*='checkbox-sms']").is(":visible");
        var homepagePopupCheckbox = $("div[id*='WC_homepageSmsPopupFormDiv_CheckBoxSMS']").is(":visible");

        if(myaccountCheckbox)
            params.receivesms = $('#WC_UserRegistrationAddForm_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(checkoutCheckbox)
            params.receivesms = $('#WC_shippingAddressCreateEditFormDiv_1_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        if(homepagePopupCheckbox)
        params.receivesms = $('#WC_homepageSmsPopupFormDiv_SMSOption_Checkbox_1').is(':checked') ? 1 : 0 ;
        else if(userType == 'R' && !checkoutCheckbox)
            tealiumUserSMSOptin  = "1";
         
        if((params.phone1 != '' && params.phone1.match(/^\d+$/) != null ) && (checkoutCheckbox))
            wcService.invoke("JoinSMSCmdService", params);    
    },

    updatePhysicalStoresArea: function (zipCodeValue) {
        if (typeof displayPhysicalStoreOptionsInCheckoutShipping != "undefined" && displayPhysicalStoreOptionsInCheckoutShipping == true && zipCodeValue == undefined) {
            var zipcode = $('#WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_zipCode_1').val();
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipcode;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        } else if (zipCodeValue != undefined) {
            wcRenderContext.getRenderContextProperties('PhysicalStoresOptionsViewSBPageContext')['zipCode'] = zipCodeValue;
            $("#physicalStoresOptionsViewSBPageArea").refreshWidget().refreshWidget("refresh", wcRenderContext.getRenderContextProperties("PhysicalStoresOptionsViewSBPageContext"));
            $('#storeLocatorResults').html("");
        }
    },

    saveSelectedPhysicalStoreForOrder: function(ordersId, stloc_id) {

        console.log("saveSelectedPhysicalStoreForOrder");
        $.ajax({
            type: "POST",
            url: "OrderPhysicalStoreAddUpdate?ordersId=" + ordersId + "&stloc_id=" + stloc_id + "&storeId=" + WCParamJS.storeId,
            headers: {
                "Cache-Control": "no-cache, no-store, must-revalidate"
            },
            success: function (data) {
                console.log(" Selected physical store has been saved successfully");
            }, error: function (data) {
                console.log("An error has been occurred while trying to save the selected physical store");
            }
        });
    },

    /**
     * Funtion that fills the AddressForm from Thank you page with order data
     */
    fillFormAddressThankyouPage: function() {
        $('input[name="firstName"]').attr('value', $('.address #firstName').text());
        $('input[name="lastName"]').attr('value', $('.address #lastName').text());
        $("input[name='logonId']").attr('value', $('.address #emailAddress1').text());
        $("input[name='email1']").attr('value', $('.address #emailAddress1').text());
        $("input[name='usr_email1']").attr('value', $('.address #emailAddress1').text());
        if ($("input[name='middleName']"))
            $("input[name='middleName']").attr('value', $('.address #middleName').text());
        $("input[name='usr_address1']").attr('value', $('.address #addressLine1').text());
        $("input[name='usr_address2']").attr('value', $('.address #addressLine2').text());
        $("input[name='usr_zipCode']").attr('value', $('.address #postalCode').text());
        $("input[name='usr_city']").attr('value', $('.address #city').text());
        $("input[name='usr_state']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_stateName']").attr('value', $('.address #stateDisplayName').text());
        $("input[name='usr_phone1']").attr('value', $('.address #telephone1').text());
    },
        //START - new functions for checkout_3_0 Oliver/Persol
    updateUnregisteredCheckoutAddressAndGoPaymentStep: function (formName1, formName2, addressIdShipping, addressIdBilling, sameAddressChecked, onSuccessURL) {
        var form1 = document.forms[formName1];
        var form2 = document.forms[formName2];
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";

        //We are here because the user came back to this page after address addition to database
        if (addressIdShipping == addressIdBilling) {
            //The address stored in the database is SB
            if (sameAddressChecked) {
                //Update current SB address
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        loadAddressInfo(); // added for checkout 3.0
                       // location.href = onSuccessURL; //non deve più essere indirizzato nella view succesiva 

                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating SB address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Change current SB address to S and add billing address.
                form1.addressType.value = "Shipping";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                form2.addressType.value = "Billing";
                form2.nickName.value = "MyAddress_Billing";
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::SB address changed to S successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "POST",
                            url: url,
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address added successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                 loadAddressInfo(); // added for checkout 3.0
                                 //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error adding B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing SB address to S");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });
            }
        } else {
            //There are two different addresses in the database
            if (sameAddressChecked) {
                //Update current S address to SB and delete current billing address.
                form1.addressType.value = "ShippingAndBilling";
                form1.nickName.value = "MyAddress_Shipping";
                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address changed to SB successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"ShippingAndBilling");
                        cursor_clear();
                        $.ajax({
                            type: "DELETE",
                            url: url + "/MyAddress_Billing",
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address deleted successfully");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error deleting B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error changing S address to SB");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            } else {
                //Update current S address and B address           	
                form1.nickName.value = "MyAddress_Shipping";
                form2.nickName.value = "MyAddress_Billing";
               // form2.email1.value = form1.email1.value;
                if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup' && isOliver){
            		form1.addressType.value = "Shipping";
                    form2.addressType.value = "Billing";
                }

                var jsonDataShipping = AddressHelper.getJSONContactDataFromAddressForm(formName1);
                var jsonDataBilling = AddressHelper.getJSONContactDataFromAddressForm(formName2);

                cursor_wait();

                $.ajax({
                    type: "PUT",
                    url: url + "/MyAddress_Shipping",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache, no-store, must-revalidate"
                    },
                    dataType: 'json',
                    data: jsonDataShipping,
                    success: function (msg) {
                        console.log("PSL::AddressHelper.js::S address updated successfully");
                        AddressHelper.updateAddressCookies(msg.addressId,"Shipping");
                        cursor_clear();
                        $.ajax({
                            type: "PUT",
                            url: url + "/MyAddress_Billing",
                            headers: {
                                "Content-Type": "application/json",
                                "Cache-Control": "no-cache, no-store, must-revalidate"
                            },
                            dataType: 'json',
                            data: jsonDataBilling,
                            success: function (msg) {
                                console.log("PSL::AddressHelper.js::B address updated successfully");
                                AddressHelper.updateAddressCookies(msg.addressId,"Billing");
                                cursor_clear();
                                loadAddressInfo(); // added for checkout 3.0
                                //location.href = onSuccessURL;
                            }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                                restoreAjaxButtons();
                                console.log("PSL::AddressHelper.js::Error updating B address");
                                console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                            }
                        });
                    }, error: function (XMLHttpRequest, textStatus, errorThrown) {
                        restoreAjaxButtons();
                        console.log("PSL::AddressHelper.js::Error updating S address");
                        console.log("PSL::AddressHelper.js::Status: " + textStatus + " ; Error: " + errorThrown);
                    }
                });

            }
        }
    },

    addSuccesIcon: function (formField) {
          
               // $(formField).parent().addClass('validCheck');

                $(formField).parent().removeClass('isNotValid');
                
                if($(formField).siblings('.address-erros-message-cont').length > 0){
                	$(formField).siblings('.address-erros-message-cont').remove();
                }
                
                if($(formField).attr('formtmoreturn') && (isOliver || isPersol) && $('.form-page-container .find-order-wrapper .form-container .input-style input#email').length  > 0){
                	if($('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').length > 0){
                		$('.form-page-container .find-order-wrapper .form-container .input-style input#email').siblings('.address-erros-message-cont').remove();
                    }
                }
                
                if (typeof formField === 'string'){
                	if(formField.includes("country")){
                    	//$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').hide();
                    }
                }else{
                    $(formField).parent().addClass('validCheck');
                }
                
                
    },

    removeSuccesIcon: function (formField) {
          
        $(formField).parent().removeClass('validCheck');
        if($(formField).hasClass('field-error-message')){
            $(formField).parent().addClass('isNotValid');
        }
        
        if($(formField).attr('formtmoreturn')){
        	$(formField).parent().addClass('isNotValid');
        }
        
        
        if (typeof formField === 'string'){
        	if(formField.includes("country")){
            	$(formField).siblings('.ui-selectmenu-button').children('.ui-selectmenu-icon').show();
            }
        }
}
//END - new functions for checkout_3_0 Oliver/Persol
}

/*
 * Common utilities for all brands in the NERD project
 */

/**
 * isMobile https://github.com/kaimallea/isMobile
 * This function detects mobile devices and then it then creates a JavaScript object with the results.
 * version 0.5.1
 */
!function(e){var n=/iPhone/i,t=/iPod/i,r=/iPad/i,a=/\bAndroid(?:.+)Mobile\b/i,p=/Android/i,l=/\bAndroid(?:.+)SD4930UR\b/i,b=/\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i,f=/Windows Phone/i,u=/\bWindows(?:.+)ARM\b/i,c=/BlackBerry/i,s=/BB10/i,v=/Opera Mini/i,h=/\b(CriOS|Chrome)(?:.+)Mobile/i,w=/\Mobile(?:.+)Firefox\b/i;function m(e,i){return e.test(i)}function i(e){var i=e||("undefined"!=typeof navigator?navigator.userAgent:""),o=i.split("[FBAN");void 0!==o[1]&&(i=o[0]),void 0!==(o=i.split("Twitter"))[1]&&(i=o[0]);var d={apple:{phone:m(n,i)&&!m(f,i),ipod:m(t,i),tablet:!m(n,i)&&m(r,i)&&!m(f,i),device:(m(n,i)||m(t,i)||m(r,i))&&!m(f,i)},amazon:{phone:m(l,i),tablet:!m(l,i)&&m(b,i),device:m(l,i)||m(b,i)},android:{phone:!m(f,i)&&m(l,i)||!m(f,i)&&m(a,i),tablet:!m(f,i)&&!m(l,i)&&!m(a,i)&&(m(b,i)||m(p,i)),device:!m(f,i)&&(m(l,i)||m(b,i)||m(a,i)||m(p,i))},windows:{phone:m(f,i),tablet:m(u,i),device:m(f,i)||m(u,i)},other:{blackberry:m(c,i),blackberry10:m(s,i),opera:m(v,i),firefox:m(w,i),chrome:m(h,i),device:m(c,i)||m(s,i)||m(v,i)||m(w,i)||m(h,i)}};return d.any=d.apple.device||d.android.device||d.windows.device||d.other.device,d.phone=d.apple.phone||d.android.phone||d.windows.phone,d.tablet=d.apple.tablet||d.android.tablet||d.windows.tablet,d}"undefined"!=typeof module&&module.exports&&"undefined"==typeof window?module.exports=i:"undefined"!=typeof module&&module.exports&&"undefined"!=typeof window?module.exports=i():"function"==typeof define&&define.amd?define([],e.isMobile=i()):e.isMobile=i()}(this);

/**
 * replaceAll function. Replaces all occurrences of a string (since the js replace function only replaces the first one)
 * @param {String} search String to search for
 * @param {String} replacement Replacement string
 * @returns String with all replacements done
 */
String.prototype.replaceAll = function(search, replacement) {
    var target = this;
    return target.split(search).join(replacement);
};

function plog(str){
    console.log(new Date().toISOString()+"::PSL::"+str);
}
/** custom function  **/
window.setQueryParams = function (url, params) { // case 2
    let pasreUrl = url.split('?')[0];
    let result =  pasreUrl + params;
    return result;
}

window.setAttr = function (id, attributeName, url, params) { // per jsp
    let tag = document.getElementById(id)
    if (tag)  tag.setAttribute(attributeName, window.setQueryParams(url, params))
}

/**
 * HB-1995 Checkout | Payment | AMEX card: add field validation CVV should have 4 digits (3 if cc is not amex)
 */

/**
 * This function check if the credit card passed as parameter is an American Express
 * Following this guide: https://www.cybersource.com/developers/getting_started/test_and_manage/best_practices/card_type_id/
 * Amex rules are: Valid length: 15 digits. First digit must be a 3 and second digit must be a 4 or 7.
 *
 * @param {String} ccNumber Credit card number with or without spaces
 * @param {boolean} strictTest If false this function will only test the first digits condition
 */
function isAmexCreditCard(ccNumber, strictTest){
    var ccNumberParsed;
    if (ccNumber.includes(" ")){
        ccNumberParsed = ccNumber.split(" ");
        ccNumberParsed = ccNumberParsed.join("");
    } else {
        ccNumberParsed = ccNumber;
    }
    if (ccNumberParsed.length<2){
        return false;
    }else{
        var ccHead = ccNumberParsed.substring(0,2);
        //Check if the credit card is American Express
        if (ccHead != "34" && ccHead != "37"){
            return false;
        } else {
            if (strictTest){
                if (ccNumberParsed.length == 15){
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }
    }
}




function addDirectToCart(moco) {
	  //Declare a service for retrieving catalog entry detailed information for an item...
	isAdd2CartClicked=true;
	
	 var parameters = {
           moco : moco 
       };

	 
  wcService.declare({
      id: "GetCatalogEntryByMocoCmd",
      actionId: "GetCatalogEntryByMocoCmd",
      url: "GetCatalogEntryByMocoCmd",
      
      successHandler: function (serviceResponse) {
    	  //productDisplayJS.productAdd2Cart('entitledItem_'+serviceResponse.catentry);
    	  productDisplayJS.Add2ShopCartAjax('entitledItem_'+serviceResponse.catentry,1, false);
          productPageAdd2Cart();
          
          showDropdown=true;
          
          if (showDropdown && isVogue) {
        	  $('#shoppingCart').addClass('open');
              $('#MiniShopCartProductAdded').show();
              update_content = true;
              //We have added item to cart..So display the drop down with item added message..
              positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
              showDropdown = false;
              populateProductAddedDropdown();
          }
      },
      failureHandler: function (serviceResponse) {
          console.debug("We can't add to cart Item "+moco);
      }
  });
	 
  wcService.invoke("GetCatalogEntryByMocoCmd", parameters);
  
}





function GetCardType(number) {

	var retval="";
	
	var re = new RegExp("^4");
	if (number.match(re) != null)
		retval = "Visa";

	// Mastercard
	// Updated for Mastercard 2017 BINs expansion
    re = new RegExp("^5[1-5]");
    if (number.match(re) != null)
    	retval = "MasterCard";

	// AMEX
	re = new RegExp("^3[47]");
	if (number.match(re) != null)
		retval = "Amex";

	// Discover
	re = new RegExp(
			"^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
	if (number.match(re) != null)
		retval = "Discover";

	// Diners
	re = new RegExp("^36");
	if (number.match(re) != null)
		retval = "Diners";

	// Diners - Carte Blanche
	re = new RegExp("^30[0-5]");
	if (number.match(re) != null)
		retval = "Diners";

	// JCB
	re = new RegExp("^35(2[89]|[3-8][0-9])");
	if (number.match(re) != null)
		retval =  "JCB";

	
	if(retval != '')
		return retval;
	else
		return "CC";

}

/**
 * This function changes the maxlength of the CVV input field, according to the
 * card number input value
 * 
 * @param {String}
 *            ccInputId Id of the credit card input field
 * @param {String}
 *            cvvInputId Id of the cvv input field
 */
function updateCVVInputLength(ccInputId, cvvInputId){
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    document.getElementById(cvvInputId).setAttribute("maxlength", maxVal);
}

/**
 * This function tests if the cvv length is valid for the credit card number passed as paramenter
 * Currently the logic is:
 *  If the card is Amex and ccv lenght = 4, then return true,
 *  if the card is not Amex and ccv lenght = 3, then return true,
 *  otherwise return false
 *
 * @param {String} ccNumber Credit card number
 * @param {String} cvv CVV number
 */
function matchCreditCardCVV(ccNumber, cvv){
    if (isAmexCreditCard(ccNumber, false)){
        //is American Express
        if (cvv.length==4){
            return true;
        }else{
            return false;
        }
    } else {
        //not American Express
        if (cvv.length==3){
            return true;
        }else{
            return false;
        }
    }
}

/* HB-1995 END ******************************************************************************/

/**
 * This function validates the maxlength of the CVV input field, according to the type of card card gotten from the input value of the card field
 *
 * @param {String} ccInputId Id of the credit card input field
 * @param {String} cvvInputId Id of the cvv input field
 */
function validateCVVInputLength(ccInputId, cvvInputId) {
    var ccNumber = document.getElementById(ccInputId).value;
    var maxVal = 3;
    if (isAmexCreditCard(ccNumber, false)){
        maxVal = 4;
    }
    var ccvInputValue = document.getElementById(cvvInputId).value;
    if (undefined != ccvInputValue && "" !== ccvInputValue) {
    	if (ccvInputValue.length != maxVal) {
    		$("#wrongCVVLength").css("display", "block");
    	} else {
    		$("#wrongCVVLength").css("display", "none");
    	}
    }
}

/**
 * getGoogleAddress(countryCode, zipCode, language, callbackFunction)
 *
 * This function provides a common interface to access the Google Address API.
 * First it makes an async call to Google API sending required parameters and,
 * when the response is received, it parses the data to fit our requirements.
 * Finally launches callbackFunction sending the parsed data object as parameter.
 *
 * Usage: e.g. (Named function)     getGoogleAddress("ES","15001", "es", myFunction);
 *             (Anonymous function) getGoogleAddress("ES","15001", "es", function(data){
 *                                      //Your code here
 *                                      //At this point data is an object with all the address info
 *                                  });
 *
 * Parsed address object:
 *      {
 *          status : <success | error>,
 *          error_description : <error description (only when status = error)>,
 *          address :
 *              {
 *                  city : <city name>,
 *                  country : <country name>,
 *                  country_short : <short country name>,
 *                  locality : <locality name>,
 *                  neighborhood : <neighborhoodId name>,
 *                  prov_state : <province name (state in the US), e.g."Citta Metropolitana di Milano">,
 *                  prov_state_short : <short province name (state in the US) e.g."MI">
 *                  zipcode : <zip code>
 *              },
 *          raw :
 *              {
 *                  <data object received from Google API>
 *              }
 *      }
 *
 * Usage samples:
 *    getGoogleAddress("US","10462", "en", showAddressData);
 *    getGoogleAddress("ES","15001", "es", showAddressData);
 *    getGoogleAddress("IT","20099", "it", showAddressData);
 *    getGoogleAddress("FR","20099", "it", showAddressData);
 *    getGoogleAddress("US","10462", "en", function(result){
 *        if (result.status == "error"){
 *            console.log(result.error_description);
 *        } else {
 *            console.log(result);
 *        }
 *    });
 *
 *
 * @param {String} countryCode e.g."ES"
 * @param {String} zipCode e.g."15001"
 * @param {String} language e.g. "es"
 * @param {function} callbackFunction
 */
function getGoogleAddress(countryCode, zipCode, language, callbackFunction){
    try{
        var geocoder = new google.maps.Geocoder();
        geocoder.geocode({
            componentRestrictions: {
              country: countryCode,
              postalCode: zipCode
            }
          }, function(results, status) {
            
                if(status != "OK"){
                    if(AddressHelper.zipCodeNotFound ||status == "ZERO_RESULTS") {
                        zipCodeError = false;
                    }
                    else {
                        zipCodeError = true
                    }
                }
                else{
                    zipCodeError=false;
                }
                
                findAddressInformation(results);
            
          });
    }catch(e){
        console.log("getGoogleAddress : the promise constructor cannot be invoked directly");
    }
    

      function findAddressInformation (results){
            var city = null;
            var locality = null;
            var neighborhood = null;
            var maxNeighborhoodlenght = 31;
            var province = null;
            var province_short = null;
            var postalCode = null;
            var administrativeArea2 = null;
            var administrativeArea1 = null;
            var administrativeArea3 = null;
            var administrativeArea2_short = null;
            var administrativeArea1_short = null;
            var administrativeArea3_short = null;
            var country = null;
            var country_short = null;
            var responseObj={};
            var addressData={};

            if (results == null || results[0] == null ||  results[0].address_components == null || results[0].address_components.length == 0
                    || (results[0].address_components.length == 1 && results[0].address_components[0].types[0] == "country")) {

                responseObj.status = "error";
                responseObj.error_description = "zipcode_not_found";
                responseObj.raw = results;

            } else {

                if (results != null && results[0] != null) {
                    var addressComponents = results[0].address_components;
                    for (var i = 0; i < addressComponents.length; i++) {

                        if (addressComponents[i].types[0] == "postal_code") {
                            postalCode = addressComponents[i].long_name;
                        }
                        //getting city
                        if (addressComponents[i].types[0] == "postal_town") {
                            city = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "country") {
                            country = addressComponents[i].long_name;
                            country_short = addressComponents[i].short_name;
                        }
                        //getting locality
                        if (addressComponents[i].types[0] == "locality") {
                            locality = addressComponents[i].long_name;
                        }
                        if (addressComponents[i].types[0] == "neighborhood") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        if (addressComponents[i].types[2] == "sublocality_level_1") {
                            neighborhood = (addressComponents[i].long_name).substring(0,maxNeighborhoodlenght);
                        }
                        //getting administrative Area1 (state)
                        if (addressComponents[i].types[0] == "administrative_area_level_1") {
                            administrativeArea1 = addressComponents[i].long_name;
                            administrativeArea1_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area2
                        if (addressComponents[i].types[0] == "administrative_area_level_2") {
                            administrativeArea2 = addressComponents[i].long_name;
                            administrativeArea2_short = addressComponents[i].short_name;
                        }
                        //getting administrative Area3
                        if (addressComponents[i].types[0] == "administrative_area_level_3") {
                            administrativeArea3 = addressComponents[i].long_name;
                            administrativeArea3_short = addressComponents[i].short_name;
                        }
                    }
                }

                if (city == null) {

                    if (locality == null){
                        if (neighborhood == null){
                            if (administrativeArea3 == null){
                                city = administrativeArea2;
                            } else {
                                city = administrativeArea3;
                            }
                        } else {
                            city = neighborhood;
                        }
                    } else {
                        city = locality;
                    }
                }

                // For america and canada administrativeArea1 represents the province
                // For italy and spain this value is stored on administrativeArea2
                if (country_short === 'ES') {
                    province = administrativeArea2;
                    province_short = zipCode.substring(0,2);
                    //HB-5761: revert HB-5556
                    //province_short = administrativeArea2_short; 
                } else if (country_short === 'IT') {
                    province = administrativeArea2;
                    province_short = administrativeArea2_short;
                } else {
                    province = administrativeArea1;
                    province_short = administrativeArea1_short;
                }

                addressData.city = city;
                addressData.locality = locality;
                addressData.neighborhood = neighborhood;
                addressData.prov_state = province;
                addressData.prov_state_short = province_short;
                addressData.country = country;
                addressData.country_short = country_short;
                addressData.zipcode = postalCode;

                /*
                addressData.administrativeArea1 = administrativeArea1;
                addressData.administrativeArea2 = administrativeArea2;
                addressData.administrativeArea3 = administrativeArea3;
                addressData.administrativeArea1_short = administrativeArea1_short;
                addressData.administrativeArea2_short = administrativeArea2_short;
                addressData.administrativeArea3_short = administrativeArea3_short;
                */
                
                responseObj.status = "success";
                responseObj.address = addressData;
                responseObj.raw = results;

                
            }
            callbackFunction(responseObj);
        
      }


}

function getGoogleAddressPromise(countryCode, zipCode, language){
   return new Promise(function(resolve, reject) {
                var geocoder = new google.maps.Geocoder();
        
                geocoder.geocode({
                    componentRestrictions: {
                    country: countryCode,
                    postalCode: zipCode
                }
                }, function(results, status) {
                        var data= {
                        results:"",
                         status:""
                        }
                    if (status == 'OK') {
                        zipCodeError=false;
                        data.results=results;
                        data.status= status;
                        resolve(data);
                    } else {     	
                        reject(function(data){
                            console.log("UnregisteredCheckout.jsp::","Zip code unknown");
                        });
       
                    }
       
                  });
    });
      
}

function convertGoogleAddressResponse(data){
    var responseObj = {};

    if (data.status != "OK"){
        responseObj.status = "error";
        responseObj.error_description = "google_api_error";
        responseObj.raw = data;
    } else {
        var addressData = {};

        var city = null;
        var locality = null;
        var neighborhood = null;
        var province = null;
        var province_short = null;
        var postalCode = null;
        var administrativeArea2 = null;
        var administrativeArea1 = null;
        var administrativeArea3 = null;
        var administrativeArea2_short = null;
        var administrativeArea1_short = null;
        var administrativeArea3_short = null;
        var country = null;
        var country_short = null;

        if (data == null || data.results[0] == null ||  data.results[0].address_components == null || data.results[0].address_components.length == 0
                || (data.results[0].address_components.length == 1 && data.results[0].address_components[0].types[0] == "country")) {

            responseObj.status = "error";
            responseObj.error_description = "zipcode_not_found";
            responseObj.raw = data;

        } else {

            if (data != null && data.results[0] != null) {
                var addressComponents = data.results[0].address_components;
                for (var i = 0; i < addressComponents.length; i++) {

                    if (addressComponents[i].types[0] == "postal_code") {
                        postalCode = addressComponents[i].long_name;
                    }
                    //getting city
                    if (addressComponents[i].types[0] == "postal_town") {
                        city = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "country") {
                        country = addressComponents[i].long_name;
                        country_short = addressComponents[i].short_name;
                    }
                    //getting locality
                    if (addressComponents[i].types[0] == "locality") {
                        locality = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[0] == "neighborhood") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    if (addressComponents[i].types[2] == "sublocality_level_1") {
                        neighborhood = addressComponents[i].long_name;
                    }
                    //getting administrative Area1 (state)
                    if (addressComponents[i].types[0] == "administrative_area_level_1") {
                        administrativeArea1 = addressComponents[i].long_name;
                        administrativeArea1_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area2
                    if (addressComponents[i].types[0] == "administrative_area_level_2") {
                        administrativeArea2 = addressComponents[i].long_name;
                        administrativeArea2_short = addressComponents[i].short_name;
                    }
                    //getting administrative Area3
                    if (addressComponents[i].types[0] == "administrative_area_level_3") {
                        administrativeArea3 = addressComponents[i].long_name;
                        administrativeArea3_short = addressComponents[i].short_name;
                    }
                }
            }

            if (city == null) {
                //city = locality == null ? (neighborhood == null ? (administrativeArea3 == null ? administrativeArea2 : administrativeArea3) : neighborhood) : locality;
                if (locality == null){
                    if (neighborhood == null){
                        if (administrativeArea3 == null){
                            city = administrativeArea2;
                        } else {
                            city = administrativeArea3;
                        }
                    } else {
                        city = neighborhood;
                    }
                } else {
                    city = locality;
                }
            }

            // For america and canada administrativeArea1 represents the province
            // For italy and spain this value is stored on administrativeArea2
            if (country_short === 'ES') {
                province = administrativeArea2;
                //province_short = postalCode.substring(0,2);
                //fix
                province_short = administrativeArea2_short;
            } else if (country_short === 'IT') {
                province = administrativeArea2;
                province_short = administrativeArea2_short;
            } else {
                province = administrativeArea1;
                province_short = administrativeArea1_short;
            }

            addressData.city = city;
            addressData.locality = locality;
            addressData.neighborhood = neighborhood;
            addressData.prov_state = province;
            addressData.prov_state_short = province_short;
            addressData.country = country;
            addressData.country_short = country_short;
            addressData.zipcode = postalCode;

            responseObj.status = "success";
            responseObj.address = addressData;
            responseObj.raw = data;
        }
    }

    return responseObj;
}

function getUserAddressListPromise(){
    var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
    return $.ajax({
        method: "GET",
        url: url,
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        data: {
            "timestamp": Date.now()
        },
        dataType: "json"
    });
}

function updateCurrentOrderShippingDatePromise(){
    var time = "0700";
    if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "noon") {
        time = "1200";
    } else if (document.querySelector('input[name="shippingSelectTime"]:checked').value == "night") {
        time = "1800";
    }

    var date = $("#datepicker-holder").datepicker('getDate');
    var formattedDate = $.datepicker.formatDate("yymmdd", date);

    $.ajax({
        type: "POST",
        url: "AjaxShippingDateUpdate?requestType=update&shippingDate=" + formattedDate + time + "&ordersId=.&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId,
        headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate"
        }
    });
}



/**
 * This function transform a jQuery ajax error response to a string error message
 * Usage:
 *   $.ajax({
 *       ...
 *       success: function (data) {
 *           ...
 *       },
 *       error: function(jqXHR, exception){
 *           console.log(METHODNAME + "::Ajax error: " + getAjaxErrorMessage(jqXHR, exception));
 *       },
 *       complete: function(){
 *           ...
 *       }
 *   });
 *
 * @param {Object} jqXHR
 * @param {String} exception
 * @returns {String} Error message
 */
function getAjaxErrorMessage(jqXHR, exception){
    var msg = "";
    if (jqXHR.status === 0) {
        msg = "Not connected.\n Verify Network.";
    } else if (jqXHR.status == 404) {
        msg = "Requested page not found. [404]";
    } else if (jqXHR.status == 500) {
        msg = "Internal Server Error [500].";
    } else if (exception === "parsererror") {
        msg = "Requested JSON parse failed.";
    } else if (exception === "timeout") {
        msg = "Time out error.";
    } else if (exception === "abort") {
        msg = "Ajax request aborted.";
    } else {
        msg = "Uncaught Error.\n" + jqXHR.responseText;
    }

    return msg;
}
/**
 * @desc Compare arrays
 * @param {Array} array
 * @see https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript?page=1&tab=votes#tab-top
 * @return True or False
 */

// Warn if overriding existing method
if (Array.prototype.equals)
    console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");

// Attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // If the other array is a falsy value, return
    if (!array) return false;

    // Compare lengths - can save a lot of time
    if (this.length != array.length) return false;

    for (var i = 0, l=this.length; i < l; i++) {
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // Recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) {
            // Warning - two different object instances will never be equal: {x:20} != {x:20}
            return false;
        }
    }
    return true;
}

// Hide method from for-in loops
Object.defineProperty(Array.prototype, "equals", {enumerable: false});

/**
 * Add NodeList.forEach and Element.remove support to IE9+
 */
(function() {
    if (typeof NodeList.prototype.forEach !== "function"){
        NodeList.prototype.forEach = Array.prototype.forEach;
    }
    if (typeof Element.prototype.remove !== "function"){
        Element.prototype.remove = function(){
            this.parentElement.removeChild(this);
        }
    }
})();

/**
 * This function creates a cookie named 'WC_X_LoggedUser=No' when the user is G (guest).
 * If the storeUserType changes to registered, the cookie is deleted by the function.
 * This function helps Akamai to determinate if the jsp should be cached or not.
 * NERD-761
 * 23-11-23
 * hb-14987 --> in this function is been added sessionStorage["logged"] = 'false'; 
 * 				to indicated the user is not logged
 * 			    
 */

loggedUserCookieManager();

function loggedUserCookieManager(){
    //If the user is G=Guest, creates the cookie
    if (storeUserType === "G"){
        document.cookie="WC_X_LoggedUser=No;;path=/";

    }
    //Otherwise, the cookie is deleted
    else{
        var today = new Date();
        today.setTime(today.getTime() - 1000);
        var expires = "expires="+today.toUTCString();
        document.cookie="WC_X_LoggedUser=;" + expires + ";path=/";
    }
}




function getTaxesFromZipCodePromise(srcForm){
    if (!AddressHelper.hasTaxes){
        return "";
    }else{
        var isCheckOut = (document.querySelectorAll("#page.checkout").length != 0 ||$("#page.checkout-page").length != 0)

        var city = srcForm.city.value;
        var state = srcForm.state.value;
        var zipcode = srcForm.zipCode.value;

        // submit AjaxOrderCalculate request
        var params = [];

        params.storeId      = WCParamJS.storeId;
        params.catalogId    = WCParamJS.catalogId;
        params.langId       = WCParamJS.langId;

        params.updatePrices = "0";
        if(isCheckOut){
            params.orderId = ".";
        } else {
            params.orderId = $('#wcs_calTax_notification #orderId').val();
        }

        params.addressFlag = true;
        params.isDeliveryAddressAdded = false;
        params.zipCode = zipcode != null ? zipcode : "";
        params.city = city != null ? city : "";
        params.state = state != null ? state : "";
        params.country = "us";
        params.isZipChange = true;//isZipChange;

        var url = getAbsoluteURL() + "AjaxOrderCalculate?";
        for (var param  in params) {
            url += param + "=" + params[param] + "&";
        }
        url += "calculationUsageId=-1&";
        url += "calculationUsageId=-2&";
        url += "calculationUsageId=-3&";
        url += "calculationUsageId=-4";

        //Make the call to AjaxOrderCalculate
        return $.ajax({
            url: url,
            type: 'POST',
        });
    }
}

function goToOrderShippingBillingViewOnClickHandler(event){
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    let isFormNoError = true; //true if form is without error in checkout 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }
    
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    form2.email1.value=form1.email1.value;
    if(isFormNoError){
        isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    }else {
        AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>')
    }
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
                  if (typeof data.contact === 'undefined'){
                      plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                      AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                  } else {
                      for (var i = 0; i<data.contact.length; i++){
                          if (data.contact[i].nickName == 'MyAddress_Shipping'){
                              plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                              AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                              break;
                          }
                      }
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
        	if(AddressHelper.validateAddressForm(form3)) {
        		/*
        		 * //REPLACE BOSS: 
        		 * 70128 with zipcode of pickupstore
        		 * we will take this zipcode by the tab services
        		 
        		getGoogleAddressPromise(countryCode, '70128', storeLanguage) 
		        .then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + '70128' + " not valid for country "+countryCode;
		            } else {
		            	/*
		            	 * REPLACE BOSS: 
		            	 * var city will be the city of store
		            	 * we will take this city by the tab services
		            	
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_billingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form3, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form3);
		        }).then(function(data){
		        	//Billing Address
		            return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		        }).then(function(data){
		        	var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		            	formValidationError = true;
		                throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		            } else {
		            	AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		            }
		            return getUserAddressListPromise();
		        }).then(function(data){
			    	if (typeof data.contact !== 'undefined'){
			        	for (var i = 0; i<data.contact.length; i++){
			            	if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
			                	AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
			                    plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
			                }
			            }
			        }
			    }, function(err){
			    	 console.log(err);
			    }).then(function(){
		            if (!AddressHelper.validateAddressForm(form3)){
		                formValidationError = true;
		            }
		            if (!AddressHelper.validateAddressForm(form2)){
		            	formValidationError = true;
		           	}
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            AddressHelper.joinNewsletter('recipient_detail', WCParamJS.langId, WCParamJS.storeId);
		            
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv2');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('recipient_detail', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, false, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        }); 
        	}
        }else{*/
	    	if(AddressHelper.validateAddressForm(form1)) {
                if(isFormNoError)
                    isFormNoError  = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderShippingBillingViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		
		            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
		
		            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
		            //calling the rest service. If success then address exist else address does not exist.
		            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
		            $.ajax({
		                method: "GET",
		                url: url,
		                headers: {
		                    "Content-Type": "application/json",
		                    "Cache-Control": "no-cache, no-store, must-revalidate"
		                },
		                dataType: "json",
		                success:function(data, textStatus, jqXHR){
		                    if (typeof data.contact === 'undefined'){
		                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
		                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
		                    } else {
		                        for (var i = 0; i<data.contact.length; i++){
		                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
		                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
		                                AddressHelper.updateUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
		                                break;
		                            }
		                        }
		                    }
		                },
		                error:function(jqXHR, exception){
		                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
		                }
		            });
		
		            moveToError();
		
		        })
	    	}else{
                isFormNoError = false;
            }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError){ 
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc'); 
    }  
}


// NERD-760 Functions that help Akamai to determinate if it is necesary to activate the cache depending if the user is logged and / or if there are items on cart

/**
 * This function calls updateItemsInCartBadge() passing it the number of items that have been added to the cart by the user.
 * NERD-762
 */
function getNumberOfItemsInCart(){
    if(personInfo.userId !== '-1002' || (isVogue && document.querySelectorAll('.pdp').length > 0)){
        var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self/shipping_info";
        getAjaxCallInfo(url, null, numberOfItemsInCartCallback);

        function numberOfItemsInCartCallback(response) {
            if(response.recordSetTotal !== '0') {
                var url = "/wcs/resources/store/" + WCParamJS.storeId + "/cart/@self";
                getAjaxCallInfo(url, null, orderitemsInfoInCartCallback);
            } else {
                updateItemsInCartBadge(response.recordSetTotal);
            }
        }
        function orderitemsInfoInCartCallback(response) {
        	var total= 0;
        	if(response != undefined && response.recordSetTotal != 0) {
        		total = response.recordSetTotal;
        		response.orderItem.forEach(function(item) {
        			if(item.partNumber.includes('Service') || item.partNumber.endsWith("SV") || item.partNumber.endsWith("PG") ) { //non contare engraving, lenti e servizi 
        				total-=1;
                    }
        		});
        		
        	}
        	updateItemsInCartBadge(total);
            /**if(response.orderItem) {
                for(var i = 0; i < response.orderItem.length; i++) {
                    if((response.orderItem[i].xitem_field2 && (response.orderItem[i].xitem_field2).indexOf("|") !== -1)
                     || (response.orderItem[i].partNumber && (response.orderItem[i].partNumber).indexOf("K-") !== -1)) {
                        total--;
                    }
                }
                updateItemsInCartBadge(total);
            }*/
        }
    }
}

/**
 * This function updates the number rendered into the shoping bag badge according to the number of items included in the cart.
 * As well, if the amount is equal to 0, adds the class 'empty' to the element.
 * @param {*} itemsInCartBadge Amount of items added to the cart by the user.
 * NERD-762
 */

var itemsInCartBadge = "0";
function updateItemsInCartBadge(paramItemsInCart){

    var itemsInCartBadgeElement;
    if (document.getElementById("minishopcart_total") !== null) {
        itemsInCartBadgeElement = document.getElementById("minishopcart_total");
    } else {
        itemsInCartBadgeElement = "0";
    }
    itemsInCartBadge = paramItemsInCart;
    itemsInCartBadgeElement.innerHTML  = itemsInCartBadge;

    if (itemsInCartBadgeElement.innerHTML === "0"){
        itemsInCartBadgeElement.classList.add("empty");
    }

    if(isPersol && paramItemsInCart > 0){
    	var minicartHtml = $('#minishopcart_total');
    	if(minicartHtml.length == 0){
    	minicartHtml = $('<div/>',{id: 'minishopcart_total', class: 'minishopcart-quantity-number'});
    	}
    	minicartHtml.text(paramItemsInCart);
    	$('#widget_minishopcart').prepend(minicartHtml);
    }
    
    if(isVogue) {
        var shopElem =  document.getElementById('shoppingCart');
        var isPDP = document.querySelectorAll('.pdp').length > 0;
        if(isPDP) {
            if(!isAdd2CartClicked && personInfo.userId === '-1002') {
                shopElem.classList.remove('fill');
            } else if(isAdd2CartClicked) {
                shopElem.classList.remove('fill','added');
                shopElem.classList.add('added');
                isAdd2CartClicked = false;
            } else if(!isAdd2CartClicked && personInfo.userId !== '-1002' && paramItemsInCart !== '0' && paramItemsInCart !== '') {
                shopElem.classList.add('fill');
            }
        } else {
            if(itemsInCartBadgeElement.innerHTML !== "0") {
                shopElem.classList.add('fill');
            } else {
                shopElem.classList.remove('fill');
            }
        }
    }
}

/**
 * Function that make a GET ajax call and execute a callback if success
 * @param {string} url - the url to make the ajax call
 * @param {object} params - ajax call params if its needed
 * @param {function} callback - function that it will be executed if ajax call is success
 */
function getAjaxCallInfo(url, params, callback) {
    var parameters = {};
    if(params) {
        parameters = params;
    }
    parameters["timestamp"] = Date.now();
    $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters,
        success: function (response, textStatus, request) {
            callback(response);
        },
        error: function(response){
            console.log(response);
            if(typeof pageType != "undefined")
				callback(response);
        }
    });
}

// BEGIN NERD-795 PSD2 | Front-end | Adaptation
// Those functions are called from servicesDeclaration.js AjaxSubmitOrder service
    /**
     * This function creates a dark overlay with a loader spinner that fits the whole page and adds a 'noScroll' class to the body.
     * The scope is to improve the UX while the PSD2 payment is in process.
     */
    function createPaymentLoaderOverlay(){
        $("body").append("<div class='paymentLoaderOverlay'></div>");
        $('body').addClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner that fits the whole page and removes a 'noScroll' class from the body.
 */
    function deletePaymentLoaderOverlay(){
        $(".paymentLoaderOverlay").remove();
        $('body').removeClass('noScroll');
    }
/**
 * This function deletes a dark overlay with a loader spiner when any error message is closed by clicking on its closing buton
 */
    $(function(){
        $('#clickableErrorMessageImg').click(deletePaymentLoaderOverlay);

    });

// END NERD-795 PSD2 | Front-end | Adaptation
// BEGIN HB-3160: recover parameter from URL generic function.
/**
 * Recover a parameter from URL, returning the default value if does not exist.
 *
 * @param parameter Parameter name
 * @param defaultValue Parameter default value when it does not exist in URL
 * @return Parameter value
 */
function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        var vars = {};
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        urlparameter = vars[parameter];
        if (urlparameter === undefined || urlparameter === null) {
            urlparameter = defaultvalue;
        }
    }
    return urlparameter;
}
// END HB-3160

/**
 * HB-3032 | All | Analytics | Do not push to Tealium certain payment response codes
 * This variable is used in Stores/WebContent/<Brand>SAS/javascript/ServicesDeclaration.js, in failureHandler of AjaxRESTOrderSubmit service
 *
 * Those response values are not application errors so they should not be shown in Analytics
 * 202 - Expired card
 * 203 - Card refused
 * 204 - Insufficient funds
 * 205 - Stolen card
 * 208 - Inactive card
 * 209 - CVN doesn't match
 * 210 - Reached the credit limit
 * 211 - Invalid CVN
 * 230 - Soft decline
 * 231 - Invalid account number
 * 233 - General decline
 * 481 - Decision manager decline (now managed by Forter)
 */

var paymentResponseCodesNotWCSError = [
    "PLUGIN_RC_202",
    "PLUGIN_RC_203",
    "PLUGIN_RC_204",
    "PLUGIN_RC_205",
    "PLUGIN_RC_208",
    "PLUGIN_RC_209",
    "PLUGIN_RC_210",
    "PLUGIN_RC_211",
    "PLUGIN_RC_230",
    "PLUGIN_RC_231",
    "PLUGIN_RC_233",
    "PLUGIN_RC_481"
];

var paymentErrorMessageMeaning = {};

paymentErrorMessageMeaning["PLUGIN_RC_202"] = "Expired card";
paymentErrorMessageMeaning["PLUGIN_RC_203"] = "Card refused";
paymentErrorMessageMeaning["PLUGIN_RC_204"] = "Insufficient funds";
paymentErrorMessageMeaning["PLUGIN_RC_205"] = "Stolen card";
paymentErrorMessageMeaning["PLUGIN_RC_208"] = "Inactive card";
paymentErrorMessageMeaning["PLUGIN_RC_209"] = "CVN doesn't match";
paymentErrorMessageMeaning["PLUGIN_RC_210"] = "Reached the credit limit";
paymentErrorMessageMeaning["PLUGIN_RC_211"] = "Invalid CVN";
paymentErrorMessageMeaning["PLUGIN_RC_230"] = "Soft decline";
paymentErrorMessageMeaning["PLUGIN_RC_231"] = "Invalid account number";
paymentErrorMessageMeaning["PLUGIN_RC_233"] = "General decline";
paymentErrorMessageMeaning["PLUGIN_RC_481"] = "Decision manager decline";

function sendPaymentErrorMessageToTealium(errorMessageKey, errorMessage){
    if (paymentResponseCodesNotWCSError.includes(errorMessageKey)){
        pushErrorToTealium('Client', "Cybersource Error " + errorMessageKey + " (" + paymentErrorMessageMeaning[errorMessageKey] + ")", 'Error in CyberSource occurred on payment of order',CheckoutHelperJS.getOrderId());
    } else {
        //pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order <' + CheckoutHelperJS.getOrderId() + '>');
    	//HB-3186
    	pushErrorToTealium('Server', errorMessage, 'Error occurred on payment of order',CheckoutHelperJS.getOrderId());
    }
}

// HB-3032 END

function getAjaxPromise(url) {
    var parameters = {};
    parameters["timestamp"] = Date.now();

    return $.ajax({
        url: url,
        type: 'GET',
        headers: {
            "Content-Type": "application/json",
            "Cache-Control": "no-cache, no-store, must-revalidate"
        },
        dataType: "json",
        data: parameters
    });
}

function removeErrorMessagesFromElement(element){
    $(element).find(".error-messages-section").remove();
    $('#WC_PromotionCodeDisplay_div_2').removeClass('error');
}

function addErrorMessageToElement(element, message){
    var el = $(element);
    var noErrorSection = false;

    if ($(el).find(".error-messages-section").length==0){
        if(el.attr('id')== 'PromotionCodeForm' && (isOliver ||isPersol) ){ //only checkout 3.0
            $('#WC_PromotionCodeDisplay_div_2').addClass('error');
            $('#PromotionCodeForm #PromotionCodeForm_upper .input-style').after("<div class='error-messages-section'></div>");
        }else{
        $(el).append("<div class='error-messages-section'></div>");
        }
        noErrorSection = true;
    }

    el = $(element).find(".error-messages-section");

    if (noErrorSection || $(el).find(".error-message.error-message-md5-"+md5(message).toString()).length==0){
    	if((isVogue || isPersol) && document.cookie.includes('X_WC_PR_SEGMENTS')){
    		$('#PromotionCodeForm .error-message').remove();
    		$('#PromotionCodeForm input#promoCode.error , #PromotionCodeForm input#coupon-value.error').removeClass('ea_input');
    	}
    	var finalMessage = "<div class='error-message error-message-md5-"+ md5(message).toString() +"'>" + message + "</div>";
        $(el).append(finalMessage);
    }
}

/* detect mobile*/ 
window.mobilecheck = function() {
    var check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
  };

window.tabletPortraitCheck = function(){
    var tabletPortrait = false;
    var mq =  window.matchMedia( "screen and (min-width:1024");
    var portrait =  window.matchMedia("(orientation: portrait)");
    if(!mq.matches  && portrait.matches){
        tabletPortrait = true; 
    }
    return tabletPortrait;
}

/* function to manage header z-index in pdp mobile  */
function checkMobilePdpPage(){
    if((window.mobilecheck() || window.tabletPortraitCheck()) && $('#page').hasClass('pdp')){
        return true
    }
}

//its also used in WCAG.js too
function productPageAdd2Cart(wishlistProductId) {

    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
			showCTAloaderClip();
		}else{
			showCTAloader("productPageAdd2Cart");
		}
	} else if (isPersol || isOliver){
        if (!isWishlistPage){
            showCTAloader("productPageAdd2Cart");
        } else {
            showWishlistCTAloader(wishlistProductId);
        }
    }

    var waitForEl = function(selector, callback) {
        if ($(selector).length) {
            callback();
        } else {
            setTimeout(function() {
                waitForEl(selector, callback);
            }, 1000);
        }
    };

    var selector = '[aria-describedby="MiniShopCartProductAdded"]';

    waitForEl(selector, function() {

    	if(isPersol && !productDisplayJS.priceSwitched){
    		if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	    			var clip_on_selected = $('.product-clip-on.selected').attr('catentryClip');
	    			var clip_on_sku_selected = $('#current-clipon-catentry').val();
	    			var offer_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].price;
	                var list_price = arrayOfClip[clip_on_selected].skus[clip_on_sku_selected].listprice;
	                productDisplayJS.lastPriceSaved = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	                productDisplayJS.lastOfferPriceSaved = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
    		} else {
	            var offer_price = !isWishlistPage ? document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('offerPrice_'+wishlistProductId).innerText;
	            //document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
	            productDisplayJS.lastPriceSaved = offer_price;
	            var list_price = !isWishlistPage ? document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
	            if (!isWishlistPage) {
	                document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
	            } else {
	                document.getElementById('listPrice_'+wishlistProductId).innerText = productDisplayJS.lastOfferPriceSaved;
	            }
	            productDisplayJS.lastOfferPriceSaved = list_price;
    		}
            
            
           
            /*
             // Show complete pair offer price if frame has a promotion
             // Now handled by LensConfigurator

                if (completePairTotalPrice != undefined && completePairTotalPrice[frameId] != undefined && completePairTotalPrice[frameId][selectedLendCatentryId] != undefined) {
                    var frameId = $("#roxLenses").val();
                    var selectedLensID = $("#presc--lens--id").val();
                    var hasPromotion = completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] != undefined ? completePairTotalPrice[frameId][selectedLensID]['hasPromotion'] : false;
                    if (hasPromotion) {
                        var completePairOfferPrice = completePairTotalPrice[frameId][selectedLensID]['offerPrice'];
                        var completePairListPrice = completePairTotalPrice[frameId][selectedLensID]['listPrice']; 
                        $('.priceCart')[0].innerText = WCCurrencyJS.format(completePairOfferPrice);
                        $('#minicartPST.price__list')[0].innerText = WCCurrencyJS.format(completePairListPrice);
                        document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    }
                }
            */
	    	if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
	    	productDisplayJS.priceSwitched = true;
            
    	}
    	else if(isOliver && !productDisplayJS.priceSwitched) {
    		var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+wishlistProductId+']');
    		var div;
    		for(var i = 0; i<elements.length;i++) {
    			if(elements[i].nodeName == "DIV") {
    				div = elements[i];
    			}
    		}
    		if(div != undefined) {
    			var temp = div.getElementsByClassName('price__unity')[0].innerText;
    			productDisplayJS.lastPriceSaved = temp;
        		div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        	}
    		
    		var temp = !isWishlistPage ? document.getElementById('listPrice_'+productParent).innerText : document.getElementById('listPrice_'+wishlistProductId).innerText;
    		if (!isWishlistPage){
                document.getElementById('listPrice_'+productParent).innerText=productDisplayJS.lastOfferPriceSaved;
            } else {
                document.getElementById('listPrice_'+wishlistProductId).innerText=productDisplayJS.lastOfferPriceSaved;
            }
            
    		productDisplayJS.lastOfferPriceSaved = temp;
    		if(affirmEnabled && !isWishlistPage) {
	    		customizeAffirmPrice();
	    	}
    		productDisplayJS.priceSwitched = true;
    	}
        //reset size
        $('.options_dropdown_column input').each(function( index,input ) {
            if(isOliver){
                var stringCmp = "normal"
            }else{
                var stringCmp = "standard"
            }         
            if(input.value.toLowerCase().includes(stringCmp)){
                $('.options_dropdown_column .size-option-selected span').html(input.value);
            }
        //reset z-index bottom-scrollable-section
        $('.bottom-scrollable-section').css('z-index', "3"); 
            
        });
    	// work the magic
        var defaultPaymentPlacement = $("#defaultPaymentPlacement").val();
        showDefaultPaymentPlacement(defaultPaymentPlacement);
        $('[aria-describedby="MiniShopCartProductAdded"]').addClass("opend");
        // $('#page-overflow-wrapper').addClass('overflow-hidden');
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            $('body').addClass('no-scroll');
        }

        if($('#page').hasClass('pdp') && brandCode=="PO"){
            $('#header').css('z-index', '1000') 
        }

        $(".minishopcartadded--fade").show(); 
        if($('#page').hasClass('pdp') && brandCode=="OP"){
            if(!$('#header').is(":visible")) $('#header').slideDown()
            hideHeaderTimeout.cancel();
        }
        if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			setTimeout(function() {
    				hideCTAloaderClip();
                }, 1000)
    		}else{
    			setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
    		}
    	} else if (isPersol || isOliver){
            if (!isWishlistPage){
                setTimeout(function() {
                    hideCTALoader("productPageAdd2Cart");
                }, 1000)
            } else {
                setTimeout(function() {
                    hideWishlistCTALoader(wishlistProductId);
                }, 1000)
            }
        }

        if (minicartYMALCallback != undefined) {
            minicartYMALCallback.onWidgetLoaded();
        }

        //HB-7718 
        //check if the add to cart is related to upsell
        var isUpsell = false;
        if($('#upsell-added-inicart').length > 0){
            isUpsell = true;
        }

        //START Early Access
        if (isPersol){
        	var offer_price;
        	var list_price;
        	
            //Wishlist
            if (isWishlistPage) window.lastOfferPrice = returnLastOfferPrice();
            //Wishlist

            //if a upsell products is been added in cart we must use the offerprice and listprice of the upsell product
        	//this listprice and offerprice are in a div created in updateLastOfferUpsell() in store-presol.js
        	//after this we must delete the div with upsell product's listprice and offerprice.
        	if($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true'){
	        		var str_offer_price = offer_price.trim();
	            	var str_list_price = list_price.trim();
        	} else {
        		var str_offer_price = returnLastOfferPrice().trim();
            	var str_list_price = productDisplayJS.lastOfferPriceSaved.trim();
        	}
        	
        	//SETTING PRICE IN MINICART
        	if(!isUpsell){
        		if(productDisplayJS.engraving){
        			 str_offer_price = document.getElementById('offerPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 if(productDisplayJS.lastOfferPriceSaved!==""){
        				 str_list_price = document.getElementById('listPrice_'+productDisplayJS.baseCatalogEntryId+"_1").innerHTML;
        			 }
        		}
        		$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html(str_offer_price);
        		
        		
        		if(str_offer_price != str_list_price && !str_list_price.includes("NaN")){
        			document.getElementById("minicartPST").innerHTML=str_list_price;
        		}
                if (!isWishlistPage){
	        		if(!($('#current-clipon-catentry').length > 0 && $('#current-clipon-catentry').attr('isAdded') == 'true')){
		        		offer_price = document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText;
		        		list_price = document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText;
	        		}
                } else {
                    offer_price = document.getElementById('offerPrice_'+wishlistProductId).innerText;
                    list_price = document.getElementById('listPrice_'+wishlistProductId).innerText;
                } 
        	}else{
        		if($('#upsell-added-inicart #upsell-offer-price').text().length > 0){
        			$('#MiniShopCartProdPrice_' + $('#orderItemId').val() + '.product_total .priceCart').html($('#upsell-added-inicart #upsell-offer-price').text());
        		}
        		offer_price = $('#upsell-added-inicart #upsell-offer-price').text();
        		list_price = $('#upsell-added-inicart #upsell-list-price').text();
                //hide carousel for new upsell
                hideCarouselRecommend('#minicartYMAL');
        	}
        	
        	//upload PST in minicart
            if((document.cookie.includes('X_WC_PR_SEGMENTS') || isUpsell) && list_price.length > 0){
            	if(parseFloat(list_price.replace( /^\D+/g, '')) != parseFloat(offer_price.replace( /^\D+/g, ''))){
            		$('#minicartPST.price__list')[0].innerText = list_price;
            	}
            	
            	if(isUpsell){
            		$('#upsell-added-inicart').remove();
            	}
            }
        }else{
            if(isUpsell){
                //hide carousel for new upsell
                $('#upsell-added-inicart').remove();
                hideCarouselRecommend('#minicartYMAL');
            }
        }
        //END Early Access

        //Show badge in minicart
        if (isOliver || isPersol){
            if ( $('.minicart-badge .prescription_added').length > 0 || $('.minicart-badge .product_polarized').length > 0) {
                if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                    $(".minicart-badge").show();
                } else $(".minicart-badge.mobile").show();
            }
        }

        //added manifest map in localStorage
        if(localStorage != undefined){
            if(localStorage['manifestMap']!= undefined){ 
                try {
                    var manifestMapMerged = $.extend($.parseJSON(localStorage['manifestMap']),$.parseJSON($("#manifestMap").val()));
                    localStorage.setItem('manifestMap', JSON.stringify(manifestMapMerged));
                }
                catch(e) {
                    localStorage.setItem('manifestMap',$("#manifestMap").val());
                }
            }else{

                localStorage.setItem('manifestMap',$("#manifestMap").val());
            }

            if (isOliver || isPersol) {
                // var upSellPartNumber = $("#upSellPartnumber").val();
                // const upSellPartnumberArray = upSellPartNumber.split(" ").slice(1);
                if (isWishlistPage){
                    replaceImageMinicart($("#cartDropdown .product_image img"));
                } else {
                    replaceImageMinicart($("#cartDropdown .product_image img"), partNumber);
                }
                replaceImageMinicart($("#cartSuggestion .owl-item.active .product_image  img:nth-child(2)"));
                $("#skeleton-minicart").hide();
                $("#cartDropdown .product_image img").eq(0).show();
            }
        
        }

    });
}

function changeHeaderIndex(isOpening){
    isOpening ? $('#header').css('z-index', '1001') :  $('#header').css('z-index', '600')
}
function changeFooterIndex(isOpening){
    isOpening ? $('#footerWrapper').css('z-index', '1002') :  $('#footerWrapper').css('z-index', '600')
}

function hideCarouselRecommend(container){
    switch(container){
      case "#minicartYMAL":
        if(isPersol) $('#widget_minishopcart_popup_1').addClass('disable-carousel');
      default:
        $(container).hide();
      break;
    }
}
function getPreOrderBadge(attributes) {
    var preOrder = null;
    preOrder = attributes.find(x=>(x.identifier == 'PREORDER' && x.usage == 'Descriptive'));
    if(isPreOrderActive && preOrder) {
        var preOrderVal = preOrder.values[0].value ? preOrder.values[0].value.toString().toLowerCase() : null;
        if(preOrderVal && preOrderVal == 'true') {
            return preOrder.identifier;
        }
    }
}


function printBadges(attributes){
    /**
     * OP Badge Hierarchy
     * PremiumMaterials > Exclusive > Pre-release > New > Clip Available
    */
    if(isOliver) {
        var newRelease = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;
        var preRelease = null;
        
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        preRelease = attributes.find(x=>(x.identifier == 'PRE_RELEASE' && x.usage == 'Descriptive')); 
        if(preRelease) {
            var preReleaseVal = preRelease.values[0].value ? preRelease.values[0].value.toString().toLowerCase():null;
            if(preReleaseVal && preReleaseVal =='true')
                return preRelease.name;
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
        clipsAvailable = attributes.find(x=>(x.identifier == 'MATCH_WITH_CLIPS' && x.usage == 'Descriptive'));
        if(clipsAvailable) {
            var clipsAvailableVal = clipsAvailable.values[0].value ? clipsAvailable.values[0].value.toString().toLowerCase() : null;
            if(clipsAvailableVal && clipsAvailableVal =='true')
                return  $('#clipAvailable').val();
        }  
    }
     /**
     * PO Badge Hierarchy
     * Limited Edition > Exclusive > PremiumMaterials > New
    */
    if(isPersol){
        
        var premiumMaterial = null;
        var exclusive = null;
        var newRelease = null;
        var limited = null;
        
       
        limited = attributes.find(x=>(x.identifier == 'LIMITED_EDITION' && x.usage == 'Descriptive'));
        if(limited) {
            var limitedEditionVal = limited.values[0].value ? limited.values[0].value.toString().toLowerCase() : null;
            if( limitedEditionVal && limitedEditionVal == 'true')
                return limited.name;
        }
        exclusive = attributes.find(x=>(x.identifier == 'EXCLUSIVE' && x.usage == 'Descriptive')); 
        if(exclusive){
            var exclusiveVal = exclusive.values[0].value ?  exclusive.values[0].value.toString().toLowerCase() : null;
            if(exclusiveVal && exclusiveVal == 'true')
                return exclusive.name;
        } 
        premiumMaterial = attributes.find(x=>(x.identifier == 'FRAMEMATERIAL_FACET' && x.usage == 'Descriptive'));
        if(premiumMaterial) {
            premiumMaterial = premiumMaterial.values[0].value ? premiumMaterial.values[0].value.toString().toLowerCase(): null;
            if(premiumMaterial && (premiumMaterial === 'horn' || premiumMaterial === 'solid gold' || premiumMaterial === 'gold'))
                return $('#premiumMaterial').val();
        }
        newRelease = attributes.find(x=>(x.identifier == 'NEWRELEASES' && x.usage == 'Descriptive'));
        if(newRelease) {
            var newReleaseVal = newRelease.values[0].value ? newRelease.values[0].value.toString().toLowerCase(): null;
            if(newReleaseVal && (newReleaseVal =='true' || newRelease.values[0].value =='new')){
                if (WCParamJS.countryCode.toUpperCase() != 'DE' && WCParamJS.countryCode.toUpperCase() != 'AT') {
                    return 'New';
                } else {
                    return 'Neu';
                }
            }
        }
    }

    return "";
}

//Begin of EMAIL_ME
function printStatus(product){
    
    if(isEcommerceStoreJS == 'TRUE' && !(typeof product['inventory'] === 'undefined')){
        
        var comingSoon = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'true';
        var soldOut = product['inventory']['ranking'] == '0';
        var comingSoonBack = product['inventory']['ranking'] == '1' && product['inventory']['flComingSoon'] == 'false';
        if(soldOut == false && comingSoonBack == false && comingSoon == false){
            return false; //se non ci sono badge da mostrare ritorna falso ==>serve per il controllo in CatalogENtryList_Oliver/persol_ui.jspf 
        }else{
            return {'SoldOut': SOLD_OUT_STATUS ,
                        'isSoldOut': soldOut , 
                        'Coming': COMING_SOON_STATUS, 
                        'isComing': comingSoon,
                        'ComingSoonBack': COMING_SOON_BACK_STATUS,
                        'isComingSoonBack': comingSoonBack,
                        }
        }
                    
    }   else{
        return false;
    }    
    
}
//End of EMAIL_ME




function getPolarized (attributes,isClass) {
    var polarized = null;
    var isPolar = false;
    if (attributes != undefined) {
        polarized = attributes.find(x=>(x.identifier == 'POLARIZED' && x.usage == 'Descriptive'));
        var polarizedValue = polarized && polarized.values[0].value ? polarized.values[0].value.toString().toLowerCase(): 'false';
        if(polarizedValue == 'true' || polarizedValue == 'yes') {
            polarized = polarized.name;
            if(polarized == null){
                polarized = POLARIZED_TEXT;
            }
            isPolar= true;
        }
        else polarized=null;
    }
    return isClass ? isPolar : polarized;    
}

function getTransitionBadge (attributes,isClass) {
    var transition = null;
    var isTransition = false;

    if (attributes != undefined) {
        transition = attributes.find(x=>(x.identifier == 'TRANSITIONS' && x.usage == 'Descriptive'));
        var transitionValue = transition && transition.values[0].value ? transition.values[0].value.toString().toLowerCase(): 'false';
        if(transitionValue == 'true' || transitionValue == 'yes') {
            transition = transition.name;
            if(transition == null){
                transition = TRANSITION_TEXT;
            }
            isTransition= true;
        }
        else transition=null;
    }
    return isClass ? isTransition : transition;
}


function isPrescription(attributes){
    var isRoxable=false;
    for (var index = 0; index < attributes.length; index++) {
    
           
            if ( attributes[index].identifier == 'IS_ROXABLE') {
                isRoxable = (attributes[index].values[0].value.toLowerCase() == 'yes' || attributes[index].values[0].value.toLowerCase() == 'true');
                break;
            }else{
                isRoxable = false;
            }
        
    }
    return isRoxable;
}



function getElementPosition(idClass) {
    var element = $(idClass);
    var offset = element.offset();

    return {
        'top': offset.top,
        'right': offset.left + element.outerWidth(),
        'bottom': offset.top + element.outerHeight(),
        'left': offset.left,
    };
};
          
function getParameterByName(name) {
    var url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
   };

function replaceImage(picture,typeImg){
        var urlBase_Persol = "https://assets2.persol.com/is/image/";
        var urlBase_Oliver = "https://assets2.oliverpeoples.com/is/image/";
        var urlBaseAccessories_Oliver = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var urlBaseAccessories_Persol = "https://assets.persol.com/extra/image/TargetOptical/accessories/";
        var FOLDER_NAME_Persol = "Persol";
        var FOLDER_NAME_Oliver = "OliverPeoples";
        var SUFFIX_AKAMAI_WS = "_manifest_2.json";
        var FOLDER_ACCESSORIES_IMAGES_PERSOL = "https://assets.persol.com/extra/image/Persol/accessories/";
        var FOLDER_ACCESSORIES_IMAGES_OLIVER = "https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/";
        var productPartNumber;
        if(isOliver){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }else if(isPersol){
            var ymalAkamaiPolicy = '?impolicy=HB_parameters&sclw=0.5&sclh=0.5';
        }
        if (screenWidthPx <= 400) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=400');
        } else if (400 < screenWidthPx && screenWidthPx <= 750) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=800');
        } else if (1200 < screenWidthPx) {
            ymalAkamaiPolicy = ymalAkamaiPolicy.replace('&sclw=0.5&sclh=0.5','&wid=2000');
        }

        //get partnumber and create url for call to manifest
        for(var i = 0; i < picture.length; i++) {
        	if(picture[i].className == 'lazy catalog__image--front'){
        		productPartNumber= picture[i].dataset.partnumber;
        		if(isPersol){
                    var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }else{
                    var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                }
        	}else{
        		for(var j = 0; j < picture[i].childNodes.length; j++){
                    if(picture[i].childNodes[j].nodeName == 'IMG'){
                        productPartNumber= picture[0].childNodes[5].dataset['partnumber'];
                        if(isPersol){
                            var akamaiAPI = urlBase_Persol + FOLDER_NAME_Persol + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }else{
                            var akamaiAPI = urlBase_Oliver + FOLDER_NAME_Oliver + '/' + productPartNumber + SUFFIX_AKAMAI_WS;
                        }                        
                    }
                }
        	}            
        }
        var thumbnail="";
        var hasImage=false;
         //call service (manifest)
        $.ajax({
            url: akamaiAPI,
            dataType: "json",
            success: function(data) {
                //check if there is the required image
                for (var i = 0; i < data.items.length; i++) {
                    var imageFileKey = data.items[i].file_key;
                    if (imageFileKey.includes(typeImg)) {
                        hasImage= true;
                    }
                }

            }, error: function(requestObject, error, errorThrown){
                console.error("error in rest call to manifest",error);
            }, complete: function(){
                if(hasImage){//if it exists  create URL images
                    if(isPersol){
                        thumbnail= baseUrlAkamaiIMPO + classicPathAkamaiIMPO + productPartNumber +"__"+ typeImg+'.png' + ymalAkamaiPolicy;
                    }else{
                        thumbnail = baseUrlAkamaiIMOP + classicPathAkamaiIMOP + productPartNumber +"__"+ typeImg+'.png'+ymalAkamaiPolicy;
                    } 
                }else{ //else put 001 image or 002 image
                        if(isPersol && typeImg == 'STD__shad__fr'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isPersol && typeImg == 'STD__shad__qt'){
                            thumbnail=  window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy); 
                        }else if(isOliver && typeImg == 'STD__shad__fr'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail , ymalAkamaiPolicy);
                        }else if(isOliver && typeImg == 'STD__shad__qt'){
                            thumbnail = window.setQueryParams(catalogEntryDetails.thumbnail2 , ymalAkamaiPolicy);
                        }      
                }
                //replace picture srcset
                for(var g = 0; g < picture.length; g++) {
                	if(picture[g].className == 'lazy catalog__image--front'){
                		thumbnail = thumbnail.split('=')[0] + '=HB_parameters_transp&wid=720&cropnorth=-9&cropsouth=-9';
                		picture[g].dataset["srcset"]= thumbnail;
                	}else{
                		for(var j = 0; j < picture[g].childNodes.length; j++){
                            if(picture[g].childNodes[j].nodeName == "SOURCE"){
                               picture[g].childNodes[j].dataset["srcset"]= thumbnail;
                            }
                        }
                	}
                }
            }
        });
}

function replaceTileImgByDevice(url,pattern,tileType) {
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    if (typeof url == 'string') {
        var screenWidthPx = Math.round(window.innerWidth*window.devicePixelRatio);
        if (screenWidthPx < 400/* mobile */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=400');
            }
        } else if (400 < screenWidthPx && screenWidthPx <= 750/* tablet */) {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=375');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=500');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=100');
            }
        } else if (750 < screenWidthPx && screenWidthPx <= 1200/* desktop 1x */) {
            if (tileType == 'small') {
                if(isWishlistPage){
                    return url.replace(pattern,'wid=800');
                }else{
                    return url.replace(pattern,'wid=400');
                } 
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=150');
            }
        } else if (1200 < screenWidthPx)/* desktop 2x */ {
            if (tileType == 'small') {
                return url.replace(pattern,'wid=800');
            } else if (tileType == 'big') {
                return url.replace(pattern,'wid=1600');
            } else if (tileType == 'lowerCarousel') {
                return url.replace(pattern,'wid=300');
            }
        }
    }
    return url;
}

function removeIOSRubberEffect( element ) {
	element.addEventListener( "touchstart", function () {
		var top = element.scrollTop, totalScroll = element.scrollHeight, currentScroll = top + element.offsetHeight;
		if ( top === 0 ) {
			element.scrollTop = 1;
		} else if ( currentScroll === totalScroll ) {
			element.scrollTop = top - 1;
		}
	} );
}

function handleSwipeBounce(){
    var startX = 0, startY = 0;

    $('.owl-wrapper').on( "touchstart", function(e){
            e=(e.touches)?e.touches[0]:e;//e.touches[0] is for ios
            startX = e.clientX;
            startY = e.clientY; 
    } );

    $('.owl-wrapper').on( "touchmove", function(event){
        var e=(event.touches)?event.touches[0]:event;//e.touches[0] is for ios
        var deltaX = Math.abs(e.clientX - startX);
        var deltaY = Math.abs(e.clientY - startY);

        if(deltaX > deltaY) {
          event.preventDefault();
        }
    });

    $('.owl-item').on( "touchend", function(e){ 
        if (isOliver) {
            $('body').css('overflow', 'auto'); 
        }
    });
}

function disableScrollingByClass() {
    document.ontouchmove = function ( event ) {

        var isTouchMoveAllowed = true, target = event.target;
    
        while ( target !== null ) {
            if ( target.classList && target.classList.contains( 'disable-scrolling' ) ) {
                isTouchMoveAllowed = false;
                break;
            }
            target = target.parentNode;
        }
    
        if ( !isTouchMoveAllowed ) {
            event.preventDefault();
        }
    
    };
}

function manageScrollOverlay(isOpen){
    /*
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        if (isOpen) {
            if (myPane !== undefined){
                myPane.disableDrag();
                bodyScrollLock.enableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").hide();
        } else {
            if (myPane !== undefined) {
                myPane.enableDrag();
                bodyScrollLock.disableBodyScroll(document.querySelector('#draggable-cta-section'));
            }
            $("#fixed-top--mobile").show();
        }
    }
    */
}
/** jQuery Get Browser Plugin
 * @version: 1.01
 * @author: Pablo E. Fernández (islavisual@gmail.com).
 * Copyright 2016-2018 Islavisual. 
 * Licensed under MIT (https://github.com/islavisual/getBrowser/blob/master/LICENSE). 
 * Last update: 07/02/2018
 **/
 !function(e){e.extend({browser:function(){var e,r=navigator.userAgent,t=r.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i)||[];/trident/i.test(t[1])&&(e=/\brv[ :]+(\d+)/g.exec(r)||[],t[1]="Internet Explorer",t[2]=e[1]),"Chrome"===t[1]&&(e=r.match(/\b(OPR|Edge)\/(\d+)/),t[1]=null!=e?e.slice(1).join(" ").replace("OPR","Opera"):"Chrome"),t=t[2]?[t[1],t[2]]:[navigator.appName,navigator.appVersion,"-?"],null!=(e=r.match(/version\/(\d+)/i))&&t.splice(1,1,e[1]);var o=/firefox/.test(navigator.userAgent.toLowerCase())&&!/webkit    /.test(navigator.userAgent.toLowerCase()),a=/webkit/.test(navigator.userAgent.toLowerCase()),s=/opera/.test(navigator.userAgent.toLowerCase()),n=/edge/.test(navigator.userAgent.toLowerCase())||/msie/.test(navigator.userAgent.toLowerCase())||/msie (\d+\.\d+);/.test(navigator.userAgent.toLowerCase())||/trident.*rv[ :]*(\d+\.\d+)/.test(navigator.userAgent.toLowerCase()),i=n?"":a?"-webkit-":o?"-moz-":"";return{name:t[0],version:t[1],firefox:o,opera:s,msie:n,chrome:a,prefix:i}}}),jQuery.browser=e.browser()}(jQuery);

 /** Handle multiple promises */
 function all(array,promises) {
     var deferred = $.Deferred();
     var fulfilled = 0, length = array.length;
     var results = [];
     if (length === 0) {
         deferred.resolve(results);
     } else {
             for (var index=0; index<array.length; index++) {
            	 
            	 (function (index) {
            		 var upc = array[index];
                     promises[upc].then(function(response){
                       results[index] = response;
                       fulfilled++;
                       if (fulfilled === length) {
                           deferred.resolve(results);
                       }
                     });
            	 }(index));
                 
           }
     }
     return deferred.promise();
 };
 
 /** getScript with cache */
 jQuery.cachedScript = function(url,options) {
   // Allow user to set any option except for dataType, cache, and url
   options = $.extend(options || {},{
     dataType: "script",
     cache: true,
     url: url
   });
   // Use $.ajax() since it is more flexible than $.getScript
   // Return the jqXHR object so we can chain callbacks
   return jQuery.ajax(options);
 };
 
//left: 37, up: 38, right: 39, down: 40,
//spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {37: 1, 38: 1, 39: 1, 40: 1};

function preventDefault(e) {
	e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
	if (keys[e.keyCode]) {
	  preventDefault(e);
	  return false;
	}
}

//modern Chrome requires { passive: false } when adding event
var supportsPassive = false;
try {
window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
	get: function () { supportsPassive = true; } 
}));
} catch(e) {}

var wheelOpt = supportsPassive ? { passive: false } : false;
var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

//call this to Disable
function disableScroll() {
	window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
	window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
	window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
	window.addEventListener('keydown', preventDefaultForScrollKeys, false);
}

//call this to Enable
function enableScroll() {
	window.removeEventListener('DOMMouseScroll', preventDefault, false);
	window.removeEventListener(wheelEvent, preventDefault, wheelOpt); 
	window.removeEventListener('touchmove', preventDefault, wheelOpt);
	window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
}

function capitalizeEachWord(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
    }
    // Directly return the joined string
    return splitStr.join(' '); 
 }



function iOSversion() {
	if (/iP(hone|od|ad)/.test(navigator.platform)) {
		// supports iOS 2.0 and later: <http://bit.ly/TJjs1V>
	    var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
	    return parseInt(v[1], 10);
	}
}
/**
 * Check if we are in Chrome on an iOS device
 * becase function isSafari returns true even when we are in chrome
 * @returns true if is chrome on iOS, false otherwise
 */
function isChromeOnIOS() { 
    return navigator.userAgent.indexOf('CriOS') >= 0;
}

 
/* START Early Access */

function getPriceByCustomerSegment(priceObj) {
    if (isPersol || isVogue){
        //  Check User Customer Segment using cookie
        if (document.cookie.includes("X_WC_PR_SEGMENTS") && window.customerSegment != undefined){
            //  Get price for my customer segment
            if (priceObj["price_"+window.customerSegment] != undefined && priceObj["price_"+window.customerSegment] != ""){
                price = priceObj["price_"+window.customerSegment];
            } else price = priceObj.price;
        } else price = priceObj.price;
    } else if (isOliver){
        price = priceObj.price;
    }
    return price; //  Return price
}

function returnLastOfferPrice() {
    var lastOfferPrice;
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;
    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
  
    if (!isWishlistPage) {
      if(productParent[0]){
        if ((window.mobilecheck() || window.tabletPortraitCheck()) && !isPersol){
            lastOfferPrice = document.querySelectorAll('#offerPrice_'+productParent[0])[1].innerText;
        } else if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerHTML;
        }else if(isVogue){
        	lastOfferPrice = document.getElementsByClassName('offerPrice_'+productParent[0]).innerHTML;
        }else{
          lastOfferPrice = document.getElementById('offerPrice_'+productParent[0]).innerText;
        }
      }
    } else {
      lastOfferPrice = document.getElementById('offerPrice_'+ minicartAddedId).innerText;
    }

    return lastOfferPrice;
}

/* END Early Access */

//checkout 3.0

function goToOrderPaymentViewOnClickHandler(event){
    
    form1 = document.forms['shippingAddressCreateEditFormDiv_1'];
    form2 = document.forms['billingAddressCreateEditFormDiv_1'];
    /*if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup'){
    	form3 = document.forms['recipient_detail']; //form for PickUpInStore
    }*/ 
    var sameaddressCheckbox = document.getElementById("SameShippingAndBillingAddress");
    if(AddressHelper.zipCodeNotFound){
    	var stateDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1');
    	var stateHiddenDiv = document.getElementById('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_state_1_hidden');
    	if(stateDiv != null && stateDiv.value != "") {
    		stateHiddenDiv.value = stateDiv.value;
    	} 
    }

    console.log("PSL::UnregisteredCheckout.jsp::addressId_formS_"+storeDirectory+"::"+addressId_formS);
    console.log("PSL::UnregisteredCheckout.jsp::addressId_formB_"+storeDirectory+"::"+addressId_formB);
    
    AddressBookFormJS.checkAddressCopyAndCopyIfNeeded('shippingAddressCreateEditFormDiv_1','billingAddressCreateEditFormDiv_1',countryCode);
    
    //START CODE BOSS
    //if((!($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'pickup') && isOliver) || isPersol){
    	//form2.email1.value=form1.email1.value;
    let isFormNoError = AddressHelper.validateEmail('WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_email1_1"/>');
    /*}else{
    	form2.email1.value=form3.email1.value;
      	AddressHelper.validateEmail('recipient_detail__email1"/>');
    } */  
    //END CODE BOSS
    var formValidationError = false;
    
    if(AddressHelper.zipCodeNotFound){
    	  AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);

          //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
          //calling the rest service. If success then address exist else address does not exist.
          var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
          $.ajax({
              method: "GET",
              url: url,
              headers: {
                  "Content-Type": "application/json",
                  "Cache-Control": "no-cache, no-store, must-revalidate"
              },
              dataType: "json",
              success:function(data, textStatus, jqXHR){
            	  var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		          }
                  if(addressValidate){
                	  if (typeof data.contact === 'undefined'){
                          plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
                          AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
                      } else {
                          for (var i = 0; i<data.contact.length; i++){
                              if (data.contact[i].nickName == 'MyAddress_Shipping'){
                                  plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
                                  AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
                                  break;
                              }
                          }
                      }
                      /* START - OP BOSS */
                      if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
                    }
                    /* END - OP BOSS */  
                  }else{
                	  restoreAjaxButtons();
                  }
              },
              error:function(jqXHR, exception){
                  plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
              }
          });
    }
    else {
        
        if(AddressHelper.validateAddressForm(form1)) {
            //if(isFormNoError)//isFormNoError check if one of th input field in checkoutform is with error in this case if email is with error with need to send error to analytics 
                isFormNoError = true;
		    getGoogleAddressPromise(countryCode, form1.zipCode.value, storeLanguage)
		        .then(function(data){
		            var addressObj = convertGoogleAddressResponse(data);
		            if (addressObj.status != "success"){
		                formValidationError = true;
		                throw "zipCode " + form1.zipCode.value + " not valid for country "+countryCode;
		            } else {
		            	var city = document.getElementById("WC__ShoppingCartAddressEntryForm_shippingAddressCreateEditFormDiv_1_city_1").value;
		            	var addObjCity= addressObj["address"]["city"];
		            	if(city != addObjCity){
		            		addressObj["address"]["city"]= city;
		            		addressObj["address"]["locality"] = city;
		            	}
		                AddressHelper.fillFormAddressFromAddressDataObject(form1, addressObj);
		            }
		        })
		        .then(function(data){
		            return getTaxesFromZipCodePromise(form1);
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                return getGoogleAddressPromise(countryCode, form2.zipCode.value, storeLanguage)
		            }
		        })
		        .then(function(data){
		            if (!sameaddressCheckbox.checked){
		                var addressObj = convertGoogleAddressResponse(data);
		                if (addressObj.status != "success"){
		                    formValidationError = true;
		                    throw "zipCode " + form2.zipCode.value + " not valid for country " + countryCode;
		                } else {
		                    AddressHelper.fillFormAddressFromAddressDataObject(form2, addressObj);
		                }
		            }
		
		            return getUserAddressListPromise();
		        })
		        .then(
		            function(data){
		                if (typeof data.contact !== 'undefined'){
		                    for (var i = 0; i<data.contact.length; i++){
		                        if (data.contact[i].nickName == 'MyAddress_Shipping' || data.contact[i].nickName == 'MyAddress_Billing'){
		                            AddressHelper.updateAddressCookies(data.contact[i].addressId, data.contact[i].addressType);
		                            plog("CommonUtilities.js::goToOrderPaymentsViewOnClickHandler::"+ data.contact[i].nickName +" found: shippingAddressId: " + data.contact[i].addressId +", shippingAddressType: " + data.contact[i].addressType);
		                        }
		                    }
		                }
		            }, function(err){
		                console.log(err);
		            })
		        .then(function(){
		            if (!AddressHelper.validateAddressForm(form1)){
		                formValidationError = true;
		            }
		            if (!sameaddressCheckbox.checked){
		                if (!AddressHelper.validateAddressForm(form2)){
		                    formValidationError = true;
		                }
		            }
		            if (formValidationError){
		                restoreAjaxButtons();
		                console.log("UnregisteredCheckout.jsp::Form validation error");
		                return;
		            }
		            
		            var addressValidate = true;
		        	if($('#addressValidationActive').val() == 'true'){
		        		if($('#addressValidationFirstTime').val() == 'true'){
		        			addressValidate = callAddressValidation( $('#shippingAddressCreateEditFormDiv_1 [name="address1"]').val(),  $('#shippingAddressCreateEditFormDiv_1 [name="zipCode"]').val());	
		        		}
		        	}
		        	
		        	if(addressValidate){
			            AddressHelper.joinNewsletter('shippingAddressCreateEditFormDiv_1', WCParamJS.langId, WCParamJS.storeId);
	
			            //Extra verification: If the cookie does not exist, verify if MyAddress_Shipping exists
			            //calling the rest service. If success then address exist else address does not exist.
			            var url = "/wcs/resources/store/" + WCParamJS.storeId + "/person/@self/contact";
			            $.ajax({
			                method: "GET",
			                url: url,
			                headers: {
			                    "Content-Type": "application/json",
			                    "Cache-Control": "no-cache, no-store, must-revalidate"
			                },
			                dataType: "json",
			                success:function(data, textStatus, jqXHR){
			                    if (typeof data.contact === 'undefined'){
			                        plog("AddressHelper.js::initAddressCookies::Shipping address not found. Saving...");
			                        AddressHelper.saveUnregisteredCheckoutAddress('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', 'stateDiv2', 'stateDiv1');
			                    } else {
			                        for (var i = 0; i<data.contact.length; i++){
			                            if (data.contact[i].nickName == 'MyAddress_Shipping'){
			                                plog("AddressHelper.js::initAddressCookies::Shipping address found. Updating...");
			                                AddressHelper.updateUnregisteredCheckoutAddressAndGoPaymentStep('shippingAddressCreateEditFormDiv_1', 'billingAddressCreateEditFormDiv_1', addressId_formS, addressId_formB, sameaddressCheckbox.checked, orderShippingBillingViewURL);
			                                break;
			                            }
			                        }
			                    }
			                },
			                error:function(jqXHR, exception){
			                    plog("AddressHelper.js::initAddressCookies::Error retrieving user addresses");
			                }
			            });
			
			            moveToError();
		        	}else{
		        		restoreAjaxButtons();
		        	}
		        }).then(function(){
                    if (isOliver) {
                        if($('div[shipmodecode="ShipToStore"]').length > 0){
                            var url = null;
                            if($('input[name=singleShipmentShippingMode]:checked').attr('shipmodecode') === 'ShipToStore'){
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/pushInfo?orderId=" + $checkoutObj.cartData.orderId + "&storeCode=" + storeCode + "&storeName=" + storeName + "&storePhone=" + storePhone + "&storeEmail=" + storeEmail + "&storeHours=" + JSON.stringify(storeHours) + "&storeDirections="  +  encodeURIComponent(storeDirection);
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }else{
                                url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/orders/bossOrder/deleteInfo?orderId=" + $checkoutObj.cartData.orderId;
                                $.ajax({
                                    url: url,
                                    type: 'POST',
                                    success: function (data) {
                                        console.log(data);
                                    },
                                    error: function (xhr, ajaxOptions, thrownError) {
                                        console.log(data);
                                    }
                                });
                            }
                        }
		            }
		        })
        }else{
            isFormNoError = false;
        }
       // }
    }
    
    //BEGIN SMS NOTIFICATION 
    AddressHelper.joinSMS();
    //END SMS
    
    if(!isFormNoError)
        //ERROR IN SHIPPING FORM 
        newTealiumPushFormError('Shipping address','Please provide a valid city,zip code, etc');   
}

function parseStoreHours(storeHours){
	var weekDays = getWeekDays(locale.replace('_','-'));
	var hourString = titleCase(weekDays[0]);
	var existAnotherWithTheSameHours = '';
	//we start from second day
	for(var i = 1; i < storeHours.length; i++){
		if(storeHours[i].opening === storeHours[i-1].opening && storeHours[i].closing === storeHours[i-1].closing){
			if (existAnotherWithTheSameHours == ''){
				existAnotherWithTheSameHours = ' - ';
			}
		}else{
			if(storeHours[i-1].isClosed){
				if(i == 1){
					hourString = hourString + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + $('#textClosed').attr('value') + ' | ' + titleCase(weekDays[i]);	
				}
			}else{
				if(i == 1){
					hourString = hourString + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);
				}else{
					hourString = hourString + existAnotherWithTheSameHours +  titleCase(weekDays[i - 1]) + ': ' + storeHours[i-1].opening + ' - ' + storeHours[i-1].closing +  ' | ' + titleCase(weekDays[i]);	
				}
			}
			existAnotherWithTheSameHours =  '';
		}
	}
	
	if( existAnotherWithTheSameHours == '' ){
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}else{
		if(storeHours[storeHours.length-1].isClosed){
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) + ': ' + $('#textClosed').attr('value');
		}else{
			hourString = hourString + existAnotherWithTheSameHours + titleCase(weekDays[weekDays.length-1]) +  ': ' + storeHours[storeHours.length-1].opening + ' - ' + storeHours[storeHours.length-1].closing;
		}
	}
	return hourString.replaceAll('"','');
}

function titleCase(string){
	return string[0].toUpperCase() + string.slice(1).toLowerCase();
}

function getWeekDays(locale){
    var baseDate = new Date(Date.UTC(2017, 0, 2)); // just a Monday
    var weekDays = [];
    for(i = 0; i < 7; i++){       
        weekDays.push(baseDate.toLocaleDateString(locale, { weekday: 'long' }));
        baseDate.setDate(baseDate.getDate() + 1);       
    }

    //HB-9317. This fix is related to common weeksdays order in America. In USA , Sunday is considered the first day of week. This 
    // caused a strange parsing in storeHours. We have aligne the weekdays orders to the classic one.
    if(locale=='en-US' && weekDays[0]=='Sunday'){
        weekDays = ["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"];
    }
    return weekDays;
}


function iPhoneVersion() {
	  var iHeight = window.screen.height;
	  var iWidth = window.screen.width;

	  
	  if (iWidth === 390 && iHeight === 844) {
		    return "12-13";
	  }
	  
	  if (iWidth === 414 && iHeight === 896) {
		    return "11";
	  }

	  if (iWidth === 414 && iHeight === 896) {
	    return "Xmax-Xr";
	  }
	  else if (iWidth === 375 && iHeight === 812) {
	    return "X-Xs";
	  }
	  else if (iWidth === 320 && iHeight === 480) {
	    return "4";
	  }
	  else if (iWidth === 375 && iHeight === 667) {
	    return "6-7";
	  }
	  else if (iWidth === 414 && iHeight === 736) {
	    return "6+";
	  }
	  else if (iWidth === 320 && iHeight === 568) {
	    return "5";
	  }
	  else if (iHeight <= 480) {
	    return "2-3";
	  }
	  return 'none';
	}



//checkout 3.0

/* START - Online Return Form */

function cleanCartForShipOrder(isReturnForm = false,callback) {
    if(personInfo.userId !== '-1002') {
        
        var url = '/wcs/resources/store/' + WCParamJS.storeId + '/cart/@self';
        function deleteCart(url,callback) {
            $.ajax({
                url: url,
                type: 'DELETE',
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache, no-store, must-revalidate"
                },
                dataType: "json",
                data: [],
                success: function (response, textStatus, request) {
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                },
                error: function(response){
                    if (typeof callback != 'undefined') {
                        callback(response);
                    }
                }
            });
        }

        if (isReturnForm) {
            //  When Return Form, simply delete the cart
            deleteCart(url,callback);
        } else {
            //  When in classic cart, delete the cart after checking it is a Ship Order
            getAjaxCallInfo(url, null, function(response) {
                let isShipOrder = false;
                if (response.orderItem !== undefined) {
                    response.orderItem.forEach(function(item) {
                        if (item.partNumber == 'RETURN_SHIPPING_CHARGE_SKU') {
                            isShipOrder = true;
                        }
                    });
                }
                if (isShipOrder) {
                    deleteCart(url,callback);
                }
            });
        }

    }
}

/* END - Online Return Form */

function checkPasswordStrenght(passwordField) {
    var password = passwordField.value;
    const conditionThreshold = 5;
    var sumConditions = 0;
    if(RegExp('(?=.{8,})').test(password)) { //at least 8 characters long
        $('#password_length').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_length').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[A-Z])').test(password)) {//at least one uppercase letter
        $('#password_uppercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_uppercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[a-z])').test(password)) { //at least one lowercase letter
        $('#password_lowercase').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_lowercase').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('(?=.*[0-9])').test(password)) { //at least one digit 
        $('#password_number').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_number').attr("checked",false);
        sumConditions--;
    }

    if(RegExp('([^A-Za-z0-9])').test(password)) { //at least one special character
        $('#password_special').attr("checked",true);
        sumConditions++;
    }
    else {
        $('#password_special').attr("checked",false);
        sumConditions--;
    }
    console.log(sumConditions==conditionThreshold);
    return sumConditions==conditionThreshold;
}

function checkPasswordFieldAndSubmit(form) {
	
	if(form.validationCode.value == ''){
		$('.password-policies-title').addClass('hidden');
		$('#validationCodeError').removeClass('hidden');
	}else{
	 if(checkPasswordStrenght(form.logonPassword)){
	        $('.password-policies-title').removeClass('hidden');
	        $('.password-policies-title-error').addClass('hidden');
	        $('[name="logonPassword"').removeClass('error');
	        submitSpecifiedForm(form);
	    }
		else {
			$('.password-policies-title').addClass('hidden');
	        $('.password-policies-title-error').removeClass('hidden');
	        $('[name="logonPassword"').addClass('error')
		}
	}
   
}

function openPasswordPolicyDiv() {
    $('.password-policies-container').show();
    $('.input-style--password').addClass('passPolicyOpen'); //Persol
}


/*Check specific browser version*/
navigator.sayswho= (function(){
    var N= navigator.appName, ua= navigator.userAgent, tem;
    var M= ua.match(/(opera|chrome|safari|firefox|msie)\/?\s*(\.?\d+(\.\d+)*)/i);
    if(M && (tem= ua.match(/version\/([\.\d]+)/i))!= null) M[2]= tem[1];
    M= M? [M[1], M[2]]: [N, navigator.appVersion,'-?'];
    return M;
})();

function getAttributeValue(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].value : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}

function getAttributeIdentifier(attributes,identifier) {
    var val = attributes.map(function(attribute) {
        return (attribute.identifier === identifier) ? attribute.values[0].identifier : null;
    }).filter((value) => { return value != null })[0];
    //console.log('getAttributeValue: ' + identifier + ' = ' + val);
    return typeof val != 'undefined' ? val : '';
}
function getConvertedDistance(distance) {
    //var inchMeasure = 25.4;
	var cleanNumber = "";
	
	if(typeof distance != 'undefined'){
		cleanNumber = distance.replace(/\D/g,'');
	}
    return '('+ cleanNumber + ' mm)';
}

function showKlarnaPlacements(){
    $('.pdp .klarna-mess-pdp').show();
    $('.pdp .klarna-minicart, .wishListDisplay .klarna-minicart').show();
    $('.minicart-klarna').show();
    $(".checkout__klarna").show();
    $('#vat_klarna:not(#cartSuggestion .content .espot-complete-order-upsell #vat_klarna)').show();
}

async function sha256(message) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
}

//Resolve promise for sha256
function getSha256Promise(message) {
    const result = sha256(message);
    return result instanceof Promise ? result : Promise.resolve(result);
}

//Return FALSE if VARIABLE DOESN'T CONTAINS VALUE; Return TRUE if VARIABLE CONTAINS VALUE;
function checkIsNull(variable){
    if(typeof(variable)!='undefined' &&  variable != '' && variable != null)
        return false;
    else
        return true;
}

window.addEventListener('load', (event) => {
    if (typeof fn_FrameAdvisor === 'function') {
        fn_FrameAdvisor();
    }
});


//CRM Banner - this function opens up promo popups with a promocode in cart on PO and VO
function fn_CartPromoCode(promoCode,copyPromoCode) {
    if (isPersol || isVogue){    
        if (typeof promoCode !== 'undefined' && typeof copyPromoCode !== 'undefined' ||
        promoCode != "" && copyPromoCode != "") {
        	window.isCRMPromo = true;
        	if(isVogue){
        		if($('#promoCodeCRM').length < 1){
        			$('#headerWidget').append('<input type="hidden" id="promoCodeCRM" name="promoCodeCRM" value="' + promoCode +'" autocomplete="off">');
        		}
        		if($('#copyPromoCodeCRM').length < 1){
        			$('#headerWidget').append("<input type='hidden' id='copyPromoCodeCRM' name='copyPromoCodeCRM' value='"+ copyPromoCode.replaceAll("'", '"') +"' autocomplete='off'>");
        		}
        		promoCode = $('#promoCodeCRM').val();
        		copyPromoCode = $('#copyPromoCodeCRM').val();
        	}
            $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
            $(".cart-crm-banner .promo-description").html(copyPromoCode);

            if (isVogue) {
                $("#cart-crm-promocode-box-banner .use-promocode-container").off("click").on("click", function(){
                    if ($("#promo-form-title.dropdown").hasClass("opend")){
                        $("#promo-form-title.dropdown").removeClass("opend");
                    }else{
                        $('#promo-form-title.dropdown').removeClass("opend");
                        $("#promo-form-title.dropdown").addClass("opend");
                    }
                });

                if ((window.mobilecheck() || window.tabletPortraitCheck())) {
                    $("#promo-form-title.dropdown").addClass("available-promocode");
                }

                CRMRemovePromoCode();
            }

            if (isPersol) {
                $("#cart-crm-promo-banner").addClass("showed").removeClass("hidden");
                $("#promotions .wrapperPromotions .promotion-code__label").addClass("available-promocode");

                $(".promotion-code__label.available-promocode, .use-promocode-container").on("click", function(){
                    $(".promocode-box-reminder .apply-promocode-cta").on("click", function(event){
                        event.stopPropagation();
                    });
                    if(isVogue){
                    	if ($("#promotion-code__input").is(":checked")){
                            $(".promotion-code__label.available-promocode").addClass("expanded");
                        } else {
                            $(".promotion-code__label.available-promocode").removeClass("expanded");
                        }
                    }else{
                    	if ($("#promotion-code__input").is(":checked")){
                    		$(".promotion-code__label.available-promocode").removeClass("expanded");
                        } else {
                        	$(".promotion-code__label.available-promocode").addClass("expanded");
                        }
                    }
                    
                });
            }

            $('.cart-crm-banner .apply-promocode-cta').off('click').on('click', function(){
                if (isPersol) {
                    if ($("input#promoCode").val() == "") {
                        $("input#promoCode").val(promoCode.toString());
                        $(".promocode-button-wrapper button").click();
                    }
                } else if (isVogue) {
                    if ($("input#coupon-value").val() == "") {
                        $("input#coupon-value").val(promoCode.toString());
                        $(".promotion_button button").click();
                    }
                }

            });
        } else {
            window.isCRMPromo = false;
        }
    }
}

function CRMRemovePromoCode (){
    if ($("#isPromocodeApplied").val() == 'true') {
        $("#cart-crm-promocode-box-banner").addClass("hidden").removeClass("showed");
        $(".visibleOrderDiscount td").css("color", "#000");
        $("#appliedPromotionCodes").hide();
        $("#CRMappliedPromotionCodes").show();
        $(".removePromotionLink").hide();
        $(".CRMremovePromotionLink").css("display","flex");
        if (!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("#PromotionCodeForm").css("padding-bottom", "16px");
        } else {
            $("#promo-form-title").css("border-bottom", "none");
        }
    } else {
        $("#cart-crm-promocode-box-banner").addClass("showed").removeClass("hidden");
        $("#CRMappliedPromotionCodes").hide();
    }
}

//retrive all parameters from url
function getAllUrlParams() {
	var queryString = window.location.href.split('?')[1];
	var obj = {};

    if (queryString) {
        queryString = queryString.split('#')[0];
        var arr = queryString.split('&');

        for (var i = 0; i < arr.length; i++) {
            var a = arr[i].split('=');

            var paramName = a[0];
            var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

            paramName = paramName.toLowerCase();
            if (typeof paramValue === 'string') paramValue = paramValue.toLowerCase();

            if (paramName.match(/\[(\d+)?\]$/)) {
                var key = paramName.replace(/\[(\d+)?\]/, '');
                if (!obj[key]) obj[key] = [];

                if (paramName.match(/\[\d+\]$/)) {
                    var index = /\[(\d+)\]/.exec(paramName)[1];
                    obj[key][index] = paramValue;
                } else {
                    obj[key].push(paramValue);
                }
            } else {
                if (!obj[paramName]) {
                    obj[paramName] = paramValue;
                } else if (obj[paramName] && typeof obj[paramName] === 'string') {
                    obj[paramName] = [obj[paramName]];
                    obj[paramName].push(paramValue);
                } else {
                    obj[paramName].push(paramValue);
                }
            }
        }
    }

    return obj;
}


!function(e,o){if("function"==typeof define&&define.amd)define(["exports"],o);else if("undefined"!=typeof exports)o(exports);else{var t={};o(t),e.bodyScrollLock=t}}(this,function(exports){"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var t=!1;if("undefined"!=typeof window){var e={get passive(){t=!0}};window.addEventListener("testPassive",null,e),window.removeEventListener("testPassive",null,e)}function l(o){return c.some(function(e){return!(!e.options.allowTouchMove||!e.options.allowTouchMove(o))})}function d(e){var o=e||window.event;return!!l(o.target)||(1<o.touches.length||(o.preventDefault&&o.preventDefault(),!1))}function n(){void 0!==v&&(document.body.style.paddingRight=v,v=void 0),void 0!==s&&(document.body.style.overflow=s,s=void 0)}var i="undefined"!=typeof window&&window.navigator&&window.navigator.platform&&(/iP(ad|hone|od)/.test(window.navigator.platform)||"MacIntel"===window.navigator.platform&&1<window.navigator.maxTouchPoints),c=[],a=!1,u=-1,s=void 0,v=void 0;exports.disableBodyScroll=function(r,e){if(r){if(!c.some(function(e){return e.targetElement===r})){var o={targetElement:r,options:e||{}};c=[].concat(function(e){if(Array.isArray(e)){for(var o=0,t=Array(e.length);o<e.length;o++)t[o]=e[o];return t}return Array.from(e)}(c),[o]),i?(r.ontouchstart=function(e){1===e.targetTouches.length&&(u=e.targetTouches[0].clientY)},r.ontouchmove=function(e){var o,t,n,i;1===e.targetTouches.length&&(t=r,i=(o=e).targetTouches[0].clientY-u,l(o.target)||(t&&0===t.scrollTop&&0<i||(n=t)&&n.scrollHeight-n.scrollTop<=n.clientHeight&&i<0?d(o):o.stopPropagation()))},a||(document.addEventListener("touchmove",d,t?{passive:!1}:void 0),a=!0)):function(e){if(void 0===v){var o=!!e&&!0===e.reserveScrollBarGap,t=window.innerWidth-document.documentElement.clientWidth;o&&0<t&&(v=document.body.style.paddingRight,document.body.style.paddingRight=t+"px")}void 0===s&&(s=document.body.style.overflow,document.body.style.overflow="hidden")}(e)}}else console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.")},exports.clearAllBodyScrollLocks=function(){i?(c.forEach(function(e){e.targetElement.ontouchstart=null,e.targetElement.ontouchmove=null}),a&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1),u=-1):n(),c=[]},exports.enableBodyScroll=function(o){o?(c=c.filter(function(e){return e.targetElement!==o}),i?(o.ontouchstart=null,o.ontouchmove=null,a&&0===c.length&&(document.removeEventListener("touchmove",d,t?{passive:!1}:void 0),a=!1)):c.length||n()):console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.")}});

/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 3.5.5
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;"undefined"!=typeof window?e=window:"undefined"!=typeof global?e=global:"undefined"!=typeof self&&(e=self),e.Promise=t()}}(function(){var t,e,n;return function r(t,e,n){function i(s,a){if(!e[s]){if(!t[s]){var c="function"==typeof _dereq_&&_dereq_;if(!a&&c)return c(s,!0);if(o)return o(s,!0);var l=new Error("Cannot find module '"+s+"'");throw l.code="MODULE_NOT_FOUND",l}var u=e[s]={exports:{}};t[s][0].call(u.exports,function(e){var n=t[s][1][e];return i(n?n:e)},u,u.exports,r,t,e,n)}return e[s].exports}for(var o="function"==typeof _dereq_&&_dereq_,s=0;s<n.length;s++)i(n[s]);return i}({1:[function(t,e,n){"use strict";e.exports=function(t){function e(t){var e=new n(t),r=e.promise();return e.setHowMany(1),e.setUnwrap(),e.init(),r}var n=t._SomePromiseArray;t.any=function(t){return e(t)},t.prototype.any=function(){return e(this)}}},{}],2:[function(t,e,n){"use strict";function r(){this._customScheduler=!1,this._isTickUsed=!1,this._lateQueue=new h(16),this._normalQueue=new h(16),this._haveDrainedQueues=!1,this._trampolineEnabled=!0;var t=this;this.drainQueues=function(){t._drainQueues()},this._schedule=p}function i(t,e,n){this._lateQueue.push(t,e,n),this._queueTick()}function o(t,e,n){this._normalQueue.push(t,e,n),this._queueTick()}function s(t){this._normalQueue._pushOne(t),this._queueTick()}function a(t){for(;t.length()>0;)c(t)}function c(t){var e=t.shift();if("function"!=typeof e)e._settlePromises();else{var n=t.shift(),r=t.shift();e.call(n,r)}}var l;try{throw new Error}catch(u){l=u}var p=t("./schedule"),h=t("./queue"),f=t("./util");r.prototype.setScheduler=function(t){var e=this._schedule;return this._schedule=t,this._customScheduler=!0,e},r.prototype.hasCustomScheduler=function(){return this._customScheduler},r.prototype.enableTrampoline=function(){this._trampolineEnabled=!0},r.prototype.disableTrampolineIfNecessary=function(){f.hasDevTools&&(this._trampolineEnabled=!1)},r.prototype.haveItemsQueued=function(){return this._isTickUsed||this._haveDrainedQueues},r.prototype.fatalError=function(t,e){e?(process.stderr.write("Fatal "+(t instanceof Error?t.stack:t)+"\n"),process.exit(2)):this.throwLater(t)},r.prototype.throwLater=function(t,e){if(1===arguments.length&&(e=t,t=function(){throw e}),"undefined"!=typeof setTimeout)setTimeout(function(){t(e)},0);else try{this._schedule(function(){t(e)})}catch(n){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")}},f.hasDevTools?(r.prototype.invokeLater=function(t,e,n){this._trampolineEnabled?i.call(this,t,e,n):this._schedule(function(){setTimeout(function(){t.call(e,n)},100)})},r.prototype.invoke=function(t,e,n){this._trampolineEnabled?o.call(this,t,e,n):this._schedule(function(){t.call(e,n)})},r.prototype.settlePromises=function(t){this._trampolineEnabled?s.call(this,t):this._schedule(function(){t._settlePromises()})}):(r.prototype.invokeLater=i,r.prototype.invoke=o,r.prototype.settlePromises=s),r.prototype._drainQueues=function(){a(this._normalQueue),this._reset(),this._haveDrainedQueues=!0,a(this._lateQueue)},r.prototype._queueTick=function(){this._isTickUsed||(this._isTickUsed=!0,this._schedule(this.drainQueues))},r.prototype._reset=function(){this._isTickUsed=!1},e.exports=r,e.exports.firstLineError=l},{"./queue":26,"./schedule":29,"./util":36}],3:[function(t,e,n){"use strict";e.exports=function(t,e,n,r){var i=!1,o=function(t,e){this._reject(e)},s=function(t,e){e.promiseRejectionQueued=!0,e.bindingPromise._then(o,o,null,this,t)},a=function(t,e){0===(50397184&this._bitField)&&this._resolveCallback(e.target)},c=function(t,e){e.promiseRejectionQueued||this._reject(t)};t.prototype.bind=function(o){i||(i=!0,t.prototype._propagateFrom=r.propagateFromFunction(),t.prototype._boundValue=r.boundValueFunction());var l=n(o),u=new t(e);u._propagateFrom(this,1);var p=this._target();if(u._setBoundTo(l),l instanceof t){var h={promiseRejectionQueued:!1,promise:u,target:p,bindingPromise:l};p._then(e,s,void 0,u,h),l._then(a,c,void 0,u,h),u._setOnCancel(l)}else u._resolveCallback(p);return u},t.prototype._setBoundTo=function(t){void 0!==t?(this._bitField=2097152|this._bitField,this._boundTo=t):this._bitField=-2097153&this._bitField},t.prototype._isBound=function(){return 2097152===(2097152&this._bitField)},t.bind=function(e,n){return t.resolve(n).bind(e)}}},{}],4:[function(t,e,n){"use strict";function r(){try{Promise===o&&(Promise=i)}catch(t){}return o}var i;"undefined"!=typeof Promise&&(i=Promise);var o=t("./promise")();o.noConflict=r,e.exports=o},{"./promise":22}],5:[function(t,e,n){"use strict";var r=Object.create;if(r){var i=r(null),o=r(null);i[" size"]=o[" size"]=0}e.exports=function(e){function n(t,n){var r;if(null!=t&&(r=t[n]),"function"!=typeof r){var i="Object "+a.classString(t)+" has no method '"+a.toString(n)+"'";throw new e.TypeError(i)}return r}function r(t){var e=this.pop(),r=n(t,e);return r.apply(t,this)}function i(t){return t[this]}function o(t){var e=+this;return 0>e&&(e=Math.max(0,e+t.length)),t[e]}var s,a=t("./util"),c=a.canEvaluate;a.isIdentifier;e.prototype.call=function(t){var e=[].slice.call(arguments,1);return e.push(t),this._then(r,void 0,void 0,e,void 0)},e.prototype.get=function(t){var e,n="number"==typeof t;if(n)e=o;else if(c){var r=s(t);e=null!==r?r:i}else e=i;return this._then(e,void 0,void 0,t,void 0)}}},{"./util":36}],6:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){var o=t("./util"),s=o.tryCatch,a=o.errorObj,c=e._async;e.prototype["break"]=e.prototype.cancel=function(){if(!i.cancellation())return this._warn("cancellation is disabled");for(var t=this,e=t;t._isCancellable();){if(!t._cancelBy(e)){e._isFollowing()?e._followee().cancel():e._cancelBranched();break}var n=t._cancellationParent;if(null==n||!n._isCancellable()){t._isFollowing()?t._followee().cancel():t._cancelBranched();break}t._isFollowing()&&t._followee().cancel(),t._setWillBeCancelled(),e=t,t=n}},e.prototype._branchHasCancelled=function(){this._branchesRemainingToCancel--},e.prototype._enoughBranchesHaveCancelled=function(){return void 0===this._branchesRemainingToCancel||this._branchesRemainingToCancel<=0},e.prototype._cancelBy=function(t){return t===this?(this._branchesRemainingToCancel=0,this._invokeOnCancel(),!0):(this._branchHasCancelled(),this._enoughBranchesHaveCancelled()?(this._invokeOnCancel(),!0):!1)},e.prototype._cancelBranched=function(){this._enoughBranchesHaveCancelled()&&this._cancel()},e.prototype._cancel=function(){this._isCancellable()&&(this._setCancelled(),c.invoke(this._cancelPromises,this,void 0))},e.prototype._cancelPromises=function(){this._length()>0&&this._settlePromises()},e.prototype._unsetOnCancel=function(){this._onCancelField=void 0},e.prototype._isCancellable=function(){return this.isPending()&&!this._isCancelled()},e.prototype.isCancellable=function(){return this.isPending()&&!this.isCancelled()},e.prototype._doInvokeOnCancel=function(t,e){if(o.isArray(t))for(var n=0;n<t.length;++n)this._doInvokeOnCancel(t[n],e);else if(void 0!==t)if("function"==typeof t){if(!e){var r=s(t).call(this._boundValue());r===a&&(this._attachExtraTrace(r.e),c.throwLater(r.e))}}else t._resultCancelled(this)},e.prototype._invokeOnCancel=function(){var t=this._onCancel();this._unsetOnCancel(),c.invoke(this._doInvokeOnCancel,this,t)},e.prototype._invokeInternalOnCancel=function(){this._isCancellable()&&(this._doInvokeOnCancel(this._onCancel(),!0),this._unsetOnCancel())},e.prototype._resultCancelled=function(){this.cancel()}}},{"./util":36}],7:[function(t,e,n){"use strict";e.exports=function(e){function n(t,n,a){return function(c){var l=a._boundValue();t:for(var u=0;u<t.length;++u){var p=t[u];if(p===Error||null!=p&&p.prototype instanceof Error){if(c instanceof p)return o(n).call(l,c)}else if("function"==typeof p){var h=o(p).call(l,c);if(h===s)return h;if(h)return o(n).call(l,c)}else if(r.isObject(c)){for(var f=i(p),_=0;_<f.length;++_){var d=f[_];if(p[d]!=c[d])continue t}return o(n).call(l,c)}}return e}}var r=t("./util"),i=t("./es5").keys,o=r.tryCatch,s=r.errorObj;return n}},{"./es5":13,"./util":36}],8:[function(t,e,n){"use strict";e.exports=function(t){function e(){this._trace=new e.CapturedTrace(r())}function n(){return i?new e:void 0}function r(){var t=o.length-1;return t>=0?o[t]:void 0}var i=!1,o=[];return t.prototype._promiseCreated=function(){},t.prototype._pushContext=function(){},t.prototype._popContext=function(){return null},t._peekContext=t.prototype._peekContext=function(){},e.prototype._pushContext=function(){void 0!==this._trace&&(this._trace._promiseCreated=null,o.push(this._trace))},e.prototype._popContext=function(){if(void 0!==this._trace){var t=o.pop(),e=t._promiseCreated;return t._promiseCreated=null,e}return null},e.CapturedTrace=null,e.create=n,e.deactivateLongStackTraces=function(){},e.activateLongStackTraces=function(){var n=t.prototype._pushContext,o=t.prototype._popContext,s=t._peekContext,a=t.prototype._peekContext,c=t.prototype._promiseCreated;e.deactivateLongStackTraces=function(){t.prototype._pushContext=n,t.prototype._popContext=o,t._peekContext=s,t.prototype._peekContext=a,t.prototype._promiseCreated=c,i=!1},i=!0,t.prototype._pushContext=e.prototype._pushContext,t.prototype._popContext=e.prototype._popContext,t._peekContext=t.prototype._peekContext=r,t.prototype._promiseCreated=function(){var t=this._peekContext();t&&null==t._promiseCreated&&(t._promiseCreated=this)}},e}},{}],9:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,e){return{promise:e}}function i(){return!1}function o(t,e,n){var r=this;try{t(e,n,function(t){if("function"!=typeof t)throw new TypeError("onCancel must be a function, got: "+H.toString(t));r._attachCancellationCallback(t)})}catch(i){return i}}function s(t){if(!this._isCancellable())return this;var e=this._onCancel();void 0!==e?H.isArray(e)?e.push(t):this._setOnCancel([e,t]):this._setOnCancel(t)}function a(){return this._onCancelField}function c(t){this._onCancelField=t}function l(){this._cancellationParent=void 0,this._onCancelField=void 0}function u(t,e){if(0!==(1&e)){this._cancellationParent=t;var n=t._branchesRemainingToCancel;void 0===n&&(n=0),t._branchesRemainingToCancel=n+1}0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function p(t,e){0!==(2&e)&&t._isBound()&&this._setBoundTo(t._boundTo)}function h(){var t=this._boundTo;return void 0!==t&&t instanceof e?t.isFulfilled()?t.value():void 0:t}function f(){this._trace=new O(this._peekContext())}function _(t,e){if(U(t)){var n=this._trace;if(void 0!==n&&e&&(n=n._parent),void 0!==n)n.attachExtraTrace(t);else if(!t.__stackCleaned__){var r=E(t);H.notEnumerableProp(t,"stack",r.message+"\n"+r.stack.join("\n")),H.notEnumerableProp(t,"__stackCleaned__",!0)}}}function d(){this._trace=void 0}function v(t,e,n,r,i){if(void 0===t&&null!==e&&J){if(void 0!==i&&i._returnedNonUndefined())return;if(0===(65535&r._bitField))return;n&&(n+=" ");var o="",s="";if(e._trace){for(var a=e._trace.stack.split("\n"),c=C(a),l=c.length-1;l>=0;--l){var u=c[l];if(!q.test(u)){var p=u.match($);p&&(o="at "+p[1]+":"+p[2]+":"+p[3]+" ");break}}if(c.length>0)for(var h=c[0],l=0;l<a.length;++l)if(a[l]===h){l>0&&(s="\n"+a[l-1]);break}}var f="a promise was created in a "+n+"handler "+o+"but was not returned from it, see http://goo.gl/rRqMUw"+s;r._warn(f,!0,e)}}function y(t,e){var n=t+" is deprecated and will be removed in a future version.";return e&&(n+=" Use "+e+" instead."),m(n)}function m(t,n,r){if(at.warnings){var i,o=new N(t);if(n)r._attachExtraTrace(o);else if(at.longStackTraces&&(i=e._peekContext()))i.attachExtraTrace(o);else{var s=E(o);o.stack=s.message+"\n"+s.stack.join("\n")}nt("warning",o)||k(o,"",!0)}}function g(t,e){for(var n=0;n<e.length-1;++n)e[n].push("From previous event:"),e[n]=e[n].join("\n");return n<e.length&&(e[n]=e[n].join("\n")),t+"\n"+e.join("\n")}function b(t){for(var e=0;e<t.length;++e)(0===t[e].length||e+1<t.length&&t[e][0]===t[e+1][0])&&(t.splice(e,1),e--)}function w(t){for(var e=t[0],n=1;n<t.length;++n){for(var r=t[n],i=e.length-1,o=e[i],s=-1,a=r.length-1;a>=0;--a)if(r[a]===o){s=a;break}for(var a=s;a>=0;--a){var c=r[a];if(e[i]!==c)break;e.pop(),i--}e=r}}function C(t){for(var e=[],n=0;n<t.length;++n){var r=t[n],i="    (No stack trace)"===r||Q.test(r),o=i&&it(r);i&&!o&&(z&&" "!==r.charAt(0)&&(r="    "+r),e.push(r))}return e}function j(t){for(var e=t.stack.replace(/\s+$/g,"").split("\n"),n=0;n<e.length;++n){var r=e[n];if("    (No stack trace)"===r||Q.test(r))break}return n>0&&"SyntaxError"!=t.name&&(e=e.slice(n)),e}function E(t){var e=t.stack,n=t.toString();return e="string"==typeof e&&e.length>0?j(t):["    (No stack trace)"],{message:n,stack:"SyntaxError"==t.name?e:C(e)}}function k(t,e,n){if("undefined"!=typeof console){var r;if(H.isObject(t)){var i=t.stack;r=e+G(i,t)}else r=e+String(t);"function"==typeof V?V(r,n):("function"==typeof console.log||"object"==typeof console.log)&&console.log(r)}}function F(t,e,n,r){var i=!1;try{"function"==typeof e&&(i=!0,"rejectionHandled"===t?e(r):e(n,r))}catch(o){L.throwLater(o)}"unhandledRejection"===t?nt(t,n,r)||i||k(n,"Unhandled rejection "):nt(t,r)}function T(t){var e;if("function"==typeof t)e="[function "+(t.name||"anonymous")+"]";else{e=t&&"function"==typeof t.toString?t.toString():H.toString(t);var n=/\[object [a-zA-Z0-9$_]+\]/;if(n.test(e))try{var r=JSON.stringify(t);e=r}catch(i){}0===e.length&&(e="(empty array)")}return"(<"+x(e)+">, no stack trace)"}function x(t){var e=41;return t.length<e?t:t.substr(0,e-3)+"..."}function P(){return"function"==typeof st}function S(t){var e=t.match(ot);return e?{fileName:e[1],line:parseInt(e[2],10)}:void 0}function R(t,e){if(P()){for(var n,r,i=(t.stack||"").split("\n"),o=(e.stack||"").split("\n"),s=-1,a=-1,c=0;c<i.length;++c){var l=S(i[c]);if(l){n=l.fileName,s=l.line;break}}for(var c=0;c<o.length;++c){var l=S(o[c]);if(l){r=l.fileName,a=l.line;break}}0>s||0>a||!n||!r||n!==r||s>=a||(it=function(t){if(M.test(t))return!0;var e=S(t);return e&&e.fileName===n&&s<=e.line&&e.line<=a?!0:!1})}}function O(t){this._parent=t,this._promisesCreated=0;var e=this._length=1+(void 0===t?0:t._length);st(this,O),e>32&&this.uncycle()}var A,D,V,I=e._getDomain,L=e._async,N=t("./errors").Warning,H=t("./util"),B=t("./es5"),U=H.canAttachTrace,M=/[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/,q=/\((?:timers\.js):\d+:\d+\)/,$=/[\/<\(](.+?):(\d+):(\d+)\)?\s*$/,Q=null,G=null,z=!1,X=!(0==H.env("BLUEBIRD_DEBUG")||!H.env("BLUEBIRD_DEBUG")&&"development"!==H.env("NODE_ENV")),W=!(0==H.env("BLUEBIRD_WARNINGS")||!X&&!H.env("BLUEBIRD_WARNINGS")),K=!(0==H.env("BLUEBIRD_LONG_STACK_TRACES")||!X&&!H.env("BLUEBIRD_LONG_STACK_TRACES")),J=0!=H.env("BLUEBIRD_W_FORGOTTEN_RETURN")&&(W||!!H.env("BLUEBIRD_W_FORGOTTEN_RETURN"));e.prototype.suppressUnhandledRejections=function(){var t=this._target();t._bitField=-1048577&t._bitField|524288},e.prototype._ensurePossibleRejectionHandled=function(){if(0===(524288&this._bitField)){this._setRejectionIsUnhandled();var t=this;setTimeout(function(){t._notifyUnhandledRejection()},1)}},e.prototype._notifyUnhandledRejectionIsHandled=function(){F("rejectionHandled",A,void 0,this)},e.prototype._setReturnedNonUndefined=function(){this._bitField=268435456|this._bitField},e.prototype._returnedNonUndefined=function(){return 0!==(268435456&this._bitField)},e.prototype._notifyUnhandledRejection=function(){if(this._isRejectionUnhandled()){var t=this._settledValue();this._setUnhandledRejectionIsNotified(),F("unhandledRejection",D,t,this)}},e.prototype._setUnhandledRejectionIsNotified=function(){this._bitField=262144|this._bitField},e.prototype._unsetUnhandledRejectionIsNotified=function(){this._bitField=-262145&this._bitField},e.prototype._isUnhandledRejectionNotified=function(){return(262144&this._bitField)>0},e.prototype._setRejectionIsUnhandled=function(){this._bitField=1048576|this._bitField},e.prototype._unsetRejectionIsUnhandled=function(){this._bitField=-1048577&this._bitField,this._isUnhandledRejectionNotified()&&(this._unsetUnhandledRejectionIsNotified(),this._notifyUnhandledRejectionIsHandled())},e.prototype._isRejectionUnhandled=function(){return(1048576&this._bitField)>0},e.prototype._warn=function(t,e,n){return m(t,e,n||this)},e.onPossiblyUnhandledRejection=function(t){var e=I();D="function"==typeof t?null===e?t:H.domainBind(e,t):void 0},e.onUnhandledRejectionHandled=function(t){var e=I();A="function"==typeof t?null===e?t:H.domainBind(e,t):void 0};var Y=function(){};e.longStackTraces=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");if(!at.longStackTraces&&P()){var t=e.prototype._captureStackTrace,r=e.prototype._attachExtraTrace,i=e.prototype._dereferenceTrace;at.longStackTraces=!0,Y=function(){if(L.haveItemsQueued()&&!at.longStackTraces)throw new Error("cannot enable long stack traces after promises have been created\n\n    See http://goo.gl/MqrFmX\n");e.prototype._captureStackTrace=t,e.prototype._attachExtraTrace=r,e.prototype._dereferenceTrace=i,n.deactivateLongStackTraces(),L.enableTrampoline(),at.longStackTraces=!1},e.prototype._captureStackTrace=f,e.prototype._attachExtraTrace=_,e.prototype._dereferenceTrace=d,n.activateLongStackTraces(),L.disableTrampolineIfNecessary()}},e.hasLongStackTraces=function(){return at.longStackTraces&&P()};var Z=function(){try{if("function"==typeof CustomEvent){var t=new CustomEvent("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n={detail:e,cancelable:!0};B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason});var r=new CustomEvent(t.toLowerCase(),n);return!H.global.dispatchEvent(r)}}if("function"==typeof Event){var t=new Event("CustomEvent");return H.global.dispatchEvent(t),function(t,e){var n=new Event(t.toLowerCase(),{cancelable:!0});return n.detail=e,B.defineProperty(n,"promise",{value:e.promise}),B.defineProperty(n,"reason",{value:e.reason}),!H.global.dispatchEvent(n)}}var t=document.createEvent("CustomEvent");return t.initCustomEvent("testingtheevent",!1,!0,{}),H.global.dispatchEvent(t),function(t,e){var n=document.createEvent("CustomEvent");return n.initCustomEvent(t.toLowerCase(),!1,!0,e),!H.global.dispatchEvent(n)}}catch(e){}return function(){return!1}}(),tt=function(){return H.isNode?function(){return process.emit.apply(process,arguments)}:H.global?function(t){var e="on"+t.toLowerCase(),n=H.global[e];return n?(n.apply(H.global,[].slice.call(arguments,1)),!0):!1}:function(){return!1}}(),et={promiseCreated:r,promiseFulfilled:r,promiseRejected:r,promiseResolved:r,promiseCancelled:r,promiseChained:function(t,e,n){return{promise:e,child:n}},warning:function(t,e){return{warning:e}},unhandledRejection:function(t,e,n){return{reason:e,promise:n}},rejectionHandled:r},nt=function(t){var e=!1;try{e=tt.apply(null,arguments)}catch(n){L.throwLater(n),e=!0}var r=!1;try{r=Z(t,et[t].apply(null,arguments))}catch(n){L.throwLater(n),r=!0}return r||e};e.config=function(t){if(t=Object(t),"longStackTraces"in t&&(t.longStackTraces?e.longStackTraces():!t.longStackTraces&&e.hasLongStackTraces()&&Y()),"warnings"in t){var n=t.warnings;at.warnings=!!n,J=at.warnings,H.isObject(n)&&"wForgottenReturn"in n&&(J=!!n.wForgottenReturn)}if("cancellation"in t&&t.cancellation&&!at.cancellation){if(L.haveItemsQueued())throw new Error("cannot enable cancellation after promises are in use");e.prototype._clearCancellationData=l,e.prototype._propagateFrom=u,e.prototype._onCancel=a,e.prototype._setOnCancel=c,e.prototype._attachCancellationCallback=s,e.prototype._execute=o,rt=u,at.cancellation=!0}return"monitoring"in t&&(t.monitoring&&!at.monitoring?(at.monitoring=!0,e.prototype._fireEvent=nt):!t.monitoring&&at.monitoring&&(at.monitoring=!1,e.prototype._fireEvent=i)),e},e.prototype._fireEvent=i,e.prototype._execute=function(t,e,n){try{t(e,n)}catch(r){return r}},e.prototype._onCancel=function(){},e.prototype._setOnCancel=function(t){},e.prototype._attachCancellationCallback=function(t){},e.prototype._captureStackTrace=function(){},e.prototype._attachExtraTrace=function(){},e.prototype._dereferenceTrace=function(){},e.prototype._clearCancellationData=function(){},e.prototype._propagateFrom=function(t,e){};var rt=p,it=function(){return!1},ot=/[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;H.inherits(O,Error),n.CapturedTrace=O,O.prototype.uncycle=function(){var t=this._length;if(!(2>t)){for(var e=[],n={},r=0,i=this;void 0!==i;++r)e.push(i),i=i._parent;t=this._length=r;for(var r=t-1;r>=0;--r){var o=e[r].stack;void 0===n[o]&&(n[o]=r)}for(var r=0;t>r;++r){var s=e[r].stack,a=n[s];if(void 0!==a&&a!==r){a>0&&(e[a-1]._parent=void 0,e[a-1]._length=1),e[r]._parent=void 0,e[r]._length=1;var c=r>0?e[r-1]:this;t-1>a?(c._parent=e[a+1],c._parent.uncycle(),c._length=c._parent._length+1):(c._parent=void 0,c._length=1);for(var l=c._length+1,u=r-2;u>=0;--u)e[u]._length=l,l++;return}}}},O.prototype.attachExtraTrace=function(t){if(!t.__stackCleaned__){this.uncycle();for(var e=E(t),n=e.message,r=[e.stack],i=this;void 0!==i;)r.push(C(i.stack.split("\n"))),i=i._parent;w(r),b(r),H.notEnumerableProp(t,"stack",g(n,r)),H.notEnumerableProp(t,"__stackCleaned__",!0)}};var st=function(){var t=/^\s*at\s*/,e=function(t,e){return"string"==typeof t?t:void 0!==e.name&&void 0!==e.message?e.toString():T(e)};if("number"==typeof Error.stackTraceLimit&&"function"==typeof Error.captureStackTrace){Error.stackTraceLimit+=6,Q=t,G=e;var n=Error.captureStackTrace;return it=function(t){return M.test(t)},function(t,e){Error.stackTraceLimit+=6,n(t,e),Error.stackTraceLimit-=6}}var r=new Error;if("string"==typeof r.stack&&r.stack.split("\n")[0].indexOf("stackDetection@")>=0)return Q=/@/,G=e,z=!0,function(t){t.stack=(new Error).stack};var i;try{throw new Error}catch(o){i="stack"in o}return"stack"in r||!i||"number"!=typeof Error.stackTraceLimit?(G=function(t,e){return"string"==typeof t?t:"object"!=typeof e&&"function"!=typeof e||void 0===e.name||void 0===e.message?T(e):e.toString()},null):(Q=t,G=e,function(t){Error.stackTraceLimit+=6;try{throw new Error}catch(e){t.stack=e.stack}Error.stackTraceLimit-=6})}([]);"undefined"!=typeof console&&"undefined"!=typeof console.warn&&(V=function(t){console.warn(t)},H.isNode&&process.stderr.isTTY?V=function(t,e){var n=e?"[33m":"[31m";console.warn(n+t+"[0m\n")}:H.isNode||"string"!=typeof(new Error).stack||(V=function(t,e){console.warn("%c"+t,e?"color: darkorange":"color: red")}));var at={warnings:W,longStackTraces:!1,cancellation:!1,monitoring:!1};return K&&e.longStackTraces(),{longStackTraces:function(){return at.longStackTraces},warnings:function(){return at.warnings},cancellation:function(){return at.cancellation},monitoring:function(){return at.monitoring},propagateFromFunction:function(){return rt},boundValueFunction:function(){return h},checkForgottenReturns:v,setBounds:R,warn:m,deprecated:y,CapturedTrace:O,fireDomEvent:Z,fireGlobalEvent:tt}}},{"./errors":12,"./es5":13,"./util":36}],10:[function(t,e,n){"use strict";e.exports=function(t){function e(){return this.value}function n(){throw this.reason}t.prototype["return"]=t.prototype.thenReturn=function(n){return n instanceof t&&n.suppressUnhandledRejections(),this._then(e,void 0,void 0,{value:n},void 0)},t.prototype["throw"]=t.prototype.thenThrow=function(t){return this._then(n,void 0,void 0,{reason:t},void 0)},t.prototype.catchThrow=function(t){if(arguments.length<=1)return this._then(void 0,n,void 0,{reason:t},void 0);var e=arguments[1],r=function(){throw e};return this.caught(t,r)},t.prototype.catchReturn=function(n){if(arguments.length<=1)return n instanceof t&&n.suppressUnhandledRejections(),this._then(void 0,e,void 0,{value:n},void 0);var r=arguments[1];r instanceof t&&r.suppressUnhandledRejections();var i=function(){return r};return this.caught(n,i)}}},{}],11:[function(t,e,n){"use strict";e.exports=function(t,e){function n(){return o(this)}function r(t,n){return i(t,n,e,e)}var i=t.reduce,o=t.all;t.prototype.each=function(t){return i(this,t,e,0)._then(n,void 0,void 0,this,void 0)},t.prototype.mapSeries=function(t){return i(this,t,e,e)},t.each=function(t,r){return i(t,r,e,0)._then(n,void 0,void 0,t,void 0)},t.mapSeries=r}},{}],12:[function(t,e,n){"use strict";function r(t,e){function n(r){return this instanceof n?(p(this,"message","string"==typeof r?r:e),p(this,"name",t),void(Error.captureStackTrace?Error.captureStackTrace(this,this.constructor):Error.call(this))):new n(r)}return u(n,Error),n}function i(t){return this instanceof i?(p(this,"name","OperationalError"),p(this,"message",t),this.cause=t,this.isOperational=!0,void(t instanceof Error?(p(this,"message",t.message),p(this,"stack",t.stack)):Error.captureStackTrace&&Error.captureStackTrace(this,this.constructor))):new i(t)}var o,s,a=t("./es5"),c=a.freeze,l=t("./util"),u=l.inherits,p=l.notEnumerableProp,h=r("Warning","warning"),f=r("CancellationError","cancellation error"),_=r("TimeoutError","timeout error"),d=r("AggregateError","aggregate error");try{o=TypeError,s=RangeError}catch(v){o=r("TypeError","type error"),s=r("RangeError","range error")}for(var y="join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" "),m=0;m<y.length;++m)"function"==typeof Array.prototype[y[m]]&&(d.prototype[y[m]]=Array.prototype[y[m]]);a.defineProperty(d.prototype,"length",{value:0,configurable:!1,writable:!0,enumerable:!0}),d.prototype.isOperational=!0;var g=0;d.prototype.toString=function(){var t=Array(4*g+1).join(" "),e="\n"+t+"AggregateError of:\n";g++,t=Array(4*g+1).join(" ");for(var n=0;n<this.length;++n){for(var r=this[n]===this?"[Circular AggregateError]":this[n]+"",i=r.split("\n"),o=0;o<i.length;++o)i[o]=t+i[o];r=i.join("\n"),e+=r+"\n"}return g--,e},u(i,Error);var b=Error.__BluebirdErrorTypes__;b||(b=c({CancellationError:f,TimeoutError:_,OperationalError:i,RejectionError:i,AggregateError:d}),a.defineProperty(Error,"__BluebirdErrorTypes__",{value:b,writable:!1,enumerable:!1,configurable:!1})),e.exports={Error:Error,TypeError:o,RangeError:s,CancellationError:b.CancellationError,OperationalError:b.OperationalError,TimeoutError:b.TimeoutError,AggregateError:b.AggregateError,Warning:h}},{"./es5":13,"./util":36}],13:[function(t,e,n){var r=function(){"use strict";return void 0===this}();if(r)e.exports={freeze:Object.freeze,defineProperty:Object.defineProperty,getDescriptor:Object.getOwnPropertyDescriptor,keys:Object.keys,names:Object.getOwnPropertyNames,getPrototypeOf:Object.getPrototypeOf,isArray:Array.isArray,isES5:r,propertyIsWritable:function(t,e){var n=Object.getOwnPropertyDescriptor(t,e);return!(n&&!n.writable&&!n.set)}};else{var i={}.hasOwnProperty,o={}.toString,s={}.constructor.prototype,a=function(t){var e=[];for(var n in t)i.call(t,n)&&e.push(n);return e},c=function(t,e){return{value:t[e]}},l=function(t,e,n){return t[e]=n.value,t},u=function(t){return t},p=function(t){try{return Object(t).constructor.prototype}catch(e){return s}},h=function(t){try{return"[object Array]"===o.call(t)}catch(e){return!1}};e.exports={isArray:h,keys:a,names:a,defineProperty:l,getDescriptor:c,freeze:u,getPrototypeOf:p,isES5:r,propertyIsWritable:function(){return!0}}}},{}],14:[function(t,e,n){"use strict";e.exports=function(t,e){var n=t.map;t.prototype.filter=function(t,r){return n(this,t,r,e)},t.filter=function(t,r,i){return n(t,r,i,e)}}},{}],15:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t,e,n){this.promise=t,this.type=e,this.handler=n,this.called=!1,this.cancelPromise=null}function o(t){this.finallyHandler=t}function s(t,e){return null!=t.cancelPromise?(arguments.length>1?t.cancelPromise._reject(e):t.cancelPromise._cancel(),t.cancelPromise=null,!0):!1}function a(){return l.call(this,this.promise._target()._settledValue())}function c(t){return s(this,t)?void 0:(h.e=t,h)}function l(t){var i=this.promise,l=this.handler;if(!this.called){this.called=!0;var u=this.isFinallyHandler()?l.call(i._boundValue()):l.call(i._boundValue(),t);if(u===r)return u;if(void 0!==u){i._setReturnedNonUndefined();var f=n(u,i);if(f instanceof e){if(null!=this.cancelPromise){if(f._isCancelled()){var _=new p("late cancellation observer");return i._attachExtraTrace(_),h.e=_,h}f.isPending()&&f._attachCancellationCallback(new o(this))}return f._then(a,c,void 0,this,void 0)}}}return i.isRejected()?(s(this),h.e=t,h):(s(this),t)}var u=t("./util"),p=e.CancellationError,h=u.errorObj,f=t("./catch_filter")(r);return i.prototype.isFinallyHandler=function(){return 0===this.type},o.prototype._resultCancelled=function(){s(this.finallyHandler)},e.prototype._passThrough=function(t,e,n,r){return"function"!=typeof t?this.then():this._then(n,r,void 0,new i(this,e,t),void 0)},e.prototype.lastly=e.prototype["finally"]=function(t){return this._passThrough(t,0,l,l)},e.prototype.tap=function(t){return this._passThrough(t,1,l)},e.prototype.tapCatch=function(t){var n=arguments.length;if(1===n)return this._passThrough(t,1,void 0,l);var r,i=new Array(n-1),o=0;for(r=0;n-1>r;++r){var s=arguments[r];if(!u.isObject(s))return e.reject(new TypeError("tapCatch statement predicate: expecting an object but got "+u.classString(s)));i[o++]=s}i.length=o;var a=arguments[r];return this._passThrough(f(i,a,this),1,void 0,l)},i}},{"./catch_filter":7,"./util":36}],16:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r){for(var o=0;o<n.length;++o){r._pushContext();var s=f(n[o])(t);if(r._popContext(),s===h){r._pushContext();var a=e.reject(h.e);return r._popContext(),a}var c=i(s,r);if(c instanceof e)return c}return null}function c(t,n,i,o){if(s.cancellation()){var a=new e(r),c=this._finallyPromise=new e(r);this._promise=a.lastly(function(){return c}),a._captureStackTrace(),a._setOnCancel(this)}else{var l=this._promise=new e(r);l._captureStackTrace()}this._stack=o,this._generatorFunction=t,this._receiver=n,this._generator=void 0,this._yieldHandlers="function"==typeof i?[i].concat(_):_,this._yieldedPromise=null,this._cancellationPhase=!1}var l=t("./errors"),u=l.TypeError,p=t("./util"),h=p.errorObj,f=p.tryCatch,_=[];p.inherits(c,o),c.prototype._isResolved=function(){return null===this._promise},c.prototype._cleanup=function(){this._promise=this._generator=null,s.cancellation()&&null!==this._finallyPromise&&(this._finallyPromise._fulfill(),this._finallyPromise=null)},c.prototype._promiseCancelled=function(){if(!this._isResolved()){var t,n="undefined"!=typeof this._generator["return"];if(n)this._promise._pushContext(),t=f(this._generator["return"]).call(this._generator,void 0),this._promise._popContext();else{var r=new e.CancellationError("generator .return() sentinel");e.coroutine.returnSentinel=r,this._promise._attachExtraTrace(r),this._promise._pushContext(),t=f(this._generator["throw"]).call(this._generator,r),this._promise._popContext()}this._cancellationPhase=!0,this._yieldedPromise=null,this._continue(t)}},c.prototype._promiseFulfilled=function(t){this._yieldedPromise=null,this._promise._pushContext();var e=f(this._generator.next).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._promiseRejected=function(t){this._yieldedPromise=null,this._promise._attachExtraTrace(t),this._promise._pushContext();var e=f(this._generator["throw"]).call(this._generator,t);this._promise._popContext(),this._continue(e)},c.prototype._resultCancelled=function(){if(this._yieldedPromise instanceof e){var t=this._yieldedPromise;this._yieldedPromise=null,t.cancel()}},c.prototype.promise=function(){return this._promise},c.prototype._run=function(){this._generator=this._generatorFunction.call(this._receiver),this._receiver=this._generatorFunction=void 0,this._promiseFulfilled(void 0)},c.prototype._continue=function(t){var n=this._promise;if(t===h)return this._cleanup(),this._cancellationPhase?n.cancel():n._rejectCallback(t.e,!1);var r=t.value;if(t.done===!0)return this._cleanup(),this._cancellationPhase?n.cancel():n._resolveCallback(r);var o=i(r,this._promise);if(!(o instanceof e)&&(o=a(o,this._yieldHandlers,this._promise),
null===o))return void this._promiseRejected(new u("A value %s was yielded that could not be treated as a promise\n\n    See http://goo.gl/MqrFmX\n\n".replace("%s",String(r))+"From coroutine:\n"+this._stack.split("\n").slice(1,-7).join("\n")));o=o._target();var s=o._bitField;0===(50397184&s)?(this._yieldedPromise=o,o._proxy(this,null)):0!==(33554432&s)?e._async.invoke(this._promiseFulfilled,this,o._value()):0!==(16777216&s)?e._async.invoke(this._promiseRejected,this,o._reason()):this._promiseCancelled()},e.coroutine=function(t,e){if("function"!=typeof t)throw new u("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var n=Object(e).yieldHandler,r=c,i=(new Error).stack;return function(){var e=t.apply(this,arguments),o=new r(void 0,void 0,n,i),s=o.promise();return o._generator=e,o._promiseFulfilled(void 0),s}},e.coroutine.addYieldHandler=function(t){if("function"!=typeof t)throw new u("expecting a function but got "+p.classString(t));_.push(t)},e.spawn=function(t){if(s.deprecated("Promise.spawn()","Promise.coroutine()"),"function"!=typeof t)return n("generatorFunction must be a function\n\n    See http://goo.gl/MqrFmX\n");var r=new c(t,this),i=r.promise();return r._run(e.spawn),i}}},{"./errors":12,"./util":36}],17:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){var a=t("./util");a.canEvaluate,a.tryCatch,a.errorObj;e.join=function(){var t,e=arguments.length-1;if(e>0&&"function"==typeof arguments[e]){t=arguments[e];var r}var i=[].slice.call(arguments);t&&i.pop();var r=new n(i).promise();return void 0!==t?r.spread(t):r}}},{"./util":36}],18:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,e,n,r){this.constructor$(t),this._promise._captureStackTrace();var i=l();this._callback=null===i?e:u.domainBind(i,e),this._preservedValues=r===o?new Array(this.length()):null,this._limit=n,this._inFlight=0,this._queue=[],f.invoke(this._asyncInit,this,void 0)}function c(t,n,i,o){if("function"!=typeof n)return r("expecting a function but got "+u.classString(n));var s=0;if(void 0!==i){if("object"!=typeof i||null===i)return e.reject(new TypeError("options argument must be an object but it is "+u.classString(i)));if("number"!=typeof i.concurrency)return e.reject(new TypeError("'concurrency' must be a number but it is "+u.classString(i.concurrency)));s=i.concurrency}return s="number"==typeof s&&isFinite(s)&&s>=1?s:0,new a(t,n,s,o).promise()}var l=e._getDomain,u=t("./util"),p=u.tryCatch,h=u.errorObj,f=e._async;u.inherits(a,n),a.prototype._asyncInit=function(){this._init$(void 0,-2)},a.prototype._init=function(){},a.prototype._promiseFulfilled=function(t,n){var r=this._values,o=this.length(),a=this._preservedValues,c=this._limit;if(0>n){if(n=-1*n-1,r[n]=t,c>=1&&(this._inFlight--,this._drainQueue(),this._isResolved()))return!0}else{if(c>=1&&this._inFlight>=c)return r[n]=t,this._queue.push(n),!1;null!==a&&(a[n]=t);var l=this._promise,u=this._callback,f=l._boundValue();l._pushContext();var _=p(u).call(f,t,n,o),d=l._popContext();if(s.checkForgottenReturns(_,d,null!==a?"Promise.filter":"Promise.map",l),_===h)return this._reject(_.e),!0;var v=i(_,this._promise);if(v instanceof e){v=v._target();var y=v._bitField;if(0===(50397184&y))return c>=1&&this._inFlight++,r[n]=v,v._proxy(this,-1*(n+1)),!1;if(0===(33554432&y))return 0!==(16777216&y)?(this._reject(v._reason()),!0):(this._cancel(),!0);_=v._value()}r[n]=_}var m=++this._totalResolved;return m>=o?(null!==a?this._filter(r,a):this._resolve(r),!0):!1},a.prototype._drainQueue=function(){for(var t=this._queue,e=this._limit,n=this._values;t.length>0&&this._inFlight<e;){if(this._isResolved())return;var r=t.pop();this._promiseFulfilled(n[r],r)}},a.prototype._filter=function(t,e){for(var n=e.length,r=new Array(n),i=0,o=0;n>o;++o)t[o]&&(r[i++]=e[o]);r.length=i,this._resolve(r)},a.prototype.preservedValues=function(){return this._preservedValues},e.prototype.map=function(t,e){return c(this,t,e,null)},e.map=function(t,e,n,r){return c(t,e,n,r)}}},{"./util":36}],19:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){var s=t("./util"),a=s.tryCatch;e.method=function(t){if("function"!=typeof t)throw new e.TypeError("expecting a function but got "+s.classString(t));return function(){var r=new e(n);r._captureStackTrace(),r._pushContext();var i=a(t).apply(this,arguments),s=r._popContext();return o.checkForgottenReturns(i,s,"Promise.method",r),r._resolveFromSyncValue(i),r}},e.attempt=e["try"]=function(t){if("function"!=typeof t)return i("expecting a function but got "+s.classString(t));var r=new e(n);r._captureStackTrace(),r._pushContext();var c;if(arguments.length>1){o.deprecated("calling Promise.try with more than 1 argument");var l=arguments[1],u=arguments[2];c=s.isArray(l)?a(t).apply(u,l):a(t).call(u,l)}else c=a(t)();var p=r._popContext();return o.checkForgottenReturns(c,p,"Promise.try",r),r._resolveFromSyncValue(c),r},e.prototype._resolveFromSyncValue=function(t){t===s.errorObj?this._rejectCallback(t.e,!1):this._resolveCallback(t,!0)}}},{"./util":36}],20:[function(t,e,n){"use strict";function r(t){return t instanceof Error&&u.getPrototypeOf(t)===Error.prototype}function i(t){var e;if(r(t)){e=new l(t),e.name=t.name,e.message=t.message,e.stack=t.stack;for(var n=u.keys(t),i=0;i<n.length;++i){var o=n[i];p.test(o)||(e[o]=t[o])}return e}return s.markAsOriginatingFromRejection(t),t}function o(t,e){return function(n,r){if(null!==t){if(n){var o=i(a(n));t._attachExtraTrace(o),t._reject(o)}else if(e){var s=[].slice.call(arguments,1);t._fulfill(s)}else t._fulfill(r);t=null}}}var s=t("./util"),a=s.maybeWrapAsError,c=t("./errors"),l=c.OperationalError,u=t("./es5"),p=/^(?:name|message|stack|cause)$/;e.exports=o},{"./errors":12,"./es5":13,"./util":36}],21:[function(t,e,n){"use strict";e.exports=function(e){function n(t,e){var n=this;if(!o.isArray(t))return r.call(n,t,e);var i=a(e).apply(n._boundValue(),[null].concat(t));i===c&&s.throwLater(i.e)}function r(t,e){var n=this,r=n._boundValue(),i=void 0===t?a(e).call(r,null):a(e).call(r,null,t);i===c&&s.throwLater(i.e)}function i(t,e){var n=this;if(!t){var r=new Error(t+"");r.cause=t,t=r}var i=a(e).call(n._boundValue(),t);i===c&&s.throwLater(i.e)}var o=t("./util"),s=e._async,a=o.tryCatch,c=o.errorObj;e.prototype.asCallback=e.prototype.nodeify=function(t,e){if("function"==typeof t){var o=r;void 0!==e&&Object(e).spread&&(o=n),this._then(o,i,void 0,this,t)}return this}}},{"./util":36}],22:[function(t,e,n){"use strict";e.exports=function(){function n(){}function r(t,e){if(null==t||t.constructor!==i)throw new m("the promise constructor cannot be invoked directly\n\n    See http://goo.gl/MqrFmX\n");if("function"!=typeof e)throw new m("expecting a function but got "+f.classString(e))}function i(t){t!==b&&r(this,t),this._bitField=0,this._fulfillmentHandler0=void 0,this._rejectionHandler0=void 0,this._promise0=void 0,this._receiver0=void 0,this._resolveFromExecutor(t),this._promiseCreated(),this._fireEvent("promiseCreated",this)}function o(t){this.promise._resolveCallback(t)}function s(t){this.promise._rejectCallback(t,!1)}function a(t){var e=new i(b);e._fulfillmentHandler0=t,e._rejectionHandler0=t,e._promise0=t,e._receiver0=t}var c,l=function(){return new m("circular promise resolution chain\n\n    See http://goo.gl/MqrFmX\n")},u=function(){return new i.PromiseInspection(this._target())},p=function(t){return i.reject(new m(t))},h={},f=t("./util");c=f.isNode?function(){var t=process.domain;return void 0===t&&(t=null),t}:function(){return null},f.notEnumerableProp(i,"_getDomain",c);var _=t("./es5"),d=t("./async"),v=new d;_.defineProperty(i,"_async",{value:v});var y=t("./errors"),m=i.TypeError=y.TypeError;i.RangeError=y.RangeError;var g=i.CancellationError=y.CancellationError;i.TimeoutError=y.TimeoutError,i.OperationalError=y.OperationalError,i.RejectionError=y.OperationalError,i.AggregateError=y.AggregateError;var b=function(){},w={},C={},j=t("./thenables")(i,b),E=t("./promise_array")(i,b,j,p,n),k=t("./context")(i),F=k.create,T=t("./debuggability")(i,k),x=(T.CapturedTrace,t("./finally")(i,j,C)),P=t("./catch_filter")(C),S=t("./nodeback"),R=f.errorObj,O=f.tryCatch;return i.prototype.toString=function(){return"[object Promise]"},i.prototype.caught=i.prototype["catch"]=function(t){var e=arguments.length;if(e>1){var n,r=new Array(e-1),i=0;for(n=0;e-1>n;++n){var o=arguments[n];if(!f.isObject(o))return p("Catch statement predicate: expecting an object but got "+f.classString(o));r[i++]=o}if(r.length=i,t=arguments[n],"function"!=typeof t)throw new m("The last argument to .catch() must be a function, got "+f.toString(t));return this.then(void 0,P(r,t,this))}return this.then(void 0,t)},i.prototype.reflect=function(){return this._then(u,u,void 0,this,void 0)},i.prototype.then=function(t,e){if(T.warnings()&&arguments.length>0&&"function"!=typeof t&&"function"!=typeof e){var n=".then() only accepts functions but was passed: "+f.classString(t);arguments.length>1&&(n+=", "+f.classString(e)),this._warn(n)}return this._then(t,e,void 0,void 0,void 0)},i.prototype.done=function(t,e){var n=this._then(t,e,void 0,void 0,void 0);n._setIsFinal()},i.prototype.spread=function(t){return"function"!=typeof t?p("expecting a function but got "+f.classString(t)):this.all()._then(t,void 0,void 0,w,void 0)},i.prototype.toJSON=function(){var t={isFulfilled:!1,isRejected:!1,fulfillmentValue:void 0,rejectionReason:void 0};return this.isFulfilled()?(t.fulfillmentValue=this.value(),t.isFulfilled=!0):this.isRejected()&&(t.rejectionReason=this.reason(),t.isRejected=!0),t},i.prototype.all=function(){return arguments.length>0&&this._warn(".all() was passed arguments but it does not take any"),new E(this).promise()},i.prototype.error=function(t){return this.caught(f.originatesFromRejection,t)},i.getNewLibraryCopy=e.exports,i.is=function(t){return t instanceof i},i.fromNode=i.fromCallback=function(t){var e=new i(b);e._captureStackTrace();var n=arguments.length>1?!!Object(arguments[1]).multiArgs:!1,r=O(t)(S(e,n));return r===R&&e._rejectCallback(r.e,!0),e._isFateSealed()||e._setAsyncGuaranteed(),e},i.all=function(t){return new E(t).promise()},i.cast=function(t){var e=j(t);return e instanceof i||(e=new i(b),e._captureStackTrace(),e._setFulfilled(),e._rejectionHandler0=t),e},i.resolve=i.fulfilled=i.cast,i.reject=i.rejected=function(t){var e=new i(b);return e._captureStackTrace(),e._rejectCallback(t,!0),e},i.setScheduler=function(t){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));return v.setScheduler(t)},i.prototype._then=function(t,e,n,r,o){var s=void 0!==o,a=s?o:new i(b),l=this._target(),u=l._bitField;s||(a._propagateFrom(this,3),a._captureStackTrace(),void 0===r&&0!==(2097152&this._bitField)&&(r=0!==(50397184&u)?this._boundValue():l===this?void 0:this._boundTo),this._fireEvent("promiseChained",this,a));var p=c();if(0!==(50397184&u)){var h,_,d=l._settlePromiseCtx;0!==(33554432&u)?(_=l._rejectionHandler0,h=t):0!==(16777216&u)?(_=l._fulfillmentHandler0,h=e,l._unsetRejectionIsUnhandled()):(d=l._settlePromiseLateCancellationObserver,_=new g("late cancellation observer"),l._attachExtraTrace(_),h=e),v.invoke(d,l,{handler:null===p?h:"function"==typeof h&&f.domainBind(p,h),promise:a,receiver:r,value:_})}else l._addCallbacks(t,e,a,r,p);return a},i.prototype._length=function(){return 65535&this._bitField},i.prototype._isFateSealed=function(){return 0!==(117506048&this._bitField)},i.prototype._isFollowing=function(){return 67108864===(67108864&this._bitField)},i.prototype._setLength=function(t){this._bitField=-65536&this._bitField|65535&t},i.prototype._setFulfilled=function(){this._bitField=33554432|this._bitField,this._fireEvent("promiseFulfilled",this)},i.prototype._setRejected=function(){this._bitField=16777216|this._bitField,this._fireEvent("promiseRejected",this)},i.prototype._setFollowing=function(){this._bitField=67108864|this._bitField,this._fireEvent("promiseResolved",this)},i.prototype._setIsFinal=function(){this._bitField=4194304|this._bitField},i.prototype._isFinal=function(){return(4194304&this._bitField)>0},i.prototype._unsetCancelled=function(){this._bitField=-65537&this._bitField},i.prototype._setCancelled=function(){this._bitField=65536|this._bitField,this._fireEvent("promiseCancelled",this)},i.prototype._setWillBeCancelled=function(){this._bitField=8388608|this._bitField},i.prototype._setAsyncGuaranteed=function(){v.hasCustomScheduler()||(this._bitField=134217728|this._bitField)},i.prototype._receiverAt=function(t){var e=0===t?this._receiver0:this[4*t-4+3];return e===h?void 0:void 0===e&&this._isBound()?this._boundValue():e},i.prototype._promiseAt=function(t){return this[4*t-4+2]},i.prototype._fulfillmentHandlerAt=function(t){return this[4*t-4+0]},i.prototype._rejectionHandlerAt=function(t){return this[4*t-4+1]},i.prototype._boundValue=function(){},i.prototype._migrateCallback0=function(t){var e=(t._bitField,t._fulfillmentHandler0),n=t._rejectionHandler0,r=t._promise0,i=t._receiverAt(0);void 0===i&&(i=h),this._addCallbacks(e,n,r,i,null)},i.prototype._migrateCallbackAt=function(t,e){var n=t._fulfillmentHandlerAt(e),r=t._rejectionHandlerAt(e),i=t._promiseAt(e),o=t._receiverAt(e);void 0===o&&(o=h),this._addCallbacks(n,r,i,o,null)},i.prototype._addCallbacks=function(t,e,n,r,i){var o=this._length();if(o>=65531&&(o=0,this._setLength(0)),0===o)this._promise0=n,this._receiver0=r,"function"==typeof t&&(this._fulfillmentHandler0=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this._rejectionHandler0=null===i?e:f.domainBind(i,e));else{var s=4*o-4;this[s+2]=n,this[s+3]=r,"function"==typeof t&&(this[s+0]=null===i?t:f.domainBind(i,t)),"function"==typeof e&&(this[s+1]=null===i?e:f.domainBind(i,e))}return this._setLength(o+1),o},i.prototype._proxy=function(t,e){this._addCallbacks(void 0,void 0,e,t,null)},i.prototype._resolveCallback=function(t,e){if(0===(117506048&this._bitField)){if(t===this)return this._rejectCallback(l(),!1);var n=j(t,this);if(!(n instanceof i))return this._fulfill(t);e&&this._propagateFrom(n,2);var r=n._target();if(r===this)return void this._reject(l());var o=r._bitField;if(0===(50397184&o)){var s=this._length();s>0&&r._migrateCallback0(this);for(var a=1;s>a;++a)r._migrateCallbackAt(this,a);this._setFollowing(),this._setLength(0),this._setFollowee(r)}else if(0!==(33554432&o))this._fulfill(r._value());else if(0!==(16777216&o))this._reject(r._reason());else{var c=new g("late cancellation observer");r._attachExtraTrace(c),this._reject(c)}}},i.prototype._rejectCallback=function(t,e,n){var r=f.ensureErrorObject(t),i=r===t;if(!i&&!n&&T.warnings()){var o="a promise was rejected with a non-error: "+f.classString(t);this._warn(o,!0)}this._attachExtraTrace(r,e?i:!1),this._reject(t)},i.prototype._resolveFromExecutor=function(t){if(t!==b){var e=this;this._captureStackTrace(),this._pushContext();var n=!0,r=this._execute(t,function(t){e._resolveCallback(t)},function(t){e._rejectCallback(t,n)});n=!1,this._popContext(),void 0!==r&&e._rejectCallback(r,!0)}},i.prototype._settlePromiseFromHandler=function(t,e,n,r){var i=r._bitField;if(0===(65536&i)){r._pushContext();var o;e===w?n&&"number"==typeof n.length?o=O(t).apply(this._boundValue(),n):(o=R,o.e=new m("cannot .spread() a non-array: "+f.classString(n))):o=O(t).call(e,n);var s=r._popContext();i=r._bitField,0===(65536&i)&&(o===C?r._reject(n):o===R?r._rejectCallback(o.e,!1):(T.checkForgottenReturns(o,s,"",r,this),r._resolveCallback(o)))}},i.prototype._target=function(){for(var t=this;t._isFollowing();)t=t._followee();return t},i.prototype._followee=function(){return this._rejectionHandler0},i.prototype._setFollowee=function(t){this._rejectionHandler0=t},i.prototype._settlePromise=function(t,e,r,o){var s=t instanceof i,a=this._bitField,c=0!==(134217728&a);0!==(65536&a)?(s&&t._invokeInternalOnCancel(),r instanceof x&&r.isFinallyHandler()?(r.cancelPromise=t,O(e).call(r,o)===R&&t._reject(R.e)):e===u?t._fulfill(u.call(r)):r instanceof n?r._promiseCancelled(t):s||t instanceof E?t._cancel():r.cancel()):"function"==typeof e?s?(c&&t._setAsyncGuaranteed(),this._settlePromiseFromHandler(e,r,o,t)):e.call(r,o,t):r instanceof n?r._isResolved()||(0!==(33554432&a)?r._promiseFulfilled(o,t):r._promiseRejected(o,t)):s&&(c&&t._setAsyncGuaranteed(),0!==(33554432&a)?t._fulfill(o):t._reject(o))},i.prototype._settlePromiseLateCancellationObserver=function(t){var e=t.handler,n=t.promise,r=t.receiver,o=t.value;"function"==typeof e?n instanceof i?this._settlePromiseFromHandler(e,r,o,n):e.call(r,o,n):n instanceof i&&n._reject(o)},i.prototype._settlePromiseCtx=function(t){this._settlePromise(t.promise,t.handler,t.receiver,t.value)},i.prototype._settlePromise0=function(t,e,n){var r=this._promise0,i=this._receiverAt(0);this._promise0=void 0,this._receiver0=void 0,this._settlePromise(r,t,i,e)},i.prototype._clearCallbackDataAtIndex=function(t){var e=4*t-4;this[e+2]=this[e+3]=this[e+0]=this[e+1]=void 0},i.prototype._fulfill=function(t){var e=this._bitField;if(!((117506048&e)>>>16)){if(t===this){var n=l();return this._attachExtraTrace(n),this._reject(n)}this._setFulfilled(),this._rejectionHandler0=t,(65535&e)>0&&(0!==(134217728&e)?this._settlePromises():v.settlePromises(this),this._dereferenceTrace())}},i.prototype._reject=function(t){var e=this._bitField;if(!((117506048&e)>>>16))return this._setRejected(),this._fulfillmentHandler0=t,this._isFinal()?v.fatalError(t,f.isNode):void((65535&e)>0?v.settlePromises(this):this._ensurePossibleRejectionHandled())},i.prototype._fulfillPromises=function(t,e){for(var n=1;t>n;n++){var r=this._fulfillmentHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._rejectPromises=function(t,e){for(var n=1;t>n;n++){var r=this._rejectionHandlerAt(n),i=this._promiseAt(n),o=this._receiverAt(n);this._clearCallbackDataAtIndex(n),this._settlePromise(i,r,o,e)}},i.prototype._settlePromises=function(){var t=this._bitField,e=65535&t;if(e>0){if(0!==(16842752&t)){var n=this._fulfillmentHandler0;this._settlePromise0(this._rejectionHandler0,n,t),this._rejectPromises(e,n)}else{var r=this._rejectionHandler0;this._settlePromise0(this._fulfillmentHandler0,r,t),this._fulfillPromises(e,r)}this._setLength(0)}this._clearCancellationData()},i.prototype._settledValue=function(){var t=this._bitField;return 0!==(33554432&t)?this._rejectionHandler0:0!==(16777216&t)?this._fulfillmentHandler0:void 0},"undefined"!=typeof Symbol&&Symbol.toStringTag&&_.defineProperty(i.prototype,Symbol.toStringTag,{get:function(){return"Object"}}),i.defer=i.pending=function(){T.deprecated("Promise.defer","new Promise");var t=new i(b);return{promise:t,resolve:o,reject:s}},f.notEnumerableProp(i,"_makeSelfResolutionError",l),t("./method")(i,b,j,p,T),t("./bind")(i,b,j,T),t("./cancel")(i,E,p,T),t("./direct_resolve")(i),t("./synchronous_inspection")(i),t("./join")(i,E,j,b,v,c),i.Promise=i,i.version="3.5.5",t("./call_get.js")(i),t("./generators.js")(i,p,b,j,n,T),t("./map.js")(i,E,p,j,b,T),t("./nodeify.js")(i),t("./promisify.js")(i,b),t("./props.js")(i,E,j,p),t("./race.js")(i,b,j,p),t("./reduce.js")(i,E,p,j,b,T),t("./settle.js")(i,E,T),t("./some.js")(i,E,p),t("./timers.js")(i,b,T),t("./using.js")(i,p,j,F,b,T),t("./any.js")(i),t("./each.js")(i,b),t("./filter.js")(i,b),f.toFastProperties(i),f.toFastProperties(i.prototype),a({a:1}),a({b:2}),a({c:3}),a(1),a(function(){}),a(void 0),a(!1),a(new i(b)),T.setBounds(d.firstLineError,f.lastLineError),i}},{"./any.js":1,"./async":2,"./bind":3,"./call_get.js":5,"./cancel":6,"./catch_filter":7,"./context":8,"./debuggability":9,"./direct_resolve":10,"./each.js":11,"./errors":12,"./es5":13,"./filter.js":14,"./finally":15,"./generators.js":16,"./join":17,"./map.js":18,"./method":19,"./nodeback":20,"./nodeify.js":21,"./promise_array":23,"./promisify.js":24,"./props.js":25,"./race.js":27,"./reduce.js":28,"./settle.js":30,"./some.js":31,"./synchronous_inspection":32,"./thenables":33,"./timers.js":34,"./using.js":35,"./util":36}],23:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o){function s(t){switch(t){case-2:return[];case-3:return{};case-6:return new Map}}function a(t){var r=this._promise=new e(n);t instanceof e&&r._propagateFrom(t,3),r._setOnCancel(this),this._values=t,this._length=0,this._totalResolved=0,this._init(void 0,-2)}var c=t("./util");c.isArray;return c.inherits(a,o),a.prototype.length=function(){return this._length},a.prototype.promise=function(){return this._promise},a.prototype._init=function l(t,n){var o=r(this._values,this._promise);if(o instanceof e){o=o._target();var a=o._bitField;if(this._values=o,0===(50397184&a))return this._promise._setAsyncGuaranteed(),o._then(l,this._reject,void 0,this,n);if(0===(33554432&a))return 0!==(16777216&a)?this._reject(o._reason()):this._cancel();o=o._value()}if(o=c.asArray(o),null===o){var u=i("expecting an array or an iterable object but got "+c.classString(o)).reason();return void this._promise._rejectCallback(u,!1)}return 0===o.length?void(-5===n?this._resolveEmptyArray():this._resolve(s(n))):void this._iterate(o)},a.prototype._iterate=function(t){var n=this.getActualLength(t.length);this._length=n,this._values=this.shouldCopyValues()?new Array(n):this._values;for(var i=this._promise,o=!1,s=null,a=0;n>a;++a){var c=r(t[a],i);c instanceof e?(c=c._target(),s=c._bitField):s=null,o?null!==s&&c.suppressUnhandledRejections():null!==s?0===(50397184&s)?(c._proxy(this,a),this._values[a]=c):o=0!==(33554432&s)?this._promiseFulfilled(c._value(),a):0!==(16777216&s)?this._promiseRejected(c._reason(),a):this._promiseCancelled(a):o=this._promiseFulfilled(c,a)}o||i._setAsyncGuaranteed()},a.prototype._isResolved=function(){return null===this._values},a.prototype._resolve=function(t){this._values=null,this._promise._fulfill(t)},a.prototype._cancel=function(){!this._isResolved()&&this._promise._isCancellable()&&(this._values=null,this._promise._cancel())},a.prototype._reject=function(t){this._values=null,this._promise._rejectCallback(t,!1)},a.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},a.prototype._promiseCancelled=function(){return this._cancel(),!0},a.prototype._promiseRejected=function(t){return this._totalResolved++,this._reject(t),!0},a.prototype._resultCancelled=function(){if(!this._isResolved()){var t=this._values;if(this._cancel(),t instanceof e)t.cancel();else for(var n=0;n<t.length;++n)t[n]instanceof e&&t[n].cancel()}},a.prototype.shouldCopyValues=function(){return!0},a.prototype.getActualLength=function(t){return t},a}},{"./util":36}],24:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t){return!C.test(t)}function i(t){try{return t.__isPromisified__===!0}catch(e){return!1}}function o(t,e,n){var r=f.getDataPropertyOrDefault(t,e+n,b);return r?i(r):!1}function s(t,e,n){for(var r=0;r<t.length;r+=2){var i=t[r];if(n.test(i))for(var o=i.replace(n,""),s=0;s<t.length;s+=2)if(t[s]===o)throw new m("Cannot promisify an API that has normal methods with '%s'-suffix\n\n    See http://goo.gl/MqrFmX\n".replace("%s",e))}}function a(t,e,n,r){for(var a=f.inheritedDataKeys(t),c=[],l=0;l<a.length;++l){var u=a[l],p=t[u],h=r===j?!0:j(u,p,t);"function"!=typeof p||i(p)||o(t,u,e)||!r(u,p,t,h)||c.push(u,p)}return s(c,e,n),c}function c(t,r,i,o,s,a){function c(){var i=r;r===h&&(i=this);var o=new e(n);o._captureStackTrace();var s="string"==typeof u&&this!==l?this[u]:t,c=_(o,a);try{s.apply(i,d(arguments,c))}catch(p){o._rejectCallback(v(p),!0,!0)}return o._isFateSealed()||o._setAsyncGuaranteed(),o}var l=function(){return this}(),u=t;return"string"==typeof u&&(t=o),f.notEnumerableProp(c,"__isPromisified__",!0),c}function l(t,e,n,r,i){for(var o=new RegExp(E(e)+"$"),s=a(t,e,o,n),c=0,l=s.length;l>c;c+=2){var u=s[c],p=s[c+1],_=u+e;if(r===k)t[_]=k(u,h,u,p,e,i);else{var d=r(p,function(){return k(u,h,u,p,e,i)});f.notEnumerableProp(d,"__isPromisified__",!0),t[_]=d}}return f.toFastProperties(t),t}function u(t,e,n){return k(t,e,void 0,t,null,n)}var p,h={},f=t("./util"),_=t("./nodeback"),d=f.withAppended,v=f.maybeWrapAsError,y=f.canEvaluate,m=t("./errors").TypeError,g="Async",b={__isPromisified__:!0},w=["arity","length","name","arguments","caller","callee","prototype","__isPromisified__"],C=new RegExp("^(?:"+w.join("|")+")$"),j=function(t){return f.isIdentifier(t)&&"_"!==t.charAt(0)&&"constructor"!==t},E=function(t){return t.replace(/([$])/,"\\$")},k=y?p:c;e.promisify=function(t,e){if("function"!=typeof t)throw new m("expecting a function but got "+f.classString(t));if(i(t))return t;e=Object(e);var n=void 0===e.context?h:e.context,o=!!e.multiArgs,s=u(t,n,o);return f.copyDescriptors(t,s,r),s},e.promisifyAll=function(t,e){if("function"!=typeof t&&"object"!=typeof t)throw new m("the target of promisifyAll must be an object or a function\n\n    See http://goo.gl/MqrFmX\n");e=Object(e);var n=!!e.multiArgs,r=e.suffix;"string"!=typeof r&&(r=g);var i=e.filter;"function"!=typeof i&&(i=j);var o=e.promisifier;if("function"!=typeof o&&(o=k),!f.isIdentifier(r))throw new RangeError("suffix must be a valid identifier\n\n    See http://goo.gl/MqrFmX\n");for(var s=f.inheritedDataKeys(t),a=0;a<s.length;++a){var c=t[s[a]];"constructor"!==s[a]&&f.isClass(c)&&(l(c.prototype,r,i,o,n),l(c,r,i,o,n))}return l(t,r,i,o,n)}}},{"./errors":12,"./nodeback":20,"./util":36}],25:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t){var e,n=!1;if(void 0!==a&&t instanceof a)e=p(t),n=!0;else{var r=u.keys(t),i=r.length;e=new Array(2*i);for(var o=0;i>o;++o){var s=r[o];e[o]=t[s],e[o+i]=s}}this.constructor$(e),this._isMap=n,this._init$(void 0,n?-6:-3)}function s(t){var n,s=r(t);return l(s)?(n=s instanceof e?s._then(e.props,void 0,void 0,void 0,void 0):new o(s).promise(),s instanceof e&&n._propagateFrom(s,2),n):i("cannot await properties of a non-object\n\n    See http://goo.gl/MqrFmX\n")}var a,c=t("./util"),l=c.isObject,u=t("./es5");"function"==typeof Map&&(a=Map);var p=function(){function t(t,r){this[e]=t,this[e+n]=r,e++}var e=0,n=0;return function(r){n=r.size,e=0;var i=new Array(2*r.size);return r.forEach(t,i),i}}(),h=function(t){for(var e=new a,n=t.length/2|0,r=0;n>r;++r){var i=t[n+r],o=t[r];e.set(i,o)}return e};c.inherits(o,n),o.prototype._init=function(){},o.prototype._promiseFulfilled=function(t,e){this._values[e]=t;var n=++this._totalResolved;if(n>=this._length){var r;if(this._isMap)r=h(this._values);else{r={};for(var i=this.length(),o=0,s=this.length();s>o;++o)r[this._values[o+i]]=this._values[o]}return this._resolve(r),!0}return!1},o.prototype.shouldCopyValues=function(){return!1},o.prototype.getActualLength=function(t){return t>>1},e.prototype.props=function(){return s(this)},e.props=function(t){return s(t)}}},{"./es5":13,"./util":36}],26:[function(t,e,n){"use strict";function r(t,e,n,r,i){for(var o=0;i>o;++o)n[o+r]=t[o+e],t[o+e]=void 0}function i(t){this._capacity=t,this._length=0,this._front=0}i.prototype._willBeOverCapacity=function(t){return this._capacity<t},i.prototype._pushOne=function(t){var e=this.length();this._checkCapacity(e+1);var n=this._front+e&this._capacity-1;this[n]=t,this._length=e+1},i.prototype.push=function(t,e,n){var r=this.length()+3;if(this._willBeOverCapacity(r))return this._pushOne(t),this._pushOne(e),void this._pushOne(n);var i=this._front+r-3;this._checkCapacity(r);var o=this._capacity-1;this[i+0&o]=t,this[i+1&o]=e,this[i+2&o]=n,this._length=r},i.prototype.shift=function(){var t=this._front,e=this[t];return this[t]=void 0,this._front=t+1&this._capacity-1,this._length--,e},i.prototype.length=function(){return this._length},i.prototype._checkCapacity=function(t){this._capacity<t&&this._resizeTo(this._capacity<<1)},i.prototype._resizeTo=function(t){var e=this._capacity;this._capacity=t;var n=this._front,i=this._length,o=n+i&e-1;r(this,0,this,e,o)},e.exports=i},{}],27:[function(t,e,n){"use strict";e.exports=function(e,n,r,i){function o(t,o){var c=r(t);if(c instanceof e)return a(c);if(t=s.asArray(t),null===t)return i("expecting an array or an iterable object but got "+s.classString(t));var l=new e(n);void 0!==o&&l._propagateFrom(o,3);for(var u=l._fulfill,p=l._reject,h=0,f=t.length;f>h;++h){var _=t[h];(void 0!==_||h in t)&&e.cast(_)._then(u,p,void 0,l,null)}return l}var s=t("./util"),a=function(t){return t.then(function(e){return o(e,t)})};e.race=function(t){return o(t,void 0)},e.prototype.race=function(){return o(this,void 0)}}},{"./util":36}],28:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t,n,r,i){this.constructor$(t);var s=h();this._fn=null===s?n:f.domainBind(s,n),void 0!==r&&(r=e.resolve(r),r._attachCancellationCallback(this)),this._initialValue=r,this._currentCancellable=null,i===o?this._eachValues=Array(this._length):0===i?this._eachValues=null:this._eachValues=void 0,this._promise._captureStackTrace(),this._init$(void 0,-5)}function c(t,e){this.isFulfilled()?e._resolve(t):e._reject(t)}function l(t,e,n,i){if("function"!=typeof e)return r("expecting a function but got "+f.classString(e));var o=new a(t,e,n,i);return o.promise()}function u(t){this.accum=t,this.array._gotAccum(t);var n=i(this.value,this.array._promise);return n instanceof e?(this.array._currentCancellable=n,n._then(p,void 0,void 0,this,void 0)):p.call(this,n)}function p(t){var n=this.array,r=n._promise,i=_(n._fn);r._pushContext();var o;o=void 0!==n._eachValues?i.call(r._boundValue(),t,this.index,this.length):i.call(r._boundValue(),this.accum,t,this.index,this.length),o instanceof e&&(n._currentCancellable=o);var a=r._popContext();return s.checkForgottenReturns(o,a,void 0!==n._eachValues?"Promise.each":"Promise.reduce",r),o}var h=e._getDomain,f=t("./util"),_=f.tryCatch;f.inherits(a,n),a.prototype._gotAccum=function(t){void 0!==this._eachValues&&null!==this._eachValues&&t!==o&&this._eachValues.push(t)},a.prototype._eachComplete=function(t){return null!==this._eachValues&&this._eachValues.push(t),this._eachValues},a.prototype._init=function(){},a.prototype._resolveEmptyArray=function(){this._resolve(void 0!==this._eachValues?this._eachValues:this._initialValue)},a.prototype.shouldCopyValues=function(){return!1},a.prototype._resolve=function(t){this._promise._resolveCallback(t),this._values=null},a.prototype._resultCancelled=function(t){return t===this._initialValue?this._cancel():void(this._isResolved()||(this._resultCancelled$(),this._currentCancellable instanceof e&&this._currentCancellable.cancel(),this._initialValue instanceof e&&this._initialValue.cancel()))},a.prototype._iterate=function(t){this._values=t;var n,r,i=t.length;if(void 0!==this._initialValue?(n=this._initialValue,r=0):(n=e.resolve(t[0]),r=1),this._currentCancellable=n,!n.isRejected())for(;i>r;++r){var o={accum:null,value:t[r],index:r,length:i,array:this};n=n._then(u,void 0,void 0,o,void 0)}void 0!==this._eachValues&&(n=n._then(this._eachComplete,void 0,void 0,this,void 0)),n._then(c,c,void 0,n,this)},e.prototype.reduce=function(t,e){return l(this,t,e,null)},e.reduce=function(t,e,n,r){return l(t,e,n,r)}}},{"./util":36}],29:[function(t,e,n){"use strict";var r,i=t("./util"),o=function(){throw new Error("No async scheduler available\n\n    See http://goo.gl/MqrFmX\n")},s=i.getNativePromise();if(i.isNode&&"undefined"==typeof MutationObserver){var a=global.setImmediate,c=process.nextTick;r=i.isRecentNode?function(t){a.call(global,t)}:function(t){c.call(process,t)}}else if("function"==typeof s&&"function"==typeof s.resolve){var l=s.resolve();r=function(t){l.then(t)}}else r="undefined"!=typeof MutationObserver&&("undefined"==typeof window||!window.navigator||!window.navigator.standalone&&!window.cordova)&&"classList"in document.documentElement?function(){var t=document.createElement("div"),e={attributes:!0},n=!1,r=document.createElement("div"),i=new MutationObserver(function(){t.classList.toggle("foo"),n=!1});i.observe(r,e);var o=function(){n||(n=!0,r.classList.toggle("foo"))};return function(n){var r=new MutationObserver(function(){r.disconnect(),n()});r.observe(t,e),o()}}():"undefined"!=typeof setImmediate?function(t){setImmediate(t)}:"undefined"!=typeof setTimeout?function(t){setTimeout(t,0)}:o;e.exports=r},{"./util":36
}],30:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t)}var o=e.PromiseInspection,s=t("./util");s.inherits(i,n),i.prototype._promiseResolved=function(t,e){this._values[t]=e;var n=++this._totalResolved;return n>=this._length?(this._resolve(this._values),!0):!1},i.prototype._promiseFulfilled=function(t,e){var n=new o;return n._bitField=33554432,n._settledValueField=t,this._promiseResolved(e,n)},i.prototype._promiseRejected=function(t,e){var n=new o;return n._bitField=16777216,n._settledValueField=t,this._promiseResolved(e,n)},e.settle=function(t){return r.deprecated(".settle()",".reflect()"),new i(t).promise()},e.prototype.settle=function(){return e.settle(this)}}},{"./util":36}],31:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.constructor$(t),this._howMany=0,this._unwrap=!1,this._initialized=!1}function o(t,e){if((0|e)!==e||0>e)return r("expecting a positive integer\n\n    See http://goo.gl/MqrFmX\n");var n=new i(t),o=n.promise();return n.setHowMany(e),n.init(),o}var s=t("./util"),a=t("./errors").RangeError,c=t("./errors").AggregateError,l=s.isArray,u={};s.inherits(i,n),i.prototype._init=function(){if(this._initialized){if(0===this._howMany)return void this._resolve([]);this._init$(void 0,-5);var t=l(this._values);!this._isResolved()&&t&&this._howMany>this._canPossiblyFulfill()&&this._reject(this._getRangeError(this.length()))}},i.prototype.init=function(){this._initialized=!0,this._init()},i.prototype.setUnwrap=function(){this._unwrap=!0},i.prototype.howMany=function(){return this._howMany},i.prototype.setHowMany=function(t){this._howMany=t},i.prototype._promiseFulfilled=function(t){return this._addFulfilled(t),this._fulfilled()===this.howMany()?(this._values.length=this.howMany(),1===this.howMany()&&this._unwrap?this._resolve(this._values[0]):this._resolve(this._values),!0):!1},i.prototype._promiseRejected=function(t){return this._addRejected(t),this._checkOutcome()},i.prototype._promiseCancelled=function(){return this._values instanceof e||null==this._values?this._cancel():(this._addRejected(u),this._checkOutcome())},i.prototype._checkOutcome=function(){if(this.howMany()>this._canPossiblyFulfill()){for(var t=new c,e=this.length();e<this._values.length;++e)this._values[e]!==u&&t.push(this._values[e]);return t.length>0?this._reject(t):this._cancel(),!0}return!1},i.prototype._fulfilled=function(){return this._totalResolved},i.prototype._rejected=function(){return this._values.length-this.length()},i.prototype._addRejected=function(t){this._values.push(t)},i.prototype._addFulfilled=function(t){this._values[this._totalResolved++]=t},i.prototype._canPossiblyFulfill=function(){return this.length()-this._rejected()},i.prototype._getRangeError=function(t){var e="Input array must contain at least "+this._howMany+" items but contains only "+t+" items";return new a(e)},i.prototype._resolveEmptyArray=function(){this._reject(this._getRangeError(0))},e.some=function(t,e){return o(t,e)},e.prototype.some=function(t){return o(this,t)},e._SomePromiseArray=i}},{"./errors":12,"./util":36}],32:[function(t,e,n){"use strict";e.exports=function(t){function e(t){void 0!==t?(t=t._target(),this._bitField=t._bitField,this._settledValueField=t._isFateSealed()?t._settledValue():void 0):(this._bitField=0,this._settledValueField=void 0)}e.prototype._settledValue=function(){return this._settledValueField};var n=e.prototype.value=function(){if(!this.isFulfilled())throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},r=e.prototype.error=e.prototype.reason=function(){if(!this.isRejected())throw new TypeError("cannot get rejection reason of a non-rejected promise\n\n    See http://goo.gl/MqrFmX\n");return this._settledValue()},i=e.prototype.isFulfilled=function(){return 0!==(33554432&this._bitField)},o=e.prototype.isRejected=function(){return 0!==(16777216&this._bitField)},s=e.prototype.isPending=function(){return 0===(50397184&this._bitField)},a=e.prototype.isResolved=function(){return 0!==(50331648&this._bitField)};e.prototype.isCancelled=function(){return 0!==(8454144&this._bitField)},t.prototype.__isCancelled=function(){return 65536===(65536&this._bitField)},t.prototype._isCancelled=function(){return this._target().__isCancelled()},t.prototype.isCancelled=function(){return 0!==(8454144&this._target()._bitField)},t.prototype.isPending=function(){return s.call(this._target())},t.prototype.isRejected=function(){return o.call(this._target())},t.prototype.isFulfilled=function(){return i.call(this._target())},t.prototype.isResolved=function(){return a.call(this._target())},t.prototype.value=function(){return n.call(this._target())},t.prototype.reason=function(){var t=this._target();return t._unsetRejectionIsUnhandled(),r.call(t)},t.prototype._value=function(){return this._settledValue()},t.prototype._reason=function(){return this._unsetRejectionIsUnhandled(),this._settledValue()},t.PromiseInspection=e}},{}],33:[function(t,e,n){"use strict";e.exports=function(e,n){function r(t,r){if(u(t)){if(t instanceof e)return t;var i=o(t);if(i===l){r&&r._pushContext();var c=e.reject(i.e);return r&&r._popContext(),c}if("function"==typeof i){if(s(t)){var c=new e(n);return t._then(c._fulfill,c._reject,void 0,c,null),c}return a(t,i,r)}}return t}function i(t){return t.then}function o(t){try{return i(t)}catch(e){return l.e=e,l}}function s(t){try{return p.call(t,"_promise0")}catch(e){return!1}}function a(t,r,i){function o(t){a&&(a._resolveCallback(t),a=null)}function s(t){a&&(a._rejectCallback(t,p,!0),a=null)}var a=new e(n),u=a;i&&i._pushContext(),a._captureStackTrace(),i&&i._popContext();var p=!0,h=c.tryCatch(r).call(t,o,s);return p=!1,a&&h===l&&(a._rejectCallback(h.e,!0,!0),a=null),u}var c=t("./util"),l=c.errorObj,u=c.isObject,p={}.hasOwnProperty;return r}},{"./util":36}],34:[function(t,e,n){"use strict";e.exports=function(e,n,r){function i(t){this.handle=t}function o(t){return clearTimeout(this.handle),t}function s(t){throw clearTimeout(this.handle),t}var a=t("./util"),c=e.TimeoutError;i.prototype._resultCancelled=function(){clearTimeout(this.handle)};var l=function(t){return u(+this).thenReturn(t)},u=e.delay=function(t,o){var s,a;return void 0!==o?(s=e.resolve(o)._then(l,null,null,t,void 0),r.cancellation()&&o instanceof e&&s._setOnCancel(o)):(s=new e(n),a=setTimeout(function(){s._fulfill()},+t),r.cancellation()&&s._setOnCancel(new i(a)),s._captureStackTrace()),s._setAsyncGuaranteed(),s};e.prototype.delay=function(t){return u(t,this)};var p=function(t,e,n){var r;r="string"!=typeof e?e instanceof Error?e:new c("operation timed out"):new c(e),a.markAsOriginatingFromRejection(r),t._attachExtraTrace(r),t._reject(r),null!=n&&n.cancel()};e.prototype.timeout=function(t,e){t=+t;var n,a,c=new i(setTimeout(function(){n.isPending()&&p(n,e,a)},t));return r.cancellation()?(a=this.then(),n=a._then(o,s,void 0,c,void 0),n._setOnCancel(c)):n=this._then(o,s,void 0,c,void 0),n}}},{"./util":36}],35:[function(t,e,n){"use strict";e.exports=function(e,n,r,i,o,s){function a(t){setTimeout(function(){throw t},0)}function c(t){var e=r(t);return e!==t&&"function"==typeof t._isDisposable&&"function"==typeof t._getDisposer&&t._isDisposable()&&e._setDisposable(t._getDisposer()),e}function l(t,n){function i(){if(s>=l)return u._fulfill();var o=c(t[s++]);if(o instanceof e&&o._isDisposable()){try{o=r(o._getDisposer().tryDispose(n),t.promise)}catch(p){return a(p)}if(o instanceof e)return o._then(i,a,null,null,null)}i()}var s=0,l=t.length,u=new e(o);return i(),u}function u(t,e,n){this._data=t,this._promise=e,this._context=n}function p(t,e,n){this.constructor$(t,e,n)}function h(t){return u.isDisposer(t)?(this.resources[this.index]._setDisposable(t),t.promise()):t}function f(t){this.length=t,this.promise=null,this[t-1]=null}var _=t("./util"),d=t("./errors").TypeError,v=t("./util").inherits,y=_.errorObj,m=_.tryCatch,g={};u.prototype.data=function(){return this._data},u.prototype.promise=function(){return this._promise},u.prototype.resource=function(){return this.promise().isFulfilled()?this.promise().value():g},u.prototype.tryDispose=function(t){var e=this.resource(),n=this._context;void 0!==n&&n._pushContext();var r=e!==g?this.doDispose(e,t):null;return void 0!==n&&n._popContext(),this._promise._unsetDisposable(),this._data=null,r},u.isDisposer=function(t){return null!=t&&"function"==typeof t.resource&&"function"==typeof t.tryDispose},v(p,u),p.prototype.doDispose=function(t,e){var n=this.data();return n.call(t,t,e)},f.prototype._resultCancelled=function(){for(var t=this.length,n=0;t>n;++n){var r=this[n];r instanceof e&&r.cancel()}},e.using=function(){var t=arguments.length;if(2>t)return n("you must pass at least 2 arguments to Promise.using");var i=arguments[t-1];if("function"!=typeof i)return n("expecting a function but got "+_.classString(i));var o,a=!0;2===t&&Array.isArray(arguments[0])?(o=arguments[0],t=o.length,a=!1):(o=arguments,t--);for(var c=new f(t),p=0;t>p;++p){var d=o[p];if(u.isDisposer(d)){var v=d;d=d.promise(),d._setDisposable(v)}else{var g=r(d);g instanceof e&&(d=g._then(h,null,null,{resources:c,index:p},void 0))}c[p]=d}for(var b=new Array(c.length),p=0;p<b.length;++p)b[p]=e.resolve(c[p]).reflect();var w=e.all(b).then(function(t){for(var e=0;e<t.length;++e){var n=t[e];if(n.isRejected())return y.e=n.error(),y;if(!n.isFulfilled())return void w.cancel();t[e]=n.value()}C._pushContext(),i=m(i);var r=a?i.apply(void 0,t):i(t),o=C._popContext();return s.checkForgottenReturns(r,o,"Promise.using",C),r}),C=w.lastly(function(){var t=new e.PromiseInspection(w);return l(c,t)});return c.promise=C,C._setOnCancel(c),C},e.prototype._setDisposable=function(t){this._bitField=131072|this._bitField,this._disposer=t},e.prototype._isDisposable=function(){return(131072&this._bitField)>0},e.prototype._getDisposer=function(){return this._disposer},e.prototype._unsetDisposable=function(){this._bitField=-131073&this._bitField,this._disposer=void 0},e.prototype.disposer=function(t){if("function"==typeof t)return new p(t,this,i());throw new d}}},{"./errors":12,"./util":36}],36:[function(t,e,n){"use strict";function r(){try{var t=P;return P=null,t.apply(this,arguments)}catch(e){return x.e=e,x}}function i(t){return P=t,r}function o(t){return null==t||t===!0||t===!1||"string"==typeof t||"number"==typeof t}function s(t){return"function"==typeof t||"object"==typeof t&&null!==t}function a(t){return o(t)?new Error(v(t)):t}function c(t,e){var n,r=t.length,i=new Array(r+1);for(n=0;r>n;++n)i[n]=t[n];return i[n]=e,i}function l(t,e,n){if(!F.isES5)return{}.hasOwnProperty.call(t,e)?t[e]:void 0;var r=Object.getOwnPropertyDescriptor(t,e);return null!=r?null==r.get&&null==r.set?r.value:n:void 0}function u(t,e,n){if(o(t))return t;var r={value:n,configurable:!0,enumerable:!1,writable:!0};return F.defineProperty(t,e,r),t}function p(t){throw t}function h(t){try{if("function"==typeof t){var e=F.names(t.prototype),n=F.isES5&&e.length>1,r=e.length>0&&!(1===e.length&&"constructor"===e[0]),i=A.test(t+"")&&F.names(t).length>0;if(n||r||i)return!0}return!1}catch(o){return!1}}function f(t){function e(){}function n(){return typeof r.foo}e.prototype=t;var r=new e;return n(),n(),t}function _(t){return D.test(t)}function d(t,e,n){for(var r=new Array(t),i=0;t>i;++i)r[i]=e+i+n;return r}function v(t){try{return t+""}catch(e){return"[no string representation]"}}function y(t){return t instanceof Error||null!==t&&"object"==typeof t&&"string"==typeof t.message&&"string"==typeof t.name}function m(t){try{u(t,"isOperational",!0)}catch(e){}}function g(t){return null==t?!1:t instanceof Error.__BluebirdErrorTypes__.OperationalError||t.isOperational===!0}function b(t){return y(t)&&F.propertyIsWritable(t,"stack")}function w(t){return{}.toString.call(t)}function C(t,e,n){for(var r=F.names(t),i=0;i<r.length;++i){var o=r[i];if(n(o))try{F.defineProperty(e,o,F.getDescriptor(t,o))}catch(s){}}}function j(t){return H?process.env[t]:void 0}function E(){if("function"==typeof Promise)try{var t=new Promise(function(){});if("[object Promise]"==={}.toString.call(t))return Promise}catch(e){}}function k(t,e){return t.bind(e)}var F=t("./es5"),T="undefined"==typeof navigator,x={e:{}},P,S="undefined"!=typeof self?self:"undefined"!=typeof window?window:"undefined"!=typeof global?global:void 0!==this?this:null,R=function(t,e){function n(){this.constructor=t,this.constructor$=e;for(var n in e.prototype)r.call(e.prototype,n)&&"$"!==n.charAt(n.length-1)&&(this[n+"$"]=e.prototype[n])}var r={}.hasOwnProperty;return n.prototype=e.prototype,t.prototype=new n,t.prototype},O=function(){var t=[Array.prototype,Object.prototype,Function.prototype],e=function(e){for(var n=0;n<t.length;++n)if(t[n]===e)return!0;return!1};if(F.isES5){var n=Object.getOwnPropertyNames;return function(t){for(var r=[],i=Object.create(null);null!=t&&!e(t);){var o;try{o=n(t)}catch(s){return r}for(var a=0;a<o.length;++a){var c=o[a];if(!i[c]){i[c]=!0;var l=Object.getOwnPropertyDescriptor(t,c);null!=l&&null==l.get&&null==l.set&&r.push(c)}}t=F.getPrototypeOf(t)}return r}}var r={}.hasOwnProperty;return function(n){if(e(n))return[];var i=[];t:for(var o in n)if(r.call(n,o))i.push(o);else{for(var s=0;s<t.length;++s)if(r.call(t[s],o))continue t;i.push(o)}return i}}(),A=/this\s*\.\s*\S+\s*=/,D=/^[a-z$_][a-z$_0-9]*$/i,V=function(){return"stack"in new Error?function(t){return b(t)?t:new Error(v(t))}:function(t){if(b(t))return t;try{throw new Error(v(t))}catch(e){return e}}}(),I=function(t){return F.isArray(t)?t:null};if("undefined"!=typeof Symbol&&Symbol.iterator){var L="function"==typeof Array.from?function(t){return Array.from(t)}:function(t){for(var e,n=[],r=t[Symbol.iterator]();!(e=r.next()).done;)n.push(e.value);return n};I=function(t){return F.isArray(t)?t:null!=t&&"function"==typeof t[Symbol.iterator]?L(t):null}}var N="undefined"!=typeof process&&"[object process]"===w(process).toLowerCase(),H="undefined"!=typeof process&&"undefined"!=typeof process.env,B={isClass:h,isIdentifier:_,inheritedDataKeys:O,getDataPropertyOrDefault:l,thrower:p,isArray:F.isArray,asArray:I,notEnumerableProp:u,isPrimitive:o,isObject:s,isError:y,canEvaluate:T,errorObj:x,tryCatch:i,inherits:R,withAppended:c,maybeWrapAsError:a,toFastProperties:f,filledRange:d,toString:v,canAttachTrace:b,ensureErrorObject:V,originatesFromRejection:g,markAsOriginatingFromRejection:m,classString:w,copyDescriptors:C,hasDevTools:"undefined"!=typeof chrome&&chrome&&"function"==typeof chrome.loadTimes,isNode:N,hasEnvVariables:H,env:j,global:S,getNativePromise:E,domainBind:k};B.isRecentNode=B.isNode&&function(){var t;return process.versions&&process.versions.node?t=process.versions.node.split(".").map(Number):process.version&&(t=process.version.split(".").map(Number)),0===t[0]&&t[1]>10||t[0]>0}(),B.isNode&&B.toFastProperties(process);try{throw new Error}catch(U){B.lastLineError=U}e.exports=B},{"./es5":13}]},{},[4])(4)}),"undefined"!=typeof window&&null!==window?window.P=window.Promise:"undefined"!=typeof self&&null!==self&&(self.P=self.Promise);
/*
Copyright © 2013 Adobe Systems Incorporated.
Licensed under the Apache License, Version 2.0 (the “License”);
you may not use this file except in compliance with the License.
You may obtain a copy of the License at
http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an “AS IS” BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/**
 * See <a href="http://jquery.com">http://jquery.com</a>.
 * @name jquery
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 */

/**
 * See <a href="http://jquery.com">http://jquery.com</a>
 * @name fn
 * @class
 * See the jQuery Library  (<a href="http://jquery.com">http://jquery.com</a>) for full details.  This just
 * documents the function and classes that are added to jQuery by this plug-in.
 * @memberOf jquery
 */

/**
 * @fileOverview accessibleMegaMenu plugin
 *
 *<p>Licensed under the Apache License, Version 2.0 (the “License”)
 *<br />Copyright © 2013 Adobe Systems Incorporated.
 *<br />Project page <a href="https://github.com/adobe-accessibility/Accessible-Mega-Menu">https://github.com/adobe-accessibility/Accessible-Mega-Menu</a>
 * @version 0.1
 * @author Michael Jordan
 * @requires jquery
 */

/*jslint browser: true, devel: true, plusplus: true, nomen: true */
/*global jQuery, window, document */
(function ($, window, document) {
    "use strict";
    var pluginName = "accessibleMegaMenu",
        defaults = {
            uuidPrefix: "accessible-megamenu", // unique ID's are required to indicate aria-owns, aria-controls and aria-labelledby
            menuClass: "accessible-megamenu", // default css class used to define the megamenu styling
            topNavItemClass: "accessible-megamenu-top-nav-item", // default css class for a top-level navigation item in the megamenu
            panelClass: "accessible-megamenu-panel", // default css class for a megamenu panel
            panelGroupClass: "accessible-megamenu-panel-group", // default css class for a group of items within a megamenu panel
            hoverClass: "hover", // default css class for the hover state
            focusClass: "focus", // default css class for the focus state
            openClass: "open", // default css class for the open state,
            toggleButtonClass: "accessible-megamenu-toggle", // default css class responsive toggle button
            openDelay: 0, // default open delay when opening menu via mouseover
            closeDelay: 250, // default open delay when opening menu via mouseover
            openOnMouseover: false // default setting for whether menu should open on mouseover
        },
        Keyboard = {
            BACKSPACE: 8,
            COMMA: 188,
            DELETE: 46,
            DOWN: 40,
            END: 35,
            ENTER: 13,
            ESCAPE: 27,
            HOME: 36,
            LEFT: 37,
            PAGE_DOWN: 34,
            PAGE_UP: 33,
            PERIOD: 190,
            RIGHT: 39,
            SPACE: 32,
            TAB: 9,
            UP: 38,
            keyMap: {
                48: "0",
                49: "1",
                50: "2",
                51: "3",
                52: "4",
                53: "5",
                54: "6",
                55: "7",
                56: "8",
                57: "9",
                59: ";",
                65: "a",
                66: "b",
                67: "c",
                68: "d",
                69: "e",
                70: "f",
                71: "g",
                72: "h",
                73: "i",
                74: "j",
                75: "k",
                76: "l",
                77: "m",
                78: "n",
                79: "o",
                80: "p",
                81: "q",
                82: "r",
                83: "s",
                84: "t",
                85: "u",
                86: "v",
                87: "w",
                88: "x",
                89: "y",
                90: "z",
                96: "0",
                97: "1",
                98: "2",
                99: "3",
                100: "4",
                101: "5",
                102: "6",
                103: "7",
                104: "8",
                105: "9",
                190: "."
            }
        },
        clearTimeout = window.clearTimeout,
        setTimeout = window.setTimeout,
        isOpera = window.opera && window.opera.toString() === '[object Opera]';
    /**
     * @desc Creates a new accessible mega menu instance.
     * @param {jquery} element
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @constructor
     */
    function AccessibleMegaMenu(element, options) {
        this.element = element;

        // merge optional settings and defaults into settings
        this.settings = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;

        this.mouseTimeoutID = null;
        this.focusTimeoutID = null;
        this.mouseFocused = false;
        this.justFocused = false;

        this.init();
    }

    AccessibleMegaMenu.prototype = (function () {

        /* private attributes and methods ------------------------ */
        var uuid = 0,
            keydownTimeoutDuration = 1000,
            keydownSearchString = "",
            isTouch = 'ontouchstart' in window || window.navigator.msMaxTouchPoints,
            _getPlugin,
            _addUniqueId,
            _togglePanel,
            _clickHandler,
            _touchmoveHandler,
            _clickOutsideHandler,
            _DOMAttrModifiedHandler,
            _focusInHandler,
            _focusOutHandler,
            _keyDownHandler,
            _mouseDownHandler,
            _mouseOverHandler,
            _mouseOutHandler,
            _clickToggleHandler,
            _toggleExpandedEventHandlers,
            _addEventHandlers,
            _removeEventHandlers;

        /**
         * @name jQuery.fn.accessibleMegaMenu~_getPlugin
         * @desc Returns the parent accessibleMegaMenu instance for a given element
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _getPlugin = function (element) {
            return $(element).closest(':data(plugin_' + pluginName + ')').data("plugin_" + pluginName);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_addUniqueId
         * @desc Adds a unique id and element.
         * The id string starts with the
         * string defined in settings.uuidPrefix.
         * @param {jQuery} element
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _addUniqueId = function (element) {
            element = $(element);
            var settings = this.settings;
            if (!element.attr("id")) {
                element.attr("id", settings.uuidPrefix + "-" + new Date().getTime() + "-" + (++uuid));
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_togglePanel
         * @desc Toggle the display of mega menu panels in response to an event.
         * The optional boolean value 'hide' forces all panels to hide.
         * @param {event} event
         * @param {Boolean} [hide] Hide all mega menu panels when true
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _togglePanel = function (event, hide) {
            var target = $(event.target),
                that = this,
                settings = this.settings,
                menu = this.menu,
                topli = target.closest('.' + settings.topNavItemClass),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                newfocus;

            _toggleExpandedEventHandlers.call(this, true);

            if (hide) {
                topli = menu.find('.' + settings.topNavItemClass + ' .' + settings.openClass + ':first').closest('.' + settings.topNavItemClass);
                if (!(topli.is(event.relatedTarget) || topli.has(event.relatedTarget).length > 0)) {
                    if ((event.type === 'mouseout' || event.type === 'focusout') && topli.has(document.activeElement).length > 0) {
                        return;
                    }
                    topli.find('[aria-expanded]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                    if ((event.type === 'keydown' && event.keyCode === Keyboard.ESCAPE) || event.type === 'DOMAttrModified') {
                        newfocus = topli.find(':tabbable:first');
                        setTimeout(function () {
                            menu.find('[aria-expanded].' + that.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
                            newfocus.focus();
                            that.justFocused = false;
                        }, 99);
                    }
                } else if (topli.length === 0) {
                    menu.find('[aria-expanded=true]')
                        .attr('aria-expanded', 'false')
                        .removeClass(settings.openClass)
                        .filter('.' + settings.panelClass)
                        .attr('aria-hidden', 'true');
                }
            } else {
                clearTimeout(that.focusTimeoutID);
                topli.siblings()
                    .find('[aria-expanded]')
                    .attr('aria-expanded', 'false')
                    .removeClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'true');
                topli.find('[aria-expanded]')
                    .attr('aria-expanded', 'true')
                    .addClass(settings.openClass)
                    .filter('.' + settings.panelClass)
                    .attr('aria-hidden', 'false');

                var pageScrollPosition = $('html')[0].scrollTop;
                var openPanelTopPosition = $('.' + settings.panelClass + '.' + settings.openClass).parent().offset().top;

                if(pageScrollPosition > openPanelTopPosition) {
                    $('html')[0].scrollTop = openPanelTopPosition;
                }

                if (event.type === 'mouseover' && target.is(':tabbable') && topli.length === 1 && panel.length === 0 && menu.has(document.activeElement).length > 0) {
                    target.focus();
                    that.justFocused = false;
                }

                _toggleExpandedEventHandlers.call(that);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickHandler
         * @desc Handle click event on mega menu item
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickHandler = function (event) {
            var target = $(event.target).closest(':tabbable'),
                topli = target.closest('.' + this.settings.topNavItemClass),
                panel = target.closest('.' + this.settings.panelClass);
            if (topli.length === 1
                    && panel.length === 0
                    && topli.find('.' + this.settings.panelClass).length === 1) {
                if (!target.hasClass(this.settings.openClass)) {
                    event.preventDefault();
                    event.stopPropagation();
                    _togglePanel.call(this, event);
                    this.justFocused = false;
                } else {
                    if (this.justFocused) {
                        event.preventDefault();
                        event.stopPropagation();
                        this.justFocused = false;
                    } else if (isTouch || !isTouch && !this.settings.openOnMouseover) {
                        event.preventDefault();
                        event.stopPropagation();
                        _togglePanel.call(this, event, target.hasClass(this.settings.openClass));
                    }
                }
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_touchmoveHandler
         * @desc Handle touch move event on menu
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _touchmoveHandler = function () {
            this.justMoved = true;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickOutsideHandler
         * @desc Handle click event outside of a the megamenu
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickOutsideHandler = function (event) {
            if ($(event.target).closest(this.menu).length === 0) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_DOMAttrModifiedHandler
         * @desc Handle DOMAttrModified event on panel to respond to Windows 8 Narrator ExpandCollapse pattern
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _DOMAttrModifiedHandler = function (event) {
            if (event.originalEvent.attrName === 'aria-expanded'
                    && event.originalEvent.newValue === 'false'
                    && $(event.target).hasClass(this.settings.openClass)) {
                event.preventDefault();
                event.stopPropagation();
                _togglePanel.call(this, event, true);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusInHandler
         * @desc Handle focusin event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusInHandler = function (event) {
            clearTimeout(this.focusTimeoutID);
            var target = $(event.target),
                panel = target.closest('.' + this.settings.panelClass);
            target
                .addClass(this.settings.focusClass);
            this.justFocused = !this.mouseFocused || (!this.settings.openOnMouseover && this.mouseFocused);
            this.mouseFocused = false;
            if (this.justFocused && this.panels.not(panel).filter('.' + this.settings.openClass).length) {
                _togglePanel.call(this, event);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_focusOutHandler
         * @desc Handle focusout event on mega menu item.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _focusOutHandler = function (event) {
            this.justFocused = false;
            var that = this,
                target = $(event.target),
                topli = target.closest('.' + this.settings.topNavItemClass);
            target
                .removeClass(this.settings.focusClass);

            if (window.cvox) {
                // If ChromeVox is running...
                that.focusTimeoutID = setTimeout(function () {
                    window.cvox.Api.getCurrentNode(function (node) {
                        if (topli.has(node).length) {
                            // and the current node being voiced is in
                            // the mega menu, clearTimeout,
                            // so the panel stays open.
                            clearTimeout(that.focusTimeoutID);
                        } else {
                            that.focusTimeoutID = setTimeout(function (scope, event, hide) {
                                _togglePanel.call(scope, event, hide);
                            }, 275, that, event, true);
                        }
                    });
                }, 25);
            } else {
                that.focusTimeoutID = setTimeout(function () {
                    if (that.mouseFocused && event.relatedTarget === null) {
                        return;
                    }
                    _togglePanel.call(that, event, true);
                }, 300);
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_keyDownHandler
         * @desc Handle keydown event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _keyDownHandler = function (event) {
            var that = (this.constructor === AccessibleMegaMenu) ? this : _getPlugin(this), // determine the AccessibleMegaMenu plugin instance
                settings = that.settings,
                target = $($(this).is('.' + settings.hoverClass + ':tabbable') ? this : event.target), // if the element is hovered the target is this, otherwise, its the focused element
                menu = that.menu,
                topnavitems = that.topnavitems,
                topli = target.closest('.' + settings.topNavItemClass),
                tabbables = menu.find(':tabbable'),
                panel = target.hasClass(settings.panelClass) ? target : target.closest('.' + settings.panelClass),
                panelGroups = panel.find('.' + settings.panelGroupClass),
                currentPanelGroup = target.closest('.' + settings.panelGroupClass),
                next,
                keycode = event.keyCode || event.which,
                start,
                i,
                o,
                label,
                found = false,
                newString = Keyboard.keyMap[event.keyCode] || '',
                regex,
                isTopNavItem = (topli.length === 1 && panel.length === 0);

            if (target.is("input:focus, select:focus, textarea:focus, button:focus")) {
                // if the event target is a form element we should handle keydown normally
                return;
            }

            if (target.is('.' + settings.hoverClass + ':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }

            switch (keycode) {
            case Keyboard.ESCAPE:
                this.mouseFocused = false;
                _togglePanel.call(that, event, true);
                break;
            case Keyboard.DOWN:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    _togglePanel.call(that, event);
                    found = (topli.find('.' + settings.panelClass + ' :tabbable:first').focus().length === 1);
                } else {
                    found = (tabbables.filter(':gt(' + tabbables.index(target) + '):first').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.UP:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = (next.find('[aria-expanded]')
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus() === 1);
                    }
                } else if (!isTopNavItem) {
                    found = (tabbables.filter(':lt(' + tabbables.index(target) + '):last').focus().length === 1);
                }

                if (!found && isOpera && (event.ctrlKey || event.metaKey)) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                }
                break;
            case Keyboard.RIGHT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':gt(' + topnavitems.index(topli) + '):first').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the next panel group
                        found = (panelGroups.filter(':gt(' + panelGroups.index(currentPanelGroup) + '):first').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.LEFT:
                event.preventDefault();
                this.mouseFocused = false;
                if (isTopNavItem) {
                    found = (topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last').find(':tabbable:first').focus().length === 1);
                } else {
                    if (panelGroups.length && currentPanelGroup.length) {
                        // if the current panel contains panel groups, and we are able to focus the first tabbable element of the previous panel group
                        found = (panelGroups.filter(':lt(' + panelGroups.index(currentPanelGroup) + '):last').find(':tabbable:first').focus().length === 1);
                    }

                    if (!found) {
                        found = (topli.find(':tabbable:first').focus().length === 1);
                    }
                }
                break;
            case Keyboard.TAB:
                this.mouseFocused = false;
                i = tabbables.index(target);
                if (event.shiftKey && isTopNavItem && target.hasClass(settings.openClass)) {
                    _togglePanel.call(that, event, true);
                    next = topnavitems.filter(':lt(' + topnavitems.index(topli) + '):last');
                    if (next.children('.' + settings.panelClass).length) {
                        found = next.children()
                            .attr('aria-expanded', 'true')
                            .addClass(settings.openClass)
                            .filter('.' + settings.panelClass)
                            .attr('aria-hidden', 'false')
                            .find(':tabbable:last')
                            .focus();
                    }
                } else if (event.shiftKey && i > 0) {
                    found = (tabbables.filter(':lt(' + i + '):last').focus().length === 1);
                } else if (!event.shiftKey && i < tabbables.length - 1) {
                    found = (tabbables.filter(':gt(' + i + '):first').focus().length === 1);
                } else if (isOpera) {
                    tabbables = $(':tabbable');
                    i = tabbables.index(target);
                    if (event.shiftKey) {
                        found = ($(':tabbable:lt(' + $(':tabbable').index(target) + '):last').focus().length === 1);
                    } else {
                        found = ($(':tabbable:gt(' + $(':tabbable').index(target) + '):first').focus().length === 1);
                    }
                }

                if (found) {
                    event.preventDefault();
                }
                break;
            case Keyboard.SPACE:
            case Keyboard.ENTER:
                if (isTopNavItem) {
                    event.preventDefault();
                    _clickHandler.call(that, event);
                } else {
                    return true;
                }
                break;
            default:
                // alphanumeric filter
                clearTimeout(this.keydownTimeoutID);

                keydownSearchString += newString !== keydownSearchString ? newString : '';

                if (keydownSearchString.length === 0) {
                    return;
                }

                this.keydownTimeoutID = setTimeout(function () {
                    keydownSearchString = '';
                }, keydownTimeoutDuration);

                if (isTopNavItem && !target.hasClass(settings.openClass)) {
                    tabbables = tabbables.filter(':not(.' + settings.panelClass + ' :tabbable)');
                } else {
                    tabbables = topli.find(':tabbable');
                }

                if (event.shiftKey) {
                    tabbables = $(tabbables.get()
                        .reverse());
                }

                for (i = 0; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    if (o.is(target)) {
                        start = (keydownSearchString.length === 1) ? i + 1 : i;
                        break;
                    }
                }

                regex = new RegExp('^' + keydownSearchString.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&'), 'i');

                for (i = start; i < tabbables.length; i++) {
                    o = tabbables.eq(i);
                    label = $.trim(o.text());
                    if (regex.test(label)) {
                        found = true;
                        o.focus();
                        break;
                    }
                }
                if (!found) {
                    for (i = 0; i < start; i++) {
                        o = tabbables.eq(i);
                        label = $.trim(o.text());
                        if (regex.test(label)) {
                            o.focus();
                            break;
                        }
                    }
                }
                break;
            }
            that.justFocused = false;
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseDownHandler
         * @desc Handle mousedown event on mega menu.
         * @param {event} Event object
         * @memberof accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseDownHandler = function (event) {
            if ($(event.target).closest(this.settings.panelClass) || $(event.target).closest(":focusable").length) {
                this.mouseFocused = true;
                if ($(event.target).closest(this.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }
            clearTimeout(this.mouseTimeoutID);
            this.mouseTimeoutID = setTimeout(function () {
                clearTimeout(this.focusTimeoutID);
            }, 1);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOverHandler
         * @desc Handle mouseover event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOverHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            this.mouseTimeoutID = setTimeout(function () {
                $(event.target).addClass(that.settings.hoverClass);
                _togglePanel.call(that, event);
                if ($(event.target).closest(that.settings.menuClass)) {
                    $('html').on('keydown.accessible-megamenu', $.proxy(_keyDownHandler, event.target));
                }
            }, this.settings.openDelay);
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_mouseOutHandler
         * @desc Handle mouseout event on mega menu.
         * @param {event} Event object
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _mouseOutHandler = function (event) {
            clearTimeout(this.mouseTimeoutID);
            var that = this;

            if (!that.settings.openOnMouseover) {
                return;
            }

            $(event.target)
                .removeClass(that.settings.hoverClass);

            that.mouseTimeoutID = setTimeout(function () {
                _togglePanel.call(that, event, true);
            }, this.settings.closeDelay);
            if ($(event.target).is(':tabbable')) {
                $('html').off('keydown.accessible-megamenu');
            }
        };

        /**
         * @name jQuery.fn.accessibleMegaMenu~_clickToggleHandler
         * @desc Handle click event on menu toggle button.
         * @memberof jQuery.fn.accessibleMegaMenu
         * @inner
         * @private
         */
        _clickToggleHandler = function () {
            var isExpanded = this.toggleButton.attr('aria-expanded') === 'true';
            this.toggleButton.attr({'aria-expanded': !isExpanded, 'aria-pressed': !isExpanded});
        };

        _toggleExpandedEventHandlers = function (hide) {
            var menu = this.menu;
            if (hide) {
                $('html').off('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu');

                menu.find('[aria-expanded].' + this.settings.panelClass).off('DOMAttrModified.accessible-megamenu');
            } else {
                $('html').on('mouseup.outside-accessible-megamenu, touchend.outside-accessible-megamenu, mspointerup.outside-accessible-megamenu,  pointerup.outside-accessible-megamenu', $.proxy(_clickOutsideHandler, this));

                /* Narrator in Windows 8 automatically toggles the aria-expanded property on double tap or click.
                   To respond to the change to collapse the panel, we must add a listener for a DOMAttrModified event. */
                menu.find('[aria-expanded=true].' + this.settings.panelClass).on('DOMAttrModified.accessible-megamenu', $.proxy(_DOMAttrModifiedHandler, this));
            }
        };

        _addEventHandlers = function() {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.on("focusin.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusInHandler, this))
                .on("focusout.accessible-megamenu", ":focusable, ." + this.settings.panelClass, $.proxy(_focusOutHandler, this))
                .on("keydown.accessible-megamenu", $.proxy(_keyDownHandler, this))
                .on("mouseover.accessible-megamenu", $.proxy(_mouseOverHandler, this))
                .on("mouseout.accessible-megamenu", $.proxy(_mouseOutHandler, this))
                .on("mousedown.accessible-megamenu", $.proxy(_mouseDownHandler, this))
                .on("click.accessible-megamenu", $.proxy(_clickHandler, this));

            toggleButton.on('click.accessible-megamenu', $.proxy(_clickToggleHandler, this));

            if (isTouch) {
                menu.on("touchmove.accessible-megamenu", $.proxy(_touchmoveHandler, this));
            }

            if ($(document.activeElement).closest(menu).length) {
              $(document.activeElement).trigger("focusin.accessible-megamenu");
            }
        };

        _removeEventHandlers = function () {
            var menu = this.menu,
                toggleButton = this.toggleButton;
            menu.off('.accessible-megamenu');
            if (menu.find('[aria-expanded=true].' + this.settings.panelClass).length) {
                _toggleExpandedEventHandlers.call(this, true);
            }

            toggleButton.off('.accessible-megamenu');
        };

        /* public attributes and methods ------------------------- */
        return {
            constructor: AccessibleMegaMenu,

            /**
             * @lends jQuery.fn.accessibleMegaMenu
             * @desc Initializes an instance of the accessibleMegaMenu plugins
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            init: function () {
                var settings = this.settings,
                    nav = $(this.element),
                    menu = nav.children('ol,ul').first(),
                    topnavitems = menu.children(),
                    toggleButton = nav.children('button').first();
                this.start(settings, nav, menu, topnavitems, toggleButton);
            },

            start: function(settings, nav, menu, topnavitems, toggleButton) {
                var that = this;
                this.settings = settings;
                this.menu = menu;
                this.topnavitems = topnavitems;
                this.toggleButton = toggleButton;

                nav.attr("role", "navigation");
                _addUniqueId.call(that, menu);
                menu.addClass(settings.menuClass);
                menu.addClass(['js', settings.menuClass].join('-'));
                topnavitems.each(function (i, topnavitem) {
                    var topnavitemlink, topnavitempanel;
                    topnavitem = $(topnavitem);
                    topnavitem.addClass(settings.topNavItemClass);
                    topnavitemlink = topnavitem.find(":tabbable:first");
                    topnavitempanel = topnavitem.children(":not(:tabbable):last");
                    _addUniqueId.call(that, topnavitemlink);
                    if (topnavitempanel.length) {
                        _addUniqueId.call(that, topnavitempanel);
                        topnavitemlink.attr({
                            "role": "button",
                            "aria-controls": topnavitempanel.attr("id"),
                            "aria-expanded": false,
                            "tabindex": 0
                        });

                        topnavitempanel.attr({
                            "role": "region",
                            "aria-expanded": false,
                            "aria-hidden": true
                        })
                            .addClass(settings.panelClass)
                            .not("[aria-labelledby]")
                            .attr("aria-labelledby", topnavitemlink.attr("id"));
                    }
                });

                this.panels = menu.find("." + settings.panelClass);

                menu.find("hr").attr("role", "separator");

                toggleButton.addClass(settings.toggleButtonClass);
                toggleButton.attr({'aria-expanded': false, 'aria-pressed': false, 'aria-controls': menu.attr('id')});

                _addEventHandlers.call(this);
            },

            /**
             * @desc Removes maga menu javascript behavior
             * @example $(selector).accessibleMegaMenu("destroy");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            destroy: function () {
                this.menu.removeClass(['js', this.settings.menuClass].join('-'));
                _removeEventHandlers.call(this, true);
            },

            /**
             * @desc Get default values
             * @example $(selector).accessibleMegaMenu("getDefaults");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getDefaults: function () {
                return this._defaults;
            },

            /**
             * @desc Get any option set to plugin using its name (as string)
             * @example $(selector).accessibleMegaMenu("getOption", some_option);
             * @param {string} opt
             * @return {string}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getOption: function (opt) {
                return this.settings[opt];
            },

            /**
             * @desc Get all options
             * @example $(selector).accessibleMegaMenu("getAllOptions");
             * @return {object}
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            getAllOptions: function () {
                return this.settings;
            },

            /**
             * @desc Set option
             * @example $(selector).accessibleMegaMenu("setOption", "option_name",  "option_value",  reinitialize);
             * @param {string} opt - Option name
             * @param {string} val - Option value
             * @param {boolean} [reinitialize] - boolean to re-initialize the menu.
             * @memberof jQuery.fn.accessibleMegaMenu
             * @instance
             */
            setOption: function (opt, value, reinitialize) {
                this.settings[opt] = value;
                if (reinitialize) {
                    this.init();
                }
            }
        };
    }());

    /* lightweight plugin wrapper around the constructor,
       to prevent against multiple instantiations */

    /**
     * @class accessibleMegaMenu
     * @memberOf jQuery.fn
     * @classdesc Implements an accessible mega menu as a jQuery plugin.
     * <p>The mega-menu It is modeled after the mega menu on {@link http://adobe.com|adobe.com} but has been simplified for use by others. A brief description of the interaction design choices can be found in a blog post at {@link http://blogs.adobe.com/accessibility/2013/05/adobe-com.html|Mega menu accessibility on adobe.com}.</p>
     * <h3>Keyboard Accessibility</h3>
     * <p>The accessible mega menu supports keyboard interaction modeled after the behavior described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern}, however we also try to respect users' general expectations for the behavior of links in a global navigation. To this end, the accessible mega menu implementation permits tab focus on each of the six top-level menu items. When one of the menu items has focus, pressing the Enter key, Spacebar or Down arrow will open the submenu panel, and pressing the Left or Right arrow key will shift focus to the adjacent menu item. Links within the submenu panels are included in the tab order when the panel is open. They can also be navigated with the arrow keys or by typing the first character in the link name, which speeds up keyboard navigation considerably. Pressing the Escape key closes the submenu and restores focus to the parent menu item.</p>
     * <h3>Screen Reader Accessibility</h3>
     * <p>The accessible mega menu models its use of WAI-ARIA Roles, States, and Properties after those described in the {@link http://www.w3.org/TR/wai-aria-practices/#menu|WAI-ARIA Menu or Menu bar (widget) design pattern} with some notable exceptions, so that it behaves better with screen reader user expectations for global navigation. We don't use <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menu"</span></code> for the menu container and <code class="prettyprint prettyprinted" style=""><span class="pln">role</span><span class="pun">=</span><span class="str">"menuitem"</span></code> for each of the links therein, because if we do, assistive technology will no longer interpret the links as links, but instead, as menu items, and the links in our global navigation will no longer show up when a screen reader user executes a shortcut command to bring up a list of links in the page.</p>
     * @example <h4>HTML</h4><hr/>
&lt;nav&gt;
    &lt;ul class=&quot;nav-menu&quot;&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?movie&quot;&gt;Movies&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=0&quot;&gt;Action &amp;amp; Adventure&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=2&quot;&gt;Children &amp;amp; Family&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=7&quot;&gt;Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=9&quot;&gt;Foreign&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=14&quot;&gt;Musicals&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?movie&amp;genre=15&quot;&gt;Romance&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
        &lt;li class=&quot;nav-item&quot;&gt;
            &lt;a href=&quot;?tv&quot;&gt;TV Shows&lt;/a&gt;
            &lt;div class=&quot;sub-nav&quot;&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=20&quot;&gt;Classic TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=21&quot;&gt;Crime TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=27&quot;&gt;Reality TV&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=30&quot;&gt;TV Action&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
                &lt;ul class=&quot;sub-nav-group&quot;&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=33&quot;&gt;TV Dramas&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&lt;a href=&quot;?tv&amp;genre=34&quot;&gt;TV Horror&lt;/a&gt;&lt;/li&gt;
                    &lt;li&gt;&amp;#8230;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/li&gt;
    &lt;/ul&gt;
&lt;/nav&gt;
     * @example <h4>CSS</h4><hr/>
&#47;* Rudimentary mega menu CSS for demonstration *&#47;
&#47;* mega menu list *&#47;
.nav-menu {
    display: block;
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    z-index: 15;
}
&#47;* a top level navigation item in the mega menu *&#47;
.nav-item {
    list-style: none;
    display: inline-block;
    padding: 0;
    margin: 0;
}
&#47;* first descendant link within a top level navigation item *&#47;
.nav-item &gt; a {
    position: relative;
    display: inline-block;
    padding: 0.5em 1em;
    margin: 0 0 -1px 0;
    border: 1px solid transparent;
}
&#47;* focus/open states of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a:focus,
.nav-item &gt; a.open {
    border: 1px solid #dedede;
}
&#47;* open state of first descendant link within a top level
   navigation item *&#47;
.nav-item &gt; a.open {
    background-color: #fff;
    border-bottom: none;
    z-index: 1;
}
&#47;* sub-navigation panel *&#47;
.sub-nav {
    position: absolute;
    display: none;
    top: 2.2em;
    margin-top: -1px;
    padding: 0.5em 1em;
    border: 1px solid #dedede;
    background-color: #fff;
}
&#47;* sub-navigation panel open state *&#47;
.sub-nav.open {
    display: block;
}
&#47;* list of items within sub-navigation panel *&#47;
.sub-nav ul {
    display: inline-block;
    vertical-align: top;
    margin: 0 1em 0 0;
    padding: 0;
}
&#47;* list item within sub-navigation panel *&#47;
.sub-nav li {
    display: block;
    list-style-type: none;
    margin: 0;
    padding: 0;
}
     * @example <h4>JavaScript</h4><hr/>
&lt;!-- include jquery --&gt;
&lt;script src=&quot;http://code.jquery.com/jquery-1.10.1.min.js&quot;&gt;&lt;/script&gt;
&lt;!-- include the jquery-accessibleMegaMenu plugin script --&gt;
&lt;script src=&quot;js/jquery-accessibleMegaMenu.js&quot;&gt;&lt;/script&gt;
&lt;!-- initialize a selector as an accessibleMegaMenu --&gt;
&lt;script&gt;
    $(&quot;nav:first&quot;).accessibleMegaMenu({
        &#47;* prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby *&#47;
        uuidPrefix: &quot;accessible-megamenu&quot;,
        &#47;* css class used to define the megamenu styling *&#47;
        menuClass: &quot;nav-menu&quot;,
        &#47;* css class for a top-level navigation item in the megamenu *&#47;
        topNavItemClass: &quot;nav-item&quot;,
        &#47;* css class for a megamenu panel *&#47;
        panelClass: &quot;sub-nav&quot;,
        &#47;* css class for a group of items within a megamenu panel *&#47;
        panelGroupClass: &quot;sub-nav-group&quot;,
        &#47;* css class for the hover state *&#47;
        hoverClass: &quot;hover&quot;,
        &#47;* css class for the focus state *&#47;
        focusClass: &quot;focus&quot;,
        &#47;* css class for the open state *&#47;
        openClass: &quot;open&quot;
    });
&lt;/script&gt;
     * @param {object} [options] Mega Menu options
     * @param {string} [options.uuidPrefix=accessible-megamenu] - Prefix for generated unique id attributes, which are required to indicate aria-owns, aria-controls and aria-labelledby
     * @param {string} [options.menuClass=accessible-megamenu] - CSS class used to define the megamenu styling
     * @param {string} [options.topNavItemClass=accessible-megamenu-top-nav-item] - CSS class for a top-level navigation item in the megamenu
     * @param {string} [options.panelClass=accessible-megamenu-panel] - CSS class for a megamenu panel
     * @param {string} [options.panelGroupClass=accessible-megamenu-panel-group] - CSS class for a group of items within a megamenu panel
     * @param {string} [options.hoverClass=hover] - CSS class for the hover state
     * @param {string} [options.focusClass=focus] - CSS class for the focus state
     * @param {string} [options.openClass=open] - CSS class for the open state
     * @param {string} [options.openDelay=0] - Open delay when opening menu via mouseover
     * @param {string} [options.closeDelay=250] - Open delay when opening menu via mouseover
     * @param {boolean} [options.openOnMouseover=false] - Should menu open on mouseover
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            var pluginInstance = $.data(this, "plugin_" + pluginName);
            if (!pluginInstance) {
                $.data(this, "plugin_" + pluginName, new $.fn[pluginName].AccessibleMegaMenu(this, options));
            } else if (typeof pluginInstance[options] === 'function') {
                pluginInstance[options].apply(pluginInstance, Array.prototype.slice.call(arguments, 1));
            }
        });
    };

    $.fn[pluginName].AccessibleMegaMenu = AccessibleMegaMenu;

    /* :focusable and :tabbable selectors from
       https://raw.github.com/jquery/jquery-ui/master/ui/jquery.ui.core.js */

    /**
     * @private
     */
    function visible(element) {
        return $.expr.filters.visible(element) && !$(element).parents().addBack().filter(function () {
            return $.css(this, "visibility") === "hidden";
        }).length;
    }

    /**
     * @private
     */
    function focusable(element, isTabIndexNotNaN) {
        var map, mapName, img,
            nodeName = element.nodeName.toLowerCase();
        if ("area" === nodeName) {
            map = element.parentNode;
            mapName = map.name;
            if (!element.href || !mapName || map.nodeName.toLowerCase() !== "map") {
                return false;
            }
            img = $("img[usemap=#" + mapName + "]")[0];
            return !!img && visible(img);
        }
        return (/input|select|textarea|button|object/.test(nodeName) ? !element.disabled :
                "a" === nodeName ?
                        element.href || isTabIndexNotNaN :
                        isTabIndexNotNaN) &&
                            // the element and all of its ancestors must be visible
                            visible(element);
    }

    $.extend($.expr[":"], {
        data: $.expr.createPseudo ? $.expr.createPseudo(function (dataName) {
            return function (elem) {
                return !!$.data(elem, dataName);
            };
        }) : // support: jQuery <1.8
                function (elem, i, match) {
                    return !!$.data(elem, match[3]);
                },

        focusable: function (element) {
            return focusable(element, !isNaN($.attr(element, "tabindex")));
        },

        tabbable: function (element) {
            var tabIndex = $.attr(element, "tabindex"),
                isTabIndexNaN = isNaN(tabIndex);
            return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
        }
    });
}(jQuery, window, document));
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

shoppingActionsJS = {

    /** The language ID currently in use **/
    langId: "-1",

    /** The store ID currently in use **/
    storeId: "",

    /** The catalog ID currently in use **/
    catalogId: "",

    /** Holds the current user type such as guest or registered user. Allowed values are 'G' for guest and 'R' for registered.**/
    userType: "",

    /** A boolean used in a variety of the add to cart methods to tell whether or not the base item was added to the cart. **/
    baseItemAddedToCart: false,

    /** An array of entitled items which is used in various methods throughout ShoppingActions.js **/
    entitledItems: [],

    /** a JSON object that holds attributes of an entitled item **/
    entitledItemJsonObject: null,

    /** A map of attribute name value pairs for the currently selected attribute values **/
    selectedAttributesList: {},

    /** A variable used to form the url dynamically for the more info link in the Quickinfo popup */
    moreInfoUrl: "",

    /**
     * A boolean used to to determine is it from a Qick info popup or not. 
     **/
    isPopup: false,

    /**
     * A boolean used to to determine whether or not to diplay the price range when the catEntry is selected. 
     **/
    displayPriceRange: true,

    /**
     * This array holds the json object retured from the service, holding the price information of the catEntry.
     **/
    itemPriceJsonOject: [],

    /** 
     * stores all name and value of all swatches 
     * this is a 2 dimension array and each record i contains the following information:
     * allSwatchesArray[i][0] - attribute name of the swatch
     * allSwatchesArray[i][1] - attribute value of the swatch
     * allSwatchesArray[i][2] - image1 of swatch (image to use for enabled state)
     * allSwatchesArray[i][3] - image2 of swatch (image to use for disabled state)
     * allSwatchesArray[i][4] - onclick action of the swatch when enabled
     **/
    allSwatchesArrayList: {},

    /**
     * Holds the ID of the image used for swatch
     **/
    skuImageId: "",

    /**
     * The prefix of the cookie key that is used to store item Ids. 
     */
    cookieKeyPrefix: "CompareItems_",

    /**
     * The delimiter used to separate item Ids in the cookie.
     */
    cookieDelimiter: ";",

    /**
     * The maximum number of items allowed in the compare zone. 
     */
    maxNumberProductsAllowedToCompare: 4,

    /**
     * The minimum number of items allowed in the compare zone. 
     */
    minNumberProductsAllowedToCompare: 2,

    /**
     * Id of the base catalog entry. 
     */
    baseCatalogEntryId: 0,

    /**
     * An map which holds the attributes of a set of products
     */
    selectedProducts: {},

    /**
     * An array to keep the quantity of the products in a list (bundle)
     */
    productList: {},

    /**
     * stores the currency symbol
     */
    currencySymbol: "",

    /**
     * stores the compare return page name
     */
    compareReturnName: "",
    /**
     * stores the search term
     */
    searchTerm: "",

    search01: "'",

    search02: '"',

    replaceStr01: /\\\'/g,

    replaceStr02: /\\\"/g,

    ampersandChar: /&/g,

    ampersandEntityName: "&amp;",

    /**
     * An array to keep the details of the newly added products.
     */
    productAddedList: {},

    setCompareReturnName: function (compareReturnName) {
        this.compareReturnName = compareReturnName;
    },

    setSearchTerm: function (searchTerm) {
        this.searchTerm = searchTerm;
    },

    setCommonParameters: function (langId, storeId, catalogId, userType, currencySymbol) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        this.userType = userType;
        this.currencySymbol = currencySymbol;
    },

    setEntitledItems: function (entitledItemArray) {
        this.entitledItems = entitledItemArray;
    },

    getCatalogEntryId: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * getCatalogEntryIdforProduct Returns the catalog entry ID for a catalog entry that has the same attribute values as a specified product's selected attributes as passed in via the selectedAttributes parameter.
     *
     * @param {String[]} selectedAttributes The array of selected attributes upon which to resolve the SKU.
     *
     * @return {String} catalog entry ID of the SKU.
     *
     **/
    getCatalogEntryIdforProduct: function (selectedAttributes) {
        var attributeArray = [];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveSKU(attributeArray);
    },

    /**
     * retrieves the entitledItemJsonObject
     */
    getEntitledItemJsonObject: function () {
        return this.entitledItemJsonObject;
    },

    /**
     * resolveSKU Resolves a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     *
     * @return {String} catentry_id The catalog entry ID of the SKU.
     *
     **/
    resolveSKU: function (attributeArray) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var catentry_id = "";
        var attributeArrayCount = attributeArray.length;

        // if there is only one item, no need to check the attributes to resolve the sku
        if (this.entitledItems.length == 1) {
            return this.entitledItems[0].catentry_id;
        }
        for (x in this.entitledItems) {
            var catentry_id = this.entitledItems[x].catentry_id;
            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return catentry_id;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    var attributeValue2 = attributeValue.replace(this.search02, this.search01);
                    if (attributeValue in Attributes || attributeValue2 in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("CatEntryId:" + catentry_id + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    return catentry_id;
                }
            }
        }
        return null;
    },

    /**
     * setSelectedAttribute Sets the selected attribute value for a particular attribute not in reference to any catalog entry.
     *					   One place this function is used is on CachedProductOnlyDisplay.jsp where there is a drop down box of attributes.
     *					   When an attribute is selected from that drop down this method is called to update the selected value for that attribute.
     *
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {String} entitledItemId The element id where the json object of the sku is stored
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     *
     **/
    setSelectedAttribute: function (selectedAttributeName, selectedAttributeValue, entitledItemId, skuImageId, imageField) {
        console.debug(selectedAttributeName + " : " + selectedAttributeValue);
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        if (selectedAttributes == null) {
            selectedAttributes = {};
        }
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr01, this.search01);
        selectedAttributeValue = selectedAttributeValue.replace(this.replaceStr02, this.search02);
        selectedAttributeValue = selectedAttributeValue.replace(this.ampersandChar, this.ampersandEntityName);
        selectedAttributes[selectedAttributeName] = selectedAttributeValue;
        this.moreInfoUrl = this.moreInfoUrl + '&' + selectedAttributeName + '=' + selectedAttributeValue;
        this.selectedAttributesList[entitledItemId] = selectedAttributes;
        this.changeProdImage(entitledItemId, selectedAttributeName, selectedAttributeValue, skuImageId, imageField);
    },

    /**
     * setSelectedAttributeOfProduct Sets the selected attribute value for an attribute of a specified product.
     *								This function is used to set the assigned value of defining attributes to specific 
     *								products which will be stored in the selectedProducts map.
     *
     * @param {String} productId The catalog entry ID of the catalog entry to use.
     * @param {String} selectedAttributeName The name of the attribute.
     * @param {String} selectedAttributeValue The value of the selected attribute.
     * @param {boolean} true, if it is single SKU
     *
     **/
    setSelectedAttributeOfProduct: function (productId, selectedAttributeName, selectedAttributeValue, isSingleSKU) {

        var selectedAttributesForProduct = null;

        if (this.selectedProducts[productId]) {
            selectedAttributesForProduct = this.selectedProducts[productId];
        } else {
            selectedAttributesForProduct = {};
        }

        // add only if attribute has some name. value can be empty
        if (null != selectedAttributeName && '' != selectedAttributeName) {
            selectedAttributesForProduct[selectedAttributeName] = selectedAttributeValue;
        }
        this.selectedProducts[productId] = selectedAttributesForProduct;

        //the json object for entitled items are already in the HTML. 
        var entitledItemJSON = eval('(' + $("#entitledItem_" + productId).html() + ')');

        this.setEntitledItems(entitledItemJSON);

        var catalogEntryId = this.getCatalogEntryIdforProduct(selectedAttributesForProduct);

        if (catalogEntryId == null) {
            catalogEntryId = 0;
        } else {
            // pass true to display price range
            this.changePrice("entitledItem_" + productId, false, true, productId);

            //Update selected sku in merchandising association array
            if (typeof MerchandisingAssociationJS != 'undefined') {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (productId == MerchandisingAssociationJS.baseItemParams.components[idx].productId) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].id = catalogEntryId;
                            }
                        }
                    }
                }
            }
        }
        var productDetails = null;
        if (this.productList[productId]) {
            productDetails = this.productList[productId];
        } else {
            productDetails = {};
            this.productList[productId] = productDetails;
            productDetails.baseItemId = productId;
        }

        productDetails.id = catalogEntryId;
        if (productDetails.quantity) {
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        }

        if (!isSingleSKU) {
            // publish the attribute change event
            if (catalogEntryId != 0) {
                wcTopic.publish('DefiningAttributes_Resolved_' + productId, catalogEntryId, productId);
            } else {
                wcTopic.publish('DefiningAttributes_Changed_' + productId, catalogEntryId, productId);
            }
        }
    },

    /**
     * Add2ShopCartAjax This function is used to add a catalog entry to the shopping cart using an AJAX call. This will resolve the catentryId using entitledItemId and adds the item to the cart.
     *				This function will resolve the SKU based on the entitledItemId passed in and call {@link this.AddItem2ShopCartAjax}.
     * @param {String} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {int} quantity The quantity of the item to add to the cart.
     * @param {String} isPopup If the value is true, then this implies that the function was called from a quick info pop-up. 	
     * @param {Object} customParams - Any additional parameters that needs to be passed during service invocation.
     *
     **/
    Add2ShopCartAjax: function (entitledItemId, quantity, isPopup, customParams) {
        var dialog = $('#quick_cart_container').data("wc-WCDialog");
        if (dialog) {
            dialog.close();
        }
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var entitledItemJSON;

        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#" +entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }

        this.setEntitledItems(entitledItemJSON);
        var catalogEntryId = this.getCatalogEntryId(entitledItemId);

        if (catalogEntryId != null) {
            var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);
            this.AddItem2ShopCartAjax(catalogEntryId, quantity, customParams, productId);
            this.baseItemAddedToCart = true;
        } else if (isPopup == true) {
            $('#second_level_category_popup').css("zIndex", '1');
            MessageHelper.formErrorHandleClient('addToCartLinkAjax', Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
        } else {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
            this.baseItemAddedToCart = false;
        }
    },

    AddItem2ShopCartAjax: function (catEntryIdentifier, quantity, customParams, productId) {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var params = {storeId: this.storeId,
catalogId: this.catalogId,
langId: this.langId,
orderId: "."};
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        params.inventoryValidation = "true";
        params.calculateOrder = "0";
        var ajaxShopCartService = "AddOrderItem";

        this.productAddedList = {};
        if (Array.isArray(catEntryIdentifier) && Array.isArray(quantity)) {
            for (var i = 0; i < catEntryIdentifier.length; i++) {
                if (!isPositiveInteger(quantity[i])) {
                    MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                    return;
                }
                params["catEntryId_" + (i + 1)] = catEntryIdentifier[i];
                params["quantity_" + (i + 1)] = quantity[i];
            }
        } else {
            if (!isPositiveInteger(quantity)) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }
            params.catEntryId = catEntryIdentifier;
            params.quantity = quantity;

            var selectedAttrList = {};
            for (attr in this.selectedAttributesList['entitledItem_' + productId]) {
                selectedAttrList[attr] = this.selectedAttributesList['entitledItem_' + productId][attr];
            }

            if (productId == undefined) {
                this.saveAddedProductInfo(quantity, catEntryIdentifier, catEntryIdentifier, selectedAttrList);
            } else {
                this.saveAddedProductInfo(quantity, productId, catEntryIdentifier, selectedAttrList);
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
            if (customParams['catalogEntryType'] == 'dynamicKit') {
                ajaxShopCartService = "AddPreConfigurationToCart";
            }
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke(ajaxShopCartService, params);
        this.baseItemAddedToCart = true;

        if (document.getElementById("headerShopCartLink") && document.getElementById("headerShopCartLink").style.display != "none") {
            $("#headerShopCart").focus();
        } else {
            $("#headerShopCart1").focus();
        }
    },

    /**
     * AddBundle2ShopCartAjax This function is used to add a bundle to the shopping cart.
     **/
    AddBundle2ShopCartAjax: function () {
        if (browseOnly) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERROR_ADD2CART_BROWSE_ONLY'));
            return;
        }
        var ajaxShopCartService = "AddOrderItem";
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            orderId: ".",
            inventoryValidation: "true",
            calculateOrder: "0"
        };
        // Remove calculations for performance
        // params.calculationUsage = "-1,-2,-5,-6,-7";
        
        var idx = 1;
        this.productAddedList = {};

        for (productId in this.productList) {
            var productDetails = this.productList[productId];
            var quantity = Utils.parseNumber(productDetails.quantity);

            if (quantity == 0) {
                continue;
            }
            if (productDetails.id == 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('ERR_RESOLVING_SKU'));
                return;
            }
            if (isNaN(quantity) || quantity < 0) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
                return;
            }

            params["catEntryId_" + idx] = productDetails.id;
            params["quantity_" + idx++] = quantity;
            this.baseItemAddedToCart = true;

            this.saveAddedProductInfo(quantity, productId, productDetails.id, this.selectedProducts[productId]);
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke(ajaxShopCartService, params);

    },

    resetProductAddedList: function () {
        shoppingActionsJS.productAddedList = {};
    },
    /**
     * Save the product information of the newly added product(s) to be used for the mini cart product added popup
     *
     * @param {String} quantity The quantity of the product being purchased.
     * @param {String} productId The id of the product.
     * @param {String} skuId The id of the sku.
     * @param {String} attrList The list of selected attributes for the product, if any.
     **/
    saveAddedProductInfo: function (quantity, productId, skuId, attrList) {

        var productName = "";
        if ($("#ProductInfoName_" + productId).length) {
            productName = document.getElementById("ProductInfoName_" + productId).value;
        } else if ($("#ProductInfoName_" + skuId).length) {
            productName = document.getElementById("ProductInfoName_" + skuId).value;
        }

        var productThumbnail = "";
        if ($("#ProductInfoImage_" + productId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + productId).value;
        } else if ($("#ProductInfoImage_" + skuId).length) {
            productThumbnail = document.getElementById("ProductInfoImage_" + skuId).value;
        }

        var productPrice = "";
        if ($("#ProductInfoPrice_" + productId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + productId).value;
        } else if ($("#ProductInfoPrice_" + skuId).length) {
            productPrice = document.getElementById('ProductInfoPrice_' + skuId).value;
        }

        var productAdded = [productName, productThumbnail, productPrice, quantity, attrList];
        if (productId != skuId) {
            this.productAddedList[skuId] = productAdded;
        } else {
            this.productAddedList[productId] = productAdded;
        }

        wcTopic.publish("ProductInfo_Added", this.productAddedList);
    },

    /* SwatchCode start */

    /**
     *setSKUImageId Sets the ID of the image to use for swatch.
     **/
    setSKUImageId: function (skuImageId) {
        this.skuImageId = skuImageId;
    },

    /**
     * getImageForSKU Returns the full image of the catalog entry with the selected attributes as specified in the {@link this.selectedAttributes} value.
     *					This method uses resolveImageForSKU to find the SKU image with the selected attributes values.
     *
     * @param {String} imageField, the field name from which the image should be picked
     * @return {String} path to the SKU image.
     * 
     *
     **/
    getImageForSKU: function (entitledItemId, imageField) {
        var attributeArray = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray, imageField);
    },

    /**
     * resolveImageForSKU Resolves image of a SKU using an array of defining attributes.
     *
     * @param {String[]} attributeArray An array of defining attributes upon which to resolve a SKU.
     * @param {String} imageField, the field name from which the image should be picked
     *
     * @return {String} imagePath The location of SKU image.
     *
     **/
    resolveImageForSKU: function (attributeArray, imageField) {

        console.debug("Resolving SKU >> " + attributeArray + ">>" + this.entitledItems);
        var imagePath = "";
        var attributeArrayCount = attributeArray.length;

        for (x in this.entitledItems) {
            if (null != imageField) {
                var imagePath = this.entitledItems[x][imageField];
            } else {
                var imagePath = this.entitledItems[x].ItemImage467;
            }

            var Attributes = this.entitledItems[x].Attributes;
            var attributeCount = 0;
            for (index in Attributes) {
                attributeCount++;
            }

            // Handle special case where a catalog entry has one sku with no attributes
            if (attributeArrayCount == 0 && attributeCount == 0) {
                return imagePath;
            }
            if (attributeCount != 0 && attributeArrayCount >= attributeCount) {
                var matchedAttributeCount = 0;

                for (attributeName in attributeArray) {
                    var attributeValue = attributeArray[attributeName];
                    if (attributeValue in Attributes) {
                        matchedAttributeCount++;
                    }
                }

                if (attributeCount == matchedAttributeCount) {
                    console.debug("ItemImage:" + imagePath + " for Attribute: " + attributeArray);
                    this.disableBuyButtonforUnbuyable(x);
                    var imageArray = [];
                    imageArray.push(imagePath);
                    imageArray.push(this.entitledItems[x].ItemThumbnailImage);
                    if (this.entitledItems[x].ItemAngleThumbnail != null && this.entitledItems[x].ItemAngleThumbnail != undefined) {
                        imageArray.push(this.entitledItems[x].ItemAngleThumbnail);
                        imageArray.push(this.entitledItems[x].ItemAngleFullImage);
                    }
                    return imageArray;
                }
            }
        }
        return null;
    },

    disableBuyButtonforUnbuyable: function (entitledItemIndex) {
        var buyableFlag = this.entitledItems[entitledItemIndex].buyable;
        //				disable the add to cart button
        var btn = document.getElementById("listViewAdd2Cart_" + this.entitledItems[entitledItemIndex].productId);
        if (buyableFlag != null && btn != null) {
            if (buyableFlag == 'false') {
                btn.className += " add2CartButtonDisabled";
            } else {
                btn.className = btn.className.replace(" add2CartButtonDisabled", "");
            }
        }
    },

    /**
     * changeViewImages Updates the angle views of the SKU.
     *
     * @param {String[]} itemAngleThumbnail An array of SKU view thumbnails.
     * @param {String[]} itemAngleFullImage An array of SKU view full images.
     **/
    changeViewImages: function (itemAngleThumbnail, itemAngleFullImage) {
        var imageCount = 0;
        for (x in itemAngleThumbnail) {
            var prodAngleCount = imageCount;
            imageCount++;
            $("#WC_CachedProductOnlyDisplay_images_1_" + imageCount).attr('src', itemAngleThumbnail[x]);
            if ($("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).length) {
                $("#WC_CachedProductOnlyDisplay_links_1_" + imageCount).attr('href',
                    "JavaScript:changeThumbNail('productAngleLi" + prodAngleCount + "','" + itemAngleFullImage[x] + "');");
            }

            if ($("#productAngleLi" + prodAngleCount).length && $("#productAngleLi" + prodAngleCount).attr('className') === ('selected')) {
                changeThumbNail("productAngleLi" + prodAngleCount, itemAngleFullImage[x]);
            }
        }
    },


    /**
     * updates the product image from the PDP page to use the selected SKU image
     * @param String swatchAttrName the newly selection attribute name
     * @param String swatchAttrValue the newly selection attribute value
     * @param {String} imageField, the field name from which the image should be picked
     **/
    changeProdImage: function (entitledItemId, swatchAttrName, swatchAttrValue, skuImageId, imageField) {
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);
        var productId = entitledItemId.substring(entitledItemId.indexOf("_") + 1);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForSKU(entitledItemId, imageField);
        if (imageArr != null) {
            skuImage = imageArr[0];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId).length) {
                document.getElementById(this.skuImageId).src = skuImage;
                if ($("#ProductInfoImage_" + productId).length) {
                    document.getElementById("ProductInfoImage_" + productId).value = skuImage;
                }

                var itemAngleThumbnail = imageArr[2];
                var itemAngleFullImage = imageArr[3];
                if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                    shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                if (null != imageField) {
                    var itemImage = this.entitledItems[x][imageField];
                } else {
                    var itemImage = this.entitledItems[x].ItemImage467;
                }


                var itemAngleThumbnail = this.entitledItems[x].ItemAngleThumbnail;
                var itemAngleFullImage = this.entitledItems[x].ItemAngleFullImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        // set sku image only if the img element is present
                        if ($("#" + this.skuImageId).length) {
                            $("#" + this.skuImageId).attr('src', itemImage);
                            if (document.getElementById("ProductInfoImage_" + productId) != null) {
                                document.getElementById("ProductInfoImage_" + productId).value = itemImage;
                            }
                        }
                        if (itemAngleThumbnail != null && itemAngleThumbnail != undefined) {
                            shoppingActionsJS.changeViewImages(itemAngleThumbnail, itemAngleFullImage);
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    /**
     * Updates the swatches selections on list view.
     * Sets up the swatches array and sku images, then selects a default swatch value.
     **/
    updateSwatchListView: function () {
        var swatchArray = $("a[id^='swatch_array_']");
        for (var i = 0; i < swatchArray.length; i++) {
            var swatchArrayElement = swatchArray[i];
            eval($(swatchArrayElement).attr("href"));
        }

        var swatchSkuImage = $("a[id^='swatch_setSkuImage_']");
        for (var i = 0; i < swatchSkuImage.length; i++) {
            var swatchSkuImageElement = swatchSkuImage[i];
            eval($(swatchSkuImageElement).attr("href"));
        }

        var swatchDefault = $("a[id^='swatch_selectDefault_']");
        for (var i = 0; i < swatchDefault.length; i++) {
            var swatchDefaultElement = swatchDefault[i];
            eval($(swatchDefaultElement).attr("href"));
        }
    },

    /**
     * Handles the case when a swatch is selected. Set the border of the selected swatch.
     * @param {String} selectedAttributeName The name of the selected swatch attribute.
     * @param {String} selectedAttributeValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.
     * @param {String} imageField, the field name from which the image should be picked
     * @return boolean Whether the swatch is available for selection
     **/
    selectSwatch: function (selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        if ($("#swatch_" + entitledItemId + "_" + selectedAttributeValue).hasClass("color_swatch_disabled")) {
            return;
        }
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        for (attribute in selectedAttributes) {
            if (attribute == selectedAttributeName) {
                // case when the selected swatch is already selected with a value, if the value is different than
                // what's being selected, reset other swatches and deselect the previous value and update selection
                if (selectedAttributes[attribute] != selectedAttributeValue) {
                    // deselect previous value and update swatch selection
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + selectedAttributes[attribute]);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).title = swatchElement.alt;
                }
            }
            if (document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]) != null) {
                document.getElementById("swatch_link_" + entitledItemId + "_" + selectedAttributes[attribute]).setAttribute("aria-checked", "false");
            }
        }
        this.makeSwatchSelection(selectedAttributeName, selectedAttributeValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField);
    },

    /**
     * Make swatch selection - add to selectedAttribute, select image, and update other swatches and SKU image based on current selection.
     * @param {String} swatchAttrName The name of the selected swatch attribute.
     * @param {String} swatchAttrValue The value of the selected swatch attribute.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     * @param {String} skuImageId This is optional. The element id of the product image - image element id is different in product page and category list view. Product page need not pass it because it is set separately
     * @param {String} imageField This is optional. The json field from which image should be picked. Pass value if a different size image need to be picked
     **/
    makeSwatchSelection: function (swatchAttrName, swatchAttrValue, entitledItemId, doNotDisable, selectedAttributeDisplayValue, skuImageId, imageField) {
        // setSelectedAttribute internally calls changeProdImage method to change product image.
        this.setSelectedAttribute(swatchAttrName, swatchAttrValue, entitledItemId, skuImageId, imageField);
        document.getElementById("swatch_" + entitledItemId + "_" + swatchAttrValue).className = "color_swatch_selected";
        document.getElementById("swatch_link_" + entitledItemId + "_" + swatchAttrValue).setAttribute("aria-checked", "true");
        document.getElementById("swatch_selection_label_" + entitledItemId + "_" + swatchAttrName).className = "header color_swatch_label";
        if (document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display == "none") {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).style.display = "inline";
        }
        if (selectedAttributeDisplayValue != null) {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = selectedAttributeDisplayValue;
        } else {
            document.getElementById("swatch_selection_" + entitledItemId + "_" + swatchAttrName).innerHTML = swatchAttrValue;
        }

        this.updateSwatchImages(swatchAttrName, entitledItemId, doNotDisable, imageField);
    },

    /**
     * Constructs record and add to this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.	
     * @param {String} swatchImg1 The path to the swatch image.
     **/
    addToAllSwatchsArray: function (swatchName, swatchValue, swatchImg1, entitledItemId, swatchDisplayValue) {
        var swatchList = this.allSwatchesArrayList[entitledItemId];
        if (swatchList == null) {
            swatchList = [];;
        }
        if (!this.existInAllSwatchsArray(swatchName, swatchValue, swatchList)) {
            var swatchRecord = [];
            swatchRecord[0] = swatchName;
            swatchRecord[1] = swatchValue;
            swatchRecord[2] = swatchImg1;
            swatchRecord[4] = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchValue).onclick;
            swatchRecord[5] = null;
            swatchRecord[6] = swatchDisplayValue;
            swatchList.push(swatchRecord);
            this.allSwatchesArrayList[entitledItemId] = swatchList;
        }
    },

    /**
     * Checks if a swatch is already exist in this.allSwatchesArray.
     * @param {String} swatchName The name of the swatch attribute.
     * @param {String} swatchValue The value of the swatch attribute.		
     * @return boolean Value indicating whether or not the specified swatch name and value exists in the allSwatchesArray.
     */
    existInAllSwatchsArray: function (swatchName, swatchValue, swatchList) {
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            if (attrName == swatchName && attrValue == swatchValue) {
                return true;
            }
        }
        return false;
    },

    /**
     * Check the entitledItems array and pre-select the first entited SKU as the default swatch selection.
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.		
     **/
    makeDefaultSwatchSelection: function (entitledItemId, doNotDisable) {
        if (this.entitledItems.length == 0) {
            if ($("#" + entitledItemId).length) {
                entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
            }
            this.setEntitledItems(entitledItemJSON);
        }

        // need to make selection for every single swatch
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;
            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var swatchName = y.substring(0, index);
                var swatchValue = y.substring(index + 3);
                this.makeSwatchSelection(swatchName, swatchValue, entitledItemId, doNotDisable, null, imageField);
            }
            break;
        }
    },

    /**
     * Update swatch images - this is called after selection of a swatch is made, and this function checks for
     * entitlement and disable swatches that are not available
     * @param selectedAttrName The attribute that is selected
     * @param {String} entitledItemId The ID of the SKU.
     * @param {String} doNotDisable The name of the swatch attribute that should never be disabled.	
     **/
    updateSwatchImages: function (selectedAttrName, entitledItemId, doNotDisable, imageField) {
        var swatchToUpdate = [];
        var selectedAttributes = this.selectedAttributesList[entitledItemId];
        var selectedAttrValue = selectedAttributes[selectedAttrName];
        var swatchList = this.allSwatchesArrayList[entitledItemId];

        // finds out which swatch needs to be updated, add to swatchToUpdate array
        for (var i = 0; i < swatchList.length; i++) {
            var attrName = swatchList[i][0];
            var attrValue = swatchList[i][1];
            var attrImg1 = swatchList[i][2];
            var attrImg2 = swatchList[i][3];
            var attrOnclick = swatchList[i][4];
            var attrDisplayValue = swatchList[i][6];

            if (attrName != doNotDisable && attrName != selectedAttrName) {
                var swatchRecord = [];
                swatchRecord[0] = attrName;
                swatchRecord[1] = attrValue;
                swatchRecord[2] = attrImg1;
                swatchRecord[4] = attrOnclick;
                swatchRecord[5] = false;
                swatchRecord[6] = attrDisplayValue;
                swatchToUpdate.push(swatchRecord);
            }
        }

        // finds out which swatch is entitled, if it is, image should be set to enabled
        // go through entitledItems array and find out swatches that are entitled 
        for (x in this.entitledItems) {
            var Attributes = this.entitledItems[x].Attributes;

            for (y in Attributes) {
                var index = y.indexOf("_|_");
                var entitledSwatchName = y.substring(0, index);
                var entitledSwatchValue = y.substring(index + 3);

                //the current entitled item has the selected attribute value
                if (entitledSwatchName == selectedAttrName && entitledSwatchValue == selectedAttrValue) {
                    //go through the other attributes that are available to the selected attribute
                    //exclude the one that is selected
                    for (z in Attributes) {
                        var index2 = z.indexOf("_|_");
                        var entitledSwatchName2 = z.substring(0, index2);
                        var entitledSwatchValue2 = z.substring(index2 + 3);

                        if (y != z) { //only check the attributes that are not the one selected
                            for (i in swatchToUpdate) {
                                var swatchToUpdateName = swatchToUpdate[i][0];
                                var swatchToUpdateValue = swatchToUpdate[i][1];

                                if (entitledSwatchName2 == swatchToUpdateName && entitledSwatchValue2 == swatchToUpdateValue) {
                                    swatchToUpdate[i][5] = true;
                                }
                            }
                        }
                    }
                }
            }
        }

        // Now go through swatchToUpdate array, and update swatch images
        var disabledAttributes = [];
        for (i in swatchToUpdate) {
            var swatchToUpdateName = swatchToUpdate[i][0];
            var swatchToUpdateValue = swatchToUpdate[i][1];
            var swatchToUpdateImg1 = swatchToUpdate[i][2];
            var swatchToUpdateImg2 = swatchToUpdate[i][3];
            var swatchToUpdateOnclick = swatchToUpdate[i][4];
            var swatchToUpdateEnabled = swatchToUpdate[i][5];

            if (swatchToUpdateEnabled) {
                if (document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue).className != "color_swatch_selected") {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch";
                    swatchElement.src = swatchElement.src.replace("_disabled.png", "_enabled.png");

                    //change the title text of the swatch link
                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).title = swatchElement.alt;
                }
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "false");
                document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).onclick = swatchToUpdateOnclick;
            } else {
                if (swatchToUpdateName != doNotDisable) {
                    var swatchElement = document.getElementById("swatch_" + entitledItemId + "_" + swatchToUpdateValue);
                    var swatchLinkElement = document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue);
                    swatchElement.className = "color_swatch_disabled";
                    swatchLinkElement.onclick = null;
                    swatchElement.src = swatchElement.src.replace("_enabled.png", "_disabled.png");

                    //change the title text of the swatch link

                    var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [swatchElement.alt]);

                    document.getElementById("swatch_link_" + entitledItemId + "_" + swatchToUpdateValue).setAttribute("aria-disabled", "true");

                    //The previously selected attribute is now unavailable for the new selection
                    //Need to switch the selection to an available value
                    if (selectedAttributes[swatchToUpdateName] == swatchToUpdateValue) {
                        disabledAttributes.push(swatchToUpdate[i]);
                    }
                }
            }
        }

        //If there were any previously selected attributes that are now unavailable
        //Find another available value for that attribute and update other attributes according to the new selection
        for (i in disabledAttributes) {
            var disabledAttributeName = disabledAttributes[i][0];
            var disabledAttributeValue = disabledAttributes[i][1];

            for (i in swatchToUpdate) {
                var swatchToUpdateName = swatchToUpdate[i][0];
                var swatchToUpdateValue = swatchToUpdate[i][1];
                var swatchToUpdateDisplayValue = swatchToUpdate[i][6];
                var swatchToUpdateEnabled = swatchToUpdate[i][5];

                if (swatchToUpdateName == disabledAttributeName && swatchToUpdateValue != disabledAttributeValue && swatchToUpdateEnabled) {
                    this.makeSwatchSelection(swatchToUpdateName, swatchToUpdateValue, entitledItemId, doNotDisable, swatchToUpdateDisplayValue, imageField);
                    break;
                }
            }
        }
    },
    /* SwatchCode end */

    /**
     * This function is used to change the price displayed in the Product Display Page on change of  a attribute of the product using an AJAX call. 
     * This function will resolve the catentryId using entitledItemId and displays the price of the catentryId.
     *				
     * @param {Object} entitledItemId A DIV containing a JSON object which holds information about a catalog entry. You can reference CachedProductOnlyDisplay.jsp to see how that div is constructed.
     * @param {Boolean} isPopup If the value is true, then this implies that the function was called from a quick info pop-up.
     * @param {Boolean} displayPriceRange If the value is true, then display the price range. If it is false then donot display the price range.
     *
     **/
    changePrice: function (entitledItemId, isPopup, displayPriceRange, productId) {
        this.displayPriceRange = displayPriceRange;
        this.isPopup = isPopup;
        var entitledItemJSON;

        if ($("#" + entitledItemId).length && !this.isPopup) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        } else {
            //if $("#"+ entitledItemId).length is 0, that means there's no <div> in the HTML that contains the JSON object. 
            //in this case, it must have been set in catalogentryThumbnailDisplay.js when the quick info
            entitledItemJSON = this.getEntitledItemJsonObject();
        }
        var catalogEntryId = null;
        this.setEntitledItems(entitledItemJSON);

        if (this.selectedProducts[productId]) {
            var catalogEntryId = this.getCatalogEntryIdforProduct(this.selectedProducts[productId]);
        } else {
            var catalogEntryId = this.getCatalogEntryId(entitledItemId);
        }

        if (catalogEntryId != null) {
            //check if the json object is already present for the catEntry.
            if (this.itemPriceJsonOject[catalogEntryId] != null && this.itemPriceJsonOject[catalogEntryId] != 'undefined') {
                this.displayPrice(this.itemPriceJsonOject[catalogEntryId].catalogEntry, productId);
                console.debug("ShoppingActions.changePrice: using stored json object.");
            }
            //if json object is not present, call the service to get the details.
            else {
                var parameters = {
                    storeId: this.storeId,
                    langId: this.langId,
                    catalogId: this.catalogId,
                    catalogEntryId: catalogEntryId,
                    productId: productId
                };

                //Declare a service for retrieving catalog entry detailed information for an item...
                wcService.declare({
                    id: "getCatalogEntryDetailsSA",
                    actionId: "getCatalogEntryDetailsSA",
                    url: getAbsoluteURL() + appendWcCommonRequestParameters("GetCatalogEntryDetailsByIDView"),
                    formId: ""

                    ,
                    successHandler: function (serviceResponse, ioArgs) {
                        shoppingActionsJS.displayPriceServiceResponse(serviceResponse, ioArgs);
                    }

                    ,
                    failureHandler: function (serviceResponse, ioArgs) {
                        console.debug("ShoppingActions.changePrice: Unexpected error occurred during an xhrPost request.");
                    }

                });
                wcService.invoke("getCatalogEntryDetailsSA", parameters);
            }
        } else {
            console.debug("ShoppingActions.changePrice: all attributes are not selected.");
        }

    },

    /** 
     * Displays price of the catEntry selected with the JSON objrct returned from the server.
     * 
     * @param {object} serviceRepsonse The JSON response from the service.
     * @param {object} ioArgs The arguments from the service call.
     */
    displayPriceServiceResponse: function (serviceResponse, ioArgs) {
        var productId = ioArgs.productId;
        //stores the json object, so that the service is not called when same catEntry is selected.
        shoppingActionsJS.itemPriceJsonOject[serviceResponse.catalogEntry.catalogEntryIdentifier.uniqueID] = serviceResponse;

        shoppingActionsJS.displayPrice(serviceResponse.catalogEntry, productId);
    },

    /** 
     * Displays price of the attribute selected with the JSON oject.
     * 
     * @param {object} catEntry The JSON object with catalog entry details.
     */
    displayPrice: function (catEntry, productId) {

        var tempString;
        var popup = shoppingActionsJS.isPopup;

        if (popup == true) {
            $("#productPrice").html(catEntry.offerPrice);
            document.getElementById('productName').innerHTML = catEntry.description[0].name;
            document.getElementById('productSKUValue').innerHTML = catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
        }

        if (popup == false) {
            var innerHTML = "";
            var listPrice = Utils.parseNumber(catEntry.listPrice);
            var offerPrice = Utils.parseNumber(catEntry.offerPrice);

            this.setPriceInProductList(productId, offerPrice);

            if (!catEntry.listPriced || listPrice <= offerPrice) {
                innerHTML = "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            } else {
                innerHTML = "<span id='listPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='old_price'>" + catEntry.listPrice + "</span>" +
                    "<span id='offerPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' class='price'>" + catEntry.offerPrice + "</span>";
            }
            document.getElementById('price_display_' + productId).innerHTML = innerHTML + "<input type='hidden' id='ProductInfoPrice_" + catEntry.catalogEntryIdentifier.uniqueID + "' value='" + catEntry.offerPrice + "'/>";

            innerHTML = "";
            if (shoppingActionsJS.displayPriceRange == true) {
                for (var i in catEntry.priceRange) {
                    if (catEntry.priceRange[i].endingNumberOfUnits == catEntry.priceRange[i].startingNumberOfUnits) {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else if (catEntry.priceRange[i].endingNumberOfUnits != 'null') {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_TO_Y', {
                            0: catEntry.priceRange[i].startingNumberOfUnits,
                            1: catEntry.priceRange[i].endingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    } else {
                        tempString = Utils.getLocalizationMessage('PQ_PRICE_X_OR_MORE', {
                            0: catEntry.priceRange[i].startingNumberOfUnits
                        });
                        innerHTML = innerHTML + "<p>" + tempString;
                    }
                    innerHTML = innerHTML + " <span class='price'>" + catEntry.priceRange[i].localizedPrice + "</span></p>";
                }
            }
            // Append productId so that element is unique in bundle page, where there can be multiple components
            var quantityDiscount = document.getElementById("productLevelPriceRange_" + productId);
            var itemQuantityDiscount = document.getElementById("itemLevelPriceRange_" + productId);

            // if product level price exists and no section to update item level price
            if (null != quantityDiscount && null == itemQuantityDiscount) {
                quantityDiscount.style.display = ""; //display product level price range
            }
            // if item level price range is present
            else if ("" != innerHTML && null != itemQuantityDiscount) {
                innerHTML = Utils.getLocalizationMessage('PQ_PURCHASE') + innerHTML;
                itemQuantityDiscount.innerHTML = innerHTML;
                itemQuantityDiscount.style.display = "";
                // hide the product level price range
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = "none";
                }
            }
            // if item level price range is not present
            else if ("" == innerHTML) {
                if (null != itemQuantityDiscount) {
                    itemQuantityDiscount.style.display = "none"; //hide item level price range
                }
                if (null != quantityDiscount) {
                    quantityDiscount.style.display = ""; //display product level price range
                }
            }

            /*
             * If the product name is a link, do not replace the link only replace the text in the link.
             * Otherwise, replace the whole text
             */
            var productNameLink = $('#product_name_' + productId + ' > a');
            if (productNameLink.length == 1) {
                $(productNameLink[0]).html(catEntry.description[0].name);
            } else if ($('#product_name_' + productId)) {
                $('#product_name_' + productId).html(catEntry.description[0].name);
            }

            if ($("#widget_product_info_viewer > div[id^='PageHeading_']").length) {
                $("#widget_product_info_viewer > div[id^='PageHeading_']").each(function (i, node) {
                    if (node.childNodes != null && node.childNodes.length == 3) {
                        node.childNodes[1].innerHTML = catEntry.description[0].name;
                    }
                });
            }
            if (document.getElementById("ProductInfoName_" + productId) != null) {
                document.getElementById("ProductInfoName_" + productId).value = catEntry.description[0].name;
            }
            if (document.getElementById('product_shortdescription_' + productId)) {
                document.getElementById('product_shortdescription_' + productId).innerHTML = catEntry.description[0].shortDescription;
            }
            if (document.getElementById('product_SKU_' + productId)) {
                document.getElementById('product_SKU_' + productId).innerHTML = Utils.getLocalizationMessage('SKU') + " " + catEntry.catalogEntryIdentifier.externalIdentifier.partNumber;
            }
        }
    },

    /**
     *This method will show the WC Dialog popup
     *@param{String} widgetId The ID of the WC Dialog which should be shown
     */
    showWCDialogPopup: function (widgetId) {
        var dialog = $("#" + widgetId).data("wc-WCDialog");
        if (dialog) {
            dialog.open();
            $("#" + widgetId).css("display", "block");
        } else {
            console.debug(widgetId + " does not exist");
        }
    },

    /**
     * To notify the change in attribute to other components that is subscribed to DefiningAttributes_Resolved_[productId] event.
     */
    notifyAttributeChange: function (catalogEntryID) {
        this.baseCatalogEntryId = catalogEntryID;
        var selectedAttributes = this.selectedAttributesList["entitledItem_" + catalogEntryID];
        wcTopic.publish('DefiningAttributes_Resolved_' + catalogEntryID, catalogEntryID, -1);
    },

    /**
     * To notify the change in quantity to other components that is subscribed to Quantity_Changed event.
     */
    notifyQuantityChange: function (quantity) {
        wcTopic.publish("Quantity_Changed", quantity);
    },

    /**
     * Initializes the compare check box for all the products added to compare.
     */
    initCompare: function (fromPage) {
        if (fromPage == 'compare' || fromPage == 'catalogEntryList') {
            this.checkForCompare();
        } else {
            var cookieKey = this.cookieKeyPrefix + this.storeId;
            var newCookieValue = "";
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
        }

    },

    /**
     * Change the compare box status to checked or unchecked
     * @param{String} cbox The ID of the compare check box of the given catentry identifier.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    changeCompareBox: function (cbox, catEntryIdentifier) {
        box = document.getElementById(cbox);
        box.checked = !box.checked;
        this.addOrRemoveFromCompare(catEntryIdentifier, box.checked);
    },

    /**
     * Adds or removes the product from the compare depending on the compare box checked or unchecked.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     * @param{boolean} checked True if the checkbox is checked or False
     */
    addOrRemoveFromCompare: function (catEntryIdentifier, checked) {
        //box = eval(cbox);
        if (checked) {
            this.addToCompare(catEntryIdentifier);
        } else {
            this.removeFromCompare(catEntryIdentifier);
        }
    },

    /**
     * Adds the product to the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    addToCompare: function (catEntryIdentifier) {

        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);

        if (cookieValue != null) {
            if (cookieValue.indexOf(catEntryIdentifier) != -1 || catEntryIdentifier == null) {
                MessageHelper.displayErrorMessage(Utils.getLocalizationMessage("COMPARE_ITEM_EXISTS"));
                return;
            }
        }

        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null && cookieValue !== "") {
            currentNumberOfItemsInCompare = cookieValue.split(this.cookieDelimiter).length;
        }

        if (currentNumberOfItemsInCompare < parseInt(this.maxNumberProductsAllowedToCompare)) {
            var newCookieValue = "";
            if (cookieValue == null || cookieValue === "") {
                newCookieValue = catEntryIdentifier;
            } else {
                newCookieValue = cookieValue + this.cookieDelimiter + catEntryIdentifier;
            }
            setCookie(cookieKey, newCookieValue, {
                path: '/',
                domain: cookieDomain
            });
            shoppingActionsJS.checkForCompare();
        } else {
            this.showWCDialogPopup('widget_product_comparison_popup');
            document.getElementById("comparebox_" + catEntryIdentifier).checked = false;
            console.debug("You can only compare up to 4 products");
        }
    },

    /**
     * Removes the product from the compare cookie.
     * @param{String} catEntryIdentifier The catalog entry identifer to current product.
     */
    removeFromCompare: function (catEntryIdentifier) {
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        var currentNumberOfItemsInCompare = 0;
        if (cookieValue != null) {
            if (cookieValue.trim() == "") {
                setCookie(cookieKey, null, {
                    expires: -1
                });
            } else {
                var cookieArray = cookieValue.split(this.cookieDelimiter);
                var newCookieValue = "";
                for (index in cookieArray) {
                    if (cookieArray[index] != catEntryIdentifier) {
                        if (newCookieValue === "") {
                            newCookieValue = cookieArray[index];
                        } else {
                            newCookieValue = newCookieValue + this.cookieDelimiter + cookieArray[index];
                        }
                    }
                }
                setCookie(cookieKey, newCookieValue, {
                    path: '/',
                    domain: cookieDomain
                });
                currentNumberOfItemsInCompare = newCookieValue.split(this.cookieDelimiter).length;
            }
            shoppingActionsJS.checkForCompare();
        }
    },

    /**
     * Re-directs the browser to the CompareProductsDisplay page to compare products side-by-side.
     */
    compareProducts: function (categoryIds, manufacturer) {
        var url = appendWcCommonRequestParameters("CompareProductsDisplayView?storeId=" + this.storeId + "&catalogId=" + this.catalogId + "&langId=" + this.langId + "&compareReturnName=" + encodeURIComponent(this.compareReturnName) + "&searchTerm=" + this.searchTerm);
        if ('' != categoryIds.top_category) {
            url = url + "&top_category=" + categoryIds.top_category;
        }
        if ('' != categoryIds.parent_category_rn) {
            url = url + "&parent_category_rn=" + categoryIds.parent_category_rn;
        }
        if ('' != categoryIds.categoryId) {
            url = url + "&categoryId=" + categoryIds.categoryId;
        }
		if (manufacturer != undefined && '' != manufacturer) {
			url = url + "&manufacturer=" + manufacturer;
		}
		
        var cookieKey = this.cookieKeyPrefix + this.storeId;
        var cookieValue = getCookie(cookieKey);
        if (cookieValue != null && cookieValue.trim() != "") {
            url = url + "&catentryId=" + cookieValue;
        }
        var returnUrl = appendWcCommonRequestParameters(location.href);
        if (returnUrl.indexOf("?") === -1) {
            returnUrl = returnUrl + "?fromPage=compare";
        } else if (returnUrl.indexOf("fromPage=compare") === -1) {
            returnUrl = returnUrl + "&fromPage=compare";
        }
        url = url + "&returnUrl=" + encodeURIComponent(returnUrl);
        location.href = getAbsoluteURL() + url;
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {String} catalogEntryType, type of catalogEntry (item/product/bundle/package)
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     * @param {float} price The price of current product.
     */
    setProductQuantity: function (catalogEntryType, catalogEntryId, quantity, price) {
        var productDetails = null;
        if (this.productList[catalogEntryId]) {
            productDetails = this.productList[catalogEntryId];
        } else {
            productDetails = {};
            this.productList[catalogEntryId] = productDetails;
            productDetails.baseItemId = catalogEntryId;
            if ("item" == catalogEntryType) {
                productDetails.id = catalogEntryId;
            } else {
                productDetails.id = 0;
            }
        }
        productDetails.quantity = quantity;
        wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));
        productDetails.price = Utils.parseNumber(price);
    },

    /**
     * Sets the quantity of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} quantity The quantity of current product.
     */
    quantityChanged: function (catalogEntryId, quantity) {
        if (this.productList[catalogEntryId]) {
            var productDetails = this.productList[catalogEntryId];
            productDetails.quantity = quantity.trim();
            wcTopic.publish("Quantity_Changed", JSON.stringify(productDetails));

            //Update quantity for catentries in the merchandising association array
            if (MerchandisingAssociationJS != null) {
                if (MerchandisingAssociationJS.baseItemParams != null) {
                    if (MerchandisingAssociationJS.baseItemParams.type == 'BundleBean') {
                        // Update items in the bundle
                        for (idx = 0; idx < MerchandisingAssociationJS.baseItemParams.components.length; idx++) {
                            if (catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].productId || catalogEntryId == MerchandisingAssociationJS.baseItemParams.components[idx].id) {
                                MerchandisingAssociationJS.baseItemParams.components[idx].quantity = productDetails.quantity;
                            }
                        }
                    }
                }
            }
        }
    },

    /**
     * Sets the price of a product in the list (bundle)
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {int} price The price of current product.
     */
    setPriceInProductList: function (catalogEntryId, price) {
        var productDetails = this.productList[catalogEntryId];
        if (productDetails) {
            productDetails.price = price;
        }
    },

    /**
     * Select bundle item swatch
     * 
     * @param {int} catalogEntryId The catalog entry identifer to current product.
     * @param {String} swatchName
     * @param {String} swatchValue
     * @param {String} doNotDisable, the first swatch, that should not be disabled
     */
    selectBundleItemSwatch: function (catalogEntryId, swatchName, swatchValue, doNotDisable) {
        if ($("#swatch_" + catalogEntryId + "_" + swatchName + "_" + swatchValue).hasClass("color_swatch_disabled")) {
            return;
        }
        if ($("#entitledItem_" + catalogEntryId).length) {
            var entitledItemJSON;
            var currentSwatchkey = swatchName + "_" + swatchValue;
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = JSON.stringify($("#entitledItem_" + catalogEntryId).html());
            var validSwatchArr = [];
            for (idx in entitledItemJSON) {
                var validItem = false;
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {

                    if (currentSwatchkey == attribute) {
                        validItem = true;
                        break;
                    }
                }
                if (validItem) {
                    for (attribute in entitledItem.Attributes) {
                        var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                        if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                            validSwatchArr.push(attribute);
                        }
                    }
                }
            }

            var swatchesDisabled = [];
            var selectedSwatches = [];
            for (idx in entitledItemJSON) {
                var entitledItem = entitledItemJSON[idx];
                for (attribute in entitledItem.Attributes) {
                    var currentSwatch = attribute.substring(0, attribute.lastIndexOf("_|_"));
                    if (currentSwatch != doNotDisable && currentSwatch != swatchName) {
                        var swatchId = "swatch_" + catalogEntryId + "_" + attribute;
                        var swatchLinkId = swatchId.replace("swatch_", "swatch_link_");
                        if (validSwatchArr.indexOf(attribute) > -1) {
                            if (!$("#" + swatchId).hasClass("color_swatch_selected")) {
                                document.getElementById(swatchId).className = "color_swatch";
                                document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_disabled.png", "_enabled.png");

                                //change the title text of the swatch link
                                document.getElementById(swatchLinkId).title = document.getElementById(swatchId).alt;
                                document.getElementById(swatchLinkId).setAttribute("aria-disabled", "false");
                            }
                        } else if (swatchesDisabled.indexOf(attribute) === -1) {
                            swatchesDisabled.push(attribute);
                            if ($("#" + swatchId).hasClass("color_swatch_selected")) {
                                selectedSwatches.push(swatchId);
                            }
                            document.getElementById(swatchId).className = "color_swatch_disabled";
                            document.getElementById(swatchId).src = document.getElementById(swatchId).src.replace("_enabled.png", "_disabled.png");

                            //change the title text of the swatch link
			    
			    var altText = document.getElementById(swatchId).alt;
                            var titleText = Utils.getLocalizationMessage("INV_ATTR_UNAVAILABLE", [altText]);
                            

                           
                            $("#" + swatchLinkId).attr("aria-disabled", "true");
                        }
                    }
                    if (document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute) != null) {
                        document.getElementById("swatch_link_" + catalogEntryId + "_" + attribute).setAttribute("aria-checked", "false");
                    }
                }
            }

            for (idx in selectedSwatches) {
                var selectedSwatch = selectedSwatches[idx];
                var idSelector = selectedSwatch.substring(0, selectedSwatch.lastIndexOf("_|_"));
                var swatchSelected = false;
                $("[id^='" + idSelector + "']").each(function (index, node, arr) {
                    if (!swatchSelected && $(node).hasClass("color_swatch")) {
                        var values = node.id.split("_");
                        shoppingActionsJS.selectBundleItemSwatch(values[1], values[2], values[3], doNotDisable);
                        shoppingActionsJS.setSelectedAttributeOfProduct(values[1], values[2], values[3], false);
                        swatchSelected = true;
                    }
                });
            }
        }

        if ($("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display") == ("none")) {
            $("#swatch_selection_" + catalogEntryId + "_" + swatchName).css("display", "inline");
        }
        $("#swatch_selection_" + catalogEntryId + "_" + swatchName).html(swatchValue);

        var swatchItem = "swatch_" + catalogEntryId + "_" + swatchName + "_";
        var swatchItemLink = "swatch_link_" + catalogEntryId + "_" + swatchName + "_";

        $("img[id^='" + swatchItem + "']").each(function (index, node, arr) {
            if ($(node).hasClass("color_swatch_disabled")) {
                $(node).removeClass("color_swatch")
            } else {
                $(node).addClass("color_swatch");
            }
            $(node).removeClass("color_swatch_selected");
        });

        $("#" + swatchItem + swatchValue).attr("className", "color_swatch_selected");
        document.getElementById(swatchItemLink + swatchValue).setAttribute("aria-checked", "true");

        this.setSelectedAttributeOfProduct(catalogEntryId, swatchName, swatchValue, false);
        // select image
        this.changeBundleItemImage(catalogEntryId, swatchName, swatchValue, "productThumbNailImage_" + catalogEntryId);

    },

    changeBundleItemImage: function (catalogEntryId, swatchAttrName, swatchAttrValue, skuImageId) {
        var entitledItemId = "entitledItem_" + catalogEntryId;
        if ($("#" + entitledItemId).length) {
            //the json object for entitled items are already in the HTML. 
            entitledItemJSON = eval('(' + $("#" + entitledItemId).html() + ')');
        }

        this.setEntitledItems(entitledItemJSON);

        var skuImage = null;
        var imageArr = shoppingActionsJS.getImageForBundleItem(catalogEntryId);
        if (imageArr != null) {
            skuImage = imageArr[1];
        }

        if (skuImageId != undefined) {
            this.setSKUImageId(skuImageId);
        }

        if (skuImage != null) {
            if ($("#" + this.skuImageId) != null) {
                document.getElementById(this.skuImageId).src = skuImage;
                if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                    document.getElementById("ProductInfoImage_" + catalogEntryId).value = skuImage;
                }
            }
        } else {
            var imageFound = false;
            for (x in this.entitledItems) {
                var Attributes = this.entitledItems[x].Attributes;
                var itemImage = this.entitledItems[x].ItemThumbnailImage;

                for (y in Attributes) {
                    var index = y.indexOf("_|_");
                    var entitledSwatchName = y.substring(0, index);
                    var entitledSwatchValue = y.substring(index + 3);

                    if (entitledSwatchName == swatchAttrName && entitledSwatchValue == swatchAttrValue) {
                        document.getElementById(this.skuImageId).src = itemImage;
                        if (document.getElementById("ProductInfoImage_" + catalogEntryId) != null) {
                            document.getElementById("ProductInfoImage_" + catalogEntryId).value = itemImage;
                        }
                        imageFound = true;
                        break;
                    }
                }

                if (imageFound) {
                    break;
                }
            }
        }
    },

    getImageForBundleItem: function (entitledItemId) {
        var attributeArray = [];
        var selectedAttributes = this.selectedProducts[entitledItemId];
        for (attribute in selectedAttributes) {
            attributeArray.push(attribute + "_|_" + selectedAttributes[attribute]);
        }
        return this.resolveImageForSKU(attributeArray);
    },

    /**
     * Check if any product is already selected for compare in other pages and select them
     */
    checkForCompare: function () {
        var cookieValues = getCookie(shoppingActionsJS.cookieKeyPrefix + shoppingActionsJS.storeId);
        cookieValues = (cookieValues ? cookieValues.split(shoppingActionsJS.cookieDelimiter) : []);
        var labels = $(".compareCheckboxLabels > label");
        $(".compare_target").each(function (i, div) {
            var checkbox = $("input[type=\"checkbox\"]", div)[0];
            checkbox.checked = (cookieValues.indexOf(checkbox.value) !== -1);
            var state = (checkbox.checked ? (cookieValues.length > 1 ? 2 : 1) : 0);
            div.setAttribute("data-state", state.toString());
            var label = $("label[for=\"" + checkbox.id + "\"]", div)[0];
            $(label).html($(labels[state]).html());
        });
    },

    /**
     * replaceItemAjaxHelper This function is used to replace an item in the cart. This will be called from the {@link this.ReplaceItemAjax} method.
     *
     * @param {String} catalogEntryId The catalog entry of the item to replace to the cart.
     * @param {int} qty The quantity of the item to add.
     * @param {String} removeOrderItemId The order item ID of the catalog entry to remove from the cart.
     * @param {String} addressId The address ID of the order item.
     * @param {String} shipModeId The shipModeId of the order item.
     * @param {String} physicalStoreId The physicalStoreId of the order item.
     *
     **/
    replaceItemAjaxHelper: function (catalogEntryId, qty, removeOrderItemId, addressId, shipModeId, physicalStoreId) {

        var params = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderItemId: removeOrderItemId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params2 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            catEntryId: catalogEntryId,
            quantity: qty,
            orderId: ".",
	    calculateOrder: "1"
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params2.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params2.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var params3 = {
            storeId: WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            langId: WCParamJS.langId,
            orderId: "."
        };
        if (CheckoutHelperJS.shoppingCartPage) {
            params3.calculationUsage = "-1,-2,-5,-6,-7";
        } else {
            params3.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
        }

        var shipInfoUpdateNeeded = false;
        var orderItemReqd = true;
        if (addressId != null && addressId !== "") {
            params3.addressId = addressId;
        }
        if (shipModeId != null && shipModeId !== "") {
            params3.shipModeId = shipModeId;
        }
        if (physicalStoreId != null && physicalStoreId !== "") {
            params3.physicalStoreId = physicalStoreId;
            orderItemReqd = false;
        }
        if (params3.shipModeId != null && (params3.addressId != null || params3.physicalStoreId != null)) {
            shipInfoUpdateNeeded = true;
        }

        if (orderItemReqd) {
            params3.allocate = "***";
            params3.backorder = "***";
            params3.remerge = "***";
            params3.check = "*n";
        }

        //Delcare service for deleting item...
        wcService.declare({
            id: "AjaxReplaceItem",
            actionId: "AjaxReplaceItem",
            url: "AjaxRESTOrderItemDelete",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                //Now add the new item to cart..
                if (!shipInfoUpdateNeeded) {
                    //We dont plan to update addressId and shipMOdeId..so call AjaxAddOrderItem..
                    wcService.invoke("AjaxAddOrderItem", params2);
                } else {
                    //We need to update the adderessId and shipModeId..so call our temp service to add..
                    wcService.invoke("AjaxAddOrderItemTemp", params2);
                }
            }

            ,
            failureHandler: function (serviceResponse) {
                if (serviceResponse.errorMessage) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                } else {
                    if (serviceResponse.errorMessageKey) {
                        MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    }
                }
                cursor_clear();
            }

        });

        //Delcare service for adding item..
        wcService.declare({
            id: "AjaxAddOrderItemTemp",
            actionId: "AjaxAddOrderItemTemp",
            url: "AjaxRESTOrderItemAdd",
            formId: ""

            ,
            successHandler: function (serviceResponse) {
                // setting the newly created orderItemId
                params3.orderItemId = (serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId;

                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);

                //Now item is added.. call update to set addressId and shipModeId...
                wcService.invoke("OrderItemAddressShipMethodUpdate", params3);
            }

            ,
            failureHandler: function (serviceResponse) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        });

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        wcService.invoke("AjaxReplaceItem", params);
    },

    /**
     * customizeDynamicKit This function is used to call the configurator page for a dynamic kit.
     * @param {String} catEntryIdentifier A catalog entry ID of the item to add to the cart.
     * @param {int} quantity A quantity of the item to add to the cart.
     * @param {Object} customParams - Any additional parameters that needs to be passed to the configurator page.
     *
     **/
    customizeDynamicKit: function (catEntryIdentifier, quantity, customParams) {
        var params = {
            storeId: this.storeId,
            catalogId: this.catalogId,
            langId: this.langId,
            catEntryId: catEntryIdentifier,
            quantity: quantity
        };

        if (!isPositiveInteger(quantity)) {
            MessageHelper.displayErrorMessage(Utils.getLocalizationMessage('QUANTITY_INPUT_ERROR'));
            return;
        }

        var contractIdElements = document.getElementsByName('contractSelectForm_contractId');
        if (contractIdElements != null && contractIdElements != "undefined") {
            for (i = 0; i < contractIdElements.length; i++) {
                if (contractIdElements[i].checked) {
                    params.contractId = contractIdElements[i].value;
                    break;
                }
            }
        }

        //Pass any other customParams set by other add on features
        if (customParams != null && customParams != 'undefined') {
            for (i in customParams) {
                params[i] = customParams[i];
            }
        }

        //For Handling multiple clicks
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        var configureURL = "ConfigureView";
        var i = 0;
        for (param in params) {
            configureURL += ((i++ == 0) ? "?" : "&") + param + "=" + params[param];
        }
        document.location.href = getAbsoluteURL() + appendWcCommonRequestParameters(configureURL);
    }

}

wcTopic.subscribe("ProductInfo_Reset", shoppingActionsJS.resetProductAddedList);

$(document).ready(function () {
    var ie_version = Utils.get_IE_version();
    if (ie_version < 9) {
        $(document).on("click", ".compare_target > input[type=\"checkbox\"]:click", function (event) {
            this.blur();
            this.focus();
        });
    }
});

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2011, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

////////////////////////////////////////////////////
// MiniShopCartDisplay.js (Common implementation) //
////////////////////////////////////////////////////
//console.log("MiniShopCartDisplay.js (Common implementation) loaded");

function closeMiniShopCartDropDown(){
    var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");
    var isWishlistPage = $("#page").hasClass("wishListDisplay") ? true : false;

    //Start HB-12482 
    if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "auto");	
    }
  //End HB-12482 
    
    if (visiblePopup.length>0){
    	if(isPersol) {
    		if(productDisplayJS.priceSwitched){
                if (!isWishlistPage){
                    document.getElementById('offerPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+catalogEntryDetails.uniqueID).innerText = productDisplayJS.lastOfferPriceSaved;
                    if(affirmEnabled) {
                        customizeAffirmPrice();
                    }
                } else {
                    var minicartAddedId = $("#cartDropdown .products.added .product").attr("data-minicart-id");
                    document.getElementById('offerPrice_'+ minicartAddedId).innerText = productDisplayJS.lastPriceSaved;
                    document.getElementById('listPrice_'+ minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                    $('#header').removeClass("mincartOpened")
                }
		    	productDisplayJS.priceSwitched = false;
    		}
            //START Early Access
            window.lastOfferPrice = returnLastOfferPrice();
            //END Early Access
    	}
    	else if(isOliver){
    		if(productDisplayJS.priceSwitched){
                var minicartAddedId = $("#cartDropdown .products .product").attr("data-minicart-id");
    			var elements = !isWishlistPage ? document.querySelectorAll('[id=offerPrice_'+productParent+']') : document.querySelectorAll('[id=offerPrice_'+minicartAddedId+']');
        		var div;
        		for(var i = 0; i<elements.length;i++) {
        			if(elements[i].nodeName == "DIV") {
        				div = elements[i];
        			}
        		}
        		if(div != undefined) {
        			div.getElementsByClassName('price__unity')[0].innerText = productDisplayJS.lastPriceSaved;
        		}
	    	 	
                if (!isWishlistPage){
                    document.getElementById('listPrice_'+productParent).innerText = productDisplayJS.lastOfferPriceSaved;
                } else {
                    document.getElementById('listPrice_'+minicartAddedId).innerText = productDisplayJS.lastOfferPriceSaved;
                }

		    	if(affirmEnabled && !isWishlistPage) {
		    		customizeAffirmPrice();
		    	}
		    	productDisplayJS.priceSwitched = false;
    		}
    		
    		//open Vm if was opened
    		if ($.cookie("isVMOpen") == "1") {
    			moveVMOverProduct();
    			vmTryThemOn();
    		}
    	}
    	productDisplayJS.lastPriceSaved =  "";
    	productDisplayJS.lastOfferPriceSaved = "";
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}
    	
    
        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }

    visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

    if (visiblePopup.length>0){
    	if($('#current-clipon-catentry').length > 0 && (isPersol || isOliver)){
    		if($('#current-clipon-catentry').attr('isAdded') == 'true'){
    			$('#current-clipon-catentry').attr('isAdded','');
    		}else{
    			$(visiblePopup).find(".closeButton").click();
    		}
    	}else{
    		$(visiblePopup).find(".closeButton").click();
    	}

        /*
        This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
        It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
        */
        while ($("#MiniShopCartProductAdded").length>0){
            $("#MiniShopCartProductAdded").remove();
        }
    }
    if (isOliver || isPersol) { 
        manageScrollOverlay(false);
    }

    if (isPersol){
        $('.shopperActions--monogram--added--button.remove').click();
    }
    
}

/*
//Extra events for minishopcart buttons
function bindMiniShopCartEvents(){
    $("#continueShoppingButton").on("click touchstart", function(){
        closeMiniShopCartDropDown();
        return false;
    });
}

$(document).ready(bindMiniShopCartEvents);
$(document).ajaxComplete(bindMiniShopCartEvents);
*/
/*
function repositionMiniShopCart(){
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).css("top",-($(window).scrollTop())+"px");
}

//Manage minishopcart's position on mobile
function onScrollMiniShopCart(){
    console.log("PSL::onScrollMiniShopCart()");
    var reposition = false;
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    if ($(popup).length>0){
        for (var i = 0; i < $(popup).length; i++) {
            var element = $(popup)[i];
            if (!reposition && element.clientHeight > window.innerHeight){
                reposition = true;
            }
        }
    } else {
        console.log("PSL::onScrollMiniShopCart()::No minishopcart on screen");
    }

    if (reposition){
        console.log("PSL::onScrollMiniShopCart()::Repositioning minishopcart");
        var scrollTop = $(window).scrollTop();
        $(popup).css("top",(scrollTop*(-1))+"px");
    } else {
        console.log("PSL::onScrollMiniShopCart()::No reposition needed");
    }
}

$(document.body).on('touchmove', onScrollMiniShopCart); //mobile
$(window).on('scroll', onScrollMiniShopCart);           //desktop

function repositionMiniShopCartPopup(){
    console.log("Posicionando BEGIN");
    var popup = $("div[aria-describedby=quick_cart_container]:visible, div[aria-describedby=MiniShopCartProductAdded]:visible");
    $(popup).position({
        my: "right top",
        at: "right bottom",
        of: "#miniShopCartPopupPositionReference"
    });
    console.log("Posicionando END");
}
*/

//HB-1816 BEGIN Close MiniShopCart popup when the user clicks outside of it
$(document).click(function(event) {
    //console.log("PSL::MiniShopCartDisplay.js::Document clicked");

    // Ignore this event if preventDefault has been called.
    if (event.defaultPrevented){
        //console.log("PSL::MiniShopCartDisplay.js::event.defaultPrevented");
        return;
    }

    var isFade = ($(event.target).hasClass("quickcart--fade") || $(event.target).hasClass("minishopcartadded--fade"));

    var mouseX = event.pageX;
    var mouseY = event.pageY;

    if (mouseX != undefined && mouseY != undefined){
        //console.log("PSL::MiniShopCartDisplay.js::mouseX: " + mouseX + ", mouseY: " + mouseY);

        var visiblePopup = $("div[aria-describedby=MiniShopCartProductAdded]:visible");

        if (visiblePopup.length>0){
            event.stopPropagation();
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product Added popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                if($('#page').hasClass('pdp') && brandCode == 'PO'){
                    hideHeaderTimeout.setup();
                    $('#header').css('z-index', '5') 
                }
                $(visiblePopup).find(".closeButton").click();

                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }

        visiblePopup = $("div[aria-describedby=quick_cart_container]:visible");

        if (visiblePopup.length>0){
            //console.log("PSL::MiniShopCartDisplay.js::Minicart Product List popup visible");
            var popupX = $(visiblePopup).offset().left;
            var popupY = $(visiblePopup).offset().top;
            var popupW = $(visiblePopup).outerWidth();
            var popupH = $(visiblePopup).outerHeight();
            //console.log("PSL::MiniShopCartDisplay.js::popupOffsetX: " + popupX + ", popupOffsetY: " + popupY);
            //console.log("PSL::MiniShopCartDisplay.js::popupWidth: " + popupW + ", popupHeight: " + popupH);
            if (mouseX >= popupX && mouseX <= popupX + popupW && mouseY >= popupY && mouseY <= popupY + popupH || isFade){
                //console.log("PSL::MiniShopCartDisplay.js::Click inside");
            } else {
                //console.log("PSL::MiniShopCartDisplay.js::Click outside");
                event.preventDefault();
                event.stopPropagation();
                $(visiblePopup).find(".closeButton").click();
                if(brandCode == 'PO' && $('#page').hasClass('pdp')){
                    hideHeaderTimeout.setup()
                }
                /*
                This WHILE has been added because in Oliver more than one #MiniShopCartProductAdded div is being created.
                It seems that the reason of this bug is that some html ids have been renamed/deleted in header_ui.jspf
                */
                while ($("#MiniShopCartProductAdded").length>0){
                    $("#MiniShopCartProductAdded").remove();
                }

                return false;
            }
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::No visible Minicart");
        }
    }
});
//HB-1816 END

function lockShoppingBagIcon(){
    $("#widget_minishopcart").addClass("isDisabled");
    $("#widget_minishopcart").attr("href-disabled", $("#widget_minishopcart").attr("href") );
    $("#widget_minishopcart").attr("onclick-disabled", $("#widget_minishopcart").attr("onclick") );
    $("#widget_minishopcart").removeAttr("href");
    $("#widget_minishopcart").removeAttr("onclick");
}

function unlockShoppingBagIcon(){
    $("#widget_minishopcart").attr("href", $("#widget_minishopcart").attr("href-disabled") );
    $("#widget_minishopcart").attr("onclick", $("#widget_minishopcart").attr("onclick-disabled") );
    $("#widget_minishopcart").removeAttr("href-disabled");
    $("#widget_minishopcart").removeAttr("onclick-disabled");
    $("#widget_minishopcart").removeClass("isDisabled");
}

$(document).ready(function(){
    unlockShoppingBagIcon();
});


////////////////////////////////////////////////////
// OOTB source code                               //
////////////////////////////////////////////////////
/**
 * @fileOverview This file provides the common functions which are specific to the Mini Shopping cart
 */

/**
 * map order_updated to all the services that result in changes to an order
 * @static
 */

var order_updated = {
    'AjaxAddOrderItem': 'AjaxAddOrderItem',
    'AddOrderItem': 'AddOrderItem',
    'AjaxAddOrderItemWithShipingInfo': 'AjaxAddOrderItemWithShipingInfo',
    'AjaxDeleteOrderItem': 'AjaxDeleteOrderItem',
    'AjaxUpdateOrderItem': 'AjaxUpdateOrderItem',
    'AjaxUpdateOrderShippingInfo': 'AjaxUpdateOrderShippingInfo',
    'AjaxOrderCalculate': 'AjaxOrderCalculate',
    'AjaxLogoff': 'AjaxLogoff',
    'AjaxSetPendingOrder': 'AjaxSetPendingOrder',
    'AjaxUpdatePendingOrder': 'AjaxUpdatePendingOrder',
    'AjaxSingleOrderCancel': 'AjaxSingleOrderCancel',
    'AjaxUpdateRewardOption': 'AjaxUpdateRewardOption'
};

/** This variable indicates whether the mini cart drop down is updated or not. */
var dialogWidget,
    update_content = false,
    dropdownUpdated = false,
    /** This is variable indicates whether the mini cart drop down is being initialized. */
    dropdownInit = false,
    productAddedList = {};

function declareMiniShoppingCartRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea()::BEGIN");
    // ============================================
    // initialize refresh area widgets
    // ============================================

    // ============================================
    // div: MiniShoppingCart refresh area
    // Declares a new refresh controller for the Mini Shopping Cart.

    // declare render context
    wcRenderContext.declare("MiniShoppingCartContext", ["MiniShoppingCart"], { status: "init" });

    /*
    /* Refreshes the mini shopping cart.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().renderContextChangedHandler()::BEGIN");
        if (wcRenderContext.testForChangedRC("MiniShoppingCartContext", ["status"])) {
            wcRenderContext.getRenderContextProperties("MiniShoppingCartContext").deleteCartCookie = true;
            $("#MiniShoppingCart").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShoppingCartContext"));
        }
    };

    // model change
    /*
     * Refreshes the mini shopping cart.
     * If a new order item is added via an Ajax service call, set the mini shopping cart to display the new order item in the dropdown.
     * Otherwise, only refresh the contents of mini shopping cart to the updated order information.
     * This function is called when a modelChanged event is detected.
     *
     * @param {string} event The model changed event
     * @param {object} returnData The data returned from the event
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage" });
    wcTopic.subscribe(events, function(returnData) {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().wcTopic.subscribe()::BEGIN");
        var param = [];
        if (returnData.actionId == 'AddOrderItem') {
            if (returnData.data.orderItem != null && returnData.data.orderItem[0].orderItemId != null) {
                var addedOrderItemIdString = "";
                for (var i = 0; i < returnData.data.orderItem.length; i++) {
                    if (addedOrderItemIdString !== "") {
                        addedOrderItemIdString += ",";
                    }
                    addedOrderItemIdString += returnData.data.orderItem[i].orderItemId;
                }
                param.addedOrderItemId = addedOrderItemIdString;
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            } else {
                param.addedOrderItemId = returnData.data.orderItemId + "";
                param.catEntryId = returnData.data.catEntryId;
                param.productId = returnData.data.catEntryId;
            }

            if(productDisplayJS && productDisplayJS.YMALProductFlag) { //se abbiamo aggiunto un prodotto dai prodotti suggeriti a carrello
				productDisplayJS.YMALProductFlag = false;
				showDropdown = false; //no minicart
                window.location.reload();
			} else if (productDisplayJS && productDisplayJS.RMAProductFlag){
                productDisplayJS.RMAProductFlag = false;
				showDropdown = false; //no minicart
            }
            else {
                showDropdown = true;
            }
        }
        param.deleteCartCookie = true;
        if (returnData.data.addedFromSKUList != null && returnData.data.addedFromSKUList[0] != null) {
            param.addedFromSKUList = returnData.data.addedFromSKUList[0];
        }
        if(window.skipMiniCart) {
            getNumberOfItemsInCart(itemsInCartBadge);
            goDirectToCart();
        }
        else
            $("#MiniShoppingCart").refreshWidget("refresh", param);
           
    });

    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShoppingCartRefreshArea().postRefreshHandler()::BEGIN");
        //The dialog contents has changed..so destroy the old dialog with stale data..
        destroyDialog("MiniShopCartProductAdded");

        if (showDropdown) {
            update_content = true;
            //We have added item to cart..So display the drop down with item added message..
            positionMiniShopCartDropDown("widget_minishopcart", 'MiniShopCartProductAdded', 'orderItemAdded');
            showDropdown = false;
        }

        if (!multiSessionEnabled) {
            setTimeout(() => {
                updateCartCookie();
            }, 0);
        }

        populateProductAddedDropdown();

        if (!multiSessionEnabled) {
            setTimeout(() => {
                resetDeleteCartCookie();
            }, 0);
        }
    };

    // initialize widget
    $("#MiniShoppingCart").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });
}

function declareMiniShopCartContentsRefreshArea() {
    //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea()::BEGIN");
    // ============================================
    // div: MiniShopCartContents refresh area
    // Declares a new refresh controller for the Mini Shopping Cart contents

    // Declares a new render context for the Mini Shopping Cart contents.
    wcRenderContext.declare("MiniShopCartContentsContext", ["MiniShopCartContents"], { status: "init", relativeId: "", contentId: "", contentType: "" });

    /*
     * Refreshes the mini shopping cart contents since it is out of date.
     * This function is called when a render context changed event is detected.
     */
    var renderContextChangedHandler = function(event, data) {
        if (!dropdownUpdated) {
            wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext").fetchCartContents = true;
            dropdownUpdated = true;
            $("#MiniShopCartContents").refreshWidget("refresh", wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext"));
        }
    };

    /*
     * Indicate that the mini cart contents are out of date upon an order change action.
     * This function is called when a modelChanged event is detected.
     */
    var events = $.extend({}, order_updated, { "AjaxDeleteOrderItemForShippingBillingPage": "AjaxDeleteOrderItemForShippingBillingPage", "AjaxRESTOrderLockUnlockOnBehalf": "AjaxRESTOrderLockUnlockOnBehalf" });
    wcTopic.subscribe(events, function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().wcTopic.subscribe()::BEGIN");
        dropdownUpdated = false;
    });

    /*
     * Displays and positions the mini shop cart contents.
     * This function is called after a successful refresh.
     */
    var postRefreshHandler = function() {
        //console.log("PSL::MiniShopCartDisplay.js::declareMiniShopCartContentsRefreshArea().postRefreshHandler()::BEGIN");
        var renderContextProperties = wcRenderContext.getRenderContextProperties("MiniShopCartContentsContext");
        positionMiniShopCartDropDown(renderContextProperties.relativeId, renderContextProperties.contentId, renderContextProperties.contentType);
        //
        // This is needed for CSR solution. When CSR and shopper are browsing the store in simultaenously in
        // different browsers and if CSR locks/unlocks the shoppers cart, the miniCart in shopper's browser will
        // NOT reflect the change unless shopper takes some order related actions (add/delete from cart).
        // So to update the miniCart status loadMiniCart() function is called here.
        // It doesn't make another server call. The data returned from the MiniCartContentsUI is used
        // to refresh the miniCart summary.
        //
        updateCartCookie();
        loadMiniCart(WCParamJS.commandContextCurrency, WCParamJS.langId);
    };

    // initialize widget
    $("#MiniShopCartContents").refreshWidget({ renderContextChangedHandler: renderContextChangedHandler, postRefreshHandler: postRefreshHandler });

}

/**
 * Displays the dropdown content of the mini shopping cart when the user hovers over the
 * mini shopping cart if the contents are up-to-date or retrieve the latest contents from server.
 *
 * PSL:: This OOTB function can block the minishopcart. The variable dropdownInit is true while the shopcart is loading.
 * If the user clicks the shoppingcart again while it's loading (dropdownInit variable is 'true') sometimes this flag
 * never goes back to false and the user cannot open the MSC anymore until page reload.
 * In order to solve this issue we added a function that prevents extra clicks over the shopping bag icon
 * while the minishoppingcart popup is loading (See lockShoppingBagIcon()/unlockShoppingBagIcon())
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function showMiniShopCartDropDown(relativeId, contentId, contentType) {
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::BEGIN");
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (!dropdownInit && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        dropdownInit = true;
        lockShoppingBagIcon();

        if (!dropdownUpdated) {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el IF");
            update_content = true;
            var params = {
                status: "load",
                relativeId: relativeId,
                contentId: contentId,
                contentType: contentType,
                page_view: "dropdown"
            };
            wcRenderContext.updateRenderContext("MiniShopCartContentsContext", params);
        } else {
            //console.log("PSL::MiniShopCartDisplay.js::showMiniShopCartDropDown()::Entro por el ELSE");
            positionMiniShopCartDropDown(relativeId, contentId, contentType);
        }
    }
}

function toggleMiniShopCartDropDown(relativeId, contentId, contentType) {
    if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')) {
        // if(!(window.mobilecheck() || window.tabletPortraitCheck()))hideHeaderTimeout.cancel();
        (dialogWidget && dialogWidget._isOpen) ? $("#page-overflow-wrapper").removeClass("overflow-hidden") : $("#page-overflow-wrapper").addClass("overflow-hidden");
    }
    //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::BEGIN");}
    if (dialogWidget && dialogWidget._isOpen) {
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.setup();
        }
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el IF");
        dialogWidget.close();
    } else {
        //console.log("PSL::MiniShopCartDisplay.js::toggleMiniShopCartDropDown()::Entro por el ELSE");
        showMiniShopCartDropDown(relativeId, contentId, contentType);
        if((brandCode == 'PO' || brandCode == 'OP') && $('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    }
}

/*
 * Displays the dropdown content of the mini shopping cart.
 *
 * @param {string} relativeId The id of a placeholder element to position the dropdown relatively
 * @param {string} contentId The id of the content pane containing the mini shopping cart dropdown contents
 * @param {string} contentType The content that will be shown in the expanded mini shopping cart dropdown.
 */
function positionMiniShopCartDropDown(relativeId, contentId, contentType) {
    //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown()::BEGIN");
    var add_event_handlers = function(contentElement) {
        //console.log("PSL::MiniShopCartDisplay.js::positionMiniShopCartDropDown().add_event_handlers()::BEGIN");
        contentElement.on("wcdialogopen", function(event) {
            //deactivate(document.getElementById("header"));
            $("#" + relativeId).addClass("selected");
        });

        contentElement.on("wcdialogclose", function(event) {
            $("#" + relativeId).removeClass("selected");
        });
    };

    // Dialog is not yet created..Create one
    if (!dialogWidget /*PSL Force dialog creation */ || true) {
        var content = $("#" + contentId);
        if (contentId === "MiniShopCartProductAdded") {
            // The content may have been hidden so show it
            $("#MiniShopCartProductAddedWrapper").removeAttr("style");
        }
        dialogWidget = content.WCDialog({
            position: {
                my: "right top",
                at: "right bottom",
                of: "#widget_minishopcart"
            },
            autoOpen: false,
            open: function() {
                // Make the element show up on top of the header elements
                dialogWidget.element.parent().css("z-index", 1);

                if (contentType == 'orderItemAdded') {
                    if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                    }else{
                        $("#MiniShopCartProductAddedWrapper").css("display", "block");
                    }
                }
            },
            appendTo: "#headerRow1",
            title: $("#" + contentId + "_ACCE_Label").html(),
            show_title: false,
            width: "360px",
            //dialogClass: "no-close",
            modal: false
        }).data("wc-WCDialog");
        add_event_handlers(content);
        update_content = false;

		/* APPLEPAY BEGIN */
		if (typeof(showApplePayButtons) == "function") {
			showApplePayButtons();
		}
        /* APPLEPAY END */

    } else {
        dialogWidget.close();
        if (update_content) {
            if (contentType == 'orderItemAdded') {
                if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
                    $("#MiniShopCartProductAddedWrapper").css("display", "flex");
                }else{
                    $("#MiniShopCartProductAddedWrapper").css("display", "block");
                }
            }
            var newContent = $("#" + contentId);
            dialogWidget.update_content("#" + contentId);
            add_event_handlers(newContent);
            update_content = false;
        }
    }

    if (Utils.get_IE_version() < 7) {
        dialogWidget.css("display", "block");
    }
    
    //Start HB-12482 
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
	    $("html, body").animate({
	        scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }else if((window.mobilecheck() || window.tabletPortraitCheck())){
    	$("html").css("overflow", "hidden");
    	$("html, body").animate({
	        //scrollTop: 0
	    }, {
	        duration: 200
	    }).promise().done(function() {
	        dialogWidget.open();
	        dialogWidget.reposition();
	    });
    }
    //End HB-12482 
    
    dropdownInit = false;

    unlockShoppingBagIcon();
}

/*
 * Store the current mini cart information in the mini cart cookie.
 */
function updateCartCookie() {
    //Save current order information into cookie
    if ($("#currentOrderQuantity").length && $("#currentOrderAmount").length && $("#currentOrderCurrency").length && $("#currentOrderId").length && $("#currentOrderLanguage").length) {
        var cartQuantity = $("#currentOrderQuantity").val();
        var cartAmount = $("#currentOrderAmount").val();
        var cartCurrency = $("#currentOrderCurrency").val();
        var cartLanguage = $("#currentOrderLanguage").val();
        var cartOrderId = $("#currentOrderId").val();
        var currentOrderLocked = $("#currentOrderLocked").val();

        //Clear out previous cookies
        var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);
        if (orderIdCookie != null) {
            setCookie("WC_CartOrderId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
            var cartTotalCookie = getCookie("WC_CartTotal_" + orderIdCookie);
            if (cartTotalCookie != null) {
                setCookie("WC_CartTotal_" + orderIdCookie, null, {
                    expires: -1,
                    path: '/',
                    domain: cookieDomain
                });
            }
        }
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, cartOrderId, {
            path: '/',
            domain: cookieDomain
        });
        if (cartOrderId !== "") {
            setCookie("WC_CartTotal_" + cartOrderId, cartQuantity + ";" + cartAmount + ";" + cartCurrency + ";" + cartLanguage + ";" + currentOrderLocked, {
                path: '/',
                domain: cookieDomain
            });
        }
    } else {
        setCookie("WC_CartOrderId_" + WCParamJS.storeId, "", { path: '/', domain: cookieDomain });
    }
}

function setProductAddedList(newProductAddedList) {
    productAddedList = newProductAddedList;
}

/*
 * Populates the Product Added dropdown upon an add to cart action.
 */
function populateProductAddedDropdown() {


    var search = '"';

    var replaceStr = "'";
    for (productId in productAddedList) {
        var productDetails = productAddedList[productId];

        if ($("#MiniShopCartAddedProdName_" + productId).length && productDetails[0] != null && productDetails[0].length != 0) {
            $("#MiniShopCartAddedProdName_" + productId).html(productDetails[0]);
        }

        /* OOTB - PSL:: We disabled this code because it replaces the thumbnail with the fullimage of the catentry
        if ($("#MiniShopCartAddedProdImgSrc_" + productId).length && productDetails[1] != null && productDetails[1].length != 0) {
            $("#MiniShopCartAddedProdImgSrc_" + productId).attr("src", productDetails[1]);
            document.getElementById('MiniShopCartAddedProdImgSrc_' + productId).alt = productDetails[0];
        }
        */

        if ($("#MiniShopCartAddedProdPrice_" + productId).length && productDetails[2] != null && productDetails[2].length != 0) {
            $("#MiniShopCartAddedProdPrice_" + productId).html(productDetails[2]);
        }
        if ($("#MiniShopCartAddedProdQty_" + productId).length && productDetails[3] != null && productDetails[3].length != 0) {
            $("#MiniShopCartAddedProdQty_" + productId).html(productDetails[3]);
        }

        if ($("#MiniShopCartAddedProdAttr_" + productId).length && productDetails[4] != null && productDetails[4].length != 0) {
            $("#MiniShopCartAddedProdAttr_" + productId).html("");

            for (attrName in productDetails[4]) {
                attrValue = productDetails[4][attrName];
                if (attrValue != null && attrValue != 'undefined') {
                    attrValue = attrValue.replace(/&amp;/g, "&").replace(/&#039;/g, "'").replace(/&#034;/g, '"').replace(replaceStr, search);
                }
                document.getElementById('MiniShopCartAddedProdAttr_' + productId).innerHTML += '<div>' + attrName + ': ' + attrValue + '</div>';
            }
        }
    }
    wcTopic.publish("ProductInfo_Reset");
}

/*
 * Loads mini shop cart info upon page load.
 * @param {String} contextCurrency Current currency selected.
 * @param {String} langId Current language selected.
 */
function loadMiniCart(contextCurrency, langId) {
    var updateCart = false;
    var orderIdCookie = getCookie("WC_CartOrderId_" + WCParamJS.storeId);

      if (orderIdCookie != undefined && orderIdCookie === "") {
        var subtotal = document.getElementById("minishopcart_subtotal");
        var formattedSubtotal = null;
        if ($("#currentOrderAmount").length) {
            formattedSubtotal = Utils.formatCurrency($("#currentOrderAmount").val(), {
                currency: contextCurrency
            });
        }
        if (formattedSubtotal == null && $("#currentOrderAmount").length) {
            formattedSubtotal = $("#currentOrderAmount").val();
        }

        if (subtotal != null) {
            subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
        }
        var items = document.getElementById("minishopcart_total");
        if (items != null) {
            var itemsMsg = null;
            if ($("#currentOrderQuantity").length) {
                itemMsg = $("#currentOrderQuantity").val();
            }
            if (itemsMsg == null) {
                itemsMsg = "0";
            }
            items.innerHTML = "\n " + itemsMsg + "\n ";
        }
    } else if (orderIdCookie != undefined && orderIdCookie !== "") {
        var cartCookie = getCookie("WC_CartTotal_" + orderIdCookie);

        if (cartCookie != undefined && cartCookie != null && cartCookie !== "") {
            var orderInfo = cartCookie.split(";");

            if (orderInfo != null && orderInfo.length > 3) {
                if (orderInfo[2] == contextCurrency && orderInfo[3] == langId) {
                    var subtotal = document.getElementById("minishopcart_subtotal");
                    if (subtotal != null) {
                        var formattedSubtotal = null;
                        formattedSubtotal = Utils.formatCurrency(orderInfo[1].toString(), {
                            currency: contextCurrency
                        });
                        if (formattedSubtotal == null) {
                            formattedSubtotal = orderInfo[1].toString();
                        }
                        subtotal.innerHTML = "\n " + formattedSubtotal + "\n ";
                    }
                    var currentOrderLocked = false;
                    if (orderInfo[4] != null && orderInfo[4] == 'true') {
                        var currentOrderLocked = true;
                    }
                    var items = document.getElementById("minishopcart_total");
                    var lock = document.getElementById("minishopcart_lock");
                    if (items != null) {
                        var itemsMsg = orderInfo[0].toString();
                        items.innerHTML = "\n " + itemsMsg + "\n ";
                        if (currentOrderLocked) {
                            $(items).addClass("nodisplay");
                            $(lock).removeClass("nodisplay");
                        } else {
                            $(items).removeClass("nodisplay");
                            $(lock).addClass("nodisplay");
                        }
                    }
                } else {
                    updateCart = true;
                }
            } else {
                updateCart = true;
            }
        } else {
            updateCart = true;
        }
    } else {
        updateCart = true; 
    }
    //isOnPasswordUpdateForm flag is set at UpdatePasswordForm.jsp, in other cases the variable type will always be undefined or value equals false.
    // Need this line otherwise it'll throw a isOnPasswordUpdateForm is undefined error
    var isOnPasswordUpdateForm = isOnPasswordUpdateForm;
    if (updateCart == true && (Utils.isUndefined(isOnPasswordUpdateForm) || isOnPasswordUpdateForm == false)) {
        wcRenderContext.updateRenderContext('MiniShoppingCartContext', {
            'status': 'load'
        });
    }
}


/*
 * Turn on the flag to indicate that the mini cart cookies should be refreshed.
 */
function setDeleteCartCookie() {
    setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, true, {
        path: '/',
        domain: cookieDomain
    });
}

/*
 * Check whether the mini cart cookies need to be updated or not.
 */
function checkDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != undefined && deleteCartCookieVal !== "") {
        if (deleteCartCookieVal == 'true') {
            return true;
        }
    }
    return false;
}

/*
 * Delete the flag that indicates the mini cart cookie should be refreshed.
 */
function resetDeleteCartCookie() {
    var deleteCartCookieVal = getCookie("WC_DeleteCartCookie_" + WCParamJS.storeId);

    if (deleteCartCookieVal != null) {
        setCookie("WC_DeleteCartCookie_" + WCParamJS.storeId, null, {
            expires: -1,
            path: '/',
            domain: cookieDomain
        });
    }
}
wcTopic.subscribe("ProductInfo_Added", setProductAddedList);
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2015 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This file provides all the functions and variables to manage Global Login panel.
 */

/* global document, window, $, setCookie, getCookie, cookieDomain, WCParamJS, GlobalLoginJS, Utils, cursor_clear, cursor_wait, submitRequest, wc, processAndSubmitForm, invokeItemAdd, invokeOtherService, isOnPasswordUpdateForm, service */

/**
* Constant key in activePanel
*/
var KEY_ACTIVE = 'active',

    /**
    * Constant key in activePanel
    */
    KEY_SELECTED = 'selected'; 

GlobalLoginJS = {

    /**
     * This variable stores the ID of the language that the store currently uses. Its default value is set to -1, which corresponds to United States English.
     * @private
     */
    langId: "-1",

    /**
     * This variable stores the ID of the current store. Its default value is empty.
     * @private
     */
    storeId: "",

    /**
     * This variable stores the ID of the catalog. Its default value is empty.
     * @private
     */
    catalogId: "",

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    activePanel: {},

    widgetsLoadedOnPage: [],

    /**
     * This variable stores the ID of active panels. Its default value is empty.
     * @private
     */
    isPanelVisible: true,

    /**
     * True if mouse down event registered, false otherwise (prevents registering
     * event more than once).
     */
    mouseDownConnectHandle: null,
          
    logonId:null,
        
    reLogonURL : null,
       
    URL:null,
    
    /**
     * Sets the common parameters for the current page.
     * For example, the language ID, store ID, and catalog ID.
     *
     * @param {Integer} langId The ID of the language that the store currently uses.
     * @param {Integer} storeId The ID of the current store.
     * @param {Integer} catalogId The ID of the catalog.
     */
    setCommonParameters: function (langId, storeId, catalogId) {
        this.langId = langId;
        this.storeId = storeId;
        this.catalogId = catalogId;
        cursor_clear();
    },

    hideGLPanel: function (isPanelVisible) {
        this.isPanelVisible = isPanelVisible;
    },

    registerWidget: function (widgetId) {
        this.widgetsLoadedOnPage.push(widgetId);
    },
    
       
      /**
       * 
       */
     InitHTTPSecureFromPolicy : function(){
        	
        	 var href = document.location.href;
             var index = href.lastIndexOf("s", 4);
        	
             if(index == -1){
             	// Loaded with HTTP. Change it to HTTPS along with appropriate port.
         		if (WCParamJS.urlPrefixForHTTP) {
         			var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
         			index = newHref.indexOf("/");
         			newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
         		} else {
         			var newHref = href.substring(0,4) + "s" + (href.substring(4));
        		}
                 setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                     path: '/',
                     domain: cookieDomain
                 });
                 window.location = newHref;
             }
    
            
            return;
        	
     },

    InitHTTPSecure: function (widgetId) {
        var href = document.location.href;
        var index = href.lastIndexOf("s", 4);

        if (index != -1) {
            // Open sign in panel if loaded with HTTPS.
            GlobalLoginJS.displayPanel(widgetId);

        } else {
			// Loaded with HTTP. Change it to HTTPS along with appropriate port.
			if (WCParamJS.urlPrefixForHTTP) {
				var newHref = href.substring(WCParamJS.urlPrefixForHTTP.length);
				index = newHref.indexOf("/");
				newHref = WCParamJS.urlPrefixForHTTPS + newHref.substring(index);
			} else {
				var newHref = href.substring(0,4) + "s" + (href.substring(4));
			}
            setCookie("WC_DisplaySignInPanel_" + WCParamJS.storeId, "true", {
                path: '/',
                domain: cookieDomain
            });
            window.location = newHref;
            return;
        }
    },

    displayPanel: function (widgetId) {
        //check if the sign in panel is loaded. if loaded, toggle the dropdown. Else, trigger a refresh.
        var widgetNode = $("#" + widgetId);
        if (widgetNode.length > 0) {
            var panelLoaded = widgetNode.attr("panel-loaded");
            if (panelLoaded) {
                this.togglePanel(widgetNode);
            } else if (typeof isOnPasswordUpdateForm === 'undefined' || isOnPasswordUpdateForm == false) {
                if (!submitRequest()) {
                    return;
                }
                cursor_wait();
                wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId" : widgetId});
            }
        }
    },

    togglePanel: function (widgetNode) {
        // toggle the current active global login panel
    	 if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
    		 //HB-661
    		 var idPrefix = this.activePanel[KEY_ACTIVE] + "_";
    		 var form_input_user = idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1";
    		 var form_input_pass = idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1";
    		 if (!$("#" + form_input_user).is(":focus") && !$("#" + form_input_pass).is(":focus")) {
    			 $("#" + this.activePanel[KEY_ACTIVE]).toggleClass("active");
	             $("#" + this.activePanel[KEY_SELECTED]).toggleClass("selected");
	
	             //if the current active panel is not the caller
	             if (this.activePanel[KEY_ACTIVE] != widgetNode.attr("id")) {
	                 var toggleControl = widgetNode.attr("data-toggle-control");
	                 //toggle current widget
	                 widgetNode.toggleClass("active");
	                 toggleControl.toggleClass("selected");
	
	                 //set the current caller as active
	                 this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
	                 this.activePanel[KEY_SELECTED] = toggleControl;
	             } else {
	                 delete this.activePanel.active;
	                 delete this.activePanel.selected;
	                 widgetNode.attr("panel-loaded", false);
	                 this.unregisterMouseDown();
	             }
    		 }
         } else {
             var toggleControl = widgetNode.attr("data-toggle-control");
             //no panel is active. toggle the current
             widgetNode.toggleClass("active");
             $("#" + toggleControl).toggleClass("selected");

             //set the current caller as active
             this.activePanel[KEY_ACTIVE] = widgetNode.attr("id");
             this.activePanel[KEY_SELECTED] = toggleControl;
             this.registerMouseDown();
         }
    },

    updateGlobalLoginSignInContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        var redirectToPageName = getCookie("WC_RedirectToPage_" + WCParamJS.storeId);
        if (redirectToPageName != undefined && redirectToPageName != null) {
            setCookie("WC_RedirectToPage_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"false", "widgetId": widgetId, "redirectToPageName": redirectToPageName});
    },

    updateGlobalLoginUserDisplay: function (displayName) {
        $("#Header_GlobalLogin_signOutQuickLinkUser").html(displayName);
    },

    updateGlobalLoginContent: function (widgetId) {
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        if($('#'+widgetId).length){
	    	wcRenderContext.updateRenderContext("GlobalLogin_context",{"displayContract":"true", "widgetId": widgetId});
	    }else{
	    	cursor_clear();
	    }
    },

    updateOrganization: function (formName, widgetId) {
        var orgSetInSessionURL = widgetId + '_' + 'orgSetInSessionURL';
        var orgSetInSessionURLEle = document.getElementById(orgSetInSessionURL);
        if (orgSetInSessionURLEle != null) {
            var href = document.location.href;
            orgSetInSessionURLEle.value = href;
        }
        var form = document.forms[widgetId + '_' + formName];
        if (!submitRequest()) {
            return;
        }
        processAndSubmitForm(form);
    },

    prepareSubmit: function (widgetId) {
        var idPrefix = widgetId + "_";
        if (document.getElementById(idPrefix + "signInDropdown") != null && document.getElementById(idPrefix + "signInDropdown").className.indexOf("active") > -1) {
            document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").setAttribute("class", "wcag__error errorLabel");
            document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").setAttribute("class", "wcag__error errorLabel");
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonId_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className = document.getElementById(idPrefix + "inlineLogonErrorMessage_GL_logonId").className + " active";
                    return false;
                }
            }
            var form_input_field = document.getElementById(idPrefix + "WC_AccountDisplay_FormInput_logonPassword_In_Logon_1");
            if (form_input_field != null) {
                if (this.isEmpty(form_input_field.value)) {
                    document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className = document.getElementById(idPrefix + "inlinelogonErrorMessage_GL_logonPassword").className + " active";
                    return false;
                }
            }
        }
        return true;
    },

    /**
     * Checks if a string is null or empty.
     * @param (string) str The string to check.
     * @return (boolean) Indicates whether the string is empty.
     */
    isEmpty: function (str) {
        var reWhiteSpace = new RegExp(/^\s+$/);
        if (str == null || str == '' || reWhiteSpace.test(str)) {
            return true;
        }
        return false;
    },

    /**
     * Updates the contract that is available to the current user.
     * @param {string} formName  The name of the form that contains the selected contracts.
     */
    updateContract: function (formName) {
        var form = document.forms[formName];

        /* For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }

        form.submit();
    },

    deleteUserLogonIdCookie: function (contractURL) {
        var userLogonIdCookie = getCookie("WC_LogonUserId_" + WCParamJS.storeId);
        sessionStorage.setItem('logged', 'false');
        if (userLogonIdCookie != null) {
            setCookie("WC_LogonUserId_" + WCParamJS.storeId, null, {
                expires: -1,
                path: '/',
                domain: cookieDomain
            });
        }
        /* START - Wishlist */
        if (isPersol || isOliver) {
            sessionStorage.removeItem("defaultWishlistExternalId");
            sessionStorage.removeItem("wishlistObj");
        }
        /* END - Wishlist */
    },

    changeRememberMeState: function (jspStoreImgDir, target) {
        var targetEle = document.getElementById(target);
        if (targetEle.className.indexOf("active") > -1) {
            targetEle.className = targetEle.className.replace('active', '');
            targetEle.setAttribute("aria-checked", "false");
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox.png");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "false");
        } else {
            targetEle.className = targetEle.className + " active";
            targetEle.setAttribute("src", jspStoreImgDir + "images/checkbox_checked.png");
            targetEle.setAttribute("aria-checked", "true");
            document.getElementById(target.replace("_img", "")).setAttribute("value", "true");
        }
    },

    deleteLoginCookies: function () {
        this.deleteUserLogonIdCookie();
        setCookie("WC_BuyOnBehalf_" + WCParamJS.storeId, null, {
            path: '/',
            expires: -1,
            domain: cookieDomain
        });
    },

    /**
     * Submit a global login sign in form
     * @param (object) widgetId The form widgetId id.
     */
    submitGLSignInForm: function (formId, widgetId) {
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var logonForm = document.getElementById(formId);
        if(logonForm != null){
        	if(logonForm.logonId != null){
                this.logonId = logonForm.logonId.value;
        	}
        	if(logonForm.URL != null){
        		this.URL = logonForm.URL.value
        	}
        	if(logonForm.reLogonURL != null){
        		this.relogonURL = logonForm.reLogonURL.value;
        	}
        }

        
        var params = {
            widgetId: widgetId,
            acceptedPolicyValue: 'false',
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();

        wcService.invoke('globalLoginAjaxLogon', params);
    },
    
    /**
     * 
     */
    submitGLSignInFormFromPolicyPopup : function(formId,widgetId,reLogonURL){
    	
        var encodedReLogonURI = encodeURI(reLogonURL);
        var acceptedPolicyValue = "";
           	
        //NERD-93 accept policy
        var acceptPolicyCheckBox = document.getElementById('agreeConcent_popup');

        
        if(acceptPolicyCheckBox != null){
        	acceptedPolicyValue = acceptPolicyCheckBox.checked;
        }
                
        service = wcService.getServiceById('globalLoginAjaxLogon');
        service.setFormId(formId);
        
        var params = {
            acceptedPolicyValue:acceptedPolicyValue,
        	reLogonURL : this.relogonURL,
            URL : this.URL,
            isShopperLogin: 'true'
        };

        /*For Handling multiple clicks. */
        if (!submitRequest()) {
            return;
        }
        cursor_wait();
        
        wcService.invoke('globalLoginAjaxLogon', params);
    	
    },

    /**
     * After successful login and setting a contract in session, we need to process the action that the shopper
     * was performing before signing in. It will do nothing if shopper was not trying to perform any actions.
     */
    processNextURL: function () {
        var myNextURL = getCookie("WC_nextURL_" + WCParamJS.storeId);
        if (myNextURL != undefined && myNextURL.length > 0) {
            myNextURL = myNextURL.replace(/&amp;/g, "&");
            if (myNextURL.indexOf('AjaxRESTOrderItemAdd') != -1) {
                invokeItemAdd(myNextURL);
            } else {
                invokeOtherService(myNextURL);
            }
        }
    },

    registerMouseDown: function () {
        if (!this.mouseDownConnectHandle) {
            $(document.documentElement).on("mousedown", $.proxy(this.handleMouseDown, this));
            this.mouseDownConnectHandle = true;
        }
    },

    unregisterMouseDown: function () {
        if (this.mouseDownConnectHandle) {
            $(document.documentElement).off("mousedown");
            this.mouseDownConnectHandle = false;
        }
    },

    handleMouseDown: function (evt) {
        if (this.activePanel[KEY_ACTIVE] != null && this.activePanel[KEY_SELECTED] != null) {
            Utils.ifSelectorExists("#" + this.activePanel[KEY_ACTIVE], function(widgetNode) {
                var toggleControl = $("#" + this.activePanel[KEY_SELECTED]);
                var node = evt.target;
                if (node != document.documentElement) {
                    var close = true;
                    while (node && node != document.documentElement) {
                        if (Utils.elementExists("#" + node.id + "_dropdown") && Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") != null && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position(node),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropdownHeight = $("#" + node.id + "_dropdown").get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                $("#" + node.id + "_dropdown").css("height", newHeight + "px");
                            }
                        }
                        if (widgetNode.is(node) || toggleControl.is(node) || $(node).hasClass("dijitPopup")) {
                            close = false;
                            break;
                        }
                        node = node.parentNode;
                    }
                    node = null;
                    if (node == null) {
                        widgetNode.children("div").each(function(i, e) {
                            var position = Utils.position(e);
                            if (evt.clientX >= position.x && evt.clientX < position.x + position.w &&
                                evt.clientY >= position.y && evt.clientY < position.y + position.h) {
                                close = false;
                                return false; // breaks
                            }
                        });
                        if (Utils.elementExists("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown") &&
                            $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown").css("display") != "none" &&
                            Utils.elementExists("#" + widgetNode.id + "_numEntitledContracts") && $("#" + widgetNode.id + "_numEntitledContracts").val() > 0) {
                            var nodePosition = Utils.position("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2"),
                                windowHeight = window.innerHeight,
                                newHeight;
                            if (windowHeight - nodePosition.y > nodePosition.y) {
                                newHeight = windowHeight - nodePosition.y;
                            } else {
                                newHeight = nodePosition.y;
                            }
                            var dropDown = $("#" + widgetNode.id + "_WC_B2BMyAccountParticipantRole_select_2_dropdown"),
                                dropdownHeight = dropDown.get(0).clientHeight;
                            if (dropdownHeight > newHeight) {
                                dropDown.css("height", newHeight + "px");
                            }
                        }
                    }
                    if (close) {
                        this.togglePanel(widgetNode);
                    }
                }
            }, this);
        }
    },
    
      /**
        * show store policy popup
        */
       showPolicyPopup : function(){
         var policyPopup = $('#acceptance_policy_popup');
         policyPopup.data("wc-WCDialog").open();
        },
        
        /**
         * hides store policy popup
         */
        hidePolicyPopup : function(){
        	var policyPopup = $('#acceptance_policy_popup');
        	policyPopup.data("wc-WCDialog").close();
         }
};
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2014, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This javascript is used by the Global Login widget to handle the services
 * @version 1.10
 */

/* global document, window, $, wc, Utils, WCParamJS, MessageHelper, cursor_clear, getAbsoluteURL */


/**
 * This service allows customer to sign in
 * @constructor
 */
wcService.declare({
    id: "globalLoginAjaxLogon", 
    actionId: "globalLoginAjaxLogon",
    url: getAbsoluteURL() + "AjaxLogon",
    formId: "",

    /**
     * Hides all the messages and the progress bar.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    successHandler: function (serviceResponse) {
        cursor_clear();
        var errorMessage = "";
        
        // START - HB-16650
        if(localStorage.getItem('trackMyOrder')){
        	localStorage.removeItem('trackMyOrder');
        }
        // END - HB-16650
        
        if (serviceResponse.ErrorCode != null) {
            var errorCode = Number(serviceResponse.ErrorCode);
            switch (errorCode) {
            case 2000:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2000"];
                break;
            case 2010:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2010"];
                break;
            case 2020:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2020"];
                break;
            case 2030:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2030"];
                break;
            case 2110:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2300:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2300"];
                break;
            case 2340:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2340"];
                break;
            case 2400:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2400"];
                break;
            case 2410:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2410"];
                break;
            case 2420:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2420"];
                break;
            case 2430:
                document.location.href = "ResetPasswordForm?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode;
                break;
            case 2490:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2110"];
                break;
            case 2170:
                document.location.href = "ChangePassword?storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&langId=" + WCParamJS.langId + "&errorCode=" + errorCode + "&logonId=" + serviceResponse.logonId;
                break;
            case 2570:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2570"];
                break;
            case 2440:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2440"];
                break;
            case 2450:
                errorMessage = MessageHelper.messages["GLOBALLOGIN_SIGN_IN_ERROR_2450"];
                break;
            case 2711 : 
                GlobalLoginJS.InitHTTPSecureFromPolicy();
                GlobalLoginJS.showPolicyPopup();
                	
            }
            if (document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL") != null) {
                document.getElementById(serviceResponse.widgetId + "_logonErrorMessage_GL").innerHTML = errorMessage;
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonId_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-invalid", "true");
                document.getElementById(serviceResponse.widgetId + "_WC_AccountDisplay_FormInput_logonPassword_In_Logon_1").setAttribute("aria-describedby", "logonErrorMessage_GL_alt");
                document.querySelectorAll(".form-group .myaccount_error").forEach((el) => {
                    el.classList.add("active");
                });
            }

            /*--- WCAG Begin MCB --*/
            var attr = $('.myaccount_error').attr('tabindex');
            if(!(typeof attr !== typeof undefined && attr !== false)) {
                $('.myaccount_error').attr('tabindex', '0');
            }
            //this if prevents js error if WCAG.js are not imported
            if(typeof moveToError === 'function'){
                moveToError();
            }
            /*--- WCAG Begin MCB --*/

            /* TEALIUM BEGIN Logon fail */
            if(typeof tealium_data2track !== 'undefined'){
	            var code = 'Error while trying to login user';
	            pushErrorToTealium('Server', '', code, errorMessage);
            }
            /* TEALIUM END */

        } else {
        	sessionStorage.setItem('logged', 'true');
            var url = serviceResponse.URL[0].replace(/&amp;/g, '&'),
                languageId = serviceResponse.langId;
            if (languageId != null && document.getElementById('langSEO' + languageId) != null) { // Need to switch language.

                var browserURL = document.location.href,
                    currentLangSEO = '/' + $('#currentLanguageSEO').val() + '/';

                if (browserURL.indexOf(currentLangSEO) !== -1) {
                    // If it's SEO URL.
                    var preferLangSEO = '/' + $('#langSEO' + languageId).val() + '/';

                    var query = url.substring(url.indexOf('?') + 1, url.length),
                        parameters = Utils.queryToObject(query);
                    if (parameters["URL"] != null) {
                        var redirectURL = parameters["URL"],
                            query2 = redirectURL.substring(redirectURL.indexOf('?') + 1, redirectURL.length),
                            parameters2 = Utils.queryToObject(query2);
                        // No redirect URL
                        if (parameters2["URL"] != null) {
                            var finalRedirectURL = parameters2["URL"];
                            if (finalRedirectURL.indexOf(currentLangSEO) != -1) {
                                // Get the prefer language, and replace with prefer language.
                                finalRedirectURL = finalRedirectURL.replace(currentLangSEO, preferLangSEO);
                                parameters2["URL"] = finalRedirectURL;
                            }
                            query2 = $.param(parameters2);
                            redirectURL = redirectURL.substring(0, redirectURL.indexOf('?')) + '?' + query2;
                        } else {
                            //Current URL is the final redirect URL.
                            redirectURL = redirectURL.toString().replace(currentLangSEO, preferLangSEO);
                        }
                        parameters["URL"] = redirectURL;
                    }
                    query = $.param(parameters);
                    url = url.substring(0, url.indexOf('?')) + '?' + query;

                } else {
                    // Not SEO URL.
                    // Parse the parameter and check whether if have langId parameter.
                    if (url.contains('?')) {
                        var query = url.substring(url.indexOf('?') + 1, url.length),
                            parameters = Utils.queryToObject(query);
                        if (parameters["langId"] != null) {
                            parameters["langId"] = languageId;
                            var query2 = $.param(parameters);
                            url = url.substring(0, url.indexOf('?')) + '?' + query2;
                        } else {
                            url = url + "&langId=" + languageId;
                        }
                    } else {
                        url = url + "?langId=" + languageId;
                    }
                }
            }

            if (isPersol && $("#page").hasClass("checkout")){
                var physicalStoreSelectionURL = $("#GLPhysicalStoreSelectionURL").val();
                var billingShippingPageURLForOnline = $("#GLRegisteredUserOrderCalculateURL").val();
		
                if (ShipmodeSelectionExtJS.isBOPISEnabled() && ShipmodeSelectionExtJS.isPickUpInStore()) {
                    url = physicalStoreSelectionURL;
                } else {
                    url = billingShippingPageURLForOnline;
                }
            }

            if (serviceResponse["MERGE_CART_FAILED_SHOPCART_THRESHOLD"] == "1") {
                setCookie("MERGE_CART_FAILED_SHOPCART_THRESHOLD", "1", {path: "/", domain: cookieDomain});
            }

            /* START Early Access */
            if (isPersol || isVogue) assignCustomerSegment();
            /* END Early Access */

            /* START - Wishlist */
            if (isPersol || isOliver) {
                sessionStorage.removeItem("defaultWishlistExternalId");
                sessionStorage.removeItem("wishlistObj");
            }
            /* END - Wishlist */

            window.location = url;

             /*--- WCAG Begin MCB --*/
             var attr = $('.myaccount_error').attr('tabindex');
             if(typeof attr !== typeof undefined && attr !== false) {
                 $('.myaccount_error'). removeAttr('tabindex');
             }
             /*--- WCAG Begin MCB --*/
            
            /* TEALIUM BEGIN Login success */
            /* HB-11904 BEGIN*/
            /*if(typeof tealium_data2track !== 'undefined'){
                tealium_data2track.push({
             	   'id' : 'X-X-CheckoutDelivery-Login',
             	   'User_Email_MD5' : serviceResponse.userEmail
             	});
            }*/
            /* HB-11904 END*/
            /* TEALIUM END */
        }
    },

    /**
     * display an error message.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation.
     */
    failureHandler: function (serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
            if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
            }
        }
        cursor_clear();
    }
});
//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2007, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 *@fileOverview This javascript file defines all the javascript functions used to display
 *and handle the information messages, error messages.
 */

if (typeof (MessageHelper) == "undefined" || !MessageHelper || !MessageHelper.topicNamespace) {

  /**
     * @class The MessageHelper class contains variables and functions that are used
     * to initialize, display and handle informational and error message.
     */
  MessageHelper = {
    /**A variable that contains all the messages to be displayed*/
    messages: {},

    /**
         * internal variable to keep track of the current element id that has
         * an error tooltip assigned to it */
    identifier: "",

    /**
         * internal variable to keep track of the element id that needs to
         * give focus to on dialog dismissal */
    focusElement: "",

    /**
         * returns the current year
         * @return (int) the current year
         */
    getCurrentYear: function () {
      return new Date().getFullYear();
    },

    /**
         * returns the current month. January is 1, and December is 12.
         * @return (int) the current month
         */
    getCurrentMonth: function () {
      return new Date().getMonth() + 1;
    },

    /**
         * returns the current day of the current month, starting from 1.
         * @return (int) the current day
         */
    getCurrentDay: function () {
      return new Date().getDate();
    },

    /**
         *
         *summary: retrieves the value of the property from a render context
         *description: This function retrieves the value of the property whose name is propertName
         *from the given context.
         *
         * @param (wc.render.Content) content The context in which the properties
         * belong to.
         * @param (string) propertyName The property to be retrieved
         * @return (string) null if the context is null. undefined if the property is not found.
         * otherwise, the value of the property int he given context.
         */
    getRenderContextProperty: function ( /*wc.render.Context*/ context, /*String*/ propertyName) {

      console.debug("enter getRenderContextProperty with propertyName = " + propertyName);
      if (context == null) {
        console.debug("context is null. Return null...");
        return null;
      }

      var result = context.properties[propertyName]
      console.debug("the found property value is: " + result);

      return result;
    },

    /**
         * This function is used to initialize the messages object with all the
         * required messages. It is used to setup a JS object with any key/value.
         * @param (string) key The key used to access this message.
         * @param (string) msg The message in the correct language.
         *
         */
    setMessage: function (key, msg) {
      this.messages[key] = msg;
    },
    /**
         * This function is used to initialize the element that needs to give focus to on dialog dismissal.
         * @param (string) element The element needs to give focus to.
         *
         */
    setFocusElement: function (element) {
      this.focusElement = element;
    },



    /**
         * Use fadeIn and fadeOut to display error and informative messages in the store.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
    showHideMessageArea: function (topOffset) {
      cursor_clear();
      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }
      var node = $("#MessageArea");

      if ($("#MessageArea_ACCE_Title") !== null) {
        $("#MessageArea_ACCE_Title").css("display", "block");
      }
      // fade in
      $(node).fadeIn(200);


    },

    /**
         * Use fadeOut to hide error and informative messages in the store.
         */
    hideMessageArea: function () {
      cursor_clear();
      var focusOnElement = "";
      if (this.focusElement !== "" && $("#" + this.focusElement) !== null) {
        focusOnElement = $("#" + this.focusElement);
      }
      var node = $("#MessageArea");

      if ($("#MessageArea_ACCE_Title") !== null) {
        $("#MessageArea_ACCE_Title").css("display", "none");
      }
      if (document.getElementById(focusOnElement) != null) {
        focusOnElement.focus();
      }
      $(node).fadeOut(500);
      $('#ErrorMessageText').html("");
      this.focusElement = "";
      if (typeof removeCheckoutLoader == 'function') {
        setTimeout(removeCheckoutLoader, 250);
      }
      setTimeout(function() {
        $('#MessageArea .message_text').removeClass('oosMessage');
    }, 400);
    },

    /**
         * This function is used to display the error messages to the user.
         * @param (string) msg The error/information message to be displayed
         * @param (int) topOffset how far from the top the message display area will be displayed.
         * @param (boolean) showType whether or not the message type should be appended to the actual message
         *
         * @return (element) a HTML element that contains the error message.
         *
         */
    displayErrorMessage: function (msg, topOffset, showType) {
      //HB-1988 BEGIN
      restoreAjaxButtons();
      //HB-1988 END        

      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }

      if (showType == undefined || showType == null || showType == true) {
        //if showType is undefined, keep the FEP1 behaviour.
        if (this.messages["ERROR_MESSAGE_TYPE"] != null && this.messages["ERROR_MESSAGE_TYPE"] != 'undefined') {
          var MsgType = this.messages["ERROR_MESSAGE_TYPE"];
          msg = MsgType + msg;
        }
      }

      this.setMessageAreaStyle('error_icon');
      $('#ErrorMessageText').html(msg);
      $('#MessageArea').addClass('active');
      this.showHideMessageArea(topOffset);
      $('#clickableErrorMessageImg').focus();
      setTimeout(function () {
        if ($('#ErrorMessageText') !== null) {
          $('#ErrorMessageText').focus();
        }
      }, 1000);
      if (typeof TealeafWCJS != "undefined") {
        TealeafWCJS.logClientValidationCustomEvent({
          fieldId: "-1",
          message: msg
        });
      }
    },


    /**
         * Sets the style for the message area on the page.
         * @param (String) styleId The style Id.
         */
    setMessageAreaStyle: function (styleId) {
      $("#success_icon").css("display", "none");
      $("#error_icon").css("display", "none");
      if ($("#" + styleId) != null) {
        $("#" + styleId).css("display", "inline");
      }
    },


    /**
         * This function is used to display the informative messages to the user.
         * @param (string) msg The status message to be displayed.
         * @param (int) topOffset how far from the top of the browser the message will be displayed.
         * @return (element) a HTML element that contains the status message.
         */
    displayStatusMessage: function (msg, topOffset) {
      //HB-1988 BEGIN
      restoreAjaxButtons();
      //HB-1988 END
      
      if (topOffset == null || topOffset == undefined) {
        topOffset = 0;
      }
      this.setMessageAreaStyle('success_icon');
      $('#ErrorMessageText').html(msg);
      $('#MessageArea').addClass('active');
      this.showHideMessageArea(topOffset);
      $('#clickableErrorMessageImg').focus();
      
      setTimeout(function () {
        if ($('#ErrorMessageText') !== null) {
          $('#ErrorMessageText').focus();
        }
      }, 1000);
    },

    

    /**
         * This function is used to hide and clear the message display area in
         * the page.
         */
    hideAndClearMessage: function () {
      $('#ErrorMessageText').html("");
      $('#MessageArea').css("display", "none");
      $('#MessageArea').removeClass('active')
    },

    /**
         * This function is used to re-adjust the coordinates of the message display area on the page. Its location is relative to the "page" element.
         * @param (int) topOffset how far from the top the message display area will be displayed.
         */
    adjustCoordinates: function (topOffset) {
      if ($("#MessageArea").css("display") != "none") {
        var page = $("#page");
        var node = $("#MessageArea");
        if (page != null && node != null) {
          var postion = $(page).position();;
          var width = $(page).width();


          if (topOffset == null || topOffset == undefined) {
            topOffset = 0;
          }

          $(node).css({
            "width": width + 20 + "px",
            "left": postion.left - 10 + "px",
            "top": (postion.top + topOffset) + "px"
          });
        }
      }
    },

    /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * The function assumes the "serviceResponse" is the
         * JSON object from a WebSphere Commerce exception. The error
         * field is in the serviceResponse.errorMessageParam and the
         * error message is in the serviceResponse.errorMessage.
         *
         * @see MessageHelper.formErrorHandleClient
         * @param (object) serviceResponse The JSON object with the error data.
         * @param (string) formName The name of the form where the error field is.
         *
         */
    formErrorHandle: function (serviceResponse, formName) {

      this.formErrorHandleClient(serviceResponse.errorMessageParam, serviceResponse.errorMessage);

    },


    /**
         * This function will show the an error message tooltip
         * around the input field with the problem.
         *
         * This function will check for the emptiness of the required
         * filed and displays the "errorMessage" related to that field as a tooltip.
         * The tooltip will be closed on focus lost.
         *
         * @param (string) id The identifier for the filed in the form.
         * @param (string) errorMessage The message that should be displayed to the user.
         */
    formErrorHandleClient: function (id, errorMessage) {
      if (id.id) {
        id = id.id;
      }
      var element = $("#"+id);
      if (errorMessage == null) {
        console.debug("formErrorHandleClient: The error message is null.");
        return;
      }
      if (element) {
        if (Utils.has_ios()) {
          this.setMessageAreaStyle('error_icon');
          $('#MessageArea').css("display", "block");
          $('#ErrorMessageText').html(errorMessage);
          window.setTimeout( function (){window.scrollTo(0, 0);} , 0);
        } else if (this.identifier != (id + "_tooltip")) {
          element.focus();
          this.identifier = id + "_tooltip";
          var node = document.createElement('span');
          var imgDirPath = getImageDirectoryPath();
          if (Utils.get_IE_version() < 7) {
            node.innerHTML = errorMessage + "<iframe id='errorMessageIFrame' scrolling='no' frameborder='0' src='" + imgDirPath + "images/empty.gif'></iframe>";
          } else {
            node.innerHTML = errorMessage;
          }


          if (Utils.hasTouch()) {
            var _this = this;
            setTimeout(function () {
              var _this = this;
              var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
              this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
              $("#" + id).after(this.tooltip);
              this.tooltip.position({
                my: "center top",
                at: "center bottom",
                of: $("#" + id)

              });

              $("#" + id).blur(function () {
                if (_this.tooltip) {
                  _this.tooltip.hide();
                  _this.tooltip.remove();
                }
                MessageHelper.clearCurrentIdentifier();

              });

            }, 1000);
          } else {
            var _this = this;
            var $toolTipConnector = '/wcsstore/AuroraStorefrontAssetStore/images/colors/color1/tooltipConnectorUp.png';
            this.tooltip = $("<div class='WCTooltip'><div class='container' style='padding:5px;' ><div class='connector''></div>" + errorMessage + "</div></div>");
            $("#" + id).after(this.tooltip);
            this.tooltip.position({
              my: "center top",
              at: "center bottom",
              of: $("#" + id)

            });

            $("#" + id).blur(function () {
              if (_this.tooltip) {
                _this.tooltip.hide();
                _this.tooltip.remove();
              }
              MessageHelper.clearCurrentIdentifier();

            });

          }
        }
        if (typeof TealeafWCJS != "undefined") {
          TealeafWCJS.logClientValidationCustomEvent({
            fieldId: element.id,
            message: errorMessage
          });
        }
      }
    },

    /**
             * This function hides and destroys the current form error handler tooltip that is displayed
             * and clears the identifier that is currently tracked.
             */
    hideFormErrorHandle: function () {
      if (this.tooltip != null) {
        this.tooltip.destroyRecursive();
        this.tooltip = null;
        this.clearCurrentIdentifier();
      }
    },

    /**
             * This function clears the internal variable that has the element id
             * with the error tooltip.
             *
             */
    clearCurrentIdentifier: function () {

      this.identifier = "";
    },

    /**
             * This function is used to override any of the default functions
             * associated with the events. Ex: Tooltip widget tracks onMouseOver event
             * and display the tooltip. To remove this association,
             * tooltip widgets onMouseOver function will be overridden by this empty
             * function.
             *
             * It is an empty implementation which does nothing.
             *
             * @param (string) event  The event which triggers this function.
             */
    emptyFunc: function (event) {

    },



    /**
             * Checks whether a string contains a double byte character.
             *
             * @param (string) target the string to be checked
             * @return (boolean) true if target contains a double byte char;
             * false otherwise
             */
    containsDoubleByte: function (target) {

      var str = new String(target);
      var oneByteMax = 0x007F;

      for (var i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        if (chr > oneByteMax) {
          return true;
        }
      }
      return false;
    },

    /**
             * This function validate email address. It does not allow double byte
             * characters in the email address.
             *
             * @return (boolean) true if the email address is valid; false otherwise
             *
             * @param (string) strEmail the email address string to be validated
             */
    isValidEmail: function (strEmail) {

      if (this.containsDoubleByte(strEmail)) {
        return false;
      }

      if (strEmail.length == 0) {
        return true;
      } else if (strEmail.length < 5) {
        return false;
      } else {
        if (strEmail.indexOf(" ") > 0) {
          return false;
        } else {
          if (strEmail.indexOf("@") < 1) {
            return false;
          } else {
            if (strEmail.lastIndexOf(".") < (strEmail.indexOf("@") + 2)) {
              return false;
            } else {
              if (strEmail.lastIndexOf(".") >= strEmail.length - 2) {
                return false;
              }
            }
          }
        }
      }
      return true;
    },

    /**
             * This function will check if the number of bytes of the string
             * is within the maxlength specified.
             *
             * @param (string) UTF16String the UTF-16 string
             * @param (int) maxlength the maximum number of bytes allowed in your input
             *
             * @return (boolean) false is this input string is larger than maxlength
             */
    isValidUTF8length: function (UTF16String, maxlength) {
      if (this.utf8StringByteLength(UTF16String) > maxlength) return false;
      else return true;
    },

    /**
             * This function will count the number of bytes represented in a UTF-8
             * string.
             *
             * @param (string) UTF16String the UTF-16 string you want a byte count of
             * @return (int) the integer number of bytes represented in a UTF-8 string
             */
    utf8StringByteLength: function (UTF16String) {

      if (UTF16String === null) return 0;

      var str = String(UTF16String);
      var oneByteMax = 0x007F;
      var twoByteMax = 0x07FF;
      var byteSize = str.length;

      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        if (chr > oneByteMax) byteSize = byteSize + 1;
        if (chr > twoByteMax) byteSize = byteSize + 1;
      }
      return byteSize;
    },

    /**
             * this function will check whether the text is a numeric or not.
             *
             * @param allowDot is a boolean wich specifies whether to consider
             * the '.' or not.
             *
             * @return (boolean) true if text is numeric
             */
    IsNumeric: function (text, allowDot) {
      if (allowDot) var ValidChars = "0123456789.";
      else var ValidChars = "0123456789";

      var IsNumber = true;
      var Char;


      for (i = 0; i < text.length && IsNumber == true; i++) {
        Char = text.charAt(i);
        if (ValidChars.indexOf(Char) == -1) {
          IsNumber = false;
        }
      }
      return IsNumber;
    },

    /**
             *
             *This function will check for a valid Phone Number
             *
             *@param (string) text The string to check
             *
             *@return (boolean) true if text is a phone number, ie if each character of
             *input is one of 0123456789() -+
             */
    IsValidPhone: function (text) {

      var ValidChars = "0123456789()-+ ";

      var IsValid = true;
      var Char;

      for (i = 0; i < text.length && IsValid == true; i++) {
        Char = text.charAt(i);
        if (ValidChars.indexOf(Char) == -1) {
          IsValid = false;
        }
      }
      return IsValid;
    },

    /**
             *  To use confirmation popup, the ${StoreDirectory}/Common/ConfirmationPopup.jspf must be included
             *  in the jsp page where the confirmation popup launches from.
             *	This function launch confirmation popup
             *
             * @param (string) topicName The name of the topic that calling widget subscribing to.
             * @param (stirng) message The message to be displayed in the confirmation dialog.
             */
    showConfirmationDialog: function (topicName, message) {
      $("#confirmationPopupMessage").html(message);
      var confirmationPopupWidget = $("#confirmationPopup").data("wc-WCDialog"),
          // Also add a namespace to the click event so we
          // only remove our click handler instead of other click handlers
          eventName = "click.MessageHelper";
      // Do this only once.
      confirmationPopupWidget.primary_button.one(eventName, function (e) {
        e.preventDefault();
        confirmationPopupWidget.secondary_button.off(eventName);
        wcTopic.publish(topicName, {
          action: "YES"
        });
      });

      confirmationPopupWidget.secondary_button.one(eventName, function (e) {
        e.preventDefault();
        confirmationPopupWidget.primary_button.off(eventName);
        wcTopic.publish(topicName, {
          action: "NO"
        });
      });
      confirmationPopupWidget.open();

    }
  }
}

//-----------------------------------------------------------------
// Licensed Materials - Property of IBM
//
// WebSphere Commerce
//
// (C) Copyright IBM Corp. 2008, 2016 All Rights Reserved.
//
// US Government Users Restricted Rights - Use, duplication or
// disclosure restricted by GSA ADP Schedule Contract with
// IBM Corp.
//-----------------------------------------------------------------

/**
 * @fileOverview This class contains declarations of AJAX services used by the Madisons store pages.
 */

/**
 * @class This class stores common parameters needed to make the service call.
 */
ServicesDeclarationJS = {
    langId: "-1", /* language of the  store */
    storeId: "", /*numeric unique identifier of the store */
    catalogId: "", /*catalog of the store that is currently in use */

    /**
     * Sets common parameters used by the services
     * @param (int) langId The language of the store.
     * @param (int) storeId The store currently in use.
     * @param (int) catalogId The catalog of the store currently in use.
     */
    setCommonParameters:function(langId,storeId,catalogId){
            this.langId = langId;
            this.storeId = storeId;
            this.catalogId = catalogId;
    }
}

function nullCartTotalCookie(orderId){
    setCookie("WC_CartTotal_"+orderId, null, {expires: -1, path:'/', domain:cookieDomain});

    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
        var index = cookies[i].indexOf("=");
        var name = cookies[i].substr(0,index);
        var value = cookies[i].substr(index+1)
        name = name.replace(/^\s+|\s+$/g,"");
        value = value.replace(/^\s+|\s+$/g,"");
        if (value == orderId) {
            setCookie(name, null, {expires: -1, path:'/', domain:cookieDomain});
            break;
        }
    }
}

    /**
    * Adds an item to to the wishlist and remove the same item from the shopping
    * cart.
    * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAddAndDeleteFromCart",
        actionId: "AjaxInterestItemAddAndDeleteFromCart",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            MessageHelper.hideAndClearMessage();
            resetRequest();
            CheckoutHelperJS.deleteFromCart(serviceResponse.orderItemId,true);
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Add an item to a shopping cart in Ajax mode. A message is displayed after
     * the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddOrderItem",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemAdd",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_ADDED"]);
            cursor_clear();
            if(categoryDisplayJS){

                var attributes = document.getElementsByName("attrValue");

                var singleSKU = true;

                for(var i=0; i<attributes.length; i++){
                    if (attributes[i].options.length > 1)
                    {
                        singleSKU = false;
                    }
                }

                if (!singleSKU)
                {
                    categoryDisplayJS.selectedAttributes = [];
                    for(var i=0; i<attributes.length; i++){
                        if(attributes[i] != null){
                            attributes[i].value = "";
                        }
                    }
                }
            }
            if(typeof(ShipmodeSelectionExtJS)!= null && typeof(ShipmodeSelectionExtJS)!='undefined'){
                ShipmodeSelectionExtJS.setOrderItemId((serviceResponse.orderItem != null && serviceResponse.orderItem[0].orderItemId != null) ? serviceResponse.orderItem[0].orderItemId : serviceResponse.orderItemId);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

   /**
   * Add an item to a shopping cart in non-Ajax mode. Upon a successful request,
   * the shopping cart page is loaded. An error message is displayed otherwise.
   * @constructor
   */
    wcService.declare({
        id: "AjaxAddOrderItem_shopCart",
        actionId: "AjaxAddOrderItem",
        url: getAbsoluteURL() + "AjaxOrderChangeServiceItemAdd",
        formId: ""

     /**
     * redirects to the shopping cart page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            //Now delete from cart..
            document.location.href =  appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if(serviceResponse.errorMessageKey == "_ERR_NO_ELIGIBLE_TRADING"){
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_CONTRACT_EXPIRED_GOTO_ORDER"]);
                } else if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE"]);
                } else {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Remove an item from shopping cart. A message is displayed after the service
     * call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""
    /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse, params) {
            MessageHelper.hideAndClearMessage();
            if (typeof addCheckoutLoader === 'function') {
                addCheckoutLoader();
            }
            if (typeof params.editLensesAddToCart === 'function') {
                params.editLensesAddToCart();
            } else {
                MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            }
            if (typeof addToCartInput !== "undefined") {
                fn_ext_genericAddToCart(addToCartInput.frameObject, addToCartInput.lensObject, addToCartInput.warrantyObject, addToCartInput.reviewObject, addToCartInput.imagery, addToCartInput.merchandisingAssociations);
            }
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }
    }),


    /**
     * Removes an item from shopping cart on the shipping & billing page. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemForShippingBillingPage",
        actionId: "AjaxDeleteOrderItemForShippingBillingPage",
        url: getAbsoluteURL() + "AjaxCustomRESTOrderItemDelete",
        formId: ""

        /**
         * display a success message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            resetRequest();
            addCheckoutLoader();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            /* HB-1050 :: workaround */
            if (!$("#page").hasClass("pdp")) {
            	setTimeout(function() { location.reload(); }, 500);
            }
        }

        /**
         * display an error message
         * @param (object) serviceResponse The service response object, which is the
         * JSON object returned by the service invocation
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),


    /**
     * Remove an item from shopping cart. A message is only displayed if the service
     * call returns an error Message. It is used to remove an item from the shopping
     * cart and add the same item to the wish list.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItemFromCart",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }


    }),

    /**
     * Remove an item from shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page or the OrderShippingBillingView page depending on what page the service was invoked from.
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxDeleteOrderItem1",
        actionId: "AjaxDeleteOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemDelete",
        formId: ""

    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SHOPCART_REMOVEITEM"],null);
            addCheckoutLoader();
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                setDeleteCartCookie();
                if(CheckoutHelperJS.shoppingCartPage){

                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }else{
                    document.location.href = appendWcCommonRequestParameters("OrderShippingBillingView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service updates an order item in the shopping cart.
     * A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.hideFormErrorHandle();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            if(serviceResponse.errorCode){
                wcTopic.publish("OrderError",serviceResponse);
            }
            cursor_clear();
        }

    }),

    /**
     * Updates an order item in the shopping cart.
     * Upon a successful request, this function will load the AjaxOrderItemDisplayView page
     * An error message will be displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderItem1",
        actionId: "AjaxUpdateOrderItem",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""
    /**
     *redirect to the Shopping Cart Page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            if (!CheckoutHelperJS.pendingOrderDetailsPage)
            {
                if(CheckoutHelperJS.shoppingCartPage){
                    document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
                }
            }
            else
            {
                cursor_clear();
            }
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorMessageKey == "_ERR_RETRIEVE_PRICE") {
                    MessageHelper.displayErrorMessage(MessageHelper.messages["ERROR_RETRIEVE_PRICE_QTY_UPDATE"]);
                }
                else{
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service updates shipping information (shipping mode, shipping address)
     * for a shopping cart. A message is displayed after the service call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateOrderShippingInfo",
        actionId: "AjaxUpdateOrderShippingInfo",
        url: getAbsoluteURL() + "AjaxRESTOrderShipInfoUpdate",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service prepares an order for submission. Upon success, it submits the order.
     * @constructor
     */
    wcService.declare({
        id: "AjaxPrepareOrderForSubmit",
        actionId: "AjaxPrepareOrderForSubmit",
        url: getAbsoluteURL() + "AjaxRESTOrderPrepare",
        formId: ""

    /**
     * On success, checkout the order by calling order submit.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            CheckoutHelperJS.setOrderPrepared("true");
            CheckoutHelperJS.checkoutOrder(CheckoutHelperJS.getSavedParameter('tempOrderId'),CheckoutHelperJS.getSavedParameter('tempUserType'),CheckoutHelperJS.getSavedParameter('tempEmailAddresses'),CheckoutHelperJS.getSavedParameter('tempIsQuote'));
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * This service submits the order. Upon success, the order billing confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitOrder",
        actionId: "AjaxSubmitOrder",
        url: getAbsoluteURL() + "AjaxRESTOrderSubmit",
        formId: ""

    /**
     *redirect to the Order Confirmation page
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            nullCartTotalCookie(serviceResponse.orderId);
            /* START - Online Return Form */
            if (typeof goToOnlineReturnTYP == 'function') {
                goToOnlineReturnTYP();
            } else {
                var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
                document.location.href = appendWcCommonRequestParameters("OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId);
            }
            /* END - Online Return Form */
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     *
     * In case of failure, the next error messages will not be sent to Tealium: See paymentResponseCodesNotToSendToTealium set in CommonUtilities.js
     *
     */
        ,failureHandler: function(serviceResponse) {

            //NERD-727: Start the authentication session in case the card is enrolled in pyaer authentications.
            if (serviceResponse.errorMessageKey == "PLUGIN_RC_475" && $("#JWT").length > 0) {
                var url = "/wcs/resources/store/" + ServicesDeclarationJS.storeId + "/cart/@self/payment_instruction";
                createPaymentLoaderOverlay() //creates a dark overlay with a spinner;

                $.ajax({
                    url: url,
                    type: 'GET',
                    cache: false,
                    data: {
                        "timestamp": Date.now()
                    },
                    success: function (data) {
                        if (data != undefined) {
                            var payerAuthEnrollReply_paReq;
                            var payerAuthEnrollReply_acsURL;
                            var payerAuthEnrollReply_authenticationTransactionID;
                            $.each(data.paymentInstruction[0].protocolData, function (index, value) {
                                if (value.name == 'payerAuthEnrollReply_paReq') {
                                    payerAuthEnrollReply_paReq = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_acsURL') {
                                    payerAuthEnrollReply_acsURL = value.value;
                                } else if (value.name == 'payerAuthEnrollReply_authenticationTransactionID') {
                                    payerAuthEnrollReply_authenticationTransactionID = value.value;
                                }
                            });
                            // Start the authentication session.
                            Cardinal.continue('cca',
                            {
                                "AcsUrl": payerAuthEnrollReply_acsURL,
                                "Payload": payerAuthEnrollReply_paReq
                            },
                            {
                                "OrderDetails":{
                                    "TransactionId" : payerAuthEnrollReply_authenticationTransactionID
                                }
                            });
                        }
                    },
                    error: function(data){
                        deletePaymentLoaderOverlay();

                        MessageHelper.displayErrorMessage("There was a problem while retrieving the payment data.");
                        cursor_clear();
                    }
                });
            } else if (serviceResponse.errorMessage) {
                deletePaymentLoaderOverlay();

                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                cursor_clear();
            } else {
                if (serviceResponse.errorMessageKey) {
                    deletePaymentLoaderOverlay();

                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                    sendPaymentErrorMessageToTealium(serviceResponse.errorMessageKey, serviceResponse.errorMessage);
                    cursor_clear();
                }
            }
        }

    }),

    /**
     * This service submits the quote. Upon success, the quote  confirmation
     * page is shown. A error message is displayed otherwise.
     * @constructor
     */
    wcService.declare({
        id: "AjaxSubmitQuote",
        actionId: "AjaxSubmitQuote",
        url: getAbsoluteURL() + "AjaxSubmitQuote",
        formId: ""

   /**
    *redirect to the Quote Confirmation page
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,successHandler: function(serviceResponse) {
            var redirectURL = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId
            + "&catalogId=" + ServicesDeclarationJS.catalogId
            + "&langId=" + ServicesDeclarationJS.langId
            + "&orderId=" + CheckoutHelperJS.getOrderId()
            + "&shipmentTypeId=" + CheckoutHelperJS.getShipmentTypeId()
            + "&isQuote=true"
            + "&quoteId=" + serviceResponse.outOrderId// outOrderId is the id of the new quote created.

            if(serviceResponse.outExternalQuoteId != undefined && serviceResponse.outExternalQuoteId != null){
                redirectURL += redirectURL + "&externalQuoteId=" + serviceResponse.outExternalQuoteId;
            }
            document.location.href = appendWcCommonRequestParameters(redirectURL);
        }

   /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxAddAddressForPerson",
        actionId: "AjaxAddAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an address for the person. An error message is displayed
     * if the service failed.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdateAddressForPerson",
        actionId: "AjaxUpdateAddressForPerson",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            AddressHelper.updateOrderAfterAddressUpdate();
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service calls AjaxRESTOrderItemUpdate to update order total after shipping address is updated in the order.
     */
    wcService.declare({
        id: "AjaxUpdateOrderAfterAddressUpdate",
        actionId: "AjaxUpdateOrderAfterAddressUpdate",
        url: getAbsoluteURL() + "AjaxRESTOrderItemUpdate",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

    /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""
    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            cursor_clear();
            MessageHelper.displayStatusMessage(MessageHelper.messages["WISHLIST_ADDED"]);
            if(categoryDisplayJS)
            categoryDisplayJS.selectedAttributes = [];
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds an item to the wishlist in non-Ajax mode. Upon success,
     * the shopping cart page is displayed. This is different from
     * AjaxInterestItemAddAndDeleteFromCart in that this function does not remove
     * the item from the shopping cart. It is used mainly in catalog browsing.
     * @constructor
     */
    wcService.declare({
        id: "AjaxInterestItemAdd_shopCart",
        actionId: "AjaxInterestItemAdd",
        url: getAbsoluteURL() + "AjaxInterestItemAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            document.location.href = appendWcCommonRequestParameters("AjaxOrderItemDisplayView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This service deletes an item from the wish list. An error message will be
   * displayed if the service call failed.
   */
    wcService.declare({
        id: "AjaxInterestItemDelete",
        actionId: "AjaxInterestItemDelete",
        url: getAbsoluteURL() + "AjaxInterestItemDelete",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service sends the wish list to a specified email address.
     */
    wcService.declare({
        id: "AjaxInterestItemListMessage",
        actionId: "AjaxInterestItemListMessage",
        url: getAbsoluteURL() + "AjaxInterestItemListMessage",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeManage",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeApply",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            var objsucces = {
                'id' : 'Event',
                'Events_DiscountApplied' : '1',
                'Order_DiscountCode':serviceResponse.promoCode,
                'Order_DiscountName':serviceResponse.promoCode
            }
            pushDiscountCode(objsucces)
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage){
                $("#promoCode").addClass("error");
                addErrorMessageToElement(document.forms.PromotionCodeForm, serviceResponse.errorMessage);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1',
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : ""),
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':"",
                        'Error_Message' : 'PromoCode -'+ (serviceResponse.errorMessage ? serviceResponse.errorMessage.trim() : "")
                }
                pushDiscountCode(obj);
                restoreAjaxButton("WC_PromotionCodeDisplay_links_1");
            } else if (serviceResponse.errorMessageKey){
                $("#promoCode").addClass("error");
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                var obj = {
                		'id' : 'Event',
                        'Events_DiscountTentative' : '1', 
                		'Error_Source' : 'User', 
                		'Error_Code' : 'PromoCode -'+ serviceResponse.errorMessageKey,
                		'Order_DiscountCode':serviceResponse.errorMessageParam[0],
                        'Order_DiscountName':""
                }
                pushDiscountCode(obj);
            }
            cursor_clear();
        }

    }),

    /**
     * This service applies the promotion code to the order(s).
     */
    wcService.declare({
        id: "AjaxPromotionCodeDelete",
        actionId: "AjaxPromotionCodeManage",
        url: getAbsoluteURL() + "AjaxRESTPromotionCodeRemove",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            /*var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId 	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);*/

            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */
            ajaxCallCart(true);
            /* CHECKOUT 3.0 - mustache obj for checkout summary for OP with promotion form update */

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsAdd",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsAdd",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

  /**
   * This services adds or removes a coupon from the order(s).
   */
    wcService.declare({
        id: "AjaxCouponsRemove",
        actionId: "AjaxCouponsAddRemove",
        url: getAbsoluteURL() + "AjaxRESTCouponsRemove",
        formId: ""

    /**
     * Hides all the messages and the progress bar. It will then called the
     * AjaxRESTOrderItemUpdate service
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
      */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();

            var params = [];

            params.storeId		= ServicesDeclarationJS.storeId;
            params.catalogId	= ServicesDeclarationJS.catalogId;
            params.langId		= ServicesDeclarationJS.langId;
            params.orderItemId	= "";
            params.orderId = serviceResponse.orderId;
            if(CheckoutHelperJS.shoppingCartPage){
                params.calculationUsage = "-1,-2,-5,-6,-7";
            }else{
                params.calculationUsage = "-1,-2,-3,-4,-5,-6,-7";
            }
            params.calculateOrder = "1";

            wcService.invoke("AjaxUpdateOrderItem",params);

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * This service adds a billing address to the order(s).
     */
    wcService.declare({
        id: "AddBillingAddress",
        actionId: "AddBillingAddress",
        url: getAbsoluteURL() + "AjaxPersonChangeServiceAddressAdd",
        formId: ""

    /**
     * hides all the messages and the progress bar
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "ScheduleOrder",
    actionId: "ScheduleOrder",
    url: getAbsoluteURL() + "AjaxRESTScheduleOrder",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        var originalOrderId = document.getElementById("orderIdToSchedule").value;
        var newOrderId = serviceResponse.orderId;
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var purchaseOrderNumber = "";
        if(document.forms["purchaseOrderNumberInfo"].purchase_order_number.value != null){
            purchaseOrderNumber = document.forms["purchaseOrderNumberInfo"].purchase_order_number.value;
        }
        var url = "RESTOrderCancel?orderId=" + originalOrderId + "&storeId="  + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&URL=OrderShippingBillingConfirmationView%3ForderId%3D" + newOrderId + "%26originalOrderId%3D" + originalOrderId + "%26shipmentTypeId%3D" + shipmentTypeId + "%26purchaseOrderNumber%3D" + purchaseOrderNumber;
        document.location.href = appendWcCommonRequestParameters(url);
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service schedules an order based on the input order date and order interval parameters.
 */
wcService.declare({
    id: "SubmitRecurringOrder",
    actionId: "SubmitRecurringOrder",
    url: getAbsoluteURL() + "AjaxRESTSubmitRecurringOrSubscription",
    formId: ""

    /**
     * Hides all the messages and the progress bar.
     * Constructs a URL that deletes the current order and forward to the order confirmation page.
     * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
     */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        nullCartTotalCookie(serviceResponse.orderId);
        var shipmentTypeId = CheckoutHelperJS.getShipmentTypeId();
        var url = "OrderShippingBillingConfirmationView?storeId=" + ServicesDeclarationJS.storeId + "&catalogId=" + ServicesDeclarationJS.catalogId + "&langId=" + ServicesDeclarationJS.langId + "&orderId=" + serviceResponse.orderId + "&shipmentTypeId=" + shipmentTypeId;
        document.location.href = appendWcCommonRequestParameters(url);
        cursor_clear();
    }

    /**
     * Displays an error message if the the service call failed.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
    ,failureHandler: function(serviceResponse) {
        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        } else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }
}),

/**
 * This service updates the free gift choices made by the shopper for the
 * promotion.
 */
wcService.declare({
    id: "AjaxUpdateRewardOption",
    actionId: "AjaxUpdateRewardOption",
    url: getAbsoluteURL() + "AjaxRESTOrderRewardOptionUpdate",
    formId: ""

/**
 * Hides all the messages and the progress bar.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,successHandler: function(serviceResponse) {
        MessageHelper.hideAndClearMessage();
        cursor_clear();

    }
 /**
 * Display an error message.
 * @param (object) serviceResponse The service response object, which is the
 * JSON object returned by the service invocation
 */
    ,failureHandler: function(serviceResponse) {

        if (serviceResponse.errorMessage) {
            MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
        }
        else {
             if (serviceResponse.errorMessageKey) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
             }
        }
        cursor_clear();
    }

}),

    /**
     * Create a new saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCreate",
        actionId: "AjaxOrderCreate",
        url: getAbsoluteURL() + "AjaxOrderCreate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_CREATED"]);

            cursor_clear();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {

                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CREATED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a single saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCancel",
        actionId: "AjaxSingleOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDERS_CANCELLED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Cancel a saved order. This service is used to delete multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCancel",
        actionId: "AjaxOrderCancel",
        url: getAbsoluteURL() + "AjaxRESTOrderCancel",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.cancelSavedOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_CANCELLED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Update the description of a saved order. This service is used to update the description of multiple saved orders one at a time.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderSave",
        actionId: "AjaxOrderSave",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,successHandler: function(serviceResponse) {
            // Call again to delete any other orders in the list.
            savedOrdersJS.saveOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SAVED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }
    }),

    /**
     * Set the current order to be that of a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSetPendingOrder",
        actionId: "AjaxSetPendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();

            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);

            savedOrdersJS.determinePageForward("AjaxSetPendingOrder");

            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E" || serviceResponse.errorCode == "CMN1024E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Updates the current pending order setting it to the current shopping cart.
     * This service does not cause a refresh of the ListOrdersDisplay_Controller registered widgets.
     * The main function of this service is to keep the cpendorder database table in line with the current shopping cart.
     * Perform the service or command call.
     * @constructor
     */
    wcService.declare({
        id: "AjaxUpdatePendingOrder",
        actionId: "AjaxUpdatePendingOrder",
        url: getAbsoluteURL() + "AjaxRESTSetPendingOrder",
        formId: ""

     /**
     * There is nothing to do in the event of a success of this service since it is executed in the background.
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            savedOrdersJS.determinePageForward("AjaxUpdatePendingOrder");
            cursor_clear();

        }
     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_SET_CURRENT"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCopy",
        actionId: "AjaxSingleOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxSingleOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Copy a saved order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCopy",
        actionId: "AjaxOrderCopy",
        url: getAbsoluteURL() + "AjaxOrderCopy",
        formId: ""

    /**
    * display a success message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */

        ,successHandler: function(serviceResponse) {

        var params = [];

        params.storeId		= ServicesDeclarationJS.storeId;
        params.catalogId	= ServicesDeclarationJS.catalogId;
        params.langId		= ServicesDeclarationJS.langId;
        params.URL="";
        params.updatePrices = "1";

        params.orderId = serviceResponse.orderId;
        params.calculationUsageId = "-1";

        wcService.invoke("AjaxOrderCalculate", params);
            MessageHelper.hideAndClearMessage();

        }

    /**
    * display an error message
    * @param (object) serviceResponse The service response object, which is the
    * JSON object returned by the service invocation
    */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                 if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxSingleOrderCalculate",
        actionId: "AjaxSingleOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_COPIED"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxCurrentOrderCalculate",
        actionId: "AjaxCurrentOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["ORDER_SET_CURRENT"]);
            cursor_clear();
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),

    /**
     * Perform the order calculation operations to compute the contract prices for the order items in an order.
     * Perform the service or command call.
     */
    wcService.declare({
        id: "AjaxOrderCalculate",
        actionId: "AjaxOrderCalculate",
        url: getAbsoluteURL() + "AjaxRESTOrderCalculate",
        formId: ""

     /**
     * display a success message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */

        ,successHandler: function(serviceResponse) {

            MessageHelper.hideAndClearMessage();
            // Call again to copy any other orders in the list.
            savedOrdersJS.copyOrder(false);
        }

     /**
     * display an error message
     * @param (object) serviceResponse The service response object, which is the
     * JSON object returned by the service invocation
     */
        ,failureHandler: function(serviceResponse) {

            if (serviceResponse.errorMessage) {
                if (serviceResponse.errorCode == "CMN0409E")
                 {
                     MessageHelper.displayErrorMessage(MessageHelper.messages["ORDER_NOT_COPIED"]);
                 }
                 else
                 {
                     MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
                 }
            }
            else {
                 if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                 }
            }
            cursor_clear();
        }

    }),


    /**
     * Processes a punchout payment request.
     */
    wcService.declare({
        id: "AjaxPunchoutPay",
        actionId: "AjaxPunchoutPay",
        url: "AjaxRESTOrderRePay",
        formId: ""

        /**
         * Calls PunchoutJS.handleResponse to render the punchout payment section on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            PunchoutJS.handleResponse(serviceResponse.orderId);
            MessageHelper.hideAndClearMessage();
            cursor_clear();
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    }),


    /**
     * Subscribes to or unsubscribes from receiving information related to a particular category in the store.
     */
    wcService.declare({
        id: "AjaxCategorySubscribe",
        actionId: "AjaxCategorySubscribe",
        url: "AjaxRESTMarketingTriggerProcessServiceEvaluate",
        formId: ""

        /**
         * Clear messages on the page.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation
         */
        ,successHandler: function(serviceResponse) {
            MessageHelper.hideAndClearMessage();
            MessageHelper.displayStatusMessage(MessageHelper.messages["SUBSCRIPTION_UPDATED"]);
        }

        /**
         * Displays an error message on the page if the request failed.
         * @param (object) serviceResponse The service response object, which is the JSON object returned by the service invocation.
         */
        ,failureHandler: function(serviceResponse) {
            if (serviceResponse.errorMessage) {
                MessageHelper.displayErrorMessage(serviceResponse.errorMessage);
            } else {
                if (serviceResponse.errorMessageKey) {
                    MessageHelper.displayErrorMessage(serviceResponse.errorMessageKey);
                }
            }
            cursor_clear();
        }
    })

/**
* @fileOverview This javascript contains javascript functions used by the newsletter function
*/

NewsLetterJS={
        
    version: "Common Implementation v0.01",
	/** language ID to be used, default to -1 (English) */
	langId: "-1",
	
	/** store ID to be used */
	storeId: "",
	
	/** store Name to be used */
	appName :"",
	/** catalog ID to be used */
	catalogId: "",
	
	email :"",
	
	formId:"",
	
	/** 
	* Sets common parameters used by this javascript object
	* @param {String} langId language ID to use
	* @param {String} storeId store ID to use

	*/	
	setCommonParameters:function(langId,storeId,catalogId,appName){
		this.langId = langId;
		this.storeId = storeId;
		this.catalogId = catalogId;
        this.appName = appName;
	},
	
	updateParamObject:function(params, key, value, index){
		if(params == null){
			params = [];
		}

		if(index != null && index !== "" && index !== -1){
			//overwrite the old value at specified index
			params[key+"_"+index] = value;
		}else if(index === -1){
			var i = 1;
			while(params[key + "_" + i] != null){
				i++;
			}
			params[key + "_" + i] = value;
		}else{
			params[key] = value;
		}
		return params;
	},
	
	/**
	* This function clears all the input fields of the form passed in by parameter
	* @param {String} formName The name of the form containing the input fields.	
	*/
	 clearForm:function(formName){
		var form = document.forms[formName];
		for(var i=0; i<form.elements.length; i++) {
			if (form.elements[i].type == "text") {
				form.elements[i].value = "";
			}
		}
	},
	
	/**
	 * submitting to newsletter after checking email param
	 */
	subscribeToNewsLetter:function(formName, page){
		if(this.validateSubscriptionParams(formName)){
            var zipcode = '';  
            var firstName = '';
            var lastName = '';
            var gender = '';
            var dateOfBirth = '';
            var promo = false;
            var primaryNewsLetterFlow=true;
		    this.formId = formName;
		    emailInput = document.querySelector("form[name="+formName+"] #newsletterPopupEmail");
		    if (formName == "newsLetterForm") {
		        emailInput = document.querySelector("form[name="+formName+"] #newsletterEmail");
		        if (isCarol) {
		            emailInput.parentElement.classList.remove("errorGeneric");
	                emailInput.parentElement.classList.remove("errorDuplicate");
		        }
            }
            if(formName == "newsLetterFormLandingPage" && isOliver) {
                emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
                if(countryCode == 'US' || countryCode == 'CA') {
                	zipcode = document.querySelector("form[name="+formName+"] #newsletterZipcodeLandingPage").value;
                }
                firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            } else if (formName == "newsLetterFormPromoLandingPage"){
            	emailInput = document.querySelector("form[name="+formName+"] #newsletterEmailLandingPage");
            	firstName = document.querySelector("form[name="+formName+"] #newsletterFirstNameLandingPage").value;
            	lastName = document.querySelector("form[name="+formName+"] #newsletterLastNameLandingPage").value;
            	gender = document.querySelector("form[name="+formName+"] #newsletterGenderLandingPage").value;
            	dateOfBirth = document.querySelector("form[name="+formName+"] #newsletterBirthdayLandingPage").value;
            	promo = true;
            } //#EMAIL_ME# 
            else if (formName == "newsLetterForm_emailme") { 
		        emailInput = document.querySelector("form[name="+formName+"] #input_Emailme");
			} //#EMAIL_ME#
		    this.email = emailInput.value.toLowerCase();
		    
		    var cidCookie = null;
	        
	        if(document.cookie.includes('X_WC_CID')){
	        	cidCookie = $.cookie("X_WC_CID");
	        }
		    
			var params = {
				storeId: this.storeId,
				langId : this.langId,
				email: this.email,
                zipCode: zipcode,
                promo: promo,
                pageIdentifier: page,
                firstName: firstName,
                lastName: lastName,
                gender: gender,
                dob: dateOfBirth,
                primaryNewsLetterFlow:primaryNewsLetterFlow,
                cid: cidCookie
			}
            if(typeof updateDuplicate != 'undefined' && updateDuplicate == 'true')
                params.update = updateDuplicate

		 	cursor_wait();
		 	wcService.invoke("JoinNewsletterService", params);
		 	
		 	if(formName=="newsletterPopupForm"){
		 		setCookie("WELCOME_STICKY_SHOWN_"+this.appName,true,{expires: 10000,path: "/", domain: cookieDomain});
		 	}
		}
		
	},

    validateSubscriptionParams: function(formName) {
        this.cleanErrors(formName); 
        var namePattern = /[A-Za-z]/;
        var isValid = true; //we use this variable to check all fields and show,eventually, all errors

        /*EMAIL VALDATION - MANDATORY*/
        var emailInput = $("form[name="+formName+"] [name='EMAIL']");
        if (!emailInput.val()) { //empty or undefined
            this.toggleFormError('EMAIL','EMPTY',formName);
            isValid = false;
        } else if (emailInput.length > 0 && !AddressHelper.validateEmail(emailInput.get(0))) {
            this.toggleFormError('EMAIL','INVALID',formName);
            isValid = false;
        }
        
        /*FIRSTNAME VALDATION*/
        var firstNameInput = $("form[name="+formName+"] [name='NAME'],form[name="+formName+"] [name='FIRSTNAME']");
        if (firstNameInput.length > 0 && needsValidation(firstNameInput)) { //if fild not available or disabled do not check
            var firstNameValue = firstNameInput.val();
            if (!firstNameValue) {
                this.toggleFormError('NAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(firstNameValue)){
                this.toggleFormError('NAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*LASTNAME VALIDATION*/
        var lastNameInput = $("form[name="+formName+"] [name='LASTNAME']");
        if (lastNameInput.length > 0 && needsValidation(lastNameInput)) { //if fild not available or disabled do not check
            var lastNameValue = lastNameInput.val();
            if (!lastNameValue) {
                this.toggleFormError('LASTNAME','EMPTY',formName);  
                isValid = false; 
            } else if (!namePattern.test(lastNameValue)){
                this.toggleFormError('LASTNAME','INVALID',formName);  
                isValid = false;
            }
        }

        /*GENDER VALIDATION*/
        var genderInput = $("form[name="+formName+"] [name='gender']");
        if (genderInput.length > 0 && needsValidation(genderInput)) { //if fild not available or disabled do not check
            var genderSelected = genderInput.find('option:selected').val();

            if(!genderSelected) {
                this.toggleFormError('GENDER','EMPTY',formName);  
                isValid = false;
            } 
        }
       
        /*BIRTHDAY VALIDATION*/
        var birthdayInput = $("form[name="+formName+"] [name='BIRTHDAY']");
        if (birthdayInput.length > 0 && needsValidation(birthdayInput)) { //if fild not available or disabled do not check
            var  dateOfBirth = birthdayInput.val();
            // Variables for birthday validation
            var birthdayDate = new Date(dateOfBirth);
            var birthdayYear = birthdayDate.getFullYear();
            var currentYear = new Date().getFullYear();
            var maxAge = currentYear - birthdayYear;

            if (dateOfBirth == '') {
                this.toggleFormError('BIRTHDAY','EMPTY',formName);   
                isValid = false;
            } else if (maxAge > 100 || maxAge < 16 || birthdayYear >= currentYear){
                this.toggleFormError('BIRTHDAY','INVALID',formName);  
                isValid = false;
            }
        }

         /*ZIPCODE VALIDATION*/
         var zipCodeInput = $("form[name="+formName+"] [name='ZIPCODE']");
         if (zipCodeInput.length > 0 && needsValidation(zipCodeInput)) { //if fild not available or disabled do not check
            var  zipCodeValue = zipCodeInput.val();
            var zipCodeRegexp = AddressHelper.getZipCodeRegexpForCurrentCountryCode();
            
            if (!zipCodeRegexp.test(zipCodeValue)){
                this.toggleFormError('ZIPCODE','INVALID',formName);  
                isValid = false;
            }
         }

                 
        return isValid;
    },

    toggleFormError: function(element,error, formName) {
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                switch(element) {
                    case 'EMAIL': {
                        $("#mce-error-response-landingpage--email").show();
                        $("#mce-error-response-landingpage--email").children().hide();
                        $("#newsletterEmailForm input").css('border','solid 1px red');
                        if(error=='EMPTY'){ 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }    
                        else if (error=='INVALID') { 
                            $("#mce-error-response-landingpage--email [id^=\"mce-error-response-invalid-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - EMAIL CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    case 'NAME': {
                        $('#mce-error-response-landingpage--name').show();
                        $('#mce-error-response-landingpage--name').children().hide();
                        $('#newsletterNameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--name [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--name  [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - NAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'LASTNAME': {
                        $('#mce-error-response-landingpage--lastname').show();
                        $('#mce-error-response-landingpage--lastname').children().hide();
                        $('#newsletterLastnameForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--lastname [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--lastname [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - LASTNAME CASE '+error+' NOT DEFINED');
                        
                        break;
                    } 
        
                    case 'GENDER': {
                        $('#mce-error-response-landingpage--gender').show();
                        $('#mce-error-response-landingpage--gender').children().hide();
                        $('#newsletterGenderForm select').css('border','solid 1px red');
                        $('#newsletterGenderForm select').css('margin-bottom','0');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--gender [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else console.log('NewsletterJS.toggleFormError - GENDER CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    
                    case 'BIRTHDAY': {
                        $('#mce-error-response-landingpage--birthday').show();
                        $('#mce-error-response-landingpage--birthday').children().hide();
                        $('#newsletterBirthdayForm input').css('border','solid 1px red');
        
                        if(error == 'EMPTY')  {
                            $("#mce-error-response-landingpage--birthday [id^=\"mce-error-response-empty-landingpage\"]").show();
                        }
                        else if(error == 'INVALID') {
                            $('#mce-error-response-landingpage--birthday [id^=\"mce-error-response-invalid-landingpage\"]').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - BIRTHDAY CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
        
                    case 'ZIPCODE': {
                        $('#mce-error-response-landingpage').show();
                        $('#mce-error-response-landingpage').children().hide();
                        $('#newsletterZipCodeForm input').css('border','solid 1px red');
        
                        if(error == 'INVALID') {
                            $('#mce-error-response-zipcode-landingpage').show();
                        }
                        else console.log('NewsletterJS.toggleFormError - ZIPCODE CASE '+error+' NOT DEFINED');
                        
                        break;
                    }
                    default: console.log('NewsletterJS.toggleFormError - '+element+' CASE  NOT DEFINED')
                }

                break;
            }
            case 'newsLetterForm_emailme' : {
                $("#mce-error-response_emailme").show();
                $("#mce-error-response_emailme").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty_emailme").show();  
                else if (error=='INVALID') $("#mce-error-response-invalid_emailme").show();
                else console.log('NewsletterJS.toggleFormError - EMAILME - CASE '+error+' NOT DEFINED')
                break;
            }
            default : {
                $("#mce-error-response").show();
                $("#mce-error-response").children().hide();
                if(error=='EMPTY')
                    $("#mce-error-response-empty").show();
                else if (error=='INVALID') $("#mce-error-response-invalid").show();
                else console.log('NewsletterJS.toggleFormError - '+formName+' - CASE '+error+' NOT DEFINED');
            }
        }
    },

    cleanErrors: function(formName) {
        $("[id^=mce-error-response").hide()
        switch(formName) {
            case 'newsLetterFormPromoLandingPage' : case 'newsLetterFormLandingPage': {
                $("form[name="+formName+"] input").css('border','');
                $("form[name="+formName+"] select").css('border','');
                $("form[name="+formName+"] select").css('margin-bottom','40px');
                break;
            }
            default : {
                $("#mce-error-response").hide();
            }
        }
    },

	hideAllMessagews : function () {
	    $('#newsletterSignUpResultPopup .message-error').hide();
	    $('#newsletterSignUpResultPopup .message-duplicate').hide();
	    $('#newsletterSignUpResultPopup .message-success').hide();
	},
    handleJoinNewsletterError : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorGeneric");
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-error').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#mce-error-response-error-landingpage').show();
        } else {
            $('#newsletterSignUpResultPopup .message-error').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  

    handleJoinNewsletterDuplicate : function(){
        this.hideAllMessagews();
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                document.getElementById("newsletterEmail").parentElement.classList.add("errorDuplicate");           
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                if(window.innerWidth < 1024) {
                    $('.newsletter__title').hide();
                }
                //$('.newsletter__policy').hide();
                //$('.newsletter__form').hide();
                $('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-error-response-duplicate').show();
            	$('#mce-success-response').hide();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
        	$('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-duplicate-landingpage').show();
            
        } else if (this.formId == "newsLetterFormPromoLandingPage") {
            $('#mce-error-response-landingpage--email').show();
            $('#mce-error-response-landingpage--email').children().hide();
            $('#mce-error-response-landingpage--email #mce-error-response-duplicate-landingpage').show();
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
         /* email me messaggi di errore per duplicati newsletter 
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-error-response-duplicate_emailme').show();
            $('#mce-success-response_emailme').hide();*/
        } //#EMAIL_ME#
        else {
            $('#newsletterSignUpResultPopup .message-duplicate').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }
    },  
    
    handleJoinNewsletterSuccess : function(){
        this.hideAllMessagews();
        
        /*if(typeof customerWeekActive != 'undefined' && customerWeekActive){
          activateCustomerWeek();
        }*/
        
        if (this.formId == "newsLetterForm") {
            if (isCarol) {
                $('#newsLetterFormDiv').hide();
                $('#newsLetterSuccessDiv').fadeIn("fast");
            } else if(isVogue) {                
                $('#mce-error-response').show();
                $('#mce-error-response').children().hide();
                $('.newsletter__policy').hide();
                $('.newsletter--form--input.input-style').hide();
                $('.button.gray-alpha.button--newsletter').hide()
                $('#mce-success-response').show();
                
            } else {
            	$('#mce-error-response').show();
            	$('#mce-error-response').children().hide();
            	$('#mce-success-response').show();
            }
        } else if (this.formId == "newsLetterFormLandingPage" && isOliver) {
            $('#mce-error-response-landingpage').show();
            $('#mce-error-response-landingpage').children().hide();
            $('#opnewsletter-success-response-landingpage').show();
            $('.newsletter__wrapper').hide();
        } else if (this.formId == "newsLetterFormPromoLandingPage"){
        	//Generic
        	 $('.newsletter-page .newsletter__form').hide();
        	 $('.newsletter_homepage-button').show();
        	 $('.newsletter__policy.no-gdpr').hide();
        	//Vogue
        	 $('#mbb-success-response-landingpage').show();
        	 $('.newsletter__title-mbb').hide();
 	         $('.newsletter__info-mbb').hide();
 	         $('.newsletter__image.newsletter-mbb_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-mbb_image img:nth-child(3)').show();
        	//Persol
        	 $('#ponewsletter-success-response-landingpage').show();
        	 $('.newsletter__title-ponewsletter').hide();
 	         $('.newsletter__info-ponewsletter').hide();
 	         $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(2)').hide();
             $('.newsletter__image.newsletter-ponewsletter_image img:nth-child(3)').show();
             $('#POnewsletterImage').hide();
             $('#POnewsletterImageMobile').hide();
             if(window.mobilecheck()){
            	 $('#POnewsletterImageMobile_TP').show();
             }
             else {
            	 $('#POnewsletterImage_TP').show();
             }

            window.scrollTo(0,0);
            if (isPersol || isVogue) {
                window.setTimeout(function(){
                    window.location.href = WCParamJS.homePageURL + ($('#redirectSunglasses').length > 0 && $('#redirectSunglasses').attr('value') != undefined && $('#redirectSunglasses').attr('value') != '' ? $('#redirectSunglasses').attr('value') : '');
                }, 3200);
            }
        } else if(this.formId == "newsLetterForm_emailme"){ //#EMAIL_ME#
            $('#mce-error-response_emailme').show();
            $('#mce-error-response_emailme').children().hide();
            $('#mce-success-response_emailme').show();
            $('#mce-error-response-duplicate_emailme').hide();//#EMAIL_ME#
        } else {
            $('#newsletterSignUpResultPopup .message-success').show();
            $('#newsletterSignUpResultPopup').fadeIn("fast");
        }

        /* START Early Access */
        if (isPersol || isVogue) { 
            if ($("#boxCheckout").length == 0){
                assignCustomerSegment();
                if (this.formId == "newsLetterForm"){
                    if (window.customerSegment != undefined && document.cookie.includes("X_WC_PR_SEGMENTS")){
                        var queryString = window.location.search;
                        var urlParams = new URLSearchParams(queryString);
                        if (!urlParams.has('promo')) {
                            if (location.href.indexOf("?") === -1){
                                window.setTimeout(function(){
                                    window.location = location.href += "?promo=" + window.customerSegment;
                                }, 2000);
                            } else {
                                window.setTimeout(function(){
                                    window.location = location.href += "&promo=" + window.customerSegment;
                                }, 2000);
                            }
                        }   
                    }
                }
            }
        }
        /* END Early Access */
    }		
},
 
/**
 * This service calls JoinNewsletterCmd to make a subscription to newsLetter
 */
wcService.declare({
	id: "JoinNewsletterService",
	actionId: "JoinNewsletterService",
	url: "JoinNewsletterService",
	formId: "",

	successHandler: function(serviceResponse) {
		localStorage.setItem('chekoutUserOptin',serviceResponse.userOptin);
		if(serviceResponse.responseMessage == 'duplicate'){
		    NewsLetterJS.handleJoinNewsletterDuplicate();
		}else if(serviceResponse.responseMessage == 'success'){
		    if(typeof utag_data !== 'undefined')
               utag_data.User_EmailOptin = serviceResponse.userOptin;
		    if(pageType!=='Delivery'){
		    	tealiumPushUserOptin(serviceResponse.userOptin,serviceResponse.email);
		    }
			NewsLetterJS.handleJoinNewsletterSuccess();
            if(isVogue){
                setCookieNlEvent();
            }
		}
		cursor_clear();
		
	},

	failureHandler: function(serviceResponse) {
	    NewsLetterJS.handleJoinNewsletterError();
	    cursor_clear();
	}
});

//  Display/undisplay Landing Page fields
function toggleLandingPageFields() {
    var landingForm = $("form[name='newsLetterFormPromoLandingPage'],form[name='newsLetterFormLandingPage']");
    if (landingForm.length > 0) {
        var formId = landingForm.attr('id')
        toggleSubscriptionForms("X_SignInForms_Info");
        if (typeof subscriptionFormsJSONData != 'undefined'){
        for (var key in subscriptionFormsJSONData) {
            var dataValue = subscriptionFormsJSONData[key];
            switch(dataValue) {
                case 'disabled','false': {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("disabled","disabled");
                    $("#"+formId+" #"+key).hide();
                    if (key == 'newsletterBirthdayForm') {
                        $('#newsletter_age-disclaimer').hide();
                    }
                    break;
                }
                case 'optional' : {
                    $("#"+formId+" #"+key+" input,#"+formId+" #"+key+" select").attr("optional","optional");
                    break;
                }
                default:{}
            }
        }
      }
    }
}

function toggleSubscriptionForms(espotName){

    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName+"?"+Date.now();
  
    $.ajax({
      type: "GET", 
      dataType: 'json', 
      url: espotServiceUrl,
      async: false,
      contentType: "application/json",
      success: function (data) {
        //console.log(data);
        if (data.MarketingSpotData[0].baseMarketingSpotActivityData != undefined) {
          window.subscriptionFormsJSONData = JSON.parse(data.MarketingSpotData[0].baseMarketingSpotActivityData[0].marketingContentDescription[0].marketingText);
        }
      },
      error: function(data){
        console.log("Error retrieving newsletter subscription forms info");
      }
    });
}

function needsValidation(inputElement) {
    var needValidation = true;

    if(inputElement.attr('disabled'))
        needValidation = false;

    if(inputElement.attr('optional'))
        needValidation = false;

    return needValidation;
}

/* ---- START - DOCUMENT LOAD  ---- */

window.addEventListener('load', (event) => {
    nonCriticalLogic()
});

/* ---- END - DOCUMENT LOAD  ---- */


function toggleDiscoverMoreOverlay(){
    var EditorialCursor = {
        initCursor: function (cursorClass) {
            $('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').css({
                'cursor': 'none'
            });
            EditorialCursor.deleteCursor();
            EditorialCursor.changeCursorMouseMove(cursorClass);
        },
        deleteCursor: function () {
            $('html').css({
                'cursor': ''
            });
            $('.editorial-cursor-dark').css({
                'opacity': '0'
            });
            $('.editorial-cursor-dark > div').css({
                'transform': 'scale(0)'
            });
        },
        changeCursorMouseMove: function (cursorClass) {
            $('.editorial-content-custom-cursor[data-cursor-editorial="' + cursorClass + '"]').mousemove(function (e) {
                var leftEspot = $(this).parent().parent();
                var cursor = $(leftEspot).find("." + cursorClass);
                var divCursor = $(leftEspot).find('.' + cursorClass + ' > div');
                $(cursor).css({
                    'position': 'fixed',
                    'opacity': '1',
                    'user-select': 'none',
                    'top': e.clientY + -50 + 'px',
                    'left': e.clientX + -50 + 'px'
                });
                $(divCursor).css({
                    'transform': 'scale(1)'
                });

            });

        }
    }
    var zIndexScrollable =  $(".bottom-scrollable-section").css("z-index")
    var parentEl;
    var editorial;
    var editorialBg;
    var closeButton;
    var editorialEspot;
    var edWrapper;
    $('#Discover_More_CTA,[data-element-id="X_Pdp_Hero_CTA"], #Discover_More_CTA ~ .btn-mobile, #Discover_More_Monogram_CTA, #Discover_More_Monogram_CTA ~ .btn-mobile'+(isPersol ? ',.editorial-espot a:not(.not-overlay)' : '')).click(function(){
        parentEl = $(this).closest( ".left_espot" );
        editorialEspot = $(parentEl).parent().parent();
        editorial = $(parentEl).find(".editorial");
        editorialBg = $(parentEl).find(".editorial-background");
        closeButton = $(parentEl).find(".close");
        edWrapper = $(parentEl).find(".editorial-wrapper");
        edWrapper[0].addEventListener('wheel', transformScroll);

        $(editorial).css("transform", "translateY(0px)");
        $(editorial).addClass("show");
        $(editorialBg).show();
        if(mobilecheck() || tabletPortraitCheck()){
            $("body").addClass("overflow-hidden");
        }
        $("body").css("overscroll-behavior", "contain")
        $(".bottom-scrollable-section").css("z-index", "1000");
        $(closeButton).css("display", "flex");
        $(closeButton).css("opacity", "1");
        manageScrollOverlay(true);
    })

    function closeEditorial() {
        if(mobilecheck() || tabletPortraitCheck()){
            $("body").removeClass("overflow-hidden");
            $('html,body').animate({
                scrollTop: $(editorialEspot).offset().top
            }, 600);
            $(editorialBg).hide();
            $(closeButton).fadeOut();
            $(editorial).removeClass("show");
            $(".bottom-scrollable-section").css("z-index", '333');
            manageScrollOverlay(false);
        } else {
           $(".bottom-scrollable-section").css("z-index", zIndexScrollable);
            $(editorialBg).hide();
            
            $(editorial).removeClass("show");
            $(closeButton).hide();
        }

        $("body").css("overscroll-behavior", "initial");
        if(edWrapper != undefined)
            edWrapper[0].removeEventListener('wheel', transformScroll);
        event.preventDefault();
        event.stopPropagation();
    }

    function scrollEditorial(distance, duration) {
        $(editorial).css("transition-duration", +(duration /2000).toFixed(1) +"s");
        //inverse the number we set in the css
        var value = (distance < 0 ? "" : "-") + Math.abs(distance).toString();
        $(editorial).css("transform", "translateY(" + value + "px)");
        var opacity = 1 - (value / 200);
        $(closeButton).css("opacity", opacity)
        $(editorialBg).css("background-color", "rgba(0, 0, 0, " + opacity + ")")
    }

    function transformScroll(event) {
      if (!event.deltaY) {
        return;
      }

      event.currentTarget.scrollLeft += event.deltaY + event.deltaX;
      event.preventDefault();
    }

    $("#Prescription_lenses_editorial ~ .close,[data-espot-name='X_PDP_Editorial_Top'] .close, #Monogram_lenses_editorial ~ .close ,#Prescription_lenses_editorial  .close, [data-espot-name='X_PDP_Editorial_Bottom'] .close, .editorial-content .close").click(function(){
        closeEditorial();
    })
    if ($(window).width() > 1024) {
        // CUSTOM CURSOR SET MOUSE ENTER/LEAVE
        $('.editorial-content-custom-cursor').on({
            mouseenter: function() {
                EditorialCursor.initCursor($(this).data('cursor-editorial'));
            },
            mouseleave: function() {
                EditorialCursor.deleteCursor();
            }
        });
    }
    if(mobilecheck() || tabletPortraitCheck()){
        $(".editorial").swipe( {
            //Generic swipe handler for all directions
            swipe:function(event,direction){
                if(direction == "down") {
                    closeEditorial();
                }
            },
            swipeStatus:function(event, phase, direction, distance, duration) {
                var duration = 0;
                if (phase == 'move' && direction == "down") {
                    scrollEditorial(-distance , duration);
                };
                if (phase=="cancel") {
                    scrollEditorial(0, duration);
                }
                if (phase=="end" && direction == "down") {
                    scrollEditorial(-800, duration);
                }
            },
            allowPageScroll:"vertical",
            threshold:300
        });
    }
}

function toggleMonogramPanel(){
    if(!(window.mobilecheck() || window.tabletPortraitCheck())) managePopupTabIndex('.shopperActions--monogram--pop-up--right--wrapper' , true)
    hideHeaderTimeout.cancel();
    $('.bottom-scrollable-section').css('z-index', "1000");
    $(".shopperActions--monogram--pop-up").show();
    $("html").addClass("overflow-hidden");
    //$("#page-overflow-wrapper").addClass("overflow-hidden");

    if(window.mobilecheck() || window.tabletPortraitCheck() ){
        var windowCloseInputHeight = $(window).innerHeight();
        $(window).resize(function () {
                var windowOpenInputHeight = $(window).innerHeight();
            if(windowCloseInputHeight >  windowOpenInputHeight){
                $('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideUp()
            } else {
                $('.shopperActions--monogram--pop-up--right--wrapper--step-one').slideDown()
            }
        });
        $('#fixed-top--mobile').hide();
        manageScrollOverlay(true);
        $(".shopperActions--monogram--pop-up").css("pointer-events","auto");
        $(".shopperActions--monogram--pop-up").css("overflow","auto");
        $("body").css("pointer-events","none");
        $("body").css("overflow","hidden");
        currentBreak = 'top';

        $('#addMonogram').click(function() {
            manageScrollOverlay(false);
            $(".shopperActions--monogram--pop-up").css("pointer-events","");
            $(".shopperActions--monogram--pop-up").css("overflow","");
            $("body").css("pointer-events","");
            $("body").css("overflow","");
        });
    }

    $(".shopperActions--monogram--pop-up .ui-dialog-titlebar-close, #close-monogram").click(function(){
        $(".shopperActions--monogram--pop-up").hide()
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) managePopupTabIndex('.shopperActions--monogram--pop-up' , false)
        hideHeaderTimeout.setup()
        if(window.mobilecheck() || window.tabletPortraitCheck()){
           // $('.bottom-scrollable-section').css('z-index', '801');
        } else{
            $('.bottom-scrollable-section').css('z-index', zIndexBS);
        }
        $("html").removeClass("overflow-hidden");
        //$("#page-overflow-wrapper").removeClass("overflow-hidden");
        if (window.mobilecheck() || window.tabletPortraitCheck()){
            manageScrollOverlay(false);
            $(".shopperActions--monogram--pop-up").css("pointer-events","");
            $(".shopperActions--monogram--pop-up").css("overflow","");
            $("body").css("pointer-events","");
            $("body").css("overflow","");
        }
    });
}



function printBadgesCarousel(attributes, isPrintClass){
    if(isOliver) {
        var newRelease = null;
        var limited = null;
        var exclusive = null;
        var clipsAvailable = null;
        var premiumMaterial = null;

        $(attributes).each(function (){
            if(this.identifier === 'NEWRELEASES' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k ; k++ ){
                    if(this.values[k].value === true || this.values[k].value.toLowerCase() === 'new' || this.values[k].value.toLowerCase() === 'true'){
                        newRelease = '—New—';
                    }
                }
            }
            if(this.identifier === 'LIMITED_EDITION' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        limited = '—'+this.name+'—';
                    }
                }
            }
            if(this.identifier === 'EXCLUSIVE' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        exclusive = '—'+this.name+'—';
                    }
                }
            }
            if(this.identifier === 'MATCH_WITH_CLIPS' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].value == true || this.values[k].value.toLowerCase() === 'true'){
                        clipsAvailable = '—'+$('#clipAvailable').val()+'—';
                    }
                }
            }
            if(this.identifier === 'FRAMEMATERIAL_FACET' && this.usage === 'Descriptive' ){
                for(var k=0; this.values.length > k; k++ ){
                    if(this.values[k].identifier.toLowerCase() === 'horn' || this.values[k].identifier.toLowerCase() === 'solid gold'){
                        premiumMaterial = '—'+$('#premiumMaterial').val()+'—';
                    }
                }
            }
        })

        if(isPrintClass){
            if(newRelease || limited || exclusive || premiumMaterial || clipsAvailable) {
                return "badge-show";
            }
        }

        if(limited){
            return limited;
        } else if(exclusive){
            return exclusive;
        } else if(premiumMaterial) {
            return premiumMaterial;
        } else if(clipsAvailable) {
            return clipsAvailable;
        } else if(newRelease) {
            return newRelease;
        }
    }

    return "";

}

function calculateHeightImg(){
    if (!$("#image-soldOut").is(":visible")) {
        //central img height calculation
        if( $('.slot3 .full-image-widget').hasClass('other-colors-empty')){
            if($('#soldOut').is(":visible")){
                $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight() )
            }
        } else{
            if($('#soldOut').is(":visible")){
                $('.slot3 .full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight()  - $('.other_colors').outerHeight() );
            }

        }
    }
}

function loadEspotPDP(espotName,featureEspot) {
    var espotServiceUrl = WCParamJS.urlPrefixForHTTPS + "/wcs/resources/store/" + WCParamJS.storeId + "/espot/" + espotName + '?langId=' + WCParamJS.langId;
    var content ='';
    return new Promise((resolve, reject) => {
        $.ajax({
            url: espotServiceUrl,
            type: 'GET',
            data: '',
            async: false,
            success: function(data) {
                data["MarketingSpotData"].forEach(function(msd, index) {
                    if(msd["baseMarketingSpotActivityData"] && msd["baseMarketingSpotActivityData"][0]["baseMarketingSpotDataType"] === "MarketingContent"){
                        content= msd["baseMarketingSpotActivityData"][0]["marketingContentDescription"][0]["marketingText"]; //html text
                    }
                });
                if (content != '') {
                    if((!isPersol && featureEspot == 'lenses-sun') || featureEspot == 'folding-all'){
                        var div="<div class='product-features inverted-order-mobile'>"+content.toString()+"</div>"
                    }
                    else{
                        var div="<div class='product-features'>"+content.toString()+"</div>"
                    }
                    if(isPersol){
                        $('#product-detail-carousel').append(div);
                        var product = $(".product-features img[data-preset]");
                    }else if(isOliver){
                        $('#op-pdp__section-carousel').append(div);
                        var product = $(".op-pdp__product-details img[data-preset]");
                    }
                    if (product.length>0) {
                        handleProduct(product);
                    }
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);
                reject(error);
            }
        });
    });

}

function setPaginationOtherColors(maxPagination) {
    if(isPersol) {
        if (window.mobilecheck() || window.tabletPortraitCheck()) {  
            var array = $('.oos-Color .owl-page').toArray();
            var activeIndex = $('.oos-Color .owl-page.active').index();
            if(array.length > maxPagination && activeIndex == 0) {
                array[maxPagination].classList.add('small');
                var sliced = array.slice(maxPagination+1,array.length);
                sliced.forEach((el)=>el.classList.add('hide'));
            }
        }
    }
}

/* START - Size guide overlay */

/* PDP_W2
 * Add parameter dataElementId, in this way we can use this function also for FadeClipon
 * */
function freezeWindowForOverlay(dataElementId) {
    hideHeaderTimeout.cancel();
    if(dataElementId == 'X_X_Prod_Size&Fitting_Tooltip'){
    	$(".fade-size-guide").show();
    }else{
    	$(".fade-clipon").show();
    }
    
    if (isPersol) {
      if(!$('#header').is(':visible')){
        $("#bannerTop").css("display", "flex");
        $('#header').slideDown();
      }
      $("html").addClass("overflow-hidden");
    } else {
      $("body").addClass("overflow-hidden");
      $("body").css("position", "relative");
      if (typeof vmSwitchOff === 'function') {
      	vmSwitchOff(false);
  	   }
    }
    $('#header').attr('productAdded','yes');
    $("#page-overflow-wrapper").addClass("overflow-hidden");
    manageScrollOverlay(true);
}

function showSizeGuideOverlay() {
    if (window.mobilecheck() || window.tabletPortraitCheck()) {
        $('.size-guide--body').css('height', '90%');
    } else {
        var windowHeight = window.innerHeight;
        var overlayHeadHeight = $('.size-guide--content__header').css('height').replace(/[^-\d\.]/g, '');
        $('.size-guide--body').css('height', (windowHeight - overlayHeadHeight));
    }
    $(".size-guide").addClass('showed');
}

function unfreezeWindowForOverlay(className) {
    hideHeaderTimeout.setup();
    $('#header').removeAttr('productAdded');
    if(className != undefined){
    	$("." + className).hide();
    }else{
    	$(".fade-size-guide").hide();
    }
    if (isPersol) {
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            $("html").removeClass("overflow-hidden");
        }else if ((window.mobilecheck() || window.tabletPortraitCheck()) && className != undefined ){
        	$("html").removeClass("overflow-hidden");
        }
      
    } else {
      $("body").removeClass("overflow-hidden");
      $("body").css("position", "");
    }
    $("#page-overflow-wrapper").removeClass("overflow-hidden");
    //manageScrollOverlay(false);
}

function closeSizeGuideOverlay() {
    unfreezeWindowForOverlay();
    $(".size-guide").removeClass('showed');
}

function loadSizeGuideOverlay(elementClicked) {
    var dataElementId = elementClicked.getAttribute('data-element-id');
    
    //Analytics Size&Fit
    tealium_data2track.push({
        id: "Click",
        data_element_id: dataElementId, // data-element-id requested
        data_description: " ", // data-description only if requested
      });
    
    /* PDP_W2
     * Add parameter dataElementId to freezeWindowForOverlay, in this way we can use this function also for FadeClipon
     * */
    
    freezeWindowForOverlay(dataElementId);
    showSizeGuideOverlay();
}


/* END - Size guide overlay */

function nonCriticalLogic(){

    if (!calledNonCritical) {

        calledNonCritical = true;

        if (isOliver) {
        if(typeof attributesMap[keysAttributes[2].toString()] != 'undefined' && attributesMap[keysAttributes[2].toString()] == 'Accessories'){
            $('#cbs-desktop .button_text').html(mexAccessories);
        }else{
            $('#cbs-desktop .button_text').html(mexOthers);
        }
        var img = "1";
        var pdp_hero_gallery_m_policy = "?bgcolor=%23f8f8fa&impolicy=OV_parameters&wid=790&cropwest=21&cropeast=19";
        var pdp_hero_gallery_d_policy ="?impolicy=HB_parameters&wid=2000";
        if(typeof attributesMap[keysAttributes[2].toString()] != 'undefined' && attributesMap[keysAttributes[2].toString()] == 'Accessories'){
            img = "<picture><source media='(max-width: 767px)' data-srcset='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/"+partNumber +"_noshad_qt.jpg"+ pdp_hero_gallery_m_policy.replace('bgcolor=%23f8f8fa', 'bgcolor=%23ffffff') +"'/> <source media='(min-width: 769px)' data-srcset='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/"+ partNumber +"_noshad_qt.jpg"+ pdp_hero_gallery_d_policy +"'/> <img alt='"+ partNumber + "main image' 	class='lazy catalog__image placeholder' 	src='/wcsstore/OliverSAS/images/lazyload.png' 			 data-src='https://assets.oliverpeoples.com/extra/image/OliverPeoples/accessories/" + partNumber +"_noshad_qt.jpg"+pdp_hero_gallery_d_policy + "'/> </picture>";
        }else{
            var urlimage = $("#thumbnailImage").val()
            img = "<picture>"+
            "<source media='(max-width: 767px)' data-srcset='"+ window.setQueryParams(urlimage, pdp_hero_gallery_m_policy.replace('bgcolor=%23f8f8fa', 'bgcolor=%23ffffff') ) +"' />"+
            "<source media='(min-width: 769px)' data-srcset='"+ window.setQueryParams(urlimage, pdp_hero_gallery_d_policy) +"'/> "+
            "<img alt='" + partNumber + "main image'  class='lazy catalog__image placeholder'  src='/wcsstore/OliverSAS/images/lazyload.png' data-src='"+ window.setQueryParams(urlimage , pdp_hero_gallery_d_policy ) + "' /> "+
            "</picture>";
        }
        $('#newsLetterForm_emailme .comingSoon__newimage').html(img);
        }
    
        setTimeout(() => {
            var espotPromises = [];
            if(attributesMap['attrFeatures']){
                var split = attributesMap['attrFeatures'].split(';');
                split.forEach(function(obj){
                    var featureEspot= obj.replaceAll("_", "-").replaceAll(" ", "-");
                    featureEspot= featureEspot.toLowerCase();
                    if(isPersol){
                        var espotName = "PDP_"+featureEspot
                    }else if(isOliver){
                        var espotName = "PDP_"+featureEspot+"_2020"
                    }
                    espotPromises.push(loadEspotPDP(espotName,featureEspot));
                });
            }
        }, 0);

        setTimeout(() => {
            if(window.mobilecheck() || window.tabletPortraitCheck()){
                placeProductDetailsNew();
                //  New PDP 2021
                if (isPersol) {
                    setProductDetailPopup('#product-detail-carousel');
                } else if (isOliver) {
                    setProductDetailPopup('#op-pdp__section-carousel');
                }
            }else{
                if (isOliver) {
                    placeProductDetailsNew();
                    setProductDetailPopup('#op-pdp__section-carousel'); 
                }else if (isPersol){
                    placeProductDetailsNew();
                    setProductDetailPopup('#product-detail-carousel');;
                } 
            }
        }, 0);
        
    
        /* START - Size guide overlay */
        
        $(document).on("click",".sizeFitPanel .learnMorePanel",function() {
        	
        	loadSizeGuideOverlay(this);
        	
        	
        	if(window.mobilecheck() || window.tabletPortraitCheck()){
        	/*handle with bottom bar safari. if distance from bottom viewport is a negative value add a padding-bottom*/
	        	$(".size-guide--body").scroll(function(){
	        		 if (this.offsetHeight + this.scrollTop >= this.scrollHeight) {
	        			 var distBottom = window.innerHeight  - document.querySelector("#size-guide-BridgeDiv").getBoundingClientRect().bottom;	
	        			 if(distBottom < 0 && isOliver){
	        				 distBottom = (distBottom * -1) + 80;
	        				 $(this).css('padding-bottom', distBottom + 'px');
	        			 }else if(distBottom < 0 && isPersol){
                            distBottom = (distBottom * -1) + 16;
	        				$(this).css('padding-bottom', distBottom + 'px');
	            		 }
	        		 }
	        	});
        	}
        	
        });
        

        $(document).on("click",'.fade-size-guide, .size-guide--content__header > .closeButton',function() {
            closeSizeGuideOverlay();
            if (isOliver){
                $(".fade-size-guide").data('clicked', true);
                $("#close-size-guide").data('clicked', true);
            }
        });
        /* END - Size guide overlay */
        
        //Set bottom on size guide
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            var iOSVersion = iOSversion();
            if(iOSVersion != undefined){
                //Set bottom on size guide if  version of iOS >= 15
                $(window).on('resize touchmove', function () {
                    if ($(window).height() < window.innerHeight) { //  URL bar collapsed
                        $('.size-option-div').css('bottom','');
                    } else if ($(window).height() == window.innerHeight) { //  URL bar expanded
                        //$('.size-option-div').css('bottom','80px');
                    }
                });		
            }
        }   

        $('#Add_monogram_CTA').click(function(){
            if($(".shopperActions--monogram--pop-up").length > 0) //Do nothing if the monogram pop-up has not been loaded
                toggleMonogramPanel(); 
        });
    
        toggleDiscoverMoreOverlay();
        
        if (isPersol && window.mobilecheck() || window.tabletPortraitCheck()){
            $("#ci_espot__X_PDP_Editorial_Bottom .ct-editorial-button").on("click", function(){
                $("#fixed-top--mobile").removeClass("animation-show");
            });
            $("#ci_espot__X_PDP_Editorial_Bottom a.close").on("click", function(){
                $("#fixed-top--mobile").addClass("animation-show");
            });
        }
        
        if(typeof stock != 'undefined'){
            enableEditorialCta(stock);
        }
    
        if (typeof isSafari == 'function' && isSafari()
                && ((window.mobilecheck() || window.tabletPortraitCheck()))) {
            $('.shopperActions--monogram--pop-up--right').css('height','auto');
        }
    
      //switch button other color
        $(document).off("change",".switchButtonOtherColorsContainer input").on("change",".switchButtonOtherColorsContainer input",function(){
            if($(".switchButtonOtherColorsContainer input").is(":checked")){
                $('#popup-content-container .product[data-is-roxable!="true"]').hide();
                tealium_data2track.push({
                    id : 'SearchFilterUpdated',
                    'Search_ResultItemsQnt' : '',
                    'Search_FacetValues_String' : ''
                });
            }
            else if($(".switchButtonOtherColorsContainer input").is(":not(:checked)")){
                $('#popup-content-container .product[data-is-roxable!="true"]').show();
                tealium_data2track.push({
                    id : 'SearchFilterUpdated',
                    'Search_ResultItemsQnt' : '',
                    'Search_FacetValues_String' : ''
                });
            }
        });
    
        // BEGIN HB-9422 sizeGuideOverlay
        $(".size-guide--body").on('scroll',function () {
            if (isOliver){ 
                if($('.nav-div').offset().top <= $(window).scrollTop() + $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight() +6 ){ //6px padding-top
                    $('.size-guide--body .nav-beans').addClass('nav-div--sticky');
                    $('.size-guide--body .nav-beans').css({'top': $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight(),'width':$('.nav-div').width()});
                    $('.size-guide--body .nav-div').addClass('-sticky');
                    $('.size-guide--body #size-guide-FitDiv').addClass('-sticky');
                }else{
                    $('.size-guide--body .nav-beans').removeClass('nav-div--sticky');
                    $('.size-guide--body #size-guide-FitDiv').removeClass('-sticky');
                    $('.size-guide--body .nav-div').removeClass('-sticky');
    
                }
            }else{
                if($('.nav-div').offset().top <= $(window).scrollTop() + $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight()){
                    $('.size-guide--body .nav-beans').addClass('nav-div--sticky');
                    $('.size-guide--body .nav-beans').css({'top': $('.size-guide--content__topTitle').outerHeight() + $('.size-guide--content__header').outerHeight(),'width':$('.nav-div').width()});
                    $('.size-guide--body .nav-div').addClass('-sticky');
                    $('.size-guide--body #size-guide-FitDiv').addClass('-sticky');
                }else{ 
                    $('.size-guide--body .nav-beans').removeClass('nav-div--sticky');
                    $('.size-guide--body #size-guide-FitDiv').removeClass('-sticky');
                    $('.size-guide--body .nav-div').removeClass('-sticky');
                } 
            }
        });
        //END HB-9422
        if($("a[id='add2CartBtnNavBar']:not(:nth-child(1))").length>1){
            $("a[id='add2CartBtnNavBar']:not(:nth-child(1))").remove();
        }
    
        /**
        * Function that close the newsletter
        */
        $('.comingSoon__close').click(function () {
        closeform();
        });
    
        /**
         * Function that close the newsletter emailme when click in fade layer
         */
        $('.comingSoon--fade').click(function () {
            $('.comingSoon__close').click();
            $('body').removeClass('no-scroll');
            $('body, html').css('height', 'auto');
            $('body, html').css('overflow', 'visible');
        });
    
        $('#close_emailme').click(function () { 
        closeform();
        });

        if($('#below-clipon-section').length > 0){
        	manageCliponSection();
        }
    	$('.product-image-sticky').css('cursor', 'pointer');
        $('.product-image-sticky').click(function (){
        	$(window).scrollTop(0);
        });

    }

    if (typeof init_wishlist_tooltip === 'function') {
        if(!(window.tabletPortraitCheck() || window.mobilecheck())){
            init_wishlist_tooltip();
        }
        
    }

  
}

function placeProductDetailsNew(){
	//carousel product detail
	if(isPersol && (window.mobilecheck() || window.tabletPortraitCheck())){
		$('.view-product-details-container').before('<div id="titleProductDetail">' + $('.persol-product-title').text() + '</div>');
	}else if (isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
		$('.view-product-details-container').before('<div class="titleProductDetail">' + $('.product_text--title h1').text() + '</div>');
	}

    if(window.tabletPortraitCheck()){
        if(isPersol){
            $('.right-side .product-description').prepend('<div class="titleProductDetailTablet">' + $('#titleProductDetail').first().text() + '</div>');
        }else if(isOliver){
            $('.left-side .product-description').prepend('<div class="titleProductDetailTablet">' + $('.titleProductDetail').first().text() + '</div>');
        }
    }
	var cloneProductDetail;
	cloneProductDetail = document.querySelector('.descriptive-attributes-widget').cloneNode(true );
	cloneProductDetail .setAttribute('id', 'productDetail');
	$('.view-product-details-container').before(cloneProductDetail);
	if(window.mobilecheck() || window.tabletPortraitCheck() || isPersol){
		var cloneTab;
		if(isPersol){
			cloneTab = document.querySelector('.accordion-content').cloneNode( true );
			cloneButton = document.querySelector('.view-product-details-container').cloneNode( true );
		}else if(isOliver){
			if((isAccessory && !isClipon && $('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details').length == 0) || (!isAccessory && !isClipon) || isClipon){
	        	//if is a product, clipon or case 
				cloneTab = document.querySelector('#descriptiveAttributes').cloneNode( true );
	        }else{
	        	cloneTab = document.querySelector('.left_espot .ct-pdp--tab-details').cloneNode( true );	        	
	        }
		}    
	    cloneTab.setAttribute('id', 'tabAttr');
	    //table in persol desktop with only 8 tab
	    if(isPersol && !(window.mobilecheck() || window.tabletPortraitCheck() )){
	    	$('#productDetail #product-details-popup .text-content').append(cloneTab);
	    	$('#productDetail #product-details-popup').append(cloneButton);
	    }else{
	    	$('.view-product-details-container').not('.view-product-details-container.dsk_pdp').before(cloneTab);
	    }
	    while($('#tabAttr li').length > 8){
	    	//we wish see only the first 8 element of table
	    	$('#tabAttr li:last-child').remove();
	    }
	    //after delete the rows we can show the table 
	    if(isPersol){
	    	$('#tabAttr').css('display','block');
	    }else if((isAccessory && !isClipon && $('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details').length > 0)){
	    	//if is an collaboration acc
	    	$('#tabAttr.tabContent.ct-pdp--tab-details').addClass('blockImportant');
	    }
	    
	}else{
		//if is OP Desktop
		if(isAccessory){
			while($('#productDetail .tabContent.ct-pdp--tab-details li').not('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details li').length > 5){
		    	//we wish see only the first 6 element of table
				$('#productDetail .tabContent.ct-pdp--tab-details li:last-child').not('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details li').remove();
		    }			
		}
	} 
    //insert voice product details
    if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
    	//insert voice product details
    	$('#descriptiveAttributes.tabContent ul').before('<div id="nameDetailTab" class ="opened" >'+ $('#prodAttr').text() +'</div> ');	
    	
    	//Insert Premium Package if isn't accessory
    	if((isAccessory && isClipon)|| (!isAccessory && !isClipon)){
            if(oliverCase != ""){
                createOliverCaseDiv();
        	    $('#descriptiveAttributes.tabContent').after($('.slide-type.front-frame.case'));
        	    $('.slide-type.front-frame.case').before('<div id="titleFeature" class="tabPack" aria-expanded="false">' + $('#tab-presc .description-packaging h3')[0].innerText  +'</div>')
            }
    	}
    }else if(isOliver){
    	//insert tab in popup desktop
    	$("#productDetail #popupDetail #detailDescription").append('<div id="nameDetailTab" class ="opened" >'+ $('#prodAttr').text() +'</div> ');
    	var tabDetail = document.querySelectorAll('#descriptiveAttributes.tabContent');
    	$("#nameDetailTab").after(tabDetail[0].cloneNode(true));
    	$('#popupDetail #detailImage').append("<div feature='detailTabImg'>" +
				  // "<img src = 'https://assets.oliverpeoples.com/is/image/OliverPeoples/" + partNumber + "_shad_fr.png?bg=f8f8fb&impolicy=OV_parameters&wid=2000&cropeast=1000'>" +
				  "</div>");
    	
    	createOliverCaseDiv();    	
    }
    
}

function closeform(){
    changeTabIndex($('.comingSoon'));
    $('.comingSoon').removeClass('opend');
    $('.comingSoon--fade').hide();
    $('body').removeClass('no-scroll');
    $('body, html').css('height', 'auto');
    $('body, html').css('overflow', 'visible');
}

function resetFrom(){
//form completo da visualizzare
$('#mce-error-response_emailme').hide();
$('.comingSoon__infoSuccess').hide();
$('.comingSoon__titleSuccess').hide();
$('.comingSoon__info').show();
$('.comingSoon__title').show();
$('.input_emailme').show();
$('.check_emailme').show();
$('#confirm_emailme').show();
$('#close_emailme').hide();
$('.buttonEmailme').css('margin-top','0px');
}
//#EMAIL_ME#

function newOpenSizeGuide(){
    $('.fade-size-guide').show();
    $('.size-guide').addClass('showed');
    manageScrollOverlay(true);
}

/* This function checks replaces the current image in the minicart with the STD one for the given partnumber */
function replaceImageMinicart(imges, partnumber){
    $.each(imges, function(index,img){
       var urlImg= img.dataset['src'];
       if(urlImg != undefined){
         img.dataset['src'] = urlImg;
         img.src = urlImg;
        }
       
       
    });
}


function scrolltoDiv(id){    
    if(id == '#size-guide-BridgeDiv'){
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            var scrollTop = $(id).offset().top - 90 ;
        }else{
            var scrollTop = $(id).offset().top +500;
        }
       
    }else{
        var scrollTop = $(id).offset().top-150;
    }  
    $('.size-guide--body').animate(
        {
            
          scrollTop: scrollTop
        },
        800 //speed
      ); 
}


function closePromoBox(id){

    $("#"+id).addClass('hide-promo');
    $("#"+id).parent().addClass('hide-promo-parent');
    if(id.includes("X_PDP_Hero__Promo")){
        $("#X_PDP_Hero__Promo_mobile").addClass('hide-promo');
        $("#X_PDP_Hero__Promo").addClass('hide-promo');
        $("#X_PDP_Hero__Promo").parent().addClass('hide-promo-parent');
        $("X_PDP_Hero__Promo_mobile").parent().addClass('hide-promo-parent');
    } 
    if (isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
        if(id == "X_PDP_Hero__Clipon"){
            //$(".shopper-action-bar").css("padding-bottom","0");
        }
    }
}

function setCtabarStickyDesktop(){

    var st = document.documentElement.scrollTop;
    var upperBarOriginalHeigth = $("#upperBarOriginalHeigth").val();
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    

    if (st >= ($( window ).height() - upperBarOriginalHeigth - 64  - $("#header").height() - ($('#bannerTop').length > 0 ?($('#bannerTop').height()): 0 ))){ // viewport - ctaupperBar height - 64(space below ctabar) - header height - banner top height (if present) = scrollable area without sticky 
        $('.cta-upperBar').addClass("sticky-top");
        $('.cta-bar-container').addClass("sticky-top");
        $("#bannerTop").parent().hide();
        $(".product-image-sticky").show();
        $(".espot-promo-container").hide();
        $(".cta-lowerBar").hide();
        if(!$('.cta-bar-container').hasClass("sold-out")){
            $(".name-partnumber-and-price-widget").hide();
        }
        if($('.cta-bar-container').hasClass("coming-soon")){
            $("#comingSoon").hide();
            $('.pdp .name-part-price-container').hide();
        }
          
    
    }else{
      $("#bannerTop").parent().show();
      $(".product-image-sticky").hide();
      $('.cta-upperBar').removeClass("sticky-top");
      $('.cta-bar-container').removeClass("sticky-top");
      $(".name-partnumber-and-price-widget").show();
      if(!$('.cta-bar-container').hasClass("sold-out")){
        if (!urlParams.has('bypassPromo') || urlParams.get("bypassPromo").toLowerCase() != 'true') {
            $(".espot-promo-container").show();
        }
        $(".cta-lowerBar").show();
      }
      if($('.cta-bar-container').hasClass("coming-soon")){
        $("#comingSoon").show();
        $('.pdp .name-part-price-container').show();
    }
    $("#X_PDP_Hero__Promo_mobile").hide();
    }
    
}


function showCTAloader(buttonId){
    button = document.getElementById(buttonId);
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        
        $(button).removeClass("loaded");
        if(buttonId === 'productPageAdd2Cart'){
          button = document.getElementById('add2CartBtn');
          $(button).removeClass("loaded");
        }
    
      }else{
    
          $(button).find(".bag-icon").hide();
          if (isOliver) {
              $(button).find(".presc--side--button--icon").hide();
          } else {
              $(button).find(".plus-symbol").hide();
          }
          $(button).find(".loadpanel_loader").css("display","inline-block");
    
      }
  
}


function hideCTALoader(buttonId){
    button = document.getElementById(buttonId);
  if(!(window.mobilecheck() || window.tabletPortraitCheck())){
    
    $(button).addClass("loaded");
    if(buttonId === 'productPageAdd2Cart'){
      button = document.getElementById('add2CartBtn');
      $(button).addClass("loaded");
    }

    }else{
        
    $(button).find(".bag-icon").show();
        if (isOliver) {
            $(button).find(".presc--side--button--icon").show();
        } else {
            $(button).find(".plus-symbol").show();
        }
        $("div.loadpanel_loader").hide();
    }

 }
/* PDP called function: #
* prev function: 
* next function: 
*/
function calculateDistances(){

    var timestamp = new Date().getTime() / 1000;
    var diff = timestamp - renderingPageStarterTime;
    console.log('Performance Improvements PDP - #20 - calculateDistances (OP only) - ' + diff.toString().slice(0 , 5) + 's');

    if(window.mobilecheck()|| window.tabletPortraitCheck()){
       // $('.bottom-scrollable-section').css('z-index', '801');
        var heightVisibleElements = $('.defining-attributes-widget').children(':visible');
        window.heightHiddenActions = 1;
        for ( i=0; i < ($('.defining-attributes-widget').children(':visible').length); i++){
            window.heightHiddenActions += parseInt($(heightVisibleElements[i]).outerHeight());
            window.heightHiddenActions += 10;
        }
        if(('#op-pdp__slot5').length > 0 )
            window.productDetailTop = $('#op-pdp__slot5').offset().top + window.heightHiddenActions - $('.tab-bar').height();
            window.endSlider = parseInt($(".op-pdp__product-details").height() + window.productDetailTop);
    }else{
    	//if isn't a mobile
    	 $('.bottom-scrollable-section').css('z-index', '4');
       //  $('.bottom-scrollable-section').css('margin-top', $('#op-pdp__slot2').outerHeight());
         if(!$('.bottom-section').hasClass('hideSoldOut')){
         	$('.bottom-section').css('position','relative');
         	$('.bottom-section').css('display','flex');
         }
         //$('#pdp_other_colors').css('visibility','visible');
         //$('.op-pdp__slot2').css('position','fixed');
         
         var version = null;
  
         if(typeof navigator.sayswho != 'undefined' && navigator.sayswho.length>0){
        	 try{
        		 version = parseFloat(navigator.sayswho[1]);
        	 }catch(e){
        		 console.error("Unable to find browser version");
        	 }
         }
         
         if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) && version < 15.4) {
    		 var heighth = "-"+ $('#op-pdp__slot2').outerHeight()+"px";
    		 $('.op-pdp__slot2').css('margin-top', heighth);
    	 }

    	 $('.op-pdp .navbar-placeholder').css('height','0px');
	}
}

/**
*   This file is for the PDP
*/

// starts with polyfill
if (!String.prototype.startsWith) {
    Object.defineProperty(String.prototype, 'startsWith', {
        value: function(search, rawPos) {
            var pos = rawPos > 0 ? rawPos|0 : 0;
            return this.substring(pos, pos + search.length) === search;
        }
    });
}
/* this remove scroll positionin*/
if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}

function controlPDPDropDown() {
    var that = this;
    if ($(window).innerWidth() <= 1024) {
        if ($(that).parent().hasClass('opend')) {
            $(that).parent().removeClass('opend');
        } else {
            $('[class^="op-pdp"] .opend').removeClass('opend');
            $(that).parent().addClass('opend');
        }
    }
}

function createpaginationThumbnails(imgSrcStandardArray){
	var owlPagesSpans = $('#op-pdp__popup-images  .owl-pagination .owl-page span');
	for (var i = 0; i < imgSrcStandardArray.length; i++) {
		var imgURL = imgSrcStandardArray[i];
		var span = owlPagesSpans[i];
		var imgTag = document.createElement('img');
		imgTag.setAttribute('src',imgURL);
		span.append(imgTag);
	};
}

function manageAccessibilityFullImage(){
    if(!(window.mobilecheck() || window.tabletPortraitCheck()))
    // apply meta info to next and previous buttons and make them focusable
        $('.op-pdp__popup-wrapper .owl-item.active .popup_link').attr('tabindex','0');
        $('.op-pdp__popup-wrapper .owl-pagination').attr('aria-labelledby', 'carousel controls');
        $('.op-pdp__popup-wrapper .owl-item').attr('aria-selected','false');
        $('.op-pdp__popup-wrapper .owl-item.active').attr('aria-selected','true');
        $('.op-pdp__popup-wrapper .owl-pagination .owl-page').attr('role','button').attr('tabindex','0');
        $('.op-pdp__popup-wrapper .owl-pagination .owl-page.active') .attr('title','Active Slide')
        $('.op-pdp__popup-wrapper .owl-pagination .owl-page').on('keydown', function(e){
            if(e.keyCode == 13){
                var slideToGO = parseFloat($(this).children().children('img').attr('data-index'));
                $(".op-pdp__popup-wrapper").data('owlCarousel').goTo(slideToGO);
                $($('.op-pdp__popup-wrapper .owl-pagination .owl-page')[slideToGO]).attr('title','Active Slide')
                $($('.op-pdp__popup-wrapper .owl-pagination .owl-page')[slideToGO]).attr('title','Next Slide');
                $($('.op-pdp__popup-wrapper .owl-pagination .owl-page')[slideToGO - 2]).attr('title','Prev Slide');
            }

        })
        $('.op-pdp__popup-wrapper .owl-item').attr('aria-selected','false');
        $('.op-pdp__popup-wrapper .owl-item.active').attr('aria-selected','true');
}
// MCB WCAG - This function close the popup just pressing escape

$(document).keyup(function (e) {
    if (e.key === "Escape") {
        if ($('.presc').hasClass('showed-presc')) {
            $('#close-prescriptions').click();
        }
        if ($('.op-pdp-popup-other-colors').hasClass("active")) {
            togglePopupOtherColors(false);
        }
        if ($('.modal-background').is(':visible')) {
            $('.modal-background').css('display', 'none');
        }
        if ($('#op-pdp__popup-images').is(':visible')) {
            closePopupImages();
        }
    }
});


function closePopupImages(){
    $('body').css('overflow','visible');
    $('#page-overflow-wrapper').removeClass('overflow-hidden');
    $('#op-pdp__popup-images').hide();
    $('#header').css('z-index', window.zIndexHeader);

    if(window.mobilecheck() || window.tabletPortraitCheck()){
        $('#op-pdp__slot8').show();
       $('#op-pdp__popup-images').css('z-index', '333')
    }
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        $("#op-pdp__popup-images").off('keydown');
        managePopupTabIndex("#op-pdp__popup-images", false);
    }
    $('#op-pdp__popup-images  .owl-pagination .owl-page span').empty();
}

function closePopupSizing(){
    $('body').removeAttr("style")
}

var element;
var originalY;
var topMargin;
var stopAt;
var delayScroll;

function refreshVariables() {
    element = $('.op-pdp__slot8');
    originalY = element.offset().top;
    topMargin = 30;
    stopAt = whereToStop();
}

function whereToStop() {
    var totalHeight = $('.op-pdp__slot6').offset().top - $('.op-pdp__slot8').height();

    totalHeight -= 80;
    return totalHeight;
}

function scrollDiv() {
    var startsHeight = $(".op-pdp__slot1").offset().top + $(".op-pdp__slot1").height();
    stopAt = whereToStop();
    if ($(window).scrollTop() > stopAt) {
    } else if ($(window).scrollTop() > originalY - 85) {

        if ($(window).scrollTop() > $('.op-pdp__slot2 .product_text').offset().top) {
            element.addClass('show-name');
        } else {
            element.removeClass('show-name');
        }
    } else if ($(window).scrollTop() < startsHeight) {
    }
}


/******************************************************************************************************** */
function updateItemName(catEntryId) {
    var catEntry = productDisplayJS.itemPriceJsonOject[catEntryId].catalogEntry;
    var catalogEntryDetails = JSON.parse($('#catalogEntryDetails_temp').text());
    var TEMPLE_LENGTH = '';
    var LENS_BRIDGE = '';
    var MODEL_SIZE = ''; // DRF - To Be Confirm
    var LENS_HEIGHT = '';

    for (var sku in catalogEntryDetails.sKUs) {
        if (catEntry.catalogEntryIdentifier.externalIdentifier.partNumber === catalogEntryDetails.sKUs[sku].partNumber) {
            for (var attr in catalogEntryDetails.sKUs[sku].attributes) {
                switch (catalogEntryDetails.sKUs[sku].attributes[attr].identifier) {
                    case 'TEMPLE_LENGTH':
                        TEMPLE_LENGTH = catalogEntryDetails.sKUs[sku].attributes[attr].values[0].value;
                        break;

                    case 'LENS_BRIDGE':
                        LENS_BRIDGE = catalogEntryDetails.sKUs[sku].attributes[attr].values[0].value;
                        break;

                    case 'MODEL_SIZE':
                        MODEL_SIZE = catalogEntryDetails.sKUs[sku].attributes[attr].values[0].value;
                        break;

                    case 'LENSHEIGHT':
                        LENS_HEIGHT = catalogEntryDetails.sKUs[sku].attributes[attr].values[0].value;
                        break;

                    default:
                }
            }
        }
    }
    
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
		
    	var modelCodeLabel=$(".descriptive-attributes-widget#productDetail .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
    	var modelCodeLabelClip=$(".descriptive-attributes-widget#productDetail .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[2];
        var modelCodeLabelPopUp = $("#detailFeature .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
        var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
    
        if(typeof modelCodeLabel != 'undefined'){
            modelCodeLabel.innerText = modelCodeDisplay.innerText;
        }
        if(typeof modelCodeLabelClip != 'undefined'){
        	modelCodeLabelClip.innerText = modelCodeDisplay.innerText;
        }
        if(typeof modelCodeLabelPopUp != 'undefined'){
        	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
        }
       
    } else {
    	
    	var modelCodeLabel=$("#tabAttr .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
        var modelCodeLabelPopUp = $("#featureMenu .single-attibutes."+attributesMap['modelCodeId']+" .attr-value")[0];
        var modelCodeDisplay = document.querySelector(".modelCodeDisplay_" + catEntryId);
        
        if(typeof modelCodeLabel != 'undefined'){
            modelCodeLabel.innerText = modelCodeDisplay.innerText;
        }
        if(typeof modelCodeLabelPopUp != 'undefined'){
        	modelCodeLabelPopUp.innerText = modelCodeDisplay.innerText;
        }
    }

    var modelMeasurements = document.querySelector(".ItemMeasurements_" + catEntryId);

    var modelMeasurementsValueElement = document.querySelector("#featureMenu .descAttributeValue_modelMeasurements");
    if (modelMeasurementsValueElement != null) {
        modelMeasurementsValueElement.innerHTML = getMeasurementsDisplayValue(modelMeasurements.innerHTML);
    }
    $("#descriptiveAttributes .descAttributeValue_modelMeasurements").html(getMeasurementsDisplayValue(modelMeasurements.innerHTML))
    $("#tabAttr .descAttributeValue_modelMeasurements").html(getMeasurementsDisplayValue(modelMeasurements.innerHTML));
}


/**
 * @param {*} measurements
 */
function getMeasurementsDisplayValue(measurements) {
    var arrM = measurements.split(",");
    return arrM.join("-");
}

var currentImgUrl = null;
var currentColors = null;
var currentBadges = null;
var isCaseSlide = false;

/**
 * HB-1669 BEGIN Enable or disable addToCart button depending of current catentry stock
 */
function hideOrShowCartBtn (showAdd) {
    if(showAdd) {
        $("#add2CartBtnDisabled").hide();
        if(!$("#add2CartBtnDisabled").hasClass("hidden")) $("#add2CartBtnDisabled").addClass("hidden");
        $("#add2CartBtn").show();
        $("#add2CartBtn").removeClass("hidden");
    } else {
        $("#add2CartBtnDisabled").show();
        $("#add2CartBtnDisabled").removeClass("hidden");
        $("#add2CartBtn").hide();
        //$('#pdp-presc-and-clip-on #presc--button').css('visibility', 'hidden');
        if(!$("#add2CartBtn").hasClass("hidden")) $("#add2CartBtn").addClass("hidden");
    }
}


/* HB-1669 END ******************************************************************************/

//For other colors popup interactions
function togglePopupOtherColors(toOpen) {
    var zIndex;
    if(toOpen){
        zIndex = $('.bottom-scrollable-section').css('z-index');
    }

    if(toOpen){
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
            //wcag
            $('.op-pdp-popup-other-colors .product a.catalog__link').on('focus', function(){
                $(this).parents('.product').addClass('classHover');
            }).on('blur', function(){
                $(this).parents('.product').removeClass('classHover');
            });
            managePopupTabIndex(".op-pdp-popup-other-colors", true);
        } else {
            $(".op-pdp-popup-other-colors").scrollTop(0);
        }
        $(".op-pdp-popup-other-colors").addClass("active");
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            //changeIndexMobileOpen();
			$(".central-image-carousel").css("z-index","");
        } else {
            $('.bottom-scrollable-section').css('z-index', '1000');
        }
        hideHeaderTimeout.cancel();
        $(".op-pdp-popup-other-colors-background").addClass("active");
        $("#page-overflow-wrapper").addClass("overflow-hidden");
        $("body").addClass("overflow-hidden");
        $('.op-pdp-popup-other-colors .product .product--wrapper').on('click', function(){
            $(this).find('a.catalog__link')[0].click();
        })
    } else {
        if(!(window.mobilecheck() || window.tabletPortraitCheck())){
            //wcag
            managePopupTabIndex(".op-pdp-popup-other-colors", false);
            $('.op-pdp-popup-other-colors .product a.catalog__link').off('focus');
        }
        hideHeaderTimeout.setup();
        $(".op-pdp-popup-other-colors").removeClass("active");
        $(".op-pdp-popup-other-colors-background").removeClass("active");
        $("#page-overflow-wrapper").removeClass("overflow-hidden");
        $("body").removeClass("overflow-hidden");
        if(window.mobilecheck() || window.tabletPortraitCheck()){
			$(".op-pdp__wrapper.central-image-carousel").css("z-index","auto");
			changeIndexMobileClose();
        } else {
            zIndex ? $('.bottom-scrollable-section').css('z-index', zIndex) : $('.bottom-scrollable-section').css('z-index', '2');
        }
        $('.popup-content .product .product--wrapper').off('click');
    }
}

//trigger click you may also like
$('#op-pdp__slot7 .product').on('click', function(){
    $(this).find('a.catalog__link')[0].click()
})

var price = $(".name-part-price-container .price__unity").html();
var frontColor = $(".descriptive-attributes-widget #7741124012283379839 span[id^='descAttributeValue_']").html();
var lensColor = $(".descriptive-attributes-widget .attr--lens-color span[id^='descAttributeValue_']").html();
var frameMaterial = $(".descriptive-attributes-widget #7741124012283379837 span[id^='descAttributeValue_']").html();

var windowWidth = 1025; //TODO controllare media query
var limitDesktop = 400;
var limitMobile = 300;
var isFirstTime = true;

//wcag
function managePopupTabIndex(container, isOpen){
    if(isOpen){
        $(container).on('keydown', function(e){
            $(container).addClass('focus');
            var focusableEls = $(container + " input:visible, "+ container + " button:visible, " + container + " a:visible, "+ container + " [tabindex]:not([tabindex='-1'])" )
            var firstFocusableEl = focusableEls[0];
            var lastFocusableEl = focusableEls[focusableEls.length - 1];
            var KEYCODE_TAB = 9;
            var isTabPressed = (e.key === 'Tab' || e.keyCode === KEYCODE_TAB);
            if (!isTabPressed) {
                return;
            }
            if ( e.shiftKey ) /* shift + tab */ {
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else /* tab */ {
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        })
    } else {
        $(container).off('keydown');
    }
}


var isFirstTime = true;
var endSlider;
var startSlider;

function setStickyProductDetailsNavbar() {
    if(!$('#op-pdp__slot2').is(':visible')){
        if(isFirstTime) {
            startSlider = Math.round($(".op-pdp__product-details").position().top);
            endSlider = Math.round($(".op-pdp__product-details").height() + $(".op-pdp__product-details").position().top);
            isFirstTime = false;
        }
        var tabHeight = 40;
        var heightBlackBar = $("#op-pdp__slot8").height()
        if((window.pageYOffset + heightBlackBar) >= (startSlider) && (window.pageYOffset + heightBlackBar) < (endSlider - tabHeight)){
            $("#tab-products-details").addClass("sticky-bar");
            $('#op-pdp__slot5').css('padding-top', $('.tab-bar').height() +'px');
            $('#op-pdp__slot5').focus();
        } else {
            $("#tab-products-details").removeClass("sticky-bar");
            $('#op-pdp__slot5').css('padding-top', 0);
        }
    }
}

var lastScrollTopMobile = 0;
var headerHeight = parseInt($('#headerWrapper').outerHeight());
animationInit = function () {
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        window.onscroll = function() {
            var header = $('#op-pdp__slot8').get(0);
            var positionSticky = header.offsetTop;
            var slide = $('#op-pdp__slot2');
            //setStickyHeader(header, positionSticky, slide)
            setCtabarStickyDesktop();
            event.preventDefault();
            event.stopPropagation();
            setStickyProductDetailsNavbar();
        }
    } else{
        if (!$("#image-soldOut").is(":visible")) {
            if( $('.full-image-widget').hasClass('other-colors-empty')){
                $('.full-image-widget').css('height', window.innerHeight - $('.bottom-section').outerHeight());
            } else{
            }
        }
    }
}

var slot8Height = $('#op-pdp__slot8').height();
var tabProductsHeight = $('.tab-bar-container').height();
var desctiptiveAttrHeight = $('.descriptive-attributes-widget').height()
var isFirstScroll = true;
var setStickyBar = true;
var slideDetailCompleted = false;
var slideHeaderCompleted = false;



var isFirstScroll = true;
var lastScrollTop = 0;

function setStickyHeader (header, positionSticky, slide) {

    var st = window.pageYOffset || document.documentElement.scrollTop;


    if (st >= 20 && st > lastScrollTop && isFirstScroll ) {
    	//$('#header').slideUp();
    	// $('.op-pdp__slot8.fixed-bottom.sticky-bottom').css("bottom","auto");
        $('.bottom-section').css("bottom","auto");
    	$("#tab-products-details").addClass("sticky-bar");

        $('#op-pdp__slot2').slideUp({
            duration:300,
            complete:function(){
                stickyTopDesktop();
                $(window).scrollTop(21);
            }
        });

    } else if(st < lastScrollTop) {
        if(!$('#op-pdp__slot2').is('visible') && st < 20){
            $('#op-pdp__slot2').slideDown({
                duration:300,
                complete:function(){
                        stickyBottomDesktop();
                    }
                });
            // $('.op-pdp__slot8.fixed-bottom.sticky-bottom').css("bottom","0px");
            $('.bottom-section').css("bottom","0px");
        }
    }

    lastScrollTop = st <= 20 ? 1 : st
}



function stickyBottomDesktop() {
    isFirstScroll = true;
    var header = $('#op-pdp__slot8').get(0);
    $('#X_Pdp_Stickybar_ScrollDown').fadeIn();
    $(header).removeClass("sticky-top");
    $(".delivery-date").show();
    $(header).addClass("sticky-bottom");
    hideHeaderTimeout.showHeader();
    $(".navbar-placeholder").removeClass("fixed-top-navbar");
    $(".bottom-section").removeClass("fixed-top-navbar");
   /* $('#pdp_other_colors').show();/*wcag reason -- commented in PDP Redesign 2023*/
    if($("#tab-products-details").hasClass("sticky-bar"))$("#tab-products-details").removeClass("sticky-bar");
    $(".delivery-hide").show()
}

function goBackToTopDesktop(){
    $(header).removeClass("sticky-top").addClass("sticky-bottom");
    $(window).scrollTop(0);
    if($("#tab-products-details").hasClass("sticky-bar")) $("#tab-products-details").removeClass("sticky-bar");
    $('#op-pdp__slot2').slideDown({
        duration:300,
        complete:function(){
                $(".delivery-date").show().css({'display':'flex'});
                stickyBottomDesktop();
                isFirstScroll = true;
                $('#X_Pdp_Stickybar_ScrollDown').fadeIn();
                hideHeaderTimeout.showHeader();
                $(".delivery-hide").show()

            }
        });
}

function createTopRecap(){
    $(".current-product-colors").html();
    $("#add2CartBtnNavBar").appendTo( "#fixed-top--mobile .navbar-product .cta-buttons" ).show();
    if($("#add2CartBtnDisabled").is(':visible')){
        $("#add2CartBtnNavBar").addClass('disabled')
    }
    $("#fixed-top--mobile .navbar-product .product-image, .navbar-product .product-colors").click(goBackToTopMobile)
    var prodName = $(".short-description-widget h1").html();
    $("#fixed-top--mobile .navbar-product .product-name").html(prodName);
    $("#fixed-top--mobile .navbar-product .product-price").html($(".price__unity").html());
}

function setHeightFullImage(showHeader) {
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){

      /*  if($('.full-image-widget').hasClass("no-prescription") && $('.full-image-widget').hasClass("other-colors-empty")){
            $(".bottom-section").addClass("no-colors")
        } PDP Redesign 2023*/ 

        if(showHeader){
            // $(".short-description-widget").css("margin-top", $("#header").height() + "px")
            // $(".full-image-widget .widget_product_image_viewer .pdp-fullimage__carousel .popup_link:not(.model):not(.case) .pdp-fullimage__img").css("transform", "translateY(10%)");
            if ($("#image-soldOut").is(":visible")) {
                $(".content.pdp-fullimage").css("transform", "translateY(10%)");
            }
        } else {
            // $(".short-description-widget").css("margin-top", 0)
            // $(".full-image-widget .widget_product_image_viewer .pdp-fullimage__carousel  .popup_link:not(.model):not(.case) .pdp-fullimage__img").css('transform', 'translateY(0)');
            if ($("#image-soldOut").is(":visible")) {
                $(".content.pdp-fullimage").css('transform', 'translateY(0)');
            }
        }
    }/*else{
    	if(showHeader){
            //$(".short-description-widget").css("margin-top", $("#header").height() + "px")
            $(".full-image-widget .widget_product_image_viewer .pdp-fullimage__carousel .popup_link:not(.model):not(.case) .pdp-fullimage__img").css("transform", "translateY(10%)");
            if ($("#image-soldOut").is(":visible")) {
                $(".content.pdp-fullimage").css("transform", "translateY(10%)");
            }
        } else {
            $(".short-description-widget").css("margin-top", 0)
            $(".full-image-widget .widget_product_image_viewer .pdp-fullimage__carousel  .popup_link:not(.model):not(.case) .pdp-fullimage__img").css('transform', 'translateY(0)');
            if ($("#image-soldOut").is(":visible")) {
                $(".content.pdp-fullimage").css('transform', 'translateY(0)');
            }
        }
    }*/
}

var hideHeaderTimeout = {
    hideHeader: function() {
    	/*if($('[productAdded=yes]').length < 1){
	    		$('#header').slideUp({
	    			complete:function(){
                        setHeightFullImage(false);
                        if (window.mobilecheck() || window.tabletPortraitCheck()){
                            $('.op-pdp__slot2 .promo-callout-container').show();
                        }
	    			}
                })
                this.timeoutID = undefined;
        }*/
    },

    showHeader: function() {
        $("#header").slideDown({
            complete:function(){
                setHeightFullImage(true);
                if (window.mobilecheck() || window.tabletPortraitCheck()){
                    $('.op-pdp__slot2 .promo-callout-container').hide();
                }
            }
        });
        this.setup();
    },

    setup: function() {
    	if (window.mobilecheck() || window.tabletPortraitCheck()){
    		if (typeof this.timeoutID === 'number') {
                this.cancel();
            }
            this.timeoutID = window.setTimeout(function() { this.hideHeader();  }.bind(this), 3000);
    	}        
    },

    cancel: function() {
        window.clearTimeout(this.timeoutID);
    }
}

var firstTime = true;
function animationScroll(){

    var st = $(window).scrollTop();
    var scroll = st + $("#fixed-top--mobile").height();
    event.preventDefault();
    event.stopPropagation();

    if($("#fixed-top--mobile").hasClass("animation-show") && firstTime) {
        window.productDetailTop = $('#op-pdp__slot5').offset().top;
        window.endSlider = parseInt($("#op-pdp__section-carousel").height() + $('#op-pdp__slot5').offset().top);
        firstTime = false
    }

    if(!didResize){
        if (st > lastScrollTopMobile){
            if( st < window.heightHiddenActions ){
                $('#op-pdp__slot8 .defining-attributes-widget').height(st);
            }
            if(st >= window.heightHiddenActions){
                $('#op-pdp__slot8 .defining-attributes-widget').height(window.heightHiddenActions);
                $('#op-pdp__slot8').next().css('visibility', 'visible');
            }
            if (st >= window.innerHeight - 100){
                $('#fixed-top--mobile').addClass('animation-show');
            }
            //fisso la barra product detail se � presente
            if($('#op-pdp__slot5').length > 0){
                if(scroll >= window.productDetailTop && scroll < window.endSlider){
                    $("#tab-products-details").addClass("sticky-bar");
                    $('#op-pdp__section-carousel').css('padding-top', $('.tab-bar').height() +'px');
                } else {
                    $("#tab-products-details").removeClass("sticky-bar");
                    $('#op-pdp__section-carousel').css('padding-top', '0')
                }
            }

        } else if( st < lastScrollTopMobile) {
            // upscroll code
            if($('#op-pdp__slot5').length > 0){
                if(scroll >= window.productDetailTop && scroll < window.endSlider){
                    $("#tab-products-details").addClass("sticky-bar");
                    $('#op-pdp__section-carousel').css('padding-top', $('.tab-bar').height() +'px');
                } else {
                    $("#tab-products-details").removeClass("sticky-bar");
                    $('#op-pdp__section-carousel').css('padding-top', '0')
                }
            }

            if(st <= window.innerHeight){
                $('#fixed-top--mobile').removeClass('animation-show');
            }
            if(st <= window.heightHiddenActions ){
                $('#op-pdp__slot8').next().css('visibility', 'hidden');
                $('#op-pdp__slot8 .defining-attributes-widget').css('height', 0);
                hideHeaderTimeout.showHeader();
            }
        }
            lastScrollTopMobile = st <= 0 ? 0 : st;
    }

}

function goBackToTopMobile () {
    $(window).scrollTop(0);
    hideHeaderTimeout.showHeader();
}
var startingHeight = window.innerHeight;
var didResize;
var paddingToAdd;

// al resize re-inizializzo le animazioni e se � mobile sistemo la view
$(window).resize( function (){
    if(window.mobilecheck() || window.tabletPortraitCheck())
        didResize = true;
        setInterval(function() {
            if (didResize) {
                didResize = false;
            }
        }, 400);
    }
)

function checkPromoCookie (){
    var promoCookie = getCookie("promoCalloutCookie");
    if (promoCookie == null) {
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            $(' .promo-callout').css('top', $('#header').outerHeight() + 10)
            if (!($("#header").is(":visible"))) $(' .promo-callout-container').show()
        } else  $(' .promo-callout-container').show()
    }
}
function changeIndexMobileOpen(){
    $('.op-pdp__wrapper').css('z-index', '1001');
}
function changeIndexMobileClose(){
    $('.op-pdp__wrapper').css('z-index', '');
}

function printEllipsis (text) {
    var checkForSpace = true;
    var index = 180;

    if(text.length < index) return;
    while (checkForSpace) {
        if(text[index] === " " || index > 300) {
            checkForSpace = false;
            // index = 180;
        } else {
            index++;
        }
    }

    return text.slice(0, index) + "...";
}

function setProductDetailPopup (featuresContainerId) {
        $('#tabAttr').show(); // #tab-presc
        var sourceImage = $('.Image4Feature').val() + "?bg=f8f8fb&impolicy=OV_parameters&wid=2000&cropwest=1000";
        
        if(window.mobilecheck() || window.tabletPortraitCheck()) {
        	//create Product detail table in popup
        	$('<div class="featuresContainer main"><button class="closeButton" id="close-product-details"></button></div>').appendTo($("body")); // #tab-presc
        	$(".featuresContainer.main").append('<div id="featureMenu"></div>');
        	$($('.featuresContainer[id="tab-presc"] .text-content .product-name')[0]).prependTo($('#featureMenu'));
        	$(".featuresContainer.main #featureMenu").append('<div id = "productDetails" class ="featurePopUp"><div class ="titleFeature">' + capitalizeEachWord($('#title-product-details').text()) + '</div><div class="tabContent no-presc"></div></div>');
        }else{
        	//margin if is takumi 
        	if(parseInt($('.descriptive-attributes-widget .left-side').css('width')) < 70){
        		$('#tab-presc .text-content').css('padding-left','60px');
        		$('.view-product-details-container.dsk_pdp').css('padding-left','60px');
        	}
        	$('<div class="featuresContainer main"><button class="closeButton" id="close-product-details">' + closeMessage + '</button></div>').appendTo($("body")); // #tab-presc
        	//create Product detail table in popup
        	$(".featuresContainer.main").append('<div id="featureMenu"><div id="detailImage"></div><div id="detailFeature"></div></div>');
        	$('#featureMenu #detailImage').append("<div feature-number='detailTabImg'>" +
  				  "<img class='lazy' src='/wcsstore/OliverSAS/images/lazyload.png' data-src = '" + sourceImage + "'>" +
  				  "</div>");
        	$($('#featureMenu #detailImage')).after($('.featuresContainer[id="tab-presc"] .text-content .product-name')[0]);
        	$(".featuresContainer.main #featureMenu #detailFeature").append('<div id = "productDetails" class ="featurePopUp"><div class ="titleFeature" feature-number="detailTabImg">' + capitalizeEachWord($('#title-product-details').text()) + '</div><div class="tabContent no-presc"></div></div>');
        }
        
        if((isAccessory && !isClipon && $('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details').length == 0) || (!isAccessory && !isClipon) || isClipon){
        	//if is a product, clipon or case 
        	$($('.featuresContainer[id="tab-presc"] #descriptiveAttributes ul')[0]).appendTo($('.featuresContainer.main #featureMenu #productDetails .tabContent'));
        }else{
        	//if is Accessories
        	$('.descriptive-attributes-widget #productDetail .tabContent.ct-pdp--tab-details  ul').appendTo('.featuresContainer.main #featureMenu #productDetails .tabContent');
        	$('.featuresContainer.main .tabContent').addClass('tabAccessories');
        	$('.featuresContainer.main .tabContent').show();
        }
        

        //  Populate features
        var allFeature;
        var allFeatureImage;
        if(window.mobilecheck() || window.tabletPortraitCheck()) {
        	allFeature = document.querySelectorAll(featuresContainerId+' .product-features');
        }else{
        	allFeature = document.querySelectorAll(featuresContainerId+' .product-features .description');
        	allFeatureImage = document.querySelectorAll(featuresContainerId+' .side img');
        } 
        var allNameFeature = document.querySelectorAll(featuresContainerId+' .product-features h3');
        
        //create all feature voice in popup
        for (var i = 0 ; i < allFeature.length; i++){
        	if(window.mobilecheck() || window.tabletPortraitCheck()) {
        		$(".featuresContainer.main #featureMenu").append('<div id="featureN'+ i + '" class ="featurePopUp"> <div class="titleFeature">' + capitalizeEachWord(allNameFeature[i].getAttribute('data-title')) +'</div></div>' );
        	}else{
        		$(".featuresContainer.main #featureMenu #detailFeature").append('<div id="featureN'+ i + '" class ="featurePopUp"> <div class="titleFeature" feature-number="' + i +'">' + capitalizeEachWord(allNameFeature[i].getAttribute('data-title')) +'</div></div>' );
        		$(".featuresContainer.main #featureMenu #detailImage [feature-number='detailTabImg']").after('<div feature-number="' + i +'"></div>');
        		$(".featuresContainer.main #featureMenu #detailImage [feature-number=" + i + "]").append(allFeatureImage[i].cloneNode(true));
        	}
            
            $("#featureN" + i).append(allFeature[i].cloneNode(true));
            $('#featureN' + i + ' .description-text').after($('#featureN' + i + ' .side.left-side'));
        }
        
        //create package in Popup only if the product has a package 
        if($('.slide-type.front-frame.case .op-pdp__package-image').length > 0){
	        if(window.mobilecheck() || window.tabletPortraitCheck()) {
	        	$(".featuresContainer.main #featureMenu").append('<div id="featureN'+ allFeature.length + '" class ="featurePopUp"><div class ="titleFeature">' + capitalizeEachWord($($('.featuresContainer .tabPack')[0]).text()) + '<div></div>' );
	            $('#featureN'+ allFeature.length).append($('.slide-type.front-frame.case'));
	        }else{
	        	$(".featuresContainer.main #featureMenu #detailFeature").append('<div id="featureN'+ allFeature.length + '" class ="featurePopUp"><div class ="titleFeature" feature-number="' + allFeature.length+ '">' + capitalizeEachWord($('.description.description-packaging h3').text()) + '<div></div>' );
	            $('#featureN'+ allFeature.length).append($('.description.description-packaging'));
	            $('#featureMenu #detailImage').append('<div feature-number="' + allFeature.length +'"></div>');
	            $('#featureMenu #detailImage [feature-number="'+ allFeature.length +'"]').append(document.querySelectorAll('.slide-type.front-frame.case .op-pdp__package-image')[0].cloneNode(true));
	            
	        }  
        }
        $('.featuresContainer.main #featureMenu .descAttributeValue_modelMeasurements').text($('#tabAttr .descAttributeValue_modelMeasurements').text());
        if($(".featurePopUp").length > 0){
            $(".featurePopUp").accordion({
                collapsible: true,
                heightStyle: "content",
                activate: function( event, ui ) {
                    if (ui !== undefined
                            && ui.newPanel.length)  {
                        var panTop = ui.newPanel.offset().top;
                        var panBottom = panTop + ui.newPanel.innerHeight();
                        var isPanelVisible = 0 <= panTop && panBottom <= $(window).innerHeight();
                        if (!isPanelVisible) {
                            $('.featuresContainer.main').animate({ scrollTop: ui.newHeader.offset().top-10 }, 'slow');
                        }
                    }
                }
            });
            $( ".featurePopUp:not(#productDetails)" ).accordion('option', 'active', false);
            $( ".featurePopUp:not(#productDetails)" ).find('.titleFeature').addClass('closed');
            $( ".featurePopUp#productDetails" ).accordion('option', 'active', 0);
            $( ".featurePopUp#productDetails" ).find('.titleFeature').removeClass('closed');
            $('.featuresContainer.main #featureMenu #productDetails .tabContent');
            $('.featuresContainer.main .titleFeature').off('click').on('click',function (e) {
                e.preventDefault();
                //  Prevent from closing the first
                if ($(this).index(".featuresContainer.main .titleFeature") > 0) {
                    $( ".featurePopUp" ).not(this).accordion('option', 'active', false);
                    $( ".featurePopUp" ).not(this).find('.titleFeature').addClass('closed');
                    $($( ".featurePopUp" )[$(this).index(".featuresContainer.main .titleFeature")]).accordion('option', 'active', 0);
                    $($( ".featurePopUp" )[$(this).index(".featuresContainer.main .titleFeature")]).find('.titleFeature').removeClass('closed');
                } else {
                    if ($('.featurePopUp#productDetails [aria-expanded="true"]').length == 0) {
                        $( ".featurePopUp" ).not(this).accordion('option', 'active', false);
                        $( ".featurePopUp" ).not(this).find('.titleFeature').addClass('closed');
                        $($( ".featurePopUp" )[$(this).index(".featuresContainer.main .titleFeature")]).accordion('option', 'active', 0);
                        $($( ".featurePopUp" )[$(this).index(".featuresContainer.main .titleFeature")]).find('.titleFeature').removeClass('closed');
                    }
                }
            });
        }

        $(document).off('click',".view-product-details-container button").on('click',".view-product-details-container button",function(){
            $(".featuresContainer.main").show();
            $('#fixed-top--mobile').removeClass('animation-show');
            manageScrollOverlay(true);
            if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
            	$('body').css('overflow-y','hidden');
            }
        });
 
        $(document).off('click',".featuresContainer.main #close-product-details").on('click',".featuresContainer.main #close-product-details",function(){
            $(".featuresContainer.main").hide();
            $('#fixed-top--mobile').addClass('animation-show');
            manageScrollOverlay(false);
            if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
            	$('body').css('overflow-y','auto');
            	window.scroll(0,$('.defining-attributes-widget').offset().top);
            }
        });
        
        //function to show and hide features image in desktop
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
        	$(document).off('click',$('#featureMenu .titleFeature.ui-accordion-header')).on('click',"#featureMenu .titleFeature.ui-accordion-header",function(){
        		$('#featureMenu #detailImage [feature-number]').hide();
        		$('#featureMenu #detailImage [feature-number="' + $(this).attr('feature-number') +'"]').show();
            });
        }
        //HB-10122
    	try {
            if(($('#descriptiveAttributes .descAttributeValue_modelMeasurements').text() == '' || $('#featureMenu .descAttributeValue_modelMeasurements').text() == '') && productDisplayJS.changedCatEntryId != null && productParent[0] != null){
                updateItemName(productDisplayJS.changedCatEntryId, productParent[0]);
            }
        }catch (error) {
        	console.error('error in updateItemName function');
        	console.error(error);
        }
        
        $('.descriptive-attributes-widget:not(#productDetail)').remove();
}

function packageCloseShow(){
	if($('.tabPack').attr('aria-expanded') == 'false'){
		$('.tabPack').removeAttr('aria-expanded');
		$('.tabPack').attr('aria-expanded','true');
		$('.slide-type.front-frame.case').show();    			
	}else{
		$('.tabPack').removeAttr('aria-expanded');
		$('.tabPack').attr('aria-expanded','false');
		$('.slide-type.front-frame.case').hide();
		$('.tabPack').removeAttr('isOpen');
		if(!$('#nameDetailTab').hasClass('opened') && $('#titleFeature[aria-expanded="true"]').length == 0){
    		$('#nameDetailTab').addClass('opened');
    		$('#nameDetailTab').removeClass('closed');        			 
    		$('#descriptiveAttributes.tabContent ul').show();           				
		}
	} 
}

// ON load risposto al top
window.addEventListener('load',function(){

    /* START - 1st document.ready */

    $(".editorial-espot .btn-container a").click(function(){
        $("#fixed-top--mobile").hide();
        $("#tab-products-details").removeClass('sticky-bar');
        manageScrollOverlay(true);//HB-7545
        $('#draggable-cta-section').css('overflow-y','hidden');
    });
    $(".editorial-espot .close").click(function(){
        $("#tab-products-details").addClass('sticky-bar');
        $("#fixed-top--mobile").show();
        manageScrollOverlay(false);//HB-7545
        $('#draggable-cta-section').css('overflow-y','');
    });

    // if page is pdp on orientation change trigger page reload
    if($('#page').hasClass('pdp')){
        window.addEventListener("orientationchange", function() {
            location.reload();
            }, false);
    }

    var ts;
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        //mostro other color in una posizione per desktop
        $('.presc--body').css('height', window.innerHeight - $('.presc--content header').outerHeight()-$('.presc--content__button').outerHeight()-$('.presc--content__message').outerHeight()-70+'px'); //68
        $('.presc--content__fade').width($('.pdp .presc--content--options label').outerWidth());
        //$('#op-pdp__slot2').after($('#pdp_other_colors'));
        //$('#pdp_other_colors').css('visibility','visible');
        $(document).mousemove(function(e){
            var vertical = e.pageY;
            if(vertical <= 20 && !$('#header').is(":visible") && $('.op-pdp__slot8').hasClass('sticky-bottom')&& !$('.presc').hasClass('showed-presc') && !$('.op-pdp-popup-other-colors').hasClass('active')) {
                $('#header').slideDown("", function(){
                    setHeightFullImage(true)
                });
            }
            if(vertical > 120 && $('#header').is(":visible") && !$(".header__nav-menu").hasClass("opend") && !$("#headerRow1--wrapper").siblings() && !$('.presc').hasClass('.showed-presc') && !$('.op-pdp-popup-other-colors').hasClass('active')) {
                $('#header').slideUp();
                setHeightFullImage(false)
            }
        });

        $('#Prescription_lenses_editorial .side img').height($('#Prescription_lenses_editorial .side').width());

    } else {
        //event for touch mobile

        $(document).bind('touchstart', function (e){
            ts = e.originalEvent.touches[0].clientY;
        });

        $(document).bind('touchend', function (e){
            var te = e.originalEvent.changedTouches[0].clientY;
            if(ts < te-100 &&  !$('[aria-describedby="MiniShopCartProductAdded"]').hasClass('opend') && !$("#vm_box").is(':visible')){
                hideHeaderTimeout.showHeader();
            }
        });
        //move right bage to mantain position
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            $('#right-attributes').appendTo('#op-pdp__slot2').addClass('badge-mobile');
        }
    }
    $('#right-attributes').show();
    //cancel headerHiding on open different stuff
    $('.header__nav-title,  #ci_espot__HeaderStore_Logo a, .icone.lens.masthead, .login--icon, a#widget_minishopcart , div#newsletterClose.newsletter__close').on('focus',function(){
        hideHeaderTimeout.cancel();
    })
    //stop hiding header on hover
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        $('#header').on( 'mouseenter focusin mouseover', function(){
            if($('#page').hasClass('pdp')){
                hideHeaderTimeout.cancel();
            }
        }).on( 'mouseleave', function(){
            if(!($('.header__nav-menu').hasClass('opend') || $('.header--bottom--search').hasClass('opend')  || $('.GlobalLoginWidgetAlt').hasClass('opend')))
            hideHeaderTimeout.setup();
        });
    }

    var zIndexBS = $('.bottom-scrollable-section').css('z-index');
    $('.size-option-selected').on('click',function(e){
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            !$('.size-option-div').is(':visible') ?$('.bottom-scrollable-section').css('z-index', '1001') : null;
            $("html").toggleClass("overflow-hidden");
            $("#page").addClass("hidden-scroll-body");
           // manageScrollOverlay(true);
        } else{
            $('.modal-background').css('display', 'block');
        }

        e.stopPropagation();

        if(!(window.mobilecheck() || window.tabletPortraitCheck() ) && $('.size-option-div').is(':visible')){
            managePopupTabIndex('.size-option-div', true);
            $(window).on('click', function(e){
            	if(!$(event.target).closest('.soldOut').length){
            		if(e.target !== $('.size-option-div')[0] && e.target !== $('.size-option-div li.size-options') 
                            && e.target !== $('.size-option-div .learnMorePanel .icon-description')[0] 
                            && e.target !== $('.size-option-div .learnMorePanel .arrow-icon')[0] 
                            && e.target !== $('.size-option-div .learnMorePanel')[0]){
                                if(!$('#close-size-guide').data('clicked') || !$('.fade-size-guide').data('clicked')) {
                                    $('.modal-background').css('display', 'none');
                                }
                            $('#pdp_other_colors').css('z-index','');
                            //var modelCodeLabel=$(".descriptive-attributes-widget .single-attibutes.7741124012283379873 .attr-value")[0];
                            //var modelCodeLabelPopUp = $("#detailFeature .single-attibutes.7741124012283379873 .attr-value")[0];

                            $(".fade-size-guide").data('clicked', false);
                            $("#close-size-guide").data('clicked', false);

                            /*if($(".size-option-selected").text()!=''){
                                if(typeof modelCodeLabel != 'undefined'){
                                    var sizeSplitted = modelCodeLabel.innerText.trim().split(" ");
                                    var newSize=$(".size-option-selected").text().match(/\(([^)]+)\)/)[1];
                                    var newModelCode = modelCodeLabel.innerText.replace(sizeSplitted[sizeSplitted.length-1],newSize);
                                    modelCodeLabel.innerText = newModelCode;
                                    if(typeof modelCodeLabelPopUp != 'undefined'){
                                    	modelCodeLabelPopUp.innerText = newModelCode;
                                    }
                                }
                            }*/

                            $(window).off( "click");

                        }
            	}
            })

            $('.bottom-scrollable-section').css('z-index', zIndexBS);
            if ($(".cta-bar-container").hasClass("sticky-top")){
                $('#footerWrapper').css("z-index", "1");
            }
            $(document).on("click",".sizeFitPanel .learnMorePanel",function() {
                loadSizeGuideOverlay(this);
            });

            

        }
        
        $(document).off("click", "#view-all-open").on("click", "#view-all-open", function(e) {
            if ($.cookie("isVMOpen") == "1" && !$('#vm_box').hasClass('hide')) {
                if (typeof vmSwitchOff === 'function') {
                    vmSwitchOff(false);
                }
            }
            e.preventDefault();
            togglePopupOtherColors(true);
        });


    $(document).off("click", "#close-other-colors, .op-pdp-popup-other-colors-background").on("click", "#close-other-colors, .op-pdp-popup-other-colors-background", function(e) {
        e.preventDefault();
        togglePopupOtherColors(false);
        //if vm was opened we open it again
        if ($.cookie("isVMOpen") == "1") {
            vmTryThemOn();
        }
    });
        if(window.mobilecheck() || window.tabletPortraitCheck()){
            $('.modal-background').slideDown();
            $('#page-overflow-wrapper').toggleClass('overflow-hidden');
            $('#tab-products-details').removeClass('sticky-bar');
        }
    })

    $('.op-pdp__section-title, .op-pdp__dna-wrapper--phone .op-pdp__dna-title').click(controlPDPDropDown);

    if ($('.op-pdp__section-image-text--responsive').length > 0) {
        $('.op-pdp__section-image-text--responsive').owlCarousel({
            items: 1,
            singleItem: true,
            pagination: true,
            addClassActive: true
        });
    }

    /* END - 1st document.ready */

    /* START - 2nd document.ready */

    /********************************************************************************************************/
    /* This function generates the 6 elements carousel shown at the pdp */
    /********************************************************************************************************/

    $('.owl-custom-lenses--desktop').owlCarousel({
        singleItem: true,
        addClassActive: true,
    });

    $('.owl-custom-lenses--responsive').owlCarousel({
        items: 3,
        itemsTablet: [1024, 3],
        itemsMobile: [479, 3],
        addClassActive: true
    });
    $(".op-pdp__width").fadeIn();

    // BEGIN WCAG - change duplicate ids and aria-labels
    var idMainProductImg = $('.owl-custom-lenses__product--selected img').attr('id');
    $('.owl-custom-lenses__product--selected img').each(function (index) {
        $(this).attr('id', idMainProductImg + '_' + index);
    });

    $('.catalog__link').each(function (index) {
        var idProduct = $(this).attr('id');
        var ariaLabel = $(this).attr('aria-label');
        if (index !== 0) {
            $(this).attr('id', idProduct + "_" + index);
            $(this).attr('aria-label', ariaLabel + "_" + index);
        }
    });
    // END WCAG - change duplicate ids and aria-labels

    /* END - 2nd document.ready */

    /* START - 3rd document.ready */

    wcTopic.subscribe('DefiningAttributes_Resolved', updateItemName);

    //On mouse over the model-color selector...
    $(document).on('mouseenter', '#pdp_other_colors .other-colors-desktop .product:not(.active)', function(e) {

        currentColors = $(".current-product-colors").html();
        var infos = $(this).find(".attr--list span");
        var colorsToPrint = "";
        var colorsToPrintDiv = "<div class='product-color' style='display:none'>";
        var subtitleToPrint = "<div class='sizeAndFitContainer'>";
        isCaseSlide = false;
        $(infos).each(function(index){

            if($(this).hasClass('frameFitSpan')|| $(this).hasClass('geoFitSpan') || $(this).hasClass('polarized-span')) {
                subtitleToPrint += $(this).html();
            }
            if($(this).hasClass('front-color-value')){
                colorsToPrint += $(this).html();
                colorsToPrintDiv +=  $(this).html();
            }else if($(this).hasClass('lens-color-value')){
                colorsToPrint += " /";
                colorsToPrintDiv += " /";
                colorsToPrintDiv += $(this).html();
                colorsToPrintDiv += "</div>";
            }
        })

        if(!colorsToPrintDiv.includes('</div>')){//for eyeglasses 
            colorsToPrintDiv += '</div>'
        }

        if(subtitleToPrint != "<div class='sizeAndFitContainer'>"){//there are no attributes of geo fit frame fit and polarised
            subtitleToPrint += '</div>';
            $(".current-product-colors").html(colorsToPrintDiv + subtitleToPrint );
        }else{
            $(".current-product-colors").html(colorsToPrint);
        }

        //init badge
        if($("#right-attributes .badge-container").length > 0){
            currentBadges = $("#right-attributes .badge-container").html();
            if($(this).find(".badge--list").length > 0){
                var badges = $(this).find(".badge--list").html();
                $("#right-attributes .badge-container").html(badges);
            }
        }
        //finish badge

        var productID =  $(this).find('.catalog__image--front').attr('data-partNumber');

        productID = '/wcs/resources/store/' + WCParamJS.storeId + '/price?q=byPartNumbers&partNumber=' + productID;

        var srcUrl = $(this).find('.catalog__image--front').attr('data-src-hover');
        var imgHover = "<img src='" + srcUrl + "'/>"
        currentImgUrl = $('.full-image-widget .slick-slide.slick-active .pdp-fullimage__img').html();

        if($('.full-image-widget .slick-slide.slick-active .popup_link').hasClass('model')){
            $('.full-image-widget .slick-slide.slick-active .popup_link').removeClass('model');
            $('.full-image-widget .slick-slide.slick-active .popup_link').addClass('had-model');
        }

        $('.full-image-widget .slick-slide.slick-active .pdp-fullimage__img').html(imgHover);

        $.ajax({
            url: productID,
            dataType: "json",
            success: function(data) {
                var priceItem = '';

                if (isEcommerceStoreJS === 'TRUE' /*&& isForSaleJS === 'TRUE'*/
                    && data !== undefined && data.EntitledPrice !== undefined
                    && data.EntitledPrice[0].UnitPrice !== undefined
                    && data.EntitledPrice[0].UnitPrice[0].price !== undefined) {

                    priceItem = data.EntitledPrice[0].UnitPrice[0].price.value;

                    $('.name-part-price-container__price .price__unity').html(WCCurrencyJS.format(priceItem, {"truncDecimals":"true"}));
                } else {
                    // try to restore base price from displayed product
                    var el = $('.name-part-price-container__price .price__unity');
                    var basePrice = $(el).attr('data-base-price');
                    if (isNaN(basePrice)){
                        $('.name-part-price-container__price .price__unity').html(MESSAGE_NO_PRICE_AVAILABLE);
                    }else{
                        $('.name-part-price-container__price .price__unity').html(WCCurrencyJS.format(basePrice, {"truncDecimals":"true"}));
                    }

                }

                if ($('.op-pdp__slot8 .new-releases-attributes').length > 0 && window.newReleasesHeight == undefined) {
                    var $newReleaseAttr = $('.op-pdp__slot8 .new-releases-attributes').first();
                    var newReleasesHeight = $newReleaseAttr.height()
                        + parseInt($('.op-pdp__slot8 .new-releases-attributes').first().css('margin-top').replace(/\px/g, ''))
                        + parseInt($('.op-pdp__slot8 .new-releases-attributes').first().css('margin-bottom').replace(/\px/g, ''))
                        + parseInt($('.op-pdp__slot8 .new-releases-attributes').first().css('padding-top').replace(/\px/g, ''))
                        + parseInt($('.op-pdp__slot8 .new-releases-attributes').first().css('padding-bottom').replace(/\px/g, ''));

                    window.newReleasesHeight = newReleasesHeight;
                }

                if ($('.op-pdp__slot8').hasClass('show-name') && window.productNameHeight == undefined) {
                    window.productNameHeight = $('.op-pdp__slot8.show-name .product_text').height();
                }

                if ($('.op-pdp__slot8').hasClass('show-name') && $('.op-pdp__slot8 .new-releases-attributes').length > 0) {
                    $('.descriptive-attributes__price').css('top', window.newReleasesHeight + window.productNameHeight + 'px;');
                } else if ($('.op-pdp__slot8 .new-releases-attributes').length > 0) {
                    $('.descriptive-attributes__price').css('top', window.newReleasesHeight + 'px;');
                } else if ($('.op-pdp__slot8').hasClass('show-name')) {
                    $('.descriptive-attributes__price').css('top', window.productNameHeight + 'px;');
                }
            },
            error: function() {
                console.log('error');
            }
        });

    });

    $(document).on('mouseleave', '#pdp_other_colors .other-colors-desktop .product:not(.active)', function(e) {

        if($('.full-image-widget .slick-slide.slick-active .popup_link').hasClass('had-model')){
            $('.full-image-widget .slick-slide.slick-active .popup_link').removeClass('had-model');
            $('.full-image-widget .slick-slide.slick-active .popup_link').addClass('model');
        }
        $(".full-image-widget .slick-slide.slick-active .pdp-fullimage__img").html(currentImgUrl);
        $(".current-product-colors").html(currentColors);
        if($("#right-attributes .badge-container").length > 0){
            $("#right-attributes .badge-container").html(currentBadges);
        }
        //restore base price
        var el = $('.name-part-price-container__price .price__unity');
        var prescriptionPrice = $(el).attr('data-prescription-price');
        var basePrice = $(el).attr('data-base-price');

        if (typeof prescriptionPrice !== 'undefined' && prescriptionPrice != ""){
            $(el).html(WCCurrencyJS.format(prescriptionPrice));
        } else{
            if (isNaN(basePrice)){
                $(el).html(MESSAGE_NO_PRICE_AVAILABLE);
            }else{
                $(el).html(WCCurrencyJS.format(basePrice, {"truncDecimals":"true"}));
            }
        }

    });

    /* END - 3rd document.ready */

    /* START - 5th document.ready */

    /*
    $('body')
        .on('mouseenter focusin', '.onHoverTooltip', function() {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var tooltip_to_show_id = aria_describedby.substr(0, aria_describedby.indexOf(" "));
            var $tooltip_to_show = $('#' + tooltip_to_show_id);
            $tooltip_to_show.attr('aria-hidden', 'false');
        })
        .on('focusout', '.onHoverTooltip', function(event) {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var tooltip_to_show_id = aria_describedby.substr(0, aria_describedby.indexOf(" "));
            var $tooltip_to_show = $('#' + tooltip_to_show_id);

            $tooltip_to_show.attr('aria-hidden', 'true');
        })
        .on('mouseleave', '.js-simpletooltip', function() {
            var $this = $(this);
            $this.attr('aria-hidden', 'true');
        })
        .on('keydown', '.onHoverTooltip', function(event) {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var tooltip_to_show_id = aria_describedby.substr(0, aria_describedby.indexOf(" "));
            var $tooltip_to_show = $('#' + tooltip_to_show_id);

            if (event.keyCode == 27) {
                $tooltip_to_show.attr('aria-hidden', 'true');
            }
        });
        */

        $(".onHoverTooltip").off();
        /*For bridge fit section*/
        $(".onHoverTooltip").mouseenter(function() {
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var tooltip_to_show_id = aria_describedby.substr(0, aria_describedby.indexOf(" "));
            var $tooltip_to_show = $('#' + tooltip_to_show_id);
            $tooltip_to_show.attr('aria-hidden', 'false');
            $(this).addClass('onHover');
        })
        .mouseleave(function() {
            $(".js-simpletooltip").attr('aria-hidden', 'true');
            $(this).removeClass('onHover');
        });

        

        $(".onHoverTooltip").on("touchstart", function(){
            if($(".js-simpletooltip").attr('aria-hidden') === 'true'){
                $(".js-simpletooltip").attr('aria-hidden', 'false');
                $(this).addClass('onHover');
            }else{
                $(".js-simpletooltip").attr('aria-hidden', 'true');
                $(this).removeClass('onHover');
            }
        });



        $(document).on("click", function (event) {
            // If the target is not the container or a child of the container, then process
            // the click event for outside of the container.

            if ($(event.target).closest(".onHoverTooltip").length === 0) {
                $(".onHoverTooltip").removeClass("onHover");
            }
        });
        
        /*
        $(".onHoverTooltip").on("click", function(){
            var $this = $(this);
            var aria_describedby = $this.attr('aria-describedby');
            var tooltip_to_show_id = aria_describedby.substr(0, aria_describedby.indexOf(" "));
            var $tooltip_to_show = $('#' + tooltip_to_show_id);

            if($tooltip_to_show.attr('aria-hidden') === 'true'){
                $tooltip_to_show.attr('aria-hidden', 'false');
            }else{
                $tooltip_to_show.attr('aria-hidden', 'true');
            }
        });
        */
    /* END - 5th document.ready */

    /* START - 6th document.ready */

    /**
     * Function that add opend class to minishopcart when add product to cart
     */
    $('#productPageAdd2Cart, #add2CartBtnNavBar:not(.disabled)').on('click',  function() {
        if(checkMobilePdpPage()){
            changeHeaderIndex(true)
        }
        productPageAdd2Cart();
        if(!$('#header').is(':visible'))$('#header').slideDown();
        if($('#page').hasClass('pdp')){
            hideHeaderTimeout.cancel();
        }
    });
    $(document).on('click','.close-button-wrapper', function(){
        $('#page-overflow-wrapper').removeClass('overflow-hidden');
        //if VM was active, we opened vm
        if ($.cookie("isVMOpen") == "1") {
			vmTryThemOn();
		}
        if(checkMobilePdpPage()){
            changeHeaderIndex(false)
        }
    });

    /* END - 6th document.ready */

    /* START - 7th document.ready */

    /*
    var otherColors = $(".catalog-entry-recommendation-widget.pdp_other_colors").children(".catalogEntryRecommendationWidget")
    if(otherColors.length === 0){
        $(".catalog-entry-recommendation-widget.pdp_other_colors, .full-image-widget").addClass("other-colors-empty");
    }
    // keysAttributes[2].toString() ==> producttype;
    if (otherColors.find('.other-colors-desktop .product').length === 1 && typeof attributesMap[keysAttributes[2].toString()] != 'undefined' && attributesMap[keysAttributes[2].toString()].toLowerCase() == 'accessories' && !isClipon){
        $('#pdp_other_colors').css('visibility', 'hidden');
    }
    */

    //black navbar interactions
    animationInit();
    if(window.mobilecheck() || window.tabletPortraitCheck() ){
       // $('#op-pdp__slot8').next().css('visibility', 'hidden')
        createTopRecap();
    }

    $(".minimalist-left-simpletooltip").css("left", $(".options_dropdown_column").width())

    $(".promo-callout .close-icon").click(function(e){
        if(e) e.preventDefault();
        $(".promo-callout").hide();
        setCookie('promoCalloutCookie', true, {expires: 1} )
    })

    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        $('body').on('wheel', function(event) {
            if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20 && $('#op-pdp__slot2').is(":visible") && !$('.presc').hasClass('showed-presc')){
                $('#op-pdp__slot2').slideDown({
                    duration:300,
                    complete:function(){
                            stickyBottomDesktop();
                        }
                    });
            }
        });

        $('body').on('wheel', function(event) {
            if(event.originalEvent.deltaY < 0 && document.documentElement.scrollTop <= 20 && $('#op-pdp__slot2').is(":visible") && !$('.presc').hasClass('showed-presc')){
                hideHeaderTimeout.showHeader();
            }
        });
    }

    /* END - 7th document.ready */

    /* START - 8th document.ready */

    // Move to common js if need scrolldown handled by js on other pages
    $('body').on('click', '.anchor-scroll', function(e){
        var offset = $($(this).attr('href')).offset();
        var scrollTo = offset.top - 150;
        $('html, body').animate({scrollTop: scrollTo}, 0);
        return false;
    });

    $(window).resize( function (){
        if(!(window.mobilecheck() || window.tabletPortraitCheck())) {
            $('#Prescription_lenses_editorial .side img').height($('#Prescription_lenses_editorial .side').width());
        }
    });

    /* END - 8th document.ready */

    /* START - 1st onload */

    setTimeout(function(){
        // scrollTo(0,-1);
        /* check promoCalloutCookie */
        checkPromoCookie();
        if(!soldOutGlobal){
            calculateDistances();
        }
        hideHeaderTimeout.setup();
        handleSwipeBounce();
    },0);

    /* END - 1st onload */

});

function handleProduct(product) {
    $.each($(".op-pdp__product-details img[data-preset], #op-pdp__section-carousel img[data-preset], #featureMenu img[data-preset]"),function(j,feature) {
        try {
            var featNomencl = JSON.parse($(feature).data("nomencl").replaceAll("'","\""));
            var featPreset = $(feature).data("preset");
            var productPartNumber = partNumberFor360;
            var urlFeature = "";
            
                var urlMustCointains1 = ''; //url with priority 1 or 2 or 3
                var urlMustCointains2 = ''; //url with priority 5
                var urlMustCointains3 = ''; //url with priority 4
                
                if(featNomencl[0] == '_shad_fr'){
                    urlMustCointains1 = '_shad__fr';
                    urlMustCointains2 = '_000A';
                    urlMustCointains3 = 'shad_frN';
                }else if(featNomencl[0] == '_shad_qt'){
                    urlMustCointains1 = '_shad__qt';
                    urlMustCointains2 = '030A';
                    urlMustCointains3 = '_shad_qtN';
                }else if(featNomencl[0] == '_090A'){
                    urlMustCointains1 = '_shad__lt';
                    urlMustCointains2 = '_090A';
                    urlMustCointains3 = '_shad_ltN';
                }else if(featNomencl[0] == '_180A'){
                    urlMustCointains1 = '_shad__bk';
                    urlMustCointains2 = '_180A';
                    urlMustCointains3 = '_shad_bkN';
                }
                
                var arrayPriorityNomencl = [];
                var objectPriorityNomencl = {};
                for(var i =0; i < fullList.length; i++){
                    if(fullList[i].includes(urlMustCointains1) && urlMustCointains1 != ''){
                        var objectPriorityNomencl = {};
                        if(fullList[i].includes('VIP')){
                            objectPriorityNomencl['priority'] = '1';
                            objectPriorityNomencl['urlImage'] = fullList[i];
                        }else if(fullList[i].includes('P21')){
                            objectPriorityNomencl['priority'] = '2';
                            objectPriorityNomencl['urlImage'] = fullList[i];
                        }else if(fullList[i].includes('STD')){
                            objectPriorityNomencl['priority'] = '3';
                            objectPriorityNomencl['urlImage'] = fullList[i];
                        }else if(fullList[i].includes('TOP')){
                            objectPriorityNomencl['priority'] = '4';
                            objectPriorityNomencl['urlImage'] = fullList[i];
                        }
                        arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                    }else if(fullList[i].includes(urlMustCointains2) && urlMustCointains2 != ''){
                        var objectPriorityNomencl = {};
                        objectPriorityNomencl['priority'] = '5';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                        arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                    }else if(fullList[i].includes(urlMustCointains3) && urlMustCointains3 != ''){
                        var objectPriorityNomencl = {};
                        objectPriorityNomencl['priority'] = '4';
                        objectPriorityNomencl['urlImage'] = fullList[i];
                        arrayPriorityNomencl[arrayPriorityNomencl.length] = objectPriorityNomencl;
                    }
                }
                if(arrayPriorityNomencl.length == 1){
                    urlFeature= arrayPriorityNomencl[0]['urlImage'] + '?' +featPreset;
                }else{
                    var tmp = arrayPriorityNomencl.map(function(o) {return o.priority;});
                    urlFeature = arrayPriorityNomencl[tmp.indexOf(Math.min.apply(Math, tmp) + '')]['urlImage'] + '?' + featPreset;
                }
                
                $(feature).attr("data-src",urlFeature).attr("alt",$(feature).parent().parent().find(".description h3").text()).removeAttr("data-nomencl").removeAttr("data-preset");
            
        } catch (e) {
            console.error("Error in parsing featNomencl for "+productPartNumber,e);
        }
    });
}

$(document).ready(function() {

    if($("a[id='add2CartBtnNavBar']:not(:nth-child(1))").length>1){
    	$("a[id='add2CartBtnNavBar']:not(:nth-child(1))").remove();
    }

});  

/*For size section*/
$(".info-icon.size:not(.mobile)").mouseenter(function() {
   $(this).addClass("onHover");
   $(".infoMessage_popup.size:not(.mobile)").show();
  })
  .mouseleave(function() {
    $(this).removeClass("onHover");
    $(".infoMessage_popup.size:not(.mobile)").hide();
}).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.size:not(.mobile)").hide();
});

/*size section mobile*/
$(".info-icon.mobile.size").click(function() {
    if($(this).hasClass("onHover")){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.mobile.size").hide();
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.mobile.size").show();
    } 
});

/*For prescription section*/
  $(".info-icon.prescription:not(.mobile)").mouseenter(function(){
    $(this).addClass("onHover");
    $(".infoMessage_popup.prescription:not(.mobile)").show();
}).mouseleave(function() {
    $(this).removeClass("onHover");
    $(".infoMessage_popup.prescription:not(.mobile)").hide();
}).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.prescription:not(.mobile)").hide();
});

/*prescription section mobile*/
$(".info-icon.mobile.prescription").click(function() {
    if($(this).hasClass("onHover")){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.mobile.prescription").hide();
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.mobile.prescription").show();
    }
});


   
/*For sun-clip section*/
$(".info-icon.sun-clip:not(.mobile)").mouseenter(function() {
    $(this).addClass("onHover");
    $(".infoMessage_popup.sun-clip:not(.mobile)").show();
}).mouseleave(function() {
     $(this).removeClass("onHover");
     $(".infoMessage_popup.sun-clip:not(.mobile)").hide();
}).click(function(){
    $(this).removeClass("onHover");
    $(".infoMessage_popup.sun-clip:not(.mobile)").hide();
});

/*sun-clip section mobile*/
$(".info-icon.mobile.sun-clip").click(function() {
    if($(this).hasClass("onHover")){
        $(this).removeClass("onHover");
        $(".infoMessage_popup.mobile.sun-clip").hide();
    }else{
        $(this).addClass("onHover");
        $(".infoMessage_popup.mobile.sun-clip").show();
    }
});





 //hide the infomessage popup for mobile
 $(document).on("click", function (event) {
    // If the target is not the container or a child of the container, then process
    // the click event for outside of the container.
    if ($(event.target).closest("span.info-icon.mobile").length === 0) {
        $("span.info-icon.mobile").removeClass("onHover");
        $(".infoMessage_popup.mobile").hide();
    }
});



var OPStoriesOwlData;

$(document).ready(function(){
    var op_stories_owl = $("#owl-op-stories");
    op_stories_owl.owlCarousel({
        items : 4, //4 items above 1000px browser width
        itemsDesktop : [1000,5], //5 items between 1000px and 901px
        itemsDesktopSmall : [900,3], // betweem 900px and 601px
        itemsTablet: [600,2], //2 items between 600 and 0
        itemsMobile : false, // itemsMobile disabled - inherit from itemsTablet option
        addClassActive: true,
        lazyLoad: true,
        //navigation: true,
        //navigationText : [$('.header__nav-menu__opstories__arrow.left'),$('.header__nav-menu__opstories__arrow.right')]
    });
    OPStoriesOwlData = $("#owl-op-stories").data('owlCarousel');

    $(".header__nav-menu__opstories__arrow.left").click(function() {
        op_stories_owl.trigger('owl.next');

        if ($('#owl-op-stories .owl-item').first().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        }
    });
    $(".header__nav-menu__opstories__arrow.right").click(function() {
        op_stories_owl.trigger('owl.prev');

        if ($('#owl-op-stories .owl-item').last().hasClass('active')) {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", true);
            $(".header__nav-menu__opstories__arrow.left").prop("disabled", false);
        } else {
            $(".header__nav-menu__opstories__arrow.right").prop("disabled", false);
        }
    });
     
});


function destroyCarousel() {
    OPStoriesOwlData.destroyControls();
}

function buildCarousel() {
    OPStoriesOwlData.buildControls();
}

function goToCarouselCard(cardNumber) {
    OPStoriesOwlData.goTo(cardNumber);
}


/*start store-pdp-clipon.js
* this file was created for PDP_W2 Project
*/


/*
 * add to fade for clipon function to close popup
 */
$('.fade-clipon').on("click",function() {
	unfreezeWindowForOverlay($(this).attr('class'));
	$('#popup-clipon-section').hide();
});


/*
 * Function to open clipon popup
 */
function openPopupClipon(){
	$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+$('#popup-clipon-section .product-clip-on.selected').attr('catentryclip')+'] .slick-dots li').first().children().click();
	$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+$('#popup-clipon-section .product-clip-on.selected').attr('catentryclip')+'] .currentNumber').text('1');
	freezeWindowForOverlay();
	$('#popup-clipon-section').show();
	$("#popup-clipon-section .container-info-clipon").scrollTop(0);
	$('#popup-clipon-section .clipon-main-carousel').slick('refresh');
}


/*
 * function to manage and initialize popup and below clipon section
 */
function manageCliponSection(){
	
	for(var i = 0; i < $('.options_dropdown_column input').not('.modelSizeAttribute').length; i++){
		var frameSize =  $($('.options_dropdown_column input').not('.modelSizeAttribute')[i]).attr('value-en') + '|' + $($('.options_dropdown_column input').not('.modelSizeAttribute')[i]).attr('modelSizeAttribute');
		mapSizeFrameClip[frameSize] =  {};
	}
	
	var clipCatentry = [];
	
	for( var i = 0; i < clipOnAssoc.length; i++){
		/*
		 * With this For loop we enhance the json Object arrayOfClip
		 * with the data we have in clipOnAssoc (this variable is enhance PDP_Accessories.jsp)
		 */
		var frontColorValueClip = "";
		var lensColorValueClip = "";
		var isPolarizedClip = false;
		var modelNameValueClip = "";
		var madeInValueClip = "";
		var isLimitedEditionClip = false;
		var isExclusiveClip = false;
		var isNewReleaseClip = false;
		var isPreorderable = false;
		
		var jsonOfClip = clipOnAssoc[i]; 
		var catentryProductBean = jsonOfClip.uniqueID;
		clipCatentry.push(jsonOfClip.uniqueID);
		
		for( var j = 0; j < jsonOfClip.attributes.length; j++){
			if(jsonOfClip.attributes[j].identifier === 'MODELNAME' && jsonOfClip.attributes[j].usage === 'Descriptive' ) modelNameValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'FRONT_COLOR' && jsonOfClip.attributes[j].usage === 'Descriptive' )
            	frontColorValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'LENS_COLOR' && jsonOfClip.attributes[j].usage === 'Descriptive' ) lensColorValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'MADEIN' && jsonOfClip.attributes[j].usage === 'Descriptive' ) madeInValueClip = jsonOfClip.attributes[j].values[0].value;
            if(jsonOfClip.attributes[j].identifier === 'LIMITED_EDITION' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isLimitedEditionClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'EXCLUSIVE' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isExclusiveClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'NEWRELEASES' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isNewReleaseClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
            if(jsonOfClip.attributes[j].identifier === 'POLARIZED' && jsonOfClip.attributes[j].usage === 'Descriptive' ) isPolarizedClip = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
			if(isPreOrderActive && jsonOfClip.attributes[j].identifier === 'PREORDER' && jsonOfClip.attributes[j].usage === 'Descriptive' )  isPreorderable = checkIsTrue(jsonOfClip.attributes[j].values[0].value);
		}  
		
		var skus = {};
		for( var j = 0; j < jsonOfClip.sKUs.length; j++){
			skus[jsonOfClip.sKUs[j].uniqueID] = {};
			clipCatentry.push(jsonOfClip.sKUs[j].uniqueID);
		}
		
		var currentClipon = {
			baseUrl: WCParamJS.homePageURL,
			uniqueID: catentryProductBean,
			partnumber: jsonOfClip.partNumber.replaceAll('_','-'),
			thumbnail: jsonOfClip.thumbnail.split('?')[0],
		    modelName: modelNameValueClip,
		    madeIn: madeInValueClip,
		    isNewRelease: isNewReleaseClip,
		    isExclusive: isExclusiveClip,
		    isLimited: isLimitedEditionClip,
		    isPolarized: isPolarizedClip,
		    frontColor_lensColor: frontColorValueClip + " / " +lensColorValueClip,
			skus: skus,
			isPreorderable : isPreorderable
		}
		
		arrayOfClip[catentryProductBean] = currentClipon;
	
	}
	
	
	var urlNew = (isInToolkit ? '' : WCParamJS.homePageURL) + '/search/resources/store/' + WCParamJS.storeId + '/productview/byIds?' + 'id=' + clipCatentry.join('&id=') + "&storeId=" + WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId + "&responseFormat=json&langId=" + WCParamJS.langId + "&currency=" + WCParamJS.commandContextCurrency + (isPersol && window.customerSegment != undefined ? '&customerSegment=' + customerSegment : '')  + "&profileName=LUX_findProductByIds_Inventory&isForClip=true&isForInventory=true";
	var carouselOfClip = {};
	var htmlForOtherColors = {};
	
	promiseForClip(urlNew).then(function (data) {
		data.catalogEntryView.forEach(function(catentryIndex){
    		/* In this forEach we take:
    		 * Price for every itemBean 
    		 * Ranking for all products
    		 * Manifest for all Product Bean
    		 */
			try{
				if(catentryIndex.catalogEntryTypeCode === 'ProductBean'){
	    			if(catentryIndex.inventory.ranking != 2){
	    				delete arrayOfClip[catentryIndex.uniqueID];
	    			}else{
	    				var imageForCarouselClipon = [];
	    				var htmlForCarousel = '<div class="container-carousel-and-arrow" catentryClip="' + catentryIndex.uniqueID +'"><div class="clipon-main-carousel carousel-clip_' + catentryIndex.uniqueID +'" catentryClip="' + catentryIndex.uniqueID +'">'
	    				catentryIndex.manifest.payload.images.forEach(function(imageCarouselClipon){
	    					if( imageCarouselClipon.usage == "PDP Carousel"){
	    						imageForCarouselClipon.push(imageCarouselClipon);
	    						htmlForCarousel = htmlForCarousel + '<img class = "lazy" src="'+ lazyLoadImg +'" data-src="'+ imageCarouselClipon.path +'" alt="image of clipon">';
	    					}
	    					
	    				});
	    				htmlForCarousel = htmlForCarousel + '</div><div class="container-clipon-control-and-counter" role="region"><div class="container-control-clipon"><div class="control-clipon slick-controls-clipon_'+catentryIndex.uniqueID+'"></div></div><div class="slick-slider-number slick__'+catentryIndex.uniqueID+'"><span class="currentNumber"></span><span class="divider">/</span><span class="totalNumber"></span></div></div></div>';
	    				
	    				carouselOfClip[catentryIndex.uniqueID] = htmlForCarousel;
	    				arrayOfClip[catentryIndex.uniqueID]['manifest'] = imageForCarouselClipon;
	    				
	    				var templateOtherColorsHtml = $('#otherColorsClipTemplate').html();
	    				htmlForOtherColors[catentryIndex.uniqueID] =  Mustache.to_html(templateOtherColorsHtml, arrayOfClip[catentryIndex.uniqueID]);
	    			}
	    		}else{
	    			if(catentryIndex.inventory.ranking != 2){
	    				delete arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID];
	    			}else{
	    				var listpriceClip;
	    				if(isOliver){
	    					arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['price'] = WCCurrencyJS.format(catentryIndex.price.price, {"truncDecimals":"true"});
	    					catentryIndex.price.price == catentryIndex.price.listprice ? listpriceClip =  '' : listpriceClip = WCCurrencyJS.format( catentryIndex.price.listprice, {"truncDecimals":"true"});
	    				} else {
	    					arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['price'] = WCCurrencyJS.format(catentryIndex.price.price);
	    					catentryIndex.price.price == catentryIndex.price.listprice ? listpriceClip =  '' : listpriceClip = WCCurrencyJS.format( catentryIndex.price.listprice);
	    				}
	    				
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['priceForKlarna'] = formatCurrency(catentryIndex.price.price.split('.')[0]).replace('.','');
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['listprice'] = listpriceClip;
	    				arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['partnumber'] = catentryIndex.partNumber;
	    				
	    				catentryIndex.attributes.forEach(function(attribute){
	    					if(attribute.identifier == 'MODEL_SIZE') arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size'] = attribute.values[0].value;
	    					if(attribute.identifier == 'MODEL_SIZE_DISPLAY' ) arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size_display'] = attribute.values[0].value;
	    				});
	    				
	    				var clipSize = arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size_display'] + '|' + arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID]['model_size']
	    				if(mapSizeFrameClip[clipSize] != undefined){
	    					mapSizeFrameClip[clipSize][catentryIndex.parentCatalogEntryID] = catentryIndex.uniqueID;
	    				}else{
	    					delete arrayOfClip[catentryIndex.parentCatalogEntryID]['skus'][catentryIndex.uniqueID];
	    				}
	    			}
	    		}
			}catch(err) {
				console.log(err.message);
			}
    	});   	
    	
    	/* Inizialize the clipon section (Popup and Below section) 
         */
		

    	var templateBarHtml = null;
		if(window.mobilecheck() || window.tabletPortraitCheck()){
			templateBarHtml = $('#cliponSectionTemplateMobile').html();
		}else{
			templateBarHtml = $('#cliponSectionTemplateDesktop').html();
		}
    	//Initialize template with the first clip with the size selected
    	var sizeSelectedOfFrame = $('.size-option.selected').attr('data-option') + '|' + $('.size-option.selected').attr('model-size');
    	var catentryMocoClipSelected = null; // = Object.keys(mapSizeFrameClip[sizeSelectedOfFrame])[0];
    	var catentryUPCClipSelected = null;// = mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(mapSizeFrameClip[sizeSelectedOfFrame])[0]]
    	var existOneClipOn = false;
    	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
    		if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] != undefined){
    			catentryMocoClipSelected = Object.keys(arrayOfClip)[i];
    			catentryUPCClipSelected = mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]];
    			break;
    		}
    	}
		//Check if almost one size have one clip-on
    	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
			if(JSON.stringify(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]]) != undefined && JSON.stringify(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]])  !=  '{}'){
				existOneClipOn = true;
				break;
			}
		}

    	if(catentryMocoClipSelected == null ){
    		for(var i = 0; i< Object.keys(mapSizeFrameClip).length; i++){
    			if(catentryMocoClipSelected == null ){
    				for(var j = 0; j< Object.keys(arrayOfClip).length; j++){
    					if(mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]][Object.keys(arrayOfClip)[j]] != undefined){
    						catentryMocoClipSelected = Object.keys(arrayOfClip)[j];
    						catentryUPCClipSelected = mapSizeFrameClip[Object.keys(mapSizeFrameClip)[i]][Object.keys(arrayOfClip)[j]];
    						break;
    					}
    				}
    			}else{
    				break;
    			}
    		}
    		if(existOneClipOn){
				//BEGIN FIX HB-13132
				$('.clip-not-avaible').show();
				$('#accessory--underlined--link').addClass('cursor-not-allow');
				$('.accessory--underlined--link--name').addClass('cursor-not-allow');
				$('.accessory--underlined--link--icon').addClass('cursor-not-allow');
				$('.accessory--side--button--link').addClass('cursor-not-allow');
				var typeOfText = null;
				if(WCParamJS.langId == '-1'){
					typeOfText = 'small-text';
				}else{
					typeOfText = 'text-two-row';
				}
				$('#accessory--button-container').addClass(typeOfText);
				$('#accessory--side--button').addClass(typeOfText);
				$('#accessory--underlined--link').addClass(typeOfText);
				$('.clip-not-avaible').addClass(typeOfText);
				if(isOliver && !(window.tabletPortraitCheck() || window.mobilecheck())){
					$('#op-pdp__slot8').addClass(typeOfText);
				}else if(isPersol){
					$('#pdp_bottom-section').addClass(typeOfText);
					$('.monogram-value-container').addClass(typeOfText);
				}
				//END FIX HB-13132
			}else{
				$('#accessory--button-container').hide();
				$('#below-clipon-section').hide();
			}
    		
    	}
    	
    	var firstClip = JSON.parse(JSON.stringify(arrayOfClip[catentryMocoClipSelected]));
    	firstClip['price'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].price;
    	firstClip['listPrice'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].listprice;
    	firstClip['priceForKlarna'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].priceForKlarna;
    	firstClip['skuPartnumber'] = arrayOfClip[catentryMocoClipSelected]['skus'][catentryUPCClipSelected].partnumber;
    	
		html = Mustache.to_html(templateBarHtml, firstClip);
		$('#below-clipon-section').append(html);
		$('#popup-clipon-section').append(html);
		$('#current-clipon-catentry').attr('value', catentryUPCClipSelected);
		
		$('.size-clipon').text($('.size-option-selected .hinge-distance').text());
		$('#below-clipon-section .container-clipon-badge').find("p:visible:last").addClass('last-showed');
		$('#popup-clipon-section .container-clipon-badge.madein-section p.showed:last-child').addClass('last-showed');
		$('#popup-clipon-section .container-clipon-badge').not('.madein-section').find('p.showed:last').addClass('last-showed');
		/*
		 * Add Function at close image in popup
		 */
		$('.close-image').on('click', function() {
			unfreezeWindowForOverlay($('.fade-clipon').attr('class'));
			$('#popup-clipon-section').hide();
		});
		
		var tileToHide = [];
		
		for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
			
			/*
			 * For each element in arrayOfClip we must create the carousel. this is the scope of this for Loop
			 */
			
			$('.container-image-clipon').append(carouselOfClip[Object.keys(arrayOfClip)[i]]);
			$('.clipon-other-colors').append(htmlForOtherColors[Object.keys(arrayOfClip)[i]]);
			
			/*
			 * Add an event listener in slick clip's main carousel:
			 * when change the the image of carousel the counter of image increase
			 */
			
			$('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('init', function(event, slick) {
			    $('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		        $('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .totalNumber').text(slick.slideCount);
		    });
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('init', function(event, slick) {
			    $('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		        $('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .totalNumber').text(slick.slideCount);
		    });
			
			
			/*
			 * we inizialize for each clip the slick carousel in popup and below section
			 */
			
			$('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').slick({
	    		infinite: true,
	    	    slidesToShow: 1,
	    	    slidesToScroll: 1,
	    	    speed: 200,
	    	    dots: true,
	    	    appendArrows: $('#below-clipon-section .slick-controls-clipon_'+Object.keys(arrayOfClip)[i])
	    	});
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').slick({
	    		infinite: true,
	    	    slidesToShow: 1,
	    	    slidesToScroll: 1,
	    	    speed: 200,
	    	    dots: true,
	    	    appendArrows: $('#popup-clipon-section .slick-controls-clipon_'+Object.keys(arrayOfClip)[i])
	    	});
			
			if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] == undefined){
				tileToHide.push(Object.keys(arrayOfClip)[i]);
			}
			
			$('.container-carousel-and-arrow:not([catentryClip='+catentryMocoClipSelected+'])').hide();
			$('.container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+']').show();
			$('.container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+'] .clipon-main-carousel').slick('refresh');
			if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
				reduceCircleCarouselClip('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryMocoClipSelected+'] .clipon-main-carousel .slick-dots');
			}
			
			/*
			 * Add an event listener in slick clip's main carousel:
			 * when change the the image of carousel the counter of image increase
			 */
			
			$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('afterChange', function(event, slick) {
		    	
		    	if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
		    		reduceCircleCarouselClip(this);
		    	}else{
		    		$('#popup-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		    	}
			});
			
		    $('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('afterChange', function(event, slick) {
		    	if((window.tabletPortraitCheck() || window.mobilecheck()) && isOliver){
		    		reduceCircleCarouselClip(this);
		    	}else{
		    		$('#below-clipon-section .slick-slider-number.slick__'+  $(this).attr('catentryclip') + ' .currentNumber').text(slick.currentSlide + 1);
		    	}
		    });
		    
		    /*if(window.tabletPortraitCheck() || window.mobilecheck()){
		    	$('#popup-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('beforeChange', function(event, slick) {
			    	$('#current-clipon-catentry').attr('popupLastChangedCarousel',$($(this).find('.slick-dots')).children('.slick-active').index());
				});
				
			    $('#below-clipon-section .clipon-main-carousel[catentryclip='+  Object.keys(arrayOfClip)[i] +']').on('beforeChange', function(event, slick) {
			    	$('#current-clipon-catentry').attr('belowLastChangedCarousel',$($(this).find('.slick-dots')).children('.slick-active').index());
			    });
		    }*/
		}
		$('.product-clip-on[catentryclip="'+catentryMocoClipSelected+'"]').addClass('selected');
		
    	for(var i = 0; i < tileToHide.length; i++ ){
    		$('.product-clip-on[catentryclip=' +tileToHide[i] + ']').addClass('hidden');	
    	}
    	
    	/*
    	 * Referesh Klarna message for the price
    	 */
    	window.Klarna.OnsiteMessaging.refresh();
    	
    	/*
    	 * Function to switch CliponInformation
    	 */
    	$('.product-clip-on').on('click', function(){
    		var catentryId = $(this).attr('catentryClip');
    		var catentryIdChild  = null, selectedClipPrice  = null, selectedClipPriceList  = null, selectedClipPriceKlarna, selectedPartnumber = null;
    		var frameModelSizeDisplay = $('.size-option.selected').attr('data-option');
    		var frameModelSize = $('.size-option.selected').attr('model-size');
    		for(var i = 0; i< Object.keys(arrayOfClip[catentryId].skus).length; i++){
    			catentryIdChild = Object.keys(arrayOfClip[catentryId].skus)[i];
    			if(arrayOfClip[catentryId].skus[catentryIdChild].model_size_display == frameModelSizeDisplay && arrayOfClip[catentryId].skus[catentryIdChild].model_size == frameModelSize ){
    				selectedClipPrice = arrayOfClip[catentryId].skus[catentryIdChild].price;
    				selectedClipPriceList = arrayOfClip[catentryId].skus[catentryIdChild].listprice;
    				selectedClipPriceKlarna = arrayOfClip[catentryId].skus[catentryIdChild].priceForKlarna;
    				selectedPartnumber = arrayOfClip[catentryId].skus[catentryIdChild].partnumber;
    				break;
    			}else{
    				catentryIdChild = null;
    			}
    		}
    		if($(this).parents().hasClass('popup-class')){
    			$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .slick-dots li').first().children().click();
    			$('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .currentNumber').text('1');
    		}else if($(this).parents().hasClass('below-class')){
    			$('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .slick-dots li').first().children().click();
    			$('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .currentNumber').text('1');
    		}
    		
    		//change item selected and Change Main Info of Clip
    		$('.product-clip-on').removeClass('selected');
    		$('.product-clip-on[catentryClip='+catentryId+']').addClass('selected');
    		$('.container-carousel-and-arrow:not([catentryClip='+catentryId+'])').hide();
    		$('.container-carousel-and-arrow[catentryClip='+catentryId+']').show();
    		$('.container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel').slick('refresh');
    		$('.clipon-name').text(arrayOfClip[catentryId].modelName);
			$('.color-clipon-text').text(arrayOfClip[catentryId].frontColor_lensColor);
			
			//change link in viewdetails
			$('.clipon-view-details a').attr('href', WCParamJS.homePageURL + '/' + arrayOfClip[catentryId].partnumber)
			
			//show - hide badge of current clipon
			arrayOfClip[catentryId].isPolarized == true ? $('p.badge-text-polarized').addClass('showed') : $('p.badge-text-polarized').removeClass('showed');
			arrayOfClip[catentryId].isLimited == true ? $('p.limited-edition').addClass('showed') : $('p.limited-edition').removeClass('showed');
			arrayOfClip[catentryId].isNewRelease == true ? $('p.new-badge').addClass('showed'): $('p.new-badge').removeClass('showed');
			arrayOfClip[catentryId].isExclusive == true ? $('p.exclusive').addClass('showed') : $('p.exclusive').removeClass('showed');	
			if(arrayOfClip[catentryId].madeIn != ''){
				$('p.made-in-badge').addClass('showed');
				$('p.made-in-badge .made-in-state').text(arrayOfClip[catentryId].madeIn);
			}else{
				$('p.made-in-badge').removeClass('showed');
				$('p.made-in-badge .made-in-state').text('');
			}
			$('.container-clipon-badge>p.last-showed').removeClass('last-showed');
			$('#below-clipon-section .container-clipon-badge').find("p:visible:last").addClass('last-showed');
			$('#popup-clipon-section .container-clipon-badge.madein-section p.showed:last-child').addClass('last-showed');
			$('#popup-clipon-section .container-clipon-badge').not('.madein-section').find('p.showed:last').addClass('last-showed');
			
			
			//Change info Price
			$('.clipon-offer-price').text(selectedClipPrice);
			$('.clipon-list-price').text(selectedClipPriceList!= '' ? selectedClipPriceList : '' );
			$('.container-clip-on [data-element-id="X_X_Prod_KlarnaInfo"] [data-key="credit-promotion-auto-size"]').attr('data-purchase-amount', selectedClipPriceKlarna);
			window.Klarna.OnsiteMessaging.refresh();
			
			//Change clip to add in cart
			$('#current-clipon-catentry').attr('value', catentryIdChild);
			
			//change data-description for Tealium 
			$('.addCart').attr('data-description',selectedPartnumber);
			
			if(isOliver && (window.tabletPortraitCheck() || window.mobilecheck())){
				reduceCircleCarouselClip('#below-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel .slick-dots');
				reduceCircleCarouselClip('#popup-clipon-section .container-carousel-and-arrow[catentryClip='+catentryId+'] .clipon-main-carousel .slick-dots');
			}
    	});
	});
	
}

/*
 * this function is called in button of clipon sections add to cart 
 * */
function cliponAddToBag(){
	
	if (isPersol && currentProductIsMonogram) {
        cleanFieldsMonogram();
        $('.shopperActions--monogram--new, #contentWrapper.pageContent .estimated .estimated-monogram').removeClass('show');
        $('.shopperActions--monogram--added, #contentWrapper.pageContent .estimated .estimated-normal').removeClass('show');
        currentProductIsMonogram = false;
    }
	
	if ($('#popup-clipon-section').is(":visible")){
		unfreezeWindowForOverlay($('.fade-clipon').attr('class'));
		$('#popup-clipon-section').hide();
	}
	
	lockShoppingBagIcon();
    setCurrentId("add2CartBtn");
    resetRequest();
    if( $('#page').hasClass('pdp') && (brandCode == 'PO' || brandCode == 'OP')){
    	//close VM if is opened
    	if (!($('#vm_box').hasClass('hide'))){
    		if (typeof vmSwitchOff === 'function') {
    	    	vmSwitchOff(true);
    	    }
    	}
        hideHeaderTimeout.cancel();
        if((window.mobilecheck() || window.tabletPortraitCheck())){
           changeHeaderIndex(true)
        }
    }
	
    $('#current-clipon-catentry').attr('isAdded','true');
	productDisplayJS.AddItem2ShopCartAjax($('#current-clipon-catentry').attr('value'), '1',undefined, $('#current-clipon-catentry').attr('value'));
	productPageAdd2Cart();
}

function promiseForClip(callUrl) {
	return new Promise((resolve, reject) => {
		$.ajax({
	    	url: callUrl,
	    	type: 'GET',
	        async: true,
	    	success: function (data) {
	    		resolve(data)
	    	},
	    	error: function (error) {
	    		reject(error)
	    	},
	    })
	});
}

function changeSizeOfClip(){
	var sizeSelectedOfFrame = $('.size-option.selected').attr('data-option') + '|' + $('.size-option.selected').attr('model-size');
	var currentClipon = $('.product-clip-on.selected').attr('catentryclip');
	
	$('.size-clipon').text($('.size-option-selected .hinge-distance').text());
	if(mapSizeFrameClip[sizeSelectedOfFrame][currentClipon] != undefined){
		$('#current-clipon-catentry').attr('value', mapSizeFrameClip[sizeSelectedOfFrame][currentClipon]);
		$('.addCart').attr('data-description', arrayOfClip[currentClipon]['skus'][mapSizeFrameClip[sizeSelectedOfFrame][currentClipon]]['partnumber']);		
	}else{
		$('.product-clip-on.selected').removeClass('selected');
	}
	
	//BEGIN FIX HB-13132
	if(Object.keys(mapSizeFrameClip[sizeSelectedOfFrame]).length == 0 && $('#accessory--button-container').is(":visible")){
		$('.clip-not-avaible').show(); 
		$('#accessory--underlined--link').addClass('cursor-not-allow');
		$('.accessory--underlined--link--name').addClass('cursor-not-allow');
		$('.accessory--underlined--link--icon').addClass('cursor-not-allow');
		$('.accessory--side--button--link').addClass('cursor-not-allow');  
		$('#below-clipon-section').hide();
		var typeOfText = null;
		if(WCParamJS.langId == '-1'){
			typeOfText = 'small-text';
		}else{
			typeOfText = 'text-two-row';
		}
		$('#accessory--button-container').addClass(typeOfText);
		$('#accessory--side--button').addClass(typeOfText);
		$('#accessory--underlined--link').addClass(typeOfText);
		$('.clip-not-avaible').addClass(typeOfText);
		if(isOliver && !(window.tabletPortraitCheck() || window.mobilecheck())){
			$('#op-pdp__slot8').addClass(typeOfText);
		}else if(isPersol){
			$('#pdp_bottom-section').addClass(typeOfText);
			$('.monogram-value-container').addClass(typeOfText);
		}
	}else if(Object.keys(mapSizeFrameClip[sizeSelectedOfFrame]).length > 0 && $('.clip-not-avaible').is(":visible")){
		$('.clip-not-avaible').hide();
		//BEGIN FIX HB-13132
		$('#accessory--underlined--link').removeClass('cursor-not-allow');
		$('.accessory--underlined--link--name').removeClass('cursor-not-allow');
		$('.accessory--underlined--link--icon').removeClass('cursor-not-allow');
		$('.accessory--side--button--link').removeClass('cursor-not-allow');
		$('#below-clipon-section').show();
	    $('#accessory--button-container').show();
	    var typeOfText = null;
		if(WCParamJS.langId == '-1'){
			typeOfText = 'small-text';
		}else{
			typeOfText = 'text-two-row';
		}
		$('#accessory--button-container').removeClass(typeOfText);
		$('#accessory--side--button').removeClass(typeOfText);
		$('#accessory--underlined--link').removeClass(typeOfText);
		$('.clip-not-avaible').removeClass(typeOfText);
		if(isOliver){
			$('#op-pdp__slot8').removeClass(typeOfText);
		}else if(isPersol){
			$('#pdp_bottom-section').removeClass(typeOfText);
			$('.monogram-value-container').removeClass(typeOfText);
		}
		//END FIX HB-13132
	}
	//END FIX HB-13132
	for(var i = 0; i< Object.keys(arrayOfClip).length; i++){
		if(mapSizeFrameClip[sizeSelectedOfFrame][Object.keys(arrayOfClip)[i]] != undefined){
			$('.product-clip-on[catentryclip=' + Object.keys(arrayOfClip)[i] + ']').removeClass('hidden');
			if($('.product-clip-on.selected').length == 0){
				$('.product-clip-on[catentryclip="'+ Object.keys(arrayOfClip)[i] +'"]').click();
			}
		}else{
			$('.product-clip-on[catentryclip=' + Object.keys(arrayOfClip)[i] + ']').addClass('hidden');
		}		
	}
	
}

function showCTAloaderClip(){
	$('.container-clip-on .addCart .bag-icon').hide();
    $('.container-clip-on .addCart .loadpanel_loader').css("display","inline-block");

}

function hideCTAloaderClip(){
	$('.container-clip-on .addCart .bag-icon').show();
    $('.container-clip-on .addCart .loadpanel_loader').hide();

}

function reduceCircleCarouselClip(carousel){
	if((window.mobilecheck() || window.tabletPortraitCheck()) && isOliver){
		var dots = $(carousel).find('li');
	    dots.show();
	    
	    dots.removeClass("semi-reduced").removeClass("normal");
	    var indexActive =  $(carousel).find('li.slick-active').index();
	    
	    if(indexActive < 3){
	    	dots.eq(0).addClass("normal");
	        dots.eq(1).addClass("normal");
	        dots.eq(2).addClass("normal");
	        dots.eq(3).addClass("semi-reduced");

	        //when at the beginning of the carousel show only 5 dots
	        for (i = 5; i < dots.length; i++){
	        	dots.eq(i).hide();
	        }
	    } else {
	    	if(indexActive === dots.length - 1){
	            //when at the end of the carousel show only 5 dots
		        for (i = dots.length - 5; i > 0; i--){
		        	dots.eq(i).hide();
		        }
	    	}else if(indexActive === dots.length - 2){
	            //before the end of the carousel show 6 dots
	              for (i = dots.length - 6; i > 0; i--){
	                dots.eq(i).hide();
	              }
	    	}else if (indexActive === 3) {
	            //when at the fourth position show only 5 dots
	    		for (i = 6; i < dots.length; i++){
	              dots.eq(i).hide();
	            }
	    	} else if (indexActive > 3){

	        	for (i = indexActive + 3; i < dots.length; i++){
	            	dots.eq(i).hide();
	        	}

	            for (i = indexActive - 5; i >= 0; i--){
	            	dots.eq(i).hide();
	            }

	    	}

	        dots.eq(indexActive + 1).addClass("semi-reduced");
	        dots.eq(indexActive - 1).addClass("normal");
	        dots.eq(indexActive - 2).addClass("normal");
	        dots.eq(indexActive - 3).addClass("semi-reduced");

	    }

	}
}
//end store-pdp-clipon.js
var badgeVisible = true;

if (!Object.assign) {
    Object.defineProperty(Object, 'assign', {
      enumerable: false,
      configurable: true,
      writable: true,
      value: function(target, firstSource) {
        'use strict';
        if (target === undefined || target === null) {
          throw new TypeError('Cannot convert first argument to object');
        }

        var to = Object(target);
        for (var i = 1; i < arguments.length; i++) {
          var nextSource = arguments[i];
          if (nextSource === undefined || nextSource === null) {
            continue;
          }
          nextSource = Object(nextSource);

          var keysArray = Object.keys(Object(nextSource));
          for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
        return to;
      }
    });
  }

// Global variables
var defaultSearchProfile = getUrlParameter('searchTerm') ? 'LUX_findProductsBySearchTerm' : 'LUX_findProductsByCategory_group';
var countSelectedFacets = 0, defaultOrderBy, selectedFacetsData = {}, selectedFacets = {}, originalHrefApply = '', previousFilter = {}, originalSelectedSort = "";
var tileIndex = 0;
var indexSearchPanel = 0;

//Filter & OrderBy variables
var queryFilters = [],
    queryOrderBy = [],
    emptyFilters = true,
    emptyOrderBy = true,
    numMaxofPages,
    index,
    isFacetApplied = false;

queryParams = {
    storeId: WCParamJS.storeId,
    catalogId: WCParamJS.catalogId,
    responseFormat: 'json',
    langId: WCParamJS.langId,
    currency: WCParamJS.commandContextCurrency,
    profileName: defaultSearchProfile,
    searchSource: 'E',
    isForPLP: true
};

var featuredProductHtml = "";

/* BEGIN - Workarounds for IE */
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.indexOf(searchString, position) === position;
  };
}
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(searchString, position) {
      var subjectString = this.toString();
      if (typeof position !== 'number' || !isFinite(position)
          || Math.floor(position) !== position || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
  };
}
(function() {
	  function remove() { this.parentNode && this.parentNode.removeChild(this); }
	  if (!Element.prototype.remove) Element.prototype.remove = remove;
	  if (Text && !Text.prototype.remove) Text.prototype.remove = remove;
	})();
/* END - Workarounds for IE */
columnsToShow = 4
//	Skeleton Loader variables
var $plpSearchObj = {};
$plpSearchObj.itemsPerPage = 0;		// infinite scroll page(group) size
$plpSearchObj.itemsFromServer = 0;	// how many to get from API
$plpSearchObj.viewIndex = 0;		// index of items to show in view
$plpSearchObj.lastIndex = 0;
$plpSearchObj.resultCount = 0;
$plpSearchObj.viewMoreClicked = false;
$plpSearchObj.viewMoreSearchCount = 0;
$plpSearchObj.viewMoreSearchStartIndex = 0;
$plpSearchObj.productsServiceUrl = function(searchedWord) {
	if(storeDirectory === 'PersolGR' && host !== 'localhost'){
        WCParamJS.homePageURL = "https://"+ host + "/greece";
    }
	var baseSearchURL = (isInToolkit ? '' : WCParamJS.homePageURL)+'/search/resources/store/'+WCParamJS.storeId+'/productview/';
	var searchTerm = getUrlParameter('searchTerm');
    /* START Early Access */
    if (isPersol) {
        if (window.customerSegment != undefined && window.customerSegment != ""){
            queryParams.customerSegment = window.customerSegment;
        }
    }
    /* END Early Access */
	if (searchTerm || searchedWord) {
		return baseSearchURL+'bySearchTerm/' + (searchedWord ? searchedWord : searchTerm); // Search Obtimization
	}
	return baseSearchURL+'byCategory/'+ document.querySelector('meta[name="pageId"]').getAttribute('content');
}
$plpSearchObj.lastIndexbkp = 0;

function fn_plpFirstTiles(productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch) {
	// # Load Espot contents (TOP e MIDDLE creati durante il render delle tile)
	if (typeof isWishlist == "undefined"){
        var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
    }

    if (!isWishlist){
        selectedFacetsData = {
            storeId : WCParamJS.storeId,
            catalogId: WCParamJS.catalogId,
            fromPage: 'catalogEntryList',
            beginIndex: '0',
            responseFormat: 'json',
            orderBy: defaultOrderBy,
            categoryId: ""
        };
    } else {
        if (typeof sessionStorage.wishlistObj != "undefined"){
            var wishlistObjCount = Object.keys(JSON.parse(sessionStorage.wishlistObj)).length;
            var countString = "(" + wishlistObjCount + ")";
            $(".title-wishlist_count").html(countString);
            if (wishlistObjCount == 0){
                $("#box.wishlist").addClass("emptyWishlist");
                $("#empty-wishlist-container").removeClass("hidden");
                if (isOliver && $("#wishlistAppointmentEspot").length > 0) $("#wishlistAppointmentEspot").remove();
            } else {
                $("#box.wishlist").removeClass("emptyWishlist");
                $("#empty-wishlist-container").addClass("hidden");
            }
        }
    }

 
	$plpSearchObj.itemsPerPage = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 && sessionStorage.backItemsPerPage) ? parseInt(sessionStorage.backItemsPerPage) : columnsToShow*parseInt($("#rowsPerPage").val());			// infinite scroll page(group) size
	$plpSearchObj.itemsFromServer = (typeof pageSection_1 !== 'undefined' && sessionStorage.plpTitle == pageSection_1 & sessionStorage.itemsToLoad) ? parseInt(sessionStorage.itemsToLoad) : parseInt($("#itemsFromServer").val());					// how many to get from API
	//facet search page e plp credo
    
    if(document.querySelector('.plp') || document.querySelector('.search') || document.querySelector('.searchPanel') ) {
        // Get facets to show in filter by if it's not the Persol search
        /**
        // facets are excluded by search in Persol 
        if (!isWishlist){
            if (isOliver || isPersol) {
                $plpSearchObj.facetsForFilterBy = {};
                if ($('input#facetsForFilterBy').length){
                var facetsForFilterByArr = $('input#facetsForFilterBy').val().split(';');
                    for (var i=0;i<facetsForFilterByArr.length; i++) {
                        var facetArr = facetsForFilterByArr[i].split(':');
                        if (facetArr.length == 2) {
                            $plpSearchObj.facetsForFilterBy[facetArr[0]] = facetArr[1];
                            //queryParams['f.'+facetArr[1].substring(0,facetArr[1].indexOf('%3A'))+'.facet.mincount'] = 0;
                        }
                    }
                // Get facets to be ignored
                $plpSearchObj.facetsToBeIgnored = $('input#facetsToBeIgnored').val().split(';');
                }
            }
        }
        */

        setDefaultSortBy(defaultOrderBy, false, productData,searchedWord,isWishlist,wishlistToDeleteData,firstSearch);
        var pageElem = document.getElementById('page');
        var blockFilter = document.querySelector('.block-filter');
        var originalFilterParentElem = "";
        var facetButtonElem = document.querySelector('.plp-filter-button');

        //Different views buttons - By default, on mobile show 2 columns view; on desktop show 3 columns view
        if(!searchedWord){
            if (window.tabletPortraitCheck() || window.mobilecheck()){
                if (!isWishlist) {
                    $('.button-views.two-col-icon').addClass("active");
                    $('.grid_mode').addClass('grid_mode-two-cols');
                }
            }

            // ex --Apply facets when you click the apply button
            

            if(document.querySelector('.search-page')) {
                originalFilterParentElem = document.querySelector('#content > .search-page');
            } else {
                originalFilterParentElem = document.querySelector('#content > .plp');
            }

            if (document.querySelector(".facet__apply")) {
                originalHrefApply = document.querySelector(".facet__apply").getAttribute('data-href');
            }

            //show description before offset calculation: description can born displayed?
            if (isOliver){
                $('.description.descriptionDefault').css('display','flex');
                if (window.tabletPortraitCheck() || window.mobilecheck()) {
                    var espotHeight= $( "#contentRecommendationWidget_X_PLP_HeroBanner_X_PLP_HeroBanner").height();
                    //var textHeight =$(".descriptionDefault").height();
                    //var marginButtons= espotHeight - textHeight
                    //$('.plp-filter-view-button').css("margin-top","-"+$('.grid.product-list').css('margin-top'));
                }
            }

            // Change DOM facet button position to make it FIXED
                if (!isWishlist){
                    var class_startscroll = ".plp-filter-button_wrapper";
                    if (isPersol && document.querySelector('.search')) {
                        class_startscroll = ".searchSummaryWidget";
                    }
                    
                    var offset = $(class_startscroll).offset().top;
                    var totalOffset = offset;
                    if(window.mobilecheck() || window.tabletPortraitCheck()) {
                        totalOffset = offset + $(class_startscroll + ' .espot-plp-beans').outerHeight() + 56;
                    }
                } else {
                    if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex) {                    
                        //clean up the grid
                        $('.plp-grid-skeleton').remove();
                    }

                    //Remove extra empty <li> tags in wishlist page
                    if (isWishlist) {
                        if (typeof sessionStorage.wishlistObj != "undefined"){
                            var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                            var productsLength = Object.keys(wishlistProducts).length;

                            if (productsLength == 0){
                                if ($("#wishlist_grid li").length > 0) {
                                    $("#wishlist_grid li").remove();
                                }
                            } else {
                                for (var i=0 ;i<productsLength; i++){
                                    var wishlistLi = $("#wishlist_grid li")[i];
                                    if ($(wishlistLi).html() == ""){
                                        $(wishlistLi).remove();
                                    }
                                }
                            }
                        }
                    }
                }
                window.addEventListener('scroll', function() {
                    if (!isWishlist){
                    /** Sticky submenu in plp */
                        if (isPersol) {
                            if(window.mobilecheck() || window.tabletPortraitCheck()) {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() + $('#ci_espot__X_Header_GlobalBanner').height();
                                } else {
                                    var checkPersol = $(this).scrollTop() +1;
                                }
                            } else {
                                if ($('#ci_espot__X_Header_GlobalBanner').length){
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height() + $('#ci_espot__X_Header_GlobalBanner').height();
                                }
                                else {
                                    var checkPersol = $(this).scrollTop() - $(".ct-global--slider-container.ct-strip").height();
                                }
                            }

                            var getBannerTopHeight = function () {
                                if($('#bannerTop').length && $('#bannerTop').is(":visible")) {
                                    return $('#bannerTop').height();
                                } else {
                                    return 0;
                                }
                            }

                            var offset2 = 0;
                            if (window.mobilecheck() || window.tabletPortraitCheck()) {
                                offset2 = $(class_startscroll + " .espot-plp-beans").outerHeight() + 10;
                            }

                            if(checkPersol >= (offset + offset2)){
                                if(window.innerWidth >= 1024 && window.innerWidth < 1300 && window.matchMedia("(orientation: landscape)").matches){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                    $(class_startscroll).css('top', getBannerTopHeight());
                                } else {
                                    $(class_startscroll).css('top', $('#header').height() + getBannerTopHeight()-1);
                                }

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).addClass('plp-filter-button_wrapper--sticky');
                                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", $(".plp-filter-button_wrapper").outerHeight() );
                                        $('.plp-wrapper-title').show();
                                        $('.plp-filter-button_wrapper--sticky').css("top",$('.ct-promo-banner').height());
                                    }else {
                                        $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", "168.8px" );
                                        var stripHeight = $('.ct-promo-banner').height();
                                        var headerHeight = $('#header').outerHeight();
                                        $('.plp-filter-button_wrapper--sticky').css("top",parseInt(stripHeight)+parseInt(headerHeight));
                                    }
                                }
                            }else{
                                $(class_startscroll).css('top', 'auto');

                                if (document.querySelector('.search') == null) {
                                    $(class_startscroll).removeClass('plp-filter-button_wrapper--sticky');
                                    $('.plp-wrapper-title').hide();
                                    $(".grid.product-list:not(.grid.product-list-espot)").css("margin-top", 0 );
                                }
                            }
                        }
                    }
                    
                    var documentBottom = $(window).scrollTop()+$(window).outerHeight();
                    
                    if($(".plp-grid-skeleton").length > 0) {
                        var skeletonTop =  $(".plp-grid-skeleton").offset().top;
                        //retiver info origina plp 
                        
                        
                        if (skeletonTop <= documentBottom
                                && $plpSearchObj.viewIndex < $plpSearchObj.lastIndex
                                && !$plpSearchObj.busy) {
                            $plpSearchObj.viewMoreTiles($plpSearchObj.itemsPerPage);
                        }

                        if($plpSearchObj.viewIndex >= $plpSearchObj.lastIndex && $plpSearchObj.viewIndex!=0) {                    
                            //clean up the grid
                            $('.plp-grid-skeleton').remove();

                            //Remove extra empty <li> tags in wishlist page
                            if (isWishlist) {
                                if (typeof sessionStorage.wishlistObj != "undefined"){
                                    var wishlistProducts = JSON.parse(sessionStorage.wishlistObj);
                                    var productsLength = Object.keys(wishlistProducts).length;

                                    if (productsLength == 0){
                                        if ($("#wishlist_grid li").length > 0) {
                                            $("#wishlist_grid li").remove();
                                        }
                                    } else {
                                        for (var i=0 ;i<productsLength; i++){
                                            var wishlistLi = $("#wishlist_grid li")[i];
                                            if ($(wishlistLi).html() == ""){
                                                $(wishlistLi).remove();
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                });

                //  Begin Change DOM filter position to make it FIXED
                if (!isWishlist){
                    if (isOliver){
                        document.querySelector('body').appendChild(blockFilter);
                    }
                }

                window.addEventListener('resize', function() {
                    if(!isWishlist){
                        if(window.innerWidth >= 1024 && blockFilter.parentNode !== originalFilterParentElem) {
                            facetButtonElem.classList.remove('scroll');
                        }
                        else if (window.innerWidth < 1024 && blockFilter.parentNode !== pageElem) {
                            document.querySelector('body').appendChild(blockFilter);
                        }
                    }
                    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
                        if(isOliver) {
                            if (isWishlist){
                                $('#wishlist_grid .grid-item:not(.product-espot)').outerHeight("100%");
                            } else {
                                $('.grid-item:not(.product-espot)').outerHeight("100%");
                            }
                        } else if(isPersol) {
                            if(isWishlist){
                                $('.grid-item:not(.product-espot):not(.grid-item-search)').outerHeight("100%");

                            }else{
                                $('.grid-item:not(.product-espot)').height("100%");
                            }
                            
                        }
                    }
                    if(!isWishlist){
                        if(blockFilter.classList.contains('opend') && window.innerWidth >= 1024) {
                            document.querySelector('html').removeAttribute("style");
                            document.querySelector('body').removeAttribute("style");
                        } else if(blockFilter.classList.contains('opend') && window.innerWidth < 1024) {
                            document.querySelector('html').setAttribute("style", "overflow: hidden;");
                            document.querySelector('body').setAttribute("style", "position: static; overflow: hidden");
                        }
                    }
                }, true);
                //  End Change DOM filter position

                //Add classes to Persol if on mobile
                if (isPersol) {
                    if (window.tabletPortraitCheck() || window.mobilecheck()){
                        $('.sale_badge').addClass('submenu__subheader');
                        $('.sale_badge').addClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader');
                        $('.submenu__list-block--desktop li:not(".sale_badge") > a').addClass('submenu__subheader--mobile');
                    } else {
                        $('.sale_badge').removeClass('submenu__subheader');
                        $('.sale_badge').removeClass('submenu__subheader--mobile');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader');
                        $('.submenu__list-block--desktop li > a').removeClass('submenu__subheader--mobile');
                    }
                }

                // deleted function --- see //START FILTER SECTION in non critical js 

        
          
        }
    }

        initButtonViewOnClick();

		



    // # X_PLP_SalesBeans
    if ($('#ci_espot__X_PLP_SalesBeans').length > 0) {

    	// Change event for select
    	$('select.select-bean').change(function(e) {
        	document.location.href = $(e.target).val();
        });

    	// Active/Select current dash button page
		var urlPage= window.location.href;
	    var splitUrl = urlPage.split("/");
	    var salesCategory = splitUrl[splitUrl.length - 1];
	    $('.nav-beans #' + decodeURI(salesCategory.split('?')[0])).addClass("active");
	    $("select option[value='"+salesCategory.split('?')[0]+"']").prop("selected",true);
	}
}

function initButtonViewOnClick(){
    // Change view when clicking on different buttons
    $('.button-views.one-col-icon').click(function() {
        columnsToShow = 1;
        $('.button-views').removeClass("active");
        $('.button-views.one-col-icon').addClass("active");
        $('.grid_mode').addClass('grid_mode-one-col');
        $('.grid_mode').removeClass('grid_mode-two-cols');
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").addClass("-one-col");
    });

    $('.button-views.two-col-icon').click(function() {
        columnsToShow = 2;
        $('.button-views').removeClass("active");
        $('.button-views.two-col-icon').addClass("active");
        $('#plp_grid.grid_mode').addClass('grid_mode-two-cols');
        $('#plp_grid.grid_mode').removeClass('grid_mode-one-col');
        $('#plp_grid.grid-item').removeAttr('style')
        $('.product--wrapper__container').removeAttr('style')
        $('.plp-main-carousel').slick('unslick');
        initSlick();
        manageCarousel($('.plp-other-color-carousel'));
        $(".grid_mode").removeClass("-one-col");
    });
}

/**
 * @function setDefaultSortBy
 * @desc This function select the default sort by inside facet section
 *
 * @param {*} num
 */
function setDefaultSortBy(num, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    var sortElems = document.querySelectorAll('.facet__sortBy .facet__filter-button');
    for(var sortElem = 0; sortElem < sortElems.length; sortElem++) {
        if(sortElems[sortElem].getAttribute('data-facet') == num){
            sortElems[sortElem].parentElement.classList.add('selected');
            break;
        }
    }
    originalSelectedSort = document.querySelector('#facet__sortBy .facet__filter-noimg.selected');
    ajaxCallFacet(callbackSortBy, null, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch);
}

function ajaxCallFacet(callback, elem, isViewMore, productData,searchedWord, isWishlist, wishlistToDeleteData,firstSearch) {
    
    if(typeof firstSearch != undefined){
        $plpSearchObj.firstSearch = firstSearch;
    }else{
        $plpSearchObj.firstSearch = undefined;
    }
    $plpSearchObj.viewIndex = 0;
    $plpSearchObj.lastIndex = 0;
    $plpSearchObj.resultCount = 0;
    $plpSearchObj.getData(isViewMore, function() {
        $plpSearchObj.attrValIdentifierObject = [];//object use to retrive indetifier value of attribute value
    	$plpSearchObj.busy = false;
    	createNewTileProducts(0,$plpSearchObj.itemsPerPage,searchedWord,isWishlist,false,wishlistToDeleteData);
        $plpSearchObj.itemsPerPage = columnsToShow*parseInt($("#rowsPerPage").val());
        $plpSearchObj.itemsFromServer = parseInt($("#itemsFromServer").val());
    	callback(elem);
    }, productData,searchedWord, isWishlist);
    if (typeof productData === 'undefined') {
        $plpSearchObj.busy = true;
    }
}

//function to load plp data 
$plpSearchObj.getData = function(isViewMore,callback,productData,searchedWord,isWishlist) {
	if (!isViewMore) {
		$plpSearchObj.items = {};
		$plpSearchObj.currentPage = 1;
		$plpSearchObj.viewIndex = 0;
		$plpSearchObj.lastIndex = 0;
        
        /*if (document.querySelector('.search')) {
            $("span[id^=searchTotalCount]").html($("span[id^=searchTotalCount]").html().replace(/\d/g, ''));
        }*/
		window.scrollTo(0,0);
	} else {
        $plpSearchObj.viewMoreClicked = true;
		$plpSearchObj.currentPage = Math.floor(($plpSearchObj.lastIndex||0)/$plpSearchObj.itemsFromServer)+1;
        
        var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
        
        for(var i = 0; i  < $plpSearchObj.itemsFromServer; i++) {
            var createDOMLi = document.createElement('li');
            if(isOliver) createDOMLi.classList.add('product');
            createDOMLi.classList.add('plp-grid-skeleton');
            ulGrid.appendChild(createDOMLi);
        }
        // 	$('.product--wrapper').height($('.product').width());
        // }
    } 
	
    if (isPersol) {
    	$('.skeleton .product--wrapper').height($('.skeleton .product-container').width() * (400/360));
    }

    $plpSearchObj.queryParams = queryParams;
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['categoryId'] = '';
    }else{
        $plpSearchObj.queryParams['categoryId'] = document.querySelector('meta[name="pageId"]').getAttribute('content');
    }
	if (selectedFacetsData["orderBy"]) {
		$plpSearchObj.queryParams['orderBy'] = selectedFacetsData["orderBy"];
	    if (isPriceOrdering()) {
	    	queryParams['profileName'] = 'LUX_findProductsByCategory';
	    } else if (isNewArrivalsOrdering() && getUrlParameter('searchTerm') == null) {
	    	queryParams['profileName'] = defaultSearchProfile+'_new_first';
	    } else {
	    	queryParams['profileName'] = defaultSearchProfile;
	    }
	} else {
		delete $plpSearchObj.queryParams['orderBy'];
    	queryParams['profileName'] = defaultSearchProfile;
	}
	if (!categoryToGroupTile()) {
		queryParams['profileName'] = 'LUX_findProductsByCategory';
	}
	$plpSearchObj.queryParams['pageNumber'] = $plpSearchObj.currentPage;
	$plpSearchObj.queryParams['pageSize'] = $plpSearchObj.itemsFromServer;
    var facetArr = [];
    var queryString = window.location.search.substr(1);
    if (queryString.trim() != "") {
        var parameters = queryString.split('&');
        $.each(parameters, function(i,el){
       	 	var facetKey = el.split('=')[0];
       	 	if (facetKey.startsWith('facet')) {
       	 		var facetValue = el.split('=')[1];
       	 		facetArr.push(facetValue);
       	 	}
        });
    }
    if(searchedWord || isWishlist){
        $plpSearchObj.queryParams['facet'] = [];
    }else{
        $plpSearchObj.queryParams['facet'] = facetArr;
    }
    

    var ajaxPLPSuccess = function(data) {
    	
    	   if(location.href.includes("facet") && !$plpSearchObj.viewMoreClicked){
           	tileIndex = 0;
           }

        $plpSearchObj.resultCount = !isWishlist ? data.recordSetTotal : Object.keys(data).length;
        var dataRecordCount = !isWishlist ? data.recordSetCount : Object.keys(data).length;
        if (dataRecordCount === 0) {
        	var dataSpellCheck = '';
        	if ($('.suggestions_container .suggestion').length > 0){
        		dataSpellCheck = $('.suggestions_container .suggestion')[0].text;
        	} else if (data.metaData){
        		dataSpellCheck = data.metaData.spellcheck[0];
        	}
        	if (dataSpellCheck){
        		$.ajax({
                    url: $plpSearchObj.productsServiceUrl(dataSpellCheck),
                    type: 'GET',
                    async: true,
                    data: $.param($plpSearchObj.queryParams,true),
                    success: ajaxPLPSuccess,
                    error: function(error) {
                    	return error;
                    }
                });
        	} else {
                if(searchedWord && typeof $plpSearchObj.firstSearch == undefined){//no result in search panel 
                    searchError(true);
                    resetSearchTile(true);//resetFeature
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(searchedWord && $plpSearchObj.firstSearch ){//no result in search panel firstsearch
                    searchError(true);
                    resetSearchTile(true);
                    if(searchedWord != 'X_Search_FeaturedProducts'){
                        tealiumPushSearchPageReady(searchedWord,'0');
                    }
                    
                }else if(isWishlist){
                    $("#wishlist_grid li .grid-item").remove(); //wishlist is empty
                }else {
                    //	Hide View More button
                    //populateUtagDataAfterAjax();
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                    if (isOliver && getUrlParameter('searchTerm') === null){
                        $('#noProducts').css('display','block');
                        //add default empty element in plp_grid for wcag
                        var createDOMProduct = document.createElement('li');
                        createDOMProduct.classList.add('grid-item');
                        createDOMProduct.setAttribute('id','dummyElement');
                        ulGrid.appendChild(createDOMProduct);
                    }

                }
                
            }
        }
        
        else if (dataRecordCount > 0) {
        	if(($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm' && $('.suggestions_container .suggestion').length > 0 && $('.suggestions_container .suggestion')[0].text.toLowerCase() != (data.catalogEntryView[0].name).toLowerCase())){
        		for (var i = 0; i < dataRecordCount; i++) {
        			if($('.suggestions_container .suggestion')[0].text.toLowerCase() == (data.catalogEntryView[i].name).toLowerCase()){
        				var shortDescription = (data.catalogEntryView[i].shortDescription);
        				$.ajax({
                            url: $plpSearchObj.productsServiceUrl(shortDescription),
                            type: 'GET',
                            async: true,
                            data: $.param($plpSearchObj.queryParams,true),
                            success: ajaxPLPSuccess,
                            error: function(error) {
                            	return error;
                            }
                        });
        				break;
        			}
        		}
        	}
            var results = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord ? data.catalogEntryView : (isWishlist ? data : data.catalogEntryGroupView); 
             // Display message when no products are shown
            $('#noProducts').css('display','none');
            //delete dummyElement in plp_grid for WCAG
            $('#dummyElement').remove();
            if(searchedWord){
                searchError(false);
                $(".title_result").hide();
                $(".redirect_result_container").css("display","flex");
                $(".redirect_result_container .redirect_result_link").show()
                $(".redirect_result_link #serched_word").html($('input:text[name=searchInput]').val());
                
            }
            /* populate items */
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord) {
                $.each(results, function(key,value) {
                    $plpSearchObj.items[(parseInt(key)+($plpSearchObj.itemsFromServer*($plpSearchObj.currentPage-1)))] = value;
                    
                });
                if(!searchedWord){
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            } else {
                //  START - Email me sorting by inventory
                function fn_sortByInventory(p) {
                    var r = 0;
                    if (p['inventory']
                            && p['inventory']['ranking']
                            && p['inventory']['flComingSoon']) {
                        r = p['inventory']['ranking'] + (p['inventory']['flComingSoon'] == 'true' ? 0.5 : 0);
                    }
                    return r; 
                }
                if (!isWishlist){
                    $.each(results,function(group,products) {
                        products.sort(function(a, b){
                            var sortedResults = fn_sortByInventory(b) - fn_sortByInventory(a);
                            return sortedResults;
                        });
                    });
                }
                //  END - Email me sorting by inventory
                Object.assign($plpSearchObj.items,results);
                if(!searchedWord){
                    //search Optimization save PLP items info 
                    $plpSearchObj.itemsbkp =  $plpSearchObj.items;
                }
            }

            //  LCP
            /*
            let count = 0;
            $.each($plpSearchObj.items,function (key,value) {
                if (count == 0
                        && value[0] != undefined) {
                    var lcp = new Image();
                    if (isOliver){
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else if (isPersol) {
                        lcp.src = replaceTileImgByDevice(value[0].thumbnail,'sclw=0.25&sclh=0.25','small');
                    }
                    return false;
                }
            });
            */

            /*populate tealiumProducts HB-5614*/
            var status = 'undefined';
            if (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) {
                if(typeof tealiumProducts === 'undefined'){
                     tealiumProducts = {};
                }
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        var category = "";
                        if(pageType=='Wishlist'){
                        	category = getAttributeValue(value.attributes,"PRODUCTTYPE");
                        	category = category.toLowerCase();
                        	
                        	if(category.includes("sun")){
                        		category = "SUN";
                        	}
                        	if(category.includes("optical")){
                        		category = "OPTICS";
                        	}
                        	
                        	if(category.includes("accessories")){
                        		category = "ACCESSORIES"; 
                        	}
                        }else{
                        	category = getCategoryName(key ,"_")
                        }
                        
                        tealiumProduct['Category'] = category; 
                        tealiumProduct['Price'] = parseFloat(value['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value.inventory);
                        $(addProductsToTealium(value.partNumber,tealiumProduct)); // fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(e);
                    }
                });
            }
            else {
                $.each($plpSearchObj.items,function (key,value) {
                    try {
                        var tealiumProduct = {};
                        tealiumProduct['Category'] = getCategoryName(key ,"_");
                        tealiumProduct['Price'] = parseFloat(value[0]['price']['price']).toFixed(2);
                        tealiumProduct['PriceFull'] = parseFloat(value[0]['price']['listprice']).toFixed(2);
                        tealiumProduct['Brand'] = currentBrand;
                        tealiumProduct['Status'] = getStatus(value[0].inventory);
                        $(addProductsToTealium(value[0].partNumber,tealiumProduct));// fix for HB-13178 inserted in document ready to avoid it being called before its declaration
                    } catch (e) {
                        console.error('Error while parsing product for Tealium');
                        console.error(value[0]);
                    }
                });
            }
            
            
            if(pageType=='Search'){
               var obj = {};
               obj['Search_Keyword'] = getUrlParameter('searchTerm');
               obj['Search_ResultItemsQnt'] = $plpSearchObj.resultCount;
               obj['Search_View'] = 'SERP';
               obj['Event_Source'] = 'SERP'
               pushDataToTealium(obj)
            } 
            
            if (typeof monetateQ !== 'undefined'){
                  monetateTrackPlp();
            }

            /*END 5614*/
    
            if(!searchedWord){
                if($plpSearchObj.lastIndexbkp > 0 && !$plpSearchObj.isFilterPanel){ // search Optimization  if is after search and not use filter
                    $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp
                    $plpSearchObj.lastIndex += Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex;
                }else{
                    //if apply filter 
                    $plpSearchObj.lastIndex = Object.keys(results).length;
                    $plpSearchObj.lastIndexbkp = $plpSearchObj.lastIndex
                    $plpSearchObj.isFilterPanel = false;
                }
 
                
            }
            
            $plpSearchObj.loading = false;
            if (typeof callback == 'function') {
            	if($plpSearchObj.queryParams.profileName === 'LUX_findProductsBySearchTerm'){
            		resetSearchTile(false,false,false);
            	}
            	callback();
            }

            /* facets are included only in PLP */
            if (!isWishlist){
                if(!searchedWord){
                    closeFilterMenu();
                    isFacetApplied = true;
                    originalSelectedSort = $('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en");
                    if(countSelectedFacets == 0) {
                        $(".facet__apply").removeClass('show');
                        document.querySelector('.facet__widget').classList.remove('active');
                        isFacetApplied = false;
                    }
                }
            }

            //	View More button
            if (!isWishlist){
                if ($plpSearchObj.resultCount-$plpSearchObj.lastIndex <= 0) {
                    $('.plp__view-more.button.secondary').attr('style','display:none !important');
                } else {
                    $('.plp__view-more.button.secondary').show();
                }
            }

            if (!isViewMore) {
                /* facets are excluded by search in Persol */
                if (!searchedWord) { // SearchOptimiztion ! (isPersol && getUrlParameter('searchTerm'))
                    //	Inner function used to handle filters drawing and toggle
                    if (!isWishlist){

                        var filtersHandling = function(dataPartial,dataAll) {
                        // $plpSearchObj.attrValIdentifierObject =  createAttrValIdentifierObject(dataAll.catalogEntryGroupView);
                            drawFilters(dataAll.facetView,facetArr,parameters,$('#facet__sortBy .facet__filter-noimg.selected button').attr("data-facet-name-en"));
                            $('.facet__apply-number').text($plpSearchObj.resultCount);
                            $('.numframe').html($plpSearchObj.resultCount + ' ' + $('#frameTranslate').val());
                            $("#productsFacets li.facet__list-item li").each(function(i,e) {
                                toggleFilter(e,dataPartial);
                            });
                        };
                        //	If there are no GET parameters, then use the normal flow
                        if (facetArr.length == 0) {
                            filtersHandling(data,data);
                        } else {
                            new Promise((resolve, reject) => {
                                // else do an AJAX call to get the full facets list
                                var queryParamsAllFilters = $.extend({},$plpSearchObj.queryParams);
                                queryParamsAllFilters['facet'] = [];
                                delete queryParamsAllFilters['isForPLP'];
                                queryParamsAllFilters['isForPLPFilters'] = true;
                                $.ajax({
                                    url: $plpSearchObj.productsServiceUrl(),
                                    type: 'GET',
                                    async: true,
                                    data: $.param(queryParamsAllFilters,true),
                                    success: function(dataAll) {
                                        filtersHandling(data,dataAll);
                                        resolve(dataAll);
                                    },
                                    error: function(error) {
                                        reject(all);
                                        return error;
                                    },
                                    beforeSend: function(jqXHR, settings) {
                                        //  Security check, if true then stop the request and show 0 results
                                        if (settings.url.indexOf('TopCategoriesDisplay') > -1) {
                                            return false;
                                        }
                                    }
                                });
                            });
                        }
                    }
                }

                if (!isWishlist){
                    if(!searchedWord){
                        if(originalSelectedSort != undefined){
                            if(!(isPersol && getUrlParameter('searchTerm')) && facetArr.length == 0 && originalSelectedSort.innerText!==''){
                                setUTagData(parameters,originalSelectedSort);
                            }
                        }
                    }
                }

                if (document.querySelector('.search') ) {
                    $("span[id^=searchTotalCount] #totalCount").html("("+ $plpSearchObj.resultCount + ") " );
                }
            }
        }

        // Remove top and middle espot skeleton
        $('#plp_top_espot_skeleton').remove();
        $('#plp_middle_espot_skeleton').remove();

        //  CLS
        $('.plp-hide').show();
    };
    if (!isWishlist && typeof productData === 'undefined') {

        if(searchedWord || getUrlParameter('searchTerm') ){
            $plpSearchObj.queryParams.profileName = "LUX_findProductsBySearchTerm"
            if(isPersol){
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688668_3074457345616688669_3074457345616718183_3074457345616718182)'"; // catgoria LEnti + categorie servizi
            }else{
                $plpSearchObj.queryParams.filterQuery = "-parentCatgroup_id_search eq '(3074457345616688676_3074457345616714198_3074457345616714199_3074457345616688675)'"; // catgoria LEnti + categorie servizi
            }
             
            
        }else{
            $plpSearchObj.queryParams.profileName = $plpSearchObj.queryParams.profileName;
            delete $plpSearchObj.queryParams.filterQuery 
        }
        if(!isWishlist && !(searchedWord || getUrlParameter('searchTerm'))){}else{
        	$.ajax({
                url: $plpSearchObj.productsServiceUrl(searchedWord),
                type: 'GET',
                async: true,
                data: $.param($plpSearchObj.queryParams,true),
                success: ajaxPLPSuccess,
                error: function(error) {
                    return error;
                },
                beforeSend: function(jqXHR, settings) {
                    //  Security check, if true then stop the request and show 0 results
                    if (settings.url.indexOf('TopCategoriesDisplay') > -1) {

                        $plpSearchObj.resultCount = 0;

                        //	Hide View More button
                        $('.plp__view-more.button.secondary').attr('style','display:none !important');
                        if (isOliver && getUrlParameter('searchTerm') === null){
                            $('#noProducts').css('display','block');
                            //add default empty element in plp_gid for wcag
                            var createDOMProduct = document.createElement('li');
                            createDOMProduct.classList.add('grid-item');
                            createDOMProduct.setAttribute('id','dummyElement');
                            ulGrid.appendChild(createDOMProduct);
                            
                        }

                        return false;
                    }
                }
            });
        }
        
    } else {
        ajaxPLPSuccess(productData);
    }

};

/**
 * @funtion createNewTileProducts
 * @desc This function creates the new tile products with a template html
 */
function createNewTileProducts(startAt,count,searchedWord,isWishlist,isWishlistViewMoreTiles,wishlistToDeleteData,firstSearch) {
	// TEMPORARY FIX FOR HB-9977
	if(pageSection_1 == 'Accessories' && (window.tabletPortraitCheck() || window.mobilecheck())){
		count = 6;
	}
	$plpSearchObj.viewIndex = startAt+count;
    if(!searchedWord){
        //search Optimization -- save viewIndex 
        $plpSearchObj.viewIndexbkp = $plpSearchObj.viewIndex
    }
	//	Remove extra skeleton tiles
	var toShow = $plpSearchObj.lastIndex-$plpSearchObj.viewIndex;
	var toRemove = $plpSearchObj.itemsFromServer-toShow;
	
    var products = {}, i = 0;

    if (getUrlParameter('searchTerm') && $plpSearchObj.viewMoreClicked && !searchedWord) {
        var stopAt = $plpSearchObj.viewMoreSearchStartIndex+count;
        i = $plpSearchObj.viewMoreSearchStartIndex;
        if (toShow < 0) {
            // check for the end on products
            stopAt += toShow;
        }
        for (m in $plpSearchObj.items) {
            if (i>=$plpSearchObj.viewMoreSearchStartIndex && i < stopAt) {
                products[m] = $plpSearchObj.items[parseInt(m)+startAt];
            }
            i++;
        }
        $plpSearchObj.viewMoreSearchCount++;
        $plpSearchObj.viewMoreSearchStartIndex = count * $plpSearchObj.viewMoreSearchCount;
    } else {
        for (m in $plpSearchObj.items) {
            if (startAt<=i && i<startAt+count) {
                if(searchedWord){
                    if(isPersol && i <= 2){
                        products[m] = $plpSearchObj.items[m];
                    }else if(isOliver && i <= 1){
                        products[m] = $plpSearchObj.items[m];
                    }
                }else{
                    products[m] = $plpSearchObj.items[m];
                }
                
            }
            i++;
        }
    }

    // Show number of selected facets in the filter button
    if (countSelectedFacets >= 1) {
        $('.plp-filter-button').addClass('active');
    	$('.filter__button-number').text(countSelectedFacets);
    } else {
        $('.plp-filter-button').removeClass('active'); 
    }

    var tileCount = Object.keys($plpSearchObj.items).length;

    
    renderTileProducts(products, startAt, count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData);
}

/**
 * @funtion manageWishlistGuestEspot
 * @desc This function adds the sign in/register espot in the wishlist page as last tile of first grid row. This only happens when user is guest
 * */
function manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData) {
    var parentElement = ulGridChilds[0].parentNode;
    if (isPersol){
        if (productsLength > 0 && productsLength < 4) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(3).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[3]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    } else {
        if (productsLength > 0 && productsLength < 3) {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                //Remove empty <li> and add guest espot
                if ($("#wishlist_grid").children().eq(productsLength).html() == ""){
                    $("#wishlist_grid").children().eq(productsLength).remove();
                }
                $("#wishlist_grid").children().eq(productsLength-1).after($(espotLi));
            } else {
                ulGridChilds[productIndex+1].replaceChildren(createDOMEspot);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        } else {
            if (typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                $("#wishlist_grid").children().eq(2).before($(espotLi));
            } else {
                parentElement.insertBefore(espotLi, ulGridChilds[2]);
            }
            ulGridChilds[productIndex+1].classList.remove("plp-grid-skeleton");
        }
    }
    if (typeof setWishlistEspotCtaClick == "function"){
        setWishlistEspotCtaClick();
    }
}

/**
 * @funtion renderTileProducts
 * @desc This function creates the new tile products with a template html
 * @param {products} products
 * @param {inventory} inventory
 */
function renderTileProducts(products,startAt,count, toRemove,searchedWord,isWishlist, isWishlistViewMoreTiles, wishlistToDeleteData) {

    var ulGrid = !isWishlist ? document.querySelector('#plp_grid') : document.querySelector('#wishlist_grid');
    var productArray = [];

  
    
    const ulGridChilds = searchedWord ? document.querySelectorAll('.search-grid-skeleton') : ((isWishlist && $('.plp-grid-skeleton').length == 0) ? document.querySelectorAll('#wishlist_grid li') : document.querySelectorAll('.plp-grid-skeleton')); //search optimization

    var productIndex = 0;
   
    var productsLength = Object.keys(products).length;

    for(var product in products) {

        if (typeof wishlistToDeleteData == "undefined" || !wishlistToDeleteData.isWishlistProductToDelete){
            var createDOMProduct = document.createElement('div');
            createDOMProduct.classList.add('grid-item');
            if(searchedWord){
                createDOMProduct.classList.add('grid-item-search');
                if(searchedWord == "X_Search_FeaturedProducts"){
                    $(".grid-item-search").parent().addClass("featured-products");
                }
            }

            var isLCPTile = startAt == 0 && productIndex == 0;
           

            if(searchedWord == "X_Search_FeaturedProducts"){
                var html = getSingleTileHtml(product, products[product].productModel, true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }else{
                var html = getSingleTileHtml(product, products[product], true,productIndex,isLCPTile, tileIndex,searchedWord,isWishlist);
            }
            
            
            $(createDOMProduct).html(html);
            ulGridChilds[productIndex].replaceChildren(createDOMProduct);
        }
        
        if (isWishlist){
            //If there is at least one product and user is guest, display sign in/register espot at last position of first grid row
            if (userType == "G" && productsLength > 0){
                if (!isWishlistViewMoreTiles || typeof wishlistToDeleteData != "undefined" && wishlistToDeleteData.isWishlistProductToDelete){
                    if (productIndex == productsLength - 1) {
                        if (typeof wishlistContentEspotHTML == 'undefined'){
                            returnEspotContent("X_Wishlist_Login");
                            var wishlistContentEspotHTML = $("#guestWishlistEspotContent").val();
                        }
                        if (typeof wishlistContentEspotHTML != "undefined" && wishlistContentEspotHTML != ""){
                            var espotLi = document.createElement('li');
                            espotLi.classList.add("wishlist-li");
                            var createDOMEspot = document.createElement('div');
                            createDOMEspot.classList.add('grid-item', 'wishlist-espot');
                            $(createDOMEspot).html(wishlistContentEspotHTML);
                            espotLi.appendChild(createDOMEspot);
                            if ($(".wishlist-espot").length == 0){
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            } else {
                                $(".wishlist-espot").parent().addClass("wishlist-li");
                                if ($(".wishlist-li").length > 0) {
                                    $(".wishlist-li").remove();
                                }
                                manageWishlistGuestEspot(createDOMEspot, espotLi, ulGridChilds, productIndex, productsLength, wishlistToDeleteData);
                            }
                        }
                    }
                }
            }


            if(typeof checkIsInWishlist === 'function'){ 
                if(checkIsInWishlist(product)){ // WISHLIST -- check if current product is in wishist
                    $("[data-id=" + product + "] .wishlist-icon-container").addClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }else{
                    $("[data-id=" + product + "] .wishlist-icon-container").removeClass("wishlist_product");
                    $("[data-id=" + product + "] .wishlist-icon-container").show();
                }
            }
            wishlistAvailabilityCheckCTA(products, product);
        }

        if(searchedWord){
           ulGridChilds[productIndex].classList.remove("search-grid-skeleton");
           //$(".search-grid-skeleton").eq(productIndex).hide()
        }else {
            ulGridChilds[productIndex].classList.remove("plp-grid-skeleton");
            
        }

        ulGridChilds[productIndex].classList.remove("product");
        ulGridChilds[productIndex].querySelector('.square-container').classList.remove("skeleton-element");
        ulGridChilds[productIndex].querySelector('.product__wrapper-info').classList.remove("skeleton-element");
        
        
        productArray.push(createDOMProduct);
       
        removeLoader();


        
        productIndex++;
        tileIndex++;
    }


    if(searchedWord && $("#search_grid .search-grid-skeleton").length > 0){ //hide skeleton if result <3 /2
        $("#search_grid .search-grid-skeleton").hide();
    }

    if (!isWishlist){
        if(searchedWord != 'X_Search_FeaturedProducts' && searchedWord){
            var resultItemsQnt = $("#search_grid li:not(.search-grid-skeleton)").length;
            tealiumPushSearchPageReady(searchedWord,resultItemsQnt);
        }
    } else {
        init_wishlist_tooltip();
    }


  

    // Show images in IE, as Yall does not work properly
    if (!('IntersectionObserver' in window)) {
        if (typeof mokeupLazyLoad === "function") {
            mokeupLazyLoad();
        }
    }
    if(window.location.href.includes("?facet=")){
    	$('#X_PLP_TopBanner').hide();
    	$('#X_PLP_BottomBanner').hide();
    	$('#X_PLP_MiddleBanner').hide();
    	$('#X_PLP_PromoBanner').hide();
        $('#X_PLP_BottomGridBanner').hide();
        $('#X_PLP_GridBannerTop').hide();
        $('#X_PLP_GridBannerBottom').hide();
    }

    if(isEdgeOrIExplorer()){
        $('.grid.product-list').css("width","auto");
    }
    
    /**
     * Handle back button : scroll to the last product clicked by user 
    * */
    if(sessionStorage.plpTitle == pageSection_1 && sessionStorage.pageY) {
            if($plpSearchObj.viewIndex  > 16) { //middle espot non renderizzato
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY - sessionStorage.middleEspotHeight
                },0);
            }
            else {
                $('html, body').animate({
                    scrollTop: sessionStorage.pageY
                },0);
            }
            sessionStorage.removeItem('pageY');
            sessionStorage.removeItem('plpTitle');
            sessionStorage.removeItem('itemsToLoad');
            sessionStorage.removeItem('backItemsPerPage');
            sessionStorage.removeItem('middleEspotHeight');
    }
    if(searchedWord == "X_Search_FeaturedProducts"){ // save Feautured 
        $('#search_grid li').each(function() {
            if(!$(this).hasClass("search-grid-skeleton")){
                featuredProductHtml += this.outerHTML
            }
        })
    }
    
}
/**
 * @funtion getSingleTileHtml
 * @desc This function creates a single product tile with a template html
 * @param {model} model
 * @param {product} product
*/
function getSingleTileHtml(product, model, insideGrid,productIndex=0,isLCPTile, tileIndex,searchedWord,isWishlist,isEspot) {

    var html = '';

    try {

        var listPrice = '';
        var offerPrice = '';
        var percentage = '';

        var polarized = '';
        var isPhotocromic = false;
        var isRox = false;
        var modelNameValue = "";
        var group2BadgeValue = '';
        var wishlistAddedSize = "";
        var wishlistAddedSizeNumber = "";
        var productMoco = "";
        var isPolar = false;
        var catentryIdDefaultSize = [];

        if (typeof isWishlist == "undefined"){
            var isWishlist = $("#page").hasClass("wishListDisplay") ? true : false;
        }

        //var model = products[product];
        var showedProduct = getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0];
        if (showedProduct.thumbnail === undefined) {
            showedProduct.thumbnail = '';
        }
        $(model).each(function (ind) {
            var currProduct = $(this)[0];
            if (isOliver) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
            } else if (isPersol) {
                currProduct.thumbnail = replaceTileImgByDevice(currProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
            }

            try {
                if(WCParamJS.countryCode == 'US' || WCParamJS.countryCode == 'CA'){
                    catentryIdDefaultSize[ind]= currProduct.mostSoldSize['NA'].uniqueID;
                }else if(WCParamJS.countryCode == 'JP'){
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['JP'].uniqueID;
                }else{
                    catentryIdDefaultSize[ind] = currProduct.mostSoldSize['EMEA'].uniqueID;
                }
            } catch (e) {
                console.error('Error in finding default size for wishlist');
            }
        });

        if(showedProduct != undefined
                && showedProduct.attributes != undefined) {
            for(var i=0; showedProduct.attributes.length>i; i++) {
                if(showedProduct.attributes[i].identifier === 'MODELNAME' && showedProduct.attributes[i].usage === 'Descriptive' ) modelNameValue = showedProduct.attributes[i].values[0].value;
                if(showedProduct.attributes[i].identifier === 'POLARIZED' && showedProduct.attributes[i].usage === 'Descriptive' ){
                    for(var k=0; showedProduct.attributes[i].values.length > k; k++ ){
                        if(showedProduct.attributes[i].values[k].value == true || showedProduct.attributes[i].values[k].value.toLowerCase() === 'yes'){
                            polarized = showedProduct.attributes[i].name;
                        }
                    }
                }
                if(showedProduct.attributes[i].identifier === 'MOCO' && showedProduct.attributes[i].usage === 'Descriptive' ) {
                    productMoco = showedProduct.attributes[i].values[0].value;
                }

            }
            if (isWishlist){
                for(var i=0; showedProduct.attributes.length>i; i++) {
                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE" && showedProduct.attributes[i].usage === "Descriptive" ) {
                        if (typeof wishlistAddedSizeNumber == "undefined" || wishlistAddedSizeNumber == ""){
                            wishlistAddedSizeNumber = showedProduct.attributes[i].values[0].value;
                        }
                    }

                    if(showedProduct.attributes[i].identifier === "MODEL_SIZE_DISPLAY" && showedProduct.attributes[i].usage === "Defining" ) {
                        if (typeof wishlistAddedSize == "undefined" || wishlistAddedSize == ""){
                            wishlistAddedSize = showedProduct.attributes[i].values[0].value;
                        }
                    }
                }
            }
        }

        

        var indexOtherColors = 0;
        var eachLensColor = "";
        var eachFrontColor = "";
        var isClipon = modelNameValue.toLowerCase().includes('clip');
        /*if (isClipon) {
            showedProduct.thumbnail = showedProduct.thumbnail.replace('/is/image/OliverPeoples','/extra/image/OliverPeoples/clipon').replace('_shad_fr','_shad_fr_clipon');
        }*/

        var inventoryStatus = false;
        var cbsCounter = 0;
        var csCounter = 0;
        var soCounter = 0;
        //prova
        var colorProp = "Color"
        var colorsProp = "Colors"
        //prova
        if (!(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile()|| searchedWord || isWishlist)){
            $(model).each(function (ind) {
                if (!(typeof model[ind]['inventory'] === 'undefined')){
                    if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'true'){
                        csCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '0'){
                        soCounter++;
                    } else if (model[ind]['inventory']['ranking'] == '1' && model[ind]['inventory']['flComingSoon'] == 'false'){
                        cbsCounter++;
                    }
                } else return false;

                if (csCounter == model.length || cbsCounter == model.length || soCounter == model.length) {
                    inventoryStatus = true;
                    return inventoryStatus;
                }
            });
         }//else{
        //     $(model).each(function (ind) {
        //         if (!(typeof model['inventory'] === 'undefined')){
        //             if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'true'){
        //                 csCounter++;
        //             } else if (model['inventory']['ranking'] == '0'){
        //                 soCounter++;
        //             } else if (model['inventory']['ranking'] == '1' && model['inventory']['flComingSoon'] == 'false'){
        //                 cbsCounter++;
        //             }
        //         } else return false;

        //         if (csCounter == 1 || cbsCounter == 1 || soCounter == 1) {
        //             inventoryStatus = true;
        //             return inventoryStatus;
        //         }
        //     });
        // }

        var mustacheObj = {
            modelName: modelNameValue != undefined ? modelNameValue : '',
            inventoryStatus: inventoryStatus,
            //indexPlp:productIndex+1,
            indexPlp:tileIndex+1,
            indexSearchPanel: indexSearchPanel+1,
            isSearchPanel: function () {
                if(searchedWord != undefined) {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchFeturedProduct: function () {
                if(searchedWord == "X_Search_FeaturedProducts") {
                    return true;
                } else {
                    return false;
                }
            },
            isSearchPageResult: function(){
                if(searchedWord == undefined && getUrlParameter('searchTerm')){
                    return true;
                }else{
                    return false;
                }
            },
            isWishlistPage: function(){
                if (isWishlist){
                    return true;
                } else {
                    return false;
                }
            },
            catentryIdDefaultSize : function(){
                return catentryIdDefaultSize[indexOtherColors];
            },
            catentryIsPresentInWishlist: function(){
                if(typeof checkIsInWishlist === 'function'){
                    return checkIsInWishlist(catentryIdDefaultSize[indexOtherColors]);
                }
            },
            image: function () {
            	var stringOfThumbnail = null;
                var backgroundColor = "";
                if (isOliver){
                    backgroundColor = "";
                    // OP: using of OV_OpPlp
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1000');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                	}
                } else  {
                    // PO: scaling of 45% on desktop
                    backgroundColor = "&bgcolor=%23f7f7f7";
                	if(isEspot){
                		stringOfThumbnail = showedProduct.thumbnail.replace('wid=800','wid=1500');
                	}else{
                		stringOfThumbnail =  replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','small');
                	}
                }
                return stringOfThumbnail + backgroundColor;
            },
            imageScaled: function () {
                var backgroundColor = "";
                if (isOliver){
                    // OP: scaling of 25% on mobile
                    var backgroundColor = "";
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                } else  {
                    // PO: scaling of 25% on mobile
                    var backgroundColor = "&bgcolor=%23f7f7f7";
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                }
            },
            thumbnail: function () {
                if (isOliver){
                    return replaceTileImgByDevice(showedProduct.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                } else {
                    return replaceTileImgByDevice(showedProduct.thumbnail,'sclw=0.25&sclh=0.25','small');
                }
            },
            uniqueID: showedProduct != undefined ? showedProduct.uniqueID : '',
            partNumber: (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[indexOtherColors]).partNumber,
            partNumberAlt: function () {
                if (!isWishlist){
                    return this.partNumber.replaceAll('_','-').replaceAll('/', '-');
                } else {
                    return productMoco.toUpperCase();
                }
            },
            colorProperty: !(getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist) && model.length > 1 ? colorsProp : colorProp,
            offerPrice: offerPrice ? WCCurrencyJS.format(offerPrice) : '',
            listPrice: listPrice ? WCCurrencyJS.format(listPrice) : '',
            percentage: percentage,
            baseURL: WCParamJS.homePageURL,
            group2BadgeValue: group2BadgeValue,
            otherColors: getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? [ model ] : model,
            replaceImageUrl: function () {
            	var replaceImage = null;
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        backgroundColor = "";
                        // OP: using of OV_OpPlp
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('OV_OpPlp','OV_parameters&WID').replace('WID','wid=1000');
                            }else{
                            	replaceImage = this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID').replace('WID','wid=1000');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                            }else{
                            	replaceImage = replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters_transp&WID'),'WID','small');
                            }
                    	}
                    } else {
                        var backgroundColor = "&bgcolor=%23f7f7f7";
                    	if(isEspot){
                    		if (isClipon) {
                            	replaceImage = this.thumbnail.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }else{
                            	replaceImage = this.thumbnail2.replace('sclw=0.25&sclh=0.25','wid=1500');
                            }
                    	}else{
                    		if (isClipon) {
                            	replaceImage = replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                            }else{
    	                        // PO: scaling of 45% on desktop
    	                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
    	                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
    	                        replaceImage = replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                            }
                    	}
                    }
                }else{
                	replaceImage = this.thumbnail;
                }
                return replaceImage ;
            },
            replaceImageUrlScaled: function () {
                var backgroundColor = "";
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        
                        backgroundColor = "";
                        // OP: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') + backgroundColor;
                        }
                        return replaceTileImgByDevice(this.thumbnail2.replace('OV_OpPlp','OV_parameters&WID'),'WID','small') +  backgroundColor;
                    } else {
                        backgroundColor = "&bgcolor=%23f7f7f7";
                        // PO: scaling of 25% on mobile
                        if (isClipon) {
                            return replaceTileImgByDevice(this.thumbnail, 'sclw=0.25&sclh=0.25', 'small') + backgroundColor;
                        }
                        //return replaceTileImgByDevice(this.thumbnail.replace('_fr','_qt').replace('_001','_002'),'sclw=0.25&sclh=0.25','small');
                        //AC: effettuate modifiche per persol anche se non indicate nel file excel
                        return replaceTileImgByDevice(this.thumbnail2,'sclw=0.25&sclh=0.25','small') + backgroundColor;
                    }
                }
                return this.thumbnail;
            },
            replaceImageUrl1Tile: function () {
                if (this.thumbnail != undefined) {
                    if (isOliver){
                        return replaceTileImgByDevice(this.thumbnail.replace('OV_OpPlp','OV_parameters&WID'),'WID','small');
                    } else
                        //return this.thumbnail;
                        return replaceTileImgByDevice(this.thumbnail,'sclw=0.25&sclh=0.25','big');
                }
                return this.thumbnail;
            },
            index: function() {
                indexOtherColors++;
            },
            // Show color names under image
            printColorsName: function(){
                $(this.attributes).each(function (){
                    if ((this.identifier) === "FRONT_COLOR"){
                        eachFrontColor = ((this).values[0].identifier);
                    }
                    if ((this.identifier) === "LENS_COLOR"){
                        eachLensColor = ((this).values[0].identifier);
                    }
                })
                if ($("#categoryName").val() === 'OV_Sun') {
                    return (eachFrontColor + '/' + eachLensColor);
                } else {
                    return (eachFrontColor);
                }
            },
            printListPrice: function() {
                var product = this;
                var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
                return listPrice != '' ? WCCurrencyJS.format(listPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            printOfferPrice: function() {
                var product = this;
                offerPrice = getPriceByCustomerSegment(product["price"]);
                return offerPrice != '' ? WCCurrencyJS.format(offerPrice) : MESSAGE_NO_PRICE_AVAILABLE;
            },
            showListPrice: function() {
            	var product = this;
            	var listPrice =  product['price']['listprice'] ? product['price']['listprice'] : "";
            	var offerPrice = getPriceByCustomerSegment(product["price"]);
            	if(offerPrice != '' && listPrice != ''){
	            	if(offerPrice < listPrice) {
	            		return 'showListPrice';
	            	}
            	}
            	return '';
            },
            printStatus: function() {
                return printStatus(this);
            },
            printWishlistSize: function() {
                return wishlistAddedSize;
            },
            printWishlistSizeNumber: function() {
                return wishlistAddedSizeNumber;
            },
            isWishlistSizeEmpty: function() {
                if (wishlistAddedSize == "" || typeof wishlistAddedSize == "undefined"){
                    return true;
                } else {
                    return false;
                }
            },
            printPolarBadge: function() {
                return getPolarized(this.attributes);
            },
            printTransitionBadge : function () {
                return getTransitionBadge(this.attributes);
            },
            printTopBadge: function() {
                /**
                 * Group 1 Badges Hierarchy
                 * PO Transition > Polar
                 * OP Polar
                 */
                var isPolar = getPolarized(this.attributes);
                var isTransition =  getTransitionBadge(this.attributes);
             
                if(isTransition && isPersol){
                    return isTransition;
                }
                else if(isPolar){
                    if(isOliver){
                        return "— "+isPolar+" —";
                    }else{
                        return isPolar;
                    }
                }
            },
            printBottomBadge : function(){
               return  printBadges(this.attributes);
            },
            isPreOrder : function() {
                return getPreOrderBadge(this.attributes) != undefined ;
            },
            isPrescription: function(){
                return isPrescription(this.attributes);
            },
            printSeparator: function(){
                if((printBadges(this.attributes) != "" || getPreOrderBadge(this.attributes) != undefined) && isPrescription(this.attributes,searchedWord) == true){
                    return true;
                }else{
                    return false;
                }
            },
            isFastLoadImg: function() {
                return this.indexPlp < 4
            },
            isLCPTile: isLCPTile
          }

        if(searchedWord) {
            indexSearchPanel++;
        }

        if (insideGrid && !searchedWord) {
            if(typeof tealiumProducts === 'undefined'){
                var tealiumProducts = {};
            }

            //	Tealium
            var tealiumProduct = {};
            var myPartNumber = (getUrlParameter('searchTerm') || isPriceOrdering() || !categoryToGroupTile() || searchedWord || isWishlist ? model : model[0]).partNumber;
            if (isPersol){
                tealiumProduct['Sku'] = myPartNumber.replaceAll('RX_','');
            } else {
                tealiumProduct['Sku'] = myPartNumber;
            }
            tealiumProduct['ModelName'] = (modelNameValue != undefined ? modelNameValue : '').toUpperCase();
            tealiumProduct['Category'] = !isWishlist ? getSunOpticalCategoryName($("#categoryName").val()) : '';
            tealiumProduct['Price'] = offerPrice;
            tealiumProduct['PriceFull'] = listPrice;
            tealiumProduct['Brand'] = currentBrand;
            tealiumProducts[myPartNumber] = tealiumProduct;
            if(typeof pushWkndSkuInPLP == 'function' && window.wunderkind && window.wunderkind.category !== undefined)
                pushWkndSkuInPLP(tealiumProduct['Sku']);
        }

        var templateHtml = $('#plpTemplate2024').html();
        html = Mustache.to_html(templateHtml, mustacheObj);
        

    } catch (error) {
        console.error('Error in tile creation',error);
    }

    return html;
}



/**
* Opens the search bar when the search icon is clicked.
* Change the tabindex value to every focusable element into the search.
*/
function openSearchBar(element){
    //hideHeaderTimeout.cancel();
    var searchPanel = $('.header__search-wrapper');
    changeTabIndex($('.header__search-wrapper'));
    searchPanel.hasClass("opend") ? searchPanel.removeClass('opend') : searchPanel.addClass('opend');
    searchPanel.removeClass("hidden-panel");
    $('.search--fade').show();
    history.pushState({}, '') // added state in chronology To close the panel when the back button is clicked
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","hidden");
    }
    
    $("body").css("overflow","hidden");
    $("#page").css("overflow","hidden");
    if(!(window.mobilecheck() || window.tabletPortraitCheck())){
        loadHeaderEspot("X_Search_FeaturedProducts"); // load Feature Products
    }

    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").addClass("searchPanelIsOpen");

    if(isOliver){
        tealium_data2track.push({
            'id':'Click', 
            'data_element_id': 'MainNav_Search_Open',
            'Click_FocusElement' : element
        });
    }
 
    
};

function closeSearchBar() {
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        if($(".searchPanel .search_panel_container").hasClass("active")){
            $(".searchPanel .search_panel_container").removeClass("active");
            $(".searchPanel .search_panel_container").focusout();
            window.history.go(-1);
            if(isPersol){
            	$('.header_wishlist').show(); 
                $("#logo").hide();
            }
        }

    }else{
        $('.header__search-wrapper').removeClass('opend');
        $('.search--fade').hide();
        window.history.go(-1);// delete the state added at opening
        if($plpSearchObj.itemsbkp != undefined){
            //search Optimization --retrieve info on the plp that was being navigated
            $plpSearchObj.items =  $plpSearchObj.itemsbkp;
            $plpSearchObj.busy = false;
            $plpSearchObj.lastIndex = $plpSearchObj.lastIndexbkp;
            $plpSearchObj.viewIndex = $plpSearchObj.viewIndexbkp ;
        }
    }
    
   
    if(!((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol)){
        $("html").css("overflow","auto");
    }
    $("body").css("overflow","auto");
    $("#page").css("overflow","auto");

    resetSearchTile(true,true,false);
    $("#contentRecommendationWidget_X_Header_GlobalBanner_X_Header_GlobalBanner").removeClass("searchPanelIsOpen");

    if(isOliver){
        setTimeout(function() {
            $('.header__search-wrapper').addClass("hidden-panel"); //HB-12925 Overlay fade effect when close panel
        }, 600);
    }
};


window.onpopstate = function() { //interface is fired when the active history entry changes while the user navigates the session history.
    if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
        var searchPanel = $(".searchPanel .search_panel_container");
        if(searchPanel.hasClass("active")){
            closeSearchBar();
        }
    }else{
        var searchPanel = $('.header__search-wrapper');
        if(searchPanel.hasClass("opend")){
            closeSearchBar();
        }
    }     
  };






function getUrlParameter(paramName) {
    var results = new RegExp('[\?&]' + paramName + '=([^&#]*)').exec(window.location.href);
    if (results == null){
       return null;
    } else {
       return decodeURI(results[1]) || 0;
    }
}

/**
 * @function callbackSortBy
 * @desc callback function for default sort by
 */
function callbackSortBy(elem){
    if(elem) {
        checkFacetsAndSearch($(elem));
    }
    $('.facet__apply-number').text($plpSearchObj.resultCount);

}

function isNewArrivalsOrdering() {
	return selectedFacetsData["orderBy"] === '8';
}

function isPriceOrdering() {
	return selectedFacetsData["orderBy"] === '3' || selectedFacetsData["orderBy"] === '4';
}

function categoryToGroupTile() {
	if ($('input#notGroupTile').val() == 1)
		return false;

	return true;
}





function resetSearchTile(reloadFeaturedProducts,resetInputButton,resetSuggestion){
    if(reloadFeaturedProducts){
        if( !(window.tabletPortraitCheck() || window.mobilecheck()) && $(".searchPanel .featured-products").length == 0 ){
            $("#search_grid").html(featuredProductHtml);
        } 
        $(".title_result").show();
        $(".redirect_result_container").css("display","none");
    }else{
        $("#search_grid .search-grid-skeleton").show();
        $('#search_grid li').each(function() {
            $(".redirect_result_container .redirect_result_link").css("display","none");
            if(!$(this).hasClass("search-grid-skeleton")){
                 $(this).empty(); // elimina il contenuto 
                 $(this).append('<div class="grid-item">' +
                                    '<div class="product">' +
                                        '<div class="product--wrapper">' +
                                            '<div class="product--wrapper__container">' +
                                                '<div class="plp__other-product-carousel new-plp">' +
                                                    '<div class="square-container skeleton-element">' +
                                                        '<div class="square-content">' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="product__wrapper-info skeleton-element">' +
                                                        '<a class="lower-tile-container ">' +
                                                        '</a>' +
                                                    '</div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>');
                 $(this).addClass("search-grid-skeleton");
                 $(this).removeClass("featured-products");
                
                 
            }
         });
    }
    if(resetInputButton){
        $('input:text[name=searchInput]').val("");
        $(".searchPanel .delete-input-icon").hide();
    }
    if(resetSuggestion){
        $("#search_UsefulLinks").show();
        $("#search_popular").show();
        $(".searchPanel .suggestions_container").empty();
        $(".searchPanel .suggestions_container").hide();
        searchError(false);
    }

    removeLoader();
    
}

function updateSearchTermHistoryCookieAndRedirect(updatedSearchTerm, redirectURL){
	
	this.updateSearchTermHistoryCookie(updatedSearchTerm);
    if (navigator.userAgent.toLowerCase().indexOf('firefox') == -1) {document.location.href = appendWcCommonRequestParameters(redirectURL);}
    
}

function fn_startSearch() {
    var searchTimeout;
    indexSearchPanel = 0;
    var dInput = $('input:text[name=searchInput]').val().toLowerCase();
    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
        if(dInput.length >= 2){
        	$plpSearchObj.search = true;
            resetSearchTile();
            const promise2 = Promise.resolve(printAutoSuggestions(dInput));
            const promise3 = new Promise((resolve, reject) => {
                setTimeout(resolve, 500, 'Success');
            });
            const promise1 = Promise.resolve(fn_plpFirstTiles(undefined,dInput,undefined,undefined,true));
            Promise.all([promise1,promise2, promise3]).then((values) => {
                if(values[1].suggestionView[0].entry.length > 0 && ($(".error_search_message").is(":visible") || $('.title_result').is(":visible") || $('#search_grid .square-container.skeleton-element').is(":visible")) ){
                    searchError(false);
                    resetSearchTile(false,false,false);
                    fn_plpFirstTiles(undefined,values[1].suggestionView[0].entry[0].name);
                }else if( (!$(".error_search_message").is(":visible") || !$('.title_result').is(":visible")) ){
                    searchError(false);
                }else{
                    searchError(true);
                    resetSearchTile(true,false,false); 
                }
            });
        }
    }else{
        if(dInput.length >= 2){
            printAutoSuggestions(dInput);
        } 
    }
    if(dInput.length > 0){
        if(dInput.length < 2){
            resetSearchTile(true,false,true);
        }
       // $(".searchPanel .delete-input-icon").show();
    }else if(dInput == 0){
        resetSearchTile(true,true,true);
    }
}

function tealiumPushSearchPageReady(dInput,resultItemsQnt) {
    console.log("TEALIUM::tealiumPushSearchPageReady function invoked");
    if(typeof tealium_data2track !== 'undefined' && !mobilecheck()) {
        var trackData = {};
        trackData['id'] = 'SearchPageReady';
        trackData['Search_Keyword'] = dInput.toLowerCase();
        trackData['Search_KeywordActual'] = '';
        trackData['Search_Type'] = 'text';
        trackData['Search_ResultItemsQnt'] = resultItemsQnt; 
        trackData['Search_FacetValues_String'] = "";
        trackData['Search_View'] = "SERB"
        tealium_data2track.push(trackData);
    }
}


function goToSearchPage(input){
    var searchType = ""
    if(input != undefined){
        var dInput = input  
        searchType = "suggested"
       
    }else {
        var dInput = $('input:text[name=searchInput]').val();
        searchType = "text"
        
    }
    var typeResult = checkTileEditorialProduct(numItems,numEditorials);
    if(dInput.length > 0){
        updateSearchTermHistoryCookie(dInput);
        var baseSearchPage = (isInToolkit ? '' : WCParamJS.homePageURL +"/")+'SearchDisplay?storeId='+WCParamJS.storeId+'&catalogId='+ WCParamJS.catalogId + '&langId='+ WCParamJS.langId + '&design=' + typeResult + '&searchTerm=' + dInput +'&Search_Type='+ searchType;   
        location.href = baseSearchPage;
    }
   
}

/**
function printAutoSuggestions(dInput){
    dInput = dInput.replaceAll("’","'");
    $(".searchPanel .suggestions_container").empty();//clean suggestion div 
    var searchHistory = getSearchTermsCookie();
    var limit = 10 - searchHistory.length; //total suggestions + history search = 10

    if(searchHistory.length > 0){ //check for research already done
        searchHistory.forEach(function (term) { 
            historySearchDiv = '<div><a class="search-history" onclick=" goToSearchPage(\''+ term.replace("-","").replace(" ","") +'\')" data-element-id="SearchPanel_Results_query">' + term.replace("%27","'")+ '</a></div>';
            $(".searchPanel .suggestions_container").append(historySearchDiv);//print the latest research
        }) 
    }
    queryAutoSuggestions = {
        storeId: WCParamJS.storeId,
        catalogId: WCParamJS.catalogId,
        responseFormat: 'json',
        langId: WCParamJS.langId,
        categoryId: WCParamJS.categoryId,
        limit: limit
    };
    return new Promise((resolve, reject) => {
        $.ajax({
            url: (isInToolkit ? '' : WCParamJS.homePageURL) +"/search/resources/store/" + WCParamJS.storeId  + "/sitecontent/productSuggestionsBySearchTerm/"+ dInput ,
            type: 'GET',
            async: true,
            data: queryAutoSuggestions,
            success: function(data){
                var suggestionDiv = "";
                if(data.suggestionView && data.suggestionView[0].entry.length > 0){
                    if(!(window.tabletPortraitCheck() || window.mobilecheck())){
                        $("#search_UsefulLinks").hide();
                        $("#search_popular").hide();
                        
                    }else{
                        tealiumPushSearchPageReady(dInput,limit);
                    }
                    searchError(false);
                    $(".searchPanel .suggestions_container").show();
                    var searchTerms = [];
                    for (var i = 0; i < data.suggestionView[0].entry.length; i++) {
                    	var isPresent = false;
                    	var temporaryTerm = data.suggestionView[0].entry[i].name;
                		for (var j = 0; j < searchTerms.length; j++) {
                		//check if the result name has been already shown
                    		if (temporaryTerm === searchTerms[j]){
                    			isPresent = true;
                    		}
                    	}
                    	if(!isPresent){
                    		var spanTerm = data.suggestionView[0].entry[i].name.replace(dInput.toLowerCase(),"<span class='serched-word'>" + dInput.toLowerCase() +"</span>" );
                            suggestionDiv = '<div><a class="suggestion" onclick="goToSearchPage(\'' + data.suggestionView[0].entry[i].name.replace("'","%27") + '\')">' + spanTerm.toLowerCase() + '</a></div>';
                            $(".searchPanel .suggestions_container").append(suggestionDiv);//print suggestions
                    	}
                    	searchTerms.push(data.suggestionView[0].entry[i].name);
                    }
                }
                else if (data.metaData){
                	dInput = data.metaData.spellcheck[0];
                	printAutoSuggestions(dInput);
                }
                else if(!(searchHistory.length > 0 && data.suggestionView && data.suggestionView[0].entry.length > 0)){
                    if((window.tabletPortraitCheck() || window.mobilecheck())){
                        searchError(true);
                        tealiumPushSearchPageReady(dInput,'0');
                    }
                    $(".suggestions_container").hide();
                    $("#search_UsefulLinks").show();
                    $("#search_popular").show();
                    
                }
                resolve(data);
            },
            error: function(error) {
                console.error(error);  
                reject(error);
            }
        });
    });

    

}
*/ 

var inputTimer = null;

function loadHeaderEspot(espotName) {

    // If espot div is not present, skip the loading
    if ($("#" + espotName).length == 0) return;
  
    // Get product, if present
    let products = {};
    let contents = [];
  
    // Compose service url
    var espotServiceUrl =
      WCParamJS.urlPrefixForHTTPS +
      "/wcs/resources/store/" +
      WCParamJS.storeId +
      "/espot/" +
      espotName +
      "?langId=" +
      WCParamJS.langId;
  
    return new Promise((resolve, reject) => {
  
      $.getJSON(espotServiceUrl, function (data) {
        products = {};
        contents = [];
        //con la risposta del servizio mi creo due array di oggetti di prodotti e contenuti
        data["MarketingSpotData"].forEach(function (msd, index) {
          if (msd["baseMarketingSpotActivityData"]) {
            var savedActivityPriority;
            msd["baseMarketingSpotActivityData"].every(function (bmspd, index) {
              if (
                typeof savedActivityPriority != "undefined" &&
                savedActivityPriority != bmspd["activityPriority"]
              ) {
                return false;
              }
              savedActivityPriority = bmspd["activityPriority"];
              if (bmspd["baseMarketingSpotDataType"] === "CatalogEntry") {
                // controllo che sia un prodotto
                var productsobj = {
                  product: bmspd["baseMarketingSpotActivityName"],
                  productId: bmspd["productId"]
                };
                //prendo le info sul modello
                var isProductPresent =
                  productsobj["product"].length > 0 &&
                  productsobj["productId"].length > 0;
                  if (isProductPresent) {
                    products[productsobj["productId"]] = productsobj;
                }
              } else if (
                bmspd["baseMarketingSpotDataType"] === "MarketingContent"
              ) {
                // controllo che sia un contenuto
                bmspd["marketingContentDescription"].forEach(function (mkd, index) {
                  if(typeof mkd["marketingText"] != 'undefined'){
                    contents.push(
                        mkd["marketingText"].replaceAll(
                          "[fullPathHomeURL]",
                          WCParamJS.homePageURL
                        )
                      ); //metto nell array di contenuto tutti i contenuti
                  }  
                });
              }
              return true;
            });
          }
        });
  
      }).done(function(data) {
  
        if (Object.keys(products).length > 0) {
  
          getProductsModelHeader(products,function() {
            if(espotName=="X_Search_FeaturedProducts"){
              renderTileProducts(products,0,0,0,espotName);
            }else{
                if( typeof espotCallback == 'function'){
                    espotCallback(products, contents, espotName);
                }
            }
            
          })
          .then((data) => {
            console.log(data);
          })
          .catch((error) => {
            console.error(error)
          });
  
        } else {
            if( typeof espotCallback == 'function'){
                espotCallback(products, contents, espotName)
            }
        }
  
        resolve(data);
    }).fail(function(error) {
      reject(error);
    });
  
    });
  
  }

  function getProductsModelHeader(products,callback) {

    var productIds = [];
    $.each(products,function(k,v) {
      productIds.push(k);
    });
  
    // Compose service url
    var productServiceUrl =
      (isInToolkit ? "" : WCParamJS.homePageURL) +
      "/search/resources/store/" +
      WCParamJS.storeId +
      "/productview/byIds?id=" +
      productIds.join("&id=") +
      "&storeId=" +
      WCParamJS.storeId +
      "&catalogId=" +
      WCParamJS.catalogId +
      "&responseFormat=json&langId=" +
      WCParamJS.langId +
      "&currency=" +
      WCParamJS.commandContextCurrency +
      "&profileName=LUX_findProductByIds_Details" +
      "&isForDDM=true"
      ;
  
    return new Promise((resolve, reject) => {
      $.getJSON(productServiceUrl, function (data) {
        var productModel = data["catalogEntryView"];
  
        // To align objects with those expected by Mustache
        productModel.forEach(function (m, index) {
          m["modelCode"] = m.partNumber.split('__')[0];
          products[m["uniqueID"]]["productModel"] = m;
        });
  
        if (typeof callback === 'function') {
          callback();
        }
  
      }).done(function(data) {
        resolve(data);
      }).fail(function(error) {
        reject(error);
      });
    });
    
  }
  /** 
  function updateSearchTermHistoryCookie(updatedSearchTerm){
    // Set the expiration date to one month from the current date
    var expirationDate = new Date();
    expirationDate.setMonth(expirationDate.getMonth() + 1);
    var cookieKey = "searchTermHistory";
    var cookieValue = "|" + updatedSearchTerm;
    var searchTermHistoryCookie = getCookie(cookieKey);
    if( searchTermHistoryCookie != undefined && searchTermHistoryCookie != 'undefined') {
        var termsArray = searchTermHistoryCookie.split("|");
        if(!termsArray.includes(cookieValue.replace("|",""))){
            cookieValue = getCookie(cookieKey) + cookieValue;
        }
        
    }
    setCookie(cookieKey, cookieValue,{path:'/', domain:cookieDomain, expires: expirationDate});
}


function getSearchTermsCookie(){
    var searchHistoryCookie = getCookie("searchTermHistory");
    var theLastTerms=[];
    if( searchHistoryCookie != undefined && searchHistoryCookie != 'undefined') {
        var termsArray = searchHistoryCookie.split("|");
        var count = 0; 
        for(var i = termsArray.length - 3; i < termsArray.length; i++) {
            if(termsArray[i] != undefined && termsArray[i] != "" && termsArray[i] != 'undefined'){
                theLastTerms[count]= termsArray[i];
                count++;
            }
        }
    }
    return theLastTerms.reverse();
}
**/

function searchError(show){
    if(show){
        var searchedWord = $('input:text[name=searchInput]').val();
        $(".error_search_message #error_word").html(searchedWord);
        $(".error_search_message").show();
        $(".error-search-icon").show();
        $(".input-icon").hide();
    }else{
        $(".error_search_message").hide();
        $(".error-search-icon").hide();
        $(".input-icon").show();
    }
    
}



/**
 * @funtion getStatus 
 * @desc get Product Status (Available, SoldOut, Out-of-stock, etc.) based on inventory informations
 */
function getStatus(inventoryStatus) {
    //var flComingSoon = inventoryStatus.flComingSoon;
    var ranking = inventoryStatus.ranking;
    var status = "";

    switch(ranking) {
        case "0" : {
            status =  "SoldOut";
            break;
        }
        case "1" : {//Coming Soon & Coming Back Soon
            status = "Out-of-stock";  
            break;
        }
        case "2" : {
            status = "Available";
            break;
        } 
        default : {
            status= "/";
        }
    }
    return status;
}

//remove loader as soon as image is displayed
function removeLoader(){
    var articleImages = document.querySelectorAll(".image-container.main > picture >  img");
    var imageSkeleton = '';
    articleImages.forEach(function(img) {
        img.addEventListener('load', function() {
            imageSkeleton = $(img).closest(".image-container");
            $(imageSkeleton).removeClass("skeleton-element");
        });       
    });
}

function clearSearchPanelEditorial(){
	while ($('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length != 0){
		$('#search_hits .ais-Hits .ais-Hits-item.is-editorial')[$('#search_hits .ais-Hits .ais-Hits-item.is-editorial').length-1].remove()
	}
}


